var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import require$$0, { useEffect, useState, useCallback, useMemo, useRef } from "react";
import { Typography, styled, Avatar as Avatar$1, Alert, AlertTitle, Button as Button$1, FormControlLabel, FormHelperText, FormControl, Checkbox as Checkbox$1, TextField, InputLabel, InputAdornment, Modal as Modal$1, Switch, Tabs as Tabs$1, Tab, TextareaAutosize, Tooltip as Tooltip$1, tooltipClasses, createTheme, ThemeProvider, StyledEngineProvider } from "@mui/material";
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
var jsxRuntime = { exports: {} };
var reactJsxRuntime_production_min = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_production_min;
function requireReactJsxRuntime_production_min() {
  if (hasRequiredReactJsxRuntime_production_min)
    return reactJsxRuntime_production_min;
  hasRequiredReactJsxRuntime_production_min = 1;
  var f = require$$0, k = Symbol.for("react.element"), l = Symbol.for("react.fragment"), m = Object.prototype.hasOwnProperty, n = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, p = { key: true, ref: true, __self: true, __source: true };
  function q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for (b in a)
      m.call(a, b) && !p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps)
      for (b in a = c.defaultProps, a)
        void 0 === d[b] && (d[b] = a[b]);
    return { $$typeof: k, type: c, key: e, ref: h, props: d, _owner: n.current };
  }
  reactJsxRuntime_production_min.Fragment = l;
  reactJsxRuntime_production_min.jsx = q;
  reactJsxRuntime_production_min.jsxs = q;
  return reactJsxRuntime_production_min;
}
var reactJsxRuntime_development = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_development;
function requireReactJsxRuntime_development() {
  if (hasRequiredReactJsxRuntime_development)
    return reactJsxRuntime_development;
  hasRequiredReactJsxRuntime_development = 1;
  if (process.env.NODE_ENV !== "production") {
    (function() {
      var React = require$$0;
      var REACT_ELEMENT_TYPE = Symbol.for("react.element");
      var REACT_PORTAL_TYPE = Symbol.for("react.portal");
      var REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
      var REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
      var REACT_PROFILER_TYPE = Symbol.for("react.profiler");
      var REACT_PROVIDER_TYPE = Symbol.for("react.provider");
      var REACT_CONTEXT_TYPE = Symbol.for("react.context");
      var REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
      var REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
      var REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
      var REACT_MEMO_TYPE = Symbol.for("react.memo");
      var REACT_LAZY_TYPE = Symbol.for("react.lazy");
      var REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
      var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
      var FAUX_ITERATOR_SYMBOL = "@@iterator";
      function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== "object") {
          return null;
        }
        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
        if (typeof maybeIterator === "function") {
          return maybeIterator;
        }
        return null;
      }
      var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      function error(format) {
        {
          {
            for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              args[_key2 - 1] = arguments[_key2];
            }
            printWarning("error", format, args);
          }
        }
      }
      function printWarning(level, format, args) {
        {
          var ReactDebugCurrentFrame2 = ReactSharedInternals.ReactDebugCurrentFrame;
          var stack = ReactDebugCurrentFrame2.getStackAddendum();
          if (stack !== "") {
            format += "%s";
            args = args.concat([stack]);
          }
          var argsWithFormat = args.map(function(item) {
            return String(item);
          });
          argsWithFormat.unshift("Warning: " + format);
          Function.prototype.apply.call(console[level], console, argsWithFormat);
        }
      }
      var enableScopeAPI = false;
      var enableCacheElement = false;
      var enableTransitionTracing = false;
      var enableLegacyHidden = false;
      var enableDebugTracing = false;
      var REACT_MODULE_REFERENCE;
      {
        REACT_MODULE_REFERENCE = Symbol.for("react.module.reference");
      }
      function isValidElementType(type) {
        if (typeof type === "string" || typeof type === "function") {
          return true;
        }
        if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden || type === REACT_OFFSCREEN_TYPE || enableScopeAPI || enableCacheElement || enableTransitionTracing) {
          return true;
        }
        if (typeof type === "object" && type !== null) {
          if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
          // types supported by any Flight configuration anywhere since
          // we don't know which Flight build this will end up being used
          // with.
          type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== void 0) {
            return true;
          }
        }
        return false;
      }
      function getWrappedName(outerType, innerType, wrapperName) {
        var displayName = outerType.displayName;
        if (displayName) {
          return displayName;
        }
        var functionName = innerType.displayName || innerType.name || "";
        return functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName;
      }
      function getContextName(type) {
        return type.displayName || "Context";
      }
      function getComponentNameFromType(type) {
        if (type == null) {
          return null;
        }
        {
          if (typeof type.tag === "number") {
            error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue.");
          }
        }
        if (typeof type === "function") {
          return type.displayName || type.name || null;
        }
        if (typeof type === "string") {
          return type;
        }
        switch (type) {
          case REACT_FRAGMENT_TYPE:
            return "Fragment";
          case REACT_PORTAL_TYPE:
            return "Portal";
          case REACT_PROFILER_TYPE:
            return "Profiler";
          case REACT_STRICT_MODE_TYPE:
            return "StrictMode";
          case REACT_SUSPENSE_TYPE:
            return "Suspense";
          case REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        }
        if (typeof type === "object") {
          switch (type.$$typeof) {
            case REACT_CONTEXT_TYPE:
              var context = type;
              return getContextName(context) + ".Consumer";
            case REACT_PROVIDER_TYPE:
              var provider = type;
              return getContextName(provider._context) + ".Provider";
            case REACT_FORWARD_REF_TYPE:
              return getWrappedName(type, type.render, "ForwardRef");
            case REACT_MEMO_TYPE:
              var outerName = type.displayName || null;
              if (outerName !== null) {
                return outerName;
              }
              return getComponentNameFromType(type.type) || "Memo";
            case REACT_LAZY_TYPE: {
              var lazyComponent = type;
              var payload = lazyComponent._payload;
              var init = lazyComponent._init;
              try {
                return getComponentNameFromType(init(payload));
              } catch (x) {
                return null;
              }
            }
          }
        }
        return null;
      }
      var assign = Object.assign;
      var disabledDepth = 0;
      var prevLog;
      var prevInfo;
      var prevWarn;
      var prevError;
      var prevGroup;
      var prevGroupCollapsed;
      var prevGroupEnd;
      function disabledLog() {
      }
      disabledLog.__reactDisabledLog = true;
      function disableLogs() {
        {
          if (disabledDepth === 0) {
            prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd;
            var props = {
              configurable: true,
              enumerable: true,
              value: disabledLog,
              writable: true
            };
            Object.defineProperties(console, {
              info: props,
              log: props,
              warn: props,
              error: props,
              group: props,
              groupCollapsed: props,
              groupEnd: props
            });
          }
          disabledDepth++;
        }
      }
      function reenableLogs() {
        {
          disabledDepth--;
          if (disabledDepth === 0) {
            var props = {
              configurable: true,
              enumerable: true,
              writable: true
            };
            Object.defineProperties(console, {
              log: assign({}, props, {
                value: prevLog
              }),
              info: assign({}, props, {
                value: prevInfo
              }),
              warn: assign({}, props, {
                value: prevWarn
              }),
              error: assign({}, props, {
                value: prevError
              }),
              group: assign({}, props, {
                value: prevGroup
              }),
              groupCollapsed: assign({}, props, {
                value: prevGroupCollapsed
              }),
              groupEnd: assign({}, props, {
                value: prevGroupEnd
              })
            });
          }
          if (disabledDepth < 0) {
            error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
          }
        }
      }
      var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
      var prefix;
      function describeBuiltInComponentFrame(name, source, ownerFn) {
        {
          if (prefix === void 0) {
            try {
              throw Error();
            } catch (x) {
              var match = x.stack.trim().match(/\n( *(at )?)/);
              prefix = match && match[1] || "";
            }
          }
          return "\n" + prefix + name;
        }
      }
      var reentry = false;
      var componentFrameCache;
      {
        var PossiblyWeakMap = typeof WeakMap === "function" ? WeakMap : Map;
        componentFrameCache = new PossiblyWeakMap();
      }
      function describeNativeComponentFrame(fn, construct) {
        if (!fn || reentry) {
          return "";
        }
        {
          var frame = componentFrameCache.get(fn);
          if (frame !== void 0) {
            return frame;
          }
        }
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var previousDispatcher;
        {
          previousDispatcher = ReactCurrentDispatcher.current;
          ReactCurrentDispatcher.current = null;
          disableLogs();
        }
        try {
          if (construct) {
            var Fake = function() {
              throw Error();
            };
            Object.defineProperty(Fake.prototype, "props", {
              set: function() {
                throw Error();
              }
            });
            if (typeof Reflect === "object" && Reflect.construct) {
              try {
                Reflect.construct(Fake, []);
              } catch (x) {
                control = x;
              }
              Reflect.construct(fn, [], Fake);
            } else {
              try {
                Fake.call();
              } catch (x) {
                control = x;
              }
              fn.call(Fake.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (x) {
              control = x;
            }
            fn();
          }
        } catch (sample) {
          if (sample && control && typeof sample.stack === "string") {
            var sampleLines = sample.stack.split("\n");
            var controlLines = control.stack.split("\n");
            var s = sampleLines.length - 1;
            var c = controlLines.length - 1;
            while (s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c]) {
              c--;
            }
            for (; s >= 1 && c >= 0; s--, c--) {
              if (sampleLines[s] !== controlLines[c]) {
                if (s !== 1 || c !== 1) {
                  do {
                    s--;
                    c--;
                    if (c < 0 || sampleLines[s] !== controlLines[c]) {
                      var _frame = "\n" + sampleLines[s].replace(" at new ", " at ");
                      if (fn.displayName && _frame.includes("<anonymous>")) {
                        _frame = _frame.replace("<anonymous>", fn.displayName);
                      }
                      {
                        if (typeof fn === "function") {
                          componentFrameCache.set(fn, _frame);
                        }
                      }
                      return _frame;
                    }
                  } while (s >= 1 && c >= 0);
                }
                break;
              }
            }
          }
        } finally {
          reentry = false;
          {
            ReactCurrentDispatcher.current = previousDispatcher;
            reenableLogs();
          }
          Error.prepareStackTrace = previousPrepareStackTrace;
        }
        var name = fn ? fn.displayName || fn.name : "";
        var syntheticFrame = name ? describeBuiltInComponentFrame(name) : "";
        {
          if (typeof fn === "function") {
            componentFrameCache.set(fn, syntheticFrame);
          }
        }
        return syntheticFrame;
      }
      function describeFunctionComponentFrame(fn, source, ownerFn) {
        {
          return describeNativeComponentFrame(fn, false);
        }
      }
      function shouldConstruct(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
      }
      function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) {
          return "";
        }
        if (typeof type === "function") {
          {
            return describeNativeComponentFrame(type, shouldConstruct(type));
          }
        }
        if (typeof type === "string") {
          return describeBuiltInComponentFrame(type);
        }
        switch (type) {
          case REACT_SUSPENSE_TYPE:
            return describeBuiltInComponentFrame("Suspense");
          case REACT_SUSPENSE_LIST_TYPE:
            return describeBuiltInComponentFrame("SuspenseList");
        }
        if (typeof type === "object") {
          switch (type.$$typeof) {
            case REACT_FORWARD_REF_TYPE:
              return describeFunctionComponentFrame(type.render);
            case REACT_MEMO_TYPE:
              return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
            case REACT_LAZY_TYPE: {
              var lazyComponent = type;
              var payload = lazyComponent._payload;
              var init = lazyComponent._init;
              try {
                return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
              } catch (x) {
              }
            }
          }
        }
        return "";
      }
      var hasOwnProperty = Object.prototype.hasOwnProperty;
      var loggedTypeFailures = {};
      var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
      function setCurrentlyValidatingElement(element) {
        {
          if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame.setExtraStackFrame(stack);
          } else {
            ReactDebugCurrentFrame.setExtraStackFrame(null);
          }
        }
      }
      function checkPropTypes(typeSpecs, values, location, componentName, element) {
        {
          var has = Function.call.bind(hasOwnProperty);
          for (var typeSpecName in typeSpecs) {
            if (has(typeSpecs, typeSpecName)) {
              var error$1 = void 0;
              try {
                if (typeof typeSpecs[typeSpecName] !== "function") {
                  var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  err.name = "Invariant Violation";
                  throw err;
                }
                error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (ex) {
                error$1 = ex;
              }
              if (error$1 && !(error$1 instanceof Error)) {
                setCurrentlyValidatingElement(element);
                error("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || "React class", location, typeSpecName, typeof error$1);
                setCurrentlyValidatingElement(null);
              }
              if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                loggedTypeFailures[error$1.message] = true;
                setCurrentlyValidatingElement(element);
                error("Failed %s type: %s", location, error$1.message);
                setCurrentlyValidatingElement(null);
              }
            }
          }
        }
      }
      var isArrayImpl = Array.isArray;
      function isArray(a) {
        return isArrayImpl(a);
      }
      function typeName(value) {
        {
          var hasToStringTag = typeof Symbol === "function" && Symbol.toStringTag;
          var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
          return type;
        }
      }
      function willCoercionThrow(value) {
        {
          try {
            testStringCoercion(value);
            return false;
          } catch (e) {
            return true;
          }
        }
      }
      function testStringCoercion(value) {
        return "" + value;
      }
      function checkKeyStringCoercion(value) {
        {
          if (willCoercionThrow(value)) {
            error("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value);
          }
        }
      }
      var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
      var RESERVED_PROPS = {
        key: true,
        ref: true,
        __self: true,
        __source: true
      };
      var specialPropKeyWarningShown;
      var specialPropRefWarningShown;
      var didWarnAboutStringRefs;
      {
        didWarnAboutStringRefs = {};
      }
      function hasValidRef(config) {
        {
          if (hasOwnProperty.call(config, "ref")) {
            var getter = Object.getOwnPropertyDescriptor(config, "ref").get;
            if (getter && getter.isReactWarning) {
              return false;
            }
          }
        }
        return config.ref !== void 0;
      }
      function hasValidKey(config) {
        {
          if (hasOwnProperty.call(config, "key")) {
            var getter = Object.getOwnPropertyDescriptor(config, "key").get;
            if (getter && getter.isReactWarning) {
              return false;
            }
          }
        }
        return config.key !== void 0;
      }
      function warnIfStringRefCannotBeAutoConverted(config, self2) {
        {
          if (typeof config.ref === "string" && ReactCurrentOwner.current && self2 && ReactCurrentOwner.current.stateNode !== self2) {
            var componentName = getComponentNameFromType(ReactCurrentOwner.current.type);
            if (!didWarnAboutStringRefs[componentName]) {
              error('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', getComponentNameFromType(ReactCurrentOwner.current.type), config.ref);
              didWarnAboutStringRefs[componentName] = true;
            }
          }
        }
      }
      function defineKeyPropWarningGetter(props, displayName) {
        {
          var warnAboutAccessingKey = function() {
            if (!specialPropKeyWarningShown) {
              specialPropKeyWarningShown = true;
              error("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
          };
          warnAboutAccessingKey.isReactWarning = true;
          Object.defineProperty(props, "key", {
            get: warnAboutAccessingKey,
            configurable: true
          });
        }
      }
      function defineRefPropWarningGetter(props, displayName) {
        {
          var warnAboutAccessingRef = function() {
            if (!specialPropRefWarningShown) {
              specialPropRefWarningShown = true;
              error("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
          };
          warnAboutAccessingRef.isReactWarning = true;
          Object.defineProperty(props, "ref", {
            get: warnAboutAccessingRef,
            configurable: true
          });
        }
      }
      var ReactElement = function(type, key, ref, self2, source, owner, props) {
        var element = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: REACT_ELEMENT_TYPE,
          // Built-in properties that belong on the element
          type,
          key,
          ref,
          props,
          // Record the component responsible for creating this element.
          _owner: owner
        };
        {
          element._store = {};
          Object.defineProperty(element._store, "validated", {
            configurable: false,
            enumerable: false,
            writable: true,
            value: false
          });
          Object.defineProperty(element, "_self", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: self2
          });
          Object.defineProperty(element, "_source", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: source
          });
          if (Object.freeze) {
            Object.freeze(element.props);
            Object.freeze(element);
          }
        }
        return element;
      };
      function jsxDEV(type, config, maybeKey, source, self2) {
        {
          var propName;
          var props = {};
          var key = null;
          var ref = null;
          if (maybeKey !== void 0) {
            {
              checkKeyStringCoercion(maybeKey);
            }
            key = "" + maybeKey;
          }
          if (hasValidKey(config)) {
            {
              checkKeyStringCoercion(config.key);
            }
            key = "" + config.key;
          }
          if (hasValidRef(config)) {
            ref = config.ref;
            warnIfStringRefCannotBeAutoConverted(config, self2);
          }
          for (propName in config) {
            if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
              props[propName] = config[propName];
            }
          }
          if (type && type.defaultProps) {
            var defaultProps = type.defaultProps;
            for (propName in defaultProps) {
              if (props[propName] === void 0) {
                props[propName] = defaultProps[propName];
              }
            }
          }
          if (key || ref) {
            var displayName = typeof type === "function" ? type.displayName || type.name || "Unknown" : type;
            if (key) {
              defineKeyPropWarningGetter(props, displayName);
            }
            if (ref) {
              defineRefPropWarningGetter(props, displayName);
            }
          }
          return ReactElement(type, key, ref, self2, source, ReactCurrentOwner.current, props);
        }
      }
      var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
      var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
      function setCurrentlyValidatingElement$1(element) {
        {
          if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
          } else {
            ReactDebugCurrentFrame$1.setExtraStackFrame(null);
          }
        }
      }
      var propTypesMisspellWarningShown;
      {
        propTypesMisspellWarningShown = false;
      }
      function isValidElement(object) {
        {
          return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
        }
      }
      function getDeclarationErrorAddendum() {
        {
          if (ReactCurrentOwner$1.current) {
            var name = getComponentNameFromType(ReactCurrentOwner$1.current.type);
            if (name) {
              return "\n\nCheck the render method of `" + name + "`.";
            }
          }
          return "";
        }
      }
      function getSourceInfoErrorAddendum(source) {
        {
          if (source !== void 0) {
            var fileName = source.fileName.replace(/^.*[\\\/]/, "");
            var lineNumber = source.lineNumber;
            return "\n\nCheck your code at " + fileName + ":" + lineNumber + ".";
          }
          return "";
        }
      }
      var ownerHasKeyUseWarning = {};
      function getCurrentComponentErrorInfo(parentType) {
        {
          var info = getDeclarationErrorAddendum();
          if (!info) {
            var parentName = typeof parentType === "string" ? parentType : parentType.displayName || parentType.name;
            if (parentName) {
              info = "\n\nCheck the top-level render call using <" + parentName + ">.";
            }
          }
          return info;
        }
      }
      function validateExplicitKey(element, parentType) {
        {
          if (!element._store || element._store.validated || element.key != null) {
            return;
          }
          element._store.validated = true;
          var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);
          if (ownerHasKeyUseWarning[currentComponentErrorInfo]) {
            return;
          }
          ownerHasKeyUseWarning[currentComponentErrorInfo] = true;
          var childOwner = "";
          if (element && element._owner && element._owner !== ReactCurrentOwner$1.current) {
            childOwner = " It was passed a child from " + getComponentNameFromType(element._owner.type) + ".";
          }
          setCurrentlyValidatingElement$1(element);
          error('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);
          setCurrentlyValidatingElement$1(null);
        }
      }
      function validateChildKeys(node, parentType) {
        {
          if (typeof node !== "object") {
            return;
          }
          if (isArray(node)) {
            for (var i = 0; i < node.length; i++) {
              var child = node[i];
              if (isValidElement(child)) {
                validateExplicitKey(child, parentType);
              }
            }
          } else if (isValidElement(node)) {
            if (node._store) {
              node._store.validated = true;
            }
          } else if (node) {
            var iteratorFn = getIteratorFn(node);
            if (typeof iteratorFn === "function") {
              if (iteratorFn !== node.entries) {
                var iterator = iteratorFn.call(node);
                var step;
                while (!(step = iterator.next()).done) {
                  if (isValidElement(step.value)) {
                    validateExplicitKey(step.value, parentType);
                  }
                }
              }
            }
          }
        }
      }
      function validatePropTypes(element) {
        {
          var type = element.type;
          if (type === null || type === void 0 || typeof type === "string") {
            return;
          }
          var propTypes;
          if (typeof type === "function") {
            propTypes = type.propTypes;
          } else if (typeof type === "object" && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          type.$$typeof === REACT_MEMO_TYPE)) {
            propTypes = type.propTypes;
          } else {
            return;
          }
          if (propTypes) {
            var name = getComponentNameFromType(type);
            checkPropTypes(propTypes, element.props, "prop", name, element);
          } else if (type.PropTypes !== void 0 && !propTypesMisspellWarningShown) {
            propTypesMisspellWarningShown = true;
            var _name = getComponentNameFromType(type);
            error("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", _name || "Unknown");
          }
          if (typeof type.getDefaultProps === "function" && !type.getDefaultProps.isReactClassApproved) {
            error("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
          }
        }
      }
      function validateFragmentProps(fragment) {
        {
          var keys = Object.keys(fragment.props);
          for (var i = 0; i < keys.length; i++) {
            var key = keys[i];
            if (key !== "children" && key !== "key") {
              setCurrentlyValidatingElement$1(fragment);
              error("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", key);
              setCurrentlyValidatingElement$1(null);
              break;
            }
          }
          if (fragment.ref !== null) {
            setCurrentlyValidatingElement$1(fragment);
            error("Invalid attribute `ref` supplied to `React.Fragment`.");
            setCurrentlyValidatingElement$1(null);
          }
        }
      }
      function jsxWithValidation(type, props, key, isStaticChildren, source, self2) {
        {
          var validType = isValidElementType(type);
          if (!validType) {
            var info = "";
            if (type === void 0 || typeof type === "object" && type !== null && Object.keys(type).length === 0) {
              info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
            }
            var sourceInfo = getSourceInfoErrorAddendum(source);
            if (sourceInfo) {
              info += sourceInfo;
            } else {
              info += getDeclarationErrorAddendum();
            }
            var typeString;
            if (type === null) {
              typeString = "null";
            } else if (isArray(type)) {
              typeString = "array";
            } else if (type !== void 0 && type.$$typeof === REACT_ELEMENT_TYPE) {
              typeString = "<" + (getComponentNameFromType(type.type) || "Unknown") + " />";
              info = " Did you accidentally export a JSX literal instead of a component?";
            } else {
              typeString = typeof type;
            }
            error("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", typeString, info);
          }
          var element = jsxDEV(type, props, key, source, self2);
          if (element == null) {
            return element;
          }
          if (validType) {
            var children2 = props.children;
            if (children2 !== void 0) {
              if (isStaticChildren) {
                if (isArray(children2)) {
                  for (var i = 0; i < children2.length; i++) {
                    validateChildKeys(children2[i], type);
                  }
                  if (Object.freeze) {
                    Object.freeze(children2);
                  }
                } else {
                  error("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
                }
              } else {
                validateChildKeys(children2, type);
              }
            }
          }
          if (type === REACT_FRAGMENT_TYPE) {
            validateFragmentProps(element);
          } else {
            validatePropTypes(element);
          }
          return element;
        }
      }
      function jsxWithValidationStatic(type, props, key) {
        {
          return jsxWithValidation(type, props, key, true);
        }
      }
      function jsxWithValidationDynamic(type, props, key) {
        {
          return jsxWithValidation(type, props, key, false);
        }
      }
      var jsx2 = jsxWithValidationDynamic;
      var jsxs2 = jsxWithValidationStatic;
      reactJsxRuntime_development.Fragment = REACT_FRAGMENT_TYPE;
      reactJsxRuntime_development.jsx = jsx2;
      reactJsxRuntime_development.jsxs = jsxs2;
    })();
  }
  return reactJsxRuntime_development;
}
if (process.env.NODE_ENV === "production") {
  jsxRuntime.exports = requireReactJsxRuntime_production_min();
} else {
  jsxRuntime.exports = requireReactJsxRuntime_development();
}
var jsxRuntimeExports = jsxRuntime.exports;
const Fragment = jsxRuntimeExports.Fragment;
const jsx = jsxRuntimeExports.jsx;
const jsxs = jsxRuntimeExports.jsxs;
var lodash = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
lodash.exports;
(function(module, exports) {
  (function() {
    var undefined$1;
    var VERSION = "4.17.21";
    var LARGE_ARRAY_SIZE = 200;
    var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
    var HASH_UNDEFINED = "__lodash_hash_undefined__";
    var MAX_MEMOIZE_SIZE = 500;
    var PLACEHOLDER = "__lodash_placeholder__";
    var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
    var HOT_COUNT = 800, HOT_SPAN = 16;
    var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 17976931348623157e292, NAN = 0 / 0;
    var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    var wrapFlags = [
      ["ary", WRAP_ARY_FLAG],
      ["bind", WRAP_BIND_FLAG],
      ["bindKey", WRAP_BIND_KEY_FLAG],
      ["curry", WRAP_CURRY_FLAG],
      ["curryRight", WRAP_CURRY_RIGHT_FLAG],
      ["flip", WRAP_FLIP_FLAG],
      ["partial", WRAP_PARTIAL_FLAG],
      ["partialRight", WRAP_PARTIAL_RIGHT_FLAG],
      ["rearg", WRAP_REARG_FLAG]
    ];
    var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
    var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
    var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    var reTrimStart = /^\s+/;
    var reWhitespace = /\s/;
    var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    var reEscapeChar = /\\(\\)?/g;
    var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    var reFlags = /\w*$/;
    var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    var reIsBinary = /^0b[01]+$/i;
    var reIsHostCtor = /^\[object .+?Constructor\]$/;
    var reIsOctal = /^0o[0-7]+$/i;
    var reIsUint = /^(?:0|[1-9]\d*)$/;
    var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    var reNoMatch = /($^)/;
    var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    var rsAstralRange = "\\ud800-\\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    var rsApos = "['’]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\\ud83c[\\udffb-\\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}", rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
    var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [rsNonAstral, rsRegional, rsSurrPair].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [rsDingbat, rsRegional, rsSurrPair].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [rsNonAstral + rsCombo + "?", rsCombo, rsRegional, rsSurrPair, rsAstral].join("|") + ")";
    var reApos = RegExp(rsApos, "g");
    var reComboMark = RegExp(rsCombo, "g");
    var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
    var reUnicodeWord = RegExp([
      rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [rsBreak, rsUpper, "$"].join("|") + ")",
      rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [rsBreak, rsUpper + rsMiscLower, "$"].join("|") + ")",
      rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
      rsUpper + "+" + rsOptContrUpper,
      rsOrdUpper,
      rsOrdLower,
      rsDigits,
      rsEmoji
    ].join("|"), "g");
    var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
    var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    var contextProps = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ];
    var templateCounter = -1;
    var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    var deburredLetters = {
      // Latin-1 Supplement block.
      "À": "A",
      "Á": "A",
      "Â": "A",
      "Ã": "A",
      "Ä": "A",
      "Å": "A",
      "à": "a",
      "á": "a",
      "â": "a",
      "ã": "a",
      "ä": "a",
      "å": "a",
      "Ç": "C",
      "ç": "c",
      "Ð": "D",
      "ð": "d",
      "È": "E",
      "É": "E",
      "Ê": "E",
      "Ë": "E",
      "è": "e",
      "é": "e",
      "ê": "e",
      "ë": "e",
      "Ì": "I",
      "Í": "I",
      "Î": "I",
      "Ï": "I",
      "ì": "i",
      "í": "i",
      "î": "i",
      "ï": "i",
      "Ñ": "N",
      "ñ": "n",
      "Ò": "O",
      "Ó": "O",
      "Ô": "O",
      "Õ": "O",
      "Ö": "O",
      "Ø": "O",
      "ò": "o",
      "ó": "o",
      "ô": "o",
      "õ": "o",
      "ö": "o",
      "ø": "o",
      "Ù": "U",
      "Ú": "U",
      "Û": "U",
      "Ü": "U",
      "ù": "u",
      "ú": "u",
      "û": "u",
      "ü": "u",
      "Ý": "Y",
      "ý": "y",
      "ÿ": "y",
      "Æ": "Ae",
      "æ": "ae",
      "Þ": "Th",
      "þ": "th",
      "ß": "ss",
      // Latin Extended-A block.
      "Ā": "A",
      "Ă": "A",
      "Ą": "A",
      "ā": "a",
      "ă": "a",
      "ą": "a",
      "Ć": "C",
      "Ĉ": "C",
      "Ċ": "C",
      "Č": "C",
      "ć": "c",
      "ĉ": "c",
      "ċ": "c",
      "č": "c",
      "Ď": "D",
      "Đ": "D",
      "ď": "d",
      "đ": "d",
      "Ē": "E",
      "Ĕ": "E",
      "Ė": "E",
      "Ę": "E",
      "Ě": "E",
      "ē": "e",
      "ĕ": "e",
      "ė": "e",
      "ę": "e",
      "ě": "e",
      "Ĝ": "G",
      "Ğ": "G",
      "Ġ": "G",
      "Ģ": "G",
      "ĝ": "g",
      "ğ": "g",
      "ġ": "g",
      "ģ": "g",
      "Ĥ": "H",
      "Ħ": "H",
      "ĥ": "h",
      "ħ": "h",
      "Ĩ": "I",
      "Ī": "I",
      "Ĭ": "I",
      "Į": "I",
      "İ": "I",
      "ĩ": "i",
      "ī": "i",
      "ĭ": "i",
      "į": "i",
      "ı": "i",
      "Ĵ": "J",
      "ĵ": "j",
      "Ķ": "K",
      "ķ": "k",
      "ĸ": "k",
      "Ĺ": "L",
      "Ļ": "L",
      "Ľ": "L",
      "Ŀ": "L",
      "Ł": "L",
      "ĺ": "l",
      "ļ": "l",
      "ľ": "l",
      "ŀ": "l",
      "ł": "l",
      "Ń": "N",
      "Ņ": "N",
      "Ň": "N",
      "Ŋ": "N",
      "ń": "n",
      "ņ": "n",
      "ň": "n",
      "ŋ": "n",
      "Ō": "O",
      "Ŏ": "O",
      "Ő": "O",
      "ō": "o",
      "ŏ": "o",
      "ő": "o",
      "Ŕ": "R",
      "Ŗ": "R",
      "Ř": "R",
      "ŕ": "r",
      "ŗ": "r",
      "ř": "r",
      "Ś": "S",
      "Ŝ": "S",
      "Ş": "S",
      "Š": "S",
      "ś": "s",
      "ŝ": "s",
      "ş": "s",
      "š": "s",
      "Ţ": "T",
      "Ť": "T",
      "Ŧ": "T",
      "ţ": "t",
      "ť": "t",
      "ŧ": "t",
      "Ũ": "U",
      "Ū": "U",
      "Ŭ": "U",
      "Ů": "U",
      "Ű": "U",
      "Ų": "U",
      "ũ": "u",
      "ū": "u",
      "ŭ": "u",
      "ů": "u",
      "ű": "u",
      "ų": "u",
      "Ŵ": "W",
      "ŵ": "w",
      "Ŷ": "Y",
      "ŷ": "y",
      "Ÿ": "Y",
      "Ź": "Z",
      "Ż": "Z",
      "Ž": "Z",
      "ź": "z",
      "ż": "z",
      "ž": "z",
      "Ĳ": "IJ",
      "ĳ": "ij",
      "Œ": "Oe",
      "œ": "oe",
      "ŉ": "'n",
      "ſ": "s"
    };
    var htmlEscapes = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    };
    var htmlUnescapes = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    };
    var stringEscapes = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    };
    var freeParseFloat = parseFloat, freeParseInt = parseInt;
    var freeGlobal = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
    var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    var root = freeGlobal || freeSelf || Function("return this")();
    var freeExports = exports && !exports.nodeType && exports;
    var freeModule = freeExports && true && module && !module.nodeType && module;
    var moduleExports = freeModule && freeModule.exports === freeExports;
    var freeProcess = moduleExports && freeGlobal.process;
    var nodeUtil = function() {
      try {
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) {
          return types;
        }
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
      } catch (e) {
      }
    }();
    var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    function apply(func, thisArg, args) {
      switch (args.length) {
        case 0:
          return func.call(thisArg);
        case 1:
          return func.call(thisArg, args[0]);
        case 2:
          return func.call(thisArg, args[0], args[1]);
        case 3:
          return func.call(thisArg, args[0], args[1], args[2]);
      }
      return func.apply(thisArg, args);
    }
    function arrayAggregator(array, setter, iteratee, accumulator) {
      var index2 = -1, length = array == null ? 0 : array.length;
      while (++index2 < length) {
        var value = array[index2];
        setter(accumulator, value, iteratee(value), array);
      }
      return accumulator;
    }
    function arrayEach(array, iteratee) {
      var index2 = -1, length = array == null ? 0 : array.length;
      while (++index2 < length) {
        if (iteratee(array[index2], index2, array) === false) {
          break;
        }
      }
      return array;
    }
    function arrayEachRight(array, iteratee) {
      var length = array == null ? 0 : array.length;
      while (length--) {
        if (iteratee(array[length], length, array) === false) {
          break;
        }
      }
      return array;
    }
    function arrayEvery(array, predicate) {
      var index2 = -1, length = array == null ? 0 : array.length;
      while (++index2 < length) {
        if (!predicate(array[index2], index2, array)) {
          return false;
        }
      }
      return true;
    }
    function arrayFilter(array, predicate) {
      var index2 = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
      while (++index2 < length) {
        var value = array[index2];
        if (predicate(value, index2, array)) {
          result[resIndex++] = value;
        }
      }
      return result;
    }
    function arrayIncludes(array, value) {
      var length = array == null ? 0 : array.length;
      return !!length && baseIndexOf(array, value, 0) > -1;
    }
    function arrayIncludesWith(array, value, comparator) {
      var index2 = -1, length = array == null ? 0 : array.length;
      while (++index2 < length) {
        if (comparator(value, array[index2])) {
          return true;
        }
      }
      return false;
    }
    function arrayMap(array, iteratee) {
      var index2 = -1, length = array == null ? 0 : array.length, result = Array(length);
      while (++index2 < length) {
        result[index2] = iteratee(array[index2], index2, array);
      }
      return result;
    }
    function arrayPush(array, values) {
      var index2 = -1, length = values.length, offset = array.length;
      while (++index2 < length) {
        array[offset + index2] = values[index2];
      }
      return array;
    }
    function arrayReduce(array, iteratee, accumulator, initAccum) {
      var index2 = -1, length = array == null ? 0 : array.length;
      if (initAccum && length) {
        accumulator = array[++index2];
      }
      while (++index2 < length) {
        accumulator = iteratee(accumulator, array[index2], index2, array);
      }
      return accumulator;
    }
    function arrayReduceRight(array, iteratee, accumulator, initAccum) {
      var length = array == null ? 0 : array.length;
      if (initAccum && length) {
        accumulator = array[--length];
      }
      while (length--) {
        accumulator = iteratee(accumulator, array[length], length, array);
      }
      return accumulator;
    }
    function arraySome(array, predicate) {
      var index2 = -1, length = array == null ? 0 : array.length;
      while (++index2 < length) {
        if (predicate(array[index2], index2, array)) {
          return true;
        }
      }
      return false;
    }
    var asciiSize = baseProperty("length");
    function asciiToArray(string) {
      return string.split("");
    }
    function asciiWords(string) {
      return string.match(reAsciiWord) || [];
    }
    function baseFindKey(collection, predicate, eachFunc) {
      var result;
      eachFunc(collection, function(value, key, collection2) {
        if (predicate(value, key, collection2)) {
          result = key;
          return false;
        }
      });
      return result;
    }
    function baseFindIndex(array, predicate, fromIndex, fromRight) {
      var length = array.length, index2 = fromIndex + (fromRight ? 1 : -1);
      while (fromRight ? index2-- : ++index2 < length) {
        if (predicate(array[index2], index2, array)) {
          return index2;
        }
      }
      return -1;
    }
    function baseIndexOf(array, value, fromIndex) {
      return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    function baseIndexOfWith(array, value, fromIndex, comparator) {
      var index2 = fromIndex - 1, length = array.length;
      while (++index2 < length) {
        if (comparator(array[index2], value)) {
          return index2;
        }
      }
      return -1;
    }
    function baseIsNaN(value) {
      return value !== value;
    }
    function baseMean(array, iteratee) {
      var length = array == null ? 0 : array.length;
      return length ? baseSum(array, iteratee) / length : NAN;
    }
    function baseProperty(key) {
      return function(object) {
        return object == null ? undefined$1 : object[key];
      };
    }
    function basePropertyOf(object) {
      return function(key) {
        return object == null ? undefined$1 : object[key];
      };
    }
    function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
      eachFunc(collection, function(value, index2, collection2) {
        accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index2, collection2);
      });
      return accumulator;
    }
    function baseSortBy(array, comparer) {
      var length = array.length;
      array.sort(comparer);
      while (length--) {
        array[length] = array[length].value;
      }
      return array;
    }
    function baseSum(array, iteratee) {
      var result, index2 = -1, length = array.length;
      while (++index2 < length) {
        var current = iteratee(array[index2]);
        if (current !== undefined$1) {
          result = result === undefined$1 ? current : result + current;
        }
      }
      return result;
    }
    function baseTimes(n, iteratee) {
      var index2 = -1, result = Array(n);
      while (++index2 < n) {
        result[index2] = iteratee(index2);
      }
      return result;
    }
    function baseToPairs(object, props) {
      return arrayMap(props, function(key) {
        return [key, object[key]];
      });
    }
    function baseTrim(string) {
      return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
    }
    function baseUnary(func) {
      return function(value) {
        return func(value);
      };
    }
    function baseValues(object, props) {
      return arrayMap(props, function(key) {
        return object[key];
      });
    }
    function cacheHas(cache, key) {
      return cache.has(key);
    }
    function charsStartIndex(strSymbols, chrSymbols) {
      var index2 = -1, length = strSymbols.length;
      while (++index2 < length && baseIndexOf(chrSymbols, strSymbols[index2], 0) > -1) {
      }
      return index2;
    }
    function charsEndIndex(strSymbols, chrSymbols) {
      var index2 = strSymbols.length;
      while (index2-- && baseIndexOf(chrSymbols, strSymbols[index2], 0) > -1) {
      }
      return index2;
    }
    function countHolders(array, placeholder) {
      var length = array.length, result = 0;
      while (length--) {
        if (array[length] === placeholder) {
          ++result;
        }
      }
      return result;
    }
    var deburrLetter = basePropertyOf(deburredLetters);
    var escapeHtmlChar = basePropertyOf(htmlEscapes);
    function escapeStringChar(chr) {
      return "\\" + stringEscapes[chr];
    }
    function getValue(object, key) {
      return object == null ? undefined$1 : object[key];
    }
    function hasUnicode(string) {
      return reHasUnicode.test(string);
    }
    function hasUnicodeWord(string) {
      return reHasUnicodeWord.test(string);
    }
    function iteratorToArray(iterator) {
      var data, result = [];
      while (!(data = iterator.next()).done) {
        result.push(data.value);
      }
      return result;
    }
    function mapToArray(map) {
      var index2 = -1, result = Array(map.size);
      map.forEach(function(value, key) {
        result[++index2] = [key, value];
      });
      return result;
    }
    function overArg(func, transform) {
      return function(arg) {
        return func(transform(arg));
      };
    }
    function replaceHolders(array, placeholder) {
      var index2 = -1, length = array.length, resIndex = 0, result = [];
      while (++index2 < length) {
        var value = array[index2];
        if (value === placeholder || value === PLACEHOLDER) {
          array[index2] = PLACEHOLDER;
          result[resIndex++] = index2;
        }
      }
      return result;
    }
    function setToArray(set) {
      var index2 = -1, result = Array(set.size);
      set.forEach(function(value) {
        result[++index2] = value;
      });
      return result;
    }
    function setToPairs(set) {
      var index2 = -1, result = Array(set.size);
      set.forEach(function(value) {
        result[++index2] = [value, value];
      });
      return result;
    }
    function strictIndexOf(array, value, fromIndex) {
      var index2 = fromIndex - 1, length = array.length;
      while (++index2 < length) {
        if (array[index2] === value) {
          return index2;
        }
      }
      return -1;
    }
    function strictLastIndexOf(array, value, fromIndex) {
      var index2 = fromIndex + 1;
      while (index2--) {
        if (array[index2] === value) {
          return index2;
        }
      }
      return index2;
    }
    function stringSize(string) {
      return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    function stringToArray(string) {
      return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    function trimmedEndIndex(string) {
      var index2 = string.length;
      while (index2-- && reWhitespace.test(string.charAt(index2))) {
      }
      return index2;
    }
    var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    function unicodeSize(string) {
      var result = reUnicode.lastIndex = 0;
      while (reUnicode.test(string)) {
        ++result;
      }
      return result;
    }
    function unicodeToArray(string) {
      return string.match(reUnicode) || [];
    }
    function unicodeWords(string) {
      return string.match(reUnicodeWord) || [];
    }
    var runInContext = function runInContext2(context) {
      context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
      var Array2 = context.Array, Date = context.Date, Error2 = context.Error, Function2 = context.Function, Math2 = context.Math, Object2 = context.Object, RegExp2 = context.RegExp, String2 = context.String, TypeError2 = context.TypeError;
      var arrayProto = Array2.prototype, funcProto = Function2.prototype, objectProto = Object2.prototype;
      var coreJsData = context["__core-js_shared__"];
      var funcToString = funcProto.toString;
      var hasOwnProperty = objectProto.hasOwnProperty;
      var idCounter = 0;
      var maskSrcKey = function() {
        var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
        return uid ? "Symbol(src)_1." + uid : "";
      }();
      var nativeObjectToString = objectProto.toString;
      var objectCtorString = funcToString.call(Object2);
      var oldDash = root._;
      var reIsNative = RegExp2(
        "^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      );
      var Buffer2 = moduleExports ? context.Buffer : undefined$1, Symbol2 = context.Symbol, Uint8Array2 = context.Uint8Array, allocUnsafe = Buffer2 ? Buffer2.allocUnsafe : undefined$1, getPrototype = overArg(Object2.getPrototypeOf, Object2), objectCreate = Object2.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol2 ? Symbol2.isConcatSpreadable : undefined$1, symIterator = Symbol2 ? Symbol2.iterator : undefined$1, symToStringTag = Symbol2 ? Symbol2.toStringTag : undefined$1;
      var defineProperty = function() {
        try {
          var func = getNative(Object2, "defineProperty");
          func({}, "", {});
          return func;
        } catch (e) {
        }
      }();
      var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
      var nativeCeil = Math2.ceil, nativeFloor = Math2.floor, nativeGetSymbols = Object2.getOwnPropertySymbols, nativeIsBuffer = Buffer2 ? Buffer2.isBuffer : undefined$1, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object2.keys, Object2), nativeMax = Math2.max, nativeMin = Math2.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math2.random, nativeReverse = arrayProto.reverse;
      var DataView = getNative(context, "DataView"), Map2 = getNative(context, "Map"), Promise2 = getNative(context, "Promise"), Set2 = getNative(context, "Set"), WeakMap2 = getNative(context, "WeakMap"), nativeCreate = getNative(Object2, "create");
      var metaMap = WeakMap2 && new WeakMap2();
      var realNames = {};
      var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map2), promiseCtorString = toSource(Promise2), setCtorString = toSource(Set2), weakMapCtorString = toSource(WeakMap2);
      var symbolProto = Symbol2 ? Symbol2.prototype : undefined$1, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined$1, symbolToString = symbolProto ? symbolProto.toString : undefined$1;
      function lodash2(value) {
        if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
          if (value instanceof LodashWrapper) {
            return value;
          }
          if (hasOwnProperty.call(value, "__wrapped__")) {
            return wrapperClone(value);
          }
        }
        return new LodashWrapper(value);
      }
      var baseCreate = function() {
        function object() {
        }
        return function(proto) {
          if (!isObject(proto)) {
            return {};
          }
          if (objectCreate) {
            return objectCreate(proto);
          }
          object.prototype = proto;
          var result2 = new object();
          object.prototype = undefined$1;
          return result2;
        };
      }();
      function baseLodash() {
      }
      function LodashWrapper(value, chainAll) {
        this.__wrapped__ = value;
        this.__actions__ = [];
        this.__chain__ = !!chainAll;
        this.__index__ = 0;
        this.__values__ = undefined$1;
      }
      lodash2.templateSettings = {
        /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        "escape": reEscape,
        /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        "evaluate": reEvaluate,
        /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        "interpolate": reInterpolate,
        /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */
        "variable": "",
        /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */
        "imports": {
          /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */
          "_": lodash2
        }
      };
      lodash2.prototype = baseLodash.prototype;
      lodash2.prototype.constructor = lodash2;
      LodashWrapper.prototype = baseCreate(baseLodash.prototype);
      LodashWrapper.prototype.constructor = LodashWrapper;
      function LazyWrapper(value) {
        this.__wrapped__ = value;
        this.__actions__ = [];
        this.__dir__ = 1;
        this.__filtered__ = false;
        this.__iteratees__ = [];
        this.__takeCount__ = MAX_ARRAY_LENGTH;
        this.__views__ = [];
      }
      function lazyClone() {
        var result2 = new LazyWrapper(this.__wrapped__);
        result2.__actions__ = copyArray(this.__actions__);
        result2.__dir__ = this.__dir__;
        result2.__filtered__ = this.__filtered__;
        result2.__iteratees__ = copyArray(this.__iteratees__);
        result2.__takeCount__ = this.__takeCount__;
        result2.__views__ = copyArray(this.__views__);
        return result2;
      }
      function lazyReverse() {
        if (this.__filtered__) {
          var result2 = new LazyWrapper(this);
          result2.__dir__ = -1;
          result2.__filtered__ = true;
        } else {
          result2 = this.clone();
          result2.__dir__ *= -1;
        }
        return result2;
      }
      function lazyValue() {
        var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index2 = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
        if (!isArr || !isRight && arrLength == length && takeCount == length) {
          return baseWrapperValue(array, this.__actions__);
        }
        var result2 = [];
        outer:
          while (length-- && resIndex < takeCount) {
            index2 += dir;
            var iterIndex = -1, value = array[index2];
            while (++iterIndex < iterLength) {
              var data = iteratees[iterIndex], iteratee2 = data.iteratee, type = data.type, computed = iteratee2(value);
              if (type == LAZY_MAP_FLAG) {
                value = computed;
              } else if (!computed) {
                if (type == LAZY_FILTER_FLAG) {
                  continue outer;
                } else {
                  break outer;
                }
              }
            }
            result2[resIndex++] = value;
          }
        return result2;
      }
      LazyWrapper.prototype = baseCreate(baseLodash.prototype);
      LazyWrapper.prototype.constructor = LazyWrapper;
      function Hash(entries) {
        var index2 = -1, length = entries == null ? 0 : entries.length;
        this.clear();
        while (++index2 < length) {
          var entry = entries[index2];
          this.set(entry[0], entry[1]);
        }
      }
      function hashClear() {
        this.__data__ = nativeCreate ? nativeCreate(null) : {};
        this.size = 0;
      }
      function hashDelete(key) {
        var result2 = this.has(key) && delete this.__data__[key];
        this.size -= result2 ? 1 : 0;
        return result2;
      }
      function hashGet(key) {
        var data = this.__data__;
        if (nativeCreate) {
          var result2 = data[key];
          return result2 === HASH_UNDEFINED ? undefined$1 : result2;
        }
        return hasOwnProperty.call(data, key) ? data[key] : undefined$1;
      }
      function hashHas(key) {
        var data = this.__data__;
        return nativeCreate ? data[key] !== undefined$1 : hasOwnProperty.call(data, key);
      }
      function hashSet(key, value) {
        var data = this.__data__;
        this.size += this.has(key) ? 0 : 1;
        data[key] = nativeCreate && value === undefined$1 ? HASH_UNDEFINED : value;
        return this;
      }
      Hash.prototype.clear = hashClear;
      Hash.prototype["delete"] = hashDelete;
      Hash.prototype.get = hashGet;
      Hash.prototype.has = hashHas;
      Hash.prototype.set = hashSet;
      function ListCache(entries) {
        var index2 = -1, length = entries == null ? 0 : entries.length;
        this.clear();
        while (++index2 < length) {
          var entry = entries[index2];
          this.set(entry[0], entry[1]);
        }
      }
      function listCacheClear() {
        this.__data__ = [];
        this.size = 0;
      }
      function listCacheDelete(key) {
        var data = this.__data__, index2 = assocIndexOf(data, key);
        if (index2 < 0) {
          return false;
        }
        var lastIndex = data.length - 1;
        if (index2 == lastIndex) {
          data.pop();
        } else {
          splice.call(data, index2, 1);
        }
        --this.size;
        return true;
      }
      function listCacheGet(key) {
        var data = this.__data__, index2 = assocIndexOf(data, key);
        return index2 < 0 ? undefined$1 : data[index2][1];
      }
      function listCacheHas(key) {
        return assocIndexOf(this.__data__, key) > -1;
      }
      function listCacheSet(key, value) {
        var data = this.__data__, index2 = assocIndexOf(data, key);
        if (index2 < 0) {
          ++this.size;
          data.push([key, value]);
        } else {
          data[index2][1] = value;
        }
        return this;
      }
      ListCache.prototype.clear = listCacheClear;
      ListCache.prototype["delete"] = listCacheDelete;
      ListCache.prototype.get = listCacheGet;
      ListCache.prototype.has = listCacheHas;
      ListCache.prototype.set = listCacheSet;
      function MapCache(entries) {
        var index2 = -1, length = entries == null ? 0 : entries.length;
        this.clear();
        while (++index2 < length) {
          var entry = entries[index2];
          this.set(entry[0], entry[1]);
        }
      }
      function mapCacheClear() {
        this.size = 0;
        this.__data__ = {
          "hash": new Hash(),
          "map": new (Map2 || ListCache)(),
          "string": new Hash()
        };
      }
      function mapCacheDelete(key) {
        var result2 = getMapData(this, key)["delete"](key);
        this.size -= result2 ? 1 : 0;
        return result2;
      }
      function mapCacheGet(key) {
        return getMapData(this, key).get(key);
      }
      function mapCacheHas(key) {
        return getMapData(this, key).has(key);
      }
      function mapCacheSet(key, value) {
        var data = getMapData(this, key), size3 = data.size;
        data.set(key, value);
        this.size += data.size == size3 ? 0 : 1;
        return this;
      }
      MapCache.prototype.clear = mapCacheClear;
      MapCache.prototype["delete"] = mapCacheDelete;
      MapCache.prototype.get = mapCacheGet;
      MapCache.prototype.has = mapCacheHas;
      MapCache.prototype.set = mapCacheSet;
      function SetCache(values2) {
        var index2 = -1, length = values2 == null ? 0 : values2.length;
        this.__data__ = new MapCache();
        while (++index2 < length) {
          this.add(values2[index2]);
        }
      }
      function setCacheAdd(value) {
        this.__data__.set(value, HASH_UNDEFINED);
        return this;
      }
      function setCacheHas(value) {
        return this.__data__.has(value);
      }
      SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
      SetCache.prototype.has = setCacheHas;
      function Stack(entries) {
        var data = this.__data__ = new ListCache(entries);
        this.size = data.size;
      }
      function stackClear() {
        this.__data__ = new ListCache();
        this.size = 0;
      }
      function stackDelete(key) {
        var data = this.__data__, result2 = data["delete"](key);
        this.size = data.size;
        return result2;
      }
      function stackGet(key) {
        return this.__data__.get(key);
      }
      function stackHas(key) {
        return this.__data__.has(key);
      }
      function stackSet(key, value) {
        var data = this.__data__;
        if (data instanceof ListCache) {
          var pairs = data.__data__;
          if (!Map2 || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([key, value]);
            this.size = ++data.size;
            return this;
          }
          data = this.__data__ = new MapCache(pairs);
        }
        data.set(key, value);
        this.size = data.size;
        return this;
      }
      Stack.prototype.clear = stackClear;
      Stack.prototype["delete"] = stackDelete;
      Stack.prototype.get = stackGet;
      Stack.prototype.has = stackHas;
      Stack.prototype.set = stackSet;
      function arrayLikeKeys(value, inherited) {
        var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result2 = skipIndexes ? baseTimes(value.length, String2) : [], length = result2.length;
        for (var key in value) {
          if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
          (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
          isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
          isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
          isIndex(key, length)))) {
            result2.push(key);
          }
        }
        return result2;
      }
      function arraySample(array) {
        var length = array.length;
        return length ? array[baseRandom(0, length - 1)] : undefined$1;
      }
      function arraySampleSize(array, n) {
        return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
      }
      function arrayShuffle(array) {
        return shuffleSelf(copyArray(array));
      }
      function assignMergeValue(object, key, value) {
        if (value !== undefined$1 && !eq(object[key], value) || value === undefined$1 && !(key in object)) {
          baseAssignValue(object, key, value);
        }
      }
      function assignValue(object, key, value) {
        var objValue = object[key];
        if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined$1 && !(key in object)) {
          baseAssignValue(object, key, value);
        }
      }
      function assocIndexOf(array, key) {
        var length = array.length;
        while (length--) {
          if (eq(array[length][0], key)) {
            return length;
          }
        }
        return -1;
      }
      function baseAggregator(collection, setter, iteratee2, accumulator) {
        baseEach(collection, function(value, key, collection2) {
          setter(accumulator, value, iteratee2(value), collection2);
        });
        return accumulator;
      }
      function baseAssign(object, source) {
        return object && copyObject(source, keys(source), object);
      }
      function baseAssignIn(object, source) {
        return object && copyObject(source, keysIn(source), object);
      }
      function baseAssignValue(object, key, value) {
        if (key == "__proto__" && defineProperty) {
          defineProperty(object, key, {
            "configurable": true,
            "enumerable": true,
            "value": value,
            "writable": true
          });
        } else {
          object[key] = value;
        }
      }
      function baseAt(object, paths) {
        var index2 = -1, length = paths.length, result2 = Array2(length), skip = object == null;
        while (++index2 < length) {
          result2[index2] = skip ? undefined$1 : get(object, paths[index2]);
        }
        return result2;
      }
      function baseClamp(number, lower, upper) {
        if (number === number) {
          if (upper !== undefined$1) {
            number = number <= upper ? number : upper;
          }
          if (lower !== undefined$1) {
            number = number >= lower ? number : lower;
          }
        }
        return number;
      }
      function baseClone(value, bitmask, customizer, key, object, stack) {
        var result2, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
        if (customizer) {
          result2 = object ? customizer(value, key, object, stack) : customizer(value);
        }
        if (result2 !== undefined$1) {
          return result2;
        }
        if (!isObject(value)) {
          return value;
        }
        var isArr = isArray(value);
        if (isArr) {
          result2 = initCloneArray(value);
          if (!isDeep) {
            return copyArray(value, result2);
          }
        } else {
          var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
          if (isBuffer(value)) {
            return cloneBuffer(value, isDeep);
          }
          if (tag == objectTag || tag == argsTag || isFunc && !object) {
            result2 = isFlat || isFunc ? {} : initCloneObject(value);
            if (!isDeep) {
              return isFlat ? copySymbolsIn(value, baseAssignIn(result2, value)) : copySymbols(value, baseAssign(result2, value));
            }
          } else {
            if (!cloneableTags[tag]) {
              return object ? value : {};
            }
            result2 = initCloneByTag(value, tag, isDeep);
          }
        }
        stack || (stack = new Stack());
        var stacked = stack.get(value);
        if (stacked) {
          return stacked;
        }
        stack.set(value, result2);
        if (isSet(value)) {
          value.forEach(function(subValue) {
            result2.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
          });
        } else if (isMap(value)) {
          value.forEach(function(subValue, key2) {
            result2.set(key2, baseClone(subValue, bitmask, customizer, key2, value, stack));
          });
        }
        var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
        var props = isArr ? undefined$1 : keysFunc(value);
        arrayEach(props || value, function(subValue, key2) {
          if (props) {
            key2 = subValue;
            subValue = value[key2];
          }
          assignValue(result2, key2, baseClone(subValue, bitmask, customizer, key2, value, stack));
        });
        return result2;
      }
      function baseConforms(source) {
        var props = keys(source);
        return function(object) {
          return baseConformsTo(object, source, props);
        };
      }
      function baseConformsTo(object, source, props) {
        var length = props.length;
        if (object == null) {
          return !length;
        }
        object = Object2(object);
        while (length--) {
          var key = props[length], predicate = source[key], value = object[key];
          if (value === undefined$1 && !(key in object) || !predicate(value)) {
            return false;
          }
        }
        return true;
      }
      function baseDelay(func, wait, args) {
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        return setTimeout2(function() {
          func.apply(undefined$1, args);
        }, wait);
      }
      function baseDifference(array, values2, iteratee2, comparator) {
        var index2 = -1, includes2 = arrayIncludes, isCommon = true, length = array.length, result2 = [], valuesLength = values2.length;
        if (!length) {
          return result2;
        }
        if (iteratee2) {
          values2 = arrayMap(values2, baseUnary(iteratee2));
        }
        if (comparator) {
          includes2 = arrayIncludesWith;
          isCommon = false;
        } else if (values2.length >= LARGE_ARRAY_SIZE) {
          includes2 = cacheHas;
          isCommon = false;
          values2 = new SetCache(values2);
        }
        outer:
          while (++index2 < length) {
            var value = array[index2], computed = iteratee2 == null ? value : iteratee2(value);
            value = comparator || value !== 0 ? value : 0;
            if (isCommon && computed === computed) {
              var valuesIndex = valuesLength;
              while (valuesIndex--) {
                if (values2[valuesIndex] === computed) {
                  continue outer;
                }
              }
              result2.push(value);
            } else if (!includes2(values2, computed, comparator)) {
              result2.push(value);
            }
          }
        return result2;
      }
      var baseEach = createBaseEach(baseForOwn);
      var baseEachRight = createBaseEach(baseForOwnRight, true);
      function baseEvery(collection, predicate) {
        var result2 = true;
        baseEach(collection, function(value, index2, collection2) {
          result2 = !!predicate(value, index2, collection2);
          return result2;
        });
        return result2;
      }
      function baseExtremum(array, iteratee2, comparator) {
        var index2 = -1, length = array.length;
        while (++index2 < length) {
          var value = array[index2], current = iteratee2(value);
          if (current != null && (computed === undefined$1 ? current === current && !isSymbol(current) : comparator(current, computed))) {
            var computed = current, result2 = value;
          }
        }
        return result2;
      }
      function baseFill(array, value, start, end) {
        var length = array.length;
        start = toInteger(start);
        if (start < 0) {
          start = -start > length ? 0 : length + start;
        }
        end = end === undefined$1 || end > length ? length : toInteger(end);
        if (end < 0) {
          end += length;
        }
        end = start > end ? 0 : toLength(end);
        while (start < end) {
          array[start++] = value;
        }
        return array;
      }
      function baseFilter(collection, predicate) {
        var result2 = [];
        baseEach(collection, function(value, index2, collection2) {
          if (predicate(value, index2, collection2)) {
            result2.push(value);
          }
        });
        return result2;
      }
      function baseFlatten(array, depth, predicate, isStrict, result2) {
        var index2 = -1, length = array.length;
        predicate || (predicate = isFlattenable);
        result2 || (result2 = []);
        while (++index2 < length) {
          var value = array[index2];
          if (depth > 0 && predicate(value)) {
            if (depth > 1) {
              baseFlatten(value, depth - 1, predicate, isStrict, result2);
            } else {
              arrayPush(result2, value);
            }
          } else if (!isStrict) {
            result2[result2.length] = value;
          }
        }
        return result2;
      }
      var baseFor = createBaseFor();
      var baseForRight = createBaseFor(true);
      function baseForOwn(object, iteratee2) {
        return object && baseFor(object, iteratee2, keys);
      }
      function baseForOwnRight(object, iteratee2) {
        return object && baseForRight(object, iteratee2, keys);
      }
      function baseFunctions(object, props) {
        return arrayFilter(props, function(key) {
          return isFunction(object[key]);
        });
      }
      function baseGet(object, path) {
        path = castPath(path, object);
        var index2 = 0, length = path.length;
        while (object != null && index2 < length) {
          object = object[toKey(path[index2++])];
        }
        return index2 && index2 == length ? object : undefined$1;
      }
      function baseGetAllKeys(object, keysFunc, symbolsFunc) {
        var result2 = keysFunc(object);
        return isArray(object) ? result2 : arrayPush(result2, symbolsFunc(object));
      }
      function baseGetTag(value) {
        if (value == null) {
          return value === undefined$1 ? undefinedTag : nullTag;
        }
        return symToStringTag && symToStringTag in Object2(value) ? getRawTag(value) : objectToString(value);
      }
      function baseGt(value, other) {
        return value > other;
      }
      function baseHas(object, key) {
        return object != null && hasOwnProperty.call(object, key);
      }
      function baseHasIn(object, key) {
        return object != null && key in Object2(object);
      }
      function baseInRange(number, start, end) {
        return number >= nativeMin(start, end) && number < nativeMax(start, end);
      }
      function baseIntersection(arrays, iteratee2, comparator) {
        var includes2 = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array2(othLength), maxLength = Infinity, result2 = [];
        while (othIndex--) {
          var array = arrays[othIndex];
          if (othIndex && iteratee2) {
            array = arrayMap(array, baseUnary(iteratee2));
          }
          maxLength = nativeMin(array.length, maxLength);
          caches[othIndex] = !comparator && (iteratee2 || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined$1;
        }
        array = arrays[0];
        var index2 = -1, seen = caches[0];
        outer:
          while (++index2 < length && result2.length < maxLength) {
            var value = array[index2], computed = iteratee2 ? iteratee2(value) : value;
            value = comparator || value !== 0 ? value : 0;
            if (!(seen ? cacheHas(seen, computed) : includes2(result2, computed, comparator))) {
              othIndex = othLength;
              while (--othIndex) {
                var cache = caches[othIndex];
                if (!(cache ? cacheHas(cache, computed) : includes2(arrays[othIndex], computed, comparator))) {
                  continue outer;
                }
              }
              if (seen) {
                seen.push(computed);
              }
              result2.push(value);
            }
          }
        return result2;
      }
      function baseInverter(object, setter, iteratee2, accumulator) {
        baseForOwn(object, function(value, key, object2) {
          setter(accumulator, iteratee2(value), key, object2);
        });
        return accumulator;
      }
      function baseInvoke(object, path, args) {
        path = castPath(path, object);
        object = parent(object, path);
        var func = object == null ? object : object[toKey(last(path))];
        return func == null ? undefined$1 : apply(func, object, args);
      }
      function baseIsArguments(value) {
        return isObjectLike(value) && baseGetTag(value) == argsTag;
      }
      function baseIsArrayBuffer(value) {
        return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
      }
      function baseIsDate(value) {
        return isObjectLike(value) && baseGetTag(value) == dateTag;
      }
      function baseIsEqual(value, other, bitmask, customizer, stack) {
        if (value === other) {
          return true;
        }
        if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
          return value !== value && other !== other;
        }
        return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
      }
      function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
        var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
        objTag = objTag == argsTag ? objectTag : objTag;
        othTag = othTag == argsTag ? objectTag : othTag;
        var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
        if (isSameTag && isBuffer(object)) {
          if (!isBuffer(other)) {
            return false;
          }
          objIsArr = true;
          objIsObj = false;
        }
        if (isSameTag && !objIsObj) {
          stack || (stack = new Stack());
          return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
        }
        if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
          var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
          if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack());
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
          }
        }
        if (!isSameTag) {
          return false;
        }
        stack || (stack = new Stack());
        return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
      }
      function baseIsMap(value) {
        return isObjectLike(value) && getTag(value) == mapTag;
      }
      function baseIsMatch(object, source, matchData, customizer) {
        var index2 = matchData.length, length = index2, noCustomizer = !customizer;
        if (object == null) {
          return !length;
        }
        object = Object2(object);
        while (index2--) {
          var data = matchData[index2];
          if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
            return false;
          }
        }
        while (++index2 < length) {
          data = matchData[index2];
          var key = data[0], objValue = object[key], srcValue = data[1];
          if (noCustomizer && data[2]) {
            if (objValue === undefined$1 && !(key in object)) {
              return false;
            }
          } else {
            var stack = new Stack();
            if (customizer) {
              var result2 = customizer(objValue, srcValue, key, object, source, stack);
            }
            if (!(result2 === undefined$1 ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result2)) {
              return false;
            }
          }
        }
        return true;
      }
      function baseIsNative(value) {
        if (!isObject(value) || isMasked(value)) {
          return false;
        }
        var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
        return pattern.test(toSource(value));
      }
      function baseIsRegExp(value) {
        return isObjectLike(value) && baseGetTag(value) == regexpTag;
      }
      function baseIsSet(value) {
        return isObjectLike(value) && getTag(value) == setTag;
      }
      function baseIsTypedArray(value) {
        return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
      }
      function baseIteratee(value) {
        if (typeof value == "function") {
          return value;
        }
        if (value == null) {
          return identity;
        }
        if (typeof value == "object") {
          return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
        }
        return property(value);
      }
      function baseKeys(object) {
        if (!isPrototype(object)) {
          return nativeKeys(object);
        }
        var result2 = [];
        for (var key in Object2(object)) {
          if (hasOwnProperty.call(object, key) && key != "constructor") {
            result2.push(key);
          }
        }
        return result2;
      }
      function baseKeysIn(object) {
        if (!isObject(object)) {
          return nativeKeysIn(object);
        }
        var isProto = isPrototype(object), result2 = [];
        for (var key in object) {
          if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) {
            result2.push(key);
          }
        }
        return result2;
      }
      function baseLt(value, other) {
        return value < other;
      }
      function baseMap(collection, iteratee2) {
        var index2 = -1, result2 = isArrayLike(collection) ? Array2(collection.length) : [];
        baseEach(collection, function(value, key, collection2) {
          result2[++index2] = iteratee2(value, key, collection2);
        });
        return result2;
      }
      function baseMatches(source) {
        var matchData = getMatchData(source);
        if (matchData.length == 1 && matchData[0][2]) {
          return matchesStrictComparable(matchData[0][0], matchData[0][1]);
        }
        return function(object) {
          return object === source || baseIsMatch(object, source, matchData);
        };
      }
      function baseMatchesProperty(path, srcValue) {
        if (isKey(path) && isStrictComparable(srcValue)) {
          return matchesStrictComparable(toKey(path), srcValue);
        }
        return function(object) {
          var objValue = get(object, path);
          return objValue === undefined$1 && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
        };
      }
      function baseMerge(object, source, srcIndex, customizer, stack) {
        if (object === source) {
          return;
        }
        baseFor(source, function(srcValue, key) {
          stack || (stack = new Stack());
          if (isObject(srcValue)) {
            baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
          } else {
            var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined$1;
            if (newValue === undefined$1) {
              newValue = srcValue;
            }
            assignMergeValue(object, key, newValue);
          }
        }, keysIn);
      }
      function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
        var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
        if (stacked) {
          assignMergeValue(object, key, stacked);
          return;
        }
        var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined$1;
        var isCommon = newValue === undefined$1;
        if (isCommon) {
          var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
          newValue = srcValue;
          if (isArr || isBuff || isTyped) {
            if (isArray(objValue)) {
              newValue = objValue;
            } else if (isArrayLikeObject(objValue)) {
              newValue = copyArray(objValue);
            } else if (isBuff) {
              isCommon = false;
              newValue = cloneBuffer(srcValue, true);
            } else if (isTyped) {
              isCommon = false;
              newValue = cloneTypedArray(srcValue, true);
            } else {
              newValue = [];
            }
          } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
            newValue = objValue;
            if (isArguments(objValue)) {
              newValue = toPlainObject(objValue);
            } else if (!isObject(objValue) || isFunction(objValue)) {
              newValue = initCloneObject(srcValue);
            }
          } else {
            isCommon = false;
          }
        }
        if (isCommon) {
          stack.set(srcValue, newValue);
          mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
          stack["delete"](srcValue);
        }
        assignMergeValue(object, key, newValue);
      }
      function baseNth(array, n) {
        var length = array.length;
        if (!length) {
          return;
        }
        n += n < 0 ? length : 0;
        return isIndex(n, length) ? array[n] : undefined$1;
      }
      function baseOrderBy(collection, iteratees, orders) {
        if (iteratees.length) {
          iteratees = arrayMap(iteratees, function(iteratee2) {
            if (isArray(iteratee2)) {
              return function(value) {
                return baseGet(value, iteratee2.length === 1 ? iteratee2[0] : iteratee2);
              };
            }
            return iteratee2;
          });
        } else {
          iteratees = [identity];
        }
        var index2 = -1;
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        var result2 = baseMap(collection, function(value, key, collection2) {
          var criteria = arrayMap(iteratees, function(iteratee2) {
            return iteratee2(value);
          });
          return { "criteria": criteria, "index": ++index2, "value": value };
        });
        return baseSortBy(result2, function(object, other) {
          return compareMultiple(object, other, orders);
        });
      }
      function basePick(object, paths) {
        return basePickBy(object, paths, function(value, path) {
          return hasIn(object, path);
        });
      }
      function basePickBy(object, paths, predicate) {
        var index2 = -1, length = paths.length, result2 = {};
        while (++index2 < length) {
          var path = paths[index2], value = baseGet(object, path);
          if (predicate(value, path)) {
            baseSet(result2, castPath(path, object), value);
          }
        }
        return result2;
      }
      function basePropertyDeep(path) {
        return function(object) {
          return baseGet(object, path);
        };
      }
      function basePullAll(array, values2, iteratee2, comparator) {
        var indexOf2 = comparator ? baseIndexOfWith : baseIndexOf, index2 = -1, length = values2.length, seen = array;
        if (array === values2) {
          values2 = copyArray(values2);
        }
        if (iteratee2) {
          seen = arrayMap(array, baseUnary(iteratee2));
        }
        while (++index2 < length) {
          var fromIndex = 0, value = values2[index2], computed = iteratee2 ? iteratee2(value) : value;
          while ((fromIndex = indexOf2(seen, computed, fromIndex, comparator)) > -1) {
            if (seen !== array) {
              splice.call(seen, fromIndex, 1);
            }
            splice.call(array, fromIndex, 1);
          }
        }
        return array;
      }
      function basePullAt(array, indexes) {
        var length = array ? indexes.length : 0, lastIndex = length - 1;
        while (length--) {
          var index2 = indexes[length];
          if (length == lastIndex || index2 !== previous) {
            var previous = index2;
            if (isIndex(index2)) {
              splice.call(array, index2, 1);
            } else {
              baseUnset(array, index2);
            }
          }
        }
        return array;
      }
      function baseRandom(lower, upper) {
        return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
      }
      function baseRange(start, end, step, fromRight) {
        var index2 = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result2 = Array2(length);
        while (length--) {
          result2[fromRight ? length : ++index2] = start;
          start += step;
        }
        return result2;
      }
      function baseRepeat(string, n) {
        var result2 = "";
        if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
          return result2;
        }
        do {
          if (n % 2) {
            result2 += string;
          }
          n = nativeFloor(n / 2);
          if (n) {
            string += string;
          }
        } while (n);
        return result2;
      }
      function baseRest(func, start) {
        return setToString(overRest(func, start, identity), func + "");
      }
      function baseSample(collection) {
        return arraySample(values(collection));
      }
      function baseSampleSize(collection, n) {
        var array = values(collection);
        return shuffleSelf(array, baseClamp(n, 0, array.length));
      }
      function baseSet(object, path, value, customizer) {
        if (!isObject(object)) {
          return object;
        }
        path = castPath(path, object);
        var index2 = -1, length = path.length, lastIndex = length - 1, nested = object;
        while (nested != null && ++index2 < length) {
          var key = toKey(path[index2]), newValue = value;
          if (key === "__proto__" || key === "constructor" || key === "prototype") {
            return object;
          }
          if (index2 != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined$1;
            if (newValue === undefined$1) {
              newValue = isObject(objValue) ? objValue : isIndex(path[index2 + 1]) ? [] : {};
            }
          }
          assignValue(nested, key, newValue);
          nested = nested[key];
        }
        return object;
      }
      var baseSetData = !metaMap ? identity : function(func, data) {
        metaMap.set(func, data);
        return func;
      };
      var baseSetToString = !defineProperty ? identity : function(func, string) {
        return defineProperty(func, "toString", {
          "configurable": true,
          "enumerable": false,
          "value": constant(string),
          "writable": true
        });
      };
      function baseShuffle(collection) {
        return shuffleSelf(values(collection));
      }
      function baseSlice(array, start, end) {
        var index2 = -1, length = array.length;
        if (start < 0) {
          start = -start > length ? 0 : length + start;
        }
        end = end > length ? length : end;
        if (end < 0) {
          end += length;
        }
        length = start > end ? 0 : end - start >>> 0;
        start >>>= 0;
        var result2 = Array2(length);
        while (++index2 < length) {
          result2[index2] = array[index2 + start];
        }
        return result2;
      }
      function baseSome(collection, predicate) {
        var result2;
        baseEach(collection, function(value, index2, collection2) {
          result2 = predicate(value, index2, collection2);
          return !result2;
        });
        return !!result2;
      }
      function baseSortedIndex(array, value, retHighest) {
        var low = 0, high = array == null ? low : array.length;
        if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
          while (low < high) {
            var mid = low + high >>> 1, computed = array[mid];
            if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) {
              low = mid + 1;
            } else {
              high = mid;
            }
          }
          return high;
        }
        return baseSortedIndexBy(array, value, identity, retHighest);
      }
      function baseSortedIndexBy(array, value, iteratee2, retHighest) {
        var low = 0, high = array == null ? 0 : array.length;
        if (high === 0) {
          return 0;
        }
        value = iteratee2(value);
        var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined$1;
        while (low < high) {
          var mid = nativeFloor((low + high) / 2), computed = iteratee2(array[mid]), othIsDefined = computed !== undefined$1, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
          if (valIsNaN) {
            var setLow = retHighest || othIsReflexive;
          } else if (valIsUndefined) {
            setLow = othIsReflexive && (retHighest || othIsDefined);
          } else if (valIsNull) {
            setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
          } else if (valIsSymbol) {
            setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
          } else if (othIsNull || othIsSymbol) {
            setLow = false;
          } else {
            setLow = retHighest ? computed <= value : computed < value;
          }
          if (setLow) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return nativeMin(high, MAX_ARRAY_INDEX);
      }
      function baseSortedUniq(array, iteratee2) {
        var index2 = -1, length = array.length, resIndex = 0, result2 = [];
        while (++index2 < length) {
          var value = array[index2], computed = iteratee2 ? iteratee2(value) : value;
          if (!index2 || !eq(computed, seen)) {
            var seen = computed;
            result2[resIndex++] = value === 0 ? 0 : value;
          }
        }
        return result2;
      }
      function baseToNumber(value) {
        if (typeof value == "number") {
          return value;
        }
        if (isSymbol(value)) {
          return NAN;
        }
        return +value;
      }
      function baseToString(value) {
        if (typeof value == "string") {
          return value;
        }
        if (isArray(value)) {
          return arrayMap(value, baseToString) + "";
        }
        if (isSymbol(value)) {
          return symbolToString ? symbolToString.call(value) : "";
        }
        var result2 = value + "";
        return result2 == "0" && 1 / value == -INFINITY ? "-0" : result2;
      }
      function baseUniq(array, iteratee2, comparator) {
        var index2 = -1, includes2 = arrayIncludes, length = array.length, isCommon = true, result2 = [], seen = result2;
        if (comparator) {
          isCommon = false;
          includes2 = arrayIncludesWith;
        } else if (length >= LARGE_ARRAY_SIZE) {
          var set2 = iteratee2 ? null : createSet(array);
          if (set2) {
            return setToArray(set2);
          }
          isCommon = false;
          includes2 = cacheHas;
          seen = new SetCache();
        } else {
          seen = iteratee2 ? [] : result2;
        }
        outer:
          while (++index2 < length) {
            var value = array[index2], computed = iteratee2 ? iteratee2(value) : value;
            value = comparator || value !== 0 ? value : 0;
            if (isCommon && computed === computed) {
              var seenIndex = seen.length;
              while (seenIndex--) {
                if (seen[seenIndex] === computed) {
                  continue outer;
                }
              }
              if (iteratee2) {
                seen.push(computed);
              }
              result2.push(value);
            } else if (!includes2(seen, computed, comparator)) {
              if (seen !== result2) {
                seen.push(computed);
              }
              result2.push(value);
            }
          }
        return result2;
      }
      function baseUnset(object, path) {
        path = castPath(path, object);
        object = parent(object, path);
        return object == null || delete object[toKey(last(path))];
      }
      function baseUpdate(object, path, updater, customizer) {
        return baseSet(object, path, updater(baseGet(object, path)), customizer);
      }
      function baseWhile(array, predicate, isDrop, fromRight) {
        var length = array.length, index2 = fromRight ? length : -1;
        while ((fromRight ? index2-- : ++index2 < length) && predicate(array[index2], index2, array)) {
        }
        return isDrop ? baseSlice(array, fromRight ? 0 : index2, fromRight ? index2 + 1 : length) : baseSlice(array, fromRight ? index2 + 1 : 0, fromRight ? length : index2);
      }
      function baseWrapperValue(value, actions) {
        var result2 = value;
        if (result2 instanceof LazyWrapper) {
          result2 = result2.value();
        }
        return arrayReduce(actions, function(result3, action) {
          return action.func.apply(action.thisArg, arrayPush([result3], action.args));
        }, result2);
      }
      function baseXor(arrays, iteratee2, comparator) {
        var length = arrays.length;
        if (length < 2) {
          return length ? baseUniq(arrays[0]) : [];
        }
        var index2 = -1, result2 = Array2(length);
        while (++index2 < length) {
          var array = arrays[index2], othIndex = -1;
          while (++othIndex < length) {
            if (othIndex != index2) {
              result2[index2] = baseDifference(result2[index2] || array, arrays[othIndex], iteratee2, comparator);
            }
          }
        }
        return baseUniq(baseFlatten(result2, 1), iteratee2, comparator);
      }
      function baseZipObject(props, values2, assignFunc) {
        var index2 = -1, length = props.length, valsLength = values2.length, result2 = {};
        while (++index2 < length) {
          var value = index2 < valsLength ? values2[index2] : undefined$1;
          assignFunc(result2, props[index2], value);
        }
        return result2;
      }
      function castArrayLikeObject(value) {
        return isArrayLikeObject(value) ? value : [];
      }
      function castFunction(value) {
        return typeof value == "function" ? value : identity;
      }
      function castPath(value, object) {
        if (isArray(value)) {
          return value;
        }
        return isKey(value, object) ? [value] : stringToPath(toString(value));
      }
      var castRest = baseRest;
      function castSlice(array, start, end) {
        var length = array.length;
        end = end === undefined$1 ? length : end;
        return !start && end >= length ? array : baseSlice(array, start, end);
      }
      var clearTimeout2 = ctxClearTimeout || function(id) {
        return root.clearTimeout(id);
      };
      function cloneBuffer(buffer, isDeep) {
        if (isDeep) {
          return buffer.slice();
        }
        var length = buffer.length, result2 = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
        buffer.copy(result2);
        return result2;
      }
      function cloneArrayBuffer(arrayBuffer) {
        var result2 = new arrayBuffer.constructor(arrayBuffer.byteLength);
        new Uint8Array2(result2).set(new Uint8Array2(arrayBuffer));
        return result2;
      }
      function cloneDataView(dataView, isDeep) {
        var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
        return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
      }
      function cloneRegExp(regexp) {
        var result2 = new regexp.constructor(regexp.source, reFlags.exec(regexp));
        result2.lastIndex = regexp.lastIndex;
        return result2;
      }
      function cloneSymbol(symbol) {
        return symbolValueOf ? Object2(symbolValueOf.call(symbol)) : {};
      }
      function cloneTypedArray(typedArray, isDeep) {
        var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
        return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
      }
      function compareAscending(value, other) {
        if (value !== other) {
          var valIsDefined = value !== undefined$1, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
          var othIsDefined = other !== undefined$1, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
          if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) {
            return 1;
          }
          if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) {
            return -1;
          }
        }
        return 0;
      }
      function compareMultiple(object, other, orders) {
        var index2 = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
        while (++index2 < length) {
          var result2 = compareAscending(objCriteria[index2], othCriteria[index2]);
          if (result2) {
            if (index2 >= ordersLength) {
              return result2;
            }
            var order = orders[index2];
            return result2 * (order == "desc" ? -1 : 1);
          }
        }
        return object.index - other.index;
      }
      function composeArgs(args, partials, holders, isCurried) {
        var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result2 = Array2(leftLength + rangeLength), isUncurried = !isCurried;
        while (++leftIndex < leftLength) {
          result2[leftIndex] = partials[leftIndex];
        }
        while (++argsIndex < holdersLength) {
          if (isUncurried || argsIndex < argsLength) {
            result2[holders[argsIndex]] = args[argsIndex];
          }
        }
        while (rangeLength--) {
          result2[leftIndex++] = args[argsIndex++];
        }
        return result2;
      }
      function composeArgsRight(args, partials, holders, isCurried) {
        var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result2 = Array2(rangeLength + rightLength), isUncurried = !isCurried;
        while (++argsIndex < rangeLength) {
          result2[argsIndex] = args[argsIndex];
        }
        var offset = argsIndex;
        while (++rightIndex < rightLength) {
          result2[offset + rightIndex] = partials[rightIndex];
        }
        while (++holdersIndex < holdersLength) {
          if (isUncurried || argsIndex < argsLength) {
            result2[offset + holders[holdersIndex]] = args[argsIndex++];
          }
        }
        return result2;
      }
      function copyArray(source, array) {
        var index2 = -1, length = source.length;
        array || (array = Array2(length));
        while (++index2 < length) {
          array[index2] = source[index2];
        }
        return array;
      }
      function copyObject(source, props, object, customizer) {
        var isNew = !object;
        object || (object = {});
        var index2 = -1, length = props.length;
        while (++index2 < length) {
          var key = props[index2];
          var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined$1;
          if (newValue === undefined$1) {
            newValue = source[key];
          }
          if (isNew) {
            baseAssignValue(object, key, newValue);
          } else {
            assignValue(object, key, newValue);
          }
        }
        return object;
      }
      function copySymbols(source, object) {
        return copyObject(source, getSymbols(source), object);
      }
      function copySymbolsIn(source, object) {
        return copyObject(source, getSymbolsIn(source), object);
      }
      function createAggregator(setter, initializer) {
        return function(collection, iteratee2) {
          var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
          return func(collection, setter, getIteratee(iteratee2, 2), accumulator);
        };
      }
      function createAssigner(assigner) {
        return baseRest(function(object, sources) {
          var index2 = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined$1, guard = length > 2 ? sources[2] : undefined$1;
          customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined$1;
          if (guard && isIterateeCall(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined$1 : customizer;
            length = 1;
          }
          object = Object2(object);
          while (++index2 < length) {
            var source = sources[index2];
            if (source) {
              assigner(object, source, index2, customizer);
            }
          }
          return object;
        });
      }
      function createBaseEach(eachFunc, fromRight) {
        return function(collection, iteratee2) {
          if (collection == null) {
            return collection;
          }
          if (!isArrayLike(collection)) {
            return eachFunc(collection, iteratee2);
          }
          var length = collection.length, index2 = fromRight ? length : -1, iterable = Object2(collection);
          while (fromRight ? index2-- : ++index2 < length) {
            if (iteratee2(iterable[index2], index2, iterable) === false) {
              break;
            }
          }
          return collection;
        };
      }
      function createBaseFor(fromRight) {
        return function(object, iteratee2, keysFunc) {
          var index2 = -1, iterable = Object2(object), props = keysFunc(object), length = props.length;
          while (length--) {
            var key = props[fromRight ? length : ++index2];
            if (iteratee2(iterable[key], key, iterable) === false) {
              break;
            }
          }
          return object;
        };
      }
      function createBind(func, bitmask, thisArg) {
        var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
        function wrapper() {
          var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
          return fn.apply(isBind ? thisArg : this, arguments);
        }
        return wrapper;
      }
      function createCaseFirst(methodName) {
        return function(string) {
          string = toString(string);
          var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined$1;
          var chr = strSymbols ? strSymbols[0] : string.charAt(0);
          var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
          return chr[methodName]() + trailing;
        };
      }
      function createCompounder(callback) {
        return function(string) {
          return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
        };
      }
      function createCtor(Ctor) {
        return function() {
          var args = arguments;
          switch (args.length) {
            case 0:
              return new Ctor();
            case 1:
              return new Ctor(args[0]);
            case 2:
              return new Ctor(args[0], args[1]);
            case 3:
              return new Ctor(args[0], args[1], args[2]);
            case 4:
              return new Ctor(args[0], args[1], args[2], args[3]);
            case 5:
              return new Ctor(args[0], args[1], args[2], args[3], args[4]);
            case 6:
              return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
            case 7:
              return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
          }
          var thisBinding = baseCreate(Ctor.prototype), result2 = Ctor.apply(thisBinding, args);
          return isObject(result2) ? result2 : thisBinding;
        };
      }
      function createCurry(func, bitmask, arity) {
        var Ctor = createCtor(func);
        function wrapper() {
          var length = arguments.length, args = Array2(length), index2 = length, placeholder = getHolder(wrapper);
          while (index2--) {
            args[index2] = arguments[index2];
          }
          var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
          length -= holders.length;
          if (length < arity) {
            return createRecurry(
              func,
              bitmask,
              createHybrid,
              wrapper.placeholder,
              undefined$1,
              args,
              holders,
              undefined$1,
              undefined$1,
              arity - length
            );
          }
          var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
          return apply(fn, this, args);
        }
        return wrapper;
      }
      function createFind(findIndexFunc) {
        return function(collection, predicate, fromIndex) {
          var iterable = Object2(collection);
          if (!isArrayLike(collection)) {
            var iteratee2 = getIteratee(predicate, 3);
            collection = keys(collection);
            predicate = function(key) {
              return iteratee2(iterable[key], key, iterable);
            };
          }
          var index2 = findIndexFunc(collection, predicate, fromIndex);
          return index2 > -1 ? iterable[iteratee2 ? collection[index2] : index2] : undefined$1;
        };
      }
      function createFlow(fromRight) {
        return flatRest(function(funcs) {
          var length = funcs.length, index2 = length, prereq = LodashWrapper.prototype.thru;
          if (fromRight) {
            funcs.reverse();
          }
          while (index2--) {
            var func = funcs[index2];
            if (typeof func != "function") {
              throw new TypeError2(FUNC_ERROR_TEXT);
            }
            if (prereq && !wrapper && getFuncName(func) == "wrapper") {
              var wrapper = new LodashWrapper([], true);
            }
          }
          index2 = wrapper ? index2 : length;
          while (++index2 < length) {
            func = funcs[index2];
            var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined$1;
            if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) {
              wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
            } else {
              wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
            }
          }
          return function() {
            var args = arguments, value = args[0];
            if (wrapper && args.length == 1 && isArray(value)) {
              return wrapper.plant(value).value();
            }
            var index3 = 0, result2 = length ? funcs[index3].apply(this, args) : value;
            while (++index3 < length) {
              result2 = funcs[index3].call(this, result2);
            }
            return result2;
          };
        });
      }
      function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary2, arity) {
        var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined$1 : createCtor(func);
        function wrapper() {
          var length = arguments.length, args = Array2(length), index2 = length;
          while (index2--) {
            args[index2] = arguments[index2];
          }
          if (isCurried) {
            var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
          }
          if (partials) {
            args = composeArgs(args, partials, holders, isCurried);
          }
          if (partialsRight) {
            args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
          }
          length -= holdersCount;
          if (isCurried && length < arity) {
            var newHolders = replaceHolders(args, placeholder);
            return createRecurry(
              func,
              bitmask,
              createHybrid,
              wrapper.placeholder,
              thisArg,
              args,
              newHolders,
              argPos,
              ary2,
              arity - length
            );
          }
          var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
          length = args.length;
          if (argPos) {
            args = reorder(args, argPos);
          } else if (isFlip && length > 1) {
            args.reverse();
          }
          if (isAry && ary2 < length) {
            args.length = ary2;
          }
          if (this && this !== root && this instanceof wrapper) {
            fn = Ctor || createCtor(fn);
          }
          return fn.apply(thisBinding, args);
        }
        return wrapper;
      }
      function createInverter(setter, toIteratee) {
        return function(object, iteratee2) {
          return baseInverter(object, setter, toIteratee(iteratee2), {});
        };
      }
      function createMathOperation(operator, defaultValue) {
        return function(value, other) {
          var result2;
          if (value === undefined$1 && other === undefined$1) {
            return defaultValue;
          }
          if (value !== undefined$1) {
            result2 = value;
          }
          if (other !== undefined$1) {
            if (result2 === undefined$1) {
              return other;
            }
            if (typeof value == "string" || typeof other == "string") {
              value = baseToString(value);
              other = baseToString(other);
            } else {
              value = baseToNumber(value);
              other = baseToNumber(other);
            }
            result2 = operator(value, other);
          }
          return result2;
        };
      }
      function createOver(arrayFunc) {
        return flatRest(function(iteratees) {
          iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
          return baseRest(function(args) {
            var thisArg = this;
            return arrayFunc(iteratees, function(iteratee2) {
              return apply(iteratee2, thisArg, args);
            });
          });
        });
      }
      function createPadding(length, chars) {
        chars = chars === undefined$1 ? " " : baseToString(chars);
        var charsLength = chars.length;
        if (charsLength < 2) {
          return charsLength ? baseRepeat(chars, length) : chars;
        }
        var result2 = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
        return hasUnicode(chars) ? castSlice(stringToArray(result2), 0, length).join("") : result2.slice(0, length);
      }
      function createPartial(func, bitmask, thisArg, partials) {
        var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
        function wrapper() {
          var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array2(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
          while (++leftIndex < leftLength) {
            args[leftIndex] = partials[leftIndex];
          }
          while (argsLength--) {
            args[leftIndex++] = arguments[++argsIndex];
          }
          return apply(fn, isBind ? thisArg : this, args);
        }
        return wrapper;
      }
      function createRange(fromRight) {
        return function(start, end, step) {
          if (step && typeof step != "number" && isIterateeCall(start, end, step)) {
            end = step = undefined$1;
          }
          start = toFinite(start);
          if (end === undefined$1) {
            end = start;
            start = 0;
          } else {
            end = toFinite(end);
          }
          step = step === undefined$1 ? start < end ? 1 : -1 : toFinite(step);
          return baseRange(start, end, step, fromRight);
        };
      }
      function createRelationalOperation(operator) {
        return function(value, other) {
          if (!(typeof value == "string" && typeof other == "string")) {
            value = toNumber(value);
            other = toNumber(other);
          }
          return operator(value, other);
        };
      }
      function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary2, arity) {
        var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined$1, newHoldersRight = isCurry ? undefined$1 : holders, newPartials = isCurry ? partials : undefined$1, newPartialsRight = isCurry ? undefined$1 : partials;
        bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
        bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
        if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
          bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
        }
        var newData = [
          func,
          bitmask,
          thisArg,
          newPartials,
          newHolders,
          newPartialsRight,
          newHoldersRight,
          argPos,
          ary2,
          arity
        ];
        var result2 = wrapFunc.apply(undefined$1, newData);
        if (isLaziable(func)) {
          setData(result2, newData);
        }
        result2.placeholder = placeholder;
        return setWrapToString(result2, func, bitmask);
      }
      function createRound(methodName) {
        var func = Math2[methodName];
        return function(number, precision) {
          number = toNumber(number);
          precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
          if (precision && nativeIsFinite(number)) {
            var pair = (toString(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
            pair = (toString(value) + "e").split("e");
            return +(pair[0] + "e" + (+pair[1] - precision));
          }
          return func(number);
        };
      }
      var createSet = !(Set2 && 1 / setToArray(new Set2([, -0]))[1] == INFINITY) ? noop : function(values2) {
        return new Set2(values2);
      };
      function createToPairs(keysFunc) {
        return function(object) {
          var tag = getTag(object);
          if (tag == mapTag) {
            return mapToArray(object);
          }
          if (tag == setTag) {
            return setToPairs(object);
          }
          return baseToPairs(object, keysFunc(object));
        };
      }
      function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary2, arity) {
        var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
        if (!isBindKey && typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        var length = partials ? partials.length : 0;
        if (!length) {
          bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
          partials = holders = undefined$1;
        }
        ary2 = ary2 === undefined$1 ? ary2 : nativeMax(toInteger(ary2), 0);
        arity = arity === undefined$1 ? arity : toInteger(arity);
        length -= holders ? holders.length : 0;
        if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
          var partialsRight = partials, holdersRight = holders;
          partials = holders = undefined$1;
        }
        var data = isBindKey ? undefined$1 : getData(func);
        var newData = [
          func,
          bitmask,
          thisArg,
          partials,
          holders,
          partialsRight,
          holdersRight,
          argPos,
          ary2,
          arity
        ];
        if (data) {
          mergeData(newData, data);
        }
        func = newData[0];
        bitmask = newData[1];
        thisArg = newData[2];
        partials = newData[3];
        holders = newData[4];
        arity = newData[9] = newData[9] === undefined$1 ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
        if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
          bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
        }
        if (!bitmask || bitmask == WRAP_BIND_FLAG) {
          var result2 = createBind(func, bitmask, thisArg);
        } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
          result2 = createCurry(func, bitmask, arity);
        } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
          result2 = createPartial(func, bitmask, thisArg, partials);
        } else {
          result2 = createHybrid.apply(undefined$1, newData);
        }
        var setter = data ? baseSetData : setData;
        return setWrapToString(setter(result2, newData), func, bitmask);
      }
      function customDefaultsAssignIn(objValue, srcValue, key, object) {
        if (objValue === undefined$1 || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) {
          return srcValue;
        }
        return objValue;
      }
      function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
        if (isObject(objValue) && isObject(srcValue)) {
          stack.set(srcValue, objValue);
          baseMerge(objValue, srcValue, undefined$1, customDefaultsMerge, stack);
          stack["delete"](srcValue);
        }
        return objValue;
      }
      function customOmitClone(value) {
        return isPlainObject(value) ? undefined$1 : value;
      }
      function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
        var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
        if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
          return false;
        }
        var arrStacked = stack.get(array);
        var othStacked = stack.get(other);
        if (arrStacked && othStacked) {
          return arrStacked == other && othStacked == array;
        }
        var index2 = -1, result2 = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache() : undefined$1;
        stack.set(array, other);
        stack.set(other, array);
        while (++index2 < arrLength) {
          var arrValue = array[index2], othValue = other[index2];
          if (customizer) {
            var compared = isPartial ? customizer(othValue, arrValue, index2, other, array, stack) : customizer(arrValue, othValue, index2, array, other, stack);
          }
          if (compared !== undefined$1) {
            if (compared) {
              continue;
            }
            result2 = false;
            break;
          }
          if (seen) {
            if (!arraySome(other, function(othValue2, othIndex) {
              if (!cacheHas(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack))) {
                return seen.push(othIndex);
              }
            })) {
              result2 = false;
              break;
            }
          } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result2 = false;
            break;
          }
        }
        stack["delete"](array);
        stack["delete"](other);
        return result2;
      }
      function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
        switch (tag) {
          case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
              return false;
            }
            object = object.buffer;
            other = other.buffer;
          case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array2(object), new Uint8Array2(other))) {
              return false;
            }
            return true;
          case boolTag:
          case dateTag:
          case numberTag:
            return eq(+object, +other);
          case errorTag:
            return object.name == other.name && object.message == other.message;
          case regexpTag:
          case stringTag:
            return object == other + "";
          case mapTag:
            var convert = mapToArray;
          case setTag:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) {
              return false;
            }
            var stacked = stack.get(object);
            if (stacked) {
              return stacked == other;
            }
            bitmask |= COMPARE_UNORDERED_FLAG;
            stack.set(object, other);
            var result2 = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result2;
          case symbolTag:
            if (symbolValueOf) {
              return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
        }
        return false;
      }
      function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
        var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
        if (objLength != othLength && !isPartial) {
          return false;
        }
        var index2 = objLength;
        while (index2--) {
          var key = objProps[index2];
          if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
            return false;
          }
        }
        var objStacked = stack.get(object);
        var othStacked = stack.get(other);
        if (objStacked && othStacked) {
          return objStacked == other && othStacked == object;
        }
        var result2 = true;
        stack.set(object, other);
        stack.set(other, object);
        var skipCtor = isPartial;
        while (++index2 < objLength) {
          key = objProps[index2];
          var objValue = object[key], othValue = other[key];
          if (customizer) {
            var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
          }
          if (!(compared === undefined$1 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result2 = false;
            break;
          }
          skipCtor || (skipCtor = key == "constructor");
        }
        if (result2 && !skipCtor) {
          var objCtor = object.constructor, othCtor = other.constructor;
          if (objCtor != othCtor && ("constructor" in object && "constructor" in other) && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
            result2 = false;
          }
        }
        stack["delete"](object);
        stack["delete"](other);
        return result2;
      }
      function flatRest(func) {
        return setToString(overRest(func, undefined$1, flatten), func + "");
      }
      function getAllKeys(object) {
        return baseGetAllKeys(object, keys, getSymbols);
      }
      function getAllKeysIn(object) {
        return baseGetAllKeys(object, keysIn, getSymbolsIn);
      }
      var getData = !metaMap ? noop : function(func) {
        return metaMap.get(func);
      };
      function getFuncName(func) {
        var result2 = func.name + "", array = realNames[result2], length = hasOwnProperty.call(realNames, result2) ? array.length : 0;
        while (length--) {
          var data = array[length], otherFunc = data.func;
          if (otherFunc == null || otherFunc == func) {
            return data.name;
          }
        }
        return result2;
      }
      function getHolder(func) {
        var object = hasOwnProperty.call(lodash2, "placeholder") ? lodash2 : func;
        return object.placeholder;
      }
      function getIteratee() {
        var result2 = lodash2.iteratee || iteratee;
        result2 = result2 === iteratee ? baseIteratee : result2;
        return arguments.length ? result2(arguments[0], arguments[1]) : result2;
      }
      function getMapData(map2, key) {
        var data = map2.__data__;
        return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
      }
      function getMatchData(object) {
        var result2 = keys(object), length = result2.length;
        while (length--) {
          var key = result2[length], value = object[key];
          result2[length] = [key, value, isStrictComparable(value)];
        }
        return result2;
      }
      function getNative(object, key) {
        var value = getValue(object, key);
        return baseIsNative(value) ? value : undefined$1;
      }
      function getRawTag(value) {
        var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
        try {
          value[symToStringTag] = undefined$1;
          var unmasked = true;
        } catch (e) {
        }
        var result2 = nativeObjectToString.call(value);
        if (unmasked) {
          if (isOwn) {
            value[symToStringTag] = tag;
          } else {
            delete value[symToStringTag];
          }
        }
        return result2;
      }
      var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
        if (object == null) {
          return [];
        }
        object = Object2(object);
        return arrayFilter(nativeGetSymbols(object), function(symbol) {
          return propertyIsEnumerable.call(object, symbol);
        });
      };
      var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
        var result2 = [];
        while (object) {
          arrayPush(result2, getSymbols(object));
          object = getPrototype(object);
        }
        return result2;
      };
      var getTag = baseGetTag;
      if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map2 && getTag(new Map2()) != mapTag || Promise2 && getTag(Promise2.resolve()) != promiseTag || Set2 && getTag(new Set2()) != setTag || WeakMap2 && getTag(new WeakMap2()) != weakMapTag) {
        getTag = function(value) {
          var result2 = baseGetTag(value), Ctor = result2 == objectTag ? value.constructor : undefined$1, ctorString = Ctor ? toSource(Ctor) : "";
          if (ctorString) {
            switch (ctorString) {
              case dataViewCtorString:
                return dataViewTag;
              case mapCtorString:
                return mapTag;
              case promiseCtorString:
                return promiseTag;
              case setCtorString:
                return setTag;
              case weakMapCtorString:
                return weakMapTag;
            }
          }
          return result2;
        };
      }
      function getView(start, end, transforms) {
        var index2 = -1, length = transforms.length;
        while (++index2 < length) {
          var data = transforms[index2], size3 = data.size;
          switch (data.type) {
            case "drop":
              start += size3;
              break;
            case "dropRight":
              end -= size3;
              break;
            case "take":
              end = nativeMin(end, start + size3);
              break;
            case "takeRight":
              start = nativeMax(start, end - size3);
              break;
          }
        }
        return { "start": start, "end": end };
      }
      function getWrapDetails(source) {
        var match = source.match(reWrapDetails);
        return match ? match[1].split(reSplitDetails) : [];
      }
      function hasPath(object, path, hasFunc) {
        path = castPath(path, object);
        var index2 = -1, length = path.length, result2 = false;
        while (++index2 < length) {
          var key = toKey(path[index2]);
          if (!(result2 = object != null && hasFunc(object, key))) {
            break;
          }
          object = object[key];
        }
        if (result2 || ++index2 != length) {
          return result2;
        }
        length = object == null ? 0 : object.length;
        return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
      }
      function initCloneArray(array) {
        var length = array.length, result2 = new array.constructor(length);
        if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
          result2.index = array.index;
          result2.input = array.input;
        }
        return result2;
      }
      function initCloneObject(object) {
        return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
      }
      function initCloneByTag(object, tag, isDeep) {
        var Ctor = object.constructor;
        switch (tag) {
          case arrayBufferTag:
            return cloneArrayBuffer(object);
          case boolTag:
          case dateTag:
            return new Ctor(+object);
          case dataViewTag:
            return cloneDataView(object, isDeep);
          case float32Tag:
          case float64Tag:
          case int8Tag:
          case int16Tag:
          case int32Tag:
          case uint8Tag:
          case uint8ClampedTag:
          case uint16Tag:
          case uint32Tag:
            return cloneTypedArray(object, isDeep);
          case mapTag:
            return new Ctor();
          case numberTag:
          case stringTag:
            return new Ctor(object);
          case regexpTag:
            return cloneRegExp(object);
          case setTag:
            return new Ctor();
          case symbolTag:
            return cloneSymbol(object);
        }
      }
      function insertWrapDetails(source, details) {
        var length = details.length;
        if (!length) {
          return source;
        }
        var lastIndex = length - 1;
        details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
        details = details.join(length > 2 ? ", " : " ");
        return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
      }
      function isFlattenable(value) {
        return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
      }
      function isIndex(value, length) {
        var type = typeof value;
        length = length == null ? MAX_SAFE_INTEGER : length;
        return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && (value > -1 && value % 1 == 0 && value < length);
      }
      function isIterateeCall(value, index2, object) {
        if (!isObject(object)) {
          return false;
        }
        var type = typeof index2;
        if (type == "number" ? isArrayLike(object) && isIndex(index2, object.length) : type == "string" && index2 in object) {
          return eq(object[index2], value);
        }
        return false;
      }
      function isKey(value, object) {
        if (isArray(value)) {
          return false;
        }
        var type = typeof value;
        if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) {
          return true;
        }
        return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object2(object);
      }
      function isKeyable(value) {
        var type = typeof value;
        return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
      }
      function isLaziable(func) {
        var funcName = getFuncName(func), other = lodash2[funcName];
        if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) {
          return false;
        }
        if (func === other) {
          return true;
        }
        var data = getData(other);
        return !!data && func === data[0];
      }
      function isMasked(func) {
        return !!maskSrcKey && maskSrcKey in func;
      }
      var isMaskable = coreJsData ? isFunction : stubFalse;
      function isPrototype(value) {
        var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
        return value === proto;
      }
      function isStrictComparable(value) {
        return value === value && !isObject(value);
      }
      function matchesStrictComparable(key, srcValue) {
        return function(object) {
          if (object == null) {
            return false;
          }
          return object[key] === srcValue && (srcValue !== undefined$1 || key in Object2(object));
        };
      }
      function memoizeCapped(func) {
        var result2 = memoize(func, function(key) {
          if (cache.size === MAX_MEMOIZE_SIZE) {
            cache.clear();
          }
          return key;
        });
        var cache = result2.cache;
        return result2;
      }
      function mergeData(data, source) {
        var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
        var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
        if (!(isCommon || isCombo)) {
          return data;
        }
        if (srcBitmask & WRAP_BIND_FLAG) {
          data[2] = source[2];
          newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
        }
        var value = source[3];
        if (value) {
          var partials = data[3];
          data[3] = partials ? composeArgs(partials, value, source[4]) : value;
          data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
        }
        value = source[5];
        if (value) {
          partials = data[5];
          data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
          data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
        }
        value = source[7];
        if (value) {
          data[7] = value;
        }
        if (srcBitmask & WRAP_ARY_FLAG) {
          data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
        }
        if (data[9] == null) {
          data[9] = source[9];
        }
        data[0] = source[0];
        data[1] = newBitmask;
        return data;
      }
      function nativeKeysIn(object) {
        var result2 = [];
        if (object != null) {
          for (var key in Object2(object)) {
            result2.push(key);
          }
        }
        return result2;
      }
      function objectToString(value) {
        return nativeObjectToString.call(value);
      }
      function overRest(func, start, transform2) {
        start = nativeMax(start === undefined$1 ? func.length - 1 : start, 0);
        return function() {
          var args = arguments, index2 = -1, length = nativeMax(args.length - start, 0), array = Array2(length);
          while (++index2 < length) {
            array[index2] = args[start + index2];
          }
          index2 = -1;
          var otherArgs = Array2(start + 1);
          while (++index2 < start) {
            otherArgs[index2] = args[index2];
          }
          otherArgs[start] = transform2(array);
          return apply(func, this, otherArgs);
        };
      }
      function parent(object, path) {
        return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
      }
      function reorder(array, indexes) {
        var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
        while (length--) {
          var index2 = indexes[length];
          array[length] = isIndex(index2, arrLength) ? oldArray[index2] : undefined$1;
        }
        return array;
      }
      function safeGet(object, key) {
        if (key === "constructor" && typeof object[key] === "function") {
          return;
        }
        if (key == "__proto__") {
          return;
        }
        return object[key];
      }
      var setData = shortOut(baseSetData);
      var setTimeout2 = ctxSetTimeout || function(func, wait) {
        return root.setTimeout(func, wait);
      };
      var setToString = shortOut(baseSetToString);
      function setWrapToString(wrapper, reference2, bitmask) {
        var source = reference2 + "";
        return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
      }
      function shortOut(func) {
        var count = 0, lastCalled = 0;
        return function() {
          var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
          lastCalled = stamp;
          if (remaining > 0) {
            if (++count >= HOT_COUNT) {
              return arguments[0];
            }
          } else {
            count = 0;
          }
          return func.apply(undefined$1, arguments);
        };
      }
      function shuffleSelf(array, size3) {
        var index2 = -1, length = array.length, lastIndex = length - 1;
        size3 = size3 === undefined$1 ? length : size3;
        while (++index2 < size3) {
          var rand = baseRandom(index2, lastIndex), value = array[rand];
          array[rand] = array[index2];
          array[index2] = value;
        }
        array.length = size3;
        return array;
      }
      var stringToPath = memoizeCapped(function(string) {
        var result2 = [];
        if (string.charCodeAt(0) === 46) {
          result2.push("");
        }
        string.replace(rePropName, function(match, number, quote, subString) {
          result2.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
        });
        return result2;
      });
      function toKey(value) {
        if (typeof value == "string" || isSymbol(value)) {
          return value;
        }
        var result2 = value + "";
        return result2 == "0" && 1 / value == -INFINITY ? "-0" : result2;
      }
      function toSource(func) {
        if (func != null) {
          try {
            return funcToString.call(func);
          } catch (e) {
          }
          try {
            return func + "";
          } catch (e) {
          }
        }
        return "";
      }
      function updateWrapDetails(details, bitmask) {
        arrayEach(wrapFlags, function(pair) {
          var value = "_." + pair[0];
          if (bitmask & pair[1] && !arrayIncludes(details, value)) {
            details.push(value);
          }
        });
        return details.sort();
      }
      function wrapperClone(wrapper) {
        if (wrapper instanceof LazyWrapper) {
          return wrapper.clone();
        }
        var result2 = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
        result2.__actions__ = copyArray(wrapper.__actions__);
        result2.__index__ = wrapper.__index__;
        result2.__values__ = wrapper.__values__;
        return result2;
      }
      function chunk(array, size3, guard) {
        if (guard ? isIterateeCall(array, size3, guard) : size3 === undefined$1) {
          size3 = 1;
        } else {
          size3 = nativeMax(toInteger(size3), 0);
        }
        var length = array == null ? 0 : array.length;
        if (!length || size3 < 1) {
          return [];
        }
        var index2 = 0, resIndex = 0, result2 = Array2(nativeCeil(length / size3));
        while (index2 < length) {
          result2[resIndex++] = baseSlice(array, index2, index2 += size3);
        }
        return result2;
      }
      function compact(array) {
        var index2 = -1, length = array == null ? 0 : array.length, resIndex = 0, result2 = [];
        while (++index2 < length) {
          var value = array[index2];
          if (value) {
            result2[resIndex++] = value;
          }
        }
        return result2;
      }
      function concat() {
        var length = arguments.length;
        if (!length) {
          return [];
        }
        var args = Array2(length - 1), array = arguments[0], index2 = length;
        while (index2--) {
          args[index2 - 1] = arguments[index2];
        }
        return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
      }
      var difference = baseRest(function(array, values2) {
        return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values2, 1, isArrayLikeObject, true)) : [];
      });
      var differenceBy = baseRest(function(array, values2) {
        var iteratee2 = last(values2);
        if (isArrayLikeObject(iteratee2)) {
          iteratee2 = undefined$1;
        }
        return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values2, 1, isArrayLikeObject, true), getIteratee(iteratee2, 2)) : [];
      });
      var differenceWith = baseRest(function(array, values2) {
        var comparator = last(values2);
        if (isArrayLikeObject(comparator)) {
          comparator = undefined$1;
        }
        return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values2, 1, isArrayLikeObject, true), undefined$1, comparator) : [];
      });
      function drop(array, n, guard) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return [];
        }
        n = guard || n === undefined$1 ? 1 : toInteger(n);
        return baseSlice(array, n < 0 ? 0 : n, length);
      }
      function dropRight(array, n, guard) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return [];
        }
        n = guard || n === undefined$1 ? 1 : toInteger(n);
        n = length - n;
        return baseSlice(array, 0, n < 0 ? 0 : n);
      }
      function dropRightWhile(array, predicate) {
        return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
      }
      function dropWhile(array, predicate) {
        return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
      }
      function fill(array, value, start, end) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return [];
        }
        if (start && typeof start != "number" && isIterateeCall(array, value, start)) {
          start = 0;
          end = length;
        }
        return baseFill(array, value, start, end);
      }
      function findIndex(array, predicate, fromIndex) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return -1;
        }
        var index2 = fromIndex == null ? 0 : toInteger(fromIndex);
        if (index2 < 0) {
          index2 = nativeMax(length + index2, 0);
        }
        return baseFindIndex(array, getIteratee(predicate, 3), index2);
      }
      function findLastIndex(array, predicate, fromIndex) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return -1;
        }
        var index2 = length - 1;
        if (fromIndex !== undefined$1) {
          index2 = toInteger(fromIndex);
          index2 = fromIndex < 0 ? nativeMax(length + index2, 0) : nativeMin(index2, length - 1);
        }
        return baseFindIndex(array, getIteratee(predicate, 3), index2, true);
      }
      function flatten(array) {
        var length = array == null ? 0 : array.length;
        return length ? baseFlatten(array, 1) : [];
      }
      function flattenDeep(array) {
        var length = array == null ? 0 : array.length;
        return length ? baseFlatten(array, INFINITY) : [];
      }
      function flattenDepth(array, depth) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return [];
        }
        depth = depth === undefined$1 ? 1 : toInteger(depth);
        return baseFlatten(array, depth);
      }
      function fromPairs(pairs) {
        var index2 = -1, length = pairs == null ? 0 : pairs.length, result2 = {};
        while (++index2 < length) {
          var pair = pairs[index2];
          result2[pair[0]] = pair[1];
        }
        return result2;
      }
      function head(array) {
        return array && array.length ? array[0] : undefined$1;
      }
      function indexOf(array, value, fromIndex) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return -1;
        }
        var index2 = fromIndex == null ? 0 : toInteger(fromIndex);
        if (index2 < 0) {
          index2 = nativeMax(length + index2, 0);
        }
        return baseIndexOf(array, value, index2);
      }
      function initial(array) {
        var length = array == null ? 0 : array.length;
        return length ? baseSlice(array, 0, -1) : [];
      }
      var intersection = baseRest(function(arrays) {
        var mapped = arrayMap(arrays, castArrayLikeObject);
        return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
      });
      var intersectionBy = baseRest(function(arrays) {
        var iteratee2 = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
        if (iteratee2 === last(mapped)) {
          iteratee2 = undefined$1;
        } else {
          mapped.pop();
        }
        return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee2, 2)) : [];
      });
      var intersectionWith = baseRest(function(arrays) {
        var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
        comparator = typeof comparator == "function" ? comparator : undefined$1;
        if (comparator) {
          mapped.pop();
        }
        return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined$1, comparator) : [];
      });
      function join(array, separator) {
        return array == null ? "" : nativeJoin.call(array, separator);
      }
      function last(array) {
        var length = array == null ? 0 : array.length;
        return length ? array[length - 1] : undefined$1;
      }
      function lastIndexOf(array, value, fromIndex) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return -1;
        }
        var index2 = length;
        if (fromIndex !== undefined$1) {
          index2 = toInteger(fromIndex);
          index2 = index2 < 0 ? nativeMax(length + index2, 0) : nativeMin(index2, length - 1);
        }
        return value === value ? strictLastIndexOf(array, value, index2) : baseFindIndex(array, baseIsNaN, index2, true);
      }
      function nth(array, n) {
        return array && array.length ? baseNth(array, toInteger(n)) : undefined$1;
      }
      var pull = baseRest(pullAll);
      function pullAll(array, values2) {
        return array && array.length && values2 && values2.length ? basePullAll(array, values2) : array;
      }
      function pullAllBy(array, values2, iteratee2) {
        return array && array.length && values2 && values2.length ? basePullAll(array, values2, getIteratee(iteratee2, 2)) : array;
      }
      function pullAllWith(array, values2, comparator) {
        return array && array.length && values2 && values2.length ? basePullAll(array, values2, undefined$1, comparator) : array;
      }
      var pullAt = flatRest(function(array, indexes) {
        var length = array == null ? 0 : array.length, result2 = baseAt(array, indexes);
        basePullAt(array, arrayMap(indexes, function(index2) {
          return isIndex(index2, length) ? +index2 : index2;
        }).sort(compareAscending));
        return result2;
      });
      function remove(array, predicate) {
        var result2 = [];
        if (!(array && array.length)) {
          return result2;
        }
        var index2 = -1, indexes = [], length = array.length;
        predicate = getIteratee(predicate, 3);
        while (++index2 < length) {
          var value = array[index2];
          if (predicate(value, index2, array)) {
            result2.push(value);
            indexes.push(index2);
          }
        }
        basePullAt(array, indexes);
        return result2;
      }
      function reverse(array) {
        return array == null ? array : nativeReverse.call(array);
      }
      function slice(array, start, end) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return [];
        }
        if (end && typeof end != "number" && isIterateeCall(array, start, end)) {
          start = 0;
          end = length;
        } else {
          start = start == null ? 0 : toInteger(start);
          end = end === undefined$1 ? length : toInteger(end);
        }
        return baseSlice(array, start, end);
      }
      function sortedIndex(array, value) {
        return baseSortedIndex(array, value);
      }
      function sortedIndexBy(array, value, iteratee2) {
        return baseSortedIndexBy(array, value, getIteratee(iteratee2, 2));
      }
      function sortedIndexOf(array, value) {
        var length = array == null ? 0 : array.length;
        if (length) {
          var index2 = baseSortedIndex(array, value);
          if (index2 < length && eq(array[index2], value)) {
            return index2;
          }
        }
        return -1;
      }
      function sortedLastIndex(array, value) {
        return baseSortedIndex(array, value, true);
      }
      function sortedLastIndexBy(array, value, iteratee2) {
        return baseSortedIndexBy(array, value, getIteratee(iteratee2, 2), true);
      }
      function sortedLastIndexOf(array, value) {
        var length = array == null ? 0 : array.length;
        if (length) {
          var index2 = baseSortedIndex(array, value, true) - 1;
          if (eq(array[index2], value)) {
            return index2;
          }
        }
        return -1;
      }
      function sortedUniq(array) {
        return array && array.length ? baseSortedUniq(array) : [];
      }
      function sortedUniqBy(array, iteratee2) {
        return array && array.length ? baseSortedUniq(array, getIteratee(iteratee2, 2)) : [];
      }
      function tail(array) {
        var length = array == null ? 0 : array.length;
        return length ? baseSlice(array, 1, length) : [];
      }
      function take(array, n, guard) {
        if (!(array && array.length)) {
          return [];
        }
        n = guard || n === undefined$1 ? 1 : toInteger(n);
        return baseSlice(array, 0, n < 0 ? 0 : n);
      }
      function takeRight(array, n, guard) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return [];
        }
        n = guard || n === undefined$1 ? 1 : toInteger(n);
        n = length - n;
        return baseSlice(array, n < 0 ? 0 : n, length);
      }
      function takeRightWhile(array, predicate) {
        return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
      }
      function takeWhile(array, predicate) {
        return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
      }
      var union = baseRest(function(arrays) {
        return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
      });
      var unionBy = baseRest(function(arrays) {
        var iteratee2 = last(arrays);
        if (isArrayLikeObject(iteratee2)) {
          iteratee2 = undefined$1;
        }
        return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee2, 2));
      });
      var unionWith = baseRest(function(arrays) {
        var comparator = last(arrays);
        comparator = typeof comparator == "function" ? comparator : undefined$1;
        return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined$1, comparator);
      });
      function uniq(array) {
        return array && array.length ? baseUniq(array) : [];
      }
      function uniqBy(array, iteratee2) {
        return array && array.length ? baseUniq(array, getIteratee(iteratee2, 2)) : [];
      }
      function uniqWith(array, comparator) {
        comparator = typeof comparator == "function" ? comparator : undefined$1;
        return array && array.length ? baseUniq(array, undefined$1, comparator) : [];
      }
      function unzip(array) {
        if (!(array && array.length)) {
          return [];
        }
        var length = 0;
        array = arrayFilter(array, function(group) {
          if (isArrayLikeObject(group)) {
            length = nativeMax(group.length, length);
            return true;
          }
        });
        return baseTimes(length, function(index2) {
          return arrayMap(array, baseProperty(index2));
        });
      }
      function unzipWith(array, iteratee2) {
        if (!(array && array.length)) {
          return [];
        }
        var result2 = unzip(array);
        if (iteratee2 == null) {
          return result2;
        }
        return arrayMap(result2, function(group) {
          return apply(iteratee2, undefined$1, group);
        });
      }
      var without = baseRest(function(array, values2) {
        return isArrayLikeObject(array) ? baseDifference(array, values2) : [];
      });
      var xor = baseRest(function(arrays) {
        return baseXor(arrayFilter(arrays, isArrayLikeObject));
      });
      var xorBy = baseRest(function(arrays) {
        var iteratee2 = last(arrays);
        if (isArrayLikeObject(iteratee2)) {
          iteratee2 = undefined$1;
        }
        return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee2, 2));
      });
      var xorWith = baseRest(function(arrays) {
        var comparator = last(arrays);
        comparator = typeof comparator == "function" ? comparator : undefined$1;
        return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined$1, comparator);
      });
      var zip = baseRest(unzip);
      function zipObject(props, values2) {
        return baseZipObject(props || [], values2 || [], assignValue);
      }
      function zipObjectDeep(props, values2) {
        return baseZipObject(props || [], values2 || [], baseSet);
      }
      var zipWith = baseRest(function(arrays) {
        var length = arrays.length, iteratee2 = length > 1 ? arrays[length - 1] : undefined$1;
        iteratee2 = typeof iteratee2 == "function" ? (arrays.pop(), iteratee2) : undefined$1;
        return unzipWith(arrays, iteratee2);
      });
      function chain(value) {
        var result2 = lodash2(value);
        result2.__chain__ = true;
        return result2;
      }
      function tap(value, interceptor) {
        interceptor(value);
        return value;
      }
      function thru(value, interceptor) {
        return interceptor(value);
      }
      var wrapperAt = flatRest(function(paths) {
        var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
          return baseAt(object, paths);
        };
        if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) {
          return this.thru(interceptor);
        }
        value = value.slice(start, +start + (length ? 1 : 0));
        value.__actions__.push({
          "func": thru,
          "args": [interceptor],
          "thisArg": undefined$1
        });
        return new LodashWrapper(value, this.__chain__).thru(function(array) {
          if (length && !array.length) {
            array.push(undefined$1);
          }
          return array;
        });
      });
      function wrapperChain() {
        return chain(this);
      }
      function wrapperCommit() {
        return new LodashWrapper(this.value(), this.__chain__);
      }
      function wrapperNext() {
        if (this.__values__ === undefined$1) {
          this.__values__ = toArray(this.value());
        }
        var done = this.__index__ >= this.__values__.length, value = done ? undefined$1 : this.__values__[this.__index__++];
        return { "done": done, "value": value };
      }
      function wrapperToIterator() {
        return this;
      }
      function wrapperPlant(value) {
        var result2, parent2 = this;
        while (parent2 instanceof baseLodash) {
          var clone2 = wrapperClone(parent2);
          clone2.__index__ = 0;
          clone2.__values__ = undefined$1;
          if (result2) {
            previous.__wrapped__ = clone2;
          } else {
            result2 = clone2;
          }
          var previous = clone2;
          parent2 = parent2.__wrapped__;
        }
        previous.__wrapped__ = value;
        return result2;
      }
      function wrapperReverse() {
        var value = this.__wrapped__;
        if (value instanceof LazyWrapper) {
          var wrapped = value;
          if (this.__actions__.length) {
            wrapped = new LazyWrapper(this);
          }
          wrapped = wrapped.reverse();
          wrapped.__actions__.push({
            "func": thru,
            "args": [reverse],
            "thisArg": undefined$1
          });
          return new LodashWrapper(wrapped, this.__chain__);
        }
        return this.thru(reverse);
      }
      function wrapperValue() {
        return baseWrapperValue(this.__wrapped__, this.__actions__);
      }
      var countBy = createAggregator(function(result2, value, key) {
        if (hasOwnProperty.call(result2, key)) {
          ++result2[key];
        } else {
          baseAssignValue(result2, key, 1);
        }
      });
      function every(collection, predicate, guard) {
        var func = isArray(collection) ? arrayEvery : baseEvery;
        if (guard && isIterateeCall(collection, predicate, guard)) {
          predicate = undefined$1;
        }
        return func(collection, getIteratee(predicate, 3));
      }
      function filter(collection, predicate) {
        var func = isArray(collection) ? arrayFilter : baseFilter;
        return func(collection, getIteratee(predicate, 3));
      }
      var find = createFind(findIndex);
      var findLast = createFind(findLastIndex);
      function flatMap(collection, iteratee2) {
        return baseFlatten(map(collection, iteratee2), 1);
      }
      function flatMapDeep(collection, iteratee2) {
        return baseFlatten(map(collection, iteratee2), INFINITY);
      }
      function flatMapDepth(collection, iteratee2, depth) {
        depth = depth === undefined$1 ? 1 : toInteger(depth);
        return baseFlatten(map(collection, iteratee2), depth);
      }
      function forEach(collection, iteratee2) {
        var func = isArray(collection) ? arrayEach : baseEach;
        return func(collection, getIteratee(iteratee2, 3));
      }
      function forEachRight(collection, iteratee2) {
        var func = isArray(collection) ? arrayEachRight : baseEachRight;
        return func(collection, getIteratee(iteratee2, 3));
      }
      var groupBy = createAggregator(function(result2, value, key) {
        if (hasOwnProperty.call(result2, key)) {
          result2[key].push(value);
        } else {
          baseAssignValue(result2, key, [value]);
        }
      });
      function includes(collection, value, fromIndex, guard) {
        collection = isArrayLike(collection) ? collection : values(collection);
        fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
        var length = collection.length;
        if (fromIndex < 0) {
          fromIndex = nativeMax(length + fromIndex, 0);
        }
        return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
      }
      var invokeMap = baseRest(function(collection, path, args) {
        var index2 = -1, isFunc = typeof path == "function", result2 = isArrayLike(collection) ? Array2(collection.length) : [];
        baseEach(collection, function(value) {
          result2[++index2] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
        });
        return result2;
      });
      var keyBy = createAggregator(function(result2, value, key) {
        baseAssignValue(result2, key, value);
      });
      function map(collection, iteratee2) {
        var func = isArray(collection) ? arrayMap : baseMap;
        return func(collection, getIteratee(iteratee2, 3));
      }
      function orderBy(collection, iteratees, orders, guard) {
        if (collection == null) {
          return [];
        }
        if (!isArray(iteratees)) {
          iteratees = iteratees == null ? [] : [iteratees];
        }
        orders = guard ? undefined$1 : orders;
        if (!isArray(orders)) {
          orders = orders == null ? [] : [orders];
        }
        return baseOrderBy(collection, iteratees, orders);
      }
      var partition = createAggregator(function(result2, value, key) {
        result2[key ? 0 : 1].push(value);
      }, function() {
        return [[], []];
      });
      function reduce(collection, iteratee2, accumulator) {
        var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
        return func(collection, getIteratee(iteratee2, 4), accumulator, initAccum, baseEach);
      }
      function reduceRight(collection, iteratee2, accumulator) {
        var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
        return func(collection, getIteratee(iteratee2, 4), accumulator, initAccum, baseEachRight);
      }
      function reject(collection, predicate) {
        var func = isArray(collection) ? arrayFilter : baseFilter;
        return func(collection, negate(getIteratee(predicate, 3)));
      }
      function sample(collection) {
        var func = isArray(collection) ? arraySample : baseSample;
        return func(collection);
      }
      function sampleSize(collection, n, guard) {
        if (guard ? isIterateeCall(collection, n, guard) : n === undefined$1) {
          n = 1;
        } else {
          n = toInteger(n);
        }
        var func = isArray(collection) ? arraySampleSize : baseSampleSize;
        return func(collection, n);
      }
      function shuffle(collection) {
        var func = isArray(collection) ? arrayShuffle : baseShuffle;
        return func(collection);
      }
      function size2(collection) {
        if (collection == null) {
          return 0;
        }
        if (isArrayLike(collection)) {
          return isString(collection) ? stringSize(collection) : collection.length;
        }
        var tag = getTag(collection);
        if (tag == mapTag || tag == setTag) {
          return collection.size;
        }
        return baseKeys(collection).length;
      }
      function some(collection, predicate, guard) {
        var func = isArray(collection) ? arraySome : baseSome;
        if (guard && isIterateeCall(collection, predicate, guard)) {
          predicate = undefined$1;
        }
        return func(collection, getIteratee(predicate, 3));
      }
      var sortBy = baseRest(function(collection, iteratees) {
        if (collection == null) {
          return [];
        }
        var length = iteratees.length;
        if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
          iteratees = [];
        } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
          iteratees = [iteratees[0]];
        }
        return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
      });
      var now = ctxNow || function() {
        return root.Date.now();
      };
      function after(n, func) {
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        n = toInteger(n);
        return function() {
          if (--n < 1) {
            return func.apply(this, arguments);
          }
        };
      }
      function ary(func, n, guard) {
        n = guard ? undefined$1 : n;
        n = func && n == null ? func.length : n;
        return createWrap(func, WRAP_ARY_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, n);
      }
      function before(n, func) {
        var result2;
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        n = toInteger(n);
        return function() {
          if (--n > 0) {
            result2 = func.apply(this, arguments);
          }
          if (n <= 1) {
            func = undefined$1;
          }
          return result2;
        };
      }
      var bind = baseRest(function(func, thisArg, partials) {
        var bitmask = WRAP_BIND_FLAG;
        if (partials.length) {
          var holders = replaceHolders(partials, getHolder(bind));
          bitmask |= WRAP_PARTIAL_FLAG;
        }
        return createWrap(func, bitmask, thisArg, partials, holders);
      });
      var bindKey = baseRest(function(object, key, partials) {
        var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
        if (partials.length) {
          var holders = replaceHolders(partials, getHolder(bindKey));
          bitmask |= WRAP_PARTIAL_FLAG;
        }
        return createWrap(key, bitmask, object, partials, holders);
      });
      function curry(func, arity, guard) {
        arity = guard ? undefined$1 : arity;
        var result2 = createWrap(func, WRAP_CURRY_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, undefined$1, arity);
        result2.placeholder = curry.placeholder;
        return result2;
      }
      function curryRight(func, arity, guard) {
        arity = guard ? undefined$1 : arity;
        var result2 = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, undefined$1, arity);
        result2.placeholder = curryRight.placeholder;
        return result2;
      }
      function debounce(func, wait, options) {
        var lastArgs, lastThis, maxWait, result2, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        wait = toNumber(wait) || 0;
        if (isObject(options)) {
          leading = !!options.leading;
          maxing = "maxWait" in options;
          maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
          trailing = "trailing" in options ? !!options.trailing : trailing;
        }
        function invokeFunc(time) {
          var args = lastArgs, thisArg = lastThis;
          lastArgs = lastThis = undefined$1;
          lastInvokeTime = time;
          result2 = func.apply(thisArg, args);
          return result2;
        }
        function leadingEdge(time) {
          lastInvokeTime = time;
          timerId = setTimeout2(timerExpired, wait);
          return leading ? invokeFunc(time) : result2;
        }
        function remainingWait(time) {
          var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
          return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
        }
        function shouldInvoke(time) {
          var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
          return lastCallTime === undefined$1 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
        }
        function timerExpired() {
          var time = now();
          if (shouldInvoke(time)) {
            return trailingEdge(time);
          }
          timerId = setTimeout2(timerExpired, remainingWait(time));
        }
        function trailingEdge(time) {
          timerId = undefined$1;
          if (trailing && lastArgs) {
            return invokeFunc(time);
          }
          lastArgs = lastThis = undefined$1;
          return result2;
        }
        function cancel() {
          if (timerId !== undefined$1) {
            clearTimeout2(timerId);
          }
          lastInvokeTime = 0;
          lastArgs = lastCallTime = lastThis = timerId = undefined$1;
        }
        function flush() {
          return timerId === undefined$1 ? result2 : trailingEdge(now());
        }
        function debounced() {
          var time = now(), isInvoking = shouldInvoke(time);
          lastArgs = arguments;
          lastThis = this;
          lastCallTime = time;
          if (isInvoking) {
            if (timerId === undefined$1) {
              return leadingEdge(lastCallTime);
            }
            if (maxing) {
              clearTimeout2(timerId);
              timerId = setTimeout2(timerExpired, wait);
              return invokeFunc(lastCallTime);
            }
          }
          if (timerId === undefined$1) {
            timerId = setTimeout2(timerExpired, wait);
          }
          return result2;
        }
        debounced.cancel = cancel;
        debounced.flush = flush;
        return debounced;
      }
      var defer = baseRest(function(func, args) {
        return baseDelay(func, 1, args);
      });
      var delay = baseRest(function(func, wait, args) {
        return baseDelay(func, toNumber(wait) || 0, args);
      });
      function flip(func) {
        return createWrap(func, WRAP_FLIP_FLAG);
      }
      function memoize(func, resolver) {
        if (typeof func != "function" || resolver != null && typeof resolver != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        var memoized = function() {
          var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
          if (cache.has(key)) {
            return cache.get(key);
          }
          var result2 = func.apply(this, args);
          memoized.cache = cache.set(key, result2) || cache;
          return result2;
        };
        memoized.cache = new (memoize.Cache || MapCache)();
        return memoized;
      }
      memoize.Cache = MapCache;
      function negate(predicate) {
        if (typeof predicate != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        return function() {
          var args = arguments;
          switch (args.length) {
            case 0:
              return !predicate.call(this);
            case 1:
              return !predicate.call(this, args[0]);
            case 2:
              return !predicate.call(this, args[0], args[1]);
            case 3:
              return !predicate.call(this, args[0], args[1], args[2]);
          }
          return !predicate.apply(this, args);
        };
      }
      function once(func) {
        return before(2, func);
      }
      var overArgs = castRest(function(func, transforms) {
        transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
        var funcsLength = transforms.length;
        return baseRest(function(args) {
          var index2 = -1, length = nativeMin(args.length, funcsLength);
          while (++index2 < length) {
            args[index2] = transforms[index2].call(this, args[index2]);
          }
          return apply(func, this, args);
        });
      });
      var partial = baseRest(function(func, partials) {
        var holders = replaceHolders(partials, getHolder(partial));
        return createWrap(func, WRAP_PARTIAL_FLAG, undefined$1, partials, holders);
      });
      var partialRight = baseRest(function(func, partials) {
        var holders = replaceHolders(partials, getHolder(partialRight));
        return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined$1, partials, holders);
      });
      var rearg = flatRest(function(func, indexes) {
        return createWrap(func, WRAP_REARG_FLAG, undefined$1, undefined$1, undefined$1, indexes);
      });
      function rest(func, start) {
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        start = start === undefined$1 ? start : toInteger(start);
        return baseRest(func, start);
      }
      function spread(func, start) {
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        start = start == null ? 0 : nativeMax(toInteger(start), 0);
        return baseRest(function(args) {
          var array = args[start], otherArgs = castSlice(args, 0, start);
          if (array) {
            arrayPush(otherArgs, array);
          }
          return apply(func, this, otherArgs);
        });
      }
      function throttle(func, wait, options) {
        var leading = true, trailing = true;
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        if (isObject(options)) {
          leading = "leading" in options ? !!options.leading : leading;
          trailing = "trailing" in options ? !!options.trailing : trailing;
        }
        return debounce(func, wait, {
          "leading": leading,
          "maxWait": wait,
          "trailing": trailing
        });
      }
      function unary(func) {
        return ary(func, 1);
      }
      function wrap(value, wrapper) {
        return partial(castFunction(wrapper), value);
      }
      function castArray() {
        if (!arguments.length) {
          return [];
        }
        var value = arguments[0];
        return isArray(value) ? value : [value];
      }
      function clone(value) {
        return baseClone(value, CLONE_SYMBOLS_FLAG);
      }
      function cloneWith(value, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$1;
        return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
      }
      function cloneDeep(value) {
        return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
      }
      function cloneDeepWith(value, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$1;
        return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
      }
      function conformsTo(object, source) {
        return source == null || baseConformsTo(object, source, keys(source));
      }
      function eq(value, other) {
        return value === other || value !== value && other !== other;
      }
      var gt = createRelationalOperation(baseGt);
      var gte = createRelationalOperation(function(value, other) {
        return value >= other;
      });
      var isArguments = baseIsArguments(function() {
        return arguments;
      }()) ? baseIsArguments : function(value) {
        return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
      };
      var isArray = Array2.isArray;
      var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
      function isArrayLike(value) {
        return value != null && isLength(value.length) && !isFunction(value);
      }
      function isArrayLikeObject(value) {
        return isObjectLike(value) && isArrayLike(value);
      }
      function isBoolean(value) {
        return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
      }
      var isBuffer = nativeIsBuffer || stubFalse;
      var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
      function isElement(value) {
        return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
      }
      function isEmpty(value) {
        if (value == null) {
          return true;
        }
        if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) {
          return !value.length;
        }
        var tag = getTag(value);
        if (tag == mapTag || tag == setTag) {
          return !value.size;
        }
        if (isPrototype(value)) {
          return !baseKeys(value).length;
        }
        for (var key in value) {
          if (hasOwnProperty.call(value, key)) {
            return false;
          }
        }
        return true;
      }
      function isEqual(value, other) {
        return baseIsEqual(value, other);
      }
      function isEqualWith(value, other, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$1;
        var result2 = customizer ? customizer(value, other) : undefined$1;
        return result2 === undefined$1 ? baseIsEqual(value, other, undefined$1, customizer) : !!result2;
      }
      function isError(value) {
        if (!isObjectLike(value)) {
          return false;
        }
        var tag = baseGetTag(value);
        return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject(value);
      }
      function isFinite(value) {
        return typeof value == "number" && nativeIsFinite(value);
      }
      function isFunction(value) {
        if (!isObject(value)) {
          return false;
        }
        var tag = baseGetTag(value);
        return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
      }
      function isInteger(value) {
        return typeof value == "number" && value == toInteger(value);
      }
      function isLength(value) {
        return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
      }
      function isObject(value) {
        var type = typeof value;
        return value != null && (type == "object" || type == "function");
      }
      function isObjectLike(value) {
        return value != null && typeof value == "object";
      }
      var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
      function isMatch(object, source) {
        return object === source || baseIsMatch(object, source, getMatchData(source));
      }
      function isMatchWith(object, source, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$1;
        return baseIsMatch(object, source, getMatchData(source), customizer);
      }
      function isNaN(value) {
        return isNumber(value) && value != +value;
      }
      function isNative(value) {
        if (isMaskable(value)) {
          throw new Error2(CORE_ERROR_TEXT);
        }
        return baseIsNative(value);
      }
      function isNull(value) {
        return value === null;
      }
      function isNil(value) {
        return value == null;
      }
      function isNumber(value) {
        return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
      }
      function isPlainObject(value) {
        if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
          return false;
        }
        var proto = getPrototype(value);
        if (proto === null) {
          return true;
        }
        var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
        return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
      }
      var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
      function isSafeInteger(value) {
        return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
      }
      var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
      function isString(value) {
        return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
      }
      function isSymbol(value) {
        return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
      }
      var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
      function isUndefined(value) {
        return value === undefined$1;
      }
      function isWeakMap(value) {
        return isObjectLike(value) && getTag(value) == weakMapTag;
      }
      function isWeakSet(value) {
        return isObjectLike(value) && baseGetTag(value) == weakSetTag;
      }
      var lt = createRelationalOperation(baseLt);
      var lte = createRelationalOperation(function(value, other) {
        return value <= other;
      });
      function toArray(value) {
        if (!value) {
          return [];
        }
        if (isArrayLike(value)) {
          return isString(value) ? stringToArray(value) : copyArray(value);
        }
        if (symIterator && value[symIterator]) {
          return iteratorToArray(value[symIterator]());
        }
        var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
        return func(value);
      }
      function toFinite(value) {
        if (!value) {
          return value === 0 ? value : 0;
        }
        value = toNumber(value);
        if (value === INFINITY || value === -INFINITY) {
          var sign = value < 0 ? -1 : 1;
          return sign * MAX_INTEGER;
        }
        return value === value ? value : 0;
      }
      function toInteger(value) {
        var result2 = toFinite(value), remainder = result2 % 1;
        return result2 === result2 ? remainder ? result2 - remainder : result2 : 0;
      }
      function toLength(value) {
        return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
      }
      function toNumber(value) {
        if (typeof value == "number") {
          return value;
        }
        if (isSymbol(value)) {
          return NAN;
        }
        if (isObject(value)) {
          var other = typeof value.valueOf == "function" ? value.valueOf() : value;
          value = isObject(other) ? other + "" : other;
        }
        if (typeof value != "string") {
          return value === 0 ? value : +value;
        }
        value = baseTrim(value);
        var isBinary = reIsBinary.test(value);
        return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
      }
      function toPlainObject(value) {
        return copyObject(value, keysIn(value));
      }
      function toSafeInteger(value) {
        return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
      }
      function toString(value) {
        return value == null ? "" : baseToString(value);
      }
      var assign = createAssigner(function(object, source) {
        if (isPrototype(source) || isArrayLike(source)) {
          copyObject(source, keys(source), object);
          return;
        }
        for (var key in source) {
          if (hasOwnProperty.call(source, key)) {
            assignValue(object, key, source[key]);
          }
        }
      });
      var assignIn = createAssigner(function(object, source) {
        copyObject(source, keysIn(source), object);
      });
      var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
        copyObject(source, keysIn(source), object, customizer);
      });
      var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
        copyObject(source, keys(source), object, customizer);
      });
      var at = flatRest(baseAt);
      function create(prototype, properties) {
        var result2 = baseCreate(prototype);
        return properties == null ? result2 : baseAssign(result2, properties);
      }
      var defaults = baseRest(function(object, sources) {
        object = Object2(object);
        var index2 = -1;
        var length = sources.length;
        var guard = length > 2 ? sources[2] : undefined$1;
        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          length = 1;
        }
        while (++index2 < length) {
          var source = sources[index2];
          var props = keysIn(source);
          var propsIndex = -1;
          var propsLength = props.length;
          while (++propsIndex < propsLength) {
            var key = props[propsIndex];
            var value = object[key];
            if (value === undefined$1 || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) {
              object[key] = source[key];
            }
          }
        }
        return object;
      });
      var defaultsDeep = baseRest(function(args) {
        args.push(undefined$1, customDefaultsMerge);
        return apply(mergeWith, undefined$1, args);
      });
      function findKey(object, predicate) {
        return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
      }
      function findLastKey(object, predicate) {
        return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
      }
      function forIn(object, iteratee2) {
        return object == null ? object : baseFor(object, getIteratee(iteratee2, 3), keysIn);
      }
      function forInRight(object, iteratee2) {
        return object == null ? object : baseForRight(object, getIteratee(iteratee2, 3), keysIn);
      }
      function forOwn(object, iteratee2) {
        return object && baseForOwn(object, getIteratee(iteratee2, 3));
      }
      function forOwnRight(object, iteratee2) {
        return object && baseForOwnRight(object, getIteratee(iteratee2, 3));
      }
      function functions(object) {
        return object == null ? [] : baseFunctions(object, keys(object));
      }
      function functionsIn(object) {
        return object == null ? [] : baseFunctions(object, keysIn(object));
      }
      function get(object, path, defaultValue) {
        var result2 = object == null ? undefined$1 : baseGet(object, path);
        return result2 === undefined$1 ? defaultValue : result2;
      }
      function has(object, path) {
        return object != null && hasPath(object, path, baseHas);
      }
      function hasIn(object, path) {
        return object != null && hasPath(object, path, baseHasIn);
      }
      var invert = createInverter(function(result2, value, key) {
        if (value != null && typeof value.toString != "function") {
          value = nativeObjectToString.call(value);
        }
        result2[value] = key;
      }, constant(identity));
      var invertBy = createInverter(function(result2, value, key) {
        if (value != null && typeof value.toString != "function") {
          value = nativeObjectToString.call(value);
        }
        if (hasOwnProperty.call(result2, value)) {
          result2[value].push(key);
        } else {
          result2[value] = [key];
        }
      }, getIteratee);
      var invoke = baseRest(baseInvoke);
      function keys(object) {
        return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
      }
      function keysIn(object) {
        return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
      }
      function mapKeys(object, iteratee2) {
        var result2 = {};
        iteratee2 = getIteratee(iteratee2, 3);
        baseForOwn(object, function(value, key, object2) {
          baseAssignValue(result2, iteratee2(value, key, object2), value);
        });
        return result2;
      }
      function mapValues(object, iteratee2) {
        var result2 = {};
        iteratee2 = getIteratee(iteratee2, 3);
        baseForOwn(object, function(value, key, object2) {
          baseAssignValue(result2, key, iteratee2(value, key, object2));
        });
        return result2;
      }
      var merge = createAssigner(function(object, source, srcIndex) {
        baseMerge(object, source, srcIndex);
      });
      var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
        baseMerge(object, source, srcIndex, customizer);
      });
      var omit = flatRest(function(object, paths) {
        var result2 = {};
        if (object == null) {
          return result2;
        }
        var isDeep = false;
        paths = arrayMap(paths, function(path) {
          path = castPath(path, object);
          isDeep || (isDeep = path.length > 1);
          return path;
        });
        copyObject(object, getAllKeysIn(object), result2);
        if (isDeep) {
          result2 = baseClone(result2, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
        }
        var length = paths.length;
        while (length--) {
          baseUnset(result2, paths[length]);
        }
        return result2;
      });
      function omitBy(object, predicate) {
        return pickBy(object, negate(getIteratee(predicate)));
      }
      var pick = flatRest(function(object, paths) {
        return object == null ? {} : basePick(object, paths);
      });
      function pickBy(object, predicate) {
        if (object == null) {
          return {};
        }
        var props = arrayMap(getAllKeysIn(object), function(prop) {
          return [prop];
        });
        predicate = getIteratee(predicate);
        return basePickBy(object, props, function(value, path) {
          return predicate(value, path[0]);
        });
      }
      function result(object, path, defaultValue) {
        path = castPath(path, object);
        var index2 = -1, length = path.length;
        if (!length) {
          length = 1;
          object = undefined$1;
        }
        while (++index2 < length) {
          var value = object == null ? undefined$1 : object[toKey(path[index2])];
          if (value === undefined$1) {
            index2 = length;
            value = defaultValue;
          }
          object = isFunction(value) ? value.call(object) : value;
        }
        return object;
      }
      function set(object, path, value) {
        return object == null ? object : baseSet(object, path, value);
      }
      function setWith(object, path, value, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$1;
        return object == null ? object : baseSet(object, path, value, customizer);
      }
      var toPairs = createToPairs(keys);
      var toPairsIn = createToPairs(keysIn);
      function transform(object, iteratee2, accumulator) {
        var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
        iteratee2 = getIteratee(iteratee2, 4);
        if (accumulator == null) {
          var Ctor = object && object.constructor;
          if (isArrLike) {
            accumulator = isArr ? new Ctor() : [];
          } else if (isObject(object)) {
            accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
          } else {
            accumulator = {};
          }
        }
        (isArrLike ? arrayEach : baseForOwn)(object, function(value, index2, object2) {
          return iteratee2(accumulator, value, index2, object2);
        });
        return accumulator;
      }
      function unset(object, path) {
        return object == null ? true : baseUnset(object, path);
      }
      function update(object, path, updater) {
        return object == null ? object : baseUpdate(object, path, castFunction(updater));
      }
      function updateWith(object, path, updater, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$1;
        return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
      }
      function values(object) {
        return object == null ? [] : baseValues(object, keys(object));
      }
      function valuesIn(object) {
        return object == null ? [] : baseValues(object, keysIn(object));
      }
      function clamp(number, lower, upper) {
        if (upper === undefined$1) {
          upper = lower;
          lower = undefined$1;
        }
        if (upper !== undefined$1) {
          upper = toNumber(upper);
          upper = upper === upper ? upper : 0;
        }
        if (lower !== undefined$1) {
          lower = toNumber(lower);
          lower = lower === lower ? lower : 0;
        }
        return baseClamp(toNumber(number), lower, upper);
      }
      function inRange(number, start, end) {
        start = toFinite(start);
        if (end === undefined$1) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        number = toNumber(number);
        return baseInRange(number, start, end);
      }
      function random(lower, upper, floating) {
        if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) {
          upper = floating = undefined$1;
        }
        if (floating === undefined$1) {
          if (typeof upper == "boolean") {
            floating = upper;
            upper = undefined$1;
          } else if (typeof lower == "boolean") {
            floating = lower;
            lower = undefined$1;
          }
        }
        if (lower === undefined$1 && upper === undefined$1) {
          lower = 0;
          upper = 1;
        } else {
          lower = toFinite(lower);
          if (upper === undefined$1) {
            upper = lower;
            lower = 0;
          } else {
            upper = toFinite(upper);
          }
        }
        if (lower > upper) {
          var temp = lower;
          lower = upper;
          upper = temp;
        }
        if (floating || lower % 1 || upper % 1) {
          var rand = nativeRandom();
          return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
        }
        return baseRandom(lower, upper);
      }
      var camelCase = createCompounder(function(result2, word, index2) {
        word = word.toLowerCase();
        return result2 + (index2 ? capitalize(word) : word);
      });
      function capitalize(string) {
        return upperFirst(toString(string).toLowerCase());
      }
      function deburr(string) {
        string = toString(string);
        return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
      }
      function endsWith(string, target, position) {
        string = toString(string);
        target = baseToString(target);
        var length = string.length;
        position = position === undefined$1 ? length : baseClamp(toInteger(position), 0, length);
        var end = position;
        position -= target.length;
        return position >= 0 && string.slice(position, end) == target;
      }
      function escape(string) {
        string = toString(string);
        return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
      }
      function escapeRegExp(string) {
        string = toString(string);
        return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string;
      }
      var kebabCase = createCompounder(function(result2, word, index2) {
        return result2 + (index2 ? "-" : "") + word.toLowerCase();
      });
      var lowerCase = createCompounder(function(result2, word, index2) {
        return result2 + (index2 ? " " : "") + word.toLowerCase();
      });
      var lowerFirst = createCaseFirst("toLowerCase");
      function pad(string, length, chars) {
        string = toString(string);
        length = toInteger(length);
        var strLength = length ? stringSize(string) : 0;
        if (!length || strLength >= length) {
          return string;
        }
        var mid = (length - strLength) / 2;
        return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
      }
      function padEnd(string, length, chars) {
        string = toString(string);
        length = toInteger(length);
        var strLength = length ? stringSize(string) : 0;
        return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
      }
      function padStart(string, length, chars) {
        string = toString(string);
        length = toInteger(length);
        var strLength = length ? stringSize(string) : 0;
        return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
      }
      function parseInt2(string, radix, guard) {
        if (guard || radix == null) {
          radix = 0;
        } else if (radix) {
          radix = +radix;
        }
        return nativeParseInt(toString(string).replace(reTrimStart, ""), radix || 0);
      }
      function repeat(string, n, guard) {
        if (guard ? isIterateeCall(string, n, guard) : n === undefined$1) {
          n = 1;
        } else {
          n = toInteger(n);
        }
        return baseRepeat(toString(string), n);
      }
      function replace() {
        var args = arguments, string = toString(args[0]);
        return args.length < 3 ? string : string.replace(args[1], args[2]);
      }
      var snakeCase = createCompounder(function(result2, word, index2) {
        return result2 + (index2 ? "_" : "") + word.toLowerCase();
      });
      function split(string, separator, limit) {
        if (limit && typeof limit != "number" && isIterateeCall(string, separator, limit)) {
          separator = limit = undefined$1;
        }
        limit = limit === undefined$1 ? MAX_ARRAY_LENGTH : limit >>> 0;
        if (!limit) {
          return [];
        }
        string = toString(string);
        if (string && (typeof separator == "string" || separator != null && !isRegExp(separator))) {
          separator = baseToString(separator);
          if (!separator && hasUnicode(string)) {
            return castSlice(stringToArray(string), 0, limit);
          }
        }
        return string.split(separator, limit);
      }
      var startCase = createCompounder(function(result2, word, index2) {
        return result2 + (index2 ? " " : "") + upperFirst(word);
      });
      function startsWith(string, target, position) {
        string = toString(string);
        position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
        target = baseToString(target);
        return string.slice(position, position + target.length) == target;
      }
      function template(string, options, guard) {
        var settings = lodash2.templateSettings;
        if (guard && isIterateeCall(string, options, guard)) {
          options = undefined$1;
        }
        string = toString(string);
        options = assignInWith({}, options, settings, customDefaultsAssignIn);
        var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
        var isEscaping, isEvaluating, index2 = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
        var reDelimiters = RegExp2(
          (options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$",
          "g"
        );
        var sourceURL = "//# sourceURL=" + (hasOwnProperty.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
        string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
          interpolateValue || (interpolateValue = esTemplateValue);
          source += string.slice(index2, offset).replace(reUnescapedString, escapeStringChar);
          if (escapeValue) {
            isEscaping = true;
            source += "' +\n__e(" + escapeValue + ") +\n'";
          }
          if (evaluateValue) {
            isEvaluating = true;
            source += "';\n" + evaluateValue + ";\n__p += '";
          }
          if (interpolateValue) {
            source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
          }
          index2 = offset + match.length;
          return match;
        });
        source += "';\n";
        var variable = hasOwnProperty.call(options, "variable") && options.variable;
        if (!variable) {
          source = "with (obj) {\n" + source + "\n}\n";
        } else if (reForbiddenIdentifierChars.test(variable)) {
          throw new Error2(INVALID_TEMPL_VAR_ERROR_TEXT);
        }
        source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
        source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
        var result2 = attempt(function() {
          return Function2(importsKeys, sourceURL + "return " + source).apply(undefined$1, importsValues);
        });
        result2.source = source;
        if (isError(result2)) {
          throw result2;
        }
        return result2;
      }
      function toLower(value) {
        return toString(value).toLowerCase();
      }
      function toUpper(value) {
        return toString(value).toUpperCase();
      }
      function trim(string, chars, guard) {
        string = toString(string);
        if (string && (guard || chars === undefined$1)) {
          return baseTrim(string);
        }
        if (!string || !(chars = baseToString(chars))) {
          return string;
        }
        var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
        return castSlice(strSymbols, start, end).join("");
      }
      function trimEnd(string, chars, guard) {
        string = toString(string);
        if (string && (guard || chars === undefined$1)) {
          return string.slice(0, trimmedEndIndex(string) + 1);
        }
        if (!string || !(chars = baseToString(chars))) {
          return string;
        }
        var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
        return castSlice(strSymbols, 0, end).join("");
      }
      function trimStart(string, chars, guard) {
        string = toString(string);
        if (string && (guard || chars === undefined$1)) {
          return string.replace(reTrimStart, "");
        }
        if (!string || !(chars = baseToString(chars))) {
          return string;
        }
        var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
        return castSlice(strSymbols, start).join("");
      }
      function truncate(string, options) {
        var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
        if (isObject(options)) {
          var separator = "separator" in options ? options.separator : separator;
          length = "length" in options ? toInteger(options.length) : length;
          omission = "omission" in options ? baseToString(options.omission) : omission;
        }
        string = toString(string);
        var strLength = string.length;
        if (hasUnicode(string)) {
          var strSymbols = stringToArray(string);
          strLength = strSymbols.length;
        }
        if (length >= strLength) {
          return string;
        }
        var end = length - stringSize(omission);
        if (end < 1) {
          return omission;
        }
        var result2 = strSymbols ? castSlice(strSymbols, 0, end).join("") : string.slice(0, end);
        if (separator === undefined$1) {
          return result2 + omission;
        }
        if (strSymbols) {
          end += result2.length - end;
        }
        if (isRegExp(separator)) {
          if (string.slice(end).search(separator)) {
            var match, substring = result2;
            if (!separator.global) {
              separator = RegExp2(separator.source, toString(reFlags.exec(separator)) + "g");
            }
            separator.lastIndex = 0;
            while (match = separator.exec(substring)) {
              var newEnd = match.index;
            }
            result2 = result2.slice(0, newEnd === undefined$1 ? end : newEnd);
          }
        } else if (string.indexOf(baseToString(separator), end) != end) {
          var index2 = result2.lastIndexOf(separator);
          if (index2 > -1) {
            result2 = result2.slice(0, index2);
          }
        }
        return result2 + omission;
      }
      function unescape(string) {
        string = toString(string);
        return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
      }
      var upperCase = createCompounder(function(result2, word, index2) {
        return result2 + (index2 ? " " : "") + word.toUpperCase();
      });
      var upperFirst = createCaseFirst("toUpperCase");
      function words(string, pattern, guard) {
        string = toString(string);
        pattern = guard ? undefined$1 : pattern;
        if (pattern === undefined$1) {
          return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
        }
        return string.match(pattern) || [];
      }
      var attempt = baseRest(function(func, args) {
        try {
          return apply(func, undefined$1, args);
        } catch (e) {
          return isError(e) ? e : new Error2(e);
        }
      });
      var bindAll = flatRest(function(object, methodNames) {
        arrayEach(methodNames, function(key) {
          key = toKey(key);
          baseAssignValue(object, key, bind(object[key], object));
        });
        return object;
      });
      function cond(pairs) {
        var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
        pairs = !length ? [] : arrayMap(pairs, function(pair) {
          if (typeof pair[1] != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          return [toIteratee(pair[0]), pair[1]];
        });
        return baseRest(function(args) {
          var index2 = -1;
          while (++index2 < length) {
            var pair = pairs[index2];
            if (apply(pair[0], this, args)) {
              return apply(pair[1], this, args);
            }
          }
        });
      }
      function conforms(source) {
        return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
      }
      function constant(value) {
        return function() {
          return value;
        };
      }
      function defaultTo(value, defaultValue) {
        return value == null || value !== value ? defaultValue : value;
      }
      var flow = createFlow();
      var flowRight = createFlow(true);
      function identity(value) {
        return value;
      }
      function iteratee(func) {
        return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
      }
      function matches(source) {
        return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
      }
      function matchesProperty(path, srcValue) {
        return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
      }
      var method = baseRest(function(path, args) {
        return function(object) {
          return baseInvoke(object, path, args);
        };
      });
      var methodOf = baseRest(function(object, args) {
        return function(path) {
          return baseInvoke(object, path, args);
        };
      });
      function mixin(object, source, options) {
        var props = keys(source), methodNames = baseFunctions(source, props);
        if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
          options = source;
          source = object;
          object = this;
          methodNames = baseFunctions(source, keys(source));
        }
        var chain2 = !(isObject(options) && "chain" in options) || !!options.chain, isFunc = isFunction(object);
        arrayEach(methodNames, function(methodName) {
          var func = source[methodName];
          object[methodName] = func;
          if (isFunc) {
            object.prototype[methodName] = function() {
              var chainAll = this.__chain__;
              if (chain2 || chainAll) {
                var result2 = object(this.__wrapped__), actions = result2.__actions__ = copyArray(this.__actions__);
                actions.push({ "func": func, "args": arguments, "thisArg": object });
                result2.__chain__ = chainAll;
                return result2;
              }
              return func.apply(object, arrayPush([this.value()], arguments));
            };
          }
        });
        return object;
      }
      function noConflict() {
        if (root._ === this) {
          root._ = oldDash;
        }
        return this;
      }
      function noop() {
      }
      function nthArg(n) {
        n = toInteger(n);
        return baseRest(function(args) {
          return baseNth(args, n);
        });
      }
      var over = createOver(arrayMap);
      var overEvery = createOver(arrayEvery);
      var overSome = createOver(arraySome);
      function property(path) {
        return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
      }
      function propertyOf(object) {
        return function(path) {
          return object == null ? undefined$1 : baseGet(object, path);
        };
      }
      var range = createRange();
      var rangeRight = createRange(true);
      function stubArray() {
        return [];
      }
      function stubFalse() {
        return false;
      }
      function stubObject() {
        return {};
      }
      function stubString() {
        return "";
      }
      function stubTrue() {
        return true;
      }
      function times(n, iteratee2) {
        n = toInteger(n);
        if (n < 1 || n > MAX_SAFE_INTEGER) {
          return [];
        }
        var index2 = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
        iteratee2 = getIteratee(iteratee2);
        n -= MAX_ARRAY_LENGTH;
        var result2 = baseTimes(length, iteratee2);
        while (++index2 < n) {
          iteratee2(index2);
        }
        return result2;
      }
      function toPath(value) {
        if (isArray(value)) {
          return arrayMap(value, toKey);
        }
        return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
      }
      function uniqueId(prefix) {
        var id = ++idCounter;
        return toString(prefix) + id;
      }
      var add = createMathOperation(function(augend, addend) {
        return augend + addend;
      }, 0);
      var ceil = createRound("ceil");
      var divide = createMathOperation(function(dividend, divisor) {
        return dividend / divisor;
      }, 1);
      var floor = createRound("floor");
      function max(array) {
        return array && array.length ? baseExtremum(array, identity, baseGt) : undefined$1;
      }
      function maxBy(array, iteratee2) {
        return array && array.length ? baseExtremum(array, getIteratee(iteratee2, 2), baseGt) : undefined$1;
      }
      function mean(array) {
        return baseMean(array, identity);
      }
      function meanBy(array, iteratee2) {
        return baseMean(array, getIteratee(iteratee2, 2));
      }
      function min(array) {
        return array && array.length ? baseExtremum(array, identity, baseLt) : undefined$1;
      }
      function minBy(array, iteratee2) {
        return array && array.length ? baseExtremum(array, getIteratee(iteratee2, 2), baseLt) : undefined$1;
      }
      var multiply = createMathOperation(function(multiplier, multiplicand) {
        return multiplier * multiplicand;
      }, 1);
      var round = createRound("round");
      var subtract = createMathOperation(function(minuend, subtrahend) {
        return minuend - subtrahend;
      }, 0);
      function sum(array) {
        return array && array.length ? baseSum(array, identity) : 0;
      }
      function sumBy(array, iteratee2) {
        return array && array.length ? baseSum(array, getIteratee(iteratee2, 2)) : 0;
      }
      lodash2.after = after;
      lodash2.ary = ary;
      lodash2.assign = assign;
      lodash2.assignIn = assignIn;
      lodash2.assignInWith = assignInWith;
      lodash2.assignWith = assignWith;
      lodash2.at = at;
      lodash2.before = before;
      lodash2.bind = bind;
      lodash2.bindAll = bindAll;
      lodash2.bindKey = bindKey;
      lodash2.castArray = castArray;
      lodash2.chain = chain;
      lodash2.chunk = chunk;
      lodash2.compact = compact;
      lodash2.concat = concat;
      lodash2.cond = cond;
      lodash2.conforms = conforms;
      lodash2.constant = constant;
      lodash2.countBy = countBy;
      lodash2.create = create;
      lodash2.curry = curry;
      lodash2.curryRight = curryRight;
      lodash2.debounce = debounce;
      lodash2.defaults = defaults;
      lodash2.defaultsDeep = defaultsDeep;
      lodash2.defer = defer;
      lodash2.delay = delay;
      lodash2.difference = difference;
      lodash2.differenceBy = differenceBy;
      lodash2.differenceWith = differenceWith;
      lodash2.drop = drop;
      lodash2.dropRight = dropRight;
      lodash2.dropRightWhile = dropRightWhile;
      lodash2.dropWhile = dropWhile;
      lodash2.fill = fill;
      lodash2.filter = filter;
      lodash2.flatMap = flatMap;
      lodash2.flatMapDeep = flatMapDeep;
      lodash2.flatMapDepth = flatMapDepth;
      lodash2.flatten = flatten;
      lodash2.flattenDeep = flattenDeep;
      lodash2.flattenDepth = flattenDepth;
      lodash2.flip = flip;
      lodash2.flow = flow;
      lodash2.flowRight = flowRight;
      lodash2.fromPairs = fromPairs;
      lodash2.functions = functions;
      lodash2.functionsIn = functionsIn;
      lodash2.groupBy = groupBy;
      lodash2.initial = initial;
      lodash2.intersection = intersection;
      lodash2.intersectionBy = intersectionBy;
      lodash2.intersectionWith = intersectionWith;
      lodash2.invert = invert;
      lodash2.invertBy = invertBy;
      lodash2.invokeMap = invokeMap;
      lodash2.iteratee = iteratee;
      lodash2.keyBy = keyBy;
      lodash2.keys = keys;
      lodash2.keysIn = keysIn;
      lodash2.map = map;
      lodash2.mapKeys = mapKeys;
      lodash2.mapValues = mapValues;
      lodash2.matches = matches;
      lodash2.matchesProperty = matchesProperty;
      lodash2.memoize = memoize;
      lodash2.merge = merge;
      lodash2.mergeWith = mergeWith;
      lodash2.method = method;
      lodash2.methodOf = methodOf;
      lodash2.mixin = mixin;
      lodash2.negate = negate;
      lodash2.nthArg = nthArg;
      lodash2.omit = omit;
      lodash2.omitBy = omitBy;
      lodash2.once = once;
      lodash2.orderBy = orderBy;
      lodash2.over = over;
      lodash2.overArgs = overArgs;
      lodash2.overEvery = overEvery;
      lodash2.overSome = overSome;
      lodash2.partial = partial;
      lodash2.partialRight = partialRight;
      lodash2.partition = partition;
      lodash2.pick = pick;
      lodash2.pickBy = pickBy;
      lodash2.property = property;
      lodash2.propertyOf = propertyOf;
      lodash2.pull = pull;
      lodash2.pullAll = pullAll;
      lodash2.pullAllBy = pullAllBy;
      lodash2.pullAllWith = pullAllWith;
      lodash2.pullAt = pullAt;
      lodash2.range = range;
      lodash2.rangeRight = rangeRight;
      lodash2.rearg = rearg;
      lodash2.reject = reject;
      lodash2.remove = remove;
      lodash2.rest = rest;
      lodash2.reverse = reverse;
      lodash2.sampleSize = sampleSize;
      lodash2.set = set;
      lodash2.setWith = setWith;
      lodash2.shuffle = shuffle;
      lodash2.slice = slice;
      lodash2.sortBy = sortBy;
      lodash2.sortedUniq = sortedUniq;
      lodash2.sortedUniqBy = sortedUniqBy;
      lodash2.split = split;
      lodash2.spread = spread;
      lodash2.tail = tail;
      lodash2.take = take;
      lodash2.takeRight = takeRight;
      lodash2.takeRightWhile = takeRightWhile;
      lodash2.takeWhile = takeWhile;
      lodash2.tap = tap;
      lodash2.throttle = throttle;
      lodash2.thru = thru;
      lodash2.toArray = toArray;
      lodash2.toPairs = toPairs;
      lodash2.toPairsIn = toPairsIn;
      lodash2.toPath = toPath;
      lodash2.toPlainObject = toPlainObject;
      lodash2.transform = transform;
      lodash2.unary = unary;
      lodash2.union = union;
      lodash2.unionBy = unionBy;
      lodash2.unionWith = unionWith;
      lodash2.uniq = uniq;
      lodash2.uniqBy = uniqBy;
      lodash2.uniqWith = uniqWith;
      lodash2.unset = unset;
      lodash2.unzip = unzip;
      lodash2.unzipWith = unzipWith;
      lodash2.update = update;
      lodash2.updateWith = updateWith;
      lodash2.values = values;
      lodash2.valuesIn = valuesIn;
      lodash2.without = without;
      lodash2.words = words;
      lodash2.wrap = wrap;
      lodash2.xor = xor;
      lodash2.xorBy = xorBy;
      lodash2.xorWith = xorWith;
      lodash2.zip = zip;
      lodash2.zipObject = zipObject;
      lodash2.zipObjectDeep = zipObjectDeep;
      lodash2.zipWith = zipWith;
      lodash2.entries = toPairs;
      lodash2.entriesIn = toPairsIn;
      lodash2.extend = assignIn;
      lodash2.extendWith = assignInWith;
      mixin(lodash2, lodash2);
      lodash2.add = add;
      lodash2.attempt = attempt;
      lodash2.camelCase = camelCase;
      lodash2.capitalize = capitalize;
      lodash2.ceil = ceil;
      lodash2.clamp = clamp;
      lodash2.clone = clone;
      lodash2.cloneDeep = cloneDeep;
      lodash2.cloneDeepWith = cloneDeepWith;
      lodash2.cloneWith = cloneWith;
      lodash2.conformsTo = conformsTo;
      lodash2.deburr = deburr;
      lodash2.defaultTo = defaultTo;
      lodash2.divide = divide;
      lodash2.endsWith = endsWith;
      lodash2.eq = eq;
      lodash2.escape = escape;
      lodash2.escapeRegExp = escapeRegExp;
      lodash2.every = every;
      lodash2.find = find;
      lodash2.findIndex = findIndex;
      lodash2.findKey = findKey;
      lodash2.findLast = findLast;
      lodash2.findLastIndex = findLastIndex;
      lodash2.findLastKey = findLastKey;
      lodash2.floor = floor;
      lodash2.forEach = forEach;
      lodash2.forEachRight = forEachRight;
      lodash2.forIn = forIn;
      lodash2.forInRight = forInRight;
      lodash2.forOwn = forOwn;
      lodash2.forOwnRight = forOwnRight;
      lodash2.get = get;
      lodash2.gt = gt;
      lodash2.gte = gte;
      lodash2.has = has;
      lodash2.hasIn = hasIn;
      lodash2.head = head;
      lodash2.identity = identity;
      lodash2.includes = includes;
      lodash2.indexOf = indexOf;
      lodash2.inRange = inRange;
      lodash2.invoke = invoke;
      lodash2.isArguments = isArguments;
      lodash2.isArray = isArray;
      lodash2.isArrayBuffer = isArrayBuffer;
      lodash2.isArrayLike = isArrayLike;
      lodash2.isArrayLikeObject = isArrayLikeObject;
      lodash2.isBoolean = isBoolean;
      lodash2.isBuffer = isBuffer;
      lodash2.isDate = isDate;
      lodash2.isElement = isElement;
      lodash2.isEmpty = isEmpty;
      lodash2.isEqual = isEqual;
      lodash2.isEqualWith = isEqualWith;
      lodash2.isError = isError;
      lodash2.isFinite = isFinite;
      lodash2.isFunction = isFunction;
      lodash2.isInteger = isInteger;
      lodash2.isLength = isLength;
      lodash2.isMap = isMap;
      lodash2.isMatch = isMatch;
      lodash2.isMatchWith = isMatchWith;
      lodash2.isNaN = isNaN;
      lodash2.isNative = isNative;
      lodash2.isNil = isNil;
      lodash2.isNull = isNull;
      lodash2.isNumber = isNumber;
      lodash2.isObject = isObject;
      lodash2.isObjectLike = isObjectLike;
      lodash2.isPlainObject = isPlainObject;
      lodash2.isRegExp = isRegExp;
      lodash2.isSafeInteger = isSafeInteger;
      lodash2.isSet = isSet;
      lodash2.isString = isString;
      lodash2.isSymbol = isSymbol;
      lodash2.isTypedArray = isTypedArray;
      lodash2.isUndefined = isUndefined;
      lodash2.isWeakMap = isWeakMap;
      lodash2.isWeakSet = isWeakSet;
      lodash2.join = join;
      lodash2.kebabCase = kebabCase;
      lodash2.last = last;
      lodash2.lastIndexOf = lastIndexOf;
      lodash2.lowerCase = lowerCase;
      lodash2.lowerFirst = lowerFirst;
      lodash2.lt = lt;
      lodash2.lte = lte;
      lodash2.max = max;
      lodash2.maxBy = maxBy;
      lodash2.mean = mean;
      lodash2.meanBy = meanBy;
      lodash2.min = min;
      lodash2.minBy = minBy;
      lodash2.stubArray = stubArray;
      lodash2.stubFalse = stubFalse;
      lodash2.stubObject = stubObject;
      lodash2.stubString = stubString;
      lodash2.stubTrue = stubTrue;
      lodash2.multiply = multiply;
      lodash2.nth = nth;
      lodash2.noConflict = noConflict;
      lodash2.noop = noop;
      lodash2.now = now;
      lodash2.pad = pad;
      lodash2.padEnd = padEnd;
      lodash2.padStart = padStart;
      lodash2.parseInt = parseInt2;
      lodash2.random = random;
      lodash2.reduce = reduce;
      lodash2.reduceRight = reduceRight;
      lodash2.repeat = repeat;
      lodash2.replace = replace;
      lodash2.result = result;
      lodash2.round = round;
      lodash2.runInContext = runInContext2;
      lodash2.sample = sample;
      lodash2.size = size2;
      lodash2.snakeCase = snakeCase;
      lodash2.some = some;
      lodash2.sortedIndex = sortedIndex;
      lodash2.sortedIndexBy = sortedIndexBy;
      lodash2.sortedIndexOf = sortedIndexOf;
      lodash2.sortedLastIndex = sortedLastIndex;
      lodash2.sortedLastIndexBy = sortedLastIndexBy;
      lodash2.sortedLastIndexOf = sortedLastIndexOf;
      lodash2.startCase = startCase;
      lodash2.startsWith = startsWith;
      lodash2.subtract = subtract;
      lodash2.sum = sum;
      lodash2.sumBy = sumBy;
      lodash2.template = template;
      lodash2.times = times;
      lodash2.toFinite = toFinite;
      lodash2.toInteger = toInteger;
      lodash2.toLength = toLength;
      lodash2.toLower = toLower;
      lodash2.toNumber = toNumber;
      lodash2.toSafeInteger = toSafeInteger;
      lodash2.toString = toString;
      lodash2.toUpper = toUpper;
      lodash2.trim = trim;
      lodash2.trimEnd = trimEnd;
      lodash2.trimStart = trimStart;
      lodash2.truncate = truncate;
      lodash2.unescape = unescape;
      lodash2.uniqueId = uniqueId;
      lodash2.upperCase = upperCase;
      lodash2.upperFirst = upperFirst;
      lodash2.each = forEach;
      lodash2.eachRight = forEachRight;
      lodash2.first = head;
      mixin(lodash2, function() {
        var source = {};
        baseForOwn(lodash2, function(func, methodName) {
          if (!hasOwnProperty.call(lodash2.prototype, methodName)) {
            source[methodName] = func;
          }
        });
        return source;
      }(), { "chain": false });
      lodash2.VERSION = VERSION;
      arrayEach(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(methodName) {
        lodash2[methodName].placeholder = lodash2;
      });
      arrayEach(["drop", "take"], function(methodName, index2) {
        LazyWrapper.prototype[methodName] = function(n) {
          n = n === undefined$1 ? 1 : nativeMax(toInteger(n), 0);
          var result2 = this.__filtered__ && !index2 ? new LazyWrapper(this) : this.clone();
          if (result2.__filtered__) {
            result2.__takeCount__ = nativeMin(n, result2.__takeCount__);
          } else {
            result2.__views__.push({
              "size": nativeMin(n, MAX_ARRAY_LENGTH),
              "type": methodName + (result2.__dir__ < 0 ? "Right" : "")
            });
          }
          return result2;
        };
        LazyWrapper.prototype[methodName + "Right"] = function(n) {
          return this.reverse()[methodName](n).reverse();
        };
      });
      arrayEach(["filter", "map", "takeWhile"], function(methodName, index2) {
        var type = index2 + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
        LazyWrapper.prototype[methodName] = function(iteratee2) {
          var result2 = this.clone();
          result2.__iteratees__.push({
            "iteratee": getIteratee(iteratee2, 3),
            "type": type
          });
          result2.__filtered__ = result2.__filtered__ || isFilter;
          return result2;
        };
      });
      arrayEach(["head", "last"], function(methodName, index2) {
        var takeName = "take" + (index2 ? "Right" : "");
        LazyWrapper.prototype[methodName] = function() {
          return this[takeName](1).value()[0];
        };
      });
      arrayEach(["initial", "tail"], function(methodName, index2) {
        var dropName = "drop" + (index2 ? "" : "Right");
        LazyWrapper.prototype[methodName] = function() {
          return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
        };
      });
      LazyWrapper.prototype.compact = function() {
        return this.filter(identity);
      };
      LazyWrapper.prototype.find = function(predicate) {
        return this.filter(predicate).head();
      };
      LazyWrapper.prototype.findLast = function(predicate) {
        return this.reverse().find(predicate);
      };
      LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
        if (typeof path == "function") {
          return new LazyWrapper(this);
        }
        return this.map(function(value) {
          return baseInvoke(value, path, args);
        });
      });
      LazyWrapper.prototype.reject = function(predicate) {
        return this.filter(negate(getIteratee(predicate)));
      };
      LazyWrapper.prototype.slice = function(start, end) {
        start = toInteger(start);
        var result2 = this;
        if (result2.__filtered__ && (start > 0 || end < 0)) {
          return new LazyWrapper(result2);
        }
        if (start < 0) {
          result2 = result2.takeRight(-start);
        } else if (start) {
          result2 = result2.drop(start);
        }
        if (end !== undefined$1) {
          end = toInteger(end);
          result2 = end < 0 ? result2.dropRight(-end) : result2.take(end - start);
        }
        return result2;
      };
      LazyWrapper.prototype.takeRightWhile = function(predicate) {
        return this.reverse().takeWhile(predicate).reverse();
      };
      LazyWrapper.prototype.toArray = function() {
        return this.take(MAX_ARRAY_LENGTH);
      };
      baseForOwn(LazyWrapper.prototype, function(func, methodName) {
        var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash2[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
        if (!lodashFunc) {
          return;
        }
        lodash2.prototype[methodName] = function() {
          var value = this.__wrapped__, args = isTaker ? [1] : arguments, isLazy = value instanceof LazyWrapper, iteratee2 = args[0], useLazy = isLazy || isArray(value);
          var interceptor = function(value2) {
            var result3 = lodashFunc.apply(lodash2, arrayPush([value2], args));
            return isTaker && chainAll ? result3[0] : result3;
          };
          if (useLazy && checkIteratee && typeof iteratee2 == "function" && iteratee2.length != 1) {
            isLazy = useLazy = false;
          }
          var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
          if (!retUnwrapped && useLazy) {
            value = onlyLazy ? value : new LazyWrapper(this);
            var result2 = func.apply(value, args);
            result2.__actions__.push({ "func": thru, "args": [interceptor], "thisArg": undefined$1 });
            return new LodashWrapper(result2, chainAll);
          }
          if (isUnwrapped && onlyLazy) {
            return func.apply(this, args);
          }
          result2 = this.thru(interceptor);
          return isUnwrapped ? isTaker ? result2.value()[0] : result2.value() : result2;
        };
      });
      arrayEach(["pop", "push", "shift", "sort", "splice", "unshift"], function(methodName) {
        var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
        lodash2.prototype[methodName] = function() {
          var args = arguments;
          if (retUnwrapped && !this.__chain__) {
            var value = this.value();
            return func.apply(isArray(value) ? value : [], args);
          }
          return this[chainName](function(value2) {
            return func.apply(isArray(value2) ? value2 : [], args);
          });
        };
      });
      baseForOwn(LazyWrapper.prototype, function(func, methodName) {
        var lodashFunc = lodash2[methodName];
        if (lodashFunc) {
          var key = lodashFunc.name + "";
          if (!hasOwnProperty.call(realNames, key)) {
            realNames[key] = [];
          }
          realNames[key].push({ "name": methodName, "func": lodashFunc });
        }
      });
      realNames[createHybrid(undefined$1, WRAP_BIND_KEY_FLAG).name] = [{
        "name": "wrapper",
        "func": undefined$1
      }];
      LazyWrapper.prototype.clone = lazyClone;
      LazyWrapper.prototype.reverse = lazyReverse;
      LazyWrapper.prototype.value = lazyValue;
      lodash2.prototype.at = wrapperAt;
      lodash2.prototype.chain = wrapperChain;
      lodash2.prototype.commit = wrapperCommit;
      lodash2.prototype.next = wrapperNext;
      lodash2.prototype.plant = wrapperPlant;
      lodash2.prototype.reverse = wrapperReverse;
      lodash2.prototype.toJSON = lodash2.prototype.valueOf = lodash2.prototype.value = wrapperValue;
      lodash2.prototype.first = lodash2.prototype.head;
      if (symIterator) {
        lodash2.prototype[symIterator] = wrapperToIterator;
      }
      return lodash2;
    };
    var _ = runInContext();
    if (freeModule) {
      (freeModule.exports = _)._ = _;
      freeExports._ = _;
    } else {
      root._ = _;
    }
  }).call(commonjsGlobal);
})(lodash, lodash.exports);
var lodashExports = lodash.exports;
const semantic$2 = {
  bg: {
    brand: {
      value: "rgba(41, 200, 147, 1)",
      type: "color",
      description: "lt-sys-color-bg-brand\n\naction, brand, button, primary, app, tint, background",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#29c893",
        type: "color",
        description: "lt-sys-color-bg-brand\n\naction, brand, button, primary, app, tint, background"
      },
      name: "sd-semantic-bg-brand",
      attributes: {},
      path: [
        "semantic",
        "bg",
        "brand"
      ]
    },
    "brand-secondary": {
      value: "rgba(41, 200, 147, 0.1607843137254902)",
      type: "color",
      description: "lt-sys-color-bg-brand-secondary\n\n\naction, brand, button, primary, app, tint, opacity, background",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#29c89329",
        type: "color",
        description: "lt-sys-color-bg-brand-secondary\n\n\naction, brand, button, primary, app, tint, opacity, background"
      },
      name: "sd-semantic-bg-brand-secondary",
      attributes: {},
      path: [
        "semantic",
        "bg",
        "brand-secondary"
      ]
    },
    primary: {
      value: "rgba(252, 252, 253, 1)",
      type: "color",
      description: "token = lh-semantic-color-bg-primary\n\nmid, level01, screen, background primary, default",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#fcfcfd",
        type: "color",
        description: "token = lh-semantic-color-bg-primary\n\nmid, level01, screen, background primary, default"
      },
      name: "sd-semantic-bg-primary",
      attributes: {},
      path: [
        "semantic",
        "bg",
        "primary"
      ]
    },
    secondary: {
      value: "rgba(255, 255, 255, 1)",
      type: "color",
      description: "token = lh-semantic-color-bg-secondary\n\ntoolbar, card, surface, level02, background secondary",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#ffffff",
        type: "color",
        description: "token = lh-semantic-color-bg-secondary\n\ntoolbar, card, surface, level02, background secondary"
      },
      name: "sd-semantic-bg-secondary",
      attributes: {},
      path: [
        "semantic",
        "bg",
        "secondary"
      ]
    },
    tertiary: {
      value: "rgba(243, 244, 246, 1)",
      type: "color",
      description: "token = lh-semantic-color-bg-tertiary\n\nbase, canvas, editor, alt, background tertiary",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#f3f4f6",
        type: "color",
        description: "token = lh-semantic-color-bg-tertiary\n\nbase, canvas, editor, alt, background tertiary"
      },
      name: "sd-semantic-bg-tertiary",
      attributes: {},
      path: [
        "semantic",
        "bg",
        "tertiary"
      ]
    },
    alpha: {
      value: "rgba(0, 0, 0, 0.0392156862745098)",
      type: "color",
      description: "token = lh-semantic-color-bg-alpha\n\non-card, plus level, transparent, separator",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#0000000a",
        type: "color",
        description: "token = lh-semantic-color-bg-alpha\n\non-card, plus level, transparent, separator"
      },
      name: "sd-semantic-bg-alpha",
      attributes: {},
      path: [
        "semantic",
        "bg",
        "alpha"
      ]
    },
    "alpha-secondary": {
      value: "rgba(0, 0, 0, 0.4)",
      type: "color",
      description: "token = lh-semantic-color-bg-alpha-secondary\n\nbackdrop, blanket, overlay, drawer, translucent",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#00000066",
        type: "color",
        description: "token = lh-semantic-color-bg-alpha-secondary\n\nbackdrop, blanket, overlay, drawer, translucent"
      },
      name: "sd-semantic-bg-alpha-secondary",
      attributes: {},
      path: [
        "semantic",
        "bg",
        "alpha-secondary"
      ]
    },
    inverse: {
      value: "rgba(22, 23, 25, 1)",
      type: "color",
      description: "token = lh-semantic-color-bg-inverse\n\ninverse, mid, level01, screen, background",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#161719",
        type: "color",
        description: "token = lh-semantic-color-bg-inverse\n\ninverse, mid, level01, screen, background"
      },
      name: "sd-semantic-bg-inverse",
      attributes: {},
      path: [
        "semantic",
        "bg",
        "inverse"
      ]
    },
    neutral: {
      value: "rgba(44, 45, 48, 1)",
      type: "color",
      description: "token = lh-semantic-color-bg-neutral\n\naction, neutral, background, button",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#2c2d30",
        type: "color",
        description: "token = lh-semantic-color-bg-neutral\n\naction, neutral, background, button"
      },
      name: "sd-semantic-bg-neutral",
      attributes: {},
      path: [
        "semantic",
        "bg",
        "neutral"
      ]
    },
    "neutral-secondary": {
      value: "rgba(44, 45, 48, 0.12156862745098039)",
      type: "color",
      description: "token = lh-semantic-color-bg-neutral-secondary\n\naction, neutral, opacity, translucent, background, button",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#2c2d301f",
        type: "color",
        description: "token = lh-semantic-color-bg-neutral-secondary\n\naction, neutral, opacity, translucent, background, button"
      },
      name: "sd-semantic-bg-neutral-secondary",
      attributes: {},
      path: [
        "semantic",
        "bg",
        "neutral-secondary"
      ]
    },
    disabled: {
      value: "rgba(163, 166, 172, 0.5019607843137255)",
      type: "color",
      description: "token = lh-semantic-color-bg-disabled\n\ndisabled, action, button",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#a3a6ac80",
        type: "color",
        description: "token = lh-semantic-color-bg-disabled\n\ndisabled, action, button"
      },
      name: "sd-semantic-bg-disabled",
      attributes: {},
      path: [
        "semantic",
        "bg",
        "disabled"
      ]
    },
    "disabled-secondary": {
      value: "rgba(163, 166, 172, 0.10196078431372549)",
      type: "color",
      description: "token = lh-semantic-color-bg-disabled-secondary\n\ndisabled, action, transparent",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#a3a6ac1a",
        type: "color",
        description: "token = lh-semantic-color-bg-disabled-secondary\n\ndisabled, action, transparent"
      },
      name: "sd-semantic-bg-disabled-secondary",
      attributes: {},
      path: [
        "semantic",
        "bg",
        "disabled-secondary"
      ]
    },
    "neutral-inverse": {
      value: "rgba(230, 231, 233, 1)",
      type: "color",
      description: "token = lh-semantic-color-bg-neutral-inverse\n\naction, neutral, inverse,",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#e6e7e9",
        type: "color",
        description: "token = lh-semantic-color-bg-neutral-inverse\n\naction, neutral, inverse,"
      },
      name: "sd-semantic-bg-neutral-inverse",
      attributes: {},
      path: [
        "semantic",
        "bg",
        "neutral-inverse"
      ]
    },
    "neutral-inverse-secondary": {
      value: "rgba(230, 231, 233, 0.0784313725490196)",
      type: "color",
      description: "lt-sys-color-bg-neutral-inverse-secondary\n\naction, neutral, inverse, opacity, translucent",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#e6e7e914",
        type: "color",
        description: "lt-sys-color-bg-neutral-inverse-secondary\n\naction, neutral, inverse, opacity, translucent"
      },
      name: "sd-semantic-bg-neutral-inverse-secondary",
      attributes: {},
      path: [
        "semantic",
        "bg",
        "neutral-inverse-secondary"
      ]
    },
    danger: {
      value: "rgba(255, 59, 48, 1)",
      type: "color",
      description: "token = lh-semantic-color-bg-danger\n\ndestructive, danger, error, action, delete",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#ff3b30",
        type: "color",
        description: "token = lh-semantic-color-bg-danger\n\ndestructive, danger, error, action, delete"
      },
      name: "sd-semantic-bg-danger",
      attributes: {},
      path: [
        "semantic",
        "bg",
        "danger"
      ]
    },
    "danger-secondary": {
      value: "rgba(255, 59, 48, 0.12156862745098039)",
      type: "color",
      description: "token = lh-semantic-color-bg-danger-secondary\n\ndestructive, danger, error, action, delete, opacity",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#ff3b301f",
        type: "color",
        description: "token = lh-semantic-color-bg-danger-secondary\n\ndestructive, danger, error, action, delete, opacity"
      },
      name: "sd-semantic-bg-danger-secondary",
      attributes: {},
      path: [
        "semantic",
        "bg",
        "danger-secondary"
      ]
    },
    success: {
      value: "rgba(22, 163, 74, 1)",
      type: "color",
      description: "token = lh-semantic-color-bg-success\n\nsuccess, positive, action, approved",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#16a34a",
        type: "color",
        description: "token = lh-semantic-color-bg-success\n\nsuccess, positive, action, approved"
      },
      name: "sd-semantic-bg-success",
      attributes: {},
      path: [
        "semantic",
        "bg",
        "success"
      ]
    },
    "success-secondary": {
      value: "rgba(22, 163, 74, 0.12156862745098039)",
      type: "color",
      description: "token = lh-semantic-color-bg-success-secondary\n\nsuccess, positive, action, approved, opacity",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#16a34a1f",
        type: "color",
        description: "token = lh-semantic-color-bg-success-secondary\n\nsuccess, positive, action, approved, opacity"
      },
      name: "sd-semantic-bg-success-secondary",
      attributes: {},
      path: [
        "semantic",
        "bg",
        "success-secondary"
      ]
    },
    warning: {
      value: "rgba(235, 172, 19, 1)",
      type: "color",
      description: "token = lh-semantic-color-bg-warning\n\nwarning, careful, action, caution",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#ebac13",
        type: "color",
        description: "token = lh-semantic-color-bg-warning\n\nwarning, careful, action, caution"
      },
      name: "sd-semantic-bg-warning",
      attributes: {},
      path: [
        "semantic",
        "bg",
        "warning"
      ]
    },
    "warning-secondary": {
      value: "rgba(235, 172, 19, 0.12156862745098039)",
      type: "color",
      description: "token = lh-semantic-color-bg-warning-secondary\n\nwarning, careful, action, caution",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#ebac131f",
        type: "color",
        description: "token = lh-semantic-color-bg-warning-secondary\n\nwarning, careful, action, caution"
      },
      name: "sd-semantic-bg-warning-secondary",
      attributes: {},
      path: [
        "semantic",
        "bg",
        "warning-secondary"
      ]
    },
    transparent: {
      value: "rgba(255, 255, 255, 0)",
      type: "color",
      description: "token = lh-semantic-color-bg-transparent\n\nconstant, transparent",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#ffffff00",
        type: "color",
        description: "token = lh-semantic-color-bg-transparent\n\nconstant, transparent"
      },
      name: "sd-semantic-bg-transparent",
      attributes: {},
      path: [
        "semantic",
        "bg",
        "transparent"
      ]
    },
    white: {
      value: "rgba(255, 255, 255, 1)",
      type: "color",
      description: "token = lh-semantic-color-bg-white\n\nconstant, white",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#ffffff",
        type: "color",
        description: "token = lh-semantic-color-bg-white\n\nconstant, white"
      },
      name: "sd-semantic-bg-white",
      attributes: {},
      path: [
        "semantic",
        "bg",
        "white"
      ]
    },
    "white-secondary": {
      value: "rgba(255, 255, 255, 0.12156862745098039)",
      type: "color",
      description: "token = lh-semantic-color-bg-white-secondary\n\nconstant, white",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#ffffff1f",
        type: "color",
        description: "token = lh-semantic-color-bg-white-secondary\n\nconstant, white"
      },
      name: "sd-semantic-bg-white-secondary",
      attributes: {},
      path: [
        "semantic",
        "bg",
        "white-secondary"
      ]
    },
    black: {
      value: "rgba(0, 0, 0, 1)",
      type: "color",
      description: "token = lh-semantic-color-bg-black\n\nconstant, black",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#000000",
        type: "color",
        description: "token = lh-semantic-color-bg-black\n\nconstant, black"
      },
      name: "sd-semantic-bg-black",
      attributes: {},
      path: [
        "semantic",
        "bg",
        "black"
      ]
    },
    "black-secondary": {
      value: "rgba(0, 0, 0, 0.30196078431372547)",
      type: "color",
      description: "token = lh-semantic-color-bg-black-secondary\n\nconstant, black",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#0000004d",
        type: "color",
        description: "token = lh-semantic-color-bg-black-secondary\n\nconstant, black"
      },
      name: "sd-semantic-bg-black-secondary",
      attributes: {},
      path: [
        "semantic",
        "bg",
        "black-secondary"
      ]
    }
  },
  fg: {
    brand: {
      value: "rgba(41, 200, 147, 1)",
      type: "color",
      description: "lt-sys-color-fg-brand\n\n\naction, brand, primary, app, contrast, text, icon",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#29c893",
        type: "color",
        description: "lt-sys-color-fg-brand\n\n\naction, brand, primary, app, contrast, text, icon"
      },
      name: "sd-semantic-fg-brand",
      attributes: {},
      path: [
        "semantic",
        "fg",
        "brand"
      ]
    },
    "brand-secondary": {
      value: "rgba(16, 119, 88, 1)",
      type: "color",
      description: "lt-sys-color-fg-brand-secondary\n\naction, brand, primary, app, contrast, highlight",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#107758",
        type: "color",
        description: "lt-sys-color-fg-brand-secondary\n\naction, brand, primary, app, contrast, highlight"
      },
      name: "sd-semantic-fg-brand-secondary",
      attributes: {},
      path: [
        "semantic",
        "fg",
        "brand-secondary"
      ]
    },
    primary: {
      value: "rgba(22, 23, 25, 1)",
      type: "color",
      description: "token = lh-semantic-color-fg-primary\n\n\ntitle, headline, main text, matching icon",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#161719",
        type: "color",
        description: "token = lh-semantic-color-fg-primary\n\n\ntitle, headline, main text, matching icon"
      },
      name: "sd-semantic-fg-primary",
      attributes: {},
      path: [
        "semantic",
        "fg",
        "primary"
      ]
    },
    secondary: {
      value: "rgba(122, 124, 129, 1)",
      type: "color",
      description: "token = lh-semantic-color-fg-secondary\n\nbody text, subtitle, matching icons",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#7a7c81",
        type: "color",
        description: "token = lh-semantic-color-fg-secondary\n\nbody text, subtitle, matching icons"
      },
      name: "sd-semantic-fg-secondary",
      attributes: {},
      path: [
        "semantic",
        "fg",
        "secondary"
      ]
    },
    tertiary: {
      value: "rgba(208, 209, 211, 1)",
      type: "color",
      description: "token = lh-semantic-color-fg-tertiary\n\nplaceholder text, muted",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#d0d1d3",
        type: "color",
        description: "token = lh-semantic-color-fg-tertiary\n\nplaceholder text, muted"
      },
      name: "sd-semantic-fg-tertiary",
      attributes: {},
      path: [
        "semantic",
        "fg",
        "tertiary"
      ]
    },
    inverse: {
      value: "rgba(252, 252, 253, 1)",
      type: "color",
      description: "token = lh-semantic-color-fg-inverse\n\ninverse, title, headline, main text, matching icon",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#fcfcfd",
        type: "color",
        description: "token = lh-semantic-color-fg-inverse\n\ninverse, title, headline, main text, matching icon"
      },
      name: "sd-semantic-fg-inverse",
      attributes: {},
      path: [
        "semantic",
        "fg",
        "inverse"
      ]
    },
    "inverse-secondary": {
      value: "rgba(163, 166, 172, 1)",
      type: "color",
      description: "token = lh-semantic-color-fg-inverse-secondary\n\ninverse, body text, subtitle, matching icons",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#a3a6ac",
        type: "color",
        description: "token = lh-semantic-color-fg-inverse-secondary\n\ninverse, body text, subtitle, matching icons"
      },
      name: "sd-semantic-fg-inverse-secondary",
      attributes: {},
      path: [
        "semantic",
        "fg",
        "inverse-secondary"
      ]
    },
    neutral: {
      value: "rgba(44, 45, 48, 1)",
      type: "color",
      description: "token = lh-semantic-color-fg-neutral\n\naction, neutral, icon, text",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#2c2d30",
        type: "color",
        description: "token = lh-semantic-color-fg-neutral\n\naction, neutral, icon, text"
      },
      name: "sd-semantic-fg-neutral",
      attributes: {},
      path: [
        "semantic",
        "fg",
        "neutral"
      ]
    },
    disabled: {
      value: "rgba(163, 166, 172, 0.5019607843137255)",
      type: "color",
      description: "token = lh-semantic-color-fg-disabled\n\ndisabled, action",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#a3a6ac80",
        type: "color",
        description: "token = lh-semantic-color-fg-disabled\n\ndisabled, action"
      },
      name: "sd-semantic-fg-disabled",
      attributes: {},
      path: [
        "semantic",
        "fg",
        "disabled"
      ]
    },
    "neutral-secondary": {
      value: "rgba(230, 231, 233, 1)",
      type: "color",
      description: "token = lh-semantic-color-fg-neutral-secondary\n\naction, neutral, inverse, text, icon",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#e6e7e9",
        type: "color",
        description: "token = lh-semantic-color-fg-neutral-secondary\n\naction, neutral, inverse, text, icon"
      },
      name: "sd-semantic-fg-neutral-secondary",
      attributes: {},
      path: [
        "semantic",
        "fg",
        "neutral-secondary"
      ]
    },
    danger: {
      value: "rgba(255, 59, 48, 1)",
      type: "color",
      description: "token = lh-semantic-color-fg-danger\n\ndestructive, danger, error, action, delete",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#ff3b30",
        type: "color",
        description: "token = lh-semantic-color-fg-danger\n\ndestructive, danger, error, action, delete"
      },
      name: "sd-semantic-fg-danger",
      attributes: {},
      path: [
        "semantic",
        "fg",
        "danger"
      ]
    },
    success: {
      value: "rgba(22, 163, 74, 1)",
      type: "color",
      description: "token = lh-semantic-color-fg-success\n\nsuccess, positive, action, approved",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#16a34a",
        type: "color",
        description: "token = lh-semantic-color-fg-success\n\nsuccess, positive, action, approved"
      },
      name: "sd-semantic-fg-success",
      attributes: {},
      path: [
        "semantic",
        "fg",
        "success"
      ]
    },
    warning: {
      value: "rgba(235, 172, 19, 1)",
      type: "color",
      description: "token = lh-semantic-color-fg-warning\n\nwarning, careful, action, caution",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#ebac13",
        type: "color",
        description: "token = lh-semantic-color-fg-warning\n\nwarning, careful, action, caution"
      },
      name: "sd-semantic-fg-warning",
      attributes: {},
      path: [
        "semantic",
        "fg",
        "warning"
      ]
    },
    white: {
      value: "rgba(255, 255, 255, 1)",
      type: "color",
      description: "token = lh-semantic-color-fg-white\n\nconstant, white, overlay, icon, text",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#ffffff",
        type: "color",
        description: "token = lh-semantic-color-fg-white\n\nconstant, white, overlay, icon, text"
      },
      name: "sd-semantic-fg-white",
      attributes: {},
      path: [
        "semantic",
        "fg",
        "white"
      ]
    },
    black: {
      value: "rgba(22, 23, 25, 1)",
      type: "color",
      description: "token = lh-semantic-color-fg-black\n\nconstant, black, overlay, icon, text",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#161719",
        type: "color",
        description: "token = lh-semantic-color-fg-black\n\nconstant, black, overlay, icon, text"
      },
      name: "sd-semantic-fg-black",
      attributes: {},
      path: [
        "semantic",
        "fg",
        "black"
      ]
    }
  }
};
const button$2 = {
  large: {
    "icon-first": {
      height: {
        value: "48px",
        type: "dimension",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 48,
          type: "dimension"
        },
        name: "sd-button-large-icon-first-height",
        attributes: {},
        path: [
          "button",
          "large",
          "icon-first",
          "height"
        ]
      },
      paddingRight: {
        value: "20px",
        type: "dimension",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 20,
          type: "dimension"
        },
        name: "sd-button-large-icon-first-padding-right",
        attributes: {},
        path: [
          "button",
          "large",
          "icon-first",
          "paddingRight"
        ]
      },
      paddingLeft: {
        value: "12px",
        type: "dimension",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 12,
          type: "dimension"
        },
        name: "sd-button-large-icon-first-padding-left",
        attributes: {},
        path: [
          "button",
          "large",
          "icon-first",
          "paddingLeft"
        ]
      },
      borderRadius: {
        value: "999px",
        type: "borderRadius",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 999,
          type: "borderRadius"
        },
        name: "sd-button-large-icon-first-border-radius",
        attributes: {},
        path: [
          "button",
          "large",
          "icon-first",
          "borderRadius"
        ]
      },
      itemSpacing: {
        value: "8px",
        type: "dimension",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 8,
          type: "dimension"
        },
        name: "sd-button-large-icon-first-item-spacing",
        attributes: {},
        path: [
          "button",
          "large",
          "icon-first",
          "itemSpacing"
        ]
      }
    },
    "label-first": {
      height: {
        value: "48px",
        type: "dimension",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 48,
          type: "dimension"
        },
        name: "sd-button-large-label-first-height",
        attributes: {},
        path: [
          "button",
          "large",
          "label-first",
          "height"
        ]
      },
      paddingRight: {
        value: "12px",
        type: "dimension",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 12,
          type: "dimension"
        },
        name: "sd-button-large-label-first-padding-right",
        attributes: {},
        path: [
          "button",
          "large",
          "label-first",
          "paddingRight"
        ]
      },
      paddingLeft: {
        value: "20px",
        type: "dimension",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 20,
          type: "dimension"
        },
        name: "sd-button-large-label-first-padding-left",
        attributes: {},
        path: [
          "button",
          "large",
          "label-first",
          "paddingLeft"
        ]
      },
      borderRadius: {
        value: "999px",
        type: "borderRadius",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 999,
          type: "borderRadius"
        },
        name: "sd-button-large-label-first-border-radius",
        attributes: {},
        path: [
          "button",
          "large",
          "label-first",
          "borderRadius"
        ]
      },
      itemSpacing: {
        value: "8px",
        type: "dimension",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 8,
          type: "dimension"
        },
        name: "sd-button-large-label-first-item-spacing",
        attributes: {},
        path: [
          "button",
          "large",
          "label-first",
          "itemSpacing"
        ]
      }
    },
    label: {
      height: {
        value: "48px",
        type: "dimension",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 48,
          type: "dimension"
        },
        name: "sd-button-large-label-height",
        attributes: {},
        path: [
          "button",
          "large",
          "label",
          "height"
        ]
      },
      paddingRight: {
        value: "24px",
        type: "dimension",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 24,
          type: "dimension"
        },
        name: "sd-button-large-label-padding-right",
        attributes: {},
        path: [
          "button",
          "large",
          "label",
          "paddingRight"
        ]
      },
      paddingLeft: {
        value: "24px",
        type: "dimension",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 24,
          type: "dimension"
        },
        name: "sd-button-large-label-padding-left",
        attributes: {},
        path: [
          "button",
          "large",
          "label",
          "paddingLeft"
        ]
      },
      borderRadius: {
        value: "999px",
        type: "borderRadius",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 999,
          type: "borderRadius"
        },
        name: "sd-button-large-label-border-radius",
        attributes: {},
        path: [
          "button",
          "large",
          "label",
          "borderRadius"
        ]
      },
      itemSpacing: {
        value: "8px",
        type: "dimension",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 8,
          type: "dimension"
        },
        name: "sd-button-large-label-item-spacing",
        attributes: {},
        path: [
          "button",
          "large",
          "label",
          "itemSpacing"
        ]
      }
    },
    icon: {
      height: {
        value: "48px",
        type: "dimension",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 48,
          type: "dimension"
        },
        name: "sd-button-large-icon-height",
        attributes: {},
        path: [
          "button",
          "large",
          "icon",
          "height"
        ]
      },
      paddingRight: {
        value: "24px",
        type: "dimension",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 24,
          type: "dimension"
        },
        name: "sd-button-large-icon-padding-right",
        attributes: {},
        path: [
          "button",
          "large",
          "icon",
          "paddingRight"
        ]
      },
      paddingLeft: {
        value: "24px",
        type: "dimension",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 24,
          type: "dimension"
        },
        name: "sd-button-large-icon-padding-left",
        attributes: {},
        path: [
          "button",
          "large",
          "icon",
          "paddingLeft"
        ]
      },
      borderRadius: {
        value: "999px",
        type: "borderRadius",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 999,
          type: "borderRadius"
        },
        name: "sd-button-large-icon-border-radius",
        attributes: {},
        path: [
          "button",
          "large",
          "icon",
          "borderRadius"
        ]
      },
      width: {
        value: "48px",
        type: "dimension",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 48,
          type: "dimension"
        },
        name: "sd-button-large-icon-width",
        attributes: {},
        path: [
          "button",
          "large",
          "icon",
          "width"
        ]
      },
      itemSpacing: {
        value: "8px",
        type: "dimension",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 8,
          type: "dimension"
        },
        name: "sd-button-large-icon-item-spacing",
        attributes: {},
        path: [
          "button",
          "large",
          "icon",
          "itemSpacing"
        ]
      }
    }
  },
  medium: {
    "icon-first": {
      height: {
        value: "40px",
        type: "dimension",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 40,
          type: "dimension"
        },
        name: "sd-button-medium-icon-first-height",
        attributes: {},
        path: [
          "button",
          "medium",
          "icon-first",
          "height"
        ]
      },
      paddingRight: {
        value: "16px",
        type: "dimension",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 16,
          type: "dimension"
        },
        name: "sd-button-medium-icon-first-padding-right",
        attributes: {},
        path: [
          "button",
          "medium",
          "icon-first",
          "paddingRight"
        ]
      },
      paddingLeft: {
        value: "8px",
        type: "dimension",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 8,
          type: "dimension"
        },
        name: "sd-button-medium-icon-first-padding-left",
        attributes: {},
        path: [
          "button",
          "medium",
          "icon-first",
          "paddingLeft"
        ]
      },
      borderRadius: {
        value: "999px",
        type: "borderRadius",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 999,
          type: "borderRadius"
        },
        name: "sd-button-medium-icon-first-border-radius",
        attributes: {},
        path: [
          "button",
          "medium",
          "icon-first",
          "borderRadius"
        ]
      },
      itemSpacing: {
        value: "6px",
        type: "dimension",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 6,
          type: "dimension"
        },
        name: "sd-button-medium-icon-first-item-spacing",
        attributes: {},
        path: [
          "button",
          "medium",
          "icon-first",
          "itemSpacing"
        ]
      }
    },
    "label-first": {
      height: {
        value: "40px",
        type: "dimension",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 40,
          type: "dimension"
        },
        name: "sd-button-medium-label-first-height",
        attributes: {},
        path: [
          "button",
          "medium",
          "label-first",
          "height"
        ]
      },
      paddingRight: {
        value: "8px",
        type: "dimension",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 8,
          type: "dimension"
        },
        name: "sd-button-medium-label-first-padding-right",
        attributes: {},
        path: [
          "button",
          "medium",
          "label-first",
          "paddingRight"
        ]
      },
      paddingLeft: {
        value: "16px",
        type: "dimension",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 16,
          type: "dimension"
        },
        name: "sd-button-medium-label-first-padding-left",
        attributes: {},
        path: [
          "button",
          "medium",
          "label-first",
          "paddingLeft"
        ]
      },
      borderRadius: {
        value: "999px",
        type: "borderRadius",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 999,
          type: "borderRadius"
        },
        name: "sd-button-medium-label-first-border-radius",
        attributes: {},
        path: [
          "button",
          "medium",
          "label-first",
          "borderRadius"
        ]
      },
      itemSpacing: {
        value: "6px",
        type: "dimension",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 6,
          type: "dimension"
        },
        name: "sd-button-medium-label-first-item-spacing",
        attributes: {},
        path: [
          "button",
          "medium",
          "label-first",
          "itemSpacing"
        ]
      }
    },
    label: {
      height: {
        value: "40px",
        type: "dimension",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 40,
          type: "dimension"
        },
        name: "sd-button-medium-label-height",
        attributes: {},
        path: [
          "button",
          "medium",
          "label",
          "height"
        ]
      },
      paddingRight: {
        value: "20px",
        type: "dimension",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 20,
          type: "dimension"
        },
        name: "sd-button-medium-label-padding-right",
        attributes: {},
        path: [
          "button",
          "medium",
          "label",
          "paddingRight"
        ]
      },
      paddingLeft: {
        value: "20px",
        type: "dimension",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 20,
          type: "dimension"
        },
        name: "sd-button-medium-label-padding-left",
        attributes: {},
        path: [
          "button",
          "medium",
          "label",
          "paddingLeft"
        ]
      },
      borderRadius: {
        value: "999px",
        type: "borderRadius",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 999,
          type: "borderRadius"
        },
        name: "sd-button-medium-label-border-radius",
        attributes: {},
        path: [
          "button",
          "medium",
          "label",
          "borderRadius"
        ]
      },
      itemSpacing: {
        value: "6px",
        type: "dimension",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 6,
          type: "dimension"
        },
        name: "sd-button-medium-label-item-spacing",
        attributes: {},
        path: [
          "button",
          "medium",
          "label",
          "itemSpacing"
        ]
      }
    },
    icon: {
      height: {
        value: "40px",
        type: "dimension",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 40,
          type: "dimension"
        },
        name: "sd-button-medium-icon-height",
        attributes: {},
        path: [
          "button",
          "medium",
          "icon",
          "height"
        ]
      },
      paddingRight: {
        value: "20px",
        type: "dimension",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 20,
          type: "dimension"
        },
        name: "sd-button-medium-icon-padding-right",
        attributes: {},
        path: [
          "button",
          "medium",
          "icon",
          "paddingRight"
        ]
      },
      paddingLeft: {
        value: "20px",
        type: "dimension",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 20,
          type: "dimension"
        },
        name: "sd-button-medium-icon-padding-left",
        attributes: {},
        path: [
          "button",
          "medium",
          "icon",
          "paddingLeft"
        ]
      },
      borderRadius: {
        value: "999px",
        type: "borderRadius",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 999,
          type: "borderRadius"
        },
        name: "sd-button-medium-icon-border-radius",
        attributes: {},
        path: [
          "button",
          "medium",
          "icon",
          "borderRadius"
        ]
      },
      width: {
        value: "40px",
        type: "dimension",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 40,
          type: "dimension"
        },
        name: "sd-button-medium-icon-width",
        attributes: {},
        path: [
          "button",
          "medium",
          "icon",
          "width"
        ]
      },
      itemSpacing: {
        value: "6px",
        type: "dimension",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 6,
          type: "dimension"
        },
        name: "sd-button-medium-icon-item-spacing",
        attributes: {},
        path: [
          "button",
          "medium",
          "icon",
          "itemSpacing"
        ]
      }
    }
  },
  small: {
    "icon-first": {
      height: {
        value: "32px",
        type: "dimension",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 32,
          type: "dimension"
        },
        name: "sd-button-small-icon-first-height",
        attributes: {},
        path: [
          "button",
          "small",
          "icon-first",
          "height"
        ]
      },
      paddingRight: {
        value: "12px",
        type: "dimension",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 12,
          type: "dimension"
        },
        name: "sd-button-small-icon-first-padding-right",
        attributes: {},
        path: [
          "button",
          "small",
          "icon-first",
          "paddingRight"
        ]
      },
      paddingLeft: {
        value: "6px",
        type: "dimension",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 6,
          type: "dimension"
        },
        name: "sd-button-small-icon-first-padding-left",
        attributes: {},
        path: [
          "button",
          "small",
          "icon-first",
          "paddingLeft"
        ]
      },
      borderRadius: {
        value: "999px",
        type: "borderRadius",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 999,
          type: "borderRadius"
        },
        name: "sd-button-small-icon-first-border-radius",
        attributes: {},
        path: [
          "button",
          "small",
          "icon-first",
          "borderRadius"
        ]
      },
      itemSpacing: {
        value: "4px",
        type: "dimension",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 4,
          type: "dimension"
        },
        name: "sd-button-small-icon-first-item-spacing",
        attributes: {},
        path: [
          "button",
          "small",
          "icon-first",
          "itemSpacing"
        ]
      }
    },
    "label-first": {
      height: {
        value: "32px",
        type: "dimension",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 32,
          type: "dimension"
        },
        name: "sd-button-small-label-first-height",
        attributes: {},
        path: [
          "button",
          "small",
          "label-first",
          "height"
        ]
      },
      paddingRight: {
        value: "6px",
        type: "dimension",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 6,
          type: "dimension"
        },
        name: "sd-button-small-label-first-padding-right",
        attributes: {},
        path: [
          "button",
          "small",
          "label-first",
          "paddingRight"
        ]
      },
      paddingLeft: {
        value: "12px",
        type: "dimension",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 12,
          type: "dimension"
        },
        name: "sd-button-small-label-first-padding-left",
        attributes: {},
        path: [
          "button",
          "small",
          "label-first",
          "paddingLeft"
        ]
      },
      borderRadius: {
        value: "999px",
        type: "borderRadius",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 999,
          type: "borderRadius"
        },
        name: "sd-button-small-label-first-border-radius",
        attributes: {},
        path: [
          "button",
          "small",
          "label-first",
          "borderRadius"
        ]
      },
      itemSpacing: {
        value: "4px",
        type: "dimension",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 4,
          type: "dimension"
        },
        name: "sd-button-small-label-first-item-spacing",
        attributes: {},
        path: [
          "button",
          "small",
          "label-first",
          "itemSpacing"
        ]
      }
    },
    label: {
      height: {
        value: "32px",
        type: "dimension",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 32,
          type: "dimension"
        },
        name: "sd-button-small-label-height",
        attributes: {},
        path: [
          "button",
          "small",
          "label",
          "height"
        ]
      },
      paddingRight: {
        value: "16px",
        type: "dimension",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 16,
          type: "dimension"
        },
        name: "sd-button-small-label-padding-right",
        attributes: {},
        path: [
          "button",
          "small",
          "label",
          "paddingRight"
        ]
      },
      paddingLeft: {
        value: "16px",
        type: "dimension",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 16,
          type: "dimension"
        },
        name: "sd-button-small-label-padding-left",
        attributes: {},
        path: [
          "button",
          "small",
          "label",
          "paddingLeft"
        ]
      },
      borderRadius: {
        value: "999px",
        type: "borderRadius",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 999,
          type: "borderRadius"
        },
        name: "sd-button-small-label-border-radius",
        attributes: {},
        path: [
          "button",
          "small",
          "label",
          "borderRadius"
        ]
      },
      itemSpacing: {
        value: "4px",
        type: "dimension",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 4,
          type: "dimension"
        },
        name: "sd-button-small-label-item-spacing",
        attributes: {},
        path: [
          "button",
          "small",
          "label",
          "itemSpacing"
        ]
      }
    },
    icon: {
      height: {
        value: "32px",
        type: "dimension",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 32,
          type: "dimension"
        },
        name: "sd-button-small-icon-height",
        attributes: {},
        path: [
          "button",
          "small",
          "icon",
          "height"
        ]
      },
      paddingRight: {
        value: "16px",
        type: "dimension",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 16,
          type: "dimension"
        },
        name: "sd-button-small-icon-padding-right",
        attributes: {},
        path: [
          "button",
          "small",
          "icon",
          "paddingRight"
        ]
      },
      paddingLeft: {
        value: "16px",
        type: "dimension",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 16,
          type: "dimension"
        },
        name: "sd-button-small-icon-padding-left",
        attributes: {},
        path: [
          "button",
          "small",
          "icon",
          "paddingLeft"
        ]
      },
      borderRadius: {
        value: "999px",
        type: "borderRadius",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 999,
          type: "borderRadius"
        },
        name: "sd-button-small-icon-border-radius",
        attributes: {},
        path: [
          "button",
          "small",
          "icon",
          "borderRadius"
        ]
      },
      width: {
        value: "32px",
        type: "dimension",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 32,
          type: "dimension"
        },
        name: "sd-button-small-icon-width",
        attributes: {},
        path: [
          "button",
          "small",
          "icon",
          "width"
        ]
      },
      itemSpacing: {
        value: "4px",
        type: "dimension",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 4,
          type: "dimension"
        },
        name: "sd-button-small-icon-item-spacing",
        attributes: {},
        path: [
          "button",
          "small",
          "icon",
          "itemSpacing"
        ]
      }
    }
  },
  height: {
    sm: {
      value: "32px",
      type: "sizing",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 32,
        type: "sizing"
      },
      name: "sd-button-height-sm",
      attributes: {},
      path: [
        "button",
        "height",
        "sm"
      ]
    },
    md: {
      value: "40px",
      type: "sizing",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 40,
        type: "sizing"
      },
      name: "sd-button-height-md",
      attributes: {},
      path: [
        "button",
        "height",
        "md"
      ]
    },
    lg: {
      value: "48px",
      type: "sizing",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 48,
        type: "sizing"
      },
      name: "sd-button-height-lg",
      attributes: {},
      path: [
        "button",
        "height",
        "lg"
      ]
    }
  },
  space: {
    large: {
      min: {
        value: "12px",
        type: "spacing",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 12,
          type: "spacing"
        },
        name: "sd-button-space-large-min",
        attributes: {},
        path: [
          "button",
          "space",
          "large",
          "min"
        ]
      },
      max: {
        value: "20px",
        type: "spacing",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 20,
          type: "spacing"
        },
        name: "sd-button-space-large-max",
        attributes: {},
        path: [
          "button",
          "space",
          "large",
          "max"
        ]
      },
      "default": {
        value: "24px",
        type: "spacing",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 24,
          type: "spacing"
        },
        name: "sd-button-space-large-default",
        attributes: {},
        path: [
          "button",
          "space",
          "large",
          "default"
        ]
      },
      gap: {
        value: "8px",
        type: "spacing",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 8,
          type: "spacing"
        },
        name: "sd-button-space-large-gap",
        attributes: {},
        path: [
          "button",
          "space",
          "large",
          "gap"
        ]
      }
    },
    medium: {
      min: {
        value: "8px",
        type: "spacing",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 8,
          type: "spacing"
        },
        name: "sd-button-space-medium-min",
        attributes: {},
        path: [
          "button",
          "space",
          "medium",
          "min"
        ]
      },
      max: {
        value: "16px",
        type: "spacing",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 16,
          type: "spacing"
        },
        name: "sd-button-space-medium-max",
        attributes: {},
        path: [
          "button",
          "space",
          "medium",
          "max"
        ]
      },
      "default": {
        value: "20px",
        type: "spacing",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 20,
          type: "spacing"
        },
        name: "sd-button-space-medium-default",
        attributes: {},
        path: [
          "button",
          "space",
          "medium",
          "default"
        ]
      },
      gap: {
        value: "6px",
        type: "spacing",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 6,
          type: "spacing"
        },
        name: "sd-button-space-medium-gap",
        attributes: {},
        path: [
          "button",
          "space",
          "medium",
          "gap"
        ]
      }
    },
    small: {
      min: {
        value: "6px",
        type: "spacing",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 6,
          type: "spacing"
        },
        name: "sd-button-space-small-min",
        attributes: {},
        path: [
          "button",
          "space",
          "small",
          "min"
        ]
      },
      max: {
        value: "12px",
        type: "spacing",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 12,
          type: "spacing"
        },
        name: "sd-button-space-small-max",
        attributes: {},
        path: [
          "button",
          "space",
          "small",
          "max"
        ]
      },
      "default": {
        value: "16px",
        type: "spacing",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 16,
          type: "spacing"
        },
        name: "sd-button-space-small-default",
        attributes: {},
        path: [
          "button",
          "space",
          "small",
          "default"
        ]
      },
      gap: {
        value: "4px",
        type: "spacing",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 4,
          type: "spacing"
        },
        name: "sd-button-space-small-gap",
        attributes: {},
        path: [
          "button",
          "space",
          "small",
          "gap"
        ]
      }
    }
  },
  radius: {
    value: "999px",
    type: "borderRadius",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 999,
      type: "borderRadius"
    },
    name: "sd-button-radius",
    attributes: {},
    path: [
      "button",
      "radius"
    ]
  }
};
const card$2 = {
  small: {
    verticalPadding: {
      value: "8px",
      type: "dimension",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 8,
        type: "dimension"
      },
      name: "sd-card-small-vertical-padding",
      attributes: {},
      path: [
        "card",
        "small",
        "verticalPadding"
      ]
    },
    horizontalPadding: {
      value: "8px",
      type: "dimension",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 8,
        type: "dimension"
      },
      name: "sd-card-small-horizontal-padding",
      attributes: {},
      path: [
        "card",
        "small",
        "horizontalPadding"
      ]
    },
    borderRadius: {
      value: "24px",
      type: "borderRadius",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 24,
        type: "borderRadius"
      },
      name: "sd-card-small-border-radius",
      attributes: {},
      path: [
        "card",
        "small",
        "borderRadius"
      ]
    },
    boxShadow: {
      "0": {
        color: {
          value: "rgba(14, 21, 38, 0.0784313725490196)",
          type: "color",
          filePath: "themes/popularpay-light.json",
          isSource: true,
          original: {
            value: "#0e152614",
            type: "color"
          },
          name: "sd-card-small-box-shadow-0-color",
          attributes: {},
          path: [
            "card",
            "small",
            "boxShadow",
            "0",
            "color"
          ]
        },
        type: {
          value: "dropShadow",
          type: "type",
          filePath: "themes/popularpay-light.json",
          isSource: true,
          original: {
            value: "dropShadow",
            type: "type"
          },
          name: "sd-card-small-box-shadow-0-type",
          attributes: {},
          path: [
            "card",
            "small",
            "boxShadow",
            "0",
            "type"
          ]
        },
        x: {
          value: "0px",
          type: "x",
          filePath: "themes/popularpay-light.json",
          isSource: true,
          original: {
            value: 0,
            type: "x"
          },
          name: "sd-card-small-box-shadow-0-x",
          attributes: {},
          path: [
            "card",
            "small",
            "boxShadow",
            "0",
            "x"
          ]
        },
        y: {
          value: "0px",
          type: "y",
          filePath: "themes/popularpay-light.json",
          isSource: true,
          original: {
            value: 0,
            type: "y"
          },
          name: "sd-card-small-box-shadow-0-y",
          attributes: {},
          path: [
            "card",
            "small",
            "boxShadow",
            "0",
            "y"
          ]
        },
        blur: {
          value: "1px",
          type: "blur",
          filePath: "themes/popularpay-light.json",
          isSource: true,
          original: {
            value: 1,
            type: "blur"
          },
          name: "sd-card-small-box-shadow-0-blur",
          attributes: {},
          path: [
            "card",
            "small",
            "boxShadow",
            "0",
            "blur"
          ]
        },
        spread: {
          value: "0px",
          type: "spread",
          filePath: "themes/popularpay-light.json",
          isSource: true,
          original: {
            value: 0,
            type: "spread"
          },
          name: "sd-card-small-box-shadow-0-spread",
          attributes: {},
          path: [
            "card",
            "small",
            "boxShadow",
            "0",
            "spread"
          ]
        }
      },
      "1": {
        color: {
          value: "rgba(14, 21, 38, 0.058823529411764705)",
          type: "color",
          filePath: "themes/popularpay-light.json",
          isSource: true,
          original: {
            value: "#0e15260f",
            type: "color"
          },
          name: "sd-card-small-box-shadow-1-color",
          attributes: {},
          path: [
            "card",
            "small",
            "boxShadow",
            "1",
            "color"
          ]
        },
        type: {
          value: "dropShadow",
          type: "type",
          filePath: "themes/popularpay-light.json",
          isSource: true,
          original: {
            value: "dropShadow",
            type: "type"
          },
          name: "sd-card-small-box-shadow-1-type",
          attributes: {},
          path: [
            "card",
            "small",
            "boxShadow",
            "1",
            "type"
          ]
        },
        x: {
          value: "0px",
          type: "x",
          filePath: "themes/popularpay-light.json",
          isSource: true,
          original: {
            value: 0,
            type: "x"
          },
          name: "sd-card-small-box-shadow-1-x",
          attributes: {},
          path: [
            "card",
            "small",
            "boxShadow",
            "1",
            "x"
          ]
        },
        y: {
          value: "2px",
          type: "y",
          filePath: "themes/popularpay-light.json",
          isSource: true,
          original: {
            value: 2,
            type: "y"
          },
          name: "sd-card-small-box-shadow-1-y",
          attributes: {},
          path: [
            "card",
            "small",
            "boxShadow",
            "1",
            "y"
          ]
        },
        blur: {
          value: "32px",
          type: "blur",
          filePath: "themes/popularpay-light.json",
          isSource: true,
          original: {
            value: 32,
            type: "blur"
          },
          name: "sd-card-small-box-shadow-1-blur",
          attributes: {},
          path: [
            "card",
            "small",
            "boxShadow",
            "1",
            "blur"
          ]
        },
        spread: {
          value: "0px",
          type: "spread",
          filePath: "themes/popularpay-light.json",
          isSource: true,
          original: {
            value: 0,
            type: "spread"
          },
          name: "sd-card-small-box-shadow-1-spread",
          attributes: {},
          path: [
            "card",
            "small",
            "boxShadow",
            "1",
            "spread"
          ]
        }
      }
    },
    fill: {
      value: "#ffffff",
      type: "fill",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#ffffff",
        type: "fill"
      },
      name: "sd-card-small-fill",
      attributes: {},
      path: [
        "card",
        "small",
        "fill"
      ]
    }
  },
  medium: {
    verticalPadding: {
      value: "12px",
      type: "dimension",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 12,
        type: "dimension"
      },
      name: "sd-card-medium-vertical-padding",
      attributes: {},
      path: [
        "card",
        "medium",
        "verticalPadding"
      ]
    },
    horizontalPadding: {
      value: "12px",
      type: "dimension",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 12,
        type: "dimension"
      },
      name: "sd-card-medium-horizontal-padding",
      attributes: {},
      path: [
        "card",
        "medium",
        "horizontalPadding"
      ]
    },
    borderRadius: {
      value: "32px",
      type: "borderRadius",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 32,
        type: "borderRadius"
      },
      name: "sd-card-medium-border-radius",
      attributes: {},
      path: [
        "card",
        "medium",
        "borderRadius"
      ]
    },
    boxShadow: {
      "0": {
        color: {
          value: "rgba(24, 39, 75, 0.1607843137254902)",
          type: "color",
          filePath: "themes/popularpay-light.json",
          isSource: true,
          original: {
            value: "#18274b29",
            type: "color"
          },
          name: "sd-card-medium-box-shadow-0-color",
          attributes: {},
          path: [
            "card",
            "medium",
            "boxShadow",
            "0",
            "color"
          ]
        },
        type: {
          value: "dropShadow",
          type: "type",
          filePath: "themes/popularpay-light.json",
          isSource: true,
          original: {
            value: "dropShadow",
            type: "type"
          },
          name: "sd-card-medium-box-shadow-0-type",
          attributes: {},
          path: [
            "card",
            "medium",
            "boxShadow",
            "0",
            "type"
          ]
        },
        x: {
          value: "0px",
          type: "x",
          filePath: "themes/popularpay-light.json",
          isSource: true,
          original: {
            value: 0,
            type: "x"
          },
          name: "sd-card-medium-box-shadow-0-x",
          attributes: {},
          path: [
            "card",
            "medium",
            "boxShadow",
            "0",
            "x"
          ]
        },
        y: {
          value: "18px",
          type: "y",
          filePath: "themes/popularpay-light.json",
          isSource: true,
          original: {
            value: 18,
            type: "y"
          },
          name: "sd-card-medium-box-shadow-0-y",
          attributes: {},
          path: [
            "card",
            "medium",
            "boxShadow",
            "0",
            "y"
          ]
        },
        blur: {
          value: "64px",
          type: "blur",
          filePath: "themes/popularpay-light.json",
          isSource: true,
          original: {
            value: 64,
            type: "blur"
          },
          name: "sd-card-medium-box-shadow-0-blur",
          attributes: {},
          path: [
            "card",
            "medium",
            "boxShadow",
            "0",
            "blur"
          ]
        },
        spread: {
          value: "-4px",
          type: "spread",
          filePath: "themes/popularpay-light.json",
          isSource: true,
          original: {
            value: -4,
            type: "spread"
          },
          name: "sd-card-medium-box-shadow-0-spread",
          attributes: {},
          path: [
            "card",
            "medium",
            "boxShadow",
            "0",
            "spread"
          ]
        }
      },
      "1": {
        color: {
          value: "rgba(24, 39, 75, 0.12156862745098039)",
          type: "color",
          filePath: "themes/popularpay-light.json",
          isSource: true,
          original: {
            value: "#18274b1f",
            type: "color"
          },
          name: "sd-card-medium-box-shadow-1-color",
          attributes: {},
          path: [
            "card",
            "medium",
            "boxShadow",
            "1",
            "color"
          ]
        },
        type: {
          value: "dropShadow",
          type: "type",
          filePath: "themes/popularpay-light.json",
          isSource: true,
          original: {
            value: "dropShadow",
            type: "type"
          },
          name: "sd-card-medium-box-shadow-1-type",
          attributes: {},
          path: [
            "card",
            "medium",
            "boxShadow",
            "1",
            "type"
          ]
        },
        x: {
          value: "0px",
          type: "x",
          filePath: "themes/popularpay-light.json",
          isSource: true,
          original: {
            value: 0,
            type: "x"
          },
          name: "sd-card-medium-box-shadow-1-x",
          attributes: {},
          path: [
            "card",
            "medium",
            "boxShadow",
            "1",
            "x"
          ]
        },
        y: {
          value: "6px",
          type: "y",
          filePath: "themes/popularpay-light.json",
          isSource: true,
          original: {
            value: 6,
            type: "y"
          },
          name: "sd-card-medium-box-shadow-1-y",
          attributes: {},
          path: [
            "card",
            "medium",
            "boxShadow",
            "1",
            "y"
          ]
        },
        blur: {
          value: "28px",
          type: "blur",
          filePath: "themes/popularpay-light.json",
          isSource: true,
          original: {
            value: 28,
            type: "blur"
          },
          name: "sd-card-medium-box-shadow-1-blur",
          attributes: {},
          path: [
            "card",
            "medium",
            "boxShadow",
            "1",
            "blur"
          ]
        },
        spread: {
          value: "-6px",
          type: "spread",
          filePath: "themes/popularpay-light.json",
          isSource: true,
          original: {
            value: -6,
            type: "spread"
          },
          name: "sd-card-medium-box-shadow-1-spread",
          attributes: {},
          path: [
            "card",
            "medium",
            "boxShadow",
            "1",
            "spread"
          ]
        }
      }
    },
    fill: {
      value: "#ffffff",
      type: "fill",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#ffffff",
        type: "fill"
      },
      name: "sd-card-medium-fill",
      attributes: {},
      path: [
        "card",
        "medium",
        "fill"
      ]
    },
    spacing: {
      value: "16px",
      type: "spacing",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 16,
        type: "spacing"
      },
      name: "sd-card-medium-spacing",
      attributes: {},
      path: [
        "card",
        "medium",
        "spacing"
      ]
    }
  },
  large: {
    spacing: {
      value: "16px",
      type: "spacing",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 16,
        type: "spacing"
      },
      name: "sd-card-large-spacing",
      attributes: {},
      path: [
        "card",
        "large",
        "spacing"
      ]
    },
    verticalPadding: {
      value: "16px",
      type: "dimension",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 16,
        type: "dimension"
      },
      name: "sd-card-large-vertical-padding",
      attributes: {},
      path: [
        "card",
        "large",
        "verticalPadding"
      ]
    },
    horizontalPadding: {
      value: "16px",
      type: "dimension",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 16,
        type: "dimension"
      },
      name: "sd-card-large-horizontal-padding",
      attributes: {},
      path: [
        "card",
        "large",
        "horizontalPadding"
      ]
    },
    borderRadius: {
      value: "40px",
      type: "borderRadius",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 40,
        type: "borderRadius"
      },
      name: "sd-card-large-border-radius",
      attributes: {},
      path: [
        "card",
        "large",
        "borderRadius"
      ]
    },
    boxShadow: {
      "0": {
        color: {
          value: "rgba(24, 39, 75, 0.1607843137254902)",
          type: "color",
          filePath: "themes/popularpay-light.json",
          isSource: true,
          original: {
            value: "#18274b29",
            type: "color"
          },
          name: "sd-card-large-box-shadow-0-color",
          attributes: {},
          path: [
            "card",
            "large",
            "boxShadow",
            "0",
            "color"
          ]
        },
        type: {
          value: "dropShadow",
          type: "type",
          filePath: "themes/popularpay-light.json",
          isSource: true,
          original: {
            value: "dropShadow",
            type: "type"
          },
          name: "sd-card-large-box-shadow-0-type",
          attributes: {},
          path: [
            "card",
            "large",
            "boxShadow",
            "0",
            "type"
          ]
        },
        x: {
          value: "0px",
          type: "x",
          filePath: "themes/popularpay-light.json",
          isSource: true,
          original: {
            value: 0,
            type: "x"
          },
          name: "sd-card-large-box-shadow-0-x",
          attributes: {},
          path: [
            "card",
            "large",
            "boxShadow",
            "0",
            "x"
          ]
        },
        y: {
          value: "18px",
          type: "y",
          filePath: "themes/popularpay-light.json",
          isSource: true,
          original: {
            value: 18,
            type: "y"
          },
          name: "sd-card-large-box-shadow-0-y",
          attributes: {},
          path: [
            "card",
            "large",
            "boxShadow",
            "0",
            "y"
          ]
        },
        blur: {
          value: "64px",
          type: "blur",
          filePath: "themes/popularpay-light.json",
          isSource: true,
          original: {
            value: 64,
            type: "blur"
          },
          name: "sd-card-large-box-shadow-0-blur",
          attributes: {},
          path: [
            "card",
            "large",
            "boxShadow",
            "0",
            "blur"
          ]
        },
        spread: {
          value: "-4px",
          type: "spread",
          filePath: "themes/popularpay-light.json",
          isSource: true,
          original: {
            value: -4,
            type: "spread"
          },
          name: "sd-card-large-box-shadow-0-spread",
          attributes: {},
          path: [
            "card",
            "large",
            "boxShadow",
            "0",
            "spread"
          ]
        }
      },
      "1": {
        color: {
          value: "rgba(24, 39, 75, 0.12156862745098039)",
          type: "color",
          filePath: "themes/popularpay-light.json",
          isSource: true,
          original: {
            value: "#18274b1f",
            type: "color"
          },
          name: "sd-card-large-box-shadow-1-color",
          attributes: {},
          path: [
            "card",
            "large",
            "boxShadow",
            "1",
            "color"
          ]
        },
        type: {
          value: "dropShadow",
          type: "type",
          filePath: "themes/popularpay-light.json",
          isSource: true,
          original: {
            value: "dropShadow",
            type: "type"
          },
          name: "sd-card-large-box-shadow-1-type",
          attributes: {},
          path: [
            "card",
            "large",
            "boxShadow",
            "1",
            "type"
          ]
        },
        x: {
          value: "0px",
          type: "x",
          filePath: "themes/popularpay-light.json",
          isSource: true,
          original: {
            value: 0,
            type: "x"
          },
          name: "sd-card-large-box-shadow-1-x",
          attributes: {},
          path: [
            "card",
            "large",
            "boxShadow",
            "1",
            "x"
          ]
        },
        y: {
          value: "6px",
          type: "y",
          filePath: "themes/popularpay-light.json",
          isSource: true,
          original: {
            value: 6,
            type: "y"
          },
          name: "sd-card-large-box-shadow-1-y",
          attributes: {},
          path: [
            "card",
            "large",
            "boxShadow",
            "1",
            "y"
          ]
        },
        blur: {
          value: "28px",
          type: "blur",
          filePath: "themes/popularpay-light.json",
          isSource: true,
          original: {
            value: 28,
            type: "blur"
          },
          name: "sd-card-large-box-shadow-1-blur",
          attributes: {},
          path: [
            "card",
            "large",
            "boxShadow",
            "1",
            "blur"
          ]
        },
        spread: {
          value: "-6px",
          type: "spread",
          filePath: "themes/popularpay-light.json",
          isSource: true,
          original: {
            value: -6,
            type: "spread"
          },
          name: "sd-card-large-box-shadow-1-spread",
          attributes: {},
          path: [
            "card",
            "large",
            "boxShadow",
            "1",
            "spread"
          ]
        }
      }
    },
    fill: {
      value: "#ffffff",
      type: "fill",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#ffffff",
        type: "fill"
      },
      name: "sd-card-large-fill",
      attributes: {},
      path: [
        "card",
        "large",
        "fill"
      ]
    }
  },
  radius: {
    xs: {
      value: "16px",
      type: "borderRadius",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 16,
        type: "borderRadius"
      },
      name: "sd-card-radius-xs",
      attributes: {},
      path: [
        "card",
        "radius",
        "xs"
      ]
    },
    sm: {
      value: "24px",
      type: "borderRadius",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 24,
        type: "borderRadius"
      },
      name: "sd-card-radius-sm",
      attributes: {},
      path: [
        "card",
        "radius",
        "sm"
      ]
    },
    md: {
      value: "32px",
      type: "borderRadius",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 32,
        type: "borderRadius"
      },
      name: "sd-card-radius-md",
      attributes: {},
      path: [
        "card",
        "radius",
        "md"
      ]
    },
    lg: {
      value: "40px",
      type: "borderRadius",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 40,
        type: "borderRadius"
      },
      name: "sd-card-radius-lg",
      attributes: {},
      path: [
        "card",
        "radius",
        "lg"
      ]
    }
  },
  padding: {
    sm: {
      value: "8px",
      type: "spacing",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 8,
        type: "spacing"
      },
      name: "sd-card-padding-sm",
      attributes: {},
      path: [
        "card",
        "padding",
        "sm"
      ]
    },
    md: {
      value: "12px",
      type: "spacing",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 12,
        type: "spacing"
      },
      name: "sd-card-padding-md",
      attributes: {},
      path: [
        "card",
        "padding",
        "md"
      ]
    },
    lg: {
      value: "16px",
      type: "spacing",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 16,
        type: "spacing"
      },
      name: "sd-card-padding-lg",
      attributes: {},
      path: [
        "card",
        "padding",
        "lg"
      ]
    },
    xl: {
      value: "20px",
      type: "spacing",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 20,
        type: "spacing"
      },
      name: "sd-card-padding-xl",
      attributes: {},
      path: [
        "card",
        "padding",
        "xl"
      ]
    }
  },
  gap: {
    sm: {
      value: "8px",
      type: "spacing",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 8,
        type: "spacing"
      },
      name: "sd-card-gap-sm",
      attributes: {},
      path: [
        "card",
        "gap",
        "sm"
      ]
    },
    md: {
      value: "16px",
      type: "spacing",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 16,
        type: "spacing"
      },
      name: "sd-card-gap-md",
      attributes: {},
      path: [
        "card",
        "gap",
        "md"
      ]
    },
    lg: {
      value: "24px",
      type: "spacing",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 24,
        type: "spacing"
      },
      name: "sd-card-gap-lg",
      attributes: {},
      path: [
        "card",
        "gap",
        "lg"
      ]
    },
    xl: {
      value: "32px",
      type: "spacing",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 32,
        type: "spacing"
      },
      name: "sd-card-gap-xl",
      attributes: {},
      path: [
        "card",
        "gap",
        "xl"
      ]
    }
  }
};
const sheet$2 = {
  small: {
    borderRadius: {
      value: "16px",
      type: "borderRadius",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "16 16 0 0",
        type: "borderRadius"
      },
      name: "sd-sheet-small-border-radius",
      attributes: {},
      path: [
        "sheet",
        "small",
        "borderRadius"
      ]
    },
    fill: {
      value: "#ffffff",
      type: "fill",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#ffffff",
        type: "fill"
      },
      name: "sd-sheet-small-fill",
      attributes: {},
      path: [
        "sheet",
        "small",
        "fill"
      ]
    }
  },
  medium: {
    height: {
      value: "480px",
      type: "dimension",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 480,
        type: "dimension"
      },
      name: "sd-sheet-medium-height",
      attributes: {},
      path: [
        "sheet",
        "medium",
        "height"
      ]
    },
    borderRadius: {
      value: "24px",
      type: "borderRadius",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "24 24 0 0",
        type: "borderRadius"
      },
      name: "sd-sheet-medium-border-radius",
      attributes: {},
      path: [
        "sheet",
        "medium",
        "borderRadius"
      ]
    },
    fill: {
      value: "#ffffff",
      type: "fill",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#ffffff",
        type: "fill"
      },
      name: "sd-sheet-medium-fill",
      attributes: {},
      path: [
        "sheet",
        "medium",
        "fill"
      ]
    }
  },
  large: {
    height: {
      value: "480px",
      type: "dimension",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 480,
        type: "dimension"
      },
      name: "sd-sheet-large-height",
      attributes: {},
      path: [
        "sheet",
        "large",
        "height"
      ]
    },
    borderRadius: {
      value: "32px",
      type: "borderRadius",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "32 32 0 0",
        type: "borderRadius"
      },
      name: "sd-sheet-large-border-radius",
      attributes: {},
      path: [
        "sheet",
        "large",
        "borderRadius"
      ]
    },
    fill: {
      value: "#ffffff",
      type: "fill",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#ffffff",
        type: "fill"
      },
      name: "sd-sheet-large-fill",
      attributes: {},
      path: [
        "sheet",
        "large",
        "fill"
      ]
    }
  },
  radius: {
    sm: {
      value: "16px",
      type: "borderRadius",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "16 16 0 0",
        type: "borderRadius"
      },
      name: "sd-sheet-radius-sm",
      attributes: {},
      path: [
        "sheet",
        "radius",
        "sm"
      ]
    },
    md: {
      value: "24px",
      type: "borderRadius",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "24 24 0 0",
        type: "borderRadius"
      },
      name: "sd-sheet-radius-md",
      attributes: {},
      path: [
        "sheet",
        "radius",
        "md"
      ]
    },
    lg: {
      value: "32px",
      type: "borderRadius",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "32 32 0 0",
        type: "borderRadius"
      },
      name: "sd-sheet-radius-lg",
      attributes: {},
      path: [
        "sheet",
        "radius",
        "lg"
      ]
    }
  }
};
const comp$2 = {
  button: {
    bg: {
      brand: {
        filled: {
          "default": {
            value: "rgba(41, 200, 147, 1)",
            type: "color",
            filePath: "themes/popularpay-light.json",
            isSource: true,
            original: {
              value: "#29c893",
              type: "color"
            },
            name: "sd-comp-button-bg-brand-filled-default",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "brand",
              "filled",
              "default"
            ]
          },
          hover: {
            value: "rgba(47, 147, 111, 1)",
            type: "color",
            filePath: "themes/popularpay-light.json",
            isSource: true,
            original: {
              value: "#2f936f",
              type: "color"
            },
            name: "sd-comp-button-bg-brand-filled-hover",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "brand",
              "filled",
              "hover"
            ]
          },
          pressed: {
            value: "rgba(44, 121, 93, 1)",
            type: "color",
            filePath: "themes/popularpay-light.json",
            isSource: true,
            original: {
              value: "#2c795d",
              type: "color"
            },
            name: "sd-comp-button-bg-brand-filled-pressed",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "brand",
              "filled",
              "pressed"
            ]
          },
          disabled: {
            value: "rgba(163, 166, 172, 0.25098039215686274)",
            type: "color",
            filePath: "themes/popularpay-light.json",
            isSource: true,
            original: {
              value: "#a3a6ac40",
              type: "color"
            },
            name: "sd-comp-button-bg-brand-filled-disabled",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "brand",
              "filled",
              "disabled"
            ]
          }
        },
        tinted: {
          "default": {
            value: "rgba(41, 200, 147, 0.1607843137254902)",
            type: "color",
            filePath: "themes/popularpay-light.json",
            isSource: true,
            original: {
              value: "#29c89329",
              type: "color"
            },
            name: "sd-comp-button-bg-brand-tinted-default",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "brand",
              "tinted",
              "default"
            ]
          },
          hover: {
            value: "rgba(38, 200, 147, 0.34901960784313724)",
            type: "color",
            filePath: "themes/popularpay-light.json",
            isSource: true,
            original: {
              value: "#26c89359",
              type: "color"
            },
            name: "sd-comp-button-bg-brand-tinted-hover",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "brand",
              "tinted",
              "hover"
            ]
          },
          pressed: {
            value: "rgba(38, 200, 147, 0.43137254901960786)",
            type: "color",
            filePath: "themes/popularpay-light.json",
            isSource: true,
            original: {
              value: "#26c8936e",
              type: "color"
            },
            name: "sd-comp-button-bg-brand-tinted-pressed",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "brand",
              "tinted",
              "pressed"
            ]
          },
          disabled: {
            value: "rgba(163, 166, 172, 0.10196078431372549)",
            type: "color",
            filePath: "themes/popularpay-light.json",
            isSource: true,
            original: {
              value: "#a3a6ac1a",
              type: "color"
            },
            name: "sd-comp-button-bg-brand-tinted-disabled",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "brand",
              "tinted",
              "disabled"
            ]
          }
        },
        plain: {
          "default": {
            value: "rgba(255, 255, 255, 0)",
            type: "color",
            filePath: "themes/popularpay-light.json",
            isSource: true,
            original: {
              value: "#ffffff00",
              type: "color"
            },
            name: "sd-comp-button-bg-brand-plain-default",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "brand",
              "plain",
              "default"
            ]
          },
          hover: {
            value: "rgba(168, 230, 201, 0.49019607843137253)",
            type: "color",
            filePath: "themes/popularpay-light.json",
            isSource: true,
            original: {
              value: "#a8e6c97d",
              type: "color"
            },
            name: "sd-comp-button-bg-brand-plain-hover",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "brand",
              "plain",
              "hover"
            ]
          },
          pressed: {
            value: "rgba(134, 221, 183, 0.6588235294117647)",
            type: "color",
            filePath: "themes/popularpay-light.json",
            isSource: true,
            original: {
              value: "#86ddb7a8",
              type: "color"
            },
            name: "sd-comp-button-bg-brand-plain-pressed",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "brand",
              "plain",
              "pressed"
            ]
          },
          disabled: {
            value: "rgba(255, 255, 255, 0)",
            type: "color",
            filePath: "themes/popularpay-light.json",
            isSource: true,
            original: {
              value: "#ffffff00",
              type: "color"
            },
            name: "sd-comp-button-bg-brand-plain-disabled",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "brand",
              "plain",
              "disabled"
            ]
          }
        },
        elevated: {
          "default": {
            value: "rgba(255, 255, 255, 1)",
            type: "color",
            filePath: "themes/popularpay-light.json",
            isSource: true,
            original: {
              value: "#ffffff",
              type: "color"
            },
            name: "sd-comp-button-bg-brand-elevated-default",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "brand",
              "elevated",
              "default"
            ]
          },
          hover: {
            value: "rgba(224, 224, 224, 1)",
            type: "color",
            filePath: "themes/popularpay-light.json",
            isSource: true,
            original: {
              value: "#e0e0e0",
              type: "color"
            },
            name: "sd-comp-button-bg-brand-elevated-hover",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "brand",
              "elevated",
              "hover"
            ]
          },
          pressed: {
            value: "rgba(197, 198, 198, 1)",
            type: "color",
            filePath: "themes/popularpay-light.json",
            isSource: true,
            original: {
              value: "#c5c6c6",
              type: "color"
            },
            name: "sd-comp-button-bg-brand-elevated-pressed",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "brand",
              "elevated",
              "pressed"
            ]
          },
          disabled: {
            value: "rgba(128, 130, 136, 0.611764705882353)",
            type: "color",
            filePath: "themes/popularpay-light.json",
            isSource: true,
            original: {
              value: "#8082889c",
              type: "color"
            },
            name: "sd-comp-button-bg-brand-elevated-disabled",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "brand",
              "elevated",
              "disabled"
            ]
          }
        }
      },
      neutral: {
        filled: {
          "default": {
            value: "rgba(44, 45, 48, 1)",
            type: "color",
            filePath: "themes/popularpay-light.json",
            isSource: true,
            original: {
              value: "#2c2d30",
              type: "color"
            },
            name: "sd-comp-button-bg-neutral-filled-default",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "neutral",
              "filled",
              "default"
            ]
          },
          hover: {
            value: "rgba(95, 95, 98, 1)",
            type: "color",
            filePath: "themes/popularpay-light.json",
            isSource: true,
            original: {
              value: "#5f5f62",
              type: "color"
            },
            name: "sd-comp-button-bg-neutral-filled-hover",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "neutral",
              "filled",
              "hover"
            ]
          },
          pressed: {
            value: "rgba(122, 122, 125, 1)",
            type: "color",
            filePath: "themes/popularpay-light.json",
            isSource: true,
            original: {
              value: "#7a7a7d",
              type: "color"
            },
            name: "sd-comp-button-bg-neutral-filled-pressed",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "neutral",
              "filled",
              "pressed"
            ]
          }
        },
        tinted: {
          "default": {
            value: "rgba(44, 45, 48, 0.12156862745098039)",
            type: "color",
            filePath: "themes/popularpay-light.json",
            isSource: true,
            original: {
              value: "#2c2d301f",
              type: "color"
            },
            name: "sd-comp-button-bg-neutral-tinted-default",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "neutral",
              "tinted",
              "default"
            ]
          },
          hover: {
            value: "rgba(39, 40, 42, 0.30980392156862746)",
            type: "color",
            filePath: "themes/popularpay-light.json",
            isSource: true,
            original: {
              value: "#27282a4f",
              type: "color"
            },
            name: "sd-comp-button-bg-neutral-tinted-hover",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "neutral",
              "tinted",
              "hover"
            ]
          },
          pressed: {
            value: "rgba(37, 38, 40, 0.4)",
            type: "color",
            filePath: "themes/popularpay-light.json",
            isSource: true,
            original: {
              value: "#25262866",
              type: "color"
            },
            name: "sd-comp-button-bg-neutral-tinted-pressed",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "neutral",
              "tinted",
              "pressed"
            ]
          }
        },
        plain: {
          "default": {
            value: "rgba(255, 255, 255, 0)",
            type: "color",
            filePath: "themes/popularpay-light.json",
            isSource: true,
            original: {
              value: "#ffffff00",
              type: "color"
            },
            name: "sd-comp-button-bg-neutral-plain-default",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "neutral",
              "plain",
              "default"
            ]
          },
          hover: {
            value: "rgba(144, 145, 147, 0.49019607843137253)",
            type: "color",
            filePath: "themes/popularpay-light.json",
            isSource: true,
            original: {
              value: "#9091937d",
              type: "color"
            },
            name: "sd-comp-button-bg-neutral-plain-hover",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "neutral",
              "plain",
              "hover"
            ]
          },
          pressed: {
            value: "rgba(109, 110, 112, 0.6588235294117647)",
            type: "color",
            filePath: "themes/popularpay-light.json",
            isSource: true,
            original: {
              value: "#6d6e70a8",
              type: "color"
            },
            name: "sd-comp-button-bg-neutral-plain-pressed",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "neutral",
              "plain",
              "pressed"
            ]
          }
        },
        elevated: {
          "default": {
            value: "rgba(255, 255, 255, 1)",
            type: "color",
            filePath: "themes/popularpay-light.json",
            isSource: true,
            original: {
              value: "#ffffff",
              type: "color"
            },
            name: "sd-comp-button-bg-neutral-elevated-default",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "neutral",
              "elevated",
              "default"
            ]
          },
          hover: {
            value: "rgba(224, 224, 224, 1)",
            type: "color",
            filePath: "themes/popularpay-light.json",
            isSource: true,
            original: {
              value: "#e0e0e0",
              type: "color"
            },
            name: "sd-comp-button-bg-neutral-elevated-hover",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "neutral",
              "elevated",
              "hover"
            ]
          },
          pressed: {
            value: "rgba(197, 198, 198, 1)",
            type: "color",
            filePath: "themes/popularpay-light.json",
            isSource: true,
            original: {
              value: "#c5c6c6",
              type: "color"
            },
            name: "sd-comp-button-bg-neutral-elevated-pressed",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "neutral",
              "elevated",
              "pressed"
            ]
          }
        }
      },
      danger: {
        filled: {
          "default": {
            value: "rgba(255, 59, 48, 1)",
            type: "color",
            filePath: "themes/popularpay-light.json",
            isSource: true,
            original: {
              value: "#ff3b30",
              type: "color"
            },
            name: "sd-comp-button-bg-danger-filled-default",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "danger",
              "filled",
              "default"
            ]
          },
          hover: {
            value: "rgba(187, 55, 42, 1)",
            type: "color",
            filePath: "themes/popularpay-light.json",
            isSource: true,
            original: {
              value: "#bb372a",
              type: "color"
            },
            name: "sd-comp-button-bg-danger-filled-hover",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "danger",
              "filled",
              "hover"
            ]
          },
          pressed: {
            value: "rgba(154, 51, 39, 1)",
            type: "color",
            filePath: "themes/popularpay-light.json",
            isSource: true,
            original: {
              value: "#9a3327",
              type: "color"
            },
            name: "sd-comp-button-bg-danger-filled-pressed",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "danger",
              "filled",
              "pressed"
            ]
          }
        },
        tinted: {
          "default": {
            value: "rgba(255, 59, 48, 0.12156862745098039)",
            type: "color",
            filePath: "themes/popularpay-light.json",
            isSource: true,
            original: {
              value: "#ff3b301f",
              type: "color"
            },
            name: "sd-comp-button-bg-danger-tinted-default",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "danger",
              "tinted",
              "default"
            ]
          },
          hover: {
            value: "rgba(198, 56, 43, 0.30980392156862746)",
            type: "color",
            filePath: "themes/popularpay-light.json",
            isSource: true,
            original: {
              value: "#c6382b4f",
              type: "color"
            },
            name: "sd-comp-button-bg-danger-tinted-hover",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "danger",
              "tinted",
              "hover"
            ]
          },
          pressed: {
            value: "rgba(175, 54, 42, 0.4)",
            type: "color",
            filePath: "themes/popularpay-light.json",
            isSource: true,
            original: {
              value: "#af362a66",
              type: "color"
            },
            name: "sd-comp-button-bg-danger-tinted-pressed",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "danger",
              "tinted",
              "pressed"
            ]
          }
        },
        plain: {
          "default": {
            value: "rgba(255, 255, 255, 0)",
            type: "color",
            filePath: "themes/popularpay-light.json",
            isSource: true,
            original: {
              value: "#ffffff00",
              type: "color"
            },
            name: "sd-comp-button-bg-danger-plain-default",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "danger",
              "plain",
              "default"
            ]
          },
          hover: {
            value: "rgba(255, 170, 150, 0.49019607843137253)",
            type: "color",
            filePath: "themes/popularpay-light.json",
            isSource: true,
            original: {
              value: "#ffaa967d",
              type: "color"
            },
            name: "sd-comp-button-bg-danger-plain-hover",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "danger",
              "plain",
              "hover"
            ]
          },
          pressed: {
            value: "rgba(255, 140, 116, 0.6588235294117647)",
            type: "color",
            filePath: "themes/popularpay-light.json",
            isSource: true,
            original: {
              value: "#ff8c74a8",
              type: "color"
            },
            name: "sd-comp-button-bg-danger-plain-pressed",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "danger",
              "plain",
              "pressed"
            ]
          }
        },
        elevated: {
          "default": {
            value: "rgba(255, 255, 255, 1)",
            type: "color",
            filePath: "themes/popularpay-light.json",
            isSource: true,
            original: {
              value: "#ffffff",
              type: "color"
            },
            name: "sd-comp-button-bg-danger-elevated-default",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "danger",
              "elevated",
              "default"
            ]
          },
          hover: {
            value: "rgba(224, 224, 224, 1)",
            type: "color",
            filePath: "themes/popularpay-light.json",
            isSource: true,
            original: {
              value: "#e0e0e0",
              type: "color"
            },
            name: "sd-comp-button-bg-danger-elevated-hover",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "danger",
              "elevated",
              "hover"
            ]
          },
          pressed: {
            value: "rgba(197, 198, 198, 1)",
            type: "color",
            filePath: "themes/popularpay-light.json",
            isSource: true,
            original: {
              value: "#c5c6c6",
              type: "color"
            },
            name: "sd-comp-button-bg-danger-elevated-pressed",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "danger",
              "elevated",
              "pressed"
            ]
          }
        }
      },
      overlay: {
        filled: {
          "default": {
            value: "rgba(255, 255, 255, 1)",
            type: "color",
            filePath: "themes/popularpay-light.json",
            isSource: true,
            original: {
              value: "#ffffff",
              type: "color"
            },
            name: "sd-comp-button-bg-overlay-filled-default",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "overlay",
              "filled",
              "default"
            ]
          },
          hover: {
            value: "rgba(237, 237, 237, 1)",
            type: "color",
            filePath: "themes/popularpay-light.json",
            isSource: true,
            original: {
              value: "#ededed",
              type: "color"
            },
            name: "sd-comp-button-bg-overlay-filled-hover",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "overlay",
              "filled",
              "hover"
            ]
          },
          pressed: {
            value: "rgba(222, 222, 222, 1)",
            type: "color",
            filePath: "themes/popularpay-light.json",
            isSource: true,
            original: {
              value: "#dedede",
              type: "color"
            },
            name: "sd-comp-button-bg-overlay-filled-pressed",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "overlay",
              "filled",
              "pressed"
            ]
          }
        },
        tinted: {
          "default": {
            value: "rgba(255, 255, 255, 0.12156862745098039)",
            type: "color",
            filePath: "themes/popularpay-light.json",
            isSource: true,
            original: {
              value: "#ffffff1f",
              type: "color"
            },
            name: "sd-comp-button-bg-overlay-tinted-default",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "overlay",
              "tinted",
              "default"
            ]
          },
          hover: {
            value: "rgba(255, 255, 255, 0.30980392156862746)",
            type: "color",
            filePath: "themes/popularpay-light.json",
            isSource: true,
            original: {
              value: "#ffffff4f",
              type: "color"
            },
            name: "sd-comp-button-bg-overlay-tinted-hover",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "overlay",
              "tinted",
              "hover"
            ]
          },
          pressed: {
            value: "rgba(255, 255, 255, 0.4)",
            type: "color",
            filePath: "themes/popularpay-light.json",
            isSource: true,
            original: {
              value: "#fff6",
              type: "color"
            },
            name: "sd-comp-button-bg-overlay-tinted-pressed",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "overlay",
              "tinted",
              "pressed"
            ]
          }
        },
        plain: {
          "default": {
            value: "rgba(255, 255, 255, 0)",
            type: "color",
            filePath: "themes/popularpay-light.json",
            isSource: true,
            original: {
              value: "#ffffff00",
              type: "color"
            },
            name: "sd-comp-button-bg-overlay-plain-default",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "overlay",
              "plain",
              "default"
            ]
          },
          hover: {
            value: "rgba(255, 255, 255, 0.49019607843137253)",
            type: "color",
            filePath: "themes/popularpay-light.json",
            isSource: true,
            original: {
              value: "#ffffff7d",
              type: "color"
            },
            name: "sd-comp-button-bg-overlay-plain-hover",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "overlay",
              "plain",
              "hover"
            ]
          },
          pressed: {
            value: "rgba(255, 255, 255, 0.6588235294117647)",
            type: "color",
            filePath: "themes/popularpay-light.json",
            isSource: true,
            original: {
              value: "#ffffffa8",
              type: "color"
            },
            name: "sd-comp-button-bg-overlay-plain-pressed",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "overlay",
              "plain",
              "pressed"
            ]
          }
        },
        elevated: {
          "default": {
            value: "rgba(0, 0, 0, 0.30196078431372547)",
            type: "color",
            filePath: "themes/popularpay-light.json",
            isSource: true,
            original: {
              value: "#0000004d",
              type: "color"
            },
            name: "sd-comp-button-bg-overlay-elevated-default",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "overlay",
              "elevated",
              "default"
            ]
          },
          hover: {
            value: "rgba(0, 0, 0, 0.5215686274509804)",
            type: "color",
            filePath: "themes/popularpay-light.json",
            isSource: true,
            original: {
              value: "#00000085",
              type: "color"
            },
            name: "sd-comp-button-bg-overlay-elevated-hover",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "overlay",
              "elevated",
              "hover"
            ]
          },
          pressed: {
            value: "rgba(0, 0, 0, 0.6392156862745098)",
            type: "color",
            filePath: "themes/popularpay-light.json",
            isSource: true,
            original: {
              value: "#000000a3",
              type: "color"
            },
            name: "sd-comp-button-bg-overlay-elevated-pressed",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "overlay",
              "elevated",
              "pressed"
            ]
          }
        }
      }
    },
    fg: {
      brand: {
        primary: {
          value: "rgba(255, 255, 255, 1)",
          type: "color",
          filePath: "themes/popularpay-light.json",
          isSource: true,
          original: {
            value: "#ffffff",
            type: "color"
          },
          name: "sd-comp-button-fg-brand-primary",
          attributes: {},
          path: [
            "comp",
            "button",
            "fg",
            "brand",
            "primary"
          ]
        },
        secondary: {
          value: "rgba(41, 200, 147, 1)",
          type: "color",
          filePath: "themes/popularpay-light.json",
          isSource: true,
          original: {
            value: "#29c893",
            type: "color"
          },
          name: "sd-comp-button-fg-brand-secondary",
          attributes: {},
          path: [
            "comp",
            "button",
            "fg",
            "brand",
            "secondary"
          ]
        },
        disabled: {
          value: "rgba(163, 166, 172, 0.5019607843137255)",
          type: "color",
          filePath: "themes/popularpay-light.json",
          isSource: true,
          original: {
            value: "#a3a6ac80",
            type: "color"
          },
          name: "sd-comp-button-fg-brand-disabled",
          attributes: {},
          path: [
            "comp",
            "button",
            "fg",
            "brand",
            "disabled"
          ]
        }
      },
      neutral: {
        primary: {
          value: "rgba(230, 231, 233, 1)",
          type: "color",
          filePath: "themes/popularpay-light.json",
          isSource: true,
          original: {
            value: "#e6e7e9",
            type: "color"
          },
          name: "sd-comp-button-fg-neutral-primary",
          attributes: {},
          path: [
            "comp",
            "button",
            "fg",
            "neutral",
            "primary"
          ]
        },
        secondary: {
          value: "rgba(44, 45, 48, 1)",
          type: "color",
          filePath: "themes/popularpay-light.json",
          isSource: true,
          original: {
            value: "#2c2d30",
            type: "color"
          },
          name: "sd-comp-button-fg-neutral-secondary",
          attributes: {},
          path: [
            "comp",
            "button",
            "fg",
            "neutral",
            "secondary"
          ]
        }
      },
      danger: {
        primary: {
          value: "rgba(252, 252, 253, 1)",
          type: "color",
          filePath: "themes/popularpay-light.json",
          isSource: true,
          original: {
            value: "#fcfcfd",
            type: "color"
          },
          name: "sd-comp-button-fg-danger-primary",
          attributes: {},
          path: [
            "comp",
            "button",
            "fg",
            "danger",
            "primary"
          ]
        },
        secondary: {
          value: "rgba(255, 59, 48, 1)",
          type: "color",
          filePath: "themes/popularpay-light.json",
          isSource: true,
          original: {
            value: "#ff3b30",
            type: "color"
          },
          name: "sd-comp-button-fg-danger-secondary",
          attributes: {},
          path: [
            "comp",
            "button",
            "fg",
            "danger",
            "secondary"
          ]
        }
      },
      overlay: {
        primary: {
          value: "rgba(22, 23, 25, 1)",
          type: "color",
          filePath: "themes/popularpay-light.json",
          isSource: true,
          original: {
            value: "#161719",
            type: "color"
          },
          name: "sd-comp-button-fg-overlay-primary",
          attributes: {},
          path: [
            "comp",
            "button",
            "fg",
            "overlay",
            "primary"
          ]
        },
        secondary: {
          value: "rgba(255, 255, 255, 1)",
          type: "color",
          filePath: "themes/popularpay-light.json",
          isSource: true,
          original: {
            value: "#ffffff",
            type: "color"
          },
          name: "sd-comp-button-fg-overlay-secondary",
          attributes: {},
          path: [
            "comp",
            "button",
            "fg",
            "overlay",
            "secondary"
          ]
        }
      }
    }
  }
};
const gradient$2 = {
  "primary↓": {
    value: "linear-gradient(180deg, #fcfcfd 0%, #ffffff00 100%)",
    type: "color",
    description: "token = lh-semantic-gradient-primary-down\n\nbg primary values, smooth, gradient, mask, transition",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: "linear-gradient(180deg, #fcfcfd 0%, #ffffff00 100%)",
      type: "color",
      description: "token = lh-semantic-gradient-primary-down\n\nbg primary values, smooth, gradient, mask, transition"
    },
    name: "sd-gradient-primary",
    attributes: {},
    path: [
      "gradient",
      "primary↓"
    ]
  },
  "primary↑": {
    value: "linear-gradient(0deg, #fcfcfd 0%, #ffffff00 100%)",
    type: "color",
    description: "token = lh-semantic-gradient-primary-up\n\nbg primary values, smooth, gradient, mask, transition",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: "linear-gradient(0deg, #fcfcfd 0%, #ffffff00 100%)",
      type: "color",
      description: "token = lh-semantic-gradient-primary-up\n\nbg primary values, smooth, gradient, mask, transition"
    },
    name: "sd-gradient-primary",
    attributes: {},
    path: [
      "gradient",
      "primary↑"
    ]
  },
  "secondary↓": {
    value: "linear-gradient(180deg, #ffffff 0%, #ffffff00 100%)",
    type: "color",
    description: "token = lh-semantic-gradient-secondary-down\n\nbg secondary values, smooth, gradient, mask, transition",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: "linear-gradient(180deg, #ffffff 0%, #ffffff00 100%)",
      type: "color",
      description: "token = lh-semantic-gradient-secondary-down\n\nbg secondary values, smooth, gradient, mask, transition"
    },
    name: "sd-gradient-secondary",
    attributes: {},
    path: [
      "gradient",
      "secondary↓"
    ]
  },
  "secondary↑": {
    value: "linear-gradient(0deg, #ffffff 0%, #ffffff00 100%)",
    type: "color",
    description: "token = lh-semantic-gradient-secondary-up\n\nbg secondary values, smooth, gradient, mask, transition",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: "linear-gradient(0deg, #ffffff 0%, #ffffff00 100%)",
      type: "color",
      description: "token = lh-semantic-gradient-secondary-up\n\nbg secondary values, smooth, gradient, mask, transition"
    },
    name: "sd-gradient-secondary",
    attributes: {},
    path: [
      "gradient",
      "secondary↑"
    ]
  },
  "inverse↓": {
    value: "linear-gradient(180deg, #161719 0%, #ffffff00 100%)",
    type: "color",
    description: "token = lh-semantic-gradient-inverse-down\n\nbg inverse values, smooth, gradient, mask, transition",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: "linear-gradient(180deg, #161719 0%, #ffffff00 100%)",
      type: "color",
      description: "token = lh-semantic-gradient-inverse-down\n\nbg inverse values, smooth, gradient, mask, transition"
    },
    name: "sd-gradient-inverse",
    attributes: {},
    path: [
      "gradient",
      "inverse↓"
    ]
  },
  "inverse↑": {
    value: "linear-gradient(0deg, #161719 0%, #ffffff00 100%)",
    type: "color",
    description: "token = lh-semantic-gradient-inverse-up\n\nbg inverse values, smooth, gradient, mask, transition",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: "linear-gradient(0deg, #161719 0%, #ffffff00 100%)",
      type: "color",
      description: "token = lh-semantic-gradient-inverse-up\n\nbg inverse values, smooth, gradient, mask, transition"
    },
    name: "sd-gradient-inverse",
    attributes: {},
    path: [
      "gradient",
      "inverse↑"
    ]
  },
  "brand↓": {
    value: "linear-gradient(180deg, #29c893 0%, #ffffff00 100%)",
    type: "color",
    description: "token = lh-semantic-gradient-brand-down\n\nbg brand values, smooth, gradient, mask, transition",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: "linear-gradient(180deg, #29c893 0%, #ffffff00 100%)",
      type: "color",
      description: "token = lh-semantic-gradient-brand-down\n\nbg brand values, smooth, gradient, mask, transition"
    },
    name: "sd-gradient-brand",
    attributes: {},
    path: [
      "gradient",
      "brand↓"
    ]
  },
  "brand↑": {
    value: "linear-gradient(0deg, #29c893 0%, #ffffff00 100%)",
    type: "color",
    description: "token = lh-semantic-gradient-brand-up\n\nbg brand values, smooth, gradient, mask, transition",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: "linear-gradient(0deg, #29c893 0%, #ffffff00 100%)",
      type: "color",
      description: "token = lh-semantic-gradient-brand-up\n\nbg brand values, smooth, gradient, mask, transition"
    },
    name: "sd-gradient-brand",
    attributes: {},
    path: [
      "gradient",
      "brand↑"
    ]
  },
  "black↓": {
    value: "linear-gradient(180deg, #000000 0%, #000000fc 11.79%, #000000f7 21.38%, #000000ed 29.12%, #000000e0 35.34%, #000000d1 40.37%, #000000bf 44.56%, #000000ab 48.24%, #00000096 51.76%, #00000080 55.44%, #00000069 59.63%, #00000054 64.66%, #0000003d 70.88%, #00000026 78.62%, #00000012 88.21%, #00000000 100%)",
    type: "color",
    description: "token = lh-semantic-gradient-black-down\n\nblack values, smooth, gradient, mask, transition, feed, overlay, content",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: "linear-gradient(180deg, #000000 0%, #000000fc 11.79%, #000000f7 21.38%, #000000ed 29.12%, #000000e0 35.34%, #000000d1 40.37%, #000000bf 44.56%, #000000ab 48.24%, #00000096 51.76%, #00000080 55.44%, #00000069 59.63%, #00000054 64.66%, #0000003d 70.88%, #00000026 78.62%, #00000012 88.21%, #00000000 100%)",
      type: "color",
      description: "token = lh-semantic-gradient-black-down\n\nblack values, smooth, gradient, mask, transition, feed, overlay, content"
    },
    name: "sd-gradient-black",
    attributes: {},
    path: [
      "gradient",
      "black↓"
    ]
  },
  "black↑": {
    value: "linear-gradient(0deg, #000000 0%, #000000fc 11.79%, #000000f7 21.38%, #000000ed 29.12%, #000000e0 35.34%, #000000d1 40.37%, #000000bf 44.56%, #000000ab 48.24%, #00000096 51.76%, #00000080 55.44%, #00000069 59.63%, #00000054 64.66%, #0000003d 70.88%, #00000026 78.62%, #00000012 88.21%, #00000000 100%)",
    type: "color",
    description: "token = lh-semantic-gradient-black-up\n\nblack values, smooth, gradient, mask, transition, feed, overlay, content",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: "linear-gradient(0deg, #000000 0%, #000000fc 11.79%, #000000f7 21.38%, #000000ed 29.12%, #000000e0 35.34%, #000000d1 40.37%, #000000bf 44.56%, #000000ab 48.24%, #00000096 51.76%, #00000080 55.44%, #00000069 59.63%, #00000054 64.66%, #0000003d 70.88%, #00000026 78.62%, #00000012 88.21%, #00000000 100%)",
      type: "color",
      description: "token = lh-semantic-gradient-black-up\n\nblack values, smooth, gradient, mask, transition, feed, overlay, content"
    },
    name: "sd-gradient-black",
    attributes: {},
    path: [
      "gradient",
      "black↑"
    ]
  }
};
const shadow$2 = {
  "smooth-icon": {
    "0": {
      color: {
        value: "rgba(0, 0, 0, 0.0392156862745098)",
        type: "color",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "#0000000a",
          type: "color"
        },
        name: "sd-shadow-smooth-icon-0-color",
        attributes: {},
        path: [
          "shadow",
          "smooth-icon",
          "0",
          "color"
        ]
      },
      type: {
        value: "dropShadow",
        type: "type",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "dropShadow",
          type: "type"
        },
        name: "sd-shadow-smooth-icon-0-type",
        attributes: {},
        path: [
          "shadow",
          "smooth-icon",
          "0",
          "type"
        ]
      },
      x: {
        value: "0px",
        type: "x",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 0,
          type: "x"
        },
        name: "sd-shadow-smooth-icon-0-x",
        attributes: {},
        path: [
          "shadow",
          "smooth-icon",
          "0",
          "x"
        ]
      },
      y: {
        value: "0px",
        type: "y",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 0,
          type: "y"
        },
        name: "sd-shadow-smooth-icon-0-y",
        attributes: {},
        path: [
          "shadow",
          "smooth-icon",
          "0",
          "y"
        ]
      },
      blur: {
        value: "1px",
        type: "blur",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 1,
          type: "blur"
        },
        name: "sd-shadow-smooth-icon-0-blur",
        attributes: {},
        path: [
          "shadow",
          "smooth-icon",
          "0",
          "blur"
        ]
      },
      spread: {
        value: "0px",
        type: "spread",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 0,
          type: "spread"
        },
        name: "sd-shadow-smooth-icon-0-spread",
        attributes: {},
        path: [
          "shadow",
          "smooth-icon",
          "0",
          "spread"
        ]
      }
    },
    "1": {
      color: {
        value: "rgba(0, 0, 0, 0.23921568627450981)",
        type: "color",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "#0000003d",
          type: "color"
        },
        name: "sd-shadow-smooth-icon-1-color",
        attributes: {},
        path: [
          "shadow",
          "smooth-icon",
          "1",
          "color"
        ]
      },
      type: {
        value: "dropShadow",
        type: "type",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "dropShadow",
          type: "type"
        },
        name: "sd-shadow-smooth-icon-1-type",
        attributes: {},
        path: [
          "shadow",
          "smooth-icon",
          "1",
          "type"
        ]
      },
      x: {
        value: "0px",
        type: "x",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 0,
          type: "x"
        },
        name: "sd-shadow-smooth-icon-1-x",
        attributes: {},
        path: [
          "shadow",
          "smooth-icon",
          "1",
          "x"
        ]
      },
      y: {
        value: "0px",
        type: "y",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 0,
          type: "y"
        },
        name: "sd-shadow-smooth-icon-1-y",
        attributes: {},
        path: [
          "shadow",
          "smooth-icon",
          "1",
          "y"
        ]
      },
      blur: {
        value: "16px",
        type: "blur",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 16,
          type: "blur"
        },
        name: "sd-shadow-smooth-icon-1-blur",
        attributes: {},
        path: [
          "shadow",
          "smooth-icon",
          "1",
          "blur"
        ]
      },
      spread: {
        value: "0px",
        type: "spread",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 0,
          type: "spread"
        },
        name: "sd-shadow-smooth-icon-1-spread",
        attributes: {},
        path: [
          "shadow",
          "smooth-icon",
          "1",
          "spread"
        ]
      }
    }
  },
  "sharp-icon": {
    "0": {
      color: {
        value: "rgba(0, 0, 0, 0.47843137254901963)",
        type: "color",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "#0000007a",
          type: "color"
        },
        name: "sd-shadow-sharp-icon-0-color",
        attributes: {},
        path: [
          "shadow",
          "sharp-icon",
          "0",
          "color"
        ]
      },
      type: {
        value: "dropShadow",
        type: "type",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "dropShadow",
          type: "type"
        },
        name: "sd-shadow-sharp-icon-0-type",
        attributes: {},
        path: [
          "shadow",
          "sharp-icon",
          "0",
          "type"
        ]
      },
      x: {
        value: "0px",
        type: "x",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 0,
          type: "x"
        },
        name: "sd-shadow-sharp-icon-0-x",
        attributes: {},
        path: [
          "shadow",
          "sharp-icon",
          "0",
          "x"
        ]
      },
      y: {
        value: "0px",
        type: "y",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 0,
          type: "y"
        },
        name: "sd-shadow-sharp-icon-0-y",
        attributes: {},
        path: [
          "shadow",
          "sharp-icon",
          "0",
          "y"
        ]
      },
      blur: {
        value: "1px",
        type: "blur",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 1,
          type: "blur"
        },
        name: "sd-shadow-sharp-icon-0-blur",
        attributes: {},
        path: [
          "shadow",
          "sharp-icon",
          "0",
          "blur"
        ]
      },
      spread: {
        value: "0px",
        type: "spread",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 0,
          type: "spread"
        },
        name: "sd-shadow-sharp-icon-0-spread",
        attributes: {},
        path: [
          "shadow",
          "sharp-icon",
          "0",
          "spread"
        ]
      }
    },
    "1": {
      color: {
        value: "rgba(0, 0, 0, 0.1607843137254902)",
        type: "color",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "#00000029",
          type: "color"
        },
        name: "sd-shadow-sharp-icon-1-color",
        attributes: {},
        path: [
          "shadow",
          "sharp-icon",
          "1",
          "color"
        ]
      },
      type: {
        value: "dropShadow",
        type: "type",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "dropShadow",
          type: "type"
        },
        name: "sd-shadow-sharp-icon-1-type",
        attributes: {},
        path: [
          "shadow",
          "sharp-icon",
          "1",
          "type"
        ]
      },
      x: {
        value: "0px",
        type: "x",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 0,
          type: "x"
        },
        name: "sd-shadow-sharp-icon-1-x",
        attributes: {},
        path: [
          "shadow",
          "sharp-icon",
          "1",
          "x"
        ]
      },
      y: {
        value: "0px",
        type: "y",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 0,
          type: "y"
        },
        name: "sd-shadow-sharp-icon-1-y",
        attributes: {},
        path: [
          "shadow",
          "sharp-icon",
          "1",
          "y"
        ]
      },
      blur: {
        value: "2px",
        type: "blur",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 2,
          type: "blur"
        },
        name: "sd-shadow-sharp-icon-1-blur",
        attributes: {},
        path: [
          "shadow",
          "sharp-icon",
          "1",
          "blur"
        ]
      },
      spread: {
        value: "0px",
        type: "spread",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 0,
          type: "spread"
        },
        name: "sd-shadow-sharp-icon-1-spread",
        attributes: {},
        path: [
          "shadow",
          "sharp-icon",
          "1",
          "spread"
        ]
      }
    }
  },
  seperation: {
    "0": {
      color: {
        value: "rgba(14, 21, 38, 0.0784313725490196)",
        type: "color",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "#0e152614",
          type: "color"
        },
        name: "sd-shadow-seperation-0-color",
        attributes: {},
        path: [
          "shadow",
          "seperation",
          "0",
          "color"
        ]
      },
      type: {
        value: "dropShadow",
        type: "type",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "dropShadow",
          type: "type"
        },
        name: "sd-shadow-seperation-0-type",
        attributes: {},
        path: [
          "shadow",
          "seperation",
          "0",
          "type"
        ]
      },
      x: {
        value: "0px",
        type: "x",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 0,
          type: "x"
        },
        name: "sd-shadow-seperation-0-x",
        attributes: {},
        path: [
          "shadow",
          "seperation",
          "0",
          "x"
        ]
      },
      y: {
        value: "0px",
        type: "y",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 0,
          type: "y"
        },
        name: "sd-shadow-seperation-0-y",
        attributes: {},
        path: [
          "shadow",
          "seperation",
          "0",
          "y"
        ]
      },
      blur: {
        value: "1px",
        type: "blur",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 1,
          type: "blur"
        },
        name: "sd-shadow-seperation-0-blur",
        attributes: {},
        path: [
          "shadow",
          "seperation",
          "0",
          "blur"
        ]
      },
      spread: {
        value: "0px",
        type: "spread",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 0,
          type: "spread"
        },
        name: "sd-shadow-seperation-0-spread",
        attributes: {},
        path: [
          "shadow",
          "seperation",
          "0",
          "spread"
        ]
      }
    },
    "1": {
      color: {
        value: "rgba(14, 21, 38, 0.058823529411764705)",
        type: "color",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "#0e15260f",
          type: "color"
        },
        name: "sd-shadow-seperation-1-color",
        attributes: {},
        path: [
          "shadow",
          "seperation",
          "1",
          "color"
        ]
      },
      type: {
        value: "dropShadow",
        type: "type",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "dropShadow",
          type: "type"
        },
        name: "sd-shadow-seperation-1-type",
        attributes: {},
        path: [
          "shadow",
          "seperation",
          "1",
          "type"
        ]
      },
      x: {
        value: "0px",
        type: "x",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 0,
          type: "x"
        },
        name: "sd-shadow-seperation-1-x",
        attributes: {},
        path: [
          "shadow",
          "seperation",
          "1",
          "x"
        ]
      },
      y: {
        value: "2px",
        type: "y",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 2,
          type: "y"
        },
        name: "sd-shadow-seperation-1-y",
        attributes: {},
        path: [
          "shadow",
          "seperation",
          "1",
          "y"
        ]
      },
      blur: {
        value: "32px",
        type: "blur",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 32,
          type: "blur"
        },
        name: "sd-shadow-seperation-1-blur",
        attributes: {},
        path: [
          "shadow",
          "seperation",
          "1",
          "blur"
        ]
      },
      spread: {
        value: "0px",
        type: "spread",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 0,
          type: "spread"
        },
        name: "sd-shadow-seperation-1-spread",
        attributes: {},
        path: [
          "shadow",
          "seperation",
          "1",
          "spread"
        ]
      }
    }
  },
  "elevation-1": {
    "0": {
      color: {
        value: "rgba(24, 39, 75, 0.0784313725490196)",
        type: "color",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "#18274b14",
          type: "color"
        },
        name: "sd-shadow-elevation-1-0-color",
        attributes: {},
        path: [
          "shadow",
          "elevation-1",
          "0",
          "color"
        ]
      },
      type: {
        value: "dropShadow",
        type: "type",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "dropShadow",
          type: "type"
        },
        name: "sd-shadow-elevation-1-0-type",
        attributes: {},
        path: [
          "shadow",
          "elevation-1",
          "0",
          "type"
        ]
      },
      x: {
        value: "0px",
        type: "x",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 0,
          type: "x"
        },
        name: "sd-shadow-elevation-1-0-x",
        attributes: {},
        path: [
          "shadow",
          "elevation-1",
          "0",
          "x"
        ]
      },
      y: {
        value: "4px",
        type: "y",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 4,
          type: "y"
        },
        name: "sd-shadow-elevation-1-0-y",
        attributes: {},
        path: [
          "shadow",
          "elevation-1",
          "0",
          "y"
        ]
      },
      blur: {
        value: "12px",
        type: "blur",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 12,
          type: "blur"
        },
        name: "sd-shadow-elevation-1-0-blur",
        attributes: {},
        path: [
          "shadow",
          "elevation-1",
          "0",
          "blur"
        ]
      },
      spread: {
        value: "-2px",
        type: "spread",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: -2,
          type: "spread"
        },
        name: "sd-shadow-elevation-1-0-spread",
        attributes: {},
        path: [
          "shadow",
          "elevation-1",
          "0",
          "spread"
        ]
      }
    },
    "1": {
      color: {
        value: "rgba(24, 39, 75, 0.0196078431372549)",
        type: "color",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "#18274b05",
          type: "color"
        },
        name: "sd-shadow-elevation-1-1-color",
        attributes: {},
        path: [
          "shadow",
          "elevation-1",
          "1",
          "color"
        ]
      },
      type: {
        value: "dropShadow",
        type: "type",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "dropShadow",
          type: "type"
        },
        name: "sd-shadow-elevation-1-1-type",
        attributes: {},
        path: [
          "shadow",
          "elevation-1",
          "1",
          "type"
        ]
      },
      x: {
        value: "0px",
        type: "x",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 0,
          type: "x"
        },
        name: "sd-shadow-elevation-1-1-x",
        attributes: {},
        path: [
          "shadow",
          "elevation-1",
          "1",
          "x"
        ]
      },
      y: {
        value: "0px",
        type: "y",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 0,
          type: "y"
        },
        name: "sd-shadow-elevation-1-1-y",
        attributes: {},
        path: [
          "shadow",
          "elevation-1",
          "1",
          "y"
        ]
      },
      blur: {
        value: "4px",
        type: "blur",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 4,
          type: "blur"
        },
        name: "sd-shadow-elevation-1-1-blur",
        attributes: {},
        path: [
          "shadow",
          "elevation-1",
          "1",
          "blur"
        ]
      },
      spread: {
        value: "0px",
        type: "spread",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 0,
          type: "spread"
        },
        name: "sd-shadow-elevation-1-1-spread",
        attributes: {},
        path: [
          "shadow",
          "elevation-1",
          "1",
          "spread"
        ]
      }
    }
  },
  "elevation-2": {
    "0": {
      color: {
        value: "rgba(24, 39, 75, 0.0784313725490196)",
        type: "color",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "#18274b14",
          type: "color"
        },
        name: "sd-shadow-elevation-2-0-color",
        attributes: {},
        path: [
          "shadow",
          "elevation-2",
          "0",
          "color"
        ]
      },
      type: {
        value: "dropShadow",
        type: "type",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "dropShadow",
          type: "type"
        },
        name: "sd-shadow-elevation-2-0-type",
        attributes: {},
        path: [
          "shadow",
          "elevation-2",
          "0",
          "type"
        ]
      },
      x: {
        value: "0px",
        type: "x",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 0,
          type: "x"
        },
        name: "sd-shadow-elevation-2-0-x",
        attributes: {},
        path: [
          "shadow",
          "elevation-2",
          "0",
          "x"
        ]
      },
      y: {
        value: "8px",
        type: "y",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 8,
          type: "y"
        },
        name: "sd-shadow-elevation-2-0-y",
        attributes: {},
        path: [
          "shadow",
          "elevation-2",
          "0",
          "y"
        ]
      },
      blur: {
        value: "24px",
        type: "blur",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 24,
          type: "blur"
        },
        name: "sd-shadow-elevation-2-0-blur",
        attributes: {},
        path: [
          "shadow",
          "elevation-2",
          "0",
          "blur"
        ]
      },
      spread: {
        value: "-4px",
        type: "spread",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: -4,
          type: "spread"
        },
        name: "sd-shadow-elevation-2-0-spread",
        attributes: {},
        path: [
          "shadow",
          "elevation-2",
          "0",
          "spread"
        ]
      }
    },
    "1": {
      color: {
        value: "rgba(24, 39, 75, 0.12156862745098039)",
        type: "color",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "#18274b1f",
          type: "color"
        },
        name: "sd-shadow-elevation-2-1-color",
        attributes: {},
        path: [
          "shadow",
          "elevation-2",
          "1",
          "color"
        ]
      },
      type: {
        value: "dropShadow",
        type: "type",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "dropShadow",
          type: "type"
        },
        name: "sd-shadow-elevation-2-1-type",
        attributes: {},
        path: [
          "shadow",
          "elevation-2",
          "1",
          "type"
        ]
      },
      x: {
        value: "0px",
        type: "x",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 0,
          type: "x"
        },
        name: "sd-shadow-elevation-2-1-x",
        attributes: {},
        path: [
          "shadow",
          "elevation-2",
          "1",
          "x"
        ]
      },
      y: {
        value: "2px",
        type: "y",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 2,
          type: "y"
        },
        name: "sd-shadow-elevation-2-1-y",
        attributes: {},
        path: [
          "shadow",
          "elevation-2",
          "1",
          "y"
        ]
      },
      blur: {
        value: "12px",
        type: "blur",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 12,
          type: "blur"
        },
        name: "sd-shadow-elevation-2-1-blur",
        attributes: {},
        path: [
          "shadow",
          "elevation-2",
          "1",
          "blur"
        ]
      },
      spread: {
        value: "-2px",
        type: "spread",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: -2,
          type: "spread"
        },
        name: "sd-shadow-elevation-2-1-spread",
        attributes: {},
        path: [
          "shadow",
          "elevation-2",
          "1",
          "spread"
        ]
      }
    }
  },
  "elevation-3": {
    "0": {
      color: {
        value: "rgba(24, 39, 75, 0.12156862745098039)",
        type: "color",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "#18274b1f",
          type: "color"
        },
        name: "sd-shadow-elevation-3-0-color",
        attributes: {},
        path: [
          "shadow",
          "elevation-3",
          "0",
          "color"
        ]
      },
      type: {
        value: "dropShadow",
        type: "type",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "dropShadow",
          type: "type"
        },
        name: "sd-shadow-elevation-3-0-type",
        attributes: {},
        path: [
          "shadow",
          "elevation-3",
          "0",
          "type"
        ]
      },
      x: {
        value: "0px",
        type: "x",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 0,
          type: "x"
        },
        name: "sd-shadow-elevation-3-0-x",
        attributes: {},
        path: [
          "shadow",
          "elevation-3",
          "0",
          "x"
        ]
      },
      y: {
        value: "12px",
        type: "y",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 12,
          type: "y"
        },
        name: "sd-shadow-elevation-3-0-y",
        attributes: {},
        path: [
          "shadow",
          "elevation-3",
          "0",
          "y"
        ]
      },
      blur: {
        value: "42px",
        type: "blur",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 42,
          type: "blur"
        },
        name: "sd-shadow-elevation-3-0-blur",
        attributes: {},
        path: [
          "shadow",
          "elevation-3",
          "0",
          "blur"
        ]
      },
      spread: {
        value: "-4px",
        type: "spread",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: -4,
          type: "spread"
        },
        name: "sd-shadow-elevation-3-0-spread",
        attributes: {},
        path: [
          "shadow",
          "elevation-3",
          "0",
          "spread"
        ]
      }
    },
    "1": {
      color: {
        value: "rgba(24, 39, 75, 0.12156862745098039)",
        type: "color",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "#18274b1f",
          type: "color"
        },
        name: "sd-shadow-elevation-3-1-color",
        attributes: {},
        path: [
          "shadow",
          "elevation-3",
          "1",
          "color"
        ]
      },
      type: {
        value: "dropShadow",
        type: "type",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "dropShadow",
          type: "type"
        },
        name: "sd-shadow-elevation-3-1-type",
        attributes: {},
        path: [
          "shadow",
          "elevation-3",
          "1",
          "type"
        ]
      },
      x: {
        value: "0px",
        type: "x",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 0,
          type: "x"
        },
        name: "sd-shadow-elevation-3-1-x",
        attributes: {},
        path: [
          "shadow",
          "elevation-3",
          "1",
          "x"
        ]
      },
      y: {
        value: "4px",
        type: "y",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 4,
          type: "y"
        },
        name: "sd-shadow-elevation-3-1-y",
        attributes: {},
        path: [
          "shadow",
          "elevation-3",
          "1",
          "y"
        ]
      },
      blur: {
        value: "16px",
        type: "blur",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 16,
          type: "blur"
        },
        name: "sd-shadow-elevation-3-1-blur",
        attributes: {},
        path: [
          "shadow",
          "elevation-3",
          "1",
          "blur"
        ]
      },
      spread: {
        value: "-6px",
        type: "spread",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: -6,
          type: "spread"
        },
        name: "sd-shadow-elevation-3-1-spread",
        attributes: {},
        path: [
          "shadow",
          "elevation-3",
          "1",
          "spread"
        ]
      }
    }
  },
  "elevation-4": {
    "0": {
      color: {
        value: "rgba(24, 39, 75, 0.1607843137254902)",
        type: "color",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "#18274b29",
          type: "color"
        },
        name: "sd-shadow-elevation-4-0-color",
        attributes: {},
        path: [
          "shadow",
          "elevation-4",
          "0",
          "color"
        ]
      },
      type: {
        value: "dropShadow",
        type: "type",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "dropShadow",
          type: "type"
        },
        name: "sd-shadow-elevation-4-0-type",
        attributes: {},
        path: [
          "shadow",
          "elevation-4",
          "0",
          "type"
        ]
      },
      x: {
        value: "0px",
        type: "x",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 0,
          type: "x"
        },
        name: "sd-shadow-elevation-4-0-x",
        attributes: {},
        path: [
          "shadow",
          "elevation-4",
          "0",
          "x"
        ]
      },
      y: {
        value: "18px",
        type: "y",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 18,
          type: "y"
        },
        name: "sd-shadow-elevation-4-0-y",
        attributes: {},
        path: [
          "shadow",
          "elevation-4",
          "0",
          "y"
        ]
      },
      blur: {
        value: "64px",
        type: "blur",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 64,
          type: "blur"
        },
        name: "sd-shadow-elevation-4-0-blur",
        attributes: {},
        path: [
          "shadow",
          "elevation-4",
          "0",
          "blur"
        ]
      },
      spread: {
        value: "-4px",
        type: "spread",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: -4,
          type: "spread"
        },
        name: "sd-shadow-elevation-4-0-spread",
        attributes: {},
        path: [
          "shadow",
          "elevation-4",
          "0",
          "spread"
        ]
      }
    },
    "1": {
      color: {
        value: "rgba(24, 39, 75, 0.12156862745098039)",
        type: "color",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "#18274b1f",
          type: "color"
        },
        name: "sd-shadow-elevation-4-1-color",
        attributes: {},
        path: [
          "shadow",
          "elevation-4",
          "1",
          "color"
        ]
      },
      type: {
        value: "dropShadow",
        type: "type",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "dropShadow",
          type: "type"
        },
        name: "sd-shadow-elevation-4-1-type",
        attributes: {},
        path: [
          "shadow",
          "elevation-4",
          "1",
          "type"
        ]
      },
      x: {
        value: "0px",
        type: "x",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 0,
          type: "x"
        },
        name: "sd-shadow-elevation-4-1-x",
        attributes: {},
        path: [
          "shadow",
          "elevation-4",
          "1",
          "x"
        ]
      },
      y: {
        value: "6px",
        type: "y",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 6,
          type: "y"
        },
        name: "sd-shadow-elevation-4-1-y",
        attributes: {},
        path: [
          "shadow",
          "elevation-4",
          "1",
          "y"
        ]
      },
      blur: {
        value: "28px",
        type: "blur",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 28,
          type: "blur"
        },
        name: "sd-shadow-elevation-4-1-blur",
        attributes: {},
        path: [
          "shadow",
          "elevation-4",
          "1",
          "blur"
        ]
      },
      spread: {
        value: "-6px",
        type: "spread",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: -6,
          type: "spread"
        },
        name: "sd-shadow-elevation-4-1-spread",
        attributes: {},
        path: [
          "shadow",
          "elevation-4",
          "1",
          "spread"
        ]
      }
    }
  }
};
const typography$3 = {
  display: {
    lg: {
      fontFamily: {
        value: "Brown LL",
        type: "fontFamilies",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "Brown LL",
          type: "fontFamilies"
        },
        name: "sd-typography-display-lg-font-family",
        attributes: {},
        path: [
          "typography",
          "display",
          "lg",
          "fontFamily"
        ]
      },
      fontWeight: {
        value: "Medium",
        type: "fontWeights",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "Medium",
          type: "fontWeights"
        },
        name: "sd-typography-display-lg-font-weight",
        attributes: {},
        path: [
          "typography",
          "display",
          "lg",
          "fontWeight"
        ]
      },
      lineHeight: {
        value: "72px",
        type: "lineHeight",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 72,
          type: "lineHeight"
        },
        name: "sd-typography-display-lg-line-height",
        attributes: {},
        path: [
          "typography",
          "display",
          "lg",
          "lineHeight"
        ]
      },
      fontSize: {
        value: "64px",
        type: "fontSizes",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 64,
          type: "fontSizes"
        },
        name: "sd-typography-display-lg-font-size",
        attributes: {},
        path: [
          "typography",
          "display",
          "lg",
          "fontSize"
        ]
      },
      letterSpacing: {
        value: "0px",
        type: "letterSpacing",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 0,
          type: "letterSpacing"
        },
        name: "sd-typography-display-lg-letter-spacing",
        attributes: {},
        path: [
          "typography",
          "display",
          "lg",
          "letterSpacing"
        ]
      },
      textDecoration: {
        value: "none",
        type: "textDecoration",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "none",
          type: "textDecoration"
        },
        name: "sd-typography-display-lg-text-decoration",
        attributes: {},
        path: [
          "typography",
          "display",
          "lg",
          "textDecoration"
        ]
      }
    },
    md: {
      fontFamily: {
        value: "Brown LL",
        type: "fontFamilies",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "Brown LL",
          type: "fontFamilies"
        },
        name: "sd-typography-display-md-font-family",
        attributes: {},
        path: [
          "typography",
          "display",
          "md",
          "fontFamily"
        ]
      },
      fontWeight: {
        value: "Bold",
        type: "fontWeights",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "Bold",
          type: "fontWeights"
        },
        name: "sd-typography-display-md-font-weight",
        attributes: {},
        path: [
          "typography",
          "display",
          "md",
          "fontWeight"
        ]
      },
      lineHeight: {
        value: "64px",
        type: "lineHeight",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 64,
          type: "lineHeight"
        },
        name: "sd-typography-display-md-line-height",
        attributes: {},
        path: [
          "typography",
          "display",
          "md",
          "lineHeight"
        ]
      },
      fontSize: {
        value: "56px",
        type: "fontSizes",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 56,
          type: "fontSizes"
        },
        name: "sd-typography-display-md-font-size",
        attributes: {},
        path: [
          "typography",
          "display",
          "md",
          "fontSize"
        ]
      },
      letterSpacing: {
        value: "0px",
        type: "letterSpacing",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 0,
          type: "letterSpacing"
        },
        name: "sd-typography-display-md-letter-spacing",
        attributes: {},
        path: [
          "typography",
          "display",
          "md",
          "letterSpacing"
        ]
      },
      textDecoration: {
        value: "none",
        type: "textDecoration",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "none",
          type: "textDecoration"
        },
        name: "sd-typography-display-md-text-decoration",
        attributes: {},
        path: [
          "typography",
          "display",
          "md",
          "textDecoration"
        ]
      }
    },
    "md-sm": {
      fontFamily: {
        value: "Brown LL",
        type: "fontFamilies",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "Brown LL",
          type: "fontFamilies"
        },
        name: "sd-typography-display-md-sm-font-family",
        attributes: {},
        path: [
          "typography",
          "display",
          "md-sm",
          "fontFamily"
        ]
      },
      fontWeight: {
        value: "Bold",
        type: "fontWeights",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "Bold",
          type: "fontWeights"
        },
        name: "sd-typography-display-md-sm-font-weight",
        attributes: {},
        path: [
          "typography",
          "display",
          "md-sm",
          "fontWeight"
        ]
      },
      lineHeight: {
        value: "56px",
        type: "lineHeight",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 56,
          type: "lineHeight"
        },
        name: "sd-typography-display-md-sm-line-height",
        attributes: {},
        path: [
          "typography",
          "display",
          "md-sm",
          "lineHeight"
        ]
      },
      fontSize: {
        value: "48px",
        type: "fontSizes",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 48,
          type: "fontSizes"
        },
        name: "sd-typography-display-md-sm-font-size",
        attributes: {},
        path: [
          "typography",
          "display",
          "md-sm",
          "fontSize"
        ]
      },
      letterSpacing: {
        value: "0px",
        type: "letterSpacing",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 0,
          type: "letterSpacing"
        },
        name: "sd-typography-display-md-sm-letter-spacing",
        attributes: {},
        path: [
          "typography",
          "display",
          "md-sm",
          "letterSpacing"
        ]
      },
      textDecoration: {
        value: "none",
        type: "textDecoration",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "none",
          type: "textDecoration"
        },
        name: "sd-typography-display-md-sm-text-decoration",
        attributes: {},
        path: [
          "typography",
          "display",
          "md-sm",
          "textDecoration"
        ]
      }
    },
    sm: {
      fontFamily: {
        value: "Brown LL",
        type: "fontFamilies",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "Brown LL",
          type: "fontFamilies"
        },
        name: "sd-typography-display-sm-font-family",
        attributes: {},
        path: [
          "typography",
          "display",
          "sm",
          "fontFamily"
        ]
      },
      fontWeight: {
        value: "Medium",
        type: "fontWeights",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "Medium",
          type: "fontWeights"
        },
        name: "sd-typography-display-sm-font-weight",
        attributes: {},
        path: [
          "typography",
          "display",
          "sm",
          "fontWeight"
        ]
      },
      lineHeight: {
        value: "48px",
        type: "lineHeight",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 48,
          type: "lineHeight"
        },
        name: "sd-typography-display-sm-line-height",
        attributes: {},
        path: [
          "typography",
          "display",
          "sm",
          "lineHeight"
        ]
      },
      fontSize: {
        value: "40px",
        type: "fontSizes",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 40,
          type: "fontSizes"
        },
        name: "sd-typography-display-sm-font-size",
        attributes: {},
        path: [
          "typography",
          "display",
          "sm",
          "fontSize"
        ]
      },
      letterSpacing: {
        value: "0px",
        type: "letterSpacing",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 0,
          type: "letterSpacing"
        },
        name: "sd-typography-display-sm-letter-spacing",
        attributes: {},
        path: [
          "typography",
          "display",
          "sm",
          "letterSpacing"
        ]
      },
      textDecoration: {
        value: "none",
        type: "textDecoration",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "none",
          type: "textDecoration"
        },
        name: "sd-typography-display-sm-text-decoration",
        attributes: {},
        path: [
          "typography",
          "display",
          "sm",
          "textDecoration"
        ]
      }
    }
  },
  headline: {
    xl: {
      fontFamily: {
        value: "Brown LL",
        type: "fontFamilies",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "Brown LL",
          type: "fontFamilies"
        },
        name: "sd-typography-headline-xl-font-family",
        attributes: {},
        path: [
          "typography",
          "headline",
          "xl",
          "fontFamily"
        ]
      },
      fontWeight: {
        value: "Bold",
        type: "fontWeights",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "Bold",
          type: "fontWeights"
        },
        name: "sd-typography-headline-xl-font-weight",
        attributes: {},
        path: [
          "typography",
          "headline",
          "xl",
          "fontWeight"
        ]
      },
      lineHeight: {
        value: "40px",
        type: "lineHeight",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 40,
          type: "lineHeight"
        },
        name: "sd-typography-headline-xl-line-height",
        attributes: {},
        path: [
          "typography",
          "headline",
          "xl",
          "lineHeight"
        ]
      },
      fontSize: {
        value: "32px",
        type: "fontSizes",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 32,
          type: "fontSizes"
        },
        name: "sd-typography-headline-xl-font-size",
        attributes: {},
        path: [
          "typography",
          "headline",
          "xl",
          "fontSize"
        ]
      },
      letterSpacing: {
        value: "-1px",
        type: "letterSpacing",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: -1,
          type: "letterSpacing"
        },
        name: "sd-typography-headline-xl-letter-spacing",
        attributes: {},
        path: [
          "typography",
          "headline",
          "xl",
          "letterSpacing"
        ]
      },
      textDecoration: {
        value: "none",
        type: "textDecoration",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "none",
          type: "textDecoration"
        },
        name: "sd-typography-headline-xl-text-decoration",
        attributes: {},
        path: [
          "typography",
          "headline",
          "xl",
          "textDecoration"
        ]
      }
    },
    lg: {
      fontFamily: {
        value: "Brown LL",
        type: "fontFamilies",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "Brown LL",
          type: "fontFamilies"
        },
        name: "sd-typography-headline-lg-font-family",
        attributes: {},
        path: [
          "typography",
          "headline",
          "lg",
          "fontFamily"
        ]
      },
      fontWeight: {
        value: "Bold",
        type: "fontWeights",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "Bold",
          type: "fontWeights"
        },
        name: "sd-typography-headline-lg-font-weight",
        attributes: {},
        path: [
          "typography",
          "headline",
          "lg",
          "fontWeight"
        ]
      },
      lineHeight: {
        value: "32px",
        type: "lineHeight",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 32,
          type: "lineHeight"
        },
        name: "sd-typography-headline-lg-line-height",
        attributes: {},
        path: [
          "typography",
          "headline",
          "lg",
          "lineHeight"
        ]
      },
      fontSize: {
        value: "24px",
        type: "fontSizes",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 24,
          type: "fontSizes"
        },
        name: "sd-typography-headline-lg-font-size",
        attributes: {},
        path: [
          "typography",
          "headline",
          "lg",
          "fontSize"
        ]
      },
      letterSpacing: {
        value: "-0.75px",
        type: "letterSpacing",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: -0.75,
          type: "letterSpacing"
        },
        name: "sd-typography-headline-lg-letter-spacing",
        attributes: {},
        path: [
          "typography",
          "headline",
          "lg",
          "letterSpacing"
        ]
      },
      textDecoration: {
        value: "none",
        type: "textDecoration",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "none",
          type: "textDecoration"
        },
        name: "sd-typography-headline-lg-text-decoration",
        attributes: {},
        path: [
          "typography",
          "headline",
          "lg",
          "textDecoration"
        ]
      }
    },
    md: {
      fontFamily: {
        value: "Brown LL",
        type: "fontFamilies",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "Brown LL",
          type: "fontFamilies"
        },
        name: "sd-typography-headline-md-font-family",
        attributes: {},
        path: [
          "typography",
          "headline",
          "md",
          "fontFamily"
        ]
      },
      fontWeight: {
        value: "Bold",
        type: "fontWeights",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "Bold",
          type: "fontWeights"
        },
        name: "sd-typography-headline-md-font-weight",
        attributes: {},
        path: [
          "typography",
          "headline",
          "md",
          "fontWeight"
        ]
      },
      lineHeight: {
        value: "26px",
        type: "lineHeight",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 26,
          type: "lineHeight"
        },
        name: "sd-typography-headline-md-line-height",
        attributes: {},
        path: [
          "typography",
          "headline",
          "md",
          "lineHeight"
        ]
      },
      fontSize: {
        value: "20px",
        type: "fontSizes",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 20,
          type: "fontSizes"
        },
        name: "sd-typography-headline-md-font-size",
        attributes: {},
        path: [
          "typography",
          "headline",
          "md",
          "fontSize"
        ]
      },
      letterSpacing: {
        value: "-0.25px",
        type: "letterSpacing",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: -0.25,
          type: "letterSpacing"
        },
        name: "sd-typography-headline-md-letter-spacing",
        attributes: {},
        path: [
          "typography",
          "headline",
          "md",
          "letterSpacing"
        ]
      },
      textDecoration: {
        value: "none",
        type: "textDecoration",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "none",
          type: "textDecoration"
        },
        name: "sd-typography-headline-md-text-decoration",
        attributes: {},
        path: [
          "typography",
          "headline",
          "md",
          "textDecoration"
        ]
      }
    },
    sm: {
      fontFamily: {
        value: "Brown LL",
        type: "fontFamilies",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "Brown LL",
          type: "fontFamilies"
        },
        name: "sd-typography-headline-sm-font-family",
        attributes: {},
        path: [
          "typography",
          "headline",
          "sm",
          "fontFamily"
        ]
      },
      fontWeight: {
        value: "Bold",
        type: "fontWeights",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "Bold",
          type: "fontWeights"
        },
        name: "sd-typography-headline-sm-font-weight",
        attributes: {},
        path: [
          "typography",
          "headline",
          "sm",
          "fontWeight"
        ]
      },
      lineHeight: {
        value: "24px",
        type: "lineHeight",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 24,
          type: "lineHeight"
        },
        name: "sd-typography-headline-sm-line-height",
        attributes: {},
        path: [
          "typography",
          "headline",
          "sm",
          "lineHeight"
        ]
      },
      fontSize: {
        value: "18px",
        type: "fontSizes",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 18,
          type: "fontSizes"
        },
        name: "sd-typography-headline-sm-font-size",
        attributes: {},
        path: [
          "typography",
          "headline",
          "sm",
          "fontSize"
        ]
      },
      letterSpacing: {
        value: "-0.5px",
        type: "letterSpacing",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: -0.5,
          type: "letterSpacing"
        },
        name: "sd-typography-headline-sm-letter-spacing",
        attributes: {},
        path: [
          "typography",
          "headline",
          "sm",
          "letterSpacing"
        ]
      },
      textDecoration: {
        value: "none",
        type: "textDecoration",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "none",
          type: "textDecoration"
        },
        name: "sd-typography-headline-sm-text-decoration",
        attributes: {},
        path: [
          "typography",
          "headline",
          "sm",
          "textDecoration"
        ]
      }
    },
    xs: {
      fontFamily: {
        value: "Brown LL",
        type: "fontFamilies",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "Brown LL",
          type: "fontFamilies"
        },
        name: "sd-typography-headline-xs-font-family",
        attributes: {},
        path: [
          "typography",
          "headline",
          "xs",
          "fontFamily"
        ]
      },
      fontWeight: {
        value: "Bold",
        type: "fontWeights",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "Bold",
          type: "fontWeights"
        },
        name: "sd-typography-headline-xs-font-weight",
        attributes: {},
        path: [
          "typography",
          "headline",
          "xs",
          "fontWeight"
        ]
      },
      lineHeight: {
        value: "20px",
        type: "lineHeight",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 20,
          type: "lineHeight"
        },
        name: "sd-typography-headline-xs-line-height",
        attributes: {},
        path: [
          "typography",
          "headline",
          "xs",
          "lineHeight"
        ]
      },
      fontSize: {
        value: "16px",
        type: "fontSizes",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 16,
          type: "fontSizes"
        },
        name: "sd-typography-headline-xs-font-size",
        attributes: {},
        path: [
          "typography",
          "headline",
          "xs",
          "fontSize"
        ]
      },
      letterSpacing: {
        value: "-0.5px",
        type: "letterSpacing",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: -0.5,
          type: "letterSpacing"
        },
        name: "sd-typography-headline-xs-letter-spacing",
        attributes: {},
        path: [
          "typography",
          "headline",
          "xs",
          "letterSpacing"
        ]
      },
      textDecoration: {
        value: "none",
        type: "textDecoration",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "none",
          type: "textDecoration"
        },
        name: "sd-typography-headline-xs-text-decoration",
        attributes: {},
        path: [
          "typography",
          "headline",
          "xs",
          "textDecoration"
        ]
      }
    },
    xxs: {
      fontFamily: {
        value: "Brown LL",
        type: "fontFamilies",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "Brown LL",
          type: "fontFamilies"
        },
        name: "sd-typography-headline-xxs-font-family",
        attributes: {},
        path: [
          "typography",
          "headline",
          "xxs",
          "fontFamily"
        ]
      },
      fontWeight: {
        value: "Bold",
        type: "fontWeights",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "Bold",
          type: "fontWeights"
        },
        name: "sd-typography-headline-xxs-font-weight",
        attributes: {},
        path: [
          "typography",
          "headline",
          "xxs",
          "fontWeight"
        ]
      },
      lineHeight: {
        value: "18px",
        type: "lineHeight",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 18,
          type: "lineHeight"
        },
        name: "sd-typography-headline-xxs-line-height",
        attributes: {},
        path: [
          "typography",
          "headline",
          "xxs",
          "lineHeight"
        ]
      },
      fontSize: {
        value: "14px",
        type: "fontSizes",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 14,
          type: "fontSizes"
        },
        name: "sd-typography-headline-xxs-font-size",
        attributes: {},
        path: [
          "typography",
          "headline",
          "xxs",
          "fontSize"
        ]
      },
      letterSpacing: {
        value: "-0.25px",
        type: "letterSpacing",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: -0.25,
          type: "letterSpacing"
        },
        name: "sd-typography-headline-xxs-letter-spacing",
        attributes: {},
        path: [
          "typography",
          "headline",
          "xxs",
          "letterSpacing"
        ]
      },
      textDecoration: {
        value: "none",
        type: "textDecoration",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "none",
          type: "textDecoration"
        },
        name: "sd-typography-headline-xxs-text-decoration",
        attributes: {},
        path: [
          "typography",
          "headline",
          "xxs",
          "textDecoration"
        ]
      }
    },
    xxxs: {
      fontFamily: {
        value: "Brown LL",
        type: "fontFamilies",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "Brown LL",
          type: "fontFamilies"
        },
        name: "sd-typography-headline-xxxs-font-family",
        attributes: {},
        path: [
          "typography",
          "headline",
          "xxxs",
          "fontFamily"
        ]
      },
      fontWeight: {
        value: "Bold",
        type: "fontWeights",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "Bold",
          type: "fontWeights"
        },
        name: "sd-typography-headline-xxxs-font-weight",
        attributes: {},
        path: [
          "typography",
          "headline",
          "xxxs",
          "fontWeight"
        ]
      },
      lineHeight: {
        value: "14px",
        type: "lineHeight",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 14,
          type: "lineHeight"
        },
        name: "sd-typography-headline-xxxs-line-height",
        attributes: {},
        path: [
          "typography",
          "headline",
          "xxxs",
          "lineHeight"
        ]
      },
      fontSize: {
        value: "12px",
        type: "fontSizes",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 12,
          type: "fontSizes"
        },
        name: "sd-typography-headline-xxxs-font-size",
        attributes: {},
        path: [
          "typography",
          "headline",
          "xxxs",
          "fontSize"
        ]
      },
      letterSpacing: {
        value: "-0.25px",
        type: "letterSpacing",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: -0.25,
          type: "letterSpacing"
        },
        name: "sd-typography-headline-xxxs-letter-spacing",
        attributes: {},
        path: [
          "typography",
          "headline",
          "xxxs",
          "letterSpacing"
        ]
      },
      textDecoration: {
        value: "none",
        type: "textDecoration",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "none",
          type: "textDecoration"
        },
        name: "sd-typography-headline-xxxs-text-decoration",
        attributes: {},
        path: [
          "typography",
          "headline",
          "xxxs",
          "textDecoration"
        ]
      }
    }
  },
  body: {
    xl: {
      fontFamily: {
        value: "Brown LL",
        type: "fontFamilies",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "Brown LL",
          type: "fontFamilies"
        },
        name: "sd-typography-body-xl-font-family",
        attributes: {},
        path: [
          "typography",
          "body",
          "xl",
          "fontFamily"
        ]
      },
      fontWeight: {
        value: "Regular",
        type: "fontWeights",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "Regular",
          type: "fontWeights"
        },
        name: "sd-typography-body-xl-font-weight",
        attributes: {},
        path: [
          "typography",
          "body",
          "xl",
          "fontWeight"
        ]
      },
      lineHeight: {
        value: "24px",
        type: "lineHeight",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 24,
          type: "lineHeight"
        },
        name: "sd-typography-body-xl-line-height",
        attributes: {},
        path: [
          "typography",
          "body",
          "xl",
          "lineHeight"
        ]
      },
      fontSize: {
        value: "18px",
        type: "fontSizes",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 18,
          type: "fontSizes"
        },
        name: "sd-typography-body-xl-font-size",
        attributes: {},
        path: [
          "typography",
          "body",
          "xl",
          "fontSize"
        ]
      },
      letterSpacing: {
        value: "-0.5px",
        type: "letterSpacing",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: -0.5,
          type: "letterSpacing"
        },
        name: "sd-typography-body-xl-letter-spacing",
        attributes: {},
        path: [
          "typography",
          "body",
          "xl",
          "letterSpacing"
        ]
      },
      textDecoration: {
        value: "none",
        type: "textDecoration",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "none",
          type: "textDecoration"
        },
        name: "sd-typography-body-xl-text-decoration",
        attributes: {},
        path: [
          "typography",
          "body",
          "xl",
          "textDecoration"
        ]
      }
    },
    lg: {
      fontFamily: {
        value: "Brown LL",
        type: "fontFamilies",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "Brown LL",
          type: "fontFamilies"
        },
        name: "sd-typography-body-lg-font-family",
        attributes: {},
        path: [
          "typography",
          "body",
          "lg",
          "fontFamily"
        ]
      },
      fontWeight: {
        value: "Regular",
        type: "fontWeights",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "Regular",
          type: "fontWeights"
        },
        name: "sd-typography-body-lg-font-weight",
        attributes: {},
        path: [
          "typography",
          "body",
          "lg",
          "fontWeight"
        ]
      },
      lineHeight: {
        value: "20px",
        type: "lineHeight",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 20,
          type: "lineHeight"
        },
        name: "sd-typography-body-lg-line-height",
        attributes: {},
        path: [
          "typography",
          "body",
          "lg",
          "lineHeight"
        ]
      },
      fontSize: {
        value: "16px",
        type: "fontSizes",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 16,
          type: "fontSizes"
        },
        name: "sd-typography-body-lg-font-size",
        attributes: {},
        path: [
          "typography",
          "body",
          "lg",
          "fontSize"
        ]
      },
      letterSpacing: {
        value: "-0.5px",
        type: "letterSpacing",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: -0.5,
          type: "letterSpacing"
        },
        name: "sd-typography-body-lg-letter-spacing",
        attributes: {},
        path: [
          "typography",
          "body",
          "lg",
          "letterSpacing"
        ]
      },
      textDecoration: {
        value: "none",
        type: "textDecoration",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "none",
          type: "textDecoration"
        },
        name: "sd-typography-body-lg-text-decoration",
        attributes: {},
        path: [
          "typography",
          "body",
          "lg",
          "textDecoration"
        ]
      }
    },
    md: {
      fontFamily: {
        value: "Brown LL",
        type: "fontFamilies",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "Brown LL",
          type: "fontFamilies"
        },
        name: "sd-typography-body-md-font-family",
        attributes: {},
        path: [
          "typography",
          "body",
          "md",
          "fontFamily"
        ]
      },
      fontWeight: {
        value: "Regular",
        type: "fontWeights",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "Regular",
          type: "fontWeights"
        },
        name: "sd-typography-body-md-font-weight",
        attributes: {},
        path: [
          "typography",
          "body",
          "md",
          "fontWeight"
        ]
      },
      lineHeight: {
        value: "18px",
        type: "lineHeight",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 18,
          type: "lineHeight"
        },
        name: "sd-typography-body-md-line-height",
        attributes: {},
        path: [
          "typography",
          "body",
          "md",
          "lineHeight"
        ]
      },
      fontSize: {
        value: "14px",
        type: "fontSizes",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 14,
          type: "fontSizes"
        },
        name: "sd-typography-body-md-font-size",
        attributes: {},
        path: [
          "typography",
          "body",
          "md",
          "fontSize"
        ]
      },
      letterSpacing: {
        value: "-0.25px",
        type: "letterSpacing",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: -0.25,
          type: "letterSpacing"
        },
        name: "sd-typography-body-md-letter-spacing",
        attributes: {},
        path: [
          "typography",
          "body",
          "md",
          "letterSpacing"
        ]
      },
      textDecoration: {
        value: "none",
        type: "textDecoration",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "none",
          type: "textDecoration"
        },
        name: "sd-typography-body-md-text-decoration",
        attributes: {},
        path: [
          "typography",
          "body",
          "md",
          "textDecoration"
        ]
      }
    },
    sm: {
      fontFamily: {
        value: "Brown LL",
        type: "fontFamilies",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "Brown LL",
          type: "fontFamilies"
        },
        name: "sd-typography-body-sm-font-family",
        attributes: {},
        path: [
          "typography",
          "body",
          "sm",
          "fontFamily"
        ]
      },
      fontWeight: {
        value: "Regular",
        type: "fontWeights",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "Regular",
          type: "fontWeights"
        },
        name: "sd-typography-body-sm-font-weight",
        attributes: {},
        path: [
          "typography",
          "body",
          "sm",
          "fontWeight"
        ]
      },
      lineHeight: {
        value: "16px",
        type: "lineHeight",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 16,
          type: "lineHeight"
        },
        name: "sd-typography-body-sm-line-height",
        attributes: {},
        path: [
          "typography",
          "body",
          "sm",
          "lineHeight"
        ]
      },
      fontSize: {
        value: "12px",
        type: "fontSizes",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 12,
          type: "fontSizes"
        },
        name: "sd-typography-body-sm-font-size",
        attributes: {},
        path: [
          "typography",
          "body",
          "sm",
          "fontSize"
        ]
      },
      letterSpacing: {
        value: "-0.25px",
        type: "letterSpacing",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: -0.25,
          type: "letterSpacing"
        },
        name: "sd-typography-body-sm-letter-spacing",
        attributes: {},
        path: [
          "typography",
          "body",
          "sm",
          "letterSpacing"
        ]
      },
      textDecoration: {
        value: "none",
        type: "textDecoration",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "none",
          type: "textDecoration"
        },
        name: "sd-typography-body-sm-text-decoration",
        attributes: {},
        path: [
          "typography",
          "body",
          "sm",
          "textDecoration"
        ]
      }
    },
    xs: {
      fontFamily: {
        value: "Brown LL",
        type: "fontFamilies",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "Brown LL",
          type: "fontFamilies"
        },
        name: "sd-typography-body-xs-font-family",
        attributes: {},
        path: [
          "typography",
          "body",
          "xs",
          "fontFamily"
        ]
      },
      fontWeight: {
        value: "Regular",
        type: "fontWeights",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "Regular",
          type: "fontWeights"
        },
        name: "sd-typography-body-xs-font-weight",
        attributes: {},
        path: [
          "typography",
          "body",
          "xs",
          "fontWeight"
        ]
      },
      lineHeight: {
        value: "14px",
        type: "lineHeight",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 14,
          type: "lineHeight"
        },
        name: "sd-typography-body-xs-line-height",
        attributes: {},
        path: [
          "typography",
          "body",
          "xs",
          "lineHeight"
        ]
      },
      fontSize: {
        value: "10px",
        type: "fontSizes",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 10,
          type: "fontSizes"
        },
        name: "sd-typography-body-xs-font-size",
        attributes: {},
        path: [
          "typography",
          "body",
          "xs",
          "fontSize"
        ]
      },
      letterSpacing: {
        value: "-0.25px",
        type: "letterSpacing",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: -0.25,
          type: "letterSpacing"
        },
        name: "sd-typography-body-xs-letter-spacing",
        attributes: {},
        path: [
          "typography",
          "body",
          "xs",
          "letterSpacing"
        ]
      },
      textDecoration: {
        value: "none",
        type: "textDecoration",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "none",
          type: "textDecoration"
        },
        name: "sd-typography-body-xs-text-decoration",
        attributes: {},
        path: [
          "typography",
          "body",
          "xs",
          "textDecoration"
        ]
      }
    },
    xxs: {
      fontFamily: {
        value: "Brown LL",
        type: "fontFamilies",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "Brown LL",
          type: "fontFamilies"
        },
        name: "sd-typography-body-xxs-font-family",
        attributes: {},
        path: [
          "typography",
          "body",
          "xxs",
          "fontFamily"
        ]
      },
      fontWeight: {
        value: "Regular",
        type: "fontWeights",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "Regular",
          type: "fontWeights"
        },
        name: "sd-typography-body-xxs-font-weight",
        attributes: {},
        path: [
          "typography",
          "body",
          "xxs",
          "fontWeight"
        ]
      },
      lineHeight: {
        value: "12px",
        type: "lineHeight",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 12,
          type: "lineHeight"
        },
        name: "sd-typography-body-xxs-line-height",
        attributes: {},
        path: [
          "typography",
          "body",
          "xxs",
          "lineHeight"
        ]
      },
      fontSize: {
        value: "8px",
        type: "fontSizes",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 8,
          type: "fontSizes"
        },
        name: "sd-typography-body-xxs-font-size",
        attributes: {},
        path: [
          "typography",
          "body",
          "xxs",
          "fontSize"
        ]
      },
      letterSpacing: {
        value: "-0.25px",
        type: "letterSpacing",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: -0.25,
          type: "letterSpacing"
        },
        name: "sd-typography-body-xxs-letter-spacing",
        attributes: {},
        path: [
          "typography",
          "body",
          "xxs",
          "letterSpacing"
        ]
      },
      textDecoration: {
        value: "none",
        type: "textDecoration",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "none",
          type: "textDecoration"
        },
        name: "sd-typography-body-xxs-text-decoration",
        attributes: {},
        path: [
          "typography",
          "body",
          "xxs",
          "textDecoration"
        ]
      }
    }
  },
  label: {
    xl: {
      fontFamily: {
        value: "Brown LL",
        type: "fontFamilies",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "Brown LL",
          type: "fontFamilies"
        },
        name: "sd-typography-label-xl-font-family",
        attributes: {},
        path: [
          "typography",
          "label",
          "xl",
          "fontFamily"
        ]
      },
      fontWeight: {
        value: "Medium",
        type: "fontWeights",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "Medium",
          type: "fontWeights"
        },
        name: "sd-typography-label-xl-font-weight",
        attributes: {},
        path: [
          "typography",
          "label",
          "xl",
          "fontWeight"
        ]
      },
      lineHeight: {
        value: "22px",
        type: "lineHeight",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 22,
          type: "lineHeight"
        },
        name: "sd-typography-label-xl-line-height",
        attributes: {},
        path: [
          "typography",
          "label",
          "xl",
          "lineHeight"
        ]
      },
      fontSize: {
        value: "18px",
        type: "fontSizes",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 18,
          type: "fontSizes"
        },
        name: "sd-typography-label-xl-font-size",
        attributes: {},
        path: [
          "typography",
          "label",
          "xl",
          "fontSize"
        ]
      },
      letterSpacing: {
        value: "-0.5px",
        type: "letterSpacing",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: -0.5,
          type: "letterSpacing"
        },
        name: "sd-typography-label-xl-letter-spacing",
        attributes: {},
        path: [
          "typography",
          "label",
          "xl",
          "letterSpacing"
        ]
      },
      textDecoration: {
        value: "none",
        type: "textDecoration",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "none",
          type: "textDecoration"
        },
        name: "sd-typography-label-xl-text-decoration",
        attributes: {},
        path: [
          "typography",
          "label",
          "xl",
          "textDecoration"
        ]
      }
    },
    lg: {
      fontFamily: {
        value: "Brown LL",
        type: "fontFamilies",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "Brown LL",
          type: "fontFamilies"
        },
        name: "sd-typography-label-lg-font-family",
        attributes: {},
        path: [
          "typography",
          "label",
          "lg",
          "fontFamily"
        ]
      },
      fontWeight: {
        value: "Medium",
        type: "fontWeights",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "Medium",
          type: "fontWeights"
        },
        name: "sd-typography-label-lg-font-weight",
        attributes: {},
        path: [
          "typography",
          "label",
          "lg",
          "fontWeight"
        ]
      },
      lineHeight: {
        value: "20px",
        type: "lineHeight",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 20,
          type: "lineHeight"
        },
        name: "sd-typography-label-lg-line-height",
        attributes: {},
        path: [
          "typography",
          "label",
          "lg",
          "lineHeight"
        ]
      },
      fontSize: {
        value: "16px",
        type: "fontSizes",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 16,
          type: "fontSizes"
        },
        name: "sd-typography-label-lg-font-size",
        attributes: {},
        path: [
          "typography",
          "label",
          "lg",
          "fontSize"
        ]
      },
      letterSpacing: {
        value: "-0.5px",
        type: "letterSpacing",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: -0.5,
          type: "letterSpacing"
        },
        name: "sd-typography-label-lg-letter-spacing",
        attributes: {},
        path: [
          "typography",
          "label",
          "lg",
          "letterSpacing"
        ]
      },
      textDecoration: {
        value: "none",
        type: "textDecoration",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "none",
          type: "textDecoration"
        },
        name: "sd-typography-label-lg-text-decoration",
        attributes: {},
        path: [
          "typography",
          "label",
          "lg",
          "textDecoration"
        ]
      }
    },
    md: {
      fontFamily: {
        value: "Brown LL",
        type: "fontFamilies",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "Brown LL",
          type: "fontFamilies"
        },
        name: "sd-typography-label-md-font-family",
        attributes: {},
        path: [
          "typography",
          "label",
          "md",
          "fontFamily"
        ]
      },
      fontWeight: {
        value: "Medium",
        type: "fontWeights",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "Medium",
          type: "fontWeights"
        },
        name: "sd-typography-label-md-font-weight",
        attributes: {},
        path: [
          "typography",
          "label",
          "md",
          "fontWeight"
        ]
      },
      lineHeight: {
        value: "18px",
        type: "lineHeight",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 18,
          type: "lineHeight"
        },
        name: "sd-typography-label-md-line-height",
        attributes: {},
        path: [
          "typography",
          "label",
          "md",
          "lineHeight"
        ]
      },
      fontSize: {
        value: "14px",
        type: "fontSizes",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 14,
          type: "fontSizes"
        },
        name: "sd-typography-label-md-font-size",
        attributes: {},
        path: [
          "typography",
          "label",
          "md",
          "fontSize"
        ]
      },
      letterSpacing: {
        value: "-0.5px",
        type: "letterSpacing",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: -0.5,
          type: "letterSpacing"
        },
        name: "sd-typography-label-md-letter-spacing",
        attributes: {},
        path: [
          "typography",
          "label",
          "md",
          "letterSpacing"
        ]
      },
      textDecoration: {
        value: "none",
        type: "textDecoration",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "none",
          type: "textDecoration"
        },
        name: "sd-typography-label-md-text-decoration",
        attributes: {},
        path: [
          "typography",
          "label",
          "md",
          "textDecoration"
        ]
      }
    },
    sm: {
      fontFamily: {
        value: "Brown LL",
        type: "fontFamilies",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "Brown LL",
          type: "fontFamilies"
        },
        name: "sd-typography-label-sm-font-family",
        attributes: {},
        path: [
          "typography",
          "label",
          "sm",
          "fontFamily"
        ]
      },
      fontWeight: {
        value: "Bold",
        type: "fontWeights",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "Bold",
          type: "fontWeights"
        },
        name: "sd-typography-label-sm-font-weight",
        attributes: {},
        path: [
          "typography",
          "label",
          "sm",
          "fontWeight"
        ]
      },
      lineHeight: {
        value: "16px",
        type: "lineHeight",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 16,
          type: "lineHeight"
        },
        name: "sd-typography-label-sm-line-height",
        attributes: {},
        path: [
          "typography",
          "label",
          "sm",
          "lineHeight"
        ]
      },
      fontSize: {
        value: "12px",
        type: "fontSizes",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 12,
          type: "fontSizes"
        },
        name: "sd-typography-label-sm-font-size",
        attributes: {},
        path: [
          "typography",
          "label",
          "sm",
          "fontSize"
        ]
      },
      letterSpacing: {
        value: "0px",
        type: "letterSpacing",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 0,
          type: "letterSpacing"
        },
        name: "sd-typography-label-sm-letter-spacing",
        attributes: {},
        path: [
          "typography",
          "label",
          "sm",
          "letterSpacing"
        ]
      },
      textDecoration: {
        value: "none",
        type: "textDecoration",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "none",
          type: "textDecoration"
        },
        name: "sd-typography-label-sm-text-decoration",
        attributes: {},
        path: [
          "typography",
          "label",
          "sm",
          "textDecoration"
        ]
      }
    },
    xs: {
      fontFamily: {
        value: "Brown LL",
        type: "fontFamilies",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "Brown LL",
          type: "fontFamilies"
        },
        name: "sd-typography-label-xs-font-family",
        attributes: {},
        path: [
          "typography",
          "label",
          "xs",
          "fontFamily"
        ]
      },
      fontWeight: {
        value: "Bold",
        type: "fontWeights",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "Bold",
          type: "fontWeights"
        },
        name: "sd-typography-label-xs-font-weight",
        attributes: {},
        path: [
          "typography",
          "label",
          "xs",
          "fontWeight"
        ]
      },
      lineHeight: {
        value: "14px",
        type: "lineHeight",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 14,
          type: "lineHeight"
        },
        name: "sd-typography-label-xs-line-height",
        attributes: {},
        path: [
          "typography",
          "label",
          "xs",
          "lineHeight"
        ]
      },
      fontSize: {
        value: "10px",
        type: "fontSizes",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 10,
          type: "fontSizes"
        },
        name: "sd-typography-label-xs-font-size",
        attributes: {},
        path: [
          "typography",
          "label",
          "xs",
          "fontSize"
        ]
      },
      letterSpacing: {
        value: "-0.25px",
        type: "letterSpacing",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: -0.25,
          type: "letterSpacing"
        },
        name: "sd-typography-label-xs-letter-spacing",
        attributes: {},
        path: [
          "typography",
          "label",
          "xs",
          "letterSpacing"
        ]
      },
      textDecoration: {
        value: "none",
        type: "textDecoration",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "none",
          type: "textDecoration"
        },
        name: "sd-typography-label-xs-text-decoration",
        attributes: {},
        path: [
          "typography",
          "label",
          "xs",
          "textDecoration"
        ]
      }
    },
    xxs: {
      fontFamily: {
        value: "Brown LL",
        type: "fontFamilies",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "Brown LL",
          type: "fontFamilies"
        },
        name: "sd-typography-label-xxs-font-family",
        attributes: {},
        path: [
          "typography",
          "label",
          "xxs",
          "fontFamily"
        ]
      },
      fontWeight: {
        value: "Bold",
        type: "fontWeights",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "Bold",
          type: "fontWeights"
        },
        name: "sd-typography-label-xxs-font-weight",
        attributes: {},
        path: [
          "typography",
          "label",
          "xxs",
          "fontWeight"
        ]
      },
      lineHeight: {
        value: "12px",
        type: "lineHeight",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 12,
          type: "lineHeight"
        },
        name: "sd-typography-label-xxs-line-height",
        attributes: {},
        path: [
          "typography",
          "label",
          "xxs",
          "lineHeight"
        ]
      },
      fontSize: {
        value: "9px",
        type: "fontSizes",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: 9,
          type: "fontSizes"
        },
        name: "sd-typography-label-xxs-font-size",
        attributes: {},
        path: [
          "typography",
          "label",
          "xxs",
          "fontSize"
        ]
      },
      letterSpacing: {
        value: "-0.25px",
        type: "letterSpacing",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: -0.25,
          type: "letterSpacing"
        },
        name: "sd-typography-label-xxs-letter-spacing",
        attributes: {},
        path: [
          "typography",
          "label",
          "xxs",
          "letterSpacing"
        ]
      },
      textDecoration: {
        value: "none",
        type: "textDecoration",
        filePath: "themes/popularpay-light.json",
        isSource: true,
        original: {
          value: "none",
          type: "textDecoration"
        },
        name: "sd-typography-label-xxs-text-decoration",
        attributes: {},
        path: [
          "typography",
          "label",
          "xxs",
          "textDecoration"
        ]
      }
    }
  }
};
const border$2 = {
  "default": {
    value: {
      color: "#2c2d301f",
      width: 1
    },
    type: "border",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: {
        color: "#2c2d301f",
        width: 1
      },
      type: "border"
    },
    name: "sd-border-default",
    attributes: {},
    path: [
      "border",
      "default"
    ]
  },
  focused: {
    value: {
      color: "#2c2d30",
      width: 1
    },
    type: "border",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: {
        color: "#2c2d30",
        width: 1
      },
      type: "border"
    },
    name: "sd-border-focused",
    attributes: {},
    path: [
      "border",
      "focused"
    ]
  },
  selected: {
    value: {
      color: "#29c893",
      width: 2
    },
    type: "border",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: {
        color: "#29c893",
        width: 2
      },
      type: "border"
    },
    name: "sd-border-selected",
    attributes: {},
    path: [
      "border",
      "selected"
    ]
  },
  danger: {
    value: {
      color: "#ff3b30",
      width: 1
    },
    type: "border",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: {
        color: "#ff3b30",
        width: 1
      },
      type: "border"
    },
    name: "sd-border-danger",
    attributes: {},
    path: [
      "border",
      "danger"
    ]
  },
  warning: {
    value: {
      color: "#ebac13",
      width: 1
    },
    type: "border",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: {
        color: "#ebac13",
        width: 1
      },
      type: "border"
    },
    name: "sd-border-warning",
    attributes: {},
    path: [
      "border",
      "warning"
    ]
  },
  success: {
    value: {
      color: "#16a34a",
      width: 1
    },
    type: "border",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: {
        color: "#16a34a",
        width: 1
      },
      type: "border"
    },
    name: "sd-border-success",
    attributes: {},
    path: [
      "border",
      "success"
    ]
  },
  overlay: {
    value: {
      color: "#ffffff1f",
      width: 1
    },
    type: "border",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: {
        color: "#ffffff1f",
        width: 1
      },
      type: "border"
    },
    name: "sd-border-overlay",
    attributes: {},
    path: [
      "border",
      "overlay"
    ]
  }
};
const opacity$2 = {
  "0": {
    value: 0,
    type: "opacity",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 0,
      type: "opacity"
    },
    name: "sd-opacity-0",
    attributes: {},
    path: [
      "opacity",
      "0"
    ]
  },
  "20": {
    value: 0.02,
    type: "opacity",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 0.02,
      type: "opacity"
    },
    name: "sd-opacity-20",
    attributes: {},
    path: [
      "opacity",
      "20"
    ]
  },
  "40": {
    value: 0.04,
    type: "opacity",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 0.04,
      type: "opacity"
    },
    name: "sd-opacity-40",
    attributes: {},
    path: [
      "opacity",
      "40"
    ]
  },
  "60": {
    value: 0.06,
    type: "opacity",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 0.06,
      type: "opacity"
    },
    name: "sd-opacity-60",
    attributes: {},
    path: [
      "opacity",
      "60"
    ]
  },
  "80": {
    value: 0.08,
    type: "opacity",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 0.08,
      type: "opacity"
    },
    name: "sd-opacity-80",
    attributes: {},
    path: [
      "opacity",
      "80"
    ]
  },
  "100": {
    value: 0.1,
    type: "opacity",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 0.1,
      type: "opacity"
    },
    name: "sd-opacity-100",
    attributes: {},
    path: [
      "opacity",
      "100"
    ]
  },
  "120": {
    value: 0.12,
    type: "opacity",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 0.12,
      type: "opacity"
    },
    name: "sd-opacity-120",
    attributes: {},
    path: [
      "opacity",
      "120"
    ]
  },
  "160": {
    value: 0.16,
    type: "opacity",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 0.16,
      type: "opacity"
    },
    name: "sd-opacity-160",
    attributes: {},
    path: [
      "opacity",
      "160"
    ]
  },
  "200": {
    value: 0.2,
    type: "opacity",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 0.2,
      type: "opacity"
    },
    name: "sd-opacity-200",
    attributes: {},
    path: [
      "opacity",
      "200"
    ]
  },
  "250": {
    value: 0.25,
    type: "opacity",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 0.25,
      type: "opacity"
    },
    name: "sd-opacity-250",
    attributes: {},
    path: [
      "opacity",
      "250"
    ]
  },
  "300": {
    value: 0.3,
    type: "opacity",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 0.3,
      type: "opacity"
    },
    name: "sd-opacity-300",
    attributes: {},
    path: [
      "opacity",
      "300"
    ]
  },
  "350": {
    value: 0.35,
    type: "opacity",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 0.35,
      type: "opacity"
    },
    name: "sd-opacity-350",
    attributes: {},
    path: [
      "opacity",
      "350"
    ]
  },
  "400": {
    value: 0.4,
    type: "opacity",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 0.4,
      type: "opacity"
    },
    name: "sd-opacity-400",
    attributes: {},
    path: [
      "opacity",
      "400"
    ]
  },
  "500": {
    value: 0.5,
    type: "opacity",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 0.5,
      type: "opacity"
    },
    name: "sd-opacity-500",
    attributes: {},
    path: [
      "opacity",
      "500"
    ]
  },
  "600": {
    value: 0.6,
    type: "opacity",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 0.6,
      type: "opacity"
    },
    name: "sd-opacity-600",
    attributes: {},
    path: [
      "opacity",
      "600"
    ]
  },
  "700": {
    value: 0.7,
    type: "opacity",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 0.7,
      type: "opacity"
    },
    name: "sd-opacity-700",
    attributes: {},
    path: [
      "opacity",
      "700"
    ]
  },
  "800": {
    value: 0.8,
    type: "opacity",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 0.8,
      type: "opacity"
    },
    name: "sd-opacity-800",
    attributes: {},
    path: [
      "opacity",
      "800"
    ]
  },
  "900": {
    value: 0.9,
    type: "opacity",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 0.9,
      type: "opacity"
    },
    name: "sd-opacity-900",
    attributes: {},
    path: [
      "opacity",
      "900"
    ]
  },
  "1000": {
    value: 1,
    type: "opacity",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 1,
      type: "opacity"
    },
    name: "sd-opacity-1000",
    attributes: {},
    path: [
      "opacity",
      "1000"
    ]
  },
  none: {
    value: 0,
    type: "opacity",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 0,
      type: "opacity"
    },
    name: "sd-opacity-none",
    attributes: {},
    path: [
      "opacity",
      "none"
    ]
  },
  low: {
    value: 0.2,
    type: "opacity",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 0.2,
      type: "opacity"
    },
    name: "sd-opacity-low",
    attributes: {},
    path: [
      "opacity",
      "low"
    ]
  },
  mid: {
    value: 0.5,
    type: "opacity",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 0.5,
      type: "opacity"
    },
    name: "sd-opacity-mid",
    attributes: {},
    path: [
      "opacity",
      "mid"
    ]
  },
  high: {
    value: 0.8,
    type: "opacity",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 0.8,
      type: "opacity"
    },
    name: "sd-opacity-high",
    attributes: {},
    path: [
      "opacity",
      "high"
    ]
  }
};
const space$2 = {
  "0": {
    value: "0px",
    type: "spacing",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 0,
      type: "spacing"
    },
    name: "sd-space-0",
    attributes: {},
    path: [
      "space",
      "0"
    ]
  },
  "25": {
    value: "2px",
    type: "spacing",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 2,
      type: "spacing"
    },
    name: "sd-space-25",
    attributes: {},
    path: [
      "space",
      "25"
    ]
  },
  "50": {
    value: "4px",
    type: "spacing",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 4,
      type: "spacing"
    },
    name: "sd-space-50",
    attributes: {},
    path: [
      "space",
      "50"
    ]
  },
  "75": {
    value: "6px",
    type: "spacing",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 6,
      type: "spacing"
    },
    name: "sd-space-75",
    attributes: {},
    path: [
      "space",
      "75"
    ]
  },
  "100": {
    value: "8px",
    type: "spacing",
    description: "Base size\n",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 8,
      type: "spacing",
      description: "Base size\n"
    },
    name: "sd-space-100",
    attributes: {},
    path: [
      "space",
      "100"
    ]
  },
  "125": {
    value: "10px",
    type: "spacing",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 10,
      type: "spacing"
    },
    name: "sd-space-125",
    attributes: {},
    path: [
      "space",
      "125"
    ]
  },
  "150": {
    value: "12px",
    type: "spacing",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 12,
      type: "spacing"
    },
    name: "sd-space-150",
    attributes: {},
    path: [
      "space",
      "150"
    ]
  },
  "175": {
    value: "14px",
    type: "spacing",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 14,
      type: "spacing"
    },
    name: "sd-space-175",
    attributes: {},
    path: [
      "space",
      "175"
    ]
  },
  "200": {
    value: "16px",
    type: "spacing",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 16,
      type: "spacing"
    },
    name: "sd-space-200",
    attributes: {},
    path: [
      "space",
      "200"
    ]
  },
  "250": {
    value: "20px",
    type: "spacing",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 20,
      type: "spacing"
    },
    name: "sd-space-250",
    attributes: {},
    path: [
      "space",
      "250"
    ]
  },
  "300": {
    value: "24px",
    type: "spacing",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 24,
      type: "spacing"
    },
    name: "sd-space-300",
    attributes: {},
    path: [
      "space",
      "300"
    ]
  },
  "350": {
    value: "28px",
    type: "spacing",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 28,
      type: "spacing"
    },
    name: "sd-space-350",
    attributes: {},
    path: [
      "space",
      "350"
    ]
  },
  "400": {
    value: "32px",
    type: "spacing",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 32,
      type: "spacing"
    },
    name: "sd-space-400",
    attributes: {},
    path: [
      "space",
      "400"
    ]
  },
  "450": {
    value: "36px",
    type: "spacing",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 36,
      type: "spacing"
    },
    name: "sd-space-450",
    attributes: {},
    path: [
      "space",
      "450"
    ]
  },
  "500": {
    value: "40px",
    type: "spacing",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 40,
      type: "spacing"
    },
    name: "sd-space-500",
    attributes: {},
    path: [
      "space",
      "500"
    ]
  },
  "550": {
    value: "44px",
    type: "spacing",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 44,
      type: "spacing"
    },
    name: "sd-space-550",
    attributes: {},
    path: [
      "space",
      "550"
    ]
  },
  "600": {
    value: "48px",
    type: "spacing",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 48,
      type: "spacing"
    },
    name: "sd-space-600",
    attributes: {},
    path: [
      "space",
      "600"
    ]
  },
  "700": {
    value: "56px",
    type: "spacing",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 56,
      type: "spacing"
    },
    name: "sd-space-700",
    attributes: {},
    path: [
      "space",
      "700"
    ]
  },
  "800": {
    value: "64px",
    type: "spacing",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 64,
      type: "spacing"
    },
    name: "sd-space-800",
    attributes: {},
    path: [
      "space",
      "800"
    ]
  },
  "900": {
    value: "72px",
    type: "spacing",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 72,
      type: "spacing"
    },
    name: "sd-space-900",
    attributes: {},
    path: [
      "space",
      "900"
    ]
  },
  "1000": {
    value: "80px",
    type: "spacing",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 80,
      type: "spacing"
    },
    name: "sd-space-1000",
    attributes: {},
    path: [
      "space",
      "1000"
    ]
  },
  "1100": {
    value: "88px",
    type: "spacing",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 88,
      type: "spacing"
    },
    name: "sd-space-1100",
    attributes: {},
    path: [
      "space",
      "1100"
    ]
  },
  "1200": {
    value: "96px",
    type: "spacing",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 96,
      type: "spacing"
    },
    name: "sd-space-1200",
    attributes: {},
    path: [
      "space",
      "1200"
    ]
  },
  "1400": {
    value: "112px",
    type: "spacing",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 112,
      type: "spacing"
    },
    name: "sd-space-1400",
    attributes: {},
    path: [
      "space",
      "1400"
    ]
  },
  "1600": {
    value: "128px",
    type: "spacing",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 128,
      type: "spacing"
    },
    name: "sd-space-1600",
    attributes: {},
    path: [
      "space",
      "1600"
    ]
  },
  "1800": {
    value: "144px",
    type: "spacing",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 144,
      type: "spacing"
    },
    name: "sd-space-1800",
    attributes: {},
    path: [
      "space",
      "1800"
    ]
  },
  margins: {
    xxs: {
      value: "4px",
      type: "spacing",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 4,
        type: "spacing"
      },
      name: "sd-space-margins-xxs",
      attributes: {},
      path: [
        "space",
        "margins",
        "xxs"
      ]
    },
    xs: {
      value: "8px",
      type: "spacing",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 8,
        type: "spacing"
      },
      name: "sd-space-margins-xs",
      attributes: {},
      path: [
        "space",
        "margins",
        "xs"
      ]
    },
    sm: {
      value: "12px",
      type: "spacing",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 12,
        type: "spacing"
      },
      name: "sd-space-margins-sm",
      attributes: {},
      path: [
        "space",
        "margins",
        "sm"
      ]
    },
    md: {
      value: "16px",
      type: "spacing",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 16,
        type: "spacing"
      },
      name: "sd-space-margins-md",
      attributes: {},
      path: [
        "space",
        "margins",
        "md"
      ]
    },
    lg: {
      value: "20px",
      type: "spacing",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 20,
        type: "spacing"
      },
      name: "sd-space-margins-lg",
      attributes: {},
      path: [
        "space",
        "margins",
        "lg"
      ]
    },
    xl: {
      value: "24px",
      type: "spacing",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 24,
        type: "spacing"
      },
      name: "sd-space-margins-xl",
      attributes: {},
      path: [
        "space",
        "margins",
        "xl"
      ]
    },
    xxl: {
      value: "32px",
      type: "spacing",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 32,
        type: "spacing"
      },
      name: "sd-space-margins-xxl",
      attributes: {},
      path: [
        "space",
        "margins",
        "xxl"
      ]
    }
  },
  padding: {
    xs: {
      value: "8px",
      type: "spacing",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 8,
        type: "spacing"
      },
      name: "sd-space-padding-xs",
      attributes: {},
      path: [
        "space",
        "padding",
        "xs"
      ]
    },
    sm: {
      value: "12px",
      type: "spacing",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 12,
        type: "spacing"
      },
      name: "sd-space-padding-sm",
      attributes: {},
      path: [
        "space",
        "padding",
        "sm"
      ]
    },
    md: {
      value: "16px",
      type: "spacing",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 16,
        type: "spacing"
      },
      name: "sd-space-padding-md",
      attributes: {},
      path: [
        "space",
        "padding",
        "md"
      ]
    },
    lg: {
      value: "20px",
      type: "spacing",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 20,
        type: "spacing"
      },
      name: "sd-space-padding-lg",
      attributes: {},
      path: [
        "space",
        "padding",
        "lg"
      ]
    },
    xl: {
      value: "24px",
      type: "spacing",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 24,
        type: "spacing"
      },
      name: "sd-space-padding-xl",
      attributes: {},
      path: [
        "space",
        "padding",
        "xl"
      ]
    },
    xxl: {
      value: "32px",
      type: "spacing",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 32,
        type: "spacing"
      },
      name: "sd-space-padding-xxl",
      attributes: {},
      path: [
        "space",
        "padding",
        "xxl"
      ]
    }
  },
  gap: {
    xs: {
      value: "4px",
      type: "spacing",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 4,
        type: "spacing"
      },
      name: "sd-space-gap-xs",
      attributes: {},
      path: [
        "space",
        "gap",
        "xs"
      ]
    },
    sm: {
      value: "8px",
      type: "spacing",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 8,
        type: "spacing"
      },
      name: "sd-space-gap-sm",
      attributes: {},
      path: [
        "space",
        "gap",
        "sm"
      ]
    },
    md: {
      value: "12px",
      type: "spacing",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 12,
        type: "spacing"
      },
      name: "sd-space-gap-md",
      attributes: {},
      path: [
        "space",
        "gap",
        "md"
      ]
    },
    lg: {
      value: "16px",
      type: "spacing",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 16,
        type: "spacing"
      },
      name: "sd-space-gap-lg",
      attributes: {},
      path: [
        "space",
        "gap",
        "lg"
      ]
    },
    xl: {
      value: "20px",
      type: "spacing",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 20,
        type: "spacing"
      },
      name: "sd-space-gap-xl",
      attributes: {},
      path: [
        "space",
        "gap",
        "xl"
      ]
    },
    xxl: {
      value: "28px",
      type: "spacing",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 28,
        type: "spacing"
      },
      name: "sd-space-gap-xxl",
      attributes: {},
      path: [
        "space",
        "gap",
        "xxl"
      ]
    },
    xxxl: {
      value: "36px",
      type: "spacing",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 36,
        type: "spacing"
      },
      name: "sd-space-gap-xxxl",
      attributes: {},
      path: [
        "space",
        "gap",
        "xxxl"
      ]
    }
  }
};
const old$2 = {
  "large-title": {
    fontFamily: {
      value: "Brown LL",
      type: "fontFamilies",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "Brown LL",
        type: "fontFamilies"
      },
      name: "sd-old-large-title-font-family",
      attributes: {},
      path: [
        "old",
        "large-title",
        "fontFamily"
      ]
    },
    fontWeight: {
      value: "Medium",
      type: "fontWeights",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "Medium",
        type: "fontWeights"
      },
      name: "sd-old-large-title-font-weight",
      attributes: {},
      path: [
        "old",
        "large-title",
        "fontWeight"
      ]
    },
    lineHeight: {
      value: "48px",
      type: "lineHeight",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 48,
        type: "lineHeight"
      },
      name: "sd-old-large-title-line-height",
      attributes: {},
      path: [
        "old",
        "large-title",
        "lineHeight"
      ]
    },
    fontSize: {
      value: "40px",
      type: "fontSizes",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 40,
        type: "fontSizes"
      },
      name: "sd-old-large-title-font-size",
      attributes: {},
      path: [
        "old",
        "large-title",
        "fontSize"
      ]
    },
    letterSpacing: {
      value: "0px",
      type: "letterSpacing",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 0,
        type: "letterSpacing"
      },
      name: "sd-old-large-title-letter-spacing",
      attributes: {},
      path: [
        "old",
        "large-title",
        "letterSpacing"
      ]
    },
    textDecoration: {
      value: "none",
      type: "textDecoration",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "none",
        type: "textDecoration"
      },
      name: "sd-old-large-title-text-decoration",
      attributes: {},
      path: [
        "old",
        "large-title",
        "textDecoration"
      ]
    }
  },
  "title-1": {
    fontFamily: {
      value: "Brown LL",
      type: "fontFamilies",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "Brown LL",
        type: "fontFamilies"
      },
      name: "sd-old-title-1-font-family",
      attributes: {},
      path: [
        "old",
        "title-1",
        "fontFamily"
      ]
    },
    fontWeight: {
      value: "Bold",
      type: "fontWeights",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "Bold",
        type: "fontWeights"
      },
      name: "sd-old-title-1-font-weight",
      attributes: {},
      path: [
        "old",
        "title-1",
        "fontWeight"
      ]
    },
    lineHeight: {
      value: "40px",
      type: "lineHeight",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 40,
        type: "lineHeight"
      },
      name: "sd-old-title-1-line-height",
      attributes: {},
      path: [
        "old",
        "title-1",
        "lineHeight"
      ]
    },
    fontSize: {
      value: "32px",
      type: "fontSizes",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 32,
        type: "fontSizes"
      },
      name: "sd-old-title-1-font-size",
      attributes: {},
      path: [
        "old",
        "title-1",
        "fontSize"
      ]
    },
    letterSpacing: {
      value: "-1px",
      type: "letterSpacing",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: -1,
        type: "letterSpacing"
      },
      name: "sd-old-title-1-letter-spacing",
      attributes: {},
      path: [
        "old",
        "title-1",
        "letterSpacing"
      ]
    },
    textDecoration: {
      value: "none",
      type: "textDecoration",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "none",
        type: "textDecoration"
      },
      name: "sd-old-title-1-text-decoration",
      attributes: {},
      path: [
        "old",
        "title-1",
        "textDecoration"
      ]
    }
  },
  "title-2": {
    fontFamily: {
      value: "Brown LL",
      type: "fontFamilies",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "Brown LL",
        type: "fontFamilies"
      },
      name: "sd-old-title-2-font-family",
      attributes: {},
      path: [
        "old",
        "title-2",
        "fontFamily"
      ]
    },
    fontWeight: {
      value: "Bold",
      type: "fontWeights",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "Bold",
        type: "fontWeights"
      },
      name: "sd-old-title-2-font-weight",
      attributes: {},
      path: [
        "old",
        "title-2",
        "fontWeight"
      ]
    },
    lineHeight: {
      value: "32px",
      type: "lineHeight",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 32,
        type: "lineHeight"
      },
      name: "sd-old-title-2-line-height",
      attributes: {},
      path: [
        "old",
        "title-2",
        "lineHeight"
      ]
    },
    fontSize: {
      value: "24px",
      type: "fontSizes",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 24,
        type: "fontSizes"
      },
      name: "sd-old-title-2-font-size",
      attributes: {},
      path: [
        "old",
        "title-2",
        "fontSize"
      ]
    },
    letterSpacing: {
      value: "-0.75px",
      type: "letterSpacing",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: -0.75,
        type: "letterSpacing"
      },
      name: "sd-old-title-2-letter-spacing",
      attributes: {},
      path: [
        "old",
        "title-2",
        "letterSpacing"
      ]
    },
    textDecoration: {
      value: "none",
      type: "textDecoration",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "none",
        type: "textDecoration"
      },
      name: "sd-old-title-2-text-decoration",
      attributes: {},
      path: [
        "old",
        "title-2",
        "textDecoration"
      ]
    }
  },
  "title-3": {
    fontFamily: {
      value: "Brown LL",
      type: "fontFamilies",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "Brown LL",
        type: "fontFamilies"
      },
      name: "sd-old-title-3-font-family",
      attributes: {},
      path: [
        "old",
        "title-3",
        "fontFamily"
      ]
    },
    fontWeight: {
      value: "Bold",
      type: "fontWeights",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "Bold",
        type: "fontWeights"
      },
      name: "sd-old-title-3-font-weight",
      attributes: {},
      path: [
        "old",
        "title-3",
        "fontWeight"
      ]
    },
    lineHeight: {
      value: "26px",
      type: "lineHeight",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 26,
        type: "lineHeight"
      },
      name: "sd-old-title-3-line-height",
      attributes: {},
      path: [
        "old",
        "title-3",
        "lineHeight"
      ]
    },
    fontSize: {
      value: "20px",
      type: "fontSizes",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 20,
        type: "fontSizes"
      },
      name: "sd-old-title-3-font-size",
      attributes: {},
      path: [
        "old",
        "title-3",
        "fontSize"
      ]
    },
    letterSpacing: {
      value: "-0.25px",
      type: "letterSpacing",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: -0.25,
        type: "letterSpacing"
      },
      name: "sd-old-title-3-letter-spacing",
      attributes: {},
      path: [
        "old",
        "title-3",
        "letterSpacing"
      ]
    },
    textDecoration: {
      value: "none",
      type: "textDecoration",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "none",
        type: "textDecoration"
      },
      name: "sd-old-title-3-text-decoration",
      attributes: {},
      path: [
        "old",
        "title-3",
        "textDecoration"
      ]
    }
  },
  "body-1e": {
    fontFamily: {
      value: "Brown LL",
      type: "fontFamilies",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "Brown LL",
        type: "fontFamilies"
      },
      name: "sd-old-body-1e-font-family",
      attributes: {},
      path: [
        "old",
        "body-1e",
        "fontFamily"
      ]
    },
    fontWeight: {
      value: "Bold",
      type: "fontWeights",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "Bold",
        type: "fontWeights"
      },
      name: "sd-old-body-1e-font-weight",
      attributes: {},
      path: [
        "old",
        "body-1e",
        "fontWeight"
      ]
    },
    lineHeight: {
      value: "24px",
      type: "lineHeight",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 24,
        type: "lineHeight"
      },
      name: "sd-old-body-1e-line-height",
      attributes: {},
      path: [
        "old",
        "body-1e",
        "lineHeight"
      ]
    },
    fontSize: {
      value: "18px",
      type: "fontSizes",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 18,
        type: "fontSizes"
      },
      name: "sd-old-body-1e-font-size",
      attributes: {},
      path: [
        "old",
        "body-1e",
        "fontSize"
      ]
    },
    letterSpacing: {
      value: "-0.5px",
      type: "letterSpacing",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: -0.5,
        type: "letterSpacing"
      },
      name: "sd-old-body-1e-letter-spacing",
      attributes: {},
      path: [
        "old",
        "body-1e",
        "letterSpacing"
      ]
    },
    textDecoration: {
      value: "none",
      type: "textDecoration",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "none",
        type: "textDecoration"
      },
      name: "sd-old-body-1e-text-decoration",
      attributes: {},
      path: [
        "old",
        "body-1e",
        "textDecoration"
      ]
    }
  },
  "body-2e": {
    fontFamily: {
      value: "Brown LL",
      type: "fontFamilies",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "Brown LL",
        type: "fontFamilies"
      },
      name: "sd-old-body-2e-font-family",
      attributes: {},
      path: [
        "old",
        "body-2e",
        "fontFamily"
      ]
    },
    fontWeight: {
      value: "Bold",
      type: "fontWeights",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "Bold",
        type: "fontWeights"
      },
      name: "sd-old-body-2e-font-weight",
      attributes: {},
      path: [
        "old",
        "body-2e",
        "fontWeight"
      ]
    },
    lineHeight: {
      value: "20px",
      type: "lineHeight",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 20,
        type: "lineHeight"
      },
      name: "sd-old-body-2e-line-height",
      attributes: {},
      path: [
        "old",
        "body-2e",
        "lineHeight"
      ]
    },
    fontSize: {
      value: "16px",
      type: "fontSizes",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 16,
        type: "fontSizes"
      },
      name: "sd-old-body-2e-font-size",
      attributes: {},
      path: [
        "old",
        "body-2e",
        "fontSize"
      ]
    },
    letterSpacing: {
      value: "-0.5px",
      type: "letterSpacing",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: -0.5,
        type: "letterSpacing"
      },
      name: "sd-old-body-2e-letter-spacing",
      attributes: {},
      path: [
        "old",
        "body-2e",
        "letterSpacing"
      ]
    },
    textDecoration: {
      value: "none",
      type: "textDecoration",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "none",
        type: "textDecoration"
      },
      name: "sd-old-body-2e-text-decoration",
      attributes: {},
      path: [
        "old",
        "body-2e",
        "textDecoration"
      ]
    }
  },
  "body-3e": {
    fontFamily: {
      value: "Brown LL",
      type: "fontFamilies",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "Brown LL",
        type: "fontFamilies"
      },
      name: "sd-old-body-3e-font-family",
      attributes: {},
      path: [
        "old",
        "body-3e",
        "fontFamily"
      ]
    },
    fontWeight: {
      value: "Bold",
      type: "fontWeights",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "Bold",
        type: "fontWeights"
      },
      name: "sd-old-body-3e-font-weight",
      attributes: {},
      path: [
        "old",
        "body-3e",
        "fontWeight"
      ]
    },
    lineHeight: {
      value: "18px",
      type: "lineHeight",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 18,
        type: "lineHeight"
      },
      name: "sd-old-body-3e-line-height",
      attributes: {},
      path: [
        "old",
        "body-3e",
        "lineHeight"
      ]
    },
    fontSize: {
      value: "14px",
      type: "fontSizes",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 14,
        type: "fontSizes"
      },
      name: "sd-old-body-3e-font-size",
      attributes: {},
      path: [
        "old",
        "body-3e",
        "fontSize"
      ]
    },
    letterSpacing: {
      value: "-0.25px",
      type: "letterSpacing",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: -0.25,
        type: "letterSpacing"
      },
      name: "sd-old-body-3e-letter-spacing",
      attributes: {},
      path: [
        "old",
        "body-3e",
        "letterSpacing"
      ]
    },
    textDecoration: {
      value: "none",
      type: "textDecoration",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "none",
        type: "textDecoration"
      },
      name: "sd-old-body-3e-text-decoration",
      attributes: {},
      path: [
        "old",
        "body-3e",
        "textDecoration"
      ]
    }
  },
  "body-1": {
    fontFamily: {
      value: "Brown LL",
      type: "fontFamilies",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "Brown LL",
        type: "fontFamilies"
      },
      name: "sd-old-body-1-font-family",
      attributes: {},
      path: [
        "old",
        "body-1",
        "fontFamily"
      ]
    },
    fontWeight: {
      value: "Regular",
      type: "fontWeights",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "Regular",
        type: "fontWeights"
      },
      name: "sd-old-body-1-font-weight",
      attributes: {},
      path: [
        "old",
        "body-1",
        "fontWeight"
      ]
    },
    lineHeight: {
      value: "24px",
      type: "lineHeight",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 24,
        type: "lineHeight"
      },
      name: "sd-old-body-1-line-height",
      attributes: {},
      path: [
        "old",
        "body-1",
        "lineHeight"
      ]
    },
    fontSize: {
      value: "18px",
      type: "fontSizes",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 18,
        type: "fontSizes"
      },
      name: "sd-old-body-1-font-size",
      attributes: {},
      path: [
        "old",
        "body-1",
        "fontSize"
      ]
    },
    letterSpacing: {
      value: "-0.5px",
      type: "letterSpacing",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: -0.5,
        type: "letterSpacing"
      },
      name: "sd-old-body-1-letter-spacing",
      attributes: {},
      path: [
        "old",
        "body-1",
        "letterSpacing"
      ]
    },
    textDecoration: {
      value: "none",
      type: "textDecoration",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "none",
        type: "textDecoration"
      },
      name: "sd-old-body-1-text-decoration",
      attributes: {},
      path: [
        "old",
        "body-1",
        "textDecoration"
      ]
    }
  },
  "body-2": {
    fontFamily: {
      value: "Brown LL",
      type: "fontFamilies",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "Brown LL",
        type: "fontFamilies"
      },
      name: "sd-old-body-2-font-family",
      attributes: {},
      path: [
        "old",
        "body-2",
        "fontFamily"
      ]
    },
    fontWeight: {
      value: "Regular",
      type: "fontWeights",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "Regular",
        type: "fontWeights"
      },
      name: "sd-old-body-2-font-weight",
      attributes: {},
      path: [
        "old",
        "body-2",
        "fontWeight"
      ]
    },
    lineHeight: {
      value: "20px",
      type: "lineHeight",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 20,
        type: "lineHeight"
      },
      name: "sd-old-body-2-line-height",
      attributes: {},
      path: [
        "old",
        "body-2",
        "lineHeight"
      ]
    },
    fontSize: {
      value: "16px",
      type: "fontSizes",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 16,
        type: "fontSizes"
      },
      name: "sd-old-body-2-font-size",
      attributes: {},
      path: [
        "old",
        "body-2",
        "fontSize"
      ]
    },
    letterSpacing: {
      value: "-0.5px",
      type: "letterSpacing",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: -0.5,
        type: "letterSpacing"
      },
      name: "sd-old-body-2-letter-spacing",
      attributes: {},
      path: [
        "old",
        "body-2",
        "letterSpacing"
      ]
    },
    textDecoration: {
      value: "none",
      type: "textDecoration",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "none",
        type: "textDecoration"
      },
      name: "sd-old-body-2-text-decoration",
      attributes: {},
      path: [
        "old",
        "body-2",
        "textDecoration"
      ]
    }
  },
  "body-3": {
    fontFamily: {
      value: "Brown LL",
      type: "fontFamilies",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "Brown LL",
        type: "fontFamilies"
      },
      name: "sd-old-body-3-font-family",
      attributes: {},
      path: [
        "old",
        "body-3",
        "fontFamily"
      ]
    },
    fontWeight: {
      value: "Regular",
      type: "fontWeights",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "Regular",
        type: "fontWeights"
      },
      name: "sd-old-body-3-font-weight",
      attributes: {},
      path: [
        "old",
        "body-3",
        "fontWeight"
      ]
    },
    lineHeight: {
      value: "18px",
      type: "lineHeight",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 18,
        type: "lineHeight"
      },
      name: "sd-old-body-3-line-height",
      attributes: {},
      path: [
        "old",
        "body-3",
        "lineHeight"
      ]
    },
    fontSize: {
      value: "14px",
      type: "fontSizes",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 14,
        type: "fontSizes"
      },
      name: "sd-old-body-3-font-size",
      attributes: {},
      path: [
        "old",
        "body-3",
        "fontSize"
      ]
    },
    letterSpacing: {
      value: "-0.25px",
      type: "letterSpacing",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: -0.25,
        type: "letterSpacing"
      },
      name: "sd-old-body-3-letter-spacing",
      attributes: {},
      path: [
        "old",
        "body-3",
        "letterSpacing"
      ]
    },
    textDecoration: {
      value: "none",
      type: "textDecoration",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "none",
        type: "textDecoration"
      },
      name: "sd-old-body-3-text-decoration",
      attributes: {},
      path: [
        "old",
        "body-3",
        "textDecoration"
      ]
    }
  },
  footnote: {
    fontFamily: {
      value: "Brown LL",
      type: "fontFamilies",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "Brown LL",
        type: "fontFamilies"
      },
      name: "sd-old-footnote-font-family",
      attributes: {},
      path: [
        "old",
        "footnote",
        "fontFamily"
      ]
    },
    fontWeight: {
      value: "Regular",
      type: "fontWeights",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "Regular",
        type: "fontWeights"
      },
      name: "sd-old-footnote-font-weight",
      attributes: {},
      path: [
        "old",
        "footnote",
        "fontWeight"
      ]
    },
    lineHeight: {
      value: "16px",
      type: "lineHeight",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 16,
        type: "lineHeight"
      },
      name: "sd-old-footnote-line-height",
      attributes: {},
      path: [
        "old",
        "footnote",
        "lineHeight"
      ]
    },
    fontSize: {
      value: "12px",
      type: "fontSizes",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 12,
        type: "fontSizes"
      },
      name: "sd-old-footnote-font-size",
      attributes: {},
      path: [
        "old",
        "footnote",
        "fontSize"
      ]
    },
    letterSpacing: {
      value: "-0.25px",
      type: "letterSpacing",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: -0.25,
        type: "letterSpacing"
      },
      name: "sd-old-footnote-letter-spacing",
      attributes: {},
      path: [
        "old",
        "footnote",
        "letterSpacing"
      ]
    },
    textDecoration: {
      value: "none",
      type: "textDecoration",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "none",
        type: "textDecoration"
      },
      name: "sd-old-footnote-text-decoration",
      attributes: {},
      path: [
        "old",
        "footnote",
        "textDecoration"
      ]
    }
  },
  "button-1": {
    fontFamily: {
      value: "Brown LL",
      type: "fontFamilies",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "Brown LL",
        type: "fontFamilies"
      },
      name: "sd-old-button-1-font-family",
      attributes: {},
      path: [
        "old",
        "button-1",
        "fontFamily"
      ]
    },
    fontWeight: {
      value: "Medium",
      type: "fontWeights",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "Medium",
        type: "fontWeights"
      },
      name: "sd-old-button-1-font-weight",
      attributes: {},
      path: [
        "old",
        "button-1",
        "fontWeight"
      ]
    },
    lineHeight: {
      value: "20px",
      type: "lineHeight",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 20,
        type: "lineHeight"
      },
      name: "sd-old-button-1-line-height",
      attributes: {},
      path: [
        "old",
        "button-1",
        "lineHeight"
      ]
    },
    fontSize: {
      value: "16px",
      type: "fontSizes",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 16,
        type: "fontSizes"
      },
      name: "sd-old-button-1-font-size",
      attributes: {},
      path: [
        "old",
        "button-1",
        "fontSize"
      ]
    },
    letterSpacing: {
      value: "-0.5px",
      type: "letterSpacing",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: -0.5,
        type: "letterSpacing"
      },
      name: "sd-old-button-1-letter-spacing",
      attributes: {},
      path: [
        "old",
        "button-1",
        "letterSpacing"
      ]
    },
    textDecoration: {
      value: "none",
      type: "textDecoration",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "none",
        type: "textDecoration"
      },
      name: "sd-old-button-1-text-decoration",
      attributes: {},
      path: [
        "old",
        "button-1",
        "textDecoration"
      ]
    }
  },
  "button-2": {
    fontFamily: {
      value: "Brown LL",
      type: "fontFamilies",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "Brown LL",
        type: "fontFamilies"
      },
      name: "sd-old-button-2-font-family",
      attributes: {},
      path: [
        "old",
        "button-2",
        "fontFamily"
      ]
    },
    fontWeight: {
      value: "Medium",
      type: "fontWeights",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "Medium",
        type: "fontWeights"
      },
      name: "sd-old-button-2-font-weight",
      attributes: {},
      path: [
        "old",
        "button-2",
        "fontWeight"
      ]
    },
    lineHeight: {
      value: "18px",
      type: "lineHeight",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 18,
        type: "lineHeight"
      },
      name: "sd-old-button-2-line-height",
      attributes: {},
      path: [
        "old",
        "button-2",
        "lineHeight"
      ]
    },
    fontSize: {
      value: "14px",
      type: "fontSizes",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 14,
        type: "fontSizes"
      },
      name: "sd-old-button-2-font-size",
      attributes: {},
      path: [
        "old",
        "button-2",
        "fontSize"
      ]
    },
    letterSpacing: {
      value: "-0.5px",
      type: "letterSpacing",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: -0.5,
        type: "letterSpacing"
      },
      name: "sd-old-button-2-letter-spacing",
      attributes: {},
      path: [
        "old",
        "button-2",
        "letterSpacing"
      ]
    },
    textDecoration: {
      value: "none",
      type: "textDecoration",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "none",
        type: "textDecoration"
      },
      name: "sd-old-button-2-text-decoration",
      attributes: {},
      path: [
        "old",
        "button-2",
        "textDecoration"
      ]
    }
  },
  "footnote-e": {
    fontFamily: {
      value: "Brown LL",
      type: "fontFamilies",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "Brown LL",
        type: "fontFamilies"
      },
      name: "sd-old-footnote-e-font-family",
      attributes: {},
      path: [
        "old",
        "footnote-e",
        "fontFamily"
      ]
    },
    fontWeight: {
      value: "Bold",
      type: "fontWeights",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "Bold",
        type: "fontWeights"
      },
      name: "sd-old-footnote-e-font-weight",
      attributes: {},
      path: [
        "old",
        "footnote-e",
        "fontWeight"
      ]
    },
    lineHeight: {
      value: "16px",
      type: "lineHeight",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 16,
        type: "lineHeight"
      },
      name: "sd-old-footnote-e-line-height",
      attributes: {},
      path: [
        "old",
        "footnote-e",
        "lineHeight"
      ]
    },
    fontSize: {
      value: "12px",
      type: "fontSizes",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 12,
        type: "fontSizes"
      },
      name: "sd-old-footnote-e-font-size",
      attributes: {},
      path: [
        "old",
        "footnote-e",
        "fontSize"
      ]
    },
    letterSpacing: {
      value: "0px",
      type: "letterSpacing",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 0,
        type: "letterSpacing"
      },
      name: "sd-old-footnote-e-letter-spacing",
      attributes: {},
      path: [
        "old",
        "footnote-e",
        "letterSpacing"
      ]
    },
    textDecoration: {
      value: "none",
      type: "textDecoration",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "none",
        type: "textDecoration"
      },
      name: "sd-old-footnote-e-text-decoration",
      attributes: {},
      path: [
        "old",
        "footnote-e",
        "textDecoration"
      ]
    }
  },
  "caption-3": {
    fontFamily: {
      value: "Brown LL",
      type: "fontFamilies",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "Brown LL",
        type: "fontFamilies"
      },
      name: "sd-old-caption-3-font-family",
      attributes: {},
      path: [
        "old",
        "caption-3",
        "fontFamily"
      ]
    },
    fontWeight: {
      value: "Bold",
      type: "fontWeights",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "Bold",
        type: "fontWeights"
      },
      name: "sd-old-caption-3-font-weight",
      attributes: {},
      path: [
        "old",
        "caption-3",
        "fontWeight"
      ]
    },
    lineHeight: {
      value: "14px",
      type: "lineHeight",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 14,
        type: "lineHeight"
      },
      name: "sd-old-caption-3-line-height",
      attributes: {},
      path: [
        "old",
        "caption-3",
        "lineHeight"
      ]
    },
    fontSize: {
      value: "10px",
      type: "fontSizes",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 10,
        type: "fontSizes"
      },
      name: "sd-old-caption-3-font-size",
      attributes: {},
      path: [
        "old",
        "caption-3",
        "fontSize"
      ]
    },
    letterSpacing: {
      value: "-0.25px",
      type: "letterSpacing",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: -0.25,
        type: "letterSpacing"
      },
      name: "sd-old-caption-3-letter-spacing",
      attributes: {},
      path: [
        "old",
        "caption-3",
        "letterSpacing"
      ]
    },
    textDecoration: {
      value: "none",
      type: "textDecoration",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "none",
        type: "textDecoration"
      },
      name: "sd-old-caption-3-text-decoration",
      attributes: {},
      path: [
        "old",
        "caption-3",
        "textDecoration"
      ]
    }
  }
};
const radius$2 = {
  "100": {
    value: "4px",
    type: "borderRadius",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 4,
      type: "borderRadius"
    },
    name: "sd-radius-100",
    attributes: {},
    path: [
      "radius",
      "100"
    ]
  },
  "200": {
    value: "8px",
    type: "borderRadius",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 8,
      type: "borderRadius"
    },
    name: "sd-radius-200",
    attributes: {},
    path: [
      "radius",
      "200"
    ]
  },
  "300": {
    value: "12px",
    type: "borderRadius",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 12,
      type: "borderRadius"
    },
    name: "sd-radius-300",
    attributes: {},
    path: [
      "radius",
      "300"
    ]
  },
  "400": {
    value: "16px",
    type: "borderRadius",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 16,
      type: "borderRadius"
    },
    name: "sd-radius-400",
    attributes: {},
    path: [
      "radius",
      "400"
    ]
  },
  "500": {
    value: "20px",
    type: "borderRadius",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 20,
      type: "borderRadius"
    },
    name: "sd-radius-500",
    attributes: {},
    path: [
      "radius",
      "500"
    ]
  },
  "600": {
    value: "24px",
    type: "borderRadius",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 24,
      type: "borderRadius"
    },
    name: "sd-radius-600",
    attributes: {},
    path: [
      "radius",
      "600"
    ]
  },
  "700": {
    value: "28px",
    type: "borderRadius",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 28,
      type: "borderRadius"
    },
    name: "sd-radius-700",
    attributes: {},
    path: [
      "radius",
      "700"
    ]
  },
  "800": {
    value: "32px",
    type: "borderRadius",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 32,
      type: "borderRadius"
    },
    name: "sd-radius-800",
    attributes: {},
    path: [
      "radius",
      "800"
    ]
  },
  "900": {
    value: "36px",
    type: "borderRadius",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 36,
      type: "borderRadius"
    },
    name: "sd-radius-900",
    attributes: {},
    path: [
      "radius",
      "900"
    ]
  },
  "1000": {
    value: "40px",
    type: "borderRadius",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 40,
      type: "borderRadius"
    },
    name: "sd-radius-1000",
    attributes: {},
    path: [
      "radius",
      "1000"
    ]
  },
  full: {
    value: "999px",
    type: "borderRadius",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 999,
      type: "borderRadius"
    },
    name: "sd-radius-full",
    attributes: {},
    path: [
      "radius",
      "full"
    ]
  }
};
const stroke$2 = {
  "0": {
    value: "0px",
    type: "borderWidth",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 0,
      type: "borderWidth"
    },
    name: "sd-stroke-0",
    attributes: {},
    path: [
      "stroke",
      "0"
    ]
  },
  "100": {
    value: "1px",
    type: "borderWidth",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 1,
      type: "borderWidth"
    },
    name: "sd-stroke-100",
    attributes: {},
    path: [
      "stroke",
      "100"
    ]
  },
  "200": {
    value: "2px",
    type: "borderWidth",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 2,
      type: "borderWidth"
    },
    name: "sd-stroke-200",
    attributes: {},
    path: [
      "stroke",
      "200"
    ]
  },
  "300": {
    value: "3px",
    type: "borderWidth",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 3,
      type: "borderWidth"
    },
    name: "sd-stroke-300",
    attributes: {},
    path: [
      "stroke",
      "300"
    ]
  }
};
const font$2 = {
  family: {
    main: {
      value: "Brown LL",
      type: "fontFamilies",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "Brown LL",
        type: "fontFamilies"
      },
      name: "sd-font-family-main",
      attributes: {},
      path: [
        "font",
        "family",
        "main"
      ]
    }
  },
  "line-heights": {
    "50": {
      value: "14px",
      type: "lineHeights",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 14,
        type: "lineHeights"
      },
      name: "sd-font-line-heights-50",
      attributes: {},
      path: [
        "font",
        "line-heights",
        "50"
      ]
    },
    "75": {
      value: "16px",
      type: "lineHeights",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 16,
        type: "lineHeights"
      },
      name: "sd-font-line-heights-75",
      attributes: {},
      path: [
        "font",
        "line-heights",
        "75"
      ]
    },
    "100": {
      value: "18px",
      type: "lineHeights",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 18,
        type: "lineHeights"
      },
      name: "sd-font-line-heights-100",
      attributes: {},
      path: [
        "font",
        "line-heights",
        "100"
      ]
    },
    "200": {
      value: "20px",
      type: "lineHeights",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 20,
        type: "lineHeights"
      },
      name: "sd-font-line-heights-200",
      attributes: {},
      path: [
        "font",
        "line-heights",
        "200"
      ]
    },
    "300": {
      value: "24px",
      type: "lineHeights",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 24,
        type: "lineHeights"
      },
      name: "sd-font-line-heights-300",
      attributes: {},
      path: [
        "font",
        "line-heights",
        "300"
      ]
    },
    "400": {
      value: "26px",
      type: "lineHeights",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 26,
        type: "lineHeights"
      },
      name: "sd-font-line-heights-400",
      attributes: {},
      path: [
        "font",
        "line-heights",
        "400"
      ]
    },
    "500": {
      value: "32px",
      type: "lineHeights",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 32,
        type: "lineHeights"
      },
      name: "sd-font-line-heights-500",
      attributes: {},
      path: [
        "font",
        "line-heights",
        "500"
      ]
    },
    "600": {
      value: "36px",
      type: "lineHeights",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 36,
        type: "lineHeights"
      },
      name: "sd-font-line-heights-600",
      attributes: {},
      path: [
        "font",
        "line-heights",
        "600"
      ]
    },
    "700": {
      value: "40px",
      type: "lineHeights",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 40,
        type: "lineHeights"
      },
      name: "sd-font-line-heights-700",
      attributes: {},
      path: [
        "font",
        "line-heights",
        "700"
      ]
    },
    "800": {
      value: "48px",
      type: "lineHeights",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 48,
        type: "lineHeights"
      },
      name: "sd-font-line-heights-800",
      attributes: {},
      path: [
        "font",
        "line-heights",
        "800"
      ]
    },
    "900": {
      value: "64px",
      type: "lineHeights",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 64,
        type: "lineHeights"
      },
      name: "sd-font-line-heights-900",
      attributes: {},
      path: [
        "font",
        "line-heights",
        "900"
      ]
    },
    "1000": {
      value: "72px",
      type: "lineHeights",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 72,
        type: "lineHeights"
      },
      name: "sd-font-line-heights-1000",
      attributes: {},
      path: [
        "font",
        "line-heights",
        "1000"
      ]
    }
  },
  weights: {
    regular: {
      value: "Regular",
      type: "fontWeights",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "Regular",
        type: "fontWeights"
      },
      name: "sd-font-weights-regular",
      attributes: {},
      path: [
        "font",
        "weights",
        "regular"
      ]
    },
    medium: {
      value: "Medium",
      type: "fontWeights",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "Medium",
        type: "fontWeights"
      },
      name: "sd-font-weights-medium",
      attributes: {},
      path: [
        "font",
        "weights",
        "medium"
      ]
    },
    bold: {
      value: "Bold",
      type: "fontWeights",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "Bold",
        type: "fontWeights"
      },
      name: "sd-font-weights-bold",
      attributes: {},
      path: [
        "font",
        "weights",
        "bold"
      ]
    }
  },
  size: {
    "50": {
      value: "10px",
      type: "fontSizes",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 10,
        type: "fontSizes"
      },
      name: "sd-font-size-50",
      attributes: {},
      path: [
        "font",
        "size",
        "50"
      ]
    },
    "75": {
      value: "12px",
      type: "fontSizes",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 12,
        type: "fontSizes"
      },
      name: "sd-font-size-75",
      attributes: {},
      path: [
        "font",
        "size",
        "75"
      ]
    },
    "100": {
      value: "14px",
      type: "fontSizes",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 14,
        type: "fontSizes"
      },
      name: "sd-font-size-100",
      attributes: {},
      path: [
        "font",
        "size",
        "100"
      ]
    },
    "200": {
      value: "16px",
      type: "fontSizes",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 16,
        type: "fontSizes"
      },
      name: "sd-font-size-200",
      attributes: {},
      path: [
        "font",
        "size",
        "200"
      ]
    },
    "300": {
      value: "18px",
      type: "fontSizes",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 18,
        type: "fontSizes"
      },
      name: "sd-font-size-300",
      attributes: {},
      path: [
        "font",
        "size",
        "300"
      ]
    },
    "400": {
      value: "20px",
      type: "fontSizes",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 20,
        type: "fontSizes"
      },
      name: "sd-font-size-400",
      attributes: {},
      path: [
        "font",
        "size",
        "400"
      ]
    },
    "500": {
      value: "24px",
      type: "fontSizes",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 24,
        type: "fontSizes"
      },
      name: "sd-font-size-500",
      attributes: {},
      path: [
        "font",
        "size",
        "500"
      ]
    },
    "600": {
      value: "28px",
      type: "fontSizes",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 28,
        type: "fontSizes"
      },
      name: "sd-font-size-600",
      attributes: {},
      path: [
        "font",
        "size",
        "600"
      ]
    },
    "700": {
      value: "32px",
      type: "fontSizes",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 32,
        type: "fontSizes"
      },
      name: "sd-font-size-700",
      attributes: {},
      path: [
        "font",
        "size",
        "700"
      ]
    },
    "800": {
      value: "40px",
      type: "fontSizes",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 40,
        type: "fontSizes"
      },
      name: "sd-font-size-800",
      attributes: {},
      path: [
        "font",
        "size",
        "800"
      ]
    },
    "900": {
      value: "56px",
      type: "fontSizes",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 56,
        type: "fontSizes"
      },
      name: "sd-font-size-900",
      attributes: {},
      path: [
        "font",
        "size",
        "900"
      ]
    },
    "1000": {
      value: "64px",
      type: "fontSizes",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 64,
        type: "fontSizes"
      },
      name: "sd-font-size-1000",
      attributes: {},
      path: [
        "font",
        "size",
        "1000"
      ]
    }
  },
  tracking: {
    xs: {
      value: "-1px",
      type: "letterSpacing",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: -1,
        type: "letterSpacing"
      },
      name: "sd-font-tracking-xs",
      attributes: {},
      path: [
        "font",
        "tracking",
        "xs"
      ]
    },
    sm: {
      value: "-0.75px",
      type: "letterSpacing",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: -0.75,
        type: "letterSpacing"
      },
      name: "sd-font-tracking-sm",
      attributes: {},
      path: [
        "font",
        "tracking",
        "sm"
      ]
    },
    md: {
      value: "-0.5px",
      type: "letterSpacing",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: -0.5,
        type: "letterSpacing"
      },
      name: "sd-font-tracking-md",
      attributes: {},
      path: [
        "font",
        "tracking",
        "md"
      ]
    },
    lg: {
      value: "-0.25px",
      type: "letterSpacing",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: -0.25,
        type: "letterSpacing"
      },
      name: "sd-font-tracking-lg",
      attributes: {},
      path: [
        "font",
        "tracking",
        "lg"
      ]
    },
    xl: {
      value: "0px",
      type: "letterSpacing",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: 0,
        type: "letterSpacing"
      },
      name: "sd-font-tracking-xl",
      attributes: {},
      path: [
        "font",
        "tracking",
        "xl"
      ]
    }
  },
  "text-decoration": {
    none: {
      value: "none",
      type: "textDecoration",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "none",
        type: "textDecoration"
      },
      name: "sd-font-text-decoration-none",
      attributes: {},
      path: [
        "font",
        "text-decoration",
        "none"
      ]
    }
  },
  "paragraph-indent": {
    "0": {
      value: "0px",
      type: "dimension",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "0px",
        type: "dimension"
      },
      name: "sd-font-paragraph-indent-0",
      attributes: {},
      path: [
        "font",
        "paragraph-indent",
        "0"
      ]
    }
  }
};
const reference$2 = {
  black: {
    value: "rgba(0, 0, 0, 1)",
    type: "color",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: "#000000",
      type: "color"
    },
    name: "sd-reference-black",
    attributes: {},
    path: [
      "reference",
      "black"
    ]
  },
  white: {
    value: "rgba(255, 255, 255, 1)",
    type: "color",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: "#ffffff",
      type: "color"
    },
    name: "sd-reference-white",
    attributes: {},
    path: [
      "reference",
      "white"
    ]
  },
  gray: {
    "100": {
      value: "rgba(243, 244, 246, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#f3f4f6",
        type: "color"
      },
      name: "sd-reference-gray-100",
      attributes: {},
      path: [
        "reference",
        "gray",
        "100"
      ]
    },
    "200": {
      value: "rgba(230, 231, 233, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#e6e7e9",
        type: "color"
      },
      name: "sd-reference-gray-200",
      attributes: {},
      path: [
        "reference",
        "gray",
        "200"
      ]
    },
    "300": {
      value: "rgba(208, 209, 211, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#d0d1d3",
        type: "color"
      },
      name: "sd-reference-gray-300",
      attributes: {},
      path: [
        "reference",
        "gray",
        "300"
      ]
    },
    "400": {
      value: "rgba(163, 166, 172, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#a3a6ac",
        type: "color"
      },
      name: "sd-reference-gray-400",
      attributes: {},
      path: [
        "reference",
        "gray",
        "400"
      ]
    },
    "500": {
      value: "rgba(122, 124, 129, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#7a7c81",
        type: "color"
      },
      name: "sd-reference-gray-500",
      attributes: {},
      path: [
        "reference",
        "gray",
        "500"
      ]
    },
    "600": {
      value: "rgba(83, 85, 90, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#53555a",
        type: "color"
      },
      name: "sd-reference-gray-600",
      attributes: {},
      path: [
        "reference",
        "gray",
        "600"
      ]
    },
    "700": {
      value: "rgba(44, 45, 48, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#2c2d30",
        type: "color"
      },
      name: "sd-reference-gray-700",
      attributes: {},
      path: [
        "reference",
        "gray",
        "700"
      ]
    },
    "800": {
      value: "rgba(34, 35, 37, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#222325",
        type: "color"
      },
      name: "sd-reference-gray-800",
      attributes: {},
      path: [
        "reference",
        "gray",
        "800"
      ]
    },
    "900": {
      value: "rgba(22, 23, 25, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#161719",
        type: "color"
      },
      name: "sd-reference-gray-900",
      attributes: {},
      path: [
        "reference",
        "gray",
        "900"
      ]
    },
    "050": {
      value: "rgba(252, 252, 253, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#fcfcfd",
        type: "color"
      },
      name: "sd-reference-gray-050",
      attributes: {},
      path: [
        "reference",
        "gray",
        "050"
      ]
    }
  },
  blue: {
    "10": {
      value: "rgba(222, 239, 253, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#deeffd",
        type: "color"
      },
      name: "sd-reference-blue-10",
      attributes: {},
      path: [
        "reference",
        "blue",
        "10"
      ]
    },
    "20": {
      value: "rgba(170, 215, 249, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#aad7f9",
        type: "color"
      },
      name: "sd-reference-blue-20",
      attributes: {},
      path: [
        "reference",
        "blue",
        "20"
      ]
    },
    "30": {
      value: "rgba(72, 169, 242, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#48a9f2",
        type: "color"
      },
      name: "sd-reference-blue-30",
      attributes: {},
      path: [
        "reference",
        "blue",
        "30"
      ]
    },
    "40": {
      value: "rgba(43, 155, 240, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#2b9bf0",
        type: "color"
      },
      name: "sd-reference-blue-40",
      attributes: {},
      path: [
        "reference",
        "blue",
        "40"
      ]
    },
    "50": {
      value: "rgba(39, 141, 218, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#278dda",
        type: "color"
      },
      name: "sd-reference-blue-50",
      attributes: {},
      path: [
        "reference",
        "blue",
        "50"
      ]
    },
    "60": {
      value: "rgba(25, 91, 141, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#195b8d",
        type: "color"
      },
      name: "sd-reference-blue-60",
      attributes: {},
      path: [
        "reference",
        "blue",
        "60"
      ]
    },
    "70": {
      value: "rgba(16, 59, 92, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#103b5c",
        type: "color"
      },
      name: "sd-reference-blue-70",
      attributes: {},
      path: [
        "reference",
        "blue",
        "70"
      ]
    }
  },
  Indigo: {
    "10": {
      value: "rgba(227, 230, 253, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#e3e6fd",
        type: "color"
      },
      name: "sd-reference-indigo-10",
      attributes: {},
      path: [
        "reference",
        "Indigo",
        "10"
      ]
    },
    "20": {
      value: "rgba(199, 205, 252, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#c7cdfc",
        type: "color"
      },
      name: "sd-reference-indigo-20",
      attributes: {},
      path: [
        "reference",
        "Indigo",
        "20"
      ]
    },
    "30": {
      value: "rgba(139, 151, 248, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#8b97f8",
        type: "color"
      },
      name: "sd-reference-indigo-30",
      attributes: {},
      path: [
        "reference",
        "Indigo",
        "30"
      ]
    },
    "40": {
      value: "rgba(116, 130, 247, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#7482f7",
        type: "color"
      },
      name: "sd-reference-indigo-40",
      attributes: {},
      path: [
        "reference",
        "Indigo",
        "40"
      ]
    },
    "50": {
      value: "rgba(105, 118, 224, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#6976e0",
        type: "color"
      },
      name: "sd-reference-indigo-50",
      attributes: {},
      path: [
        "reference",
        "Indigo",
        "50"
      ]
    },
    "60": {
      value: "rgba(70, 78, 148, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#464e94",
        type: "color"
      },
      name: "sd-reference-indigo-60",
      attributes: {},
      path: [
        "reference",
        "Indigo",
        "60"
      ]
    },
    "70": {
      value: "rgba(46, 52, 99, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#2e3463",
        type: "color"
      },
      name: "sd-reference-indigo-70",
      attributes: {},
      path: [
        "reference",
        "Indigo",
        "70"
      ]
    }
  },
  purple: {
    "10": {
      value: "rgba(241, 236, 255, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#f1ecff",
        type: "color"
      },
      name: "sd-reference-purple-10",
      attributes: {},
      path: [
        "reference",
        "purple",
        "10"
      ]
    },
    "20": {
      value: "rgba(199, 178, 255, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#c7b2ff",
        type: "color"
      },
      name: "sd-reference-purple-20",
      attributes: {},
      path: [
        "reference",
        "purple",
        "20"
      ]
    },
    "30": {
      value: "rgba(173, 142, 255, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#ad8eff",
        type: "color"
      },
      name: "sd-reference-purple-30",
      attributes: {},
      path: [
        "reference",
        "purple",
        "30"
      ]
    },
    "40": {
      value: "rgba(165, 130, 255, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#a582ff",
        type: "color"
      },
      name: "sd-reference-purple-40",
      attributes: {},
      path: [
        "reference",
        "purple",
        "40"
      ]
    },
    "50": {
      value: "rgba(152, 112, 255, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#9870ff",
        type: "color"
      },
      name: "sd-reference-purple-50",
      attributes: {},
      path: [
        "reference",
        "purple",
        "50"
      ]
    },
    "60": {
      value: "rgba(99, 78, 153, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#634e99",
        type: "color"
      },
      name: "sd-reference-purple-60",
      attributes: {},
      path: [
        "reference",
        "purple",
        "60"
      ]
    },
    "70": {
      value: "rgba(66, 52, 102, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#423466",
        type: "color"
      },
      name: "sd-reference-purple-70",
      attributes: {},
      path: [
        "reference",
        "purple",
        "70"
      ]
    }
  },
  pink: {
    "10": {
      value: "rgba(255, 227, 240, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#ffe3f0",
        type: "color"
      },
      name: "sd-reference-pink-10",
      attributes: {},
      path: [
        "reference",
        "pink",
        "10"
      ]
    },
    "20": {
      value: "rgba(255, 201, 226, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#ffc9e2",
        type: "color"
      },
      name: "sd-reference-pink-20",
      attributes: {},
      path: [
        "reference",
        "pink",
        "20"
      ]
    },
    "30": {
      value: "rgba(255, 139, 192, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#ff8bc0",
        type: "color"
      },
      name: "sd-reference-pink-30",
      attributes: {},
      path: [
        "reference",
        "pink",
        "30"
      ]
    },
    "40": {
      value: "rgba(255, 114, 178, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#ff72b2",
        type: "color"
      },
      name: "sd-reference-pink-40",
      attributes: {},
      path: [
        "reference",
        "pink",
        "40"
      ]
    },
    "50": {
      value: "rgba(227, 102, 159, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#e3669f",
        type: "color"
      },
      name: "sd-reference-pink-50",
      attributes: {},
      path: [
        "reference",
        "pink",
        "50"
      ]
    },
    "60": {
      value: "rgba(153, 68, 107, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#99446b",
        type: "color"
      },
      name: "sd-reference-pink-60",
      attributes: {},
      path: [
        "reference",
        "pink",
        "60"
      ]
    },
    "70": {
      value: "rgba(102, 46, 71, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#662e47",
        type: "color"
      },
      name: "sd-reference-pink-70",
      attributes: {},
      path: [
        "reference",
        "pink",
        "70"
      ]
    }
  },
  red: {
    "10": {
      value: "rgba(255, 238, 237, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#ffeeed",
        type: "color"
      },
      name: "sd-reference-red-10",
      attributes: {},
      path: [
        "reference",
        "red",
        "10"
      ]
    },
    "20": {
      value: "rgba(255, 185, 184, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#ffb9b8",
        type: "color"
      },
      name: "sd-reference-red-20",
      attributes: {},
      path: [
        "reference",
        "red",
        "20"
      ]
    },
    "30": {
      value: "rgba(255, 102, 101, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#ff6665",
        type: "color"
      },
      name: "sd-reference-red-30",
      attributes: {},
      path: [
        "reference",
        "red",
        "30"
      ]
    },
    "40": {
      value: "rgba(255, 80, 78, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#ff504e",
        type: "color"
      },
      name: "sd-reference-red-40",
      attributes: {},
      path: [
        "reference",
        "red",
        "40"
      ]
    },
    "50": {
      value: "rgba(244, 75, 73, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#f44b49",
        type: "color"
      },
      name: "sd-reference-red-50",
      attributes: {},
      path: [
        "reference",
        "red",
        "50"
      ]
    },
    "60": {
      value: "rgba(153, 48, 46, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#99302e",
        type: "color"
      },
      name: "sd-reference-red-60",
      attributes: {},
      path: [
        "reference",
        "red",
        "60"
      ]
    },
    "70": {
      value: "rgba(97, 31, 30, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#611f1e",
        type: "color"
      },
      name: "sd-reference-red-70",
      attributes: {},
      path: [
        "reference",
        "red",
        "70"
      ]
    }
  },
  orange: {
    "10": {
      value: "rgba(255, 220, 196, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#ffdcc4",
        type: "color"
      },
      name: "sd-reference-orange-10",
      attributes: {},
      path: [
        "reference",
        "orange",
        "10"
      ]
    },
    "20": {
      value: "rgba(255, 188, 142, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#ffbc8e",
        type: "color"
      },
      name: "sd-reference-orange-20",
      attributes: {},
      path: [
        "reference",
        "orange",
        "20"
      ]
    },
    "30": {
      value: "rgba(255, 162, 97, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#ffa261",
        type: "color"
      },
      name: "sd-reference-orange-30",
      attributes: {},
      path: [
        "reference",
        "orange",
        "30"
      ]
    },
    "40": {
      value: "rgba(255, 144, 66, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#ff9042",
        type: "color"
      },
      name: "sd-reference-orange-40",
      attributes: {},
      path: [
        "reference",
        "orange",
        "40"
      ]
    },
    "50": {
      value: "rgba(232, 131, 60, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#e8833c",
        type: "color"
      },
      name: "sd-reference-orange-50",
      attributes: {},
      path: [
        "reference",
        "orange",
        "50"
      ]
    },
    "60": {
      value: "rgba(158, 89, 41, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#9e5929",
        type: "color"
      },
      name: "sd-reference-orange-60",
      attributes: {},
      path: [
        "reference",
        "orange",
        "60"
      ]
    },
    "70": {
      value: "rgba(102, 58, 26, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#663a1a",
        type: "color"
      },
      name: "sd-reference-orange-70",
      attributes: {},
      path: [
        "reference",
        "orange",
        "70"
      ]
    }
  },
  yellow: {
    "10": {
      value: "rgba(254, 245, 193, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#fef5c1",
        type: "color"
      },
      name: "sd-reference-yellow-10",
      attributes: {},
      path: [
        "reference",
        "yellow",
        "10"
      ]
    },
    "20": {
      value: "rgba(254, 231, 137, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#fee789",
        type: "color"
      },
      name: "sd-reference-yellow-20",
      attributes: {},
      path: [
        "reference",
        "yellow",
        "20"
      ]
    },
    "30": {
      value: "rgba(250, 213, 79, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#fad54f",
        type: "color"
      },
      name: "sd-reference-yellow-30",
      attributes: {},
      path: [
        "reference",
        "yellow",
        "30"
      ]
    },
    "40": {
      value: "rgba(247, 194, 36, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#f7c224",
        type: "color"
      },
      name: "sd-reference-yellow-40",
      attributes: {},
      path: [
        "reference",
        "yellow",
        "40"
      ]
    },
    "50": {
      value: "rgba(235, 172, 19, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#ebac13",
        type: "color"
      },
      name: "sd-reference-yellow-50",
      attributes: {},
      path: [
        "reference",
        "yellow",
        "50"
      ]
    },
    "60": {
      value: "rgba(203, 133, 9, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#cb8509",
        type: "color"
      },
      name: "sd-reference-yellow-60",
      attributes: {},
      path: [
        "reference",
        "yellow",
        "60"
      ]
    },
    "70": {
      value: "rgba(145, 80, 10, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#91500a",
        type: "color"
      },
      name: "sd-reference-yellow-70",
      attributes: {},
      path: [
        "reference",
        "yellow",
        "70"
      ]
    }
  },
  volt: {
    "10": {
      value: "rgba(241, 255, 212, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#f1ffd4",
        type: "color"
      },
      name: "sd-reference-volt-10",
      attributes: {},
      path: [
        "reference",
        "volt",
        "10"
      ]
    },
    "20": {
      value: "rgba(227, 255, 169, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#e3ffa9",
        type: "color"
      },
      name: "sd-reference-volt-20",
      attributes: {},
      path: [
        "reference",
        "volt",
        "20"
      ]
    },
    "30": {
      value: "rgba(214, 255, 127, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#d6ff7f",
        type: "color"
      },
      name: "sd-reference-volt-30",
      attributes: {},
      path: [
        "reference",
        "volt",
        "30"
      ]
    },
    "40": {
      value: "rgba(186, 255, 41, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#baff29",
        type: "color"
      },
      name: "sd-reference-volt-40",
      attributes: {},
      path: [
        "reference",
        "volt",
        "40"
      ]
    },
    "50": {
      value: "rgba(171, 235, 38, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#abeb26",
        type: "color"
      },
      name: "sd-reference-volt-50",
      attributes: {},
      path: [
        "reference",
        "volt",
        "50"
      ]
    },
    "60": {
      value: "rgba(112, 153, 25, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#709919",
        type: "color"
      },
      name: "sd-reference-volt-60",
      attributes: {},
      path: [
        "reference",
        "volt",
        "60"
      ]
    },
    "70": {
      value: "rgba(74, 102, 16, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#4a6610",
        type: "color"
      },
      name: "sd-reference-volt-70",
      attributes: {},
      path: [
        "reference",
        "volt",
        "70"
      ]
    }
  },
  green: {
    "10": {
      value: "rgba(221, 246, 230, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#ddf6e6",
        type: "color"
      },
      name: "sd-reference-green-10",
      attributes: {},
      path: [
        "reference",
        "green",
        "10"
      ]
    },
    "20": {
      value: "rgba(171, 233, 193, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#abe9c1",
        type: "color"
      },
      name: "sd-reference-green-20",
      attributes: {},
      path: [
        "reference",
        "green",
        "20"
      ]
    },
    "30": {
      value: "rgba(74, 222, 128, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#4ade80",
        type: "color"
      },
      name: "sd-reference-green-30",
      attributes: {},
      path: [
        "reference",
        "green",
        "30"
      ]
    },
    "40": {
      value: "rgba(34, 197, 94, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#22c55e",
        type: "color"
      },
      name: "sd-reference-green-40",
      attributes: {},
      path: [
        "reference",
        "green",
        "40"
      ]
    },
    "50": {
      value: "rgba(22, 163, 74, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#16a34a",
        type: "color"
      },
      name: "sd-reference-green-50",
      attributes: {},
      path: [
        "reference",
        "green",
        "50"
      ]
    },
    "60": {
      value: "rgba(21, 128, 61, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#15803d",
        type: "color"
      },
      name: "sd-reference-green-60",
      attributes: {},
      path: [
        "reference",
        "green",
        "60"
      ]
    },
    "70": {
      value: "rgba(22, 101, 52, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#166534",
        type: "color"
      },
      name: "sd-reference-green-70",
      attributes: {},
      path: [
        "reference",
        "green",
        "70"
      ]
    }
  },
  mint: {
    "10": {
      value: "rgba(220, 247, 242, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#dcf7f2",
        type: "color"
      },
      name: "sd-reference-mint-10",
      attributes: {},
      path: [
        "reference",
        "mint",
        "10"
      ]
    },
    "20": {
      value: "rgba(119, 224, 199, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#77e0c7",
        type: "color"
      },
      name: "sd-reference-mint-20",
      attributes: {},
      path: [
        "reference",
        "mint",
        "20"
      ]
    },
    "30": {
      value: "rgba(59, 210, 165, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#3bd2a5",
        type: "color"
      },
      name: "sd-reference-mint-30",
      attributes: {},
      path: [
        "reference",
        "mint",
        "30"
      ]
    },
    "40": {
      value: "rgba(41, 200, 147, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#29c893",
        type: "color"
      },
      name: "sd-reference-mint-40",
      attributes: {},
      path: [
        "reference",
        "mint",
        "40"
      ]
    },
    "50": {
      value: "rgba(41, 200, 147, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#29c893",
        type: "color"
      },
      name: "sd-reference-mint-50",
      attributes: {},
      path: [
        "reference",
        "mint",
        "50"
      ]
    },
    "60": {
      value: "rgba(16, 119, 88, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#107758",
        type: "color"
      },
      name: "sd-reference-mint-60",
      attributes: {},
      path: [
        "reference",
        "mint",
        "60"
      ]
    },
    "70": {
      value: "rgba(11, 78, 65, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#0b4e41",
        type: "color"
      },
      name: "sd-reference-mint-70",
      attributes: {},
      path: [
        "reference",
        "mint",
        "70"
      ]
    }
  },
  teal: {
    "10": {
      value: "rgba(233, 249, 253, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#e9f9fd",
        type: "color"
      },
      name: "sd-reference-teal-10",
      attributes: {},
      path: [
        "reference",
        "teal",
        "10"
      ]
    },
    "20": {
      value: "rgba(166, 232, 246, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#a6e8f6",
        type: "color"
      },
      name: "sd-reference-teal-20",
      attributes: {},
      path: [
        "reference",
        "teal",
        "20"
      ]
    },
    "30": {
      value: "rgba(82, 210, 238, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#52d2ee",
        type: "color"
      },
      name: "sd-reference-teal-30",
      attributes: {},
      path: [
        "reference",
        "teal",
        "30"
      ]
    },
    "40": {
      value: "rgba(39, 199, 234, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#27c7ea",
        type: "color"
      },
      name: "sd-reference-teal-40",
      attributes: {},
      path: [
        "reference",
        "teal",
        "40"
      ]
    },
    "50": {
      value: "rgba(30, 193, 228, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#1ec1e4",
        type: "color"
      },
      name: "sd-reference-teal-50",
      attributes: {},
      path: [
        "reference",
        "teal",
        "50"
      ]
    },
    "60": {
      value: "rgba(31, 140, 187, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#1f8cbb",
        type: "color"
      },
      name: "sd-reference-teal-60",
      attributes: {},
      path: [
        "reference",
        "teal",
        "60"
      ]
    },
    "70": {
      value: "rgba(46, 74, 99, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#2e4a63",
        type: "color"
      },
      name: "sd-reference-teal-70",
      attributes: {},
      path: [
        "reference",
        "teal",
        "70"
      ]
    }
  },
  danger: {
    "10": {
      value: "rgba(255, 210, 207, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#ffd2cf",
        type: "color"
      },
      name: "sd-reference-danger-10",
      attributes: {},
      path: [
        "reference",
        "danger",
        "10"
      ]
    },
    "20": {
      value: "rgba(255, 116, 107, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#ff746b",
        type: "color"
      },
      name: "sd-reference-danger-20",
      attributes: {},
      path: [
        "reference",
        "danger",
        "20"
      ]
    },
    "30": {
      value: "rgba(255, 75, 65, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#ff4b41",
        type: "color"
      },
      name: "sd-reference-danger-30",
      attributes: {},
      path: [
        "reference",
        "danger",
        "30"
      ]
    },
    "40": {
      value: "rgba(255, 69, 58, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#ff453a",
        type: "color"
      },
      name: "sd-reference-danger-40",
      attributes: {},
      path: [
        "reference",
        "danger",
        "40"
      ]
    },
    "50": {
      value: "rgba(255, 59, 48, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#ff3b30",
        type: "color"
      },
      name: "sd-reference-danger-50",
      attributes: {},
      path: [
        "reference",
        "danger",
        "50"
      ]
    },
    "60": {
      value: "rgba(152, 27, 20, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#981b14",
        type: "color"
      },
      name: "sd-reference-danger-60",
      attributes: {},
      path: [
        "reference",
        "danger",
        "60"
      ]
    },
    "70": {
      value: "rgba(81, 20, 15, 1)",
      type: "color",
      filePath: "themes/popularpay-light.json",
      isSource: true,
      original: {
        value: "#51140f",
        type: "color"
      },
      name: "sd-reference-danger-70",
      attributes: {},
      path: [
        "reference",
        "danger",
        "70"
      ]
    }
  }
};
const size$2 = {
  "0": {
    value: "0px",
    type: "sizing",
    description: "size",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 0,
      type: "sizing",
      description: "size"
    },
    name: "sd-size-0",
    attributes: {},
    path: [
      "size",
      "0"
    ]
  },
  "25": {
    value: "2px",
    type: "sizing",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 2,
      type: "sizing"
    },
    name: "sd-size-25",
    attributes: {},
    path: [
      "size",
      "25"
    ]
  },
  "50": {
    value: "4px",
    type: "sizing",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 4,
      type: "sizing"
    },
    name: "sd-size-50",
    attributes: {},
    path: [
      "size",
      "50"
    ]
  },
  "75": {
    value: "6px",
    type: "sizing",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 6,
      type: "sizing"
    },
    name: "sd-size-75",
    attributes: {},
    path: [
      "size",
      "75"
    ]
  },
  "100": {
    value: "8px",
    type: "sizing",
    description: "Base size\n",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 8,
      type: "sizing",
      description: "Base size\n"
    },
    name: "sd-size-100",
    attributes: {},
    path: [
      "size",
      "100"
    ]
  },
  "125": {
    value: "10px",
    type: "sizing",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 10,
      type: "sizing"
    },
    name: "sd-size-125",
    attributes: {},
    path: [
      "size",
      "125"
    ]
  },
  "150": {
    value: "12px",
    type: "sizing",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 12,
      type: "sizing"
    },
    name: "sd-size-150",
    attributes: {},
    path: [
      "size",
      "150"
    ]
  },
  "175": {
    value: "14px",
    type: "sizing",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 14,
      type: "sizing"
    },
    name: "sd-size-175",
    attributes: {},
    path: [
      "size",
      "175"
    ]
  },
  "200": {
    value: "16px",
    type: "sizing",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 16,
      type: "sizing"
    },
    name: "sd-size-200",
    attributes: {},
    path: [
      "size",
      "200"
    ]
  },
  "250": {
    value: "20px",
    type: "sizing",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 20,
      type: "sizing"
    },
    name: "sd-size-250",
    attributes: {},
    path: [
      "size",
      "250"
    ]
  },
  "300": {
    value: "24px",
    type: "sizing",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 24,
      type: "sizing"
    },
    name: "sd-size-300",
    attributes: {},
    path: [
      "size",
      "300"
    ]
  },
  "350": {
    value: "28px",
    type: "sizing",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 28,
      type: "sizing"
    },
    name: "sd-size-350",
    attributes: {},
    path: [
      "size",
      "350"
    ]
  },
  "400": {
    value: "32px",
    type: "sizing",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 32,
      type: "sizing"
    },
    name: "sd-size-400",
    attributes: {},
    path: [
      "size",
      "400"
    ]
  },
  "450": {
    value: "36px",
    type: "sizing",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 36,
      type: "sizing"
    },
    name: "sd-size-450",
    attributes: {},
    path: [
      "size",
      "450"
    ]
  },
  "500": {
    value: "40px",
    type: "sizing",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 40,
      type: "sizing"
    },
    name: "sd-size-500",
    attributes: {},
    path: [
      "size",
      "500"
    ]
  },
  "550": {
    value: "44px",
    type: "sizing",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 44,
      type: "sizing"
    },
    name: "sd-size-550",
    attributes: {},
    path: [
      "size",
      "550"
    ]
  },
  "600": {
    value: "48px",
    type: "sizing",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 48,
      type: "sizing"
    },
    name: "sd-size-600",
    attributes: {},
    path: [
      "size",
      "600"
    ]
  },
  "650": {
    value: "52px",
    type: "sizing",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 52,
      type: "sizing"
    },
    name: "sd-size-650",
    attributes: {},
    path: [
      "size",
      "650"
    ]
  },
  "700": {
    value: "56px",
    type: "sizing",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 56,
      type: "sizing"
    },
    name: "sd-size-700",
    attributes: {},
    path: [
      "size",
      "700"
    ]
  },
  "750": {
    value: "60px",
    type: "sizing",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 60,
      type: "sizing"
    },
    name: "sd-size-750",
    attributes: {},
    path: [
      "size",
      "750"
    ]
  },
  "800": {
    value: "64px",
    type: "sizing",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 64,
      type: "sizing"
    },
    name: "sd-size-800",
    attributes: {},
    path: [
      "size",
      "800"
    ]
  },
  "900": {
    value: "72px",
    type: "sizing",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 72,
      type: "sizing"
    },
    name: "sd-size-900",
    attributes: {},
    path: [
      "size",
      "900"
    ]
  },
  "1000": {
    value: "80px",
    type: "sizing",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 80,
      type: "sizing"
    },
    name: "sd-size-1000",
    attributes: {},
    path: [
      "size",
      "1000"
    ]
  },
  "1100": {
    value: "88px",
    type: "sizing",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 88,
      type: "sizing"
    },
    name: "sd-size-1100",
    attributes: {},
    path: [
      "size",
      "1100"
    ]
  },
  "1200": {
    value: "96px",
    type: "sizing",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 96,
      type: "sizing"
    },
    name: "sd-size-1200",
    attributes: {},
    path: [
      "size",
      "1200"
    ]
  },
  "1300": {
    value: "104px",
    type: "sizing",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 104,
      type: "sizing"
    },
    name: "sd-size-1300",
    attributes: {},
    path: [
      "size",
      "1300"
    ]
  },
  "1400": {
    value: "112px",
    type: "sizing",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 112,
      type: "sizing"
    },
    name: "sd-size-1400",
    attributes: {},
    path: [
      "size",
      "1400"
    ]
  },
  "1500": {
    value: "120px",
    type: "sizing",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 120,
      type: "sizing"
    },
    name: "sd-size-1500",
    attributes: {},
    path: [
      "size",
      "1500"
    ]
  },
  "1750": {
    value: "140px",
    type: "sizing",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 140,
      type: "sizing"
    },
    name: "sd-size-1750",
    attributes: {},
    path: [
      "size",
      "1750"
    ]
  },
  "2000": {
    value: "160px",
    type: "sizing",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 160,
      type: "sizing"
    },
    name: "sd-size-2000",
    attributes: {},
    path: [
      "size",
      "2000"
    ]
  },
  "2200": {
    value: "176px",
    type: "sizing",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 176,
      type: "sizing"
    },
    name: "sd-size-2200",
    attributes: {},
    path: [
      "size",
      "2200"
    ]
  },
  "2500": {
    value: "200px",
    type: "sizing",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 200,
      type: "sizing"
    },
    name: "sd-size-2500",
    attributes: {},
    path: [
      "size",
      "2500"
    ]
  },
  "3000": {
    value: "240px",
    type: "sizing",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 240,
      type: "sizing"
    },
    name: "sd-size-3000",
    attributes: {},
    path: [
      "size",
      "3000"
    ]
  },
  "3500": {
    value: "280px",
    type: "sizing",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 280,
      type: "sizing"
    },
    name: "sd-size-3500",
    attributes: {},
    path: [
      "size",
      "3500"
    ]
  },
  "4000": {
    value: "320px",
    type: "sizing",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 320,
      type: "sizing"
    },
    name: "sd-size-4000",
    attributes: {},
    path: [
      "size",
      "4000"
    ]
  },
  "5000": {
    value: "400px",
    type: "sizing",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 400,
      type: "sizing"
    },
    name: "sd-size-5000",
    attributes: {},
    path: [
      "size",
      "5000"
    ]
  },
  "6000": {
    value: "480px",
    type: "sizing",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 480,
      type: "sizing"
    },
    name: "sd-size-6000",
    attributes: {},
    path: [
      "size",
      "6000"
    ]
  },
  "7000": {
    value: "560px",
    type: "sizing",
    filePath: "themes/popularpay-light.json",
    isSource: true,
    original: {
      value: 560,
      type: "sizing"
    },
    name: "sd-size-7000",
    attributes: {},
    path: [
      "size",
      "7000"
    ]
  }
};
const popularpayLight = {
  semantic: semantic$2,
  button: button$2,
  card: card$2,
  sheet: sheet$2,
  comp: comp$2,
  gradient: gradient$2,
  shadow: shadow$2,
  typography: typography$3,
  border: border$2,
  opacity: opacity$2,
  space: space$2,
  old: old$2,
  radius: radius$2,
  stroke: stroke$2,
  font: font$2,
  reference: reference$2,
  size: size$2
};
const semantic$1 = {
  bg: {
    brand: {
      value: "rgba(255, 80, 78, 1)",
      type: "color",
      description: "lt-sys-color-bg-brand\n\naction, brand, button, primary, app, tint, background",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#ff504e",
        type: "color",
        description: "lt-sys-color-bg-brand\n\naction, brand, button, primary, app, tint, background"
      },
      name: "sd-semantic-bg-brand",
      attributes: {},
      path: [
        "semantic",
        "bg",
        "brand"
      ]
    },
    "brand-secondary": {
      value: "rgba(255, 80, 78, 0.1607843137254902)",
      type: "color",
      description: "lt-sys-color-bg-brand-secondary\n\n\naction, brand, button, primary, app, tint, opacity, background",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#ff504e29",
        type: "color",
        description: "lt-sys-color-bg-brand-secondary\n\n\naction, brand, button, primary, app, tint, opacity, background"
      },
      name: "sd-semantic-bg-brand-secondary",
      attributes: {},
      path: [
        "semantic",
        "bg",
        "brand-secondary"
      ]
    },
    primary: {
      value: "rgba(22, 23, 25, 1)",
      type: "color",
      description: "token = lh-semantic-color-bg-primary\n\nmid, level01, screen, background primary, default",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#161719",
        type: "color",
        description: "token = lh-semantic-color-bg-primary\n\nmid, level01, screen, background primary, default"
      },
      name: "sd-semantic-bg-primary",
      attributes: {},
      path: [
        "semantic",
        "bg",
        "primary"
      ]
    },
    secondary: {
      value: "rgba(34, 35, 37, 1)",
      type: "color",
      description: "token = lh-semantic-color-bg-secondary\n\ntoolbar, card, surface, level02, background secondary",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#222325",
        type: "color",
        description: "token = lh-semantic-color-bg-secondary\n\ntoolbar, card, surface, level02, background secondary"
      },
      name: "sd-semantic-bg-secondary",
      attributes: {},
      path: [
        "semantic",
        "bg",
        "secondary"
      ]
    },
    tertiary: {
      value: "rgba(0, 0, 0, 1)",
      type: "color",
      description: "token = lh-semantic-color-bg-tertiary\n\nbase, canvas, editor, alt, background tertiary",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#000000",
        type: "color",
        description: "token = lh-semantic-color-bg-tertiary\n\nbase, canvas, editor, alt, background tertiary"
      },
      name: "sd-semantic-bg-tertiary",
      attributes: {},
      path: [
        "semantic",
        "bg",
        "tertiary"
      ]
    },
    alpha: {
      value: "rgba(255, 255, 255, 0.0392156862745098)",
      type: "color",
      description: "token = lh-semantic-color-bg-alpha\n\non-card, plus level, transparent, separator",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#ffffff0a",
        type: "color",
        description: "token = lh-semantic-color-bg-alpha\n\non-card, plus level, transparent, separator"
      },
      name: "sd-semantic-bg-alpha",
      attributes: {},
      path: [
        "semantic",
        "bg",
        "alpha"
      ]
    },
    "alpha-secondary": {
      value: "rgba(0, 0, 0, 0.8)",
      type: "color",
      description: "token = lh-semantic-color-bg-alpha-secondary\n\nbackdrop, blanket, overlay, drawer, translucent",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#000000cc",
        type: "color",
        description: "token = lh-semantic-color-bg-alpha-secondary\n\nbackdrop, blanket, overlay, drawer, translucent"
      },
      name: "sd-semantic-bg-alpha-secondary",
      attributes: {},
      path: [
        "semantic",
        "bg",
        "alpha-secondary"
      ]
    },
    inverse: {
      value: "rgba(252, 252, 253, 1)",
      type: "color",
      description: "token = lh-semantic-color-bg-inverse\n\ninverse, mid, level01, screen, background",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#fcfcfd",
        type: "color",
        description: "token = lh-semantic-color-bg-inverse\n\ninverse, mid, level01, screen, background"
      },
      name: "sd-semantic-bg-inverse",
      attributes: {},
      path: [
        "semantic",
        "bg",
        "inverse"
      ]
    },
    neutral: {
      value: "rgba(230, 231, 233, 1)",
      type: "color",
      description: "token = lh-semantic-color-bg-neutral\n\naction, neutral, background, button",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#e6e7e9",
        type: "color",
        description: "token = lh-semantic-color-bg-neutral\n\naction, neutral, background, button"
      },
      name: "sd-semantic-bg-neutral",
      attributes: {},
      path: [
        "semantic",
        "bg",
        "neutral"
      ]
    },
    "neutral-secondary": {
      value: "rgba(230, 231, 233, 0.0784313725490196)",
      type: "color",
      description: "token = lh-semantic-color-bg-neutral-secondary\n\naction, neutral, opacity, translucent, background, button",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#e6e7e914",
        type: "color",
        description: "token = lh-semantic-color-bg-neutral-secondary\n\naction, neutral, opacity, translucent, background, button"
      },
      name: "sd-semantic-bg-neutral-secondary",
      attributes: {},
      path: [
        "semantic",
        "bg",
        "neutral-secondary"
      ]
    },
    disabled: {
      value: "rgba(122, 124, 129, 0.5019607843137255)",
      type: "color",
      description: "token = lh-semantic-color-bg-disabled\n\ndisabled, action, button",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#7a7c8180",
        type: "color",
        description: "token = lh-semantic-color-bg-disabled\n\ndisabled, action, button"
      },
      name: "sd-semantic-bg-disabled",
      attributes: {},
      path: [
        "semantic",
        "bg",
        "disabled"
      ]
    },
    "disabled-secondary": {
      value: "rgba(122, 124, 129, 0.12156862745098039)",
      type: "color",
      description: "token = lh-semantic-color-bg-disabled-secondary\n\ndisabled, action, transparent",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#7a7c811f",
        type: "color",
        description: "token = lh-semantic-color-bg-disabled-secondary\n\ndisabled, action, transparent"
      },
      name: "sd-semantic-bg-disabled-secondary",
      attributes: {},
      path: [
        "semantic",
        "bg",
        "disabled-secondary"
      ]
    },
    "neutral-inverse": {
      value: "rgba(44, 45, 48, 1)",
      type: "color",
      description: "token = lh-semantic-color-bg-neutral-inverse\n\naction, neutral, inverse,",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#2c2d30",
        type: "color",
        description: "token = lh-semantic-color-bg-neutral-inverse\n\naction, neutral, inverse,"
      },
      name: "sd-semantic-bg-neutral-inverse",
      attributes: {},
      path: [
        "semantic",
        "bg",
        "neutral-inverse"
      ]
    },
    "neutral-inverse-secondary": {
      value: "rgba(44, 45, 48, 0.12156862745098039)",
      type: "color",
      description: "lt-sys-color-bg-neutral-inverse-secondary\n\naction, neutral, inverse, opacity, translucent",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#2c2d301f",
        type: "color",
        description: "lt-sys-color-bg-neutral-inverse-secondary\n\naction, neutral, inverse, opacity, translucent"
      },
      name: "sd-semantic-bg-neutral-inverse-secondary",
      attributes: {},
      path: [
        "semantic",
        "bg",
        "neutral-inverse-secondary"
      ]
    },
    danger: {
      value: "rgba(255, 69, 58, 1)",
      type: "color",
      description: "token = lh-semantic-color-bg-danger\n\ndestructive, danger, error, action, delete",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#ff453a",
        type: "color",
        description: "token = lh-semantic-color-bg-danger\n\ndestructive, danger, error, action, delete"
      },
      name: "sd-semantic-bg-danger",
      attributes: {},
      path: [
        "semantic",
        "bg",
        "danger"
      ]
    },
    "danger-secondary": {
      value: "rgba(255, 69, 58, 0.1607843137254902)",
      type: "color",
      description: "token = lh-semantic-color-bg-danger-secondary\n\ndestructive, danger, error, action, delete, opacity",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#ff453a29",
        type: "color",
        description: "token = lh-semantic-color-bg-danger-secondary\n\ndestructive, danger, error, action, delete, opacity"
      },
      name: "sd-semantic-bg-danger-secondary",
      attributes: {},
      path: [
        "semantic",
        "bg",
        "danger-secondary"
      ]
    },
    success: {
      value: "rgba(74, 222, 128, 1)",
      type: "color",
      description: "token = lh-semantic-color-bg-success\n\nsuccess, positive, action, approved",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#4ade80",
        type: "color",
        description: "token = lh-semantic-color-bg-success\n\nsuccess, positive, action, approved"
      },
      name: "sd-semantic-bg-success",
      attributes: {},
      path: [
        "semantic",
        "bg",
        "success"
      ]
    },
    "success-secondary": {
      value: "rgba(74, 222, 128, 0.1607843137254902)",
      type: "color",
      description: "token = lh-semantic-color-bg-success-secondary\n\nsuccess, positive, action, approved, opacity",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#4ade8029",
        type: "color",
        description: "token = lh-semantic-color-bg-success-secondary\n\nsuccess, positive, action, approved, opacity"
      },
      name: "sd-semantic-bg-success-secondary",
      attributes: {},
      path: [
        "semantic",
        "bg",
        "success-secondary"
      ]
    },
    warning: {
      value: "rgba(250, 213, 79, 1)",
      type: "color",
      description: "token = lh-semantic-color-bg-warning\n\nwarning, careful, action, caution",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#fad54f",
        type: "color",
        description: "token = lh-semantic-color-bg-warning\n\nwarning, careful, action, caution"
      },
      name: "sd-semantic-bg-warning",
      attributes: {},
      path: [
        "semantic",
        "bg",
        "warning"
      ]
    },
    "warning-secondary": {
      value: "rgba(250, 213, 79, 0.1607843137254902)",
      type: "color",
      description: "token = lh-semantic-color-bg-warning-secondary\n\nwarning, careful, action, caution",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#fad54f29",
        type: "color",
        description: "token = lh-semantic-color-bg-warning-secondary\n\nwarning, careful, action, caution"
      },
      name: "sd-semantic-bg-warning-secondary",
      attributes: {},
      path: [
        "semantic",
        "bg",
        "warning-secondary"
      ]
    },
    transparent: {
      value: "rgba(255, 255, 255, 0)",
      type: "color",
      description: "token = lh-semantic-color-bg-transparent\n\nconstant, transparent",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#ffffff00",
        type: "color",
        description: "token = lh-semantic-color-bg-transparent\n\nconstant, transparent"
      },
      name: "sd-semantic-bg-transparent",
      attributes: {},
      path: [
        "semantic",
        "bg",
        "transparent"
      ]
    },
    white: {
      value: "rgba(255, 255, 255, 1)",
      type: "color",
      description: "token = lh-semantic-color-bg-white\n\nconstant, white",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#ffffff",
        type: "color",
        description: "token = lh-semantic-color-bg-white\n\nconstant, white"
      },
      name: "sd-semantic-bg-white",
      attributes: {},
      path: [
        "semantic",
        "bg",
        "white"
      ]
    },
    "white-secondary": {
      value: "rgba(255, 255, 255, 0.12156862745098039)",
      type: "color",
      description: "token = lh-semantic-color-bg-white-secondary\n\nconstant, white",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#ffffff1f",
        type: "color",
        description: "token = lh-semantic-color-bg-white-secondary\n\nconstant, white"
      },
      name: "sd-semantic-bg-white-secondary",
      attributes: {},
      path: [
        "semantic",
        "bg",
        "white-secondary"
      ]
    },
    black: {
      value: "rgba(0, 0, 0, 1)",
      type: "color",
      description: "token = lh-semantic-color-bg-black\n\nconstant, black",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#000000",
        type: "color",
        description: "token = lh-semantic-color-bg-black\n\nconstant, black"
      },
      name: "sd-semantic-bg-black",
      attributes: {},
      path: [
        "semantic",
        "bg",
        "black"
      ]
    },
    "black-secondary": {
      value: "rgba(0, 0, 0, 0.30196078431372547)",
      type: "color",
      description: "token = lh-semantic-color-bg-black-secondary\n\nconstant, black",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#0000004d",
        type: "color",
        description: "token = lh-semantic-color-bg-black-secondary\n\nconstant, black"
      },
      name: "sd-semantic-bg-black-secondary",
      attributes: {},
      path: [
        "semantic",
        "bg",
        "black-secondary"
      ]
    }
  },
  fg: {
    brand: {
      value: "rgba(255, 80, 78, 1)",
      type: "color",
      description: "lt-sys-color-fg-brand\n\n\naction, brand, primary, app, contrast, text, icon",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#ff504e",
        type: "color",
        description: "lt-sys-color-fg-brand\n\n\naction, brand, primary, app, contrast, text, icon"
      },
      name: "sd-semantic-fg-brand",
      attributes: {},
      path: [
        "semantic",
        "fg",
        "brand"
      ]
    },
    "brand-secondary": {
      value: "rgba(255, 185, 184, 1)",
      type: "color",
      description: "lt-sys-color-fg-brand-secondary\n\naction, brand, primary, app, contrast, highlight",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#ffb9b8",
        type: "color",
        description: "lt-sys-color-fg-brand-secondary\n\naction, brand, primary, app, contrast, highlight"
      },
      name: "sd-semantic-fg-brand-secondary",
      attributes: {},
      path: [
        "semantic",
        "fg",
        "brand-secondary"
      ]
    },
    primary: {
      value: "rgba(252, 252, 253, 1)",
      type: "color",
      description: "token = lh-semantic-color-fg-primary\n\ntitle, headline, main text, matching icon",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#fcfcfd",
        type: "color",
        description: "token = lh-semantic-color-fg-primary\n\ntitle, headline, main text, matching icon"
      },
      name: "sd-semantic-fg-primary",
      attributes: {},
      path: [
        "semantic",
        "fg",
        "primary"
      ]
    },
    secondary: {
      value: "rgba(163, 166, 172, 1)",
      type: "color",
      description: "token = lh-semantic-color-fg-secondary\n\nbody text, subtitle, matching icons",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#a3a6ac",
        type: "color",
        description: "token = lh-semantic-color-fg-secondary\n\nbody text, subtitle, matching icons"
      },
      name: "sd-semantic-fg-secondary",
      attributes: {},
      path: [
        "semantic",
        "fg",
        "secondary"
      ]
    },
    tertiary: {
      value: "rgba(122, 124, 129, 1)",
      type: "color",
      description: "token = lh-semantic-color-fg-tertiary\n\nplaceholder text, muted",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#7a7c81",
        type: "color",
        description: "token = lh-semantic-color-fg-tertiary\n\nplaceholder text, muted"
      },
      name: "sd-semantic-fg-tertiary",
      attributes: {},
      path: [
        "semantic",
        "fg",
        "tertiary"
      ]
    },
    inverse: {
      value: "rgba(22, 23, 25, 1)",
      type: "color",
      description: "token = lh-semantic-color-fg-inverse\n\ninverse, title, headline, main text, matching icon",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#161719",
        type: "color",
        description: "token = lh-semantic-color-fg-inverse\n\ninverse, title, headline, main text, matching icon"
      },
      name: "sd-semantic-fg-inverse",
      attributes: {},
      path: [
        "semantic",
        "fg",
        "inverse"
      ]
    },
    "inverse-secondary": {
      value: "rgba(122, 124, 129, 1)",
      type: "color",
      description: "token = lh-semantic-color-fg-inverse-secondary\n\ninverse, body text, subtitle, matching icons",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#7a7c81",
        type: "color",
        description: "token = lh-semantic-color-fg-inverse-secondary\n\ninverse, body text, subtitle, matching icons"
      },
      name: "sd-semantic-fg-inverse-secondary",
      attributes: {},
      path: [
        "semantic",
        "fg",
        "inverse-secondary"
      ]
    },
    neutral: {
      value: "rgba(230, 231, 233, 1)",
      type: "color",
      description: "token = lh-semantic-color-fg-neutral\n\naction, neutral, icon, text",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#e6e7e9",
        type: "color",
        description: "token = lh-semantic-color-fg-neutral\n\naction, neutral, icon, text"
      },
      name: "sd-semantic-fg-neutral",
      attributes: {},
      path: [
        "semantic",
        "fg",
        "neutral"
      ]
    },
    disabled: {
      value: "rgba(122, 124, 129, 0.5019607843137255)",
      type: "color",
      description: "token = lh-semantic-color-fg-disabled\n\ndisabled, action",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#7a7c8180",
        type: "color",
        description: "token = lh-semantic-color-fg-disabled\n\ndisabled, action"
      },
      name: "sd-semantic-fg-disabled",
      attributes: {},
      path: [
        "semantic",
        "fg",
        "disabled"
      ]
    },
    "neutral-secondary": {
      value: "rgba(44, 45, 48, 1)",
      type: "color",
      description: "token = lh-semantic-color-fg-neutral-secondary\n\naction, neutral, inverse, text, icon",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#2c2d30",
        type: "color",
        description: "token = lh-semantic-color-fg-neutral-secondary\n\naction, neutral, inverse, text, icon"
      },
      name: "sd-semantic-fg-neutral-secondary",
      attributes: {},
      path: [
        "semantic",
        "fg",
        "neutral-secondary"
      ]
    },
    danger: {
      value: "rgba(255, 69, 58, 1)",
      type: "color",
      description: "token = lh-semantic-color-fg-danger\n\ndestructive, danger, error, action, delete",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#ff453a",
        type: "color",
        description: "token = lh-semantic-color-fg-danger\n\ndestructive, danger, error, action, delete"
      },
      name: "sd-semantic-fg-danger",
      attributes: {},
      path: [
        "semantic",
        "fg",
        "danger"
      ]
    },
    success: {
      value: "rgba(74, 222, 128, 1)",
      type: "color",
      description: "token = lh-semantic-color-fg-success\n\nsuccess, positive, action, approved",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#4ade80",
        type: "color",
        description: "token = lh-semantic-color-fg-success\n\nsuccess, positive, action, approved"
      },
      name: "sd-semantic-fg-success",
      attributes: {},
      path: [
        "semantic",
        "fg",
        "success"
      ]
    },
    warning: {
      value: "rgba(250, 213, 79, 1)",
      type: "color",
      description: "token = lh-semantic-color-fg-warning\n\nwarning, careful, action, caution",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#fad54f",
        type: "color",
        description: "token = lh-semantic-color-fg-warning\n\nwarning, careful, action, caution"
      },
      name: "sd-semantic-fg-warning",
      attributes: {},
      path: [
        "semantic",
        "fg",
        "warning"
      ]
    },
    white: {
      value: "rgba(255, 255, 255, 1)",
      type: "color",
      description: "token = lh-semantic-color-fg-white\n\nconstant, white, overlay, icon, text",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#ffffff",
        type: "color",
        description: "token = lh-semantic-color-fg-white\n\nconstant, white, overlay, icon, text"
      },
      name: "sd-semantic-fg-white",
      attributes: {},
      path: [
        "semantic",
        "fg",
        "white"
      ]
    },
    black: {
      value: "rgba(22, 23, 25, 1)",
      type: "color",
      description: "token = lh-semantic-color-fg-black\n\nconstant, black, overlay, icon, text",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#161719",
        type: "color",
        description: "token = lh-semantic-color-fg-black\n\nconstant, black, overlay, icon, text"
      },
      name: "sd-semantic-fg-black",
      attributes: {},
      path: [
        "semantic",
        "fg",
        "black"
      ]
    }
  }
};
const button$1 = {
  large: {
    "icon-first": {
      height: {
        value: "48px",
        type: "dimension",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 48,
          type: "dimension"
        },
        name: "sd-button-large-icon-first-height",
        attributes: {},
        path: [
          "button",
          "large",
          "icon-first",
          "height"
        ]
      },
      paddingRight: {
        value: "20px",
        type: "dimension",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 20,
          type: "dimension"
        },
        name: "sd-button-large-icon-first-padding-right",
        attributes: {},
        path: [
          "button",
          "large",
          "icon-first",
          "paddingRight"
        ]
      },
      paddingLeft: {
        value: "12px",
        type: "dimension",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 12,
          type: "dimension"
        },
        name: "sd-button-large-icon-first-padding-left",
        attributes: {},
        path: [
          "button",
          "large",
          "icon-first",
          "paddingLeft"
        ]
      },
      borderRadius: {
        value: "999px",
        type: "borderRadius",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 999,
          type: "borderRadius"
        },
        name: "sd-button-large-icon-first-border-radius",
        attributes: {},
        path: [
          "button",
          "large",
          "icon-first",
          "borderRadius"
        ]
      },
      itemSpacing: {
        value: "8px",
        type: "dimension",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 8,
          type: "dimension"
        },
        name: "sd-button-large-icon-first-item-spacing",
        attributes: {},
        path: [
          "button",
          "large",
          "icon-first",
          "itemSpacing"
        ]
      }
    },
    "label-first": {
      height: {
        value: "48px",
        type: "dimension",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 48,
          type: "dimension"
        },
        name: "sd-button-large-label-first-height",
        attributes: {},
        path: [
          "button",
          "large",
          "label-first",
          "height"
        ]
      },
      paddingRight: {
        value: "12px",
        type: "dimension",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 12,
          type: "dimension"
        },
        name: "sd-button-large-label-first-padding-right",
        attributes: {},
        path: [
          "button",
          "large",
          "label-first",
          "paddingRight"
        ]
      },
      paddingLeft: {
        value: "20px",
        type: "dimension",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 20,
          type: "dimension"
        },
        name: "sd-button-large-label-first-padding-left",
        attributes: {},
        path: [
          "button",
          "large",
          "label-first",
          "paddingLeft"
        ]
      },
      borderRadius: {
        value: "999px",
        type: "borderRadius",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 999,
          type: "borderRadius"
        },
        name: "sd-button-large-label-first-border-radius",
        attributes: {},
        path: [
          "button",
          "large",
          "label-first",
          "borderRadius"
        ]
      },
      itemSpacing: {
        value: "8px",
        type: "dimension",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 8,
          type: "dimension"
        },
        name: "sd-button-large-label-first-item-spacing",
        attributes: {},
        path: [
          "button",
          "large",
          "label-first",
          "itemSpacing"
        ]
      }
    },
    label: {
      height: {
        value: "48px",
        type: "dimension",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 48,
          type: "dimension"
        },
        name: "sd-button-large-label-height",
        attributes: {},
        path: [
          "button",
          "large",
          "label",
          "height"
        ]
      },
      paddingRight: {
        value: "24px",
        type: "dimension",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 24,
          type: "dimension"
        },
        name: "sd-button-large-label-padding-right",
        attributes: {},
        path: [
          "button",
          "large",
          "label",
          "paddingRight"
        ]
      },
      paddingLeft: {
        value: "24px",
        type: "dimension",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 24,
          type: "dimension"
        },
        name: "sd-button-large-label-padding-left",
        attributes: {},
        path: [
          "button",
          "large",
          "label",
          "paddingLeft"
        ]
      },
      borderRadius: {
        value: "999px",
        type: "borderRadius",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 999,
          type: "borderRadius"
        },
        name: "sd-button-large-label-border-radius",
        attributes: {},
        path: [
          "button",
          "large",
          "label",
          "borderRadius"
        ]
      },
      itemSpacing: {
        value: "8px",
        type: "dimension",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 8,
          type: "dimension"
        },
        name: "sd-button-large-label-item-spacing",
        attributes: {},
        path: [
          "button",
          "large",
          "label",
          "itemSpacing"
        ]
      }
    },
    icon: {
      height: {
        value: "48px",
        type: "dimension",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 48,
          type: "dimension"
        },
        name: "sd-button-large-icon-height",
        attributes: {},
        path: [
          "button",
          "large",
          "icon",
          "height"
        ]
      },
      paddingRight: {
        value: "24px",
        type: "dimension",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 24,
          type: "dimension"
        },
        name: "sd-button-large-icon-padding-right",
        attributes: {},
        path: [
          "button",
          "large",
          "icon",
          "paddingRight"
        ]
      },
      paddingLeft: {
        value: "24px",
        type: "dimension",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 24,
          type: "dimension"
        },
        name: "sd-button-large-icon-padding-left",
        attributes: {},
        path: [
          "button",
          "large",
          "icon",
          "paddingLeft"
        ]
      },
      borderRadius: {
        value: "999px",
        type: "borderRadius",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 999,
          type: "borderRadius"
        },
        name: "sd-button-large-icon-border-radius",
        attributes: {},
        path: [
          "button",
          "large",
          "icon",
          "borderRadius"
        ]
      },
      width: {
        value: "48px",
        type: "dimension",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 48,
          type: "dimension"
        },
        name: "sd-button-large-icon-width",
        attributes: {},
        path: [
          "button",
          "large",
          "icon",
          "width"
        ]
      },
      itemSpacing: {
        value: "8px",
        type: "dimension",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 8,
          type: "dimension"
        },
        name: "sd-button-large-icon-item-spacing",
        attributes: {},
        path: [
          "button",
          "large",
          "icon",
          "itemSpacing"
        ]
      }
    }
  },
  medium: {
    "icon-first": {
      height: {
        value: "40px",
        type: "dimension",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 40,
          type: "dimension"
        },
        name: "sd-button-medium-icon-first-height",
        attributes: {},
        path: [
          "button",
          "medium",
          "icon-first",
          "height"
        ]
      },
      paddingRight: {
        value: "16px",
        type: "dimension",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 16,
          type: "dimension"
        },
        name: "sd-button-medium-icon-first-padding-right",
        attributes: {},
        path: [
          "button",
          "medium",
          "icon-first",
          "paddingRight"
        ]
      },
      paddingLeft: {
        value: "8px",
        type: "dimension",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 8,
          type: "dimension"
        },
        name: "sd-button-medium-icon-first-padding-left",
        attributes: {},
        path: [
          "button",
          "medium",
          "icon-first",
          "paddingLeft"
        ]
      },
      borderRadius: {
        value: "999px",
        type: "borderRadius",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 999,
          type: "borderRadius"
        },
        name: "sd-button-medium-icon-first-border-radius",
        attributes: {},
        path: [
          "button",
          "medium",
          "icon-first",
          "borderRadius"
        ]
      },
      itemSpacing: {
        value: "6px",
        type: "dimension",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 6,
          type: "dimension"
        },
        name: "sd-button-medium-icon-first-item-spacing",
        attributes: {},
        path: [
          "button",
          "medium",
          "icon-first",
          "itemSpacing"
        ]
      }
    },
    "label-first": {
      height: {
        value: "40px",
        type: "dimension",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 40,
          type: "dimension"
        },
        name: "sd-button-medium-label-first-height",
        attributes: {},
        path: [
          "button",
          "medium",
          "label-first",
          "height"
        ]
      },
      paddingRight: {
        value: "8px",
        type: "dimension",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 8,
          type: "dimension"
        },
        name: "sd-button-medium-label-first-padding-right",
        attributes: {},
        path: [
          "button",
          "medium",
          "label-first",
          "paddingRight"
        ]
      },
      paddingLeft: {
        value: "16px",
        type: "dimension",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 16,
          type: "dimension"
        },
        name: "sd-button-medium-label-first-padding-left",
        attributes: {},
        path: [
          "button",
          "medium",
          "label-first",
          "paddingLeft"
        ]
      },
      borderRadius: {
        value: "999px",
        type: "borderRadius",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 999,
          type: "borderRadius"
        },
        name: "sd-button-medium-label-first-border-radius",
        attributes: {},
        path: [
          "button",
          "medium",
          "label-first",
          "borderRadius"
        ]
      },
      itemSpacing: {
        value: "6px",
        type: "dimension",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 6,
          type: "dimension"
        },
        name: "sd-button-medium-label-first-item-spacing",
        attributes: {},
        path: [
          "button",
          "medium",
          "label-first",
          "itemSpacing"
        ]
      }
    },
    label: {
      height: {
        value: "40px",
        type: "dimension",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 40,
          type: "dimension"
        },
        name: "sd-button-medium-label-height",
        attributes: {},
        path: [
          "button",
          "medium",
          "label",
          "height"
        ]
      },
      paddingRight: {
        value: "20px",
        type: "dimension",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 20,
          type: "dimension"
        },
        name: "sd-button-medium-label-padding-right",
        attributes: {},
        path: [
          "button",
          "medium",
          "label",
          "paddingRight"
        ]
      },
      paddingLeft: {
        value: "20px",
        type: "dimension",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 20,
          type: "dimension"
        },
        name: "sd-button-medium-label-padding-left",
        attributes: {},
        path: [
          "button",
          "medium",
          "label",
          "paddingLeft"
        ]
      },
      borderRadius: {
        value: "999px",
        type: "borderRadius",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 999,
          type: "borderRadius"
        },
        name: "sd-button-medium-label-border-radius",
        attributes: {},
        path: [
          "button",
          "medium",
          "label",
          "borderRadius"
        ]
      },
      itemSpacing: {
        value: "6px",
        type: "dimension",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 6,
          type: "dimension"
        },
        name: "sd-button-medium-label-item-spacing",
        attributes: {},
        path: [
          "button",
          "medium",
          "label",
          "itemSpacing"
        ]
      }
    },
    icon: {
      height: {
        value: "40px",
        type: "dimension",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 40,
          type: "dimension"
        },
        name: "sd-button-medium-icon-height",
        attributes: {},
        path: [
          "button",
          "medium",
          "icon",
          "height"
        ]
      },
      paddingRight: {
        value: "20px",
        type: "dimension",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 20,
          type: "dimension"
        },
        name: "sd-button-medium-icon-padding-right",
        attributes: {},
        path: [
          "button",
          "medium",
          "icon",
          "paddingRight"
        ]
      },
      paddingLeft: {
        value: "20px",
        type: "dimension",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 20,
          type: "dimension"
        },
        name: "sd-button-medium-icon-padding-left",
        attributes: {},
        path: [
          "button",
          "medium",
          "icon",
          "paddingLeft"
        ]
      },
      borderRadius: {
        value: "999px",
        type: "borderRadius",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 999,
          type: "borderRadius"
        },
        name: "sd-button-medium-icon-border-radius",
        attributes: {},
        path: [
          "button",
          "medium",
          "icon",
          "borderRadius"
        ]
      },
      width: {
        value: "40px",
        type: "dimension",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 40,
          type: "dimension"
        },
        name: "sd-button-medium-icon-width",
        attributes: {},
        path: [
          "button",
          "medium",
          "icon",
          "width"
        ]
      },
      itemSpacing: {
        value: "6px",
        type: "dimension",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 6,
          type: "dimension"
        },
        name: "sd-button-medium-icon-item-spacing",
        attributes: {},
        path: [
          "button",
          "medium",
          "icon",
          "itemSpacing"
        ]
      }
    }
  },
  small: {
    "icon-first": {
      height: {
        value: "32px",
        type: "dimension",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 32,
          type: "dimension"
        },
        name: "sd-button-small-icon-first-height",
        attributes: {},
        path: [
          "button",
          "small",
          "icon-first",
          "height"
        ]
      },
      paddingRight: {
        value: "12px",
        type: "dimension",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 12,
          type: "dimension"
        },
        name: "sd-button-small-icon-first-padding-right",
        attributes: {},
        path: [
          "button",
          "small",
          "icon-first",
          "paddingRight"
        ]
      },
      paddingLeft: {
        value: "6px",
        type: "dimension",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 6,
          type: "dimension"
        },
        name: "sd-button-small-icon-first-padding-left",
        attributes: {},
        path: [
          "button",
          "small",
          "icon-first",
          "paddingLeft"
        ]
      },
      borderRadius: {
        value: "999px",
        type: "borderRadius",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 999,
          type: "borderRadius"
        },
        name: "sd-button-small-icon-first-border-radius",
        attributes: {},
        path: [
          "button",
          "small",
          "icon-first",
          "borderRadius"
        ]
      },
      itemSpacing: {
        value: "4px",
        type: "dimension",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 4,
          type: "dimension"
        },
        name: "sd-button-small-icon-first-item-spacing",
        attributes: {},
        path: [
          "button",
          "small",
          "icon-first",
          "itemSpacing"
        ]
      }
    },
    "label-first": {
      height: {
        value: "32px",
        type: "dimension",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 32,
          type: "dimension"
        },
        name: "sd-button-small-label-first-height",
        attributes: {},
        path: [
          "button",
          "small",
          "label-first",
          "height"
        ]
      },
      paddingRight: {
        value: "6px",
        type: "dimension",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 6,
          type: "dimension"
        },
        name: "sd-button-small-label-first-padding-right",
        attributes: {},
        path: [
          "button",
          "small",
          "label-first",
          "paddingRight"
        ]
      },
      paddingLeft: {
        value: "12px",
        type: "dimension",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 12,
          type: "dimension"
        },
        name: "sd-button-small-label-first-padding-left",
        attributes: {},
        path: [
          "button",
          "small",
          "label-first",
          "paddingLeft"
        ]
      },
      borderRadius: {
        value: "999px",
        type: "borderRadius",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 999,
          type: "borderRadius"
        },
        name: "sd-button-small-label-first-border-radius",
        attributes: {},
        path: [
          "button",
          "small",
          "label-first",
          "borderRadius"
        ]
      },
      itemSpacing: {
        value: "4px",
        type: "dimension",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 4,
          type: "dimension"
        },
        name: "sd-button-small-label-first-item-spacing",
        attributes: {},
        path: [
          "button",
          "small",
          "label-first",
          "itemSpacing"
        ]
      }
    },
    label: {
      height: {
        value: "32px",
        type: "dimension",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 32,
          type: "dimension"
        },
        name: "sd-button-small-label-height",
        attributes: {},
        path: [
          "button",
          "small",
          "label",
          "height"
        ]
      },
      paddingRight: {
        value: "16px",
        type: "dimension",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 16,
          type: "dimension"
        },
        name: "sd-button-small-label-padding-right",
        attributes: {},
        path: [
          "button",
          "small",
          "label",
          "paddingRight"
        ]
      },
      paddingLeft: {
        value: "16px",
        type: "dimension",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 16,
          type: "dimension"
        },
        name: "sd-button-small-label-padding-left",
        attributes: {},
        path: [
          "button",
          "small",
          "label",
          "paddingLeft"
        ]
      },
      borderRadius: {
        value: "999px",
        type: "borderRadius",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 999,
          type: "borderRadius"
        },
        name: "sd-button-small-label-border-radius",
        attributes: {},
        path: [
          "button",
          "small",
          "label",
          "borderRadius"
        ]
      },
      itemSpacing: {
        value: "4px",
        type: "dimension",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 4,
          type: "dimension"
        },
        name: "sd-button-small-label-item-spacing",
        attributes: {},
        path: [
          "button",
          "small",
          "label",
          "itemSpacing"
        ]
      }
    },
    icon: {
      height: {
        value: "32px",
        type: "dimension",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 32,
          type: "dimension"
        },
        name: "sd-button-small-icon-height",
        attributes: {},
        path: [
          "button",
          "small",
          "icon",
          "height"
        ]
      },
      paddingRight: {
        value: "16px",
        type: "dimension",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 16,
          type: "dimension"
        },
        name: "sd-button-small-icon-padding-right",
        attributes: {},
        path: [
          "button",
          "small",
          "icon",
          "paddingRight"
        ]
      },
      paddingLeft: {
        value: "16px",
        type: "dimension",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 16,
          type: "dimension"
        },
        name: "sd-button-small-icon-padding-left",
        attributes: {},
        path: [
          "button",
          "small",
          "icon",
          "paddingLeft"
        ]
      },
      borderRadius: {
        value: "999px",
        type: "borderRadius",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 999,
          type: "borderRadius"
        },
        name: "sd-button-small-icon-border-radius",
        attributes: {},
        path: [
          "button",
          "small",
          "icon",
          "borderRadius"
        ]
      },
      width: {
        value: "32px",
        type: "dimension",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 32,
          type: "dimension"
        },
        name: "sd-button-small-icon-width",
        attributes: {},
        path: [
          "button",
          "small",
          "icon",
          "width"
        ]
      },
      itemSpacing: {
        value: "4px",
        type: "dimension",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 4,
          type: "dimension"
        },
        name: "sd-button-small-icon-item-spacing",
        attributes: {},
        path: [
          "button",
          "small",
          "icon",
          "itemSpacing"
        ]
      }
    }
  },
  height: {
    sm: {
      value: "32px",
      type: "sizing",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 32,
        type: "sizing"
      },
      name: "sd-button-height-sm",
      attributes: {},
      path: [
        "button",
        "height",
        "sm"
      ]
    },
    md: {
      value: "40px",
      type: "sizing",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 40,
        type: "sizing"
      },
      name: "sd-button-height-md",
      attributes: {},
      path: [
        "button",
        "height",
        "md"
      ]
    },
    lg: {
      value: "48px",
      type: "sizing",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 48,
        type: "sizing"
      },
      name: "sd-button-height-lg",
      attributes: {},
      path: [
        "button",
        "height",
        "lg"
      ]
    }
  },
  space: {
    large: {
      min: {
        value: "12px",
        type: "spacing",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 12,
          type: "spacing"
        },
        name: "sd-button-space-large-min",
        attributes: {},
        path: [
          "button",
          "space",
          "large",
          "min"
        ]
      },
      max: {
        value: "20px",
        type: "spacing",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 20,
          type: "spacing"
        },
        name: "sd-button-space-large-max",
        attributes: {},
        path: [
          "button",
          "space",
          "large",
          "max"
        ]
      },
      "default": {
        value: "24px",
        type: "spacing",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 24,
          type: "spacing"
        },
        name: "sd-button-space-large-default",
        attributes: {},
        path: [
          "button",
          "space",
          "large",
          "default"
        ]
      },
      gap: {
        value: "8px",
        type: "spacing",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 8,
          type: "spacing"
        },
        name: "sd-button-space-large-gap",
        attributes: {},
        path: [
          "button",
          "space",
          "large",
          "gap"
        ]
      }
    },
    medium: {
      min: {
        value: "8px",
        type: "spacing",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 8,
          type: "spacing"
        },
        name: "sd-button-space-medium-min",
        attributes: {},
        path: [
          "button",
          "space",
          "medium",
          "min"
        ]
      },
      max: {
        value: "16px",
        type: "spacing",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 16,
          type: "spacing"
        },
        name: "sd-button-space-medium-max",
        attributes: {},
        path: [
          "button",
          "space",
          "medium",
          "max"
        ]
      },
      "default": {
        value: "20px",
        type: "spacing",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 20,
          type: "spacing"
        },
        name: "sd-button-space-medium-default",
        attributes: {},
        path: [
          "button",
          "space",
          "medium",
          "default"
        ]
      },
      gap: {
        value: "6px",
        type: "spacing",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 6,
          type: "spacing"
        },
        name: "sd-button-space-medium-gap",
        attributes: {},
        path: [
          "button",
          "space",
          "medium",
          "gap"
        ]
      }
    },
    small: {
      min: {
        value: "6px",
        type: "spacing",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 6,
          type: "spacing"
        },
        name: "sd-button-space-small-min",
        attributes: {},
        path: [
          "button",
          "space",
          "small",
          "min"
        ]
      },
      max: {
        value: "12px",
        type: "spacing",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 12,
          type: "spacing"
        },
        name: "sd-button-space-small-max",
        attributes: {},
        path: [
          "button",
          "space",
          "small",
          "max"
        ]
      },
      "default": {
        value: "16px",
        type: "spacing",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 16,
          type: "spacing"
        },
        name: "sd-button-space-small-default",
        attributes: {},
        path: [
          "button",
          "space",
          "small",
          "default"
        ]
      },
      gap: {
        value: "4px",
        type: "spacing",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 4,
          type: "spacing"
        },
        name: "sd-button-space-small-gap",
        attributes: {},
        path: [
          "button",
          "space",
          "small",
          "gap"
        ]
      }
    }
  },
  radius: {
    value: "999px",
    type: "borderRadius",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 999,
      type: "borderRadius"
    },
    name: "sd-button-radius",
    attributes: {},
    path: [
      "button",
      "radius"
    ]
  }
};
const card$1 = {
  small: {
    verticalPadding: {
      value: "8px",
      type: "dimension",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 8,
        type: "dimension"
      },
      name: "sd-card-small-vertical-padding",
      attributes: {},
      path: [
        "card",
        "small",
        "verticalPadding"
      ]
    },
    horizontalPadding: {
      value: "8px",
      type: "dimension",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 8,
        type: "dimension"
      },
      name: "sd-card-small-horizontal-padding",
      attributes: {},
      path: [
        "card",
        "small",
        "horizontalPadding"
      ]
    },
    borderRadius: {
      value: "24px",
      type: "borderRadius",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 24,
        type: "borderRadius"
      },
      name: "sd-card-small-border-radius",
      attributes: {},
      path: [
        "card",
        "small",
        "borderRadius"
      ]
    },
    boxShadow: {
      "0": {
        color: {
          value: "rgba(0, 0, 0, 0.0784313725490196)",
          type: "color",
          filePath: "themes/videoleap-dark.json",
          isSource: true,
          original: {
            value: "#00000014",
            type: "color"
          },
          name: "sd-card-small-box-shadow-0-color",
          attributes: {},
          path: [
            "card",
            "small",
            "boxShadow",
            "0",
            "color"
          ]
        },
        type: {
          value: "dropShadow",
          type: "type",
          filePath: "themes/videoleap-dark.json",
          isSource: true,
          original: {
            value: "dropShadow",
            type: "type"
          },
          name: "sd-card-small-box-shadow-0-type",
          attributes: {},
          path: [
            "card",
            "small",
            "boxShadow",
            "0",
            "type"
          ]
        },
        x: {
          value: "0px",
          type: "x",
          filePath: "themes/videoleap-dark.json",
          isSource: true,
          original: {
            value: 0,
            type: "x"
          },
          name: "sd-card-small-box-shadow-0-x",
          attributes: {},
          path: [
            "card",
            "small",
            "boxShadow",
            "0",
            "x"
          ]
        },
        y: {
          value: "0px",
          type: "y",
          filePath: "themes/videoleap-dark.json",
          isSource: true,
          original: {
            value: 0,
            type: "y"
          },
          name: "sd-card-small-box-shadow-0-y",
          attributes: {},
          path: [
            "card",
            "small",
            "boxShadow",
            "0",
            "y"
          ]
        },
        blur: {
          value: "1px",
          type: "blur",
          filePath: "themes/videoleap-dark.json",
          isSource: true,
          original: {
            value: 1,
            type: "blur"
          },
          name: "sd-card-small-box-shadow-0-blur",
          attributes: {},
          path: [
            "card",
            "small",
            "boxShadow",
            "0",
            "blur"
          ]
        },
        spread: {
          value: "0px",
          type: "spread",
          filePath: "themes/videoleap-dark.json",
          isSource: true,
          original: {
            value: 0,
            type: "spread"
          },
          name: "sd-card-small-box-shadow-0-spread",
          attributes: {},
          path: [
            "card",
            "small",
            "boxShadow",
            "0",
            "spread"
          ]
        }
      },
      "1": {
        color: {
          value: "rgba(0, 0, 0, 0.058823529411764705)",
          type: "color",
          filePath: "themes/videoleap-dark.json",
          isSource: true,
          original: {
            value: "#0000000f",
            type: "color"
          },
          name: "sd-card-small-box-shadow-1-color",
          attributes: {},
          path: [
            "card",
            "small",
            "boxShadow",
            "1",
            "color"
          ]
        },
        type: {
          value: "dropShadow",
          type: "type",
          filePath: "themes/videoleap-dark.json",
          isSource: true,
          original: {
            value: "dropShadow",
            type: "type"
          },
          name: "sd-card-small-box-shadow-1-type",
          attributes: {},
          path: [
            "card",
            "small",
            "boxShadow",
            "1",
            "type"
          ]
        },
        x: {
          value: "0px",
          type: "x",
          filePath: "themes/videoleap-dark.json",
          isSource: true,
          original: {
            value: 0,
            type: "x"
          },
          name: "sd-card-small-box-shadow-1-x",
          attributes: {},
          path: [
            "card",
            "small",
            "boxShadow",
            "1",
            "x"
          ]
        },
        y: {
          value: "2px",
          type: "y",
          filePath: "themes/videoleap-dark.json",
          isSource: true,
          original: {
            value: 2,
            type: "y"
          },
          name: "sd-card-small-box-shadow-1-y",
          attributes: {},
          path: [
            "card",
            "small",
            "boxShadow",
            "1",
            "y"
          ]
        },
        blur: {
          value: "32px",
          type: "blur",
          filePath: "themes/videoleap-dark.json",
          isSource: true,
          original: {
            value: 32,
            type: "blur"
          },
          name: "sd-card-small-box-shadow-1-blur",
          attributes: {},
          path: [
            "card",
            "small",
            "boxShadow",
            "1",
            "blur"
          ]
        },
        spread: {
          value: "0px",
          type: "spread",
          filePath: "themes/videoleap-dark.json",
          isSource: true,
          original: {
            value: 0,
            type: "spread"
          },
          name: "sd-card-small-box-shadow-1-spread",
          attributes: {},
          path: [
            "card",
            "small",
            "boxShadow",
            "1",
            "spread"
          ]
        }
      }
    },
    fill: {
      value: "#222325",
      type: "fill",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#222325",
        type: "fill"
      },
      name: "sd-card-small-fill",
      attributes: {},
      path: [
        "card",
        "small",
        "fill"
      ]
    }
  },
  medium: {
    verticalPadding: {
      value: "12px",
      type: "dimension",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 12,
        type: "dimension"
      },
      name: "sd-card-medium-vertical-padding",
      attributes: {},
      path: [
        "card",
        "medium",
        "verticalPadding"
      ]
    },
    horizontalPadding: {
      value: "12px",
      type: "dimension",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 12,
        type: "dimension"
      },
      name: "sd-card-medium-horizontal-padding",
      attributes: {},
      path: [
        "card",
        "medium",
        "horizontalPadding"
      ]
    },
    borderRadius: {
      value: "32px",
      type: "borderRadius",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 32,
        type: "borderRadius"
      },
      name: "sd-card-medium-border-radius",
      attributes: {},
      path: [
        "card",
        "medium",
        "borderRadius"
      ]
    },
    boxShadow: {
      "0": {
        color: {
          value: "rgba(0, 0, 0, 0.1607843137254902)",
          type: "color",
          filePath: "themes/videoleap-dark.json",
          isSource: true,
          original: {
            value: "#00000029",
            type: "color"
          },
          name: "sd-card-medium-box-shadow-0-color",
          attributes: {},
          path: [
            "card",
            "medium",
            "boxShadow",
            "0",
            "color"
          ]
        },
        type: {
          value: "dropShadow",
          type: "type",
          filePath: "themes/videoleap-dark.json",
          isSource: true,
          original: {
            value: "dropShadow",
            type: "type"
          },
          name: "sd-card-medium-box-shadow-0-type",
          attributes: {},
          path: [
            "card",
            "medium",
            "boxShadow",
            "0",
            "type"
          ]
        },
        x: {
          value: "0px",
          type: "x",
          filePath: "themes/videoleap-dark.json",
          isSource: true,
          original: {
            value: 0,
            type: "x"
          },
          name: "sd-card-medium-box-shadow-0-x",
          attributes: {},
          path: [
            "card",
            "medium",
            "boxShadow",
            "0",
            "x"
          ]
        },
        y: {
          value: "18px",
          type: "y",
          filePath: "themes/videoleap-dark.json",
          isSource: true,
          original: {
            value: 18,
            type: "y"
          },
          name: "sd-card-medium-box-shadow-0-y",
          attributes: {},
          path: [
            "card",
            "medium",
            "boxShadow",
            "0",
            "y"
          ]
        },
        blur: {
          value: "64px",
          type: "blur",
          filePath: "themes/videoleap-dark.json",
          isSource: true,
          original: {
            value: 64,
            type: "blur"
          },
          name: "sd-card-medium-box-shadow-0-blur",
          attributes: {},
          path: [
            "card",
            "medium",
            "boxShadow",
            "0",
            "blur"
          ]
        },
        spread: {
          value: "-4px",
          type: "spread",
          filePath: "themes/videoleap-dark.json",
          isSource: true,
          original: {
            value: -4,
            type: "spread"
          },
          name: "sd-card-medium-box-shadow-0-spread",
          attributes: {},
          path: [
            "card",
            "medium",
            "boxShadow",
            "0",
            "spread"
          ]
        }
      },
      "1": {
        color: {
          value: "rgba(0, 0, 0, 0.12156862745098039)",
          type: "color",
          filePath: "themes/videoleap-dark.json",
          isSource: true,
          original: {
            value: "#0000001f",
            type: "color"
          },
          name: "sd-card-medium-box-shadow-1-color",
          attributes: {},
          path: [
            "card",
            "medium",
            "boxShadow",
            "1",
            "color"
          ]
        },
        type: {
          value: "dropShadow",
          type: "type",
          filePath: "themes/videoleap-dark.json",
          isSource: true,
          original: {
            value: "dropShadow",
            type: "type"
          },
          name: "sd-card-medium-box-shadow-1-type",
          attributes: {},
          path: [
            "card",
            "medium",
            "boxShadow",
            "1",
            "type"
          ]
        },
        x: {
          value: "0px",
          type: "x",
          filePath: "themes/videoleap-dark.json",
          isSource: true,
          original: {
            value: 0,
            type: "x"
          },
          name: "sd-card-medium-box-shadow-1-x",
          attributes: {},
          path: [
            "card",
            "medium",
            "boxShadow",
            "1",
            "x"
          ]
        },
        y: {
          value: "6px",
          type: "y",
          filePath: "themes/videoleap-dark.json",
          isSource: true,
          original: {
            value: 6,
            type: "y"
          },
          name: "sd-card-medium-box-shadow-1-y",
          attributes: {},
          path: [
            "card",
            "medium",
            "boxShadow",
            "1",
            "y"
          ]
        },
        blur: {
          value: "28px",
          type: "blur",
          filePath: "themes/videoleap-dark.json",
          isSource: true,
          original: {
            value: 28,
            type: "blur"
          },
          name: "sd-card-medium-box-shadow-1-blur",
          attributes: {},
          path: [
            "card",
            "medium",
            "boxShadow",
            "1",
            "blur"
          ]
        },
        spread: {
          value: "-6px",
          type: "spread",
          filePath: "themes/videoleap-dark.json",
          isSource: true,
          original: {
            value: -6,
            type: "spread"
          },
          name: "sd-card-medium-box-shadow-1-spread",
          attributes: {},
          path: [
            "card",
            "medium",
            "boxShadow",
            "1",
            "spread"
          ]
        }
      }
    },
    fill: {
      value: "#222325",
      type: "fill",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#222325",
        type: "fill"
      },
      name: "sd-card-medium-fill",
      attributes: {},
      path: [
        "card",
        "medium",
        "fill"
      ]
    },
    spacing: {
      value: "16px",
      type: "spacing",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 16,
        type: "spacing"
      },
      name: "sd-card-medium-spacing",
      attributes: {},
      path: [
        "card",
        "medium",
        "spacing"
      ]
    }
  },
  large: {
    spacing: {
      value: "16px",
      type: "spacing",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 16,
        type: "spacing"
      },
      name: "sd-card-large-spacing",
      attributes: {},
      path: [
        "card",
        "large",
        "spacing"
      ]
    },
    verticalPadding: {
      value: "16px",
      type: "dimension",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 16,
        type: "dimension"
      },
      name: "sd-card-large-vertical-padding",
      attributes: {},
      path: [
        "card",
        "large",
        "verticalPadding"
      ]
    },
    horizontalPadding: {
      value: "16px",
      type: "dimension",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 16,
        type: "dimension"
      },
      name: "sd-card-large-horizontal-padding",
      attributes: {},
      path: [
        "card",
        "large",
        "horizontalPadding"
      ]
    },
    borderRadius: {
      value: "40px",
      type: "borderRadius",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 40,
        type: "borderRadius"
      },
      name: "sd-card-large-border-radius",
      attributes: {},
      path: [
        "card",
        "large",
        "borderRadius"
      ]
    },
    boxShadow: {
      "0": {
        color: {
          value: "rgba(0, 0, 0, 0.1607843137254902)",
          type: "color",
          filePath: "themes/videoleap-dark.json",
          isSource: true,
          original: {
            value: "#00000029",
            type: "color"
          },
          name: "sd-card-large-box-shadow-0-color",
          attributes: {},
          path: [
            "card",
            "large",
            "boxShadow",
            "0",
            "color"
          ]
        },
        type: {
          value: "dropShadow",
          type: "type",
          filePath: "themes/videoleap-dark.json",
          isSource: true,
          original: {
            value: "dropShadow",
            type: "type"
          },
          name: "sd-card-large-box-shadow-0-type",
          attributes: {},
          path: [
            "card",
            "large",
            "boxShadow",
            "0",
            "type"
          ]
        },
        x: {
          value: "0px",
          type: "x",
          filePath: "themes/videoleap-dark.json",
          isSource: true,
          original: {
            value: 0,
            type: "x"
          },
          name: "sd-card-large-box-shadow-0-x",
          attributes: {},
          path: [
            "card",
            "large",
            "boxShadow",
            "0",
            "x"
          ]
        },
        y: {
          value: "18px",
          type: "y",
          filePath: "themes/videoleap-dark.json",
          isSource: true,
          original: {
            value: 18,
            type: "y"
          },
          name: "sd-card-large-box-shadow-0-y",
          attributes: {},
          path: [
            "card",
            "large",
            "boxShadow",
            "0",
            "y"
          ]
        },
        blur: {
          value: "64px",
          type: "blur",
          filePath: "themes/videoleap-dark.json",
          isSource: true,
          original: {
            value: 64,
            type: "blur"
          },
          name: "sd-card-large-box-shadow-0-blur",
          attributes: {},
          path: [
            "card",
            "large",
            "boxShadow",
            "0",
            "blur"
          ]
        },
        spread: {
          value: "-4px",
          type: "spread",
          filePath: "themes/videoleap-dark.json",
          isSource: true,
          original: {
            value: -4,
            type: "spread"
          },
          name: "sd-card-large-box-shadow-0-spread",
          attributes: {},
          path: [
            "card",
            "large",
            "boxShadow",
            "0",
            "spread"
          ]
        }
      },
      "1": {
        color: {
          value: "rgba(0, 0, 0, 0.12156862745098039)",
          type: "color",
          filePath: "themes/videoleap-dark.json",
          isSource: true,
          original: {
            value: "#0000001f",
            type: "color"
          },
          name: "sd-card-large-box-shadow-1-color",
          attributes: {},
          path: [
            "card",
            "large",
            "boxShadow",
            "1",
            "color"
          ]
        },
        type: {
          value: "dropShadow",
          type: "type",
          filePath: "themes/videoleap-dark.json",
          isSource: true,
          original: {
            value: "dropShadow",
            type: "type"
          },
          name: "sd-card-large-box-shadow-1-type",
          attributes: {},
          path: [
            "card",
            "large",
            "boxShadow",
            "1",
            "type"
          ]
        },
        x: {
          value: "0px",
          type: "x",
          filePath: "themes/videoleap-dark.json",
          isSource: true,
          original: {
            value: 0,
            type: "x"
          },
          name: "sd-card-large-box-shadow-1-x",
          attributes: {},
          path: [
            "card",
            "large",
            "boxShadow",
            "1",
            "x"
          ]
        },
        y: {
          value: "6px",
          type: "y",
          filePath: "themes/videoleap-dark.json",
          isSource: true,
          original: {
            value: 6,
            type: "y"
          },
          name: "sd-card-large-box-shadow-1-y",
          attributes: {},
          path: [
            "card",
            "large",
            "boxShadow",
            "1",
            "y"
          ]
        },
        blur: {
          value: "28px",
          type: "blur",
          filePath: "themes/videoleap-dark.json",
          isSource: true,
          original: {
            value: 28,
            type: "blur"
          },
          name: "sd-card-large-box-shadow-1-blur",
          attributes: {},
          path: [
            "card",
            "large",
            "boxShadow",
            "1",
            "blur"
          ]
        },
        spread: {
          value: "-6px",
          type: "spread",
          filePath: "themes/videoleap-dark.json",
          isSource: true,
          original: {
            value: -6,
            type: "spread"
          },
          name: "sd-card-large-box-shadow-1-spread",
          attributes: {},
          path: [
            "card",
            "large",
            "boxShadow",
            "1",
            "spread"
          ]
        }
      }
    },
    fill: {
      value: "#222325",
      type: "fill",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#222325",
        type: "fill"
      },
      name: "sd-card-large-fill",
      attributes: {},
      path: [
        "card",
        "large",
        "fill"
      ]
    }
  },
  radius: {
    xs: {
      value: "16px",
      type: "borderRadius",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 16,
        type: "borderRadius"
      },
      name: "sd-card-radius-xs",
      attributes: {},
      path: [
        "card",
        "radius",
        "xs"
      ]
    },
    sm: {
      value: "24px",
      type: "borderRadius",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 24,
        type: "borderRadius"
      },
      name: "sd-card-radius-sm",
      attributes: {},
      path: [
        "card",
        "radius",
        "sm"
      ]
    },
    md: {
      value: "32px",
      type: "borderRadius",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 32,
        type: "borderRadius"
      },
      name: "sd-card-radius-md",
      attributes: {},
      path: [
        "card",
        "radius",
        "md"
      ]
    },
    lg: {
      value: "40px",
      type: "borderRadius",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 40,
        type: "borderRadius"
      },
      name: "sd-card-radius-lg",
      attributes: {},
      path: [
        "card",
        "radius",
        "lg"
      ]
    }
  },
  padding: {
    sm: {
      value: "8px",
      type: "spacing",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 8,
        type: "spacing"
      },
      name: "sd-card-padding-sm",
      attributes: {},
      path: [
        "card",
        "padding",
        "sm"
      ]
    },
    md: {
      value: "12px",
      type: "spacing",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 12,
        type: "spacing"
      },
      name: "sd-card-padding-md",
      attributes: {},
      path: [
        "card",
        "padding",
        "md"
      ]
    },
    lg: {
      value: "16px",
      type: "spacing",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 16,
        type: "spacing"
      },
      name: "sd-card-padding-lg",
      attributes: {},
      path: [
        "card",
        "padding",
        "lg"
      ]
    },
    xl: {
      value: "20px",
      type: "spacing",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 20,
        type: "spacing"
      },
      name: "sd-card-padding-xl",
      attributes: {},
      path: [
        "card",
        "padding",
        "xl"
      ]
    }
  },
  gap: {
    sm: {
      value: "8px",
      type: "spacing",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 8,
        type: "spacing"
      },
      name: "sd-card-gap-sm",
      attributes: {},
      path: [
        "card",
        "gap",
        "sm"
      ]
    },
    md: {
      value: "16px",
      type: "spacing",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 16,
        type: "spacing"
      },
      name: "sd-card-gap-md",
      attributes: {},
      path: [
        "card",
        "gap",
        "md"
      ]
    },
    lg: {
      value: "24px",
      type: "spacing",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 24,
        type: "spacing"
      },
      name: "sd-card-gap-lg",
      attributes: {},
      path: [
        "card",
        "gap",
        "lg"
      ]
    },
    xl: {
      value: "32px",
      type: "spacing",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 32,
        type: "spacing"
      },
      name: "sd-card-gap-xl",
      attributes: {},
      path: [
        "card",
        "gap",
        "xl"
      ]
    }
  }
};
const sheet$1 = {
  small: {
    borderRadius: {
      value: "16px",
      type: "borderRadius",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "16 16 0 0",
        type: "borderRadius"
      },
      name: "sd-sheet-small-border-radius",
      attributes: {},
      path: [
        "sheet",
        "small",
        "borderRadius"
      ]
    },
    fill: {
      value: "#222325",
      type: "fill",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#222325",
        type: "fill"
      },
      name: "sd-sheet-small-fill",
      attributes: {},
      path: [
        "sheet",
        "small",
        "fill"
      ]
    }
  },
  medium: {
    height: {
      value: "480px",
      type: "dimension",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 480,
        type: "dimension"
      },
      name: "sd-sheet-medium-height",
      attributes: {},
      path: [
        "sheet",
        "medium",
        "height"
      ]
    },
    borderRadius: {
      value: "24px",
      type: "borderRadius",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "24 24 0 0",
        type: "borderRadius"
      },
      name: "sd-sheet-medium-border-radius",
      attributes: {},
      path: [
        "sheet",
        "medium",
        "borderRadius"
      ]
    },
    fill: {
      value: "#222325",
      type: "fill",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#222325",
        type: "fill"
      },
      name: "sd-sheet-medium-fill",
      attributes: {},
      path: [
        "sheet",
        "medium",
        "fill"
      ]
    }
  },
  large: {
    height: {
      value: "480px",
      type: "dimension",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 480,
        type: "dimension"
      },
      name: "sd-sheet-large-height",
      attributes: {},
      path: [
        "sheet",
        "large",
        "height"
      ]
    },
    borderRadius: {
      value: "32px",
      type: "borderRadius",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "32 32 0 0",
        type: "borderRadius"
      },
      name: "sd-sheet-large-border-radius",
      attributes: {},
      path: [
        "sheet",
        "large",
        "borderRadius"
      ]
    },
    fill: {
      value: "#222325",
      type: "fill",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#222325",
        type: "fill"
      },
      name: "sd-sheet-large-fill",
      attributes: {},
      path: [
        "sheet",
        "large",
        "fill"
      ]
    }
  },
  radius: {
    sm: {
      value: "16px",
      type: "borderRadius",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "16 16 0 0",
        type: "borderRadius"
      },
      name: "sd-sheet-radius-sm",
      attributes: {},
      path: [
        "sheet",
        "radius",
        "sm"
      ]
    },
    md: {
      value: "24px",
      type: "borderRadius",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "24 24 0 0",
        type: "borderRadius"
      },
      name: "sd-sheet-radius-md",
      attributes: {},
      path: [
        "sheet",
        "radius",
        "md"
      ]
    },
    lg: {
      value: "32px",
      type: "borderRadius",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "32 32 0 0",
        type: "borderRadius"
      },
      name: "sd-sheet-radius-lg",
      attributes: {},
      path: [
        "sheet",
        "radius",
        "lg"
      ]
    }
  }
};
const comp$1 = {
  button: {
    bg: {
      brand: {
        filled: {
          "default": {
            value: "rgba(255, 80, 78, 1)",
            type: "color",
            filePath: "themes/videoleap-dark.json",
            isSource: true,
            original: {
              value: "#ff504e",
              type: "color"
            },
            name: "sd-comp-button-bg-brand-filled-default",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "brand",
              "filled",
              "default"
            ]
          },
          hover: {
            value: "rgba(255, 133, 121, 1)",
            type: "color",
            filePath: "themes/videoleap-dark.json",
            isSource: true,
            original: {
              value: "#ff8579",
              type: "color"
            },
            name: "sd-comp-button-bg-brand-filled-hover",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "brand",
              "filled",
              "hover"
            ]
          },
          pressed: {
            value: "rgba(255, 156, 145, 1)",
            type: "color",
            filePath: "themes/videoleap-dark.json",
            isSource: true,
            original: {
              value: "#ff9c91",
              type: "color"
            },
            name: "sd-comp-button-bg-brand-filled-pressed",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "brand",
              "filled",
              "pressed"
            ]
          },
          disabled: {
            value: "rgba(122, 124, 129, 0.25098039215686274)",
            type: "color",
            filePath: "themes/videoleap-dark.json",
            isSource: true,
            original: {
              value: "#7a7c8140",
              type: "color"
            },
            name: "sd-comp-button-bg-brand-filled-disabled",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "brand",
              "filled",
              "disabled"
            ]
          }
        },
        tinted: {
          "default": {
            value: "rgba(255, 80, 78, 0.1607843137254902)",
            type: "color",
            filePath: "themes/videoleap-dark.json",
            isSource: true,
            original: {
              value: "#ff504e29",
              type: "color"
            },
            name: "sd-comp-button-bg-brand-tinted-default",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "brand",
              "tinted",
              "default"
            ]
          },
          hover: {
            value: "rgba(255, 80, 78, 0.34901960784313724)",
            type: "color",
            filePath: "themes/videoleap-dark.json",
            isSource: true,
            original: {
              value: "#ff504e59",
              type: "color"
            },
            name: "sd-comp-button-bg-brand-tinted-hover",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "brand",
              "tinted",
              "hover"
            ]
          },
          pressed: {
            value: "rgba(255, 80, 78, 0.43137254901960786)",
            type: "color",
            filePath: "themes/videoleap-dark.json",
            isSource: true,
            original: {
              value: "#ff504e6e",
              type: "color"
            },
            name: "sd-comp-button-bg-brand-tinted-pressed",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "brand",
              "tinted",
              "pressed"
            ]
          },
          disabled: {
            value: "rgba(122, 124, 129, 0.12156862745098039)",
            type: "color",
            filePath: "themes/videoleap-dark.json",
            isSource: true,
            original: {
              value: "#7a7c811f",
              type: "color"
            },
            name: "sd-comp-button-bg-brand-tinted-disabled",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "brand",
              "tinted",
              "disabled"
            ]
          }
        },
        plain: {
          "default": {
            value: "rgba(255, 255, 255, 0)",
            type: "color",
            filePath: "themes/videoleap-dark.json",
            isSource: true,
            original: {
              value: "#ffffff00",
              type: "color"
            },
            name: "sd-comp-button-bg-brand-plain-default",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "brand",
              "plain",
              "default"
            ]
          },
          hover: {
            value: "rgba(255, 176, 165, 0.49019607843137253)",
            type: "color",
            filePath: "themes/videoleap-dark.json",
            isSource: true,
            original: {
              value: "#ffb0a57d",
              type: "color"
            },
            name: "sd-comp-button-bg-brand-plain-hover",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "brand",
              "plain",
              "hover"
            ]
          },
          pressed: {
            value: "rgba(255, 148, 135, 0.6588235294117647)",
            type: "color",
            filePath: "themes/videoleap-dark.json",
            isSource: true,
            original: {
              value: "#ff9487a8",
              type: "color"
            },
            name: "sd-comp-button-bg-brand-plain-pressed",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "brand",
              "plain",
              "pressed"
            ]
          },
          disabled: {
            value: "rgba(255, 255, 255, 0)",
            type: "color",
            filePath: "themes/videoleap-dark.json",
            isSource: true,
            original: {
              value: "#ffffff00",
              type: "color"
            },
            name: "sd-comp-button-bg-brand-plain-disabled",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "brand",
              "plain",
              "disabled"
            ]
          }
        },
        elevated: {
          "default": {
            value: "rgba(34, 35, 37, 1)",
            type: "color",
            filePath: "themes/videoleap-dark.json",
            isSource: true,
            original: {
              value: "#222325",
              type: "color"
            },
            name: "sd-comp-button-bg-brand-elevated-default",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "brand",
              "elevated",
              "default"
            ]
          },
          hover: {
            value: "rgba(55, 56, 58, 1)",
            type: "color",
            filePath: "themes/videoleap-dark.json",
            isSource: true,
            original: {
              value: "#37383a",
              type: "color"
            },
            name: "sd-comp-button-bg-brand-elevated-hover",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "brand",
              "elevated",
              "hover"
            ]
          },
          pressed: {
            value: "rgba(76, 76, 78, 1)",
            type: "color",
            filePath: "themes/videoleap-dark.json",
            isSource: true,
            original: {
              value: "#4c4c4e",
              type: "color"
            },
            name: "sd-comp-button-bg-brand-elevated-pressed",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "brand",
              "elevated",
              "pressed"
            ]
          },
          disabled: {
            value: "rgba(149, 151, 155, 0.611764705882353)",
            type: "color",
            filePath: "themes/videoleap-dark.json",
            isSource: true,
            original: {
              value: "#95979b9c",
              type: "color"
            },
            name: "sd-comp-button-bg-brand-elevated-disabled",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "brand",
              "elevated",
              "disabled"
            ]
          }
        }
      },
      neutral: {
        filled: {
          "default": {
            value: "rgba(230, 231, 233, 1)",
            type: "color",
            filePath: "themes/videoleap-dark.json",
            isSource: true,
            original: {
              value: "#e6e7e9",
              type: "color"
            },
            name: "sd-comp-button-bg-neutral-filled-default",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "neutral",
              "filled",
              "default"
            ]
          },
          hover: {
            value: "rgba(167, 168, 170, 1)",
            type: "color",
            filePath: "themes/videoleap-dark.json",
            isSource: true,
            original: {
              value: "#a7a8aa",
              type: "color"
            },
            name: "sd-comp-button-bg-neutral-filled-hover",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "neutral",
              "filled",
              "hover"
            ]
          },
          pressed: {
            value: "rgba(136, 138, 140, 1)",
            type: "color",
            filePath: "themes/videoleap-dark.json",
            isSource: true,
            original: {
              value: "#888a8c",
              type: "color"
            },
            name: "sd-comp-button-bg-neutral-filled-pressed",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "neutral",
              "filled",
              "pressed"
            ]
          }
        },
        tinted: {
          "default": {
            value: "rgba(230, 231, 233, 0.0784313725490196)",
            type: "color",
            filePath: "themes/videoleap-dark.json",
            isSource: true,
            original: {
              value: "#e6e7e914",
              type: "color"
            },
            name: "sd-comp-button-bg-neutral-tinted-default",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "neutral",
              "tinted",
              "default"
            ]
          },
          hover: {
            value: "rgba(235, 236, 237, 0.2784313725490196)",
            type: "color",
            filePath: "themes/videoleap-dark.json",
            isSource: true,
            original: {
              value: "#ebeced47",
              type: "color"
            },
            name: "sd-comp-button-bg-neutral-tinted-hover",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "neutral",
              "tinted",
              "hover"
            ]
          },
          pressed: {
            value: "rgba(237, 238, 239, 0.3803921568627451)",
            type: "color",
            filePath: "themes/videoleap-dark.json",
            isSource: true,
            original: {
              value: "#edeeef61",
              type: "color"
            },
            name: "sd-comp-button-bg-neutral-tinted-pressed",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "neutral",
              "tinted",
              "pressed"
            ]
          }
        },
        plain: {
          "default": {
            value: "rgba(255, 255, 255, 0)",
            type: "color",
            filePath: "themes/videoleap-dark.json",
            isSource: true,
            original: {
              value: "#ffffff00",
              type: "color"
            },
            name: "sd-comp-button-bg-neutral-plain-default",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "neutral",
              "plain",
              "default"
            ]
          },
          hover: {
            value: "rgba(243, 243, 245, 0.49019607843137253)",
            type: "color",
            filePath: "themes/videoleap-dark.json",
            isSource: true,
            original: {
              value: "#f3f3f57d",
              type: "color"
            },
            name: "sd-comp-button-bg-neutral-plain-hover",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "neutral",
              "plain",
              "hover"
            ]
          },
          pressed: {
            value: "rgba(239, 239, 241, 0.6588235294117647)",
            type: "color",
            filePath: "themes/videoleap-dark.json",
            isSource: true,
            original: {
              value: "#efeff1a8",
              type: "color"
            },
            name: "sd-comp-button-bg-neutral-plain-pressed",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "neutral",
              "plain",
              "pressed"
            ]
          }
        },
        elevated: {
          "default": {
            value: "rgba(34, 35, 37, 1)",
            type: "color",
            filePath: "themes/videoleap-dark.json",
            isSource: true,
            original: {
              value: "#222325",
              type: "color"
            },
            name: "sd-comp-button-bg-neutral-elevated-default",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "neutral",
              "elevated",
              "default"
            ]
          },
          hover: {
            value: "rgba(55, 56, 58, 1)",
            type: "color",
            filePath: "themes/videoleap-dark.json",
            isSource: true,
            original: {
              value: "#37383a",
              type: "color"
            },
            name: "sd-comp-button-bg-neutral-elevated-hover",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "neutral",
              "elevated",
              "hover"
            ]
          },
          pressed: {
            value: "rgba(76, 76, 78, 1)",
            type: "color",
            filePath: "themes/videoleap-dark.json",
            isSource: true,
            original: {
              value: "#4c4c4e",
              type: "color"
            },
            name: "sd-comp-button-bg-neutral-elevated-pressed",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "neutral",
              "elevated",
              "pressed"
            ]
          }
        }
      },
      danger: {
        filled: {
          "default": {
            value: "rgba(255, 69, 58, 1)",
            type: "color",
            filePath: "themes/videoleap-dark.json",
            isSource: true,
            original: {
              value: "#ff453a",
              type: "color"
            },
            name: "sd-comp-button-bg-danger-filled-default",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "danger",
              "filled",
              "default"
            ]
          },
          hover: {
            value: "rgba(255, 128, 107, 1)",
            type: "color",
            filePath: "themes/videoleap-dark.json",
            isSource: true,
            original: {
              value: "#ff806b",
              type: "color"
            },
            name: "sd-comp-button-bg-danger-filled-hover",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "danger",
              "filled",
              "hover"
            ]
          },
          pressed: {
            value: "rgba(255, 152, 133, 1)",
            type: "color",
            filePath: "themes/videoleap-dark.json",
            isSource: true,
            original: {
              value: "#ff9885",
              type: "color"
            },
            name: "sd-comp-button-bg-danger-filled-pressed",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "danger",
              "filled",
              "pressed"
            ]
          }
        },
        tinted: {
          "default": {
            value: "rgba(255, 69, 58, 0.1607843137254902)",
            type: "color",
            filePath: "themes/videoleap-dark.json",
            isSource: true,
            original: {
              value: "#ff453a29",
              type: "color"
            },
            name: "sd-comp-button-bg-danger-tinted-default",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "danger",
              "tinted",
              "default"
            ]
          },
          hover: {
            value: "rgba(255, 118, 97, 0.34901960784313724)",
            type: "color",
            filePath: "themes/videoleap-dark.json",
            isSource: true,
            original: {
              value: "#ff766159",
              type: "color"
            },
            name: "sd-comp-button-bg-danger-tinted-hover",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "danger",
              "tinted",
              "hover"
            ]
          },
          pressed: {
            value: "rgba(255, 136, 115, 0.43137254901960786)",
            type: "color",
            filePath: "themes/videoleap-dark.json",
            isSource: true,
            original: {
              value: "#ff88736e",
              type: "color"
            },
            name: "sd-comp-button-bg-danger-tinted-pressed",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "danger",
              "tinted",
              "pressed"
            ]
          }
        },
        plain: {
          "default": {
            value: "rgba(255, 255, 255, 0)",
            type: "color",
            filePath: "themes/videoleap-dark.json",
            isSource: true,
            original: {
              value: "#ffffff00",
              type: "color"
            },
            name: "sd-comp-button-bg-danger-plain-default",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "danger",
              "plain",
              "default"
            ]
          },
          hover: {
            value: "rgba(255, 173, 155, 0.49019607843137253)",
            type: "color",
            filePath: "themes/videoleap-dark.json",
            isSource: true,
            original: {
              value: "#ffad9b7d",
              type: "color"
            },
            name: "sd-comp-button-bg-danger-plain-hover",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "danger",
              "plain",
              "hover"
            ]
          },
          pressed: {
            value: "rgba(255, 144, 121, 0.6588235294117647)",
            type: "color",
            filePath: "themes/videoleap-dark.json",
            isSource: true,
            original: {
              value: "#ff9079a8",
              type: "color"
            },
            name: "sd-comp-button-bg-danger-plain-pressed",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "danger",
              "plain",
              "pressed"
            ]
          }
        },
        elevated: {
          "default": {
            value: "rgba(34, 35, 37, 1)",
            type: "color",
            filePath: "themes/videoleap-dark.json",
            isSource: true,
            original: {
              value: "#222325",
              type: "color"
            },
            name: "sd-comp-button-bg-danger-elevated-default",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "danger",
              "elevated",
              "default"
            ]
          },
          hover: {
            value: "rgba(55, 56, 58, 1)",
            type: "color",
            filePath: "themes/videoleap-dark.json",
            isSource: true,
            original: {
              value: "#37383a",
              type: "color"
            },
            name: "sd-comp-button-bg-danger-elevated-hover",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "danger",
              "elevated",
              "hover"
            ]
          },
          pressed: {
            value: "rgba(76, 76, 78, 1)",
            type: "color",
            filePath: "themes/videoleap-dark.json",
            isSource: true,
            original: {
              value: "#4c4c4e",
              type: "color"
            },
            name: "sd-comp-button-bg-danger-elevated-pressed",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "danger",
              "elevated",
              "pressed"
            ]
          }
        }
      },
      overlay: {
        filled: {
          "default": {
            value: "rgba(255, 255, 255, 1)",
            type: "color",
            filePath: "themes/videoleap-dark.json",
            isSource: true,
            original: {
              value: "#ffffff",
              type: "color"
            },
            name: "sd-comp-button-bg-overlay-filled-default",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "overlay",
              "filled",
              "default"
            ]
          },
          hover: {
            value: "rgba(237, 237, 237, 1)",
            type: "color",
            filePath: "themes/videoleap-dark.json",
            isSource: true,
            original: {
              value: "#ededed",
              type: "color"
            },
            name: "sd-comp-button-bg-overlay-filled-hover",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "overlay",
              "filled",
              "hover"
            ]
          },
          pressed: {
            value: "rgba(222, 222, 222, 1)",
            type: "color",
            filePath: "themes/videoleap-dark.json",
            isSource: true,
            original: {
              value: "#dedede",
              type: "color"
            },
            name: "sd-comp-button-bg-overlay-filled-pressed",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "overlay",
              "filled",
              "pressed"
            ]
          }
        },
        tinted: {
          "default": {
            value: "rgba(255, 255, 255, 0.12156862745098039)",
            type: "color",
            filePath: "themes/videoleap-dark.json",
            isSource: true,
            original: {
              value: "#ffffff1f",
              type: "color"
            },
            name: "sd-comp-button-bg-overlay-tinted-default",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "overlay",
              "tinted",
              "default"
            ]
          },
          hover: {
            value: "rgba(255, 255, 255, 0.30980392156862746)",
            type: "color",
            filePath: "themes/videoleap-dark.json",
            isSource: true,
            original: {
              value: "#ffffff4f",
              type: "color"
            },
            name: "sd-comp-button-bg-overlay-tinted-hover",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "overlay",
              "tinted",
              "hover"
            ]
          },
          pressed: {
            value: "rgba(255, 255, 255, 0.4)",
            type: "color",
            filePath: "themes/videoleap-dark.json",
            isSource: true,
            original: {
              value: "#fff6",
              type: "color"
            },
            name: "sd-comp-button-bg-overlay-tinted-pressed",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "overlay",
              "tinted",
              "pressed"
            ]
          }
        },
        plain: {
          "default": {
            value: "rgba(255, 255, 255, 0)",
            type: "color",
            filePath: "themes/videoleap-dark.json",
            isSource: true,
            original: {
              value: "#ffffff00",
              type: "color"
            },
            name: "sd-comp-button-bg-overlay-plain-default",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "overlay",
              "plain",
              "default"
            ]
          },
          hover: {
            value: "rgba(255, 255, 255, 0.49019607843137253)",
            type: "color",
            filePath: "themes/videoleap-dark.json",
            isSource: true,
            original: {
              value: "#ffffff7d",
              type: "color"
            },
            name: "sd-comp-button-bg-overlay-plain-hover",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "overlay",
              "plain",
              "hover"
            ]
          },
          pressed: {
            value: "rgba(255, 255, 255, 0.6588235294117647)",
            type: "color",
            filePath: "themes/videoleap-dark.json",
            isSource: true,
            original: {
              value: "#ffffffa8",
              type: "color"
            },
            name: "sd-comp-button-bg-overlay-plain-pressed",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "overlay",
              "plain",
              "pressed"
            ]
          }
        },
        elevated: {
          "default": {
            value: "rgba(0, 0, 0, 0.30196078431372547)",
            type: "color",
            filePath: "themes/videoleap-dark.json",
            isSource: true,
            original: {
              value: "#0000004d",
              type: "color"
            },
            name: "sd-comp-button-bg-overlay-elevated-default",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "overlay",
              "elevated",
              "default"
            ]
          },
          hover: {
            value: "rgba(0, 0, 0, 0.5215686274509804)",
            type: "color",
            filePath: "themes/videoleap-dark.json",
            isSource: true,
            original: {
              value: "#00000085",
              type: "color"
            },
            name: "sd-comp-button-bg-overlay-elevated-hover",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "overlay",
              "elevated",
              "hover"
            ]
          },
          pressed: {
            value: "rgba(0, 0, 0, 0.6392156862745098)",
            type: "color",
            filePath: "themes/videoleap-dark.json",
            isSource: true,
            original: {
              value: "#000000a3",
              type: "color"
            },
            name: "sd-comp-button-bg-overlay-elevated-pressed",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "overlay",
              "elevated",
              "pressed"
            ]
          }
        }
      }
    },
    fg: {
      brand: {
        primary: {
          value: "rgba(255, 255, 255, 1)",
          type: "color",
          filePath: "themes/videoleap-dark.json",
          isSource: true,
          original: {
            value: "#ffffff",
            type: "color"
          },
          name: "sd-comp-button-fg-brand-primary",
          attributes: {},
          path: [
            "comp",
            "button",
            "fg",
            "brand",
            "primary"
          ]
        },
        secondary: {
          value: "rgba(255, 80, 78, 1)",
          type: "color",
          filePath: "themes/videoleap-dark.json",
          isSource: true,
          original: {
            value: "#ff504e",
            type: "color"
          },
          name: "sd-comp-button-fg-brand-secondary",
          attributes: {},
          path: [
            "comp",
            "button",
            "fg",
            "brand",
            "secondary"
          ]
        },
        disabled: {
          value: "rgba(122, 124, 129, 0.5019607843137255)",
          type: "color",
          filePath: "themes/videoleap-dark.json",
          isSource: true,
          original: {
            value: "#7a7c8180",
            type: "color"
          },
          name: "sd-comp-button-fg-brand-disabled",
          attributes: {},
          path: [
            "comp",
            "button",
            "fg",
            "brand",
            "disabled"
          ]
        }
      },
      neutral: {
        primary: {
          value: "rgba(44, 45, 48, 1)",
          type: "color",
          filePath: "themes/videoleap-dark.json",
          isSource: true,
          original: {
            value: "#2c2d30",
            type: "color"
          },
          name: "sd-comp-button-fg-neutral-primary",
          attributes: {},
          path: [
            "comp",
            "button",
            "fg",
            "neutral",
            "primary"
          ]
        },
        secondary: {
          value: "rgba(230, 231, 233, 1)",
          type: "color",
          filePath: "themes/videoleap-dark.json",
          isSource: true,
          original: {
            value: "#e6e7e9",
            type: "color"
          },
          name: "sd-comp-button-fg-neutral-secondary",
          attributes: {},
          path: [
            "comp",
            "button",
            "fg",
            "neutral",
            "secondary"
          ]
        }
      },
      danger: {
        primary: {
          value: "rgba(22, 23, 25, 1)",
          type: "color",
          filePath: "themes/videoleap-dark.json",
          isSource: true,
          original: {
            value: "#161719",
            type: "color"
          },
          name: "sd-comp-button-fg-danger-primary",
          attributes: {},
          path: [
            "comp",
            "button",
            "fg",
            "danger",
            "primary"
          ]
        },
        secondary: {
          value: "rgba(255, 69, 58, 1)",
          type: "color",
          filePath: "themes/videoleap-dark.json",
          isSource: true,
          original: {
            value: "#ff453a",
            type: "color"
          },
          name: "sd-comp-button-fg-danger-secondary",
          attributes: {},
          path: [
            "comp",
            "button",
            "fg",
            "danger",
            "secondary"
          ]
        }
      },
      overlay: {
        primary: {
          value: "rgba(22, 23, 25, 1)",
          type: "color",
          filePath: "themes/videoleap-dark.json",
          isSource: true,
          original: {
            value: "#161719",
            type: "color"
          },
          name: "sd-comp-button-fg-overlay-primary",
          attributes: {},
          path: [
            "comp",
            "button",
            "fg",
            "overlay",
            "primary"
          ]
        },
        secondary: {
          value: "rgba(255, 255, 255, 1)",
          type: "color",
          filePath: "themes/videoleap-dark.json",
          isSource: true,
          original: {
            value: "#ffffff",
            type: "color"
          },
          name: "sd-comp-button-fg-overlay-secondary",
          attributes: {},
          path: [
            "comp",
            "button",
            "fg",
            "overlay",
            "secondary"
          ]
        }
      }
    }
  }
};
const gradient$1 = {
  "primary↓": {
    value: "linear-gradient(180deg, #161719 0%, #ffffff00 100%)",
    type: "color",
    description: "token = lh-semantic-gradient-primary-down\n\nbg primary values, smooth, gradient, mask, transition",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: "linear-gradient(180deg, #161719 0%, #ffffff00 100%)",
      type: "color",
      description: "token = lh-semantic-gradient-primary-down\n\nbg primary values, smooth, gradient, mask, transition"
    },
    name: "sd-gradient-primary",
    attributes: {},
    path: [
      "gradient",
      "primary↓"
    ]
  },
  "primary↑": {
    value: "linear-gradient(0deg, #161719 0%, #ffffff00 100%)",
    type: "color",
    description: "token = lh-semantic-gradient-primary-up\n\nbg primary values, smooth, gradient, mask, transition",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: "linear-gradient(0deg, #161719 0%, #ffffff00 100%)",
      type: "color",
      description: "token = lh-semantic-gradient-primary-up\n\nbg primary values, smooth, gradient, mask, transition"
    },
    name: "sd-gradient-primary",
    attributes: {},
    path: [
      "gradient",
      "primary↑"
    ]
  },
  "secondary↓": {
    value: "linear-gradient(180deg, #222325 0%, #ffffff00 100%)",
    type: "color",
    description: "token = lh-semantic-gradient-secondary-down\n\nbg secondary values, smooth, gradient, mask, transition",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: "linear-gradient(180deg, #222325 0%, #ffffff00 100%)",
      type: "color",
      description: "token = lh-semantic-gradient-secondary-down\n\nbg secondary values, smooth, gradient, mask, transition"
    },
    name: "sd-gradient-secondary",
    attributes: {},
    path: [
      "gradient",
      "secondary↓"
    ]
  },
  "secondary↑": {
    value: "linear-gradient(0deg, #222325 0%, #ffffff00 100%)",
    type: "color",
    description: "token = lh-semantic-gradient-secondary-up\n\nbg secondary values, smooth, gradient, mask, transition",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: "linear-gradient(0deg, #222325 0%, #ffffff00 100%)",
      type: "color",
      description: "token = lh-semantic-gradient-secondary-up\n\nbg secondary values, smooth, gradient, mask, transition"
    },
    name: "sd-gradient-secondary",
    attributes: {},
    path: [
      "gradient",
      "secondary↑"
    ]
  },
  "inverse↓": {
    value: "linear-gradient(180deg, #fcfcfd 0%, #ffffff00 100%)",
    type: "color",
    description: "token = lh-semantic-gradient-inverse-down\n\nbg inverse values, smooth, gradient, mask, transition",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: "linear-gradient(180deg, #fcfcfd 0%, #ffffff00 100%)",
      type: "color",
      description: "token = lh-semantic-gradient-inverse-down\n\nbg inverse values, smooth, gradient, mask, transition"
    },
    name: "sd-gradient-inverse",
    attributes: {},
    path: [
      "gradient",
      "inverse↓"
    ]
  },
  "inverse↑": {
    value: "linear-gradient(0deg, #fcfcfd 0%, #ffffff00 100%)",
    type: "color",
    description: "token = lh-semantic-gradient-inverse-up\n\nbg inverse values, smooth, gradient, mask, transition",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: "linear-gradient(0deg, #fcfcfd 0%, #ffffff00 100%)",
      type: "color",
      description: "token = lh-semantic-gradient-inverse-up\n\nbg inverse values, smooth, gradient, mask, transition"
    },
    name: "sd-gradient-inverse",
    attributes: {},
    path: [
      "gradient",
      "inverse↑"
    ]
  },
  "brand↓": {
    value: "linear-gradient(180deg, #ff504e 0%, #ffffff00 100%)",
    type: "color",
    description: "token = lh-semantic-gradient-brand-down\n\nbg brand values, smooth, gradient, mask, transition",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: "linear-gradient(180deg, #ff504e 0%, #ffffff00 100%)",
      type: "color",
      description: "token = lh-semantic-gradient-brand-down\n\nbg brand values, smooth, gradient, mask, transition"
    },
    name: "sd-gradient-brand",
    attributes: {},
    path: [
      "gradient",
      "brand↓"
    ]
  },
  "brand↑": {
    value: "linear-gradient(0deg, #ff504e 0%, #ffffff00 100%)",
    type: "color",
    description: "token = lh-semantic-gradient-brand-up\n\nbg brand values, smooth, gradient, mask, transition",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: "linear-gradient(0deg, #ff504e 0%, #ffffff00 100%)",
      type: "color",
      description: "token = lh-semantic-gradient-brand-up\n\nbg brand values, smooth, gradient, mask, transition"
    },
    name: "sd-gradient-brand",
    attributes: {},
    path: [
      "gradient",
      "brand↑"
    ]
  },
  "black↓": {
    value: "linear-gradient(180deg, #000000 0%, #000000fc 11.79%, #000000f7 21.38%, #000000ed 29.12%, #000000e0 35.34%, #000000d1 40.37%, #000000bf 44.56%, #000000ab 48.24%, #00000096 51.76%, #00000080 55.44%, #00000069 59.63%, #00000054 64.66%, #0000003d 70.88%, #00000026 78.62%, #00000012 88.21%, #00000000 100%)",
    type: "color",
    description: "token = lh-semantic-gradient-black-down\n\nblack values, smooth, gradient, mask, transition, feed, overlay, content",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: "linear-gradient(180deg, #000000 0%, #000000fc 11.79%, #000000f7 21.38%, #000000ed 29.12%, #000000e0 35.34%, #000000d1 40.37%, #000000bf 44.56%, #000000ab 48.24%, #00000096 51.76%, #00000080 55.44%, #00000069 59.63%, #00000054 64.66%, #0000003d 70.88%, #00000026 78.62%, #00000012 88.21%, #00000000 100%)",
      type: "color",
      description: "token = lh-semantic-gradient-black-down\n\nblack values, smooth, gradient, mask, transition, feed, overlay, content"
    },
    name: "sd-gradient-black",
    attributes: {},
    path: [
      "gradient",
      "black↓"
    ]
  },
  "black↑": {
    value: "linear-gradient(0deg, #000000 0%, #000000fc 11.79%, #000000f7 21.38%, #000000ed 29.12%, #000000e0 35.34%, #000000d1 40.37%, #000000bf 44.56%, #000000ab 48.24%, #00000096 51.76%, #00000080 55.44%, #00000069 59.63%, #00000054 64.66%, #0000003d 70.88%, #00000026 78.62%, #00000012 88.21%, #00000000 100%)",
    type: "color",
    description: "token = lh-semantic-gradient-black-up\n\nblack values, smooth, gradient, mask, transition, feed, overlay, content",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: "linear-gradient(0deg, #000000 0%, #000000fc 11.79%, #000000f7 21.38%, #000000ed 29.12%, #000000e0 35.34%, #000000d1 40.37%, #000000bf 44.56%, #000000ab 48.24%, #00000096 51.76%, #00000080 55.44%, #00000069 59.63%, #00000054 64.66%, #0000003d 70.88%, #00000026 78.62%, #00000012 88.21%, #00000000 100%)",
      type: "color",
      description: "token = lh-semantic-gradient-black-up\n\nblack values, smooth, gradient, mask, transition, feed, overlay, content"
    },
    name: "sd-gradient-black",
    attributes: {},
    path: [
      "gradient",
      "black↑"
    ]
  }
};
const shadow$1 = {
  "smooth-icon": {
    "0": {
      color: {
        value: "rgba(0, 0, 0, 0.0392156862745098)",
        type: "color",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: "#0000000a",
          type: "color"
        },
        name: "sd-shadow-smooth-icon-0-color",
        attributes: {},
        path: [
          "shadow",
          "smooth-icon",
          "0",
          "color"
        ]
      },
      type: {
        value: "dropShadow",
        type: "type",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: "dropShadow",
          type: "type"
        },
        name: "sd-shadow-smooth-icon-0-type",
        attributes: {},
        path: [
          "shadow",
          "smooth-icon",
          "0",
          "type"
        ]
      },
      x: {
        value: "0px",
        type: "x",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 0,
          type: "x"
        },
        name: "sd-shadow-smooth-icon-0-x",
        attributes: {},
        path: [
          "shadow",
          "smooth-icon",
          "0",
          "x"
        ]
      },
      y: {
        value: "0px",
        type: "y",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 0,
          type: "y"
        },
        name: "sd-shadow-smooth-icon-0-y",
        attributes: {},
        path: [
          "shadow",
          "smooth-icon",
          "0",
          "y"
        ]
      },
      blur: {
        value: "1px",
        type: "blur",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 1,
          type: "blur"
        },
        name: "sd-shadow-smooth-icon-0-blur",
        attributes: {},
        path: [
          "shadow",
          "smooth-icon",
          "0",
          "blur"
        ]
      },
      spread: {
        value: "0px",
        type: "spread",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 0,
          type: "spread"
        },
        name: "sd-shadow-smooth-icon-0-spread",
        attributes: {},
        path: [
          "shadow",
          "smooth-icon",
          "0",
          "spread"
        ]
      }
    },
    "1": {
      color: {
        value: "rgba(0, 0, 0, 0.23921568627450981)",
        type: "color",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: "#0000003d",
          type: "color"
        },
        name: "sd-shadow-smooth-icon-1-color",
        attributes: {},
        path: [
          "shadow",
          "smooth-icon",
          "1",
          "color"
        ]
      },
      type: {
        value: "dropShadow",
        type: "type",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: "dropShadow",
          type: "type"
        },
        name: "sd-shadow-smooth-icon-1-type",
        attributes: {},
        path: [
          "shadow",
          "smooth-icon",
          "1",
          "type"
        ]
      },
      x: {
        value: "0px",
        type: "x",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 0,
          type: "x"
        },
        name: "sd-shadow-smooth-icon-1-x",
        attributes: {},
        path: [
          "shadow",
          "smooth-icon",
          "1",
          "x"
        ]
      },
      y: {
        value: "0px",
        type: "y",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 0,
          type: "y"
        },
        name: "sd-shadow-smooth-icon-1-y",
        attributes: {},
        path: [
          "shadow",
          "smooth-icon",
          "1",
          "y"
        ]
      },
      blur: {
        value: "16px",
        type: "blur",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 16,
          type: "blur"
        },
        name: "sd-shadow-smooth-icon-1-blur",
        attributes: {},
        path: [
          "shadow",
          "smooth-icon",
          "1",
          "blur"
        ]
      },
      spread: {
        value: "0px",
        type: "spread",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 0,
          type: "spread"
        },
        name: "sd-shadow-smooth-icon-1-spread",
        attributes: {},
        path: [
          "shadow",
          "smooth-icon",
          "1",
          "spread"
        ]
      }
    }
  },
  "sharp-icon": {
    "0": {
      color: {
        value: "rgba(0, 0, 0, 0.47843137254901963)",
        type: "color",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: "#0000007a",
          type: "color"
        },
        name: "sd-shadow-sharp-icon-0-color",
        attributes: {},
        path: [
          "shadow",
          "sharp-icon",
          "0",
          "color"
        ]
      },
      type: {
        value: "dropShadow",
        type: "type",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: "dropShadow",
          type: "type"
        },
        name: "sd-shadow-sharp-icon-0-type",
        attributes: {},
        path: [
          "shadow",
          "sharp-icon",
          "0",
          "type"
        ]
      },
      x: {
        value: "0px",
        type: "x",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 0,
          type: "x"
        },
        name: "sd-shadow-sharp-icon-0-x",
        attributes: {},
        path: [
          "shadow",
          "sharp-icon",
          "0",
          "x"
        ]
      },
      y: {
        value: "0px",
        type: "y",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 0,
          type: "y"
        },
        name: "sd-shadow-sharp-icon-0-y",
        attributes: {},
        path: [
          "shadow",
          "sharp-icon",
          "0",
          "y"
        ]
      },
      blur: {
        value: "1px",
        type: "blur",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 1,
          type: "blur"
        },
        name: "sd-shadow-sharp-icon-0-blur",
        attributes: {},
        path: [
          "shadow",
          "sharp-icon",
          "0",
          "blur"
        ]
      },
      spread: {
        value: "0px",
        type: "spread",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 0,
          type: "spread"
        },
        name: "sd-shadow-sharp-icon-0-spread",
        attributes: {},
        path: [
          "shadow",
          "sharp-icon",
          "0",
          "spread"
        ]
      }
    },
    "1": {
      color: {
        value: "rgba(0, 0, 0, 0.1607843137254902)",
        type: "color",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: "#00000029",
          type: "color"
        },
        name: "sd-shadow-sharp-icon-1-color",
        attributes: {},
        path: [
          "shadow",
          "sharp-icon",
          "1",
          "color"
        ]
      },
      type: {
        value: "dropShadow",
        type: "type",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: "dropShadow",
          type: "type"
        },
        name: "sd-shadow-sharp-icon-1-type",
        attributes: {},
        path: [
          "shadow",
          "sharp-icon",
          "1",
          "type"
        ]
      },
      x: {
        value: "0px",
        type: "x",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 0,
          type: "x"
        },
        name: "sd-shadow-sharp-icon-1-x",
        attributes: {},
        path: [
          "shadow",
          "sharp-icon",
          "1",
          "x"
        ]
      },
      y: {
        value: "0px",
        type: "y",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 0,
          type: "y"
        },
        name: "sd-shadow-sharp-icon-1-y",
        attributes: {},
        path: [
          "shadow",
          "sharp-icon",
          "1",
          "y"
        ]
      },
      blur: {
        value: "2px",
        type: "blur",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 2,
          type: "blur"
        },
        name: "sd-shadow-sharp-icon-1-blur",
        attributes: {},
        path: [
          "shadow",
          "sharp-icon",
          "1",
          "blur"
        ]
      },
      spread: {
        value: "0px",
        type: "spread",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 0,
          type: "spread"
        },
        name: "sd-shadow-sharp-icon-1-spread",
        attributes: {},
        path: [
          "shadow",
          "sharp-icon",
          "1",
          "spread"
        ]
      }
    }
  },
  seperation: {
    "0": {
      color: {
        value: "rgba(0, 0, 0, 0.0784313725490196)",
        type: "color",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: "#00000014",
          type: "color"
        },
        name: "sd-shadow-seperation-0-color",
        attributes: {},
        path: [
          "shadow",
          "seperation",
          "0",
          "color"
        ]
      },
      type: {
        value: "dropShadow",
        type: "type",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: "dropShadow",
          type: "type"
        },
        name: "sd-shadow-seperation-0-type",
        attributes: {},
        path: [
          "shadow",
          "seperation",
          "0",
          "type"
        ]
      },
      x: {
        value: "0px",
        type: "x",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 0,
          type: "x"
        },
        name: "sd-shadow-seperation-0-x",
        attributes: {},
        path: [
          "shadow",
          "seperation",
          "0",
          "x"
        ]
      },
      y: {
        value: "0px",
        type: "y",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 0,
          type: "y"
        },
        name: "sd-shadow-seperation-0-y",
        attributes: {},
        path: [
          "shadow",
          "seperation",
          "0",
          "y"
        ]
      },
      blur: {
        value: "1px",
        type: "blur",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 1,
          type: "blur"
        },
        name: "sd-shadow-seperation-0-blur",
        attributes: {},
        path: [
          "shadow",
          "seperation",
          "0",
          "blur"
        ]
      },
      spread: {
        value: "0px",
        type: "spread",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 0,
          type: "spread"
        },
        name: "sd-shadow-seperation-0-spread",
        attributes: {},
        path: [
          "shadow",
          "seperation",
          "0",
          "spread"
        ]
      }
    },
    "1": {
      color: {
        value: "rgba(0, 0, 0, 0.058823529411764705)",
        type: "color",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: "#0000000f",
          type: "color"
        },
        name: "sd-shadow-seperation-1-color",
        attributes: {},
        path: [
          "shadow",
          "seperation",
          "1",
          "color"
        ]
      },
      type: {
        value: "dropShadow",
        type: "type",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: "dropShadow",
          type: "type"
        },
        name: "sd-shadow-seperation-1-type",
        attributes: {},
        path: [
          "shadow",
          "seperation",
          "1",
          "type"
        ]
      },
      x: {
        value: "0px",
        type: "x",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 0,
          type: "x"
        },
        name: "sd-shadow-seperation-1-x",
        attributes: {},
        path: [
          "shadow",
          "seperation",
          "1",
          "x"
        ]
      },
      y: {
        value: "2px",
        type: "y",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 2,
          type: "y"
        },
        name: "sd-shadow-seperation-1-y",
        attributes: {},
        path: [
          "shadow",
          "seperation",
          "1",
          "y"
        ]
      },
      blur: {
        value: "32px",
        type: "blur",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 32,
          type: "blur"
        },
        name: "sd-shadow-seperation-1-blur",
        attributes: {},
        path: [
          "shadow",
          "seperation",
          "1",
          "blur"
        ]
      },
      spread: {
        value: "0px",
        type: "spread",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 0,
          type: "spread"
        },
        name: "sd-shadow-seperation-1-spread",
        attributes: {},
        path: [
          "shadow",
          "seperation",
          "1",
          "spread"
        ]
      }
    }
  },
  "elevation-1": {
    "0": {
      color: {
        value: "rgba(0, 0, 0, 0.0784313725490196)",
        type: "color",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: "#00000014",
          type: "color"
        },
        name: "sd-shadow-elevation-1-0-color",
        attributes: {},
        path: [
          "shadow",
          "elevation-1",
          "0",
          "color"
        ]
      },
      type: {
        value: "dropShadow",
        type: "type",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: "dropShadow",
          type: "type"
        },
        name: "sd-shadow-elevation-1-0-type",
        attributes: {},
        path: [
          "shadow",
          "elevation-1",
          "0",
          "type"
        ]
      },
      x: {
        value: "0px",
        type: "x",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 0,
          type: "x"
        },
        name: "sd-shadow-elevation-1-0-x",
        attributes: {},
        path: [
          "shadow",
          "elevation-1",
          "0",
          "x"
        ]
      },
      y: {
        value: "4px",
        type: "y",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 4,
          type: "y"
        },
        name: "sd-shadow-elevation-1-0-y",
        attributes: {},
        path: [
          "shadow",
          "elevation-1",
          "0",
          "y"
        ]
      },
      blur: {
        value: "12px",
        type: "blur",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 12,
          type: "blur"
        },
        name: "sd-shadow-elevation-1-0-blur",
        attributes: {},
        path: [
          "shadow",
          "elevation-1",
          "0",
          "blur"
        ]
      },
      spread: {
        value: "-2px",
        type: "spread",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: -2,
          type: "spread"
        },
        name: "sd-shadow-elevation-1-0-spread",
        attributes: {},
        path: [
          "shadow",
          "elevation-1",
          "0",
          "spread"
        ]
      }
    },
    "1": {
      color: {
        value: "rgba(0, 0, 0, 0.0196078431372549)",
        type: "color",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: "#00000005",
          type: "color"
        },
        name: "sd-shadow-elevation-1-1-color",
        attributes: {},
        path: [
          "shadow",
          "elevation-1",
          "1",
          "color"
        ]
      },
      type: {
        value: "dropShadow",
        type: "type",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: "dropShadow",
          type: "type"
        },
        name: "sd-shadow-elevation-1-1-type",
        attributes: {},
        path: [
          "shadow",
          "elevation-1",
          "1",
          "type"
        ]
      },
      x: {
        value: "0px",
        type: "x",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 0,
          type: "x"
        },
        name: "sd-shadow-elevation-1-1-x",
        attributes: {},
        path: [
          "shadow",
          "elevation-1",
          "1",
          "x"
        ]
      },
      y: {
        value: "0px",
        type: "y",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 0,
          type: "y"
        },
        name: "sd-shadow-elevation-1-1-y",
        attributes: {},
        path: [
          "shadow",
          "elevation-1",
          "1",
          "y"
        ]
      },
      blur: {
        value: "4px",
        type: "blur",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 4,
          type: "blur"
        },
        name: "sd-shadow-elevation-1-1-blur",
        attributes: {},
        path: [
          "shadow",
          "elevation-1",
          "1",
          "blur"
        ]
      },
      spread: {
        value: "0px",
        type: "spread",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 0,
          type: "spread"
        },
        name: "sd-shadow-elevation-1-1-spread",
        attributes: {},
        path: [
          "shadow",
          "elevation-1",
          "1",
          "spread"
        ]
      }
    }
  },
  "elevation-2": {
    "0": {
      color: {
        value: "rgba(0, 0, 0, 0.0784313725490196)",
        type: "color",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: "#00000014",
          type: "color"
        },
        name: "sd-shadow-elevation-2-0-color",
        attributes: {},
        path: [
          "shadow",
          "elevation-2",
          "0",
          "color"
        ]
      },
      type: {
        value: "dropShadow",
        type: "type",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: "dropShadow",
          type: "type"
        },
        name: "sd-shadow-elevation-2-0-type",
        attributes: {},
        path: [
          "shadow",
          "elevation-2",
          "0",
          "type"
        ]
      },
      x: {
        value: "0px",
        type: "x",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 0,
          type: "x"
        },
        name: "sd-shadow-elevation-2-0-x",
        attributes: {},
        path: [
          "shadow",
          "elevation-2",
          "0",
          "x"
        ]
      },
      y: {
        value: "8px",
        type: "y",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 8,
          type: "y"
        },
        name: "sd-shadow-elevation-2-0-y",
        attributes: {},
        path: [
          "shadow",
          "elevation-2",
          "0",
          "y"
        ]
      },
      blur: {
        value: "24px",
        type: "blur",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 24,
          type: "blur"
        },
        name: "sd-shadow-elevation-2-0-blur",
        attributes: {},
        path: [
          "shadow",
          "elevation-2",
          "0",
          "blur"
        ]
      },
      spread: {
        value: "-4px",
        type: "spread",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: -4,
          type: "spread"
        },
        name: "sd-shadow-elevation-2-0-spread",
        attributes: {},
        path: [
          "shadow",
          "elevation-2",
          "0",
          "spread"
        ]
      }
    },
    "1": {
      color: {
        value: "rgba(0, 0, 0, 0.12156862745098039)",
        type: "color",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: "#0000001f",
          type: "color"
        },
        name: "sd-shadow-elevation-2-1-color",
        attributes: {},
        path: [
          "shadow",
          "elevation-2",
          "1",
          "color"
        ]
      },
      type: {
        value: "dropShadow",
        type: "type",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: "dropShadow",
          type: "type"
        },
        name: "sd-shadow-elevation-2-1-type",
        attributes: {},
        path: [
          "shadow",
          "elevation-2",
          "1",
          "type"
        ]
      },
      x: {
        value: "0px",
        type: "x",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 0,
          type: "x"
        },
        name: "sd-shadow-elevation-2-1-x",
        attributes: {},
        path: [
          "shadow",
          "elevation-2",
          "1",
          "x"
        ]
      },
      y: {
        value: "2px",
        type: "y",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 2,
          type: "y"
        },
        name: "sd-shadow-elevation-2-1-y",
        attributes: {},
        path: [
          "shadow",
          "elevation-2",
          "1",
          "y"
        ]
      },
      blur: {
        value: "12px",
        type: "blur",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 12,
          type: "blur"
        },
        name: "sd-shadow-elevation-2-1-blur",
        attributes: {},
        path: [
          "shadow",
          "elevation-2",
          "1",
          "blur"
        ]
      },
      spread: {
        value: "-2px",
        type: "spread",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: -2,
          type: "spread"
        },
        name: "sd-shadow-elevation-2-1-spread",
        attributes: {},
        path: [
          "shadow",
          "elevation-2",
          "1",
          "spread"
        ]
      }
    }
  },
  "elevation-3": {
    "0": {
      color: {
        value: "rgba(0, 0, 0, 0.12156862745098039)",
        type: "color",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: "#0000001f",
          type: "color"
        },
        name: "sd-shadow-elevation-3-0-color",
        attributes: {},
        path: [
          "shadow",
          "elevation-3",
          "0",
          "color"
        ]
      },
      type: {
        value: "dropShadow",
        type: "type",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: "dropShadow",
          type: "type"
        },
        name: "sd-shadow-elevation-3-0-type",
        attributes: {},
        path: [
          "shadow",
          "elevation-3",
          "0",
          "type"
        ]
      },
      x: {
        value: "0px",
        type: "x",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 0,
          type: "x"
        },
        name: "sd-shadow-elevation-3-0-x",
        attributes: {},
        path: [
          "shadow",
          "elevation-3",
          "0",
          "x"
        ]
      },
      y: {
        value: "12px",
        type: "y",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 12,
          type: "y"
        },
        name: "sd-shadow-elevation-3-0-y",
        attributes: {},
        path: [
          "shadow",
          "elevation-3",
          "0",
          "y"
        ]
      },
      blur: {
        value: "42px",
        type: "blur",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 42,
          type: "blur"
        },
        name: "sd-shadow-elevation-3-0-blur",
        attributes: {},
        path: [
          "shadow",
          "elevation-3",
          "0",
          "blur"
        ]
      },
      spread: {
        value: "-4px",
        type: "spread",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: -4,
          type: "spread"
        },
        name: "sd-shadow-elevation-3-0-spread",
        attributes: {},
        path: [
          "shadow",
          "elevation-3",
          "0",
          "spread"
        ]
      }
    },
    "1": {
      color: {
        value: "rgba(0, 0, 0, 0.12156862745098039)",
        type: "color",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: "#0000001f",
          type: "color"
        },
        name: "sd-shadow-elevation-3-1-color",
        attributes: {},
        path: [
          "shadow",
          "elevation-3",
          "1",
          "color"
        ]
      },
      type: {
        value: "dropShadow",
        type: "type",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: "dropShadow",
          type: "type"
        },
        name: "sd-shadow-elevation-3-1-type",
        attributes: {},
        path: [
          "shadow",
          "elevation-3",
          "1",
          "type"
        ]
      },
      x: {
        value: "0px",
        type: "x",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 0,
          type: "x"
        },
        name: "sd-shadow-elevation-3-1-x",
        attributes: {},
        path: [
          "shadow",
          "elevation-3",
          "1",
          "x"
        ]
      },
      y: {
        value: "4px",
        type: "y",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 4,
          type: "y"
        },
        name: "sd-shadow-elevation-3-1-y",
        attributes: {},
        path: [
          "shadow",
          "elevation-3",
          "1",
          "y"
        ]
      },
      blur: {
        value: "16px",
        type: "blur",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 16,
          type: "blur"
        },
        name: "sd-shadow-elevation-3-1-blur",
        attributes: {},
        path: [
          "shadow",
          "elevation-3",
          "1",
          "blur"
        ]
      },
      spread: {
        value: "-6px",
        type: "spread",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: -6,
          type: "spread"
        },
        name: "sd-shadow-elevation-3-1-spread",
        attributes: {},
        path: [
          "shadow",
          "elevation-3",
          "1",
          "spread"
        ]
      }
    }
  },
  "elevation-4": {
    "0": {
      color: {
        value: "rgba(0, 0, 0, 0.1607843137254902)",
        type: "color",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: "#00000029",
          type: "color"
        },
        name: "sd-shadow-elevation-4-0-color",
        attributes: {},
        path: [
          "shadow",
          "elevation-4",
          "0",
          "color"
        ]
      },
      type: {
        value: "dropShadow",
        type: "type",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: "dropShadow",
          type: "type"
        },
        name: "sd-shadow-elevation-4-0-type",
        attributes: {},
        path: [
          "shadow",
          "elevation-4",
          "0",
          "type"
        ]
      },
      x: {
        value: "0px",
        type: "x",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 0,
          type: "x"
        },
        name: "sd-shadow-elevation-4-0-x",
        attributes: {},
        path: [
          "shadow",
          "elevation-4",
          "0",
          "x"
        ]
      },
      y: {
        value: "18px",
        type: "y",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 18,
          type: "y"
        },
        name: "sd-shadow-elevation-4-0-y",
        attributes: {},
        path: [
          "shadow",
          "elevation-4",
          "0",
          "y"
        ]
      },
      blur: {
        value: "64px",
        type: "blur",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 64,
          type: "blur"
        },
        name: "sd-shadow-elevation-4-0-blur",
        attributes: {},
        path: [
          "shadow",
          "elevation-4",
          "0",
          "blur"
        ]
      },
      spread: {
        value: "-4px",
        type: "spread",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: -4,
          type: "spread"
        },
        name: "sd-shadow-elevation-4-0-spread",
        attributes: {},
        path: [
          "shadow",
          "elevation-4",
          "0",
          "spread"
        ]
      }
    },
    "1": {
      color: {
        value: "rgba(0, 0, 0, 0.12156862745098039)",
        type: "color",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: "#0000001f",
          type: "color"
        },
        name: "sd-shadow-elevation-4-1-color",
        attributes: {},
        path: [
          "shadow",
          "elevation-4",
          "1",
          "color"
        ]
      },
      type: {
        value: "dropShadow",
        type: "type",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: "dropShadow",
          type: "type"
        },
        name: "sd-shadow-elevation-4-1-type",
        attributes: {},
        path: [
          "shadow",
          "elevation-4",
          "1",
          "type"
        ]
      },
      x: {
        value: "0px",
        type: "x",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 0,
          type: "x"
        },
        name: "sd-shadow-elevation-4-1-x",
        attributes: {},
        path: [
          "shadow",
          "elevation-4",
          "1",
          "x"
        ]
      },
      y: {
        value: "6px",
        type: "y",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 6,
          type: "y"
        },
        name: "sd-shadow-elevation-4-1-y",
        attributes: {},
        path: [
          "shadow",
          "elevation-4",
          "1",
          "y"
        ]
      },
      blur: {
        value: "28px",
        type: "blur",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 28,
          type: "blur"
        },
        name: "sd-shadow-elevation-4-1-blur",
        attributes: {},
        path: [
          "shadow",
          "elevation-4",
          "1",
          "blur"
        ]
      },
      spread: {
        value: "-6px",
        type: "spread",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: -6,
          type: "spread"
        },
        name: "sd-shadow-elevation-4-1-spread",
        attributes: {},
        path: [
          "shadow",
          "elevation-4",
          "1",
          "spread"
        ]
      }
    }
  }
};
const typography$2 = {
  display: {
    lg: {
      fontFamily: {
        value: "Brown LL",
        type: "fontFamilies",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: "Brown LL",
          type: "fontFamilies"
        },
        name: "sd-typography-display-lg-font-family",
        attributes: {},
        path: [
          "typography",
          "display",
          "lg",
          "fontFamily"
        ]
      },
      fontWeight: {
        value: "Medium",
        type: "fontWeights",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: "Medium",
          type: "fontWeights"
        },
        name: "sd-typography-display-lg-font-weight",
        attributes: {},
        path: [
          "typography",
          "display",
          "lg",
          "fontWeight"
        ]
      },
      lineHeight: {
        value: "72px",
        type: "lineHeight",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 72,
          type: "lineHeight"
        },
        name: "sd-typography-display-lg-line-height",
        attributes: {},
        path: [
          "typography",
          "display",
          "lg",
          "lineHeight"
        ]
      },
      fontSize: {
        value: "64px",
        type: "fontSizes",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 64,
          type: "fontSizes"
        },
        name: "sd-typography-display-lg-font-size",
        attributes: {},
        path: [
          "typography",
          "display",
          "lg",
          "fontSize"
        ]
      },
      letterSpacing: {
        value: "0px",
        type: "letterSpacing",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 0,
          type: "letterSpacing"
        },
        name: "sd-typography-display-lg-letter-spacing",
        attributes: {},
        path: [
          "typography",
          "display",
          "lg",
          "letterSpacing"
        ]
      },
      textDecoration: {
        value: "none",
        type: "textDecoration",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: "none",
          type: "textDecoration"
        },
        name: "sd-typography-display-lg-text-decoration",
        attributes: {},
        path: [
          "typography",
          "display",
          "lg",
          "textDecoration"
        ]
      }
    },
    md: {
      fontFamily: {
        value: "Brown LL",
        type: "fontFamilies",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: "Brown LL",
          type: "fontFamilies"
        },
        name: "sd-typography-display-md-font-family",
        attributes: {},
        path: [
          "typography",
          "display",
          "md",
          "fontFamily"
        ]
      },
      fontWeight: {
        value: "Bold",
        type: "fontWeights",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: "Bold",
          type: "fontWeights"
        },
        name: "sd-typography-display-md-font-weight",
        attributes: {},
        path: [
          "typography",
          "display",
          "md",
          "fontWeight"
        ]
      },
      lineHeight: {
        value: "64px",
        type: "lineHeight",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 64,
          type: "lineHeight"
        },
        name: "sd-typography-display-md-line-height",
        attributes: {},
        path: [
          "typography",
          "display",
          "md",
          "lineHeight"
        ]
      },
      fontSize: {
        value: "56px",
        type: "fontSizes",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 56,
          type: "fontSizes"
        },
        name: "sd-typography-display-md-font-size",
        attributes: {},
        path: [
          "typography",
          "display",
          "md",
          "fontSize"
        ]
      },
      letterSpacing: {
        value: "0px",
        type: "letterSpacing",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 0,
          type: "letterSpacing"
        },
        name: "sd-typography-display-md-letter-spacing",
        attributes: {},
        path: [
          "typography",
          "display",
          "md",
          "letterSpacing"
        ]
      },
      textDecoration: {
        value: "none",
        type: "textDecoration",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: "none",
          type: "textDecoration"
        },
        name: "sd-typography-display-md-text-decoration",
        attributes: {},
        path: [
          "typography",
          "display",
          "md",
          "textDecoration"
        ]
      }
    },
    sm: {
      fontFamily: {
        value: "Brown LL",
        type: "fontFamilies",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: "Brown LL",
          type: "fontFamilies"
        },
        name: "sd-typography-display-sm-font-family",
        attributes: {},
        path: [
          "typography",
          "display",
          "sm",
          "fontFamily"
        ]
      },
      fontWeight: {
        value: "Medium",
        type: "fontWeights",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: "Medium",
          type: "fontWeights"
        },
        name: "sd-typography-display-sm-font-weight",
        attributes: {},
        path: [
          "typography",
          "display",
          "sm",
          "fontWeight"
        ]
      },
      lineHeight: {
        value: "48px",
        type: "lineHeight",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 48,
          type: "lineHeight"
        },
        name: "sd-typography-display-sm-line-height",
        attributes: {},
        path: [
          "typography",
          "display",
          "sm",
          "lineHeight"
        ]
      },
      fontSize: {
        value: "40px",
        type: "fontSizes",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 40,
          type: "fontSizes"
        },
        name: "sd-typography-display-sm-font-size",
        attributes: {},
        path: [
          "typography",
          "display",
          "sm",
          "fontSize"
        ]
      },
      letterSpacing: {
        value: "0px",
        type: "letterSpacing",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 0,
          type: "letterSpacing"
        },
        name: "sd-typography-display-sm-letter-spacing",
        attributes: {},
        path: [
          "typography",
          "display",
          "sm",
          "letterSpacing"
        ]
      },
      textDecoration: {
        value: "none",
        type: "textDecoration",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: "none",
          type: "textDecoration"
        },
        name: "sd-typography-display-sm-text-decoration",
        attributes: {},
        path: [
          "typography",
          "display",
          "sm",
          "textDecoration"
        ]
      }
    }
  },
  headline: {
    xl: {
      fontFamily: {
        value: "Brown LL",
        type: "fontFamilies",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: "Brown LL",
          type: "fontFamilies"
        },
        name: "sd-typography-headline-xl-font-family",
        attributes: {},
        path: [
          "typography",
          "headline",
          "xl",
          "fontFamily"
        ]
      },
      fontWeight: {
        value: "Bold",
        type: "fontWeights",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: "Bold",
          type: "fontWeights"
        },
        name: "sd-typography-headline-xl-font-weight",
        attributes: {},
        path: [
          "typography",
          "headline",
          "xl",
          "fontWeight"
        ]
      },
      lineHeight: {
        value: "40px",
        type: "lineHeight",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 40,
          type: "lineHeight"
        },
        name: "sd-typography-headline-xl-line-height",
        attributes: {},
        path: [
          "typography",
          "headline",
          "xl",
          "lineHeight"
        ]
      },
      fontSize: {
        value: "32px",
        type: "fontSizes",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 32,
          type: "fontSizes"
        },
        name: "sd-typography-headline-xl-font-size",
        attributes: {},
        path: [
          "typography",
          "headline",
          "xl",
          "fontSize"
        ]
      },
      letterSpacing: {
        value: "-1px",
        type: "letterSpacing",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: -1,
          type: "letterSpacing"
        },
        name: "sd-typography-headline-xl-letter-spacing",
        attributes: {},
        path: [
          "typography",
          "headline",
          "xl",
          "letterSpacing"
        ]
      },
      textDecoration: {
        value: "none",
        type: "textDecoration",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: "none",
          type: "textDecoration"
        },
        name: "sd-typography-headline-xl-text-decoration",
        attributes: {},
        path: [
          "typography",
          "headline",
          "xl",
          "textDecoration"
        ]
      }
    },
    lg: {
      fontFamily: {
        value: "Brown LL",
        type: "fontFamilies",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: "Brown LL",
          type: "fontFamilies"
        },
        name: "sd-typography-headline-lg-font-family",
        attributes: {},
        path: [
          "typography",
          "headline",
          "lg",
          "fontFamily"
        ]
      },
      fontWeight: {
        value: "Bold",
        type: "fontWeights",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: "Bold",
          type: "fontWeights"
        },
        name: "sd-typography-headline-lg-font-weight",
        attributes: {},
        path: [
          "typography",
          "headline",
          "lg",
          "fontWeight"
        ]
      },
      lineHeight: {
        value: "32px",
        type: "lineHeight",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 32,
          type: "lineHeight"
        },
        name: "sd-typography-headline-lg-line-height",
        attributes: {},
        path: [
          "typography",
          "headline",
          "lg",
          "lineHeight"
        ]
      },
      fontSize: {
        value: "24px",
        type: "fontSizes",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 24,
          type: "fontSizes"
        },
        name: "sd-typography-headline-lg-font-size",
        attributes: {},
        path: [
          "typography",
          "headline",
          "lg",
          "fontSize"
        ]
      },
      letterSpacing: {
        value: "-0.75px",
        type: "letterSpacing",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: -0.75,
          type: "letterSpacing"
        },
        name: "sd-typography-headline-lg-letter-spacing",
        attributes: {},
        path: [
          "typography",
          "headline",
          "lg",
          "letterSpacing"
        ]
      },
      textDecoration: {
        value: "none",
        type: "textDecoration",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: "none",
          type: "textDecoration"
        },
        name: "sd-typography-headline-lg-text-decoration",
        attributes: {},
        path: [
          "typography",
          "headline",
          "lg",
          "textDecoration"
        ]
      }
    },
    md: {
      fontFamily: {
        value: "Brown LL",
        type: "fontFamilies",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: "Brown LL",
          type: "fontFamilies"
        },
        name: "sd-typography-headline-md-font-family",
        attributes: {},
        path: [
          "typography",
          "headline",
          "md",
          "fontFamily"
        ]
      },
      fontWeight: {
        value: "Bold",
        type: "fontWeights",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: "Bold",
          type: "fontWeights"
        },
        name: "sd-typography-headline-md-font-weight",
        attributes: {},
        path: [
          "typography",
          "headline",
          "md",
          "fontWeight"
        ]
      },
      lineHeight: {
        value: "26px",
        type: "lineHeight",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 26,
          type: "lineHeight"
        },
        name: "sd-typography-headline-md-line-height",
        attributes: {},
        path: [
          "typography",
          "headline",
          "md",
          "lineHeight"
        ]
      },
      fontSize: {
        value: "20px",
        type: "fontSizes",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 20,
          type: "fontSizes"
        },
        name: "sd-typography-headline-md-font-size",
        attributes: {},
        path: [
          "typography",
          "headline",
          "md",
          "fontSize"
        ]
      },
      letterSpacing: {
        value: "-0.25px",
        type: "letterSpacing",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: -0.25,
          type: "letterSpacing"
        },
        name: "sd-typography-headline-md-letter-spacing",
        attributes: {},
        path: [
          "typography",
          "headline",
          "md",
          "letterSpacing"
        ]
      },
      textDecoration: {
        value: "none",
        type: "textDecoration",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: "none",
          type: "textDecoration"
        },
        name: "sd-typography-headline-md-text-decoration",
        attributes: {},
        path: [
          "typography",
          "headline",
          "md",
          "textDecoration"
        ]
      }
    },
    sm: {
      fontFamily: {
        value: "Brown LL",
        type: "fontFamilies",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: "Brown LL",
          type: "fontFamilies"
        },
        name: "sd-typography-headline-sm-font-family",
        attributes: {},
        path: [
          "typography",
          "headline",
          "sm",
          "fontFamily"
        ]
      },
      fontWeight: {
        value: "Bold",
        type: "fontWeights",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: "Bold",
          type: "fontWeights"
        },
        name: "sd-typography-headline-sm-font-weight",
        attributes: {},
        path: [
          "typography",
          "headline",
          "sm",
          "fontWeight"
        ]
      },
      lineHeight: {
        value: "24px",
        type: "lineHeight",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 24,
          type: "lineHeight"
        },
        name: "sd-typography-headline-sm-line-height",
        attributes: {},
        path: [
          "typography",
          "headline",
          "sm",
          "lineHeight"
        ]
      },
      fontSize: {
        value: "18px",
        type: "fontSizes",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 18,
          type: "fontSizes"
        },
        name: "sd-typography-headline-sm-font-size",
        attributes: {},
        path: [
          "typography",
          "headline",
          "sm",
          "fontSize"
        ]
      },
      letterSpacing: {
        value: "-0.5px",
        type: "letterSpacing",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: -0.5,
          type: "letterSpacing"
        },
        name: "sd-typography-headline-sm-letter-spacing",
        attributes: {},
        path: [
          "typography",
          "headline",
          "sm",
          "letterSpacing"
        ]
      },
      textDecoration: {
        value: "none",
        type: "textDecoration",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: "none",
          type: "textDecoration"
        },
        name: "sd-typography-headline-sm-text-decoration",
        attributes: {},
        path: [
          "typography",
          "headline",
          "sm",
          "textDecoration"
        ]
      }
    },
    xs: {
      fontFamily: {
        value: "Brown LL",
        type: "fontFamilies",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: "Brown LL",
          type: "fontFamilies"
        },
        name: "sd-typography-headline-xs-font-family",
        attributes: {},
        path: [
          "typography",
          "headline",
          "xs",
          "fontFamily"
        ]
      },
      fontWeight: {
        value: "Bold",
        type: "fontWeights",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: "Bold",
          type: "fontWeights"
        },
        name: "sd-typography-headline-xs-font-weight",
        attributes: {},
        path: [
          "typography",
          "headline",
          "xs",
          "fontWeight"
        ]
      },
      lineHeight: {
        value: "20px",
        type: "lineHeight",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 20,
          type: "lineHeight"
        },
        name: "sd-typography-headline-xs-line-height",
        attributes: {},
        path: [
          "typography",
          "headline",
          "xs",
          "lineHeight"
        ]
      },
      fontSize: {
        value: "16px",
        type: "fontSizes",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 16,
          type: "fontSizes"
        },
        name: "sd-typography-headline-xs-font-size",
        attributes: {},
        path: [
          "typography",
          "headline",
          "xs",
          "fontSize"
        ]
      },
      letterSpacing: {
        value: "-0.5px",
        type: "letterSpacing",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: -0.5,
          type: "letterSpacing"
        },
        name: "sd-typography-headline-xs-letter-spacing",
        attributes: {},
        path: [
          "typography",
          "headline",
          "xs",
          "letterSpacing"
        ]
      },
      textDecoration: {
        value: "none",
        type: "textDecoration",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: "none",
          type: "textDecoration"
        },
        name: "sd-typography-headline-xs-text-decoration",
        attributes: {},
        path: [
          "typography",
          "headline",
          "xs",
          "textDecoration"
        ]
      }
    },
    xxs: {
      fontFamily: {
        value: "Brown LL",
        type: "fontFamilies",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: "Brown LL",
          type: "fontFamilies"
        },
        name: "sd-typography-headline-xxs-font-family",
        attributes: {},
        path: [
          "typography",
          "headline",
          "xxs",
          "fontFamily"
        ]
      },
      fontWeight: {
        value: "Bold",
        type: "fontWeights",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: "Bold",
          type: "fontWeights"
        },
        name: "sd-typography-headline-xxs-font-weight",
        attributes: {},
        path: [
          "typography",
          "headline",
          "xxs",
          "fontWeight"
        ]
      },
      lineHeight: {
        value: "18px",
        type: "lineHeight",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 18,
          type: "lineHeight"
        },
        name: "sd-typography-headline-xxs-line-height",
        attributes: {},
        path: [
          "typography",
          "headline",
          "xxs",
          "lineHeight"
        ]
      },
      fontSize: {
        value: "14px",
        type: "fontSizes",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 14,
          type: "fontSizes"
        },
        name: "sd-typography-headline-xxs-font-size",
        attributes: {},
        path: [
          "typography",
          "headline",
          "xxs",
          "fontSize"
        ]
      },
      letterSpacing: {
        value: "-0.25px",
        type: "letterSpacing",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: -0.25,
          type: "letterSpacing"
        },
        name: "sd-typography-headline-xxs-letter-spacing",
        attributes: {},
        path: [
          "typography",
          "headline",
          "xxs",
          "letterSpacing"
        ]
      },
      textDecoration: {
        value: "none",
        type: "textDecoration",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: "none",
          type: "textDecoration"
        },
        name: "sd-typography-headline-xxs-text-decoration",
        attributes: {},
        path: [
          "typography",
          "headline",
          "xxs",
          "textDecoration"
        ]
      }
    }
  },
  body: {
    xl: {
      fontFamily: {
        value: "Brown LL",
        type: "fontFamilies",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: "Brown LL",
          type: "fontFamilies"
        },
        name: "sd-typography-body-xl-font-family",
        attributes: {},
        path: [
          "typography",
          "body",
          "xl",
          "fontFamily"
        ]
      },
      fontWeight: {
        value: "Regular",
        type: "fontWeights",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: "Regular",
          type: "fontWeights"
        },
        name: "sd-typography-body-xl-font-weight",
        attributes: {},
        path: [
          "typography",
          "body",
          "xl",
          "fontWeight"
        ]
      },
      lineHeight: {
        value: "24px",
        type: "lineHeight",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 24,
          type: "lineHeight"
        },
        name: "sd-typography-body-xl-line-height",
        attributes: {},
        path: [
          "typography",
          "body",
          "xl",
          "lineHeight"
        ]
      },
      fontSize: {
        value: "18px",
        type: "fontSizes",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 18,
          type: "fontSizes"
        },
        name: "sd-typography-body-xl-font-size",
        attributes: {},
        path: [
          "typography",
          "body",
          "xl",
          "fontSize"
        ]
      },
      letterSpacing: {
        value: "-0.5px",
        type: "letterSpacing",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: -0.5,
          type: "letterSpacing"
        },
        name: "sd-typography-body-xl-letter-spacing",
        attributes: {},
        path: [
          "typography",
          "body",
          "xl",
          "letterSpacing"
        ]
      },
      textDecoration: {
        value: "none",
        type: "textDecoration",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: "none",
          type: "textDecoration"
        },
        name: "sd-typography-body-xl-text-decoration",
        attributes: {},
        path: [
          "typography",
          "body",
          "xl",
          "textDecoration"
        ]
      }
    },
    lg: {
      fontFamily: {
        value: "Brown LL",
        type: "fontFamilies",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: "Brown LL",
          type: "fontFamilies"
        },
        name: "sd-typography-body-lg-font-family",
        attributes: {},
        path: [
          "typography",
          "body",
          "lg",
          "fontFamily"
        ]
      },
      fontWeight: {
        value: "Regular",
        type: "fontWeights",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: "Regular",
          type: "fontWeights"
        },
        name: "sd-typography-body-lg-font-weight",
        attributes: {},
        path: [
          "typography",
          "body",
          "lg",
          "fontWeight"
        ]
      },
      lineHeight: {
        value: "20px",
        type: "lineHeight",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 20,
          type: "lineHeight"
        },
        name: "sd-typography-body-lg-line-height",
        attributes: {},
        path: [
          "typography",
          "body",
          "lg",
          "lineHeight"
        ]
      },
      fontSize: {
        value: "16px",
        type: "fontSizes",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 16,
          type: "fontSizes"
        },
        name: "sd-typography-body-lg-font-size",
        attributes: {},
        path: [
          "typography",
          "body",
          "lg",
          "fontSize"
        ]
      },
      letterSpacing: {
        value: "-0.5px",
        type: "letterSpacing",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: -0.5,
          type: "letterSpacing"
        },
        name: "sd-typography-body-lg-letter-spacing",
        attributes: {},
        path: [
          "typography",
          "body",
          "lg",
          "letterSpacing"
        ]
      },
      textDecoration: {
        value: "none",
        type: "textDecoration",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: "none",
          type: "textDecoration"
        },
        name: "sd-typography-body-lg-text-decoration",
        attributes: {},
        path: [
          "typography",
          "body",
          "lg",
          "textDecoration"
        ]
      }
    },
    md: {
      fontFamily: {
        value: "Brown LL",
        type: "fontFamilies",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: "Brown LL",
          type: "fontFamilies"
        },
        name: "sd-typography-body-md-font-family",
        attributes: {},
        path: [
          "typography",
          "body",
          "md",
          "fontFamily"
        ]
      },
      fontWeight: {
        value: "Regular",
        type: "fontWeights",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: "Regular",
          type: "fontWeights"
        },
        name: "sd-typography-body-md-font-weight",
        attributes: {},
        path: [
          "typography",
          "body",
          "md",
          "fontWeight"
        ]
      },
      lineHeight: {
        value: "18px",
        type: "lineHeight",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 18,
          type: "lineHeight"
        },
        name: "sd-typography-body-md-line-height",
        attributes: {},
        path: [
          "typography",
          "body",
          "md",
          "lineHeight"
        ]
      },
      fontSize: {
        value: "14px",
        type: "fontSizes",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 14,
          type: "fontSizes"
        },
        name: "sd-typography-body-md-font-size",
        attributes: {},
        path: [
          "typography",
          "body",
          "md",
          "fontSize"
        ]
      },
      letterSpacing: {
        value: "-0.25px",
        type: "letterSpacing",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: -0.25,
          type: "letterSpacing"
        },
        name: "sd-typography-body-md-letter-spacing",
        attributes: {},
        path: [
          "typography",
          "body",
          "md",
          "letterSpacing"
        ]
      },
      textDecoration: {
        value: "none",
        type: "textDecoration",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: "none",
          type: "textDecoration"
        },
        name: "sd-typography-body-md-text-decoration",
        attributes: {},
        path: [
          "typography",
          "body",
          "md",
          "textDecoration"
        ]
      }
    },
    sm: {
      fontFamily: {
        value: "Brown LL",
        type: "fontFamilies",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: "Brown LL",
          type: "fontFamilies"
        },
        name: "sd-typography-body-sm-font-family",
        attributes: {},
        path: [
          "typography",
          "body",
          "sm",
          "fontFamily"
        ]
      },
      fontWeight: {
        value: "Regular",
        type: "fontWeights",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: "Regular",
          type: "fontWeights"
        },
        name: "sd-typography-body-sm-font-weight",
        attributes: {},
        path: [
          "typography",
          "body",
          "sm",
          "fontWeight"
        ]
      },
      lineHeight: {
        value: "16px",
        type: "lineHeight",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 16,
          type: "lineHeight"
        },
        name: "sd-typography-body-sm-line-height",
        attributes: {},
        path: [
          "typography",
          "body",
          "sm",
          "lineHeight"
        ]
      },
      fontSize: {
        value: "12px",
        type: "fontSizes",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 12,
          type: "fontSizes"
        },
        name: "sd-typography-body-sm-font-size",
        attributes: {},
        path: [
          "typography",
          "body",
          "sm",
          "fontSize"
        ]
      },
      letterSpacing: {
        value: "-0.25px",
        type: "letterSpacing",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: -0.25,
          type: "letterSpacing"
        },
        name: "sd-typography-body-sm-letter-spacing",
        attributes: {},
        path: [
          "typography",
          "body",
          "sm",
          "letterSpacing"
        ]
      },
      textDecoration: {
        value: "none",
        type: "textDecoration",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: "none",
          type: "textDecoration"
        },
        name: "sd-typography-body-sm-text-decoration",
        attributes: {},
        path: [
          "typography",
          "body",
          "sm",
          "textDecoration"
        ]
      }
    }
  },
  label: {
    lg: {
      fontFamily: {
        value: "Brown LL",
        type: "fontFamilies",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: "Brown LL",
          type: "fontFamilies"
        },
        name: "sd-typography-label-lg-font-family",
        attributes: {},
        path: [
          "typography",
          "label",
          "lg",
          "fontFamily"
        ]
      },
      fontWeight: {
        value: "Medium",
        type: "fontWeights",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: "Medium",
          type: "fontWeights"
        },
        name: "sd-typography-label-lg-font-weight",
        attributes: {},
        path: [
          "typography",
          "label",
          "lg",
          "fontWeight"
        ]
      },
      lineHeight: {
        value: "20px",
        type: "lineHeight",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 20,
          type: "lineHeight"
        },
        name: "sd-typography-label-lg-line-height",
        attributes: {},
        path: [
          "typography",
          "label",
          "lg",
          "lineHeight"
        ]
      },
      fontSize: {
        value: "16px",
        type: "fontSizes",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 16,
          type: "fontSizes"
        },
        name: "sd-typography-label-lg-font-size",
        attributes: {},
        path: [
          "typography",
          "label",
          "lg",
          "fontSize"
        ]
      },
      letterSpacing: {
        value: "-0.5px",
        type: "letterSpacing",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: -0.5,
          type: "letterSpacing"
        },
        name: "sd-typography-label-lg-letter-spacing",
        attributes: {},
        path: [
          "typography",
          "label",
          "lg",
          "letterSpacing"
        ]
      },
      textDecoration: {
        value: "none",
        type: "textDecoration",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: "none",
          type: "textDecoration"
        },
        name: "sd-typography-label-lg-text-decoration",
        attributes: {},
        path: [
          "typography",
          "label",
          "lg",
          "textDecoration"
        ]
      }
    },
    md: {
      fontFamily: {
        value: "Brown LL",
        type: "fontFamilies",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: "Brown LL",
          type: "fontFamilies"
        },
        name: "sd-typography-label-md-font-family",
        attributes: {},
        path: [
          "typography",
          "label",
          "md",
          "fontFamily"
        ]
      },
      fontWeight: {
        value: "Medium",
        type: "fontWeights",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: "Medium",
          type: "fontWeights"
        },
        name: "sd-typography-label-md-font-weight",
        attributes: {},
        path: [
          "typography",
          "label",
          "md",
          "fontWeight"
        ]
      },
      lineHeight: {
        value: "18px",
        type: "lineHeight",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 18,
          type: "lineHeight"
        },
        name: "sd-typography-label-md-line-height",
        attributes: {},
        path: [
          "typography",
          "label",
          "md",
          "lineHeight"
        ]
      },
      fontSize: {
        value: "14px",
        type: "fontSizes",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 14,
          type: "fontSizes"
        },
        name: "sd-typography-label-md-font-size",
        attributes: {},
        path: [
          "typography",
          "label",
          "md",
          "fontSize"
        ]
      },
      letterSpacing: {
        value: "-0.5px",
        type: "letterSpacing",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: -0.5,
          type: "letterSpacing"
        },
        name: "sd-typography-label-md-letter-spacing",
        attributes: {},
        path: [
          "typography",
          "label",
          "md",
          "letterSpacing"
        ]
      },
      textDecoration: {
        value: "none",
        type: "textDecoration",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: "none",
          type: "textDecoration"
        },
        name: "sd-typography-label-md-text-decoration",
        attributes: {},
        path: [
          "typography",
          "label",
          "md",
          "textDecoration"
        ]
      }
    },
    sm: {
      fontFamily: {
        value: "Brown LL",
        type: "fontFamilies",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: "Brown LL",
          type: "fontFamilies"
        },
        name: "sd-typography-label-sm-font-family",
        attributes: {},
        path: [
          "typography",
          "label",
          "sm",
          "fontFamily"
        ]
      },
      fontWeight: {
        value: "Bold",
        type: "fontWeights",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: "Bold",
          type: "fontWeights"
        },
        name: "sd-typography-label-sm-font-weight",
        attributes: {},
        path: [
          "typography",
          "label",
          "sm",
          "fontWeight"
        ]
      },
      lineHeight: {
        value: "16px",
        type: "lineHeight",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 16,
          type: "lineHeight"
        },
        name: "sd-typography-label-sm-line-height",
        attributes: {},
        path: [
          "typography",
          "label",
          "sm",
          "lineHeight"
        ]
      },
      fontSize: {
        value: "12px",
        type: "fontSizes",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 12,
          type: "fontSizes"
        },
        name: "sd-typography-label-sm-font-size",
        attributes: {},
        path: [
          "typography",
          "label",
          "sm",
          "fontSize"
        ]
      },
      letterSpacing: {
        value: "0px",
        type: "letterSpacing",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 0,
          type: "letterSpacing"
        },
        name: "sd-typography-label-sm-letter-spacing",
        attributes: {},
        path: [
          "typography",
          "label",
          "sm",
          "letterSpacing"
        ]
      },
      textDecoration: {
        value: "none",
        type: "textDecoration",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: "none",
          type: "textDecoration"
        },
        name: "sd-typography-label-sm-text-decoration",
        attributes: {},
        path: [
          "typography",
          "label",
          "sm",
          "textDecoration"
        ]
      }
    },
    xs: {
      fontFamily: {
        value: "Brown LL",
        type: "fontFamilies",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: "Brown LL",
          type: "fontFamilies"
        },
        name: "sd-typography-label-xs-font-family",
        attributes: {},
        path: [
          "typography",
          "label",
          "xs",
          "fontFamily"
        ]
      },
      fontWeight: {
        value: "Bold",
        type: "fontWeights",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: "Bold",
          type: "fontWeights"
        },
        name: "sd-typography-label-xs-font-weight",
        attributes: {},
        path: [
          "typography",
          "label",
          "xs",
          "fontWeight"
        ]
      },
      lineHeight: {
        value: "14px",
        type: "lineHeight",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 14,
          type: "lineHeight"
        },
        name: "sd-typography-label-xs-line-height",
        attributes: {},
        path: [
          "typography",
          "label",
          "xs",
          "lineHeight"
        ]
      },
      fontSize: {
        value: "10px",
        type: "fontSizes",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: 10,
          type: "fontSizes"
        },
        name: "sd-typography-label-xs-font-size",
        attributes: {},
        path: [
          "typography",
          "label",
          "xs",
          "fontSize"
        ]
      },
      letterSpacing: {
        value: "-0.25px",
        type: "letterSpacing",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: -0.25,
          type: "letterSpacing"
        },
        name: "sd-typography-label-xs-letter-spacing",
        attributes: {},
        path: [
          "typography",
          "label",
          "xs",
          "letterSpacing"
        ]
      },
      textDecoration: {
        value: "none",
        type: "textDecoration",
        filePath: "themes/videoleap-dark.json",
        isSource: true,
        original: {
          value: "none",
          type: "textDecoration"
        },
        name: "sd-typography-label-xs-text-decoration",
        attributes: {},
        path: [
          "typography",
          "label",
          "xs",
          "textDecoration"
        ]
      }
    }
  }
};
const border$1 = {
  "default": {
    value: {
      color: "#e6e7e914",
      width: 1
    },
    type: "border",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: {
        color: "#e6e7e914",
        width: 1
      },
      type: "border"
    },
    name: "sd-border-default",
    attributes: {},
    path: [
      "border",
      "default"
    ]
  },
  focused: {
    value: {
      color: "#e6e7e9",
      width: 1
    },
    type: "border",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: {
        color: "#e6e7e9",
        width: 1
      },
      type: "border"
    },
    name: "sd-border-focused",
    attributes: {},
    path: [
      "border",
      "focused"
    ]
  },
  selected: {
    value: {
      color: "#ff504e",
      width: 2
    },
    type: "border",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: {
        color: "#ff504e",
        width: 2
      },
      type: "border"
    },
    name: "sd-border-selected",
    attributes: {},
    path: [
      "border",
      "selected"
    ]
  },
  danger: {
    value: {
      color: "#ff453a",
      width: 1
    },
    type: "border",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: {
        color: "#ff453a",
        width: 1
      },
      type: "border"
    },
    name: "sd-border-danger",
    attributes: {},
    path: [
      "border",
      "danger"
    ]
  },
  warning: {
    value: {
      color: "#fad54f",
      width: 1
    },
    type: "border",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: {
        color: "#fad54f",
        width: 1
      },
      type: "border"
    },
    name: "sd-border-warning",
    attributes: {},
    path: [
      "border",
      "warning"
    ]
  },
  success: {
    value: {
      color: "#4ade80",
      width: 1
    },
    type: "border",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: {
        color: "#4ade80",
        width: 1
      },
      type: "border"
    },
    name: "sd-border-success",
    attributes: {},
    path: [
      "border",
      "success"
    ]
  },
  overlay: {
    value: {
      color: "#ffffff1f",
      width: 1
    },
    type: "border",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: {
        color: "#ffffff1f",
        width: 1
      },
      type: "border"
    },
    name: "sd-border-overlay",
    attributes: {},
    path: [
      "border",
      "overlay"
    ]
  }
};
const opacity$1 = {
  "0": {
    value: 0,
    type: "opacity",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 0,
      type: "opacity"
    },
    name: "sd-opacity-0",
    attributes: {},
    path: [
      "opacity",
      "0"
    ]
  },
  "20": {
    value: 0.02,
    type: "opacity",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 0.02,
      type: "opacity"
    },
    name: "sd-opacity-20",
    attributes: {},
    path: [
      "opacity",
      "20"
    ]
  },
  "40": {
    value: 0.04,
    type: "opacity",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 0.04,
      type: "opacity"
    },
    name: "sd-opacity-40",
    attributes: {},
    path: [
      "opacity",
      "40"
    ]
  },
  "60": {
    value: 0.06,
    type: "opacity",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 0.06,
      type: "opacity"
    },
    name: "sd-opacity-60",
    attributes: {},
    path: [
      "opacity",
      "60"
    ]
  },
  "80": {
    value: 0.08,
    type: "opacity",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 0.08,
      type: "opacity"
    },
    name: "sd-opacity-80",
    attributes: {},
    path: [
      "opacity",
      "80"
    ]
  },
  "100": {
    value: 0.1,
    type: "opacity",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 0.1,
      type: "opacity"
    },
    name: "sd-opacity-100",
    attributes: {},
    path: [
      "opacity",
      "100"
    ]
  },
  "120": {
    value: 0.12,
    type: "opacity",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 0.12,
      type: "opacity"
    },
    name: "sd-opacity-120",
    attributes: {},
    path: [
      "opacity",
      "120"
    ]
  },
  "160": {
    value: 0.16,
    type: "opacity",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 0.16,
      type: "opacity"
    },
    name: "sd-opacity-160",
    attributes: {},
    path: [
      "opacity",
      "160"
    ]
  },
  "200": {
    value: 0.2,
    type: "opacity",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 0.2,
      type: "opacity"
    },
    name: "sd-opacity-200",
    attributes: {},
    path: [
      "opacity",
      "200"
    ]
  },
  "250": {
    value: 0.25,
    type: "opacity",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 0.25,
      type: "opacity"
    },
    name: "sd-opacity-250",
    attributes: {},
    path: [
      "opacity",
      "250"
    ]
  },
  "300": {
    value: 0.3,
    type: "opacity",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 0.3,
      type: "opacity"
    },
    name: "sd-opacity-300",
    attributes: {},
    path: [
      "opacity",
      "300"
    ]
  },
  "350": {
    value: 0.35,
    type: "opacity",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 0.35,
      type: "opacity"
    },
    name: "sd-opacity-350",
    attributes: {},
    path: [
      "opacity",
      "350"
    ]
  },
  "400": {
    value: 0.4,
    type: "opacity",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 0.4,
      type: "opacity"
    },
    name: "sd-opacity-400",
    attributes: {},
    path: [
      "opacity",
      "400"
    ]
  },
  "500": {
    value: 0.5,
    type: "opacity",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 0.5,
      type: "opacity"
    },
    name: "sd-opacity-500",
    attributes: {},
    path: [
      "opacity",
      "500"
    ]
  },
  "600": {
    value: 0.6,
    type: "opacity",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 0.6,
      type: "opacity"
    },
    name: "sd-opacity-600",
    attributes: {},
    path: [
      "opacity",
      "600"
    ]
  },
  "700": {
    value: 0.7,
    type: "opacity",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 0.7,
      type: "opacity"
    },
    name: "sd-opacity-700",
    attributes: {},
    path: [
      "opacity",
      "700"
    ]
  },
  "800": {
    value: 0.8,
    type: "opacity",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 0.8,
      type: "opacity"
    },
    name: "sd-opacity-800",
    attributes: {},
    path: [
      "opacity",
      "800"
    ]
  },
  "900": {
    value: 0.9,
    type: "opacity",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 0.9,
      type: "opacity"
    },
    name: "sd-opacity-900",
    attributes: {},
    path: [
      "opacity",
      "900"
    ]
  },
  "1000": {
    value: 1,
    type: "opacity",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 1,
      type: "opacity"
    },
    name: "sd-opacity-1000",
    attributes: {},
    path: [
      "opacity",
      "1000"
    ]
  },
  none: {
    value: 0,
    type: "opacity",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 0,
      type: "opacity"
    },
    name: "sd-opacity-none",
    attributes: {},
    path: [
      "opacity",
      "none"
    ]
  },
  low: {
    value: 0.2,
    type: "opacity",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 0.2,
      type: "opacity"
    },
    name: "sd-opacity-low",
    attributes: {},
    path: [
      "opacity",
      "low"
    ]
  },
  mid: {
    value: 0.5,
    type: "opacity",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 0.5,
      type: "opacity"
    },
    name: "sd-opacity-mid",
    attributes: {},
    path: [
      "opacity",
      "mid"
    ]
  },
  high: {
    value: 0.8,
    type: "opacity",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 0.8,
      type: "opacity"
    },
    name: "sd-opacity-high",
    attributes: {},
    path: [
      "opacity",
      "high"
    ]
  }
};
const space$1 = {
  "0": {
    value: "0px",
    type: "spacing",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 0,
      type: "spacing"
    },
    name: "sd-space-0",
    attributes: {},
    path: [
      "space",
      "0"
    ]
  },
  "25": {
    value: "2px",
    type: "spacing",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 2,
      type: "spacing"
    },
    name: "sd-space-25",
    attributes: {},
    path: [
      "space",
      "25"
    ]
  },
  "50": {
    value: "4px",
    type: "spacing",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 4,
      type: "spacing"
    },
    name: "sd-space-50",
    attributes: {},
    path: [
      "space",
      "50"
    ]
  },
  "75": {
    value: "6px",
    type: "spacing",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 6,
      type: "spacing"
    },
    name: "sd-space-75",
    attributes: {},
    path: [
      "space",
      "75"
    ]
  },
  "100": {
    value: "8px",
    type: "spacing",
    description: "Base size\n",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 8,
      type: "spacing",
      description: "Base size\n"
    },
    name: "sd-space-100",
    attributes: {},
    path: [
      "space",
      "100"
    ]
  },
  "125": {
    value: "10px",
    type: "spacing",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 10,
      type: "spacing"
    },
    name: "sd-space-125",
    attributes: {},
    path: [
      "space",
      "125"
    ]
  },
  "150": {
    value: "12px",
    type: "spacing",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 12,
      type: "spacing"
    },
    name: "sd-space-150",
    attributes: {},
    path: [
      "space",
      "150"
    ]
  },
  "175": {
    value: "14px",
    type: "spacing",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 14,
      type: "spacing"
    },
    name: "sd-space-175",
    attributes: {},
    path: [
      "space",
      "175"
    ]
  },
  "200": {
    value: "16px",
    type: "spacing",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 16,
      type: "spacing"
    },
    name: "sd-space-200",
    attributes: {},
    path: [
      "space",
      "200"
    ]
  },
  "250": {
    value: "20px",
    type: "spacing",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 20,
      type: "spacing"
    },
    name: "sd-space-250",
    attributes: {},
    path: [
      "space",
      "250"
    ]
  },
  "300": {
    value: "24px",
    type: "spacing",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 24,
      type: "spacing"
    },
    name: "sd-space-300",
    attributes: {},
    path: [
      "space",
      "300"
    ]
  },
  "350": {
    value: "28px",
    type: "spacing",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 28,
      type: "spacing"
    },
    name: "sd-space-350",
    attributes: {},
    path: [
      "space",
      "350"
    ]
  },
  "400": {
    value: "32px",
    type: "spacing",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 32,
      type: "spacing"
    },
    name: "sd-space-400",
    attributes: {},
    path: [
      "space",
      "400"
    ]
  },
  "450": {
    value: "36px",
    type: "spacing",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 36,
      type: "spacing"
    },
    name: "sd-space-450",
    attributes: {},
    path: [
      "space",
      "450"
    ]
  },
  "500": {
    value: "40px",
    type: "spacing",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 40,
      type: "spacing"
    },
    name: "sd-space-500",
    attributes: {},
    path: [
      "space",
      "500"
    ]
  },
  "550": {
    value: "44px",
    type: "spacing",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 44,
      type: "spacing"
    },
    name: "sd-space-550",
    attributes: {},
    path: [
      "space",
      "550"
    ]
  },
  "600": {
    value: "48px",
    type: "spacing",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 48,
      type: "spacing"
    },
    name: "sd-space-600",
    attributes: {},
    path: [
      "space",
      "600"
    ]
  },
  "700": {
    value: "56px",
    type: "spacing",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 56,
      type: "spacing"
    },
    name: "sd-space-700",
    attributes: {},
    path: [
      "space",
      "700"
    ]
  },
  "800": {
    value: "64px",
    type: "spacing",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 64,
      type: "spacing"
    },
    name: "sd-space-800",
    attributes: {},
    path: [
      "space",
      "800"
    ]
  },
  "900": {
    value: "72px",
    type: "spacing",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 72,
      type: "spacing"
    },
    name: "sd-space-900",
    attributes: {},
    path: [
      "space",
      "900"
    ]
  },
  "1000": {
    value: "80px",
    type: "spacing",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 80,
      type: "spacing"
    },
    name: "sd-space-1000",
    attributes: {},
    path: [
      "space",
      "1000"
    ]
  },
  "1100": {
    value: "88px",
    type: "spacing",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 88,
      type: "spacing"
    },
    name: "sd-space-1100",
    attributes: {},
    path: [
      "space",
      "1100"
    ]
  },
  "1200": {
    value: "96px",
    type: "spacing",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 96,
      type: "spacing"
    },
    name: "sd-space-1200",
    attributes: {},
    path: [
      "space",
      "1200"
    ]
  },
  "1400": {
    value: "112px",
    type: "spacing",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 112,
      type: "spacing"
    },
    name: "sd-space-1400",
    attributes: {},
    path: [
      "space",
      "1400"
    ]
  },
  "1600": {
    value: "128px",
    type: "spacing",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 128,
      type: "spacing"
    },
    name: "sd-space-1600",
    attributes: {},
    path: [
      "space",
      "1600"
    ]
  },
  "1800": {
    value: "144px",
    type: "spacing",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 144,
      type: "spacing"
    },
    name: "sd-space-1800",
    attributes: {},
    path: [
      "space",
      "1800"
    ]
  },
  margins: {
    xxs: {
      value: "4px",
      type: "spacing",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 4,
        type: "spacing"
      },
      name: "sd-space-margins-xxs",
      attributes: {},
      path: [
        "space",
        "margins",
        "xxs"
      ]
    },
    xs: {
      value: "8px",
      type: "spacing",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 8,
        type: "spacing"
      },
      name: "sd-space-margins-xs",
      attributes: {},
      path: [
        "space",
        "margins",
        "xs"
      ]
    },
    sm: {
      value: "12px",
      type: "spacing",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 12,
        type: "spacing"
      },
      name: "sd-space-margins-sm",
      attributes: {},
      path: [
        "space",
        "margins",
        "sm"
      ]
    },
    md: {
      value: "16px",
      type: "spacing",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 16,
        type: "spacing"
      },
      name: "sd-space-margins-md",
      attributes: {},
      path: [
        "space",
        "margins",
        "md"
      ]
    },
    lg: {
      value: "20px",
      type: "spacing",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 20,
        type: "spacing"
      },
      name: "sd-space-margins-lg",
      attributes: {},
      path: [
        "space",
        "margins",
        "lg"
      ]
    },
    xl: {
      value: "24px",
      type: "spacing",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 24,
        type: "spacing"
      },
      name: "sd-space-margins-xl",
      attributes: {},
      path: [
        "space",
        "margins",
        "xl"
      ]
    },
    xxl: {
      value: "32px",
      type: "spacing",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 32,
        type: "spacing"
      },
      name: "sd-space-margins-xxl",
      attributes: {},
      path: [
        "space",
        "margins",
        "xxl"
      ]
    }
  },
  padding: {
    xs: {
      value: "8px",
      type: "spacing",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 8,
        type: "spacing"
      },
      name: "sd-space-padding-xs",
      attributes: {},
      path: [
        "space",
        "padding",
        "xs"
      ]
    },
    sm: {
      value: "12px",
      type: "spacing",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 12,
        type: "spacing"
      },
      name: "sd-space-padding-sm",
      attributes: {},
      path: [
        "space",
        "padding",
        "sm"
      ]
    },
    md: {
      value: "16px",
      type: "spacing",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 16,
        type: "spacing"
      },
      name: "sd-space-padding-md",
      attributes: {},
      path: [
        "space",
        "padding",
        "md"
      ]
    },
    lg: {
      value: "20px",
      type: "spacing",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 20,
        type: "spacing"
      },
      name: "sd-space-padding-lg",
      attributes: {},
      path: [
        "space",
        "padding",
        "lg"
      ]
    },
    xl: {
      value: "24px",
      type: "spacing",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 24,
        type: "spacing"
      },
      name: "sd-space-padding-xl",
      attributes: {},
      path: [
        "space",
        "padding",
        "xl"
      ]
    },
    xxl: {
      value: "32px",
      type: "spacing",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 32,
        type: "spacing"
      },
      name: "sd-space-padding-xxl",
      attributes: {},
      path: [
        "space",
        "padding",
        "xxl"
      ]
    }
  },
  gap: {
    xs: {
      value: "4px",
      type: "spacing",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 4,
        type: "spacing"
      },
      name: "sd-space-gap-xs",
      attributes: {},
      path: [
        "space",
        "gap",
        "xs"
      ]
    },
    sm: {
      value: "8px",
      type: "spacing",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 8,
        type: "spacing"
      },
      name: "sd-space-gap-sm",
      attributes: {},
      path: [
        "space",
        "gap",
        "sm"
      ]
    },
    md: {
      value: "12px",
      type: "spacing",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 12,
        type: "spacing"
      },
      name: "sd-space-gap-md",
      attributes: {},
      path: [
        "space",
        "gap",
        "md"
      ]
    },
    lg: {
      value: "16px",
      type: "spacing",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 16,
        type: "spacing"
      },
      name: "sd-space-gap-lg",
      attributes: {},
      path: [
        "space",
        "gap",
        "lg"
      ]
    },
    xl: {
      value: "20px",
      type: "spacing",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 20,
        type: "spacing"
      },
      name: "sd-space-gap-xl",
      attributes: {},
      path: [
        "space",
        "gap",
        "xl"
      ]
    },
    xxl: {
      value: "28px",
      type: "spacing",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 28,
        type: "spacing"
      },
      name: "sd-space-gap-xxl",
      attributes: {},
      path: [
        "space",
        "gap",
        "xxl"
      ]
    },
    xxxl: {
      value: "36px",
      type: "spacing",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 36,
        type: "spacing"
      },
      name: "sd-space-gap-xxxl",
      attributes: {},
      path: [
        "space",
        "gap",
        "xxxl"
      ]
    }
  }
};
const old$1 = {
  "large-title": {
    fontFamily: {
      value: "Brown LL",
      type: "fontFamilies",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "Brown LL",
        type: "fontFamilies"
      },
      name: "sd-old-large-title-font-family",
      attributes: {},
      path: [
        "old",
        "large-title",
        "fontFamily"
      ]
    },
    fontWeight: {
      value: "Medium",
      type: "fontWeights",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "Medium",
        type: "fontWeights"
      },
      name: "sd-old-large-title-font-weight",
      attributes: {},
      path: [
        "old",
        "large-title",
        "fontWeight"
      ]
    },
    lineHeight: {
      value: "48px",
      type: "lineHeight",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 48,
        type: "lineHeight"
      },
      name: "sd-old-large-title-line-height",
      attributes: {},
      path: [
        "old",
        "large-title",
        "lineHeight"
      ]
    },
    fontSize: {
      value: "40px",
      type: "fontSizes",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 40,
        type: "fontSizes"
      },
      name: "sd-old-large-title-font-size",
      attributes: {},
      path: [
        "old",
        "large-title",
        "fontSize"
      ]
    },
    letterSpacing: {
      value: "0px",
      type: "letterSpacing",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 0,
        type: "letterSpacing"
      },
      name: "sd-old-large-title-letter-spacing",
      attributes: {},
      path: [
        "old",
        "large-title",
        "letterSpacing"
      ]
    },
    textDecoration: {
      value: "none",
      type: "textDecoration",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "none",
        type: "textDecoration"
      },
      name: "sd-old-large-title-text-decoration",
      attributes: {},
      path: [
        "old",
        "large-title",
        "textDecoration"
      ]
    }
  },
  "title-1": {
    fontFamily: {
      value: "Brown LL",
      type: "fontFamilies",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "Brown LL",
        type: "fontFamilies"
      },
      name: "sd-old-title-1-font-family",
      attributes: {},
      path: [
        "old",
        "title-1",
        "fontFamily"
      ]
    },
    fontWeight: {
      value: "Bold",
      type: "fontWeights",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "Bold",
        type: "fontWeights"
      },
      name: "sd-old-title-1-font-weight",
      attributes: {},
      path: [
        "old",
        "title-1",
        "fontWeight"
      ]
    },
    lineHeight: {
      value: "40px",
      type: "lineHeight",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 40,
        type: "lineHeight"
      },
      name: "sd-old-title-1-line-height",
      attributes: {},
      path: [
        "old",
        "title-1",
        "lineHeight"
      ]
    },
    fontSize: {
      value: "32px",
      type: "fontSizes",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 32,
        type: "fontSizes"
      },
      name: "sd-old-title-1-font-size",
      attributes: {},
      path: [
        "old",
        "title-1",
        "fontSize"
      ]
    },
    letterSpacing: {
      value: "-1px",
      type: "letterSpacing",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: -1,
        type: "letterSpacing"
      },
      name: "sd-old-title-1-letter-spacing",
      attributes: {},
      path: [
        "old",
        "title-1",
        "letterSpacing"
      ]
    },
    textDecoration: {
      value: "none",
      type: "textDecoration",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "none",
        type: "textDecoration"
      },
      name: "sd-old-title-1-text-decoration",
      attributes: {},
      path: [
        "old",
        "title-1",
        "textDecoration"
      ]
    }
  },
  "title-2": {
    fontFamily: {
      value: "Brown LL",
      type: "fontFamilies",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "Brown LL",
        type: "fontFamilies"
      },
      name: "sd-old-title-2-font-family",
      attributes: {},
      path: [
        "old",
        "title-2",
        "fontFamily"
      ]
    },
    fontWeight: {
      value: "Bold",
      type: "fontWeights",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "Bold",
        type: "fontWeights"
      },
      name: "sd-old-title-2-font-weight",
      attributes: {},
      path: [
        "old",
        "title-2",
        "fontWeight"
      ]
    },
    lineHeight: {
      value: "32px",
      type: "lineHeight",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 32,
        type: "lineHeight"
      },
      name: "sd-old-title-2-line-height",
      attributes: {},
      path: [
        "old",
        "title-2",
        "lineHeight"
      ]
    },
    fontSize: {
      value: "24px",
      type: "fontSizes",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 24,
        type: "fontSizes"
      },
      name: "sd-old-title-2-font-size",
      attributes: {},
      path: [
        "old",
        "title-2",
        "fontSize"
      ]
    },
    letterSpacing: {
      value: "-0.75px",
      type: "letterSpacing",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: -0.75,
        type: "letterSpacing"
      },
      name: "sd-old-title-2-letter-spacing",
      attributes: {},
      path: [
        "old",
        "title-2",
        "letterSpacing"
      ]
    },
    textDecoration: {
      value: "none",
      type: "textDecoration",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "none",
        type: "textDecoration"
      },
      name: "sd-old-title-2-text-decoration",
      attributes: {},
      path: [
        "old",
        "title-2",
        "textDecoration"
      ]
    }
  },
  "title-3": {
    fontFamily: {
      value: "Brown LL",
      type: "fontFamilies",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "Brown LL",
        type: "fontFamilies"
      },
      name: "sd-old-title-3-font-family",
      attributes: {},
      path: [
        "old",
        "title-3",
        "fontFamily"
      ]
    },
    fontWeight: {
      value: "Bold",
      type: "fontWeights",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "Bold",
        type: "fontWeights"
      },
      name: "sd-old-title-3-font-weight",
      attributes: {},
      path: [
        "old",
        "title-3",
        "fontWeight"
      ]
    },
    lineHeight: {
      value: "26px",
      type: "lineHeight",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 26,
        type: "lineHeight"
      },
      name: "sd-old-title-3-line-height",
      attributes: {},
      path: [
        "old",
        "title-3",
        "lineHeight"
      ]
    },
    fontSize: {
      value: "20px",
      type: "fontSizes",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 20,
        type: "fontSizes"
      },
      name: "sd-old-title-3-font-size",
      attributes: {},
      path: [
        "old",
        "title-3",
        "fontSize"
      ]
    },
    letterSpacing: {
      value: "-0.25px",
      type: "letterSpacing",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: -0.25,
        type: "letterSpacing"
      },
      name: "sd-old-title-3-letter-spacing",
      attributes: {},
      path: [
        "old",
        "title-3",
        "letterSpacing"
      ]
    },
    textDecoration: {
      value: "none",
      type: "textDecoration",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "none",
        type: "textDecoration"
      },
      name: "sd-old-title-3-text-decoration",
      attributes: {},
      path: [
        "old",
        "title-3",
        "textDecoration"
      ]
    }
  },
  "body-1e": {
    fontFamily: {
      value: "Brown LL",
      type: "fontFamilies",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "Brown LL",
        type: "fontFamilies"
      },
      name: "sd-old-body-1e-font-family",
      attributes: {},
      path: [
        "old",
        "body-1e",
        "fontFamily"
      ]
    },
    fontWeight: {
      value: "Bold",
      type: "fontWeights",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "Bold",
        type: "fontWeights"
      },
      name: "sd-old-body-1e-font-weight",
      attributes: {},
      path: [
        "old",
        "body-1e",
        "fontWeight"
      ]
    },
    lineHeight: {
      value: "24px",
      type: "lineHeight",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 24,
        type: "lineHeight"
      },
      name: "sd-old-body-1e-line-height",
      attributes: {},
      path: [
        "old",
        "body-1e",
        "lineHeight"
      ]
    },
    fontSize: {
      value: "18px",
      type: "fontSizes",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 18,
        type: "fontSizes"
      },
      name: "sd-old-body-1e-font-size",
      attributes: {},
      path: [
        "old",
        "body-1e",
        "fontSize"
      ]
    },
    letterSpacing: {
      value: "-0.5px",
      type: "letterSpacing",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: -0.5,
        type: "letterSpacing"
      },
      name: "sd-old-body-1e-letter-spacing",
      attributes: {},
      path: [
        "old",
        "body-1e",
        "letterSpacing"
      ]
    },
    textDecoration: {
      value: "none",
      type: "textDecoration",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "none",
        type: "textDecoration"
      },
      name: "sd-old-body-1e-text-decoration",
      attributes: {},
      path: [
        "old",
        "body-1e",
        "textDecoration"
      ]
    }
  },
  "body-2e": {
    fontFamily: {
      value: "Brown LL",
      type: "fontFamilies",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "Brown LL",
        type: "fontFamilies"
      },
      name: "sd-old-body-2e-font-family",
      attributes: {},
      path: [
        "old",
        "body-2e",
        "fontFamily"
      ]
    },
    fontWeight: {
      value: "Bold",
      type: "fontWeights",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "Bold",
        type: "fontWeights"
      },
      name: "sd-old-body-2e-font-weight",
      attributes: {},
      path: [
        "old",
        "body-2e",
        "fontWeight"
      ]
    },
    lineHeight: {
      value: "20px",
      type: "lineHeight",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 20,
        type: "lineHeight"
      },
      name: "sd-old-body-2e-line-height",
      attributes: {},
      path: [
        "old",
        "body-2e",
        "lineHeight"
      ]
    },
    fontSize: {
      value: "16px",
      type: "fontSizes",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 16,
        type: "fontSizes"
      },
      name: "sd-old-body-2e-font-size",
      attributes: {},
      path: [
        "old",
        "body-2e",
        "fontSize"
      ]
    },
    letterSpacing: {
      value: "-0.5px",
      type: "letterSpacing",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: -0.5,
        type: "letterSpacing"
      },
      name: "sd-old-body-2e-letter-spacing",
      attributes: {},
      path: [
        "old",
        "body-2e",
        "letterSpacing"
      ]
    },
    textDecoration: {
      value: "none",
      type: "textDecoration",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "none",
        type: "textDecoration"
      },
      name: "sd-old-body-2e-text-decoration",
      attributes: {},
      path: [
        "old",
        "body-2e",
        "textDecoration"
      ]
    }
  },
  "body-3e": {
    fontFamily: {
      value: "Brown LL",
      type: "fontFamilies",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "Brown LL",
        type: "fontFamilies"
      },
      name: "sd-old-body-3e-font-family",
      attributes: {},
      path: [
        "old",
        "body-3e",
        "fontFamily"
      ]
    },
    fontWeight: {
      value: "Bold",
      type: "fontWeights",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "Bold",
        type: "fontWeights"
      },
      name: "sd-old-body-3e-font-weight",
      attributes: {},
      path: [
        "old",
        "body-3e",
        "fontWeight"
      ]
    },
    lineHeight: {
      value: "18px",
      type: "lineHeight",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 18,
        type: "lineHeight"
      },
      name: "sd-old-body-3e-line-height",
      attributes: {},
      path: [
        "old",
        "body-3e",
        "lineHeight"
      ]
    },
    fontSize: {
      value: "14px",
      type: "fontSizes",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 14,
        type: "fontSizes"
      },
      name: "sd-old-body-3e-font-size",
      attributes: {},
      path: [
        "old",
        "body-3e",
        "fontSize"
      ]
    },
    letterSpacing: {
      value: "-0.25px",
      type: "letterSpacing",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: -0.25,
        type: "letterSpacing"
      },
      name: "sd-old-body-3e-letter-spacing",
      attributes: {},
      path: [
        "old",
        "body-3e",
        "letterSpacing"
      ]
    },
    textDecoration: {
      value: "none",
      type: "textDecoration",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "none",
        type: "textDecoration"
      },
      name: "sd-old-body-3e-text-decoration",
      attributes: {},
      path: [
        "old",
        "body-3e",
        "textDecoration"
      ]
    }
  },
  "body-1": {
    fontFamily: {
      value: "Brown LL",
      type: "fontFamilies",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "Brown LL",
        type: "fontFamilies"
      },
      name: "sd-old-body-1-font-family",
      attributes: {},
      path: [
        "old",
        "body-1",
        "fontFamily"
      ]
    },
    fontWeight: {
      value: "Regular",
      type: "fontWeights",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "Regular",
        type: "fontWeights"
      },
      name: "sd-old-body-1-font-weight",
      attributes: {},
      path: [
        "old",
        "body-1",
        "fontWeight"
      ]
    },
    lineHeight: {
      value: "24px",
      type: "lineHeight",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 24,
        type: "lineHeight"
      },
      name: "sd-old-body-1-line-height",
      attributes: {},
      path: [
        "old",
        "body-1",
        "lineHeight"
      ]
    },
    fontSize: {
      value: "18px",
      type: "fontSizes",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 18,
        type: "fontSizes"
      },
      name: "sd-old-body-1-font-size",
      attributes: {},
      path: [
        "old",
        "body-1",
        "fontSize"
      ]
    },
    letterSpacing: {
      value: "-0.5px",
      type: "letterSpacing",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: -0.5,
        type: "letterSpacing"
      },
      name: "sd-old-body-1-letter-spacing",
      attributes: {},
      path: [
        "old",
        "body-1",
        "letterSpacing"
      ]
    },
    textDecoration: {
      value: "none",
      type: "textDecoration",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "none",
        type: "textDecoration"
      },
      name: "sd-old-body-1-text-decoration",
      attributes: {},
      path: [
        "old",
        "body-1",
        "textDecoration"
      ]
    }
  },
  "body-2": {
    fontFamily: {
      value: "Brown LL",
      type: "fontFamilies",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "Brown LL",
        type: "fontFamilies"
      },
      name: "sd-old-body-2-font-family",
      attributes: {},
      path: [
        "old",
        "body-2",
        "fontFamily"
      ]
    },
    fontWeight: {
      value: "Regular",
      type: "fontWeights",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "Regular",
        type: "fontWeights"
      },
      name: "sd-old-body-2-font-weight",
      attributes: {},
      path: [
        "old",
        "body-2",
        "fontWeight"
      ]
    },
    lineHeight: {
      value: "20px",
      type: "lineHeight",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 20,
        type: "lineHeight"
      },
      name: "sd-old-body-2-line-height",
      attributes: {},
      path: [
        "old",
        "body-2",
        "lineHeight"
      ]
    },
    fontSize: {
      value: "16px",
      type: "fontSizes",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 16,
        type: "fontSizes"
      },
      name: "sd-old-body-2-font-size",
      attributes: {},
      path: [
        "old",
        "body-2",
        "fontSize"
      ]
    },
    letterSpacing: {
      value: "-0.5px",
      type: "letterSpacing",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: -0.5,
        type: "letterSpacing"
      },
      name: "sd-old-body-2-letter-spacing",
      attributes: {},
      path: [
        "old",
        "body-2",
        "letterSpacing"
      ]
    },
    textDecoration: {
      value: "none",
      type: "textDecoration",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "none",
        type: "textDecoration"
      },
      name: "sd-old-body-2-text-decoration",
      attributes: {},
      path: [
        "old",
        "body-2",
        "textDecoration"
      ]
    }
  },
  "body-3": {
    fontFamily: {
      value: "Brown LL",
      type: "fontFamilies",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "Brown LL",
        type: "fontFamilies"
      },
      name: "sd-old-body-3-font-family",
      attributes: {},
      path: [
        "old",
        "body-3",
        "fontFamily"
      ]
    },
    fontWeight: {
      value: "Regular",
      type: "fontWeights",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "Regular",
        type: "fontWeights"
      },
      name: "sd-old-body-3-font-weight",
      attributes: {},
      path: [
        "old",
        "body-3",
        "fontWeight"
      ]
    },
    lineHeight: {
      value: "18px",
      type: "lineHeight",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 18,
        type: "lineHeight"
      },
      name: "sd-old-body-3-line-height",
      attributes: {},
      path: [
        "old",
        "body-3",
        "lineHeight"
      ]
    },
    fontSize: {
      value: "14px",
      type: "fontSizes",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 14,
        type: "fontSizes"
      },
      name: "sd-old-body-3-font-size",
      attributes: {},
      path: [
        "old",
        "body-3",
        "fontSize"
      ]
    },
    letterSpacing: {
      value: "-0.25px",
      type: "letterSpacing",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: -0.25,
        type: "letterSpacing"
      },
      name: "sd-old-body-3-letter-spacing",
      attributes: {},
      path: [
        "old",
        "body-3",
        "letterSpacing"
      ]
    },
    textDecoration: {
      value: "none",
      type: "textDecoration",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "none",
        type: "textDecoration"
      },
      name: "sd-old-body-3-text-decoration",
      attributes: {},
      path: [
        "old",
        "body-3",
        "textDecoration"
      ]
    }
  },
  footnote: {
    fontFamily: {
      value: "Brown LL",
      type: "fontFamilies",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "Brown LL",
        type: "fontFamilies"
      },
      name: "sd-old-footnote-font-family",
      attributes: {},
      path: [
        "old",
        "footnote",
        "fontFamily"
      ]
    },
    fontWeight: {
      value: "Regular",
      type: "fontWeights",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "Regular",
        type: "fontWeights"
      },
      name: "sd-old-footnote-font-weight",
      attributes: {},
      path: [
        "old",
        "footnote",
        "fontWeight"
      ]
    },
    lineHeight: {
      value: "16px",
      type: "lineHeight",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 16,
        type: "lineHeight"
      },
      name: "sd-old-footnote-line-height",
      attributes: {},
      path: [
        "old",
        "footnote",
        "lineHeight"
      ]
    },
    fontSize: {
      value: "12px",
      type: "fontSizes",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 12,
        type: "fontSizes"
      },
      name: "sd-old-footnote-font-size",
      attributes: {},
      path: [
        "old",
        "footnote",
        "fontSize"
      ]
    },
    letterSpacing: {
      value: "-0.25px",
      type: "letterSpacing",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: -0.25,
        type: "letterSpacing"
      },
      name: "sd-old-footnote-letter-spacing",
      attributes: {},
      path: [
        "old",
        "footnote",
        "letterSpacing"
      ]
    },
    textDecoration: {
      value: "none",
      type: "textDecoration",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "none",
        type: "textDecoration"
      },
      name: "sd-old-footnote-text-decoration",
      attributes: {},
      path: [
        "old",
        "footnote",
        "textDecoration"
      ]
    }
  },
  "button-1": {
    fontFamily: {
      value: "Brown LL",
      type: "fontFamilies",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "Brown LL",
        type: "fontFamilies"
      },
      name: "sd-old-button-1-font-family",
      attributes: {},
      path: [
        "old",
        "button-1",
        "fontFamily"
      ]
    },
    fontWeight: {
      value: "Medium",
      type: "fontWeights",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "Medium",
        type: "fontWeights"
      },
      name: "sd-old-button-1-font-weight",
      attributes: {},
      path: [
        "old",
        "button-1",
        "fontWeight"
      ]
    },
    lineHeight: {
      value: "20px",
      type: "lineHeight",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 20,
        type: "lineHeight"
      },
      name: "sd-old-button-1-line-height",
      attributes: {},
      path: [
        "old",
        "button-1",
        "lineHeight"
      ]
    },
    fontSize: {
      value: "16px",
      type: "fontSizes",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 16,
        type: "fontSizes"
      },
      name: "sd-old-button-1-font-size",
      attributes: {},
      path: [
        "old",
        "button-1",
        "fontSize"
      ]
    },
    letterSpacing: {
      value: "-0.5px",
      type: "letterSpacing",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: -0.5,
        type: "letterSpacing"
      },
      name: "sd-old-button-1-letter-spacing",
      attributes: {},
      path: [
        "old",
        "button-1",
        "letterSpacing"
      ]
    },
    textDecoration: {
      value: "none",
      type: "textDecoration",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "none",
        type: "textDecoration"
      },
      name: "sd-old-button-1-text-decoration",
      attributes: {},
      path: [
        "old",
        "button-1",
        "textDecoration"
      ]
    }
  },
  "button-2": {
    fontFamily: {
      value: "Brown LL",
      type: "fontFamilies",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "Brown LL",
        type: "fontFamilies"
      },
      name: "sd-old-button-2-font-family",
      attributes: {},
      path: [
        "old",
        "button-2",
        "fontFamily"
      ]
    },
    fontWeight: {
      value: "Medium",
      type: "fontWeights",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "Medium",
        type: "fontWeights"
      },
      name: "sd-old-button-2-font-weight",
      attributes: {},
      path: [
        "old",
        "button-2",
        "fontWeight"
      ]
    },
    lineHeight: {
      value: "18px",
      type: "lineHeight",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 18,
        type: "lineHeight"
      },
      name: "sd-old-button-2-line-height",
      attributes: {},
      path: [
        "old",
        "button-2",
        "lineHeight"
      ]
    },
    fontSize: {
      value: "14px",
      type: "fontSizes",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 14,
        type: "fontSizes"
      },
      name: "sd-old-button-2-font-size",
      attributes: {},
      path: [
        "old",
        "button-2",
        "fontSize"
      ]
    },
    letterSpacing: {
      value: "-0.5px",
      type: "letterSpacing",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: -0.5,
        type: "letterSpacing"
      },
      name: "sd-old-button-2-letter-spacing",
      attributes: {},
      path: [
        "old",
        "button-2",
        "letterSpacing"
      ]
    },
    textDecoration: {
      value: "none",
      type: "textDecoration",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "none",
        type: "textDecoration"
      },
      name: "sd-old-button-2-text-decoration",
      attributes: {},
      path: [
        "old",
        "button-2",
        "textDecoration"
      ]
    }
  },
  "footnote-e": {
    fontFamily: {
      value: "Brown LL",
      type: "fontFamilies",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "Brown LL",
        type: "fontFamilies"
      },
      name: "sd-old-footnote-e-font-family",
      attributes: {},
      path: [
        "old",
        "footnote-e",
        "fontFamily"
      ]
    },
    fontWeight: {
      value: "Bold",
      type: "fontWeights",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "Bold",
        type: "fontWeights"
      },
      name: "sd-old-footnote-e-font-weight",
      attributes: {},
      path: [
        "old",
        "footnote-e",
        "fontWeight"
      ]
    },
    lineHeight: {
      value: "16px",
      type: "lineHeight",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 16,
        type: "lineHeight"
      },
      name: "sd-old-footnote-e-line-height",
      attributes: {},
      path: [
        "old",
        "footnote-e",
        "lineHeight"
      ]
    },
    fontSize: {
      value: "12px",
      type: "fontSizes",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 12,
        type: "fontSizes"
      },
      name: "sd-old-footnote-e-font-size",
      attributes: {},
      path: [
        "old",
        "footnote-e",
        "fontSize"
      ]
    },
    letterSpacing: {
      value: "0px",
      type: "letterSpacing",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 0,
        type: "letterSpacing"
      },
      name: "sd-old-footnote-e-letter-spacing",
      attributes: {},
      path: [
        "old",
        "footnote-e",
        "letterSpacing"
      ]
    },
    textDecoration: {
      value: "none",
      type: "textDecoration",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "none",
        type: "textDecoration"
      },
      name: "sd-old-footnote-e-text-decoration",
      attributes: {},
      path: [
        "old",
        "footnote-e",
        "textDecoration"
      ]
    }
  },
  "caption-3": {
    fontFamily: {
      value: "Brown LL",
      type: "fontFamilies",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "Brown LL",
        type: "fontFamilies"
      },
      name: "sd-old-caption-3-font-family",
      attributes: {},
      path: [
        "old",
        "caption-3",
        "fontFamily"
      ]
    },
    fontWeight: {
      value: "Bold",
      type: "fontWeights",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "Bold",
        type: "fontWeights"
      },
      name: "sd-old-caption-3-font-weight",
      attributes: {},
      path: [
        "old",
        "caption-3",
        "fontWeight"
      ]
    },
    lineHeight: {
      value: "14px",
      type: "lineHeight",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 14,
        type: "lineHeight"
      },
      name: "sd-old-caption-3-line-height",
      attributes: {},
      path: [
        "old",
        "caption-3",
        "lineHeight"
      ]
    },
    fontSize: {
      value: "10px",
      type: "fontSizes",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 10,
        type: "fontSizes"
      },
      name: "sd-old-caption-3-font-size",
      attributes: {},
      path: [
        "old",
        "caption-3",
        "fontSize"
      ]
    },
    letterSpacing: {
      value: "-0.25px",
      type: "letterSpacing",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: -0.25,
        type: "letterSpacing"
      },
      name: "sd-old-caption-3-letter-spacing",
      attributes: {},
      path: [
        "old",
        "caption-3",
        "letterSpacing"
      ]
    },
    textDecoration: {
      value: "none",
      type: "textDecoration",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "none",
        type: "textDecoration"
      },
      name: "sd-old-caption-3-text-decoration",
      attributes: {},
      path: [
        "old",
        "caption-3",
        "textDecoration"
      ]
    }
  }
};
const radius$1 = {
  "100": {
    value: "4px",
    type: "borderRadius",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 4,
      type: "borderRadius"
    },
    name: "sd-radius-100",
    attributes: {},
    path: [
      "radius",
      "100"
    ]
  },
  "200": {
    value: "8px",
    type: "borderRadius",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 8,
      type: "borderRadius"
    },
    name: "sd-radius-200",
    attributes: {},
    path: [
      "radius",
      "200"
    ]
  },
  "300": {
    value: "12px",
    type: "borderRadius",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 12,
      type: "borderRadius"
    },
    name: "sd-radius-300",
    attributes: {},
    path: [
      "radius",
      "300"
    ]
  },
  "400": {
    value: "16px",
    type: "borderRadius",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 16,
      type: "borderRadius"
    },
    name: "sd-radius-400",
    attributes: {},
    path: [
      "radius",
      "400"
    ]
  },
  "500": {
    value: "20px",
    type: "borderRadius",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 20,
      type: "borderRadius"
    },
    name: "sd-radius-500",
    attributes: {},
    path: [
      "radius",
      "500"
    ]
  },
  "600": {
    value: "24px",
    type: "borderRadius",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 24,
      type: "borderRadius"
    },
    name: "sd-radius-600",
    attributes: {},
    path: [
      "radius",
      "600"
    ]
  },
  "700": {
    value: "28px",
    type: "borderRadius",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 28,
      type: "borderRadius"
    },
    name: "sd-radius-700",
    attributes: {},
    path: [
      "radius",
      "700"
    ]
  },
  "800": {
    value: "32px",
    type: "borderRadius",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 32,
      type: "borderRadius"
    },
    name: "sd-radius-800",
    attributes: {},
    path: [
      "radius",
      "800"
    ]
  },
  "900": {
    value: "36px",
    type: "borderRadius",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 36,
      type: "borderRadius"
    },
    name: "sd-radius-900",
    attributes: {},
    path: [
      "radius",
      "900"
    ]
  },
  "1000": {
    value: "40px",
    type: "borderRadius",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 40,
      type: "borderRadius"
    },
    name: "sd-radius-1000",
    attributes: {},
    path: [
      "radius",
      "1000"
    ]
  },
  full: {
    value: "999px",
    type: "borderRadius",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 999,
      type: "borderRadius"
    },
    name: "sd-radius-full",
    attributes: {},
    path: [
      "radius",
      "full"
    ]
  }
};
const stroke$1 = {
  "0": {
    value: "0px",
    type: "borderWidth",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 0,
      type: "borderWidth"
    },
    name: "sd-stroke-0",
    attributes: {},
    path: [
      "stroke",
      "0"
    ]
  },
  "100": {
    value: "1px",
    type: "borderWidth",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 1,
      type: "borderWidth"
    },
    name: "sd-stroke-100",
    attributes: {},
    path: [
      "stroke",
      "100"
    ]
  },
  "200": {
    value: "2px",
    type: "borderWidth",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 2,
      type: "borderWidth"
    },
    name: "sd-stroke-200",
    attributes: {},
    path: [
      "stroke",
      "200"
    ]
  },
  "300": {
    value: "3px",
    type: "borderWidth",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 3,
      type: "borderWidth"
    },
    name: "sd-stroke-300",
    attributes: {},
    path: [
      "stroke",
      "300"
    ]
  }
};
const font$1 = {
  family: {
    main: {
      value: "Brown LL",
      type: "fontFamilies",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "Brown LL",
        type: "fontFamilies"
      },
      name: "sd-font-family-main",
      attributes: {},
      path: [
        "font",
        "family",
        "main"
      ]
    }
  },
  "line-heights": {
    "50": {
      value: "14px",
      type: "lineHeights",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 14,
        type: "lineHeights"
      },
      name: "sd-font-line-heights-50",
      attributes: {},
      path: [
        "font",
        "line-heights",
        "50"
      ]
    },
    "75": {
      value: "16px",
      type: "lineHeights",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 16,
        type: "lineHeights"
      },
      name: "sd-font-line-heights-75",
      attributes: {},
      path: [
        "font",
        "line-heights",
        "75"
      ]
    },
    "100": {
      value: "18px",
      type: "lineHeights",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 18,
        type: "lineHeights"
      },
      name: "sd-font-line-heights-100",
      attributes: {},
      path: [
        "font",
        "line-heights",
        "100"
      ]
    },
    "200": {
      value: "20px",
      type: "lineHeights",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 20,
        type: "lineHeights"
      },
      name: "sd-font-line-heights-200",
      attributes: {},
      path: [
        "font",
        "line-heights",
        "200"
      ]
    },
    "300": {
      value: "24px",
      type: "lineHeights",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 24,
        type: "lineHeights"
      },
      name: "sd-font-line-heights-300",
      attributes: {},
      path: [
        "font",
        "line-heights",
        "300"
      ]
    },
    "400": {
      value: "26px",
      type: "lineHeights",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 26,
        type: "lineHeights"
      },
      name: "sd-font-line-heights-400",
      attributes: {},
      path: [
        "font",
        "line-heights",
        "400"
      ]
    },
    "500": {
      value: "32px",
      type: "lineHeights",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 32,
        type: "lineHeights"
      },
      name: "sd-font-line-heights-500",
      attributes: {},
      path: [
        "font",
        "line-heights",
        "500"
      ]
    },
    "600": {
      value: "36px",
      type: "lineHeights",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 36,
        type: "lineHeights"
      },
      name: "sd-font-line-heights-600",
      attributes: {},
      path: [
        "font",
        "line-heights",
        "600"
      ]
    },
    "700": {
      value: "40px",
      type: "lineHeights",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 40,
        type: "lineHeights"
      },
      name: "sd-font-line-heights-700",
      attributes: {},
      path: [
        "font",
        "line-heights",
        "700"
      ]
    },
    "800": {
      value: "48px",
      type: "lineHeights",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 48,
        type: "lineHeights"
      },
      name: "sd-font-line-heights-800",
      attributes: {},
      path: [
        "font",
        "line-heights",
        "800"
      ]
    },
    "900": {
      value: "64px",
      type: "lineHeights",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 64,
        type: "lineHeights"
      },
      name: "sd-font-line-heights-900",
      attributes: {},
      path: [
        "font",
        "line-heights",
        "900"
      ]
    },
    "1000": {
      value: "72px",
      type: "lineHeights",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 72,
        type: "lineHeights"
      },
      name: "sd-font-line-heights-1000",
      attributes: {},
      path: [
        "font",
        "line-heights",
        "1000"
      ]
    }
  },
  weights: {
    regular: {
      value: "Regular",
      type: "fontWeights",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "Regular",
        type: "fontWeights"
      },
      name: "sd-font-weights-regular",
      attributes: {},
      path: [
        "font",
        "weights",
        "regular"
      ]
    },
    medium: {
      value: "Medium",
      type: "fontWeights",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "Medium",
        type: "fontWeights"
      },
      name: "sd-font-weights-medium",
      attributes: {},
      path: [
        "font",
        "weights",
        "medium"
      ]
    },
    bold: {
      value: "Bold",
      type: "fontWeights",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "Bold",
        type: "fontWeights"
      },
      name: "sd-font-weights-bold",
      attributes: {},
      path: [
        "font",
        "weights",
        "bold"
      ]
    }
  },
  size: {
    "50": {
      value: "10px",
      type: "fontSizes",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 10,
        type: "fontSizes"
      },
      name: "sd-font-size-50",
      attributes: {},
      path: [
        "font",
        "size",
        "50"
      ]
    },
    "75": {
      value: "12px",
      type: "fontSizes",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 12,
        type: "fontSizes"
      },
      name: "sd-font-size-75",
      attributes: {},
      path: [
        "font",
        "size",
        "75"
      ]
    },
    "100": {
      value: "14px",
      type: "fontSizes",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 14,
        type: "fontSizes"
      },
      name: "sd-font-size-100",
      attributes: {},
      path: [
        "font",
        "size",
        "100"
      ]
    },
    "200": {
      value: "16px",
      type: "fontSizes",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 16,
        type: "fontSizes"
      },
      name: "sd-font-size-200",
      attributes: {},
      path: [
        "font",
        "size",
        "200"
      ]
    },
    "300": {
      value: "18px",
      type: "fontSizes",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 18,
        type: "fontSizes"
      },
      name: "sd-font-size-300",
      attributes: {},
      path: [
        "font",
        "size",
        "300"
      ]
    },
    "400": {
      value: "20px",
      type: "fontSizes",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 20,
        type: "fontSizes"
      },
      name: "sd-font-size-400",
      attributes: {},
      path: [
        "font",
        "size",
        "400"
      ]
    },
    "500": {
      value: "24px",
      type: "fontSizes",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 24,
        type: "fontSizes"
      },
      name: "sd-font-size-500",
      attributes: {},
      path: [
        "font",
        "size",
        "500"
      ]
    },
    "600": {
      value: "28px",
      type: "fontSizes",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 28,
        type: "fontSizes"
      },
      name: "sd-font-size-600",
      attributes: {},
      path: [
        "font",
        "size",
        "600"
      ]
    },
    "700": {
      value: "32px",
      type: "fontSizes",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 32,
        type: "fontSizes"
      },
      name: "sd-font-size-700",
      attributes: {},
      path: [
        "font",
        "size",
        "700"
      ]
    },
    "800": {
      value: "40px",
      type: "fontSizes",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 40,
        type: "fontSizes"
      },
      name: "sd-font-size-800",
      attributes: {},
      path: [
        "font",
        "size",
        "800"
      ]
    },
    "900": {
      value: "56px",
      type: "fontSizes",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 56,
        type: "fontSizes"
      },
      name: "sd-font-size-900",
      attributes: {},
      path: [
        "font",
        "size",
        "900"
      ]
    },
    "1000": {
      value: "64px",
      type: "fontSizes",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 64,
        type: "fontSizes"
      },
      name: "sd-font-size-1000",
      attributes: {},
      path: [
        "font",
        "size",
        "1000"
      ]
    }
  },
  tracking: {
    xs: {
      value: "-1px",
      type: "letterSpacing",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: -1,
        type: "letterSpacing"
      },
      name: "sd-font-tracking-xs",
      attributes: {},
      path: [
        "font",
        "tracking",
        "xs"
      ]
    },
    sm: {
      value: "-0.75px",
      type: "letterSpacing",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: -0.75,
        type: "letterSpacing"
      },
      name: "sd-font-tracking-sm",
      attributes: {},
      path: [
        "font",
        "tracking",
        "sm"
      ]
    },
    md: {
      value: "-0.5px",
      type: "letterSpacing",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: -0.5,
        type: "letterSpacing"
      },
      name: "sd-font-tracking-md",
      attributes: {},
      path: [
        "font",
        "tracking",
        "md"
      ]
    },
    lg: {
      value: "-0.25px",
      type: "letterSpacing",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: -0.25,
        type: "letterSpacing"
      },
      name: "sd-font-tracking-lg",
      attributes: {},
      path: [
        "font",
        "tracking",
        "lg"
      ]
    },
    xl: {
      value: "0px",
      type: "letterSpacing",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: 0,
        type: "letterSpacing"
      },
      name: "sd-font-tracking-xl",
      attributes: {},
      path: [
        "font",
        "tracking",
        "xl"
      ]
    }
  },
  "text-decoration": {
    none: {
      value: "none",
      type: "textDecoration",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "none",
        type: "textDecoration"
      },
      name: "sd-font-text-decoration-none",
      attributes: {},
      path: [
        "font",
        "text-decoration",
        "none"
      ]
    }
  },
  "paragraph-indent": {
    "0": {
      value: "0px",
      type: "dimension",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "0px",
        type: "dimension"
      },
      name: "sd-font-paragraph-indent-0",
      attributes: {},
      path: [
        "font",
        "paragraph-indent",
        "0"
      ]
    }
  }
};
const reference$1 = {
  black: {
    value: "rgba(0, 0, 0, 1)",
    type: "color",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: "#000000",
      type: "color"
    },
    name: "sd-reference-black",
    attributes: {},
    path: [
      "reference",
      "black"
    ]
  },
  white: {
    value: "rgba(255, 255, 255, 1)",
    type: "color",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: "#ffffff",
      type: "color"
    },
    name: "sd-reference-white",
    attributes: {},
    path: [
      "reference",
      "white"
    ]
  },
  gray: {
    "100": {
      value: "rgba(243, 244, 246, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#f3f4f6",
        type: "color"
      },
      name: "sd-reference-gray-100",
      attributes: {},
      path: [
        "reference",
        "gray",
        "100"
      ]
    },
    "200": {
      value: "rgba(230, 231, 233, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#e6e7e9",
        type: "color"
      },
      name: "sd-reference-gray-200",
      attributes: {},
      path: [
        "reference",
        "gray",
        "200"
      ]
    },
    "300": {
      value: "rgba(208, 209, 211, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#d0d1d3",
        type: "color"
      },
      name: "sd-reference-gray-300",
      attributes: {},
      path: [
        "reference",
        "gray",
        "300"
      ]
    },
    "400": {
      value: "rgba(163, 166, 172, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#a3a6ac",
        type: "color"
      },
      name: "sd-reference-gray-400",
      attributes: {},
      path: [
        "reference",
        "gray",
        "400"
      ]
    },
    "500": {
      value: "rgba(122, 124, 129, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#7a7c81",
        type: "color"
      },
      name: "sd-reference-gray-500",
      attributes: {},
      path: [
        "reference",
        "gray",
        "500"
      ]
    },
    "600": {
      value: "rgba(83, 85, 90, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#53555a",
        type: "color"
      },
      name: "sd-reference-gray-600",
      attributes: {},
      path: [
        "reference",
        "gray",
        "600"
      ]
    },
    "700": {
      value: "rgba(44, 45, 48, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#2c2d30",
        type: "color"
      },
      name: "sd-reference-gray-700",
      attributes: {},
      path: [
        "reference",
        "gray",
        "700"
      ]
    },
    "800": {
      value: "rgba(34, 35, 37, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#222325",
        type: "color"
      },
      name: "sd-reference-gray-800",
      attributes: {},
      path: [
        "reference",
        "gray",
        "800"
      ]
    },
    "900": {
      value: "rgba(22, 23, 25, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#161719",
        type: "color"
      },
      name: "sd-reference-gray-900",
      attributes: {},
      path: [
        "reference",
        "gray",
        "900"
      ]
    },
    "050": {
      value: "rgba(252, 252, 253, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#fcfcfd",
        type: "color"
      },
      name: "sd-reference-gray-050",
      attributes: {},
      path: [
        "reference",
        "gray",
        "050"
      ]
    }
  },
  blue: {
    "10": {
      value: "rgba(222, 239, 253, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#deeffd",
        type: "color"
      },
      name: "sd-reference-blue-10",
      attributes: {},
      path: [
        "reference",
        "blue",
        "10"
      ]
    },
    "20": {
      value: "rgba(170, 215, 249, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#aad7f9",
        type: "color"
      },
      name: "sd-reference-blue-20",
      attributes: {},
      path: [
        "reference",
        "blue",
        "20"
      ]
    },
    "30": {
      value: "rgba(72, 169, 242, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#48a9f2",
        type: "color"
      },
      name: "sd-reference-blue-30",
      attributes: {},
      path: [
        "reference",
        "blue",
        "30"
      ]
    },
    "40": {
      value: "rgba(43, 155, 240, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#2b9bf0",
        type: "color"
      },
      name: "sd-reference-blue-40",
      attributes: {},
      path: [
        "reference",
        "blue",
        "40"
      ]
    },
    "50": {
      value: "rgba(39, 141, 218, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#278dda",
        type: "color"
      },
      name: "sd-reference-blue-50",
      attributes: {},
      path: [
        "reference",
        "blue",
        "50"
      ]
    },
    "60": {
      value: "rgba(25, 91, 141, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#195b8d",
        type: "color"
      },
      name: "sd-reference-blue-60",
      attributes: {},
      path: [
        "reference",
        "blue",
        "60"
      ]
    },
    "70": {
      value: "rgba(16, 59, 92, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#103b5c",
        type: "color"
      },
      name: "sd-reference-blue-70",
      attributes: {},
      path: [
        "reference",
        "blue",
        "70"
      ]
    }
  },
  Indigo: {
    "10": {
      value: "rgba(227, 230, 253, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#e3e6fd",
        type: "color"
      },
      name: "sd-reference-indigo-10",
      attributes: {},
      path: [
        "reference",
        "Indigo",
        "10"
      ]
    },
    "20": {
      value: "rgba(199, 205, 252, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#c7cdfc",
        type: "color"
      },
      name: "sd-reference-indigo-20",
      attributes: {},
      path: [
        "reference",
        "Indigo",
        "20"
      ]
    },
    "30": {
      value: "rgba(139, 151, 248, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#8b97f8",
        type: "color"
      },
      name: "sd-reference-indigo-30",
      attributes: {},
      path: [
        "reference",
        "Indigo",
        "30"
      ]
    },
    "40": {
      value: "rgba(116, 130, 247, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#7482f7",
        type: "color"
      },
      name: "sd-reference-indigo-40",
      attributes: {},
      path: [
        "reference",
        "Indigo",
        "40"
      ]
    },
    "50": {
      value: "rgba(105, 118, 224, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#6976e0",
        type: "color"
      },
      name: "sd-reference-indigo-50",
      attributes: {},
      path: [
        "reference",
        "Indigo",
        "50"
      ]
    },
    "60": {
      value: "rgba(70, 78, 148, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#464e94",
        type: "color"
      },
      name: "sd-reference-indigo-60",
      attributes: {},
      path: [
        "reference",
        "Indigo",
        "60"
      ]
    },
    "70": {
      value: "rgba(46, 52, 99, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#2e3463",
        type: "color"
      },
      name: "sd-reference-indigo-70",
      attributes: {},
      path: [
        "reference",
        "Indigo",
        "70"
      ]
    }
  },
  purple: {
    "10": {
      value: "rgba(241, 236, 255, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#f1ecff",
        type: "color"
      },
      name: "sd-reference-purple-10",
      attributes: {},
      path: [
        "reference",
        "purple",
        "10"
      ]
    },
    "20": {
      value: "rgba(199, 178, 255, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#c7b2ff",
        type: "color"
      },
      name: "sd-reference-purple-20",
      attributes: {},
      path: [
        "reference",
        "purple",
        "20"
      ]
    },
    "30": {
      value: "rgba(173, 142, 255, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#ad8eff",
        type: "color"
      },
      name: "sd-reference-purple-30",
      attributes: {},
      path: [
        "reference",
        "purple",
        "30"
      ]
    },
    "40": {
      value: "rgba(165, 130, 255, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#a582ff",
        type: "color"
      },
      name: "sd-reference-purple-40",
      attributes: {},
      path: [
        "reference",
        "purple",
        "40"
      ]
    },
    "50": {
      value: "rgba(152, 112, 255, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#9870ff",
        type: "color"
      },
      name: "sd-reference-purple-50",
      attributes: {},
      path: [
        "reference",
        "purple",
        "50"
      ]
    },
    "60": {
      value: "rgba(99, 78, 153, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#634e99",
        type: "color"
      },
      name: "sd-reference-purple-60",
      attributes: {},
      path: [
        "reference",
        "purple",
        "60"
      ]
    },
    "70": {
      value: "rgba(66, 52, 102, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#423466",
        type: "color"
      },
      name: "sd-reference-purple-70",
      attributes: {},
      path: [
        "reference",
        "purple",
        "70"
      ]
    }
  },
  pink: {
    "10": {
      value: "rgba(255, 227, 240, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#ffe3f0",
        type: "color"
      },
      name: "sd-reference-pink-10",
      attributes: {},
      path: [
        "reference",
        "pink",
        "10"
      ]
    },
    "20": {
      value: "rgba(255, 201, 226, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#ffc9e2",
        type: "color"
      },
      name: "sd-reference-pink-20",
      attributes: {},
      path: [
        "reference",
        "pink",
        "20"
      ]
    },
    "30": {
      value: "rgba(255, 139, 192, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#ff8bc0",
        type: "color"
      },
      name: "sd-reference-pink-30",
      attributes: {},
      path: [
        "reference",
        "pink",
        "30"
      ]
    },
    "40": {
      value: "rgba(255, 114, 178, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#ff72b2",
        type: "color"
      },
      name: "sd-reference-pink-40",
      attributes: {},
      path: [
        "reference",
        "pink",
        "40"
      ]
    },
    "50": {
      value: "rgba(227, 102, 159, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#e3669f",
        type: "color"
      },
      name: "sd-reference-pink-50",
      attributes: {},
      path: [
        "reference",
        "pink",
        "50"
      ]
    },
    "60": {
      value: "rgba(153, 68, 107, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#99446b",
        type: "color"
      },
      name: "sd-reference-pink-60",
      attributes: {},
      path: [
        "reference",
        "pink",
        "60"
      ]
    },
    "70": {
      value: "rgba(102, 46, 71, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#662e47",
        type: "color"
      },
      name: "sd-reference-pink-70",
      attributes: {},
      path: [
        "reference",
        "pink",
        "70"
      ]
    }
  },
  red: {
    "10": {
      value: "rgba(255, 238, 237, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#ffeeed",
        type: "color"
      },
      name: "sd-reference-red-10",
      attributes: {},
      path: [
        "reference",
        "red",
        "10"
      ]
    },
    "20": {
      value: "rgba(255, 185, 184, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#ffb9b8",
        type: "color"
      },
      name: "sd-reference-red-20",
      attributes: {},
      path: [
        "reference",
        "red",
        "20"
      ]
    },
    "30": {
      value: "rgba(255, 102, 101, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#ff6665",
        type: "color"
      },
      name: "sd-reference-red-30",
      attributes: {},
      path: [
        "reference",
        "red",
        "30"
      ]
    },
    "40": {
      value: "rgba(255, 80, 78, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#ff504e",
        type: "color"
      },
      name: "sd-reference-red-40",
      attributes: {},
      path: [
        "reference",
        "red",
        "40"
      ]
    },
    "50": {
      value: "rgba(244, 75, 73, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#f44b49",
        type: "color"
      },
      name: "sd-reference-red-50",
      attributes: {},
      path: [
        "reference",
        "red",
        "50"
      ]
    },
    "60": {
      value: "rgba(153, 48, 46, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#99302e",
        type: "color"
      },
      name: "sd-reference-red-60",
      attributes: {},
      path: [
        "reference",
        "red",
        "60"
      ]
    },
    "70": {
      value: "rgba(97, 31, 30, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#611f1e",
        type: "color"
      },
      name: "sd-reference-red-70",
      attributes: {},
      path: [
        "reference",
        "red",
        "70"
      ]
    }
  },
  orange: {
    "10": {
      value: "rgba(255, 220, 196, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#ffdcc4",
        type: "color"
      },
      name: "sd-reference-orange-10",
      attributes: {},
      path: [
        "reference",
        "orange",
        "10"
      ]
    },
    "20": {
      value: "rgba(255, 188, 142, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#ffbc8e",
        type: "color"
      },
      name: "sd-reference-orange-20",
      attributes: {},
      path: [
        "reference",
        "orange",
        "20"
      ]
    },
    "30": {
      value: "rgba(255, 162, 97, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#ffa261",
        type: "color"
      },
      name: "sd-reference-orange-30",
      attributes: {},
      path: [
        "reference",
        "orange",
        "30"
      ]
    },
    "40": {
      value: "rgba(255, 144, 66, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#ff9042",
        type: "color"
      },
      name: "sd-reference-orange-40",
      attributes: {},
      path: [
        "reference",
        "orange",
        "40"
      ]
    },
    "50": {
      value: "rgba(232, 131, 60, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#e8833c",
        type: "color"
      },
      name: "sd-reference-orange-50",
      attributes: {},
      path: [
        "reference",
        "orange",
        "50"
      ]
    },
    "60": {
      value: "rgba(158, 89, 41, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#9e5929",
        type: "color"
      },
      name: "sd-reference-orange-60",
      attributes: {},
      path: [
        "reference",
        "orange",
        "60"
      ]
    },
    "70": {
      value: "rgba(102, 58, 26, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#663a1a",
        type: "color"
      },
      name: "sd-reference-orange-70",
      attributes: {},
      path: [
        "reference",
        "orange",
        "70"
      ]
    }
  },
  yellow: {
    "10": {
      value: "rgba(254, 245, 193, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#fef5c1",
        type: "color"
      },
      name: "sd-reference-yellow-10",
      attributes: {},
      path: [
        "reference",
        "yellow",
        "10"
      ]
    },
    "20": {
      value: "rgba(254, 231, 137, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#fee789",
        type: "color"
      },
      name: "sd-reference-yellow-20",
      attributes: {},
      path: [
        "reference",
        "yellow",
        "20"
      ]
    },
    "30": {
      value: "rgba(250, 213, 79, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#fad54f",
        type: "color"
      },
      name: "sd-reference-yellow-30",
      attributes: {},
      path: [
        "reference",
        "yellow",
        "30"
      ]
    },
    "40": {
      value: "rgba(247, 194, 36, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#f7c224",
        type: "color"
      },
      name: "sd-reference-yellow-40",
      attributes: {},
      path: [
        "reference",
        "yellow",
        "40"
      ]
    },
    "50": {
      value: "rgba(235, 172, 19, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#ebac13",
        type: "color"
      },
      name: "sd-reference-yellow-50",
      attributes: {},
      path: [
        "reference",
        "yellow",
        "50"
      ]
    },
    "60": {
      value: "rgba(203, 133, 9, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#cb8509",
        type: "color"
      },
      name: "sd-reference-yellow-60",
      attributes: {},
      path: [
        "reference",
        "yellow",
        "60"
      ]
    },
    "70": {
      value: "rgba(145, 80, 10, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#91500a",
        type: "color"
      },
      name: "sd-reference-yellow-70",
      attributes: {},
      path: [
        "reference",
        "yellow",
        "70"
      ]
    }
  },
  volt: {
    "10": {
      value: "rgba(241, 255, 212, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#f1ffd4",
        type: "color"
      },
      name: "sd-reference-volt-10",
      attributes: {},
      path: [
        "reference",
        "volt",
        "10"
      ]
    },
    "20": {
      value: "rgba(227, 255, 169, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#e3ffa9",
        type: "color"
      },
      name: "sd-reference-volt-20",
      attributes: {},
      path: [
        "reference",
        "volt",
        "20"
      ]
    },
    "30": {
      value: "rgba(214, 255, 127, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#d6ff7f",
        type: "color"
      },
      name: "sd-reference-volt-30",
      attributes: {},
      path: [
        "reference",
        "volt",
        "30"
      ]
    },
    "40": {
      value: "rgba(186, 255, 41, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#baff29",
        type: "color"
      },
      name: "sd-reference-volt-40",
      attributes: {},
      path: [
        "reference",
        "volt",
        "40"
      ]
    },
    "50": {
      value: "rgba(171, 235, 38, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#abeb26",
        type: "color"
      },
      name: "sd-reference-volt-50",
      attributes: {},
      path: [
        "reference",
        "volt",
        "50"
      ]
    },
    "60": {
      value: "rgba(112, 153, 25, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#709919",
        type: "color"
      },
      name: "sd-reference-volt-60",
      attributes: {},
      path: [
        "reference",
        "volt",
        "60"
      ]
    },
    "70": {
      value: "rgba(74, 102, 16, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#4a6610",
        type: "color"
      },
      name: "sd-reference-volt-70",
      attributes: {},
      path: [
        "reference",
        "volt",
        "70"
      ]
    }
  },
  green: {
    "10": {
      value: "rgba(221, 246, 230, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#ddf6e6",
        type: "color"
      },
      name: "sd-reference-green-10",
      attributes: {},
      path: [
        "reference",
        "green",
        "10"
      ]
    },
    "20": {
      value: "rgba(171, 233, 193, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#abe9c1",
        type: "color"
      },
      name: "sd-reference-green-20",
      attributes: {},
      path: [
        "reference",
        "green",
        "20"
      ]
    },
    "30": {
      value: "rgba(74, 222, 128, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#4ade80",
        type: "color"
      },
      name: "sd-reference-green-30",
      attributes: {},
      path: [
        "reference",
        "green",
        "30"
      ]
    },
    "40": {
      value: "rgba(34, 197, 94, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#22c55e",
        type: "color"
      },
      name: "sd-reference-green-40",
      attributes: {},
      path: [
        "reference",
        "green",
        "40"
      ]
    },
    "50": {
      value: "rgba(22, 163, 74, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#16a34a",
        type: "color"
      },
      name: "sd-reference-green-50",
      attributes: {},
      path: [
        "reference",
        "green",
        "50"
      ]
    },
    "60": {
      value: "rgba(21, 128, 61, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#15803d",
        type: "color"
      },
      name: "sd-reference-green-60",
      attributes: {},
      path: [
        "reference",
        "green",
        "60"
      ]
    },
    "70": {
      value: "rgba(22, 101, 52, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#166534",
        type: "color"
      },
      name: "sd-reference-green-70",
      attributes: {},
      path: [
        "reference",
        "green",
        "70"
      ]
    }
  },
  mint: {
    "10": {
      value: "rgba(220, 247, 242, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#dcf7f2",
        type: "color"
      },
      name: "sd-reference-mint-10",
      attributes: {},
      path: [
        "reference",
        "mint",
        "10"
      ]
    },
    "20": {
      value: "rgba(119, 224, 199, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#77e0c7",
        type: "color"
      },
      name: "sd-reference-mint-20",
      attributes: {},
      path: [
        "reference",
        "mint",
        "20"
      ]
    },
    "30": {
      value: "rgba(59, 210, 165, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#3bd2a5",
        type: "color"
      },
      name: "sd-reference-mint-30",
      attributes: {},
      path: [
        "reference",
        "mint",
        "30"
      ]
    },
    "40": {
      value: "rgba(41, 200, 147, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#29c893",
        type: "color"
      },
      name: "sd-reference-mint-40",
      attributes: {},
      path: [
        "reference",
        "mint",
        "40"
      ]
    },
    "50": {
      value: "rgba(41, 200, 147, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#29c893",
        type: "color"
      },
      name: "sd-reference-mint-50",
      attributes: {},
      path: [
        "reference",
        "mint",
        "50"
      ]
    },
    "60": {
      value: "rgba(16, 119, 88, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#107758",
        type: "color"
      },
      name: "sd-reference-mint-60",
      attributes: {},
      path: [
        "reference",
        "mint",
        "60"
      ]
    },
    "70": {
      value: "rgba(11, 78, 65, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#0b4e41",
        type: "color"
      },
      name: "sd-reference-mint-70",
      attributes: {},
      path: [
        "reference",
        "mint",
        "70"
      ]
    }
  },
  teal: {
    "10": {
      value: "rgba(233, 249, 253, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#e9f9fd",
        type: "color"
      },
      name: "sd-reference-teal-10",
      attributes: {},
      path: [
        "reference",
        "teal",
        "10"
      ]
    },
    "20": {
      value: "rgba(166, 232, 246, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#a6e8f6",
        type: "color"
      },
      name: "sd-reference-teal-20",
      attributes: {},
      path: [
        "reference",
        "teal",
        "20"
      ]
    },
    "30": {
      value: "rgba(82, 210, 238, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#52d2ee",
        type: "color"
      },
      name: "sd-reference-teal-30",
      attributes: {},
      path: [
        "reference",
        "teal",
        "30"
      ]
    },
    "40": {
      value: "rgba(39, 199, 234, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#27c7ea",
        type: "color"
      },
      name: "sd-reference-teal-40",
      attributes: {},
      path: [
        "reference",
        "teal",
        "40"
      ]
    },
    "50": {
      value: "rgba(30, 193, 228, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#1ec1e4",
        type: "color"
      },
      name: "sd-reference-teal-50",
      attributes: {},
      path: [
        "reference",
        "teal",
        "50"
      ]
    },
    "60": {
      value: "rgba(31, 140, 187, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#1f8cbb",
        type: "color"
      },
      name: "sd-reference-teal-60",
      attributes: {},
      path: [
        "reference",
        "teal",
        "60"
      ]
    },
    "70": {
      value: "rgba(46, 74, 99, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#2e4a63",
        type: "color"
      },
      name: "sd-reference-teal-70",
      attributes: {},
      path: [
        "reference",
        "teal",
        "70"
      ]
    }
  },
  danger: {
    "10": {
      value: "rgba(255, 210, 207, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#ffd2cf",
        type: "color"
      },
      name: "sd-reference-danger-10",
      attributes: {},
      path: [
        "reference",
        "danger",
        "10"
      ]
    },
    "20": {
      value: "rgba(255, 116, 107, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#ff746b",
        type: "color"
      },
      name: "sd-reference-danger-20",
      attributes: {},
      path: [
        "reference",
        "danger",
        "20"
      ]
    },
    "30": {
      value: "rgba(255, 75, 65, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#ff4b41",
        type: "color"
      },
      name: "sd-reference-danger-30",
      attributes: {},
      path: [
        "reference",
        "danger",
        "30"
      ]
    },
    "40": {
      value: "rgba(255, 69, 58, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#ff453a",
        type: "color"
      },
      name: "sd-reference-danger-40",
      attributes: {},
      path: [
        "reference",
        "danger",
        "40"
      ]
    },
    "50": {
      value: "rgba(255, 59, 48, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#ff3b30",
        type: "color"
      },
      name: "sd-reference-danger-50",
      attributes: {},
      path: [
        "reference",
        "danger",
        "50"
      ]
    },
    "60": {
      value: "rgba(152, 27, 20, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#981b14",
        type: "color"
      },
      name: "sd-reference-danger-60",
      attributes: {},
      path: [
        "reference",
        "danger",
        "60"
      ]
    },
    "70": {
      value: "rgba(81, 20, 15, 1)",
      type: "color",
      filePath: "themes/videoleap-dark.json",
      isSource: true,
      original: {
        value: "#51140f",
        type: "color"
      },
      name: "sd-reference-danger-70",
      attributes: {},
      path: [
        "reference",
        "danger",
        "70"
      ]
    }
  }
};
const size$1 = {
  "0": {
    value: "0px",
    type: "sizing",
    description: "size",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 0,
      type: "sizing",
      description: "size"
    },
    name: "sd-size-0",
    attributes: {},
    path: [
      "size",
      "0"
    ]
  },
  "25": {
    value: "2px",
    type: "sizing",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 2,
      type: "sizing"
    },
    name: "sd-size-25",
    attributes: {},
    path: [
      "size",
      "25"
    ]
  },
  "50": {
    value: "4px",
    type: "sizing",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 4,
      type: "sizing"
    },
    name: "sd-size-50",
    attributes: {},
    path: [
      "size",
      "50"
    ]
  },
  "75": {
    value: "6px",
    type: "sizing",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 6,
      type: "sizing"
    },
    name: "sd-size-75",
    attributes: {},
    path: [
      "size",
      "75"
    ]
  },
  "100": {
    value: "8px",
    type: "sizing",
    description: "Base size\n",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 8,
      type: "sizing",
      description: "Base size\n"
    },
    name: "sd-size-100",
    attributes: {},
    path: [
      "size",
      "100"
    ]
  },
  "125": {
    value: "10px",
    type: "sizing",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 10,
      type: "sizing"
    },
    name: "sd-size-125",
    attributes: {},
    path: [
      "size",
      "125"
    ]
  },
  "150": {
    value: "12px",
    type: "sizing",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 12,
      type: "sizing"
    },
    name: "sd-size-150",
    attributes: {},
    path: [
      "size",
      "150"
    ]
  },
  "175": {
    value: "14px",
    type: "sizing",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 14,
      type: "sizing"
    },
    name: "sd-size-175",
    attributes: {},
    path: [
      "size",
      "175"
    ]
  },
  "200": {
    value: "16px",
    type: "sizing",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 16,
      type: "sizing"
    },
    name: "sd-size-200",
    attributes: {},
    path: [
      "size",
      "200"
    ]
  },
  "250": {
    value: "20px",
    type: "sizing",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 20,
      type: "sizing"
    },
    name: "sd-size-250",
    attributes: {},
    path: [
      "size",
      "250"
    ]
  },
  "300": {
    value: "24px",
    type: "sizing",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 24,
      type: "sizing"
    },
    name: "sd-size-300",
    attributes: {},
    path: [
      "size",
      "300"
    ]
  },
  "350": {
    value: "28px",
    type: "sizing",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 28,
      type: "sizing"
    },
    name: "sd-size-350",
    attributes: {},
    path: [
      "size",
      "350"
    ]
  },
  "400": {
    value: "32px",
    type: "sizing",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 32,
      type: "sizing"
    },
    name: "sd-size-400",
    attributes: {},
    path: [
      "size",
      "400"
    ]
  },
  "450": {
    value: "36px",
    type: "sizing",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 36,
      type: "sizing"
    },
    name: "sd-size-450",
    attributes: {},
    path: [
      "size",
      "450"
    ]
  },
  "500": {
    value: "40px",
    type: "sizing",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 40,
      type: "sizing"
    },
    name: "sd-size-500",
    attributes: {},
    path: [
      "size",
      "500"
    ]
  },
  "550": {
    value: "44px",
    type: "sizing",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 44,
      type: "sizing"
    },
    name: "sd-size-550",
    attributes: {},
    path: [
      "size",
      "550"
    ]
  },
  "600": {
    value: "48px",
    type: "sizing",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 48,
      type: "sizing"
    },
    name: "sd-size-600",
    attributes: {},
    path: [
      "size",
      "600"
    ]
  },
  "650": {
    value: "52px",
    type: "sizing",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 52,
      type: "sizing"
    },
    name: "sd-size-650",
    attributes: {},
    path: [
      "size",
      "650"
    ]
  },
  "700": {
    value: "56px",
    type: "sizing",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 56,
      type: "sizing"
    },
    name: "sd-size-700",
    attributes: {},
    path: [
      "size",
      "700"
    ]
  },
  "750": {
    value: "60px",
    type: "sizing",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 60,
      type: "sizing"
    },
    name: "sd-size-750",
    attributes: {},
    path: [
      "size",
      "750"
    ]
  },
  "800": {
    value: "64px",
    type: "sizing",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 64,
      type: "sizing"
    },
    name: "sd-size-800",
    attributes: {},
    path: [
      "size",
      "800"
    ]
  },
  "900": {
    value: "72px",
    type: "sizing",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 72,
      type: "sizing"
    },
    name: "sd-size-900",
    attributes: {},
    path: [
      "size",
      "900"
    ]
  },
  "1000": {
    value: "80px",
    type: "sizing",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 80,
      type: "sizing"
    },
    name: "sd-size-1000",
    attributes: {},
    path: [
      "size",
      "1000"
    ]
  },
  "1100": {
    value: "88px",
    type: "sizing",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 88,
      type: "sizing"
    },
    name: "sd-size-1100",
    attributes: {},
    path: [
      "size",
      "1100"
    ]
  },
  "1200": {
    value: "96px",
    type: "sizing",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 96,
      type: "sizing"
    },
    name: "sd-size-1200",
    attributes: {},
    path: [
      "size",
      "1200"
    ]
  },
  "1300": {
    value: "104px",
    type: "sizing",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 104,
      type: "sizing"
    },
    name: "sd-size-1300",
    attributes: {},
    path: [
      "size",
      "1300"
    ]
  },
  "1400": {
    value: "112px",
    type: "sizing",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 112,
      type: "sizing"
    },
    name: "sd-size-1400",
    attributes: {},
    path: [
      "size",
      "1400"
    ]
  },
  "1500": {
    value: "120px",
    type: "sizing",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 120,
      type: "sizing"
    },
    name: "sd-size-1500",
    attributes: {},
    path: [
      "size",
      "1500"
    ]
  },
  "1750": {
    value: "140px",
    type: "sizing",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 140,
      type: "sizing"
    },
    name: "sd-size-1750",
    attributes: {},
    path: [
      "size",
      "1750"
    ]
  },
  "2000": {
    value: "160px",
    type: "sizing",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 160,
      type: "sizing"
    },
    name: "sd-size-2000",
    attributes: {},
    path: [
      "size",
      "2000"
    ]
  },
  "2200": {
    value: "176px",
    type: "sizing",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 176,
      type: "sizing"
    },
    name: "sd-size-2200",
    attributes: {},
    path: [
      "size",
      "2200"
    ]
  },
  "2500": {
    value: "200px",
    type: "sizing",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 200,
      type: "sizing"
    },
    name: "sd-size-2500",
    attributes: {},
    path: [
      "size",
      "2500"
    ]
  },
  "3000": {
    value: "240px",
    type: "sizing",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 240,
      type: "sizing"
    },
    name: "sd-size-3000",
    attributes: {},
    path: [
      "size",
      "3000"
    ]
  },
  "3500": {
    value: "280px",
    type: "sizing",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 280,
      type: "sizing"
    },
    name: "sd-size-3500",
    attributes: {},
    path: [
      "size",
      "3500"
    ]
  },
  "4000": {
    value: "320px",
    type: "sizing",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 320,
      type: "sizing"
    },
    name: "sd-size-4000",
    attributes: {},
    path: [
      "size",
      "4000"
    ]
  },
  "5000": {
    value: "400px",
    type: "sizing",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 400,
      type: "sizing"
    },
    name: "sd-size-5000",
    attributes: {},
    path: [
      "size",
      "5000"
    ]
  },
  "6000": {
    value: "480px",
    type: "sizing",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 480,
      type: "sizing"
    },
    name: "sd-size-6000",
    attributes: {},
    path: [
      "size",
      "6000"
    ]
  },
  "7000": {
    value: "560px",
    type: "sizing",
    filePath: "themes/videoleap-dark.json",
    isSource: true,
    original: {
      value: 560,
      type: "sizing"
    },
    name: "sd-size-7000",
    attributes: {},
    path: [
      "size",
      "7000"
    ]
  }
};
const videoleapDark = {
  semantic: semantic$1,
  button: button$1,
  card: card$1,
  sheet: sheet$1,
  comp: comp$1,
  gradient: gradient$1,
  shadow: shadow$1,
  typography: typography$2,
  border: border$1,
  opacity: opacity$1,
  space: space$1,
  old: old$1,
  radius: radius$1,
  stroke: stroke$1,
  font: font$1,
  reference: reference$1,
  size: size$1
};
const semantic = {
  bg: {
    brand: {
      value: "rgba(244, 75, 73, 1)",
      type: "color",
      description: "lt-sys-color-bg-brand\n\naction, brand, button, primary, app, tint, background",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#f44b49",
        type: "color",
        description: "lt-sys-color-bg-brand\n\naction, brand, button, primary, app, tint, background"
      },
      name: "sd-semantic-bg-brand",
      attributes: {},
      path: [
        "semantic",
        "bg",
        "brand"
      ]
    },
    "brand-secondary": {
      value: "rgba(244, 75, 73, 0.1607843137254902)",
      type: "color",
      description: "lt-sys-color-bg-brand-secondary\n\n\naction, brand, button, primary, app, tint, opacity, background",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#f44b4929",
        type: "color",
        description: "lt-sys-color-bg-brand-secondary\n\n\naction, brand, button, primary, app, tint, opacity, background"
      },
      name: "sd-semantic-bg-brand-secondary",
      attributes: {},
      path: [
        "semantic",
        "bg",
        "brand-secondary"
      ]
    },
    primary: {
      value: "rgba(252, 252, 253, 1)",
      type: "color",
      description: "token = lh-semantic-color-bg-primary\n\nmid, level01, screen, background primary, default",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#fcfcfd",
        type: "color",
        description: "token = lh-semantic-color-bg-primary\n\nmid, level01, screen, background primary, default"
      },
      name: "sd-semantic-bg-primary",
      attributes: {},
      path: [
        "semantic",
        "bg",
        "primary"
      ]
    },
    secondary: {
      value: "rgba(255, 255, 255, 1)",
      type: "color",
      description: "token = lh-semantic-color-bg-secondary\n\ntoolbar, card, surface, level02, background secondary",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#ffffff",
        type: "color",
        description: "token = lh-semantic-color-bg-secondary\n\ntoolbar, card, surface, level02, background secondary"
      },
      name: "sd-semantic-bg-secondary",
      attributes: {},
      path: [
        "semantic",
        "bg",
        "secondary"
      ]
    },
    tertiary: {
      value: "rgba(243, 244, 246, 1)",
      type: "color",
      description: "token = lh-semantic-color-bg-tertiary\n\nbase, canvas, editor, alt, background tertiary",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#f3f4f6",
        type: "color",
        description: "token = lh-semantic-color-bg-tertiary\n\nbase, canvas, editor, alt, background tertiary"
      },
      name: "sd-semantic-bg-tertiary",
      attributes: {},
      path: [
        "semantic",
        "bg",
        "tertiary"
      ]
    },
    alpha: {
      value: "rgba(0, 0, 0, 0.0392156862745098)",
      type: "color",
      description: "token = lh-semantic-color-bg-alpha\n\non-card, plus level, transparent, separator",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#0000000a",
        type: "color",
        description: "token = lh-semantic-color-bg-alpha\n\non-card, plus level, transparent, separator"
      },
      name: "sd-semantic-bg-alpha",
      attributes: {},
      path: [
        "semantic",
        "bg",
        "alpha"
      ]
    },
    "alpha-secondary": {
      value: "rgba(0, 0, 0, 0.4)",
      type: "color",
      description: "token = lh-semantic-color-bg-alpha-secondary\n\nbackdrop, blanket, overlay, drawer, translucent",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#00000066",
        type: "color",
        description: "token = lh-semantic-color-bg-alpha-secondary\n\nbackdrop, blanket, overlay, drawer, translucent"
      },
      name: "sd-semantic-bg-alpha-secondary",
      attributes: {},
      path: [
        "semantic",
        "bg",
        "alpha-secondary"
      ]
    },
    inverse: {
      value: "rgba(22, 23, 25, 1)",
      type: "color",
      description: "token = lh-semantic-color-bg-inverse\n\ninverse, mid, level01, screen, background",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#161719",
        type: "color",
        description: "token = lh-semantic-color-bg-inverse\n\ninverse, mid, level01, screen, background"
      },
      name: "sd-semantic-bg-inverse",
      attributes: {},
      path: [
        "semantic",
        "bg",
        "inverse"
      ]
    },
    neutral: {
      value: "rgba(44, 45, 48, 1)",
      type: "color",
      description: "token = lh-semantic-color-bg-neutral\n\naction, neutral, background, button",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#2c2d30",
        type: "color",
        description: "token = lh-semantic-color-bg-neutral\n\naction, neutral, background, button"
      },
      name: "sd-semantic-bg-neutral",
      attributes: {},
      path: [
        "semantic",
        "bg",
        "neutral"
      ]
    },
    "neutral-secondary": {
      value: "rgba(44, 45, 48, 0.12156862745098039)",
      type: "color",
      description: "token = lh-semantic-color-bg-neutral-secondary\n\naction, neutral, opacity, translucent, background, button",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#2c2d301f",
        type: "color",
        description: "token = lh-semantic-color-bg-neutral-secondary\n\naction, neutral, opacity, translucent, background, button"
      },
      name: "sd-semantic-bg-neutral-secondary",
      attributes: {},
      path: [
        "semantic",
        "bg",
        "neutral-secondary"
      ]
    },
    disabled: {
      value: "rgba(163, 166, 172, 0.5019607843137255)",
      type: "color",
      description: "token = lh-semantic-color-bg-disabled\n\ndisabled, action, button",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#a3a6ac80",
        type: "color",
        description: "token = lh-semantic-color-bg-disabled\n\ndisabled, action, button"
      },
      name: "sd-semantic-bg-disabled",
      attributes: {},
      path: [
        "semantic",
        "bg",
        "disabled"
      ]
    },
    "disabled-secondary": {
      value: "rgba(163, 166, 172, 0.10196078431372549)",
      type: "color",
      description: "token = lh-semantic-color-bg-disabled-secondary\n\ndisabled, action, transparent",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#a3a6ac1a",
        type: "color",
        description: "token = lh-semantic-color-bg-disabled-secondary\n\ndisabled, action, transparent"
      },
      name: "sd-semantic-bg-disabled-secondary",
      attributes: {},
      path: [
        "semantic",
        "bg",
        "disabled-secondary"
      ]
    },
    "neutral-inverse": {
      value: "rgba(230, 231, 233, 1)",
      type: "color",
      description: "token = lh-semantic-color-bg-neutral-inverse\n\naction, neutral, inverse,",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#e6e7e9",
        type: "color",
        description: "token = lh-semantic-color-bg-neutral-inverse\n\naction, neutral, inverse,"
      },
      name: "sd-semantic-bg-neutral-inverse",
      attributes: {},
      path: [
        "semantic",
        "bg",
        "neutral-inverse"
      ]
    },
    "neutral-inverse-secondary": {
      value: "rgba(230, 231, 233, 0.0784313725490196)",
      type: "color",
      description: "lt-sys-color-bg-neutral-inverse-secondary\n\naction, neutral, inverse, opacity, translucent",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#e6e7e914",
        type: "color",
        description: "lt-sys-color-bg-neutral-inverse-secondary\n\naction, neutral, inverse, opacity, translucent"
      },
      name: "sd-semantic-bg-neutral-inverse-secondary",
      attributes: {},
      path: [
        "semantic",
        "bg",
        "neutral-inverse-secondary"
      ]
    },
    danger: {
      value: "rgba(255, 59, 48, 1)",
      type: "color",
      description: "token = lh-semantic-color-bg-danger\n\ndestructive, danger, error, action, delete",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#ff3b30",
        type: "color",
        description: "token = lh-semantic-color-bg-danger\n\ndestructive, danger, error, action, delete"
      },
      name: "sd-semantic-bg-danger",
      attributes: {},
      path: [
        "semantic",
        "bg",
        "danger"
      ]
    },
    "danger-secondary": {
      value: "rgba(255, 59, 48, 0.12156862745098039)",
      type: "color",
      description: "token = lh-semantic-color-bg-danger-secondary\n\ndestructive, danger, error, action, delete, opacity",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#ff3b301f",
        type: "color",
        description: "token = lh-semantic-color-bg-danger-secondary\n\ndestructive, danger, error, action, delete, opacity"
      },
      name: "sd-semantic-bg-danger-secondary",
      attributes: {},
      path: [
        "semantic",
        "bg",
        "danger-secondary"
      ]
    },
    success: {
      value: "rgba(22, 163, 74, 1)",
      type: "color",
      description: "token = lh-semantic-color-bg-success\n\nsuccess, positive, action, approved",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#16a34a",
        type: "color",
        description: "token = lh-semantic-color-bg-success\n\nsuccess, positive, action, approved"
      },
      name: "sd-semantic-bg-success",
      attributes: {},
      path: [
        "semantic",
        "bg",
        "success"
      ]
    },
    "success-secondary": {
      value: "rgba(22, 163, 74, 0.12156862745098039)",
      type: "color",
      description: "token = lh-semantic-color-bg-success-secondary\n\nsuccess, positive, action, approved, opacity",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#16a34a1f",
        type: "color",
        description: "token = lh-semantic-color-bg-success-secondary\n\nsuccess, positive, action, approved, opacity"
      },
      name: "sd-semantic-bg-success-secondary",
      attributes: {},
      path: [
        "semantic",
        "bg",
        "success-secondary"
      ]
    },
    warning: {
      value: "rgba(235, 172, 19, 1)",
      type: "color",
      description: "token = lh-semantic-color-bg-warning\n\nwarning, careful, action, caution",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#ebac13",
        type: "color",
        description: "token = lh-semantic-color-bg-warning\n\nwarning, careful, action, caution"
      },
      name: "sd-semantic-bg-warning",
      attributes: {},
      path: [
        "semantic",
        "bg",
        "warning"
      ]
    },
    "warning-secondary": {
      value: "rgba(235, 172, 19, 0.12156862745098039)",
      type: "color",
      description: "token = lh-semantic-color-bg-warning-secondary\n\nwarning, careful, action, caution",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#ebac131f",
        type: "color",
        description: "token = lh-semantic-color-bg-warning-secondary\n\nwarning, careful, action, caution"
      },
      name: "sd-semantic-bg-warning-secondary",
      attributes: {},
      path: [
        "semantic",
        "bg",
        "warning-secondary"
      ]
    },
    transparent: {
      value: "rgba(255, 255, 255, 0)",
      type: "color",
      description: "token = lh-semantic-color-bg-transparent\n\nconstant, transparent",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#ffffff00",
        type: "color",
        description: "token = lh-semantic-color-bg-transparent\n\nconstant, transparent"
      },
      name: "sd-semantic-bg-transparent",
      attributes: {},
      path: [
        "semantic",
        "bg",
        "transparent"
      ]
    },
    white: {
      value: "rgba(255, 255, 255, 1)",
      type: "color",
      description: "token = lh-semantic-color-bg-white\n\nconstant, white",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#ffffff",
        type: "color",
        description: "token = lh-semantic-color-bg-white\n\nconstant, white"
      },
      name: "sd-semantic-bg-white",
      attributes: {},
      path: [
        "semantic",
        "bg",
        "white"
      ]
    },
    "white-secondary": {
      value: "rgba(255, 255, 255, 0.12156862745098039)",
      type: "color",
      description: "token = lh-semantic-color-bg-white-secondary\n\nconstant, white",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#ffffff1f",
        type: "color",
        description: "token = lh-semantic-color-bg-white-secondary\n\nconstant, white"
      },
      name: "sd-semantic-bg-white-secondary",
      attributes: {},
      path: [
        "semantic",
        "bg",
        "white-secondary"
      ]
    },
    black: {
      value: "rgba(0, 0, 0, 1)",
      type: "color",
      description: "token = lh-semantic-color-bg-black\n\nconstant, black",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#000000",
        type: "color",
        description: "token = lh-semantic-color-bg-black\n\nconstant, black"
      },
      name: "sd-semantic-bg-black",
      attributes: {},
      path: [
        "semantic",
        "bg",
        "black"
      ]
    },
    "black-secondary": {
      value: "rgba(0, 0, 0, 0.30196078431372547)",
      type: "color",
      description: "token = lh-semantic-color-bg-black-secondary\n\nconstant, black",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#0000004d",
        type: "color",
        description: "token = lh-semantic-color-bg-black-secondary\n\nconstant, black"
      },
      name: "sd-semantic-bg-black-secondary",
      attributes: {},
      path: [
        "semantic",
        "bg",
        "black-secondary"
      ]
    }
  },
  fg: {
    brand: {
      value: "rgba(244, 75, 73, 1)",
      type: "color",
      description: "lt-sys-color-fg-brand\n\n\naction, brand, primary, app, contrast, text, icon",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#f44b49",
        type: "color",
        description: "lt-sys-color-fg-brand\n\n\naction, brand, primary, app, contrast, text, icon"
      },
      name: "sd-semantic-fg-brand",
      attributes: {},
      path: [
        "semantic",
        "fg",
        "brand"
      ]
    },
    "brand-secondary": {
      value: "rgba(153, 48, 46, 1)",
      type: "color",
      description: "lt-sys-color-fg-brand-secondary\n\naction, brand, primary, app, contrast, highlight",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#99302e",
        type: "color",
        description: "lt-sys-color-fg-brand-secondary\n\naction, brand, primary, app, contrast, highlight"
      },
      name: "sd-semantic-fg-brand-secondary",
      attributes: {},
      path: [
        "semantic",
        "fg",
        "brand-secondary"
      ]
    },
    primary: {
      value: "rgba(22, 23, 25, 1)",
      type: "color",
      description: "token = lh-semantic-color-fg-primary\n\n\ntitle, headline, main text, matching icon",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#161719",
        type: "color",
        description: "token = lh-semantic-color-fg-primary\n\n\ntitle, headline, main text, matching icon"
      },
      name: "sd-semantic-fg-primary",
      attributes: {},
      path: [
        "semantic",
        "fg",
        "primary"
      ]
    },
    secondary: {
      value: "rgba(122, 124, 129, 1)",
      type: "color",
      description: "token = lh-semantic-color-fg-secondary\n\nbody text, subtitle, matching icons",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#7a7c81",
        type: "color",
        description: "token = lh-semantic-color-fg-secondary\n\nbody text, subtitle, matching icons"
      },
      name: "sd-semantic-fg-secondary",
      attributes: {},
      path: [
        "semantic",
        "fg",
        "secondary"
      ]
    },
    tertiary: {
      value: "rgba(208, 209, 211, 1)",
      type: "color",
      description: "token = lh-semantic-color-fg-tertiary\n\nplaceholder text, muted",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#d0d1d3",
        type: "color",
        description: "token = lh-semantic-color-fg-tertiary\n\nplaceholder text, muted"
      },
      name: "sd-semantic-fg-tertiary",
      attributes: {},
      path: [
        "semantic",
        "fg",
        "tertiary"
      ]
    },
    inverse: {
      value: "rgba(252, 252, 253, 1)",
      type: "color",
      description: "token = lh-semantic-color-fg-inverse\n\ninverse, title, headline, main text, matching icon",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#fcfcfd",
        type: "color",
        description: "token = lh-semantic-color-fg-inverse\n\ninverse, title, headline, main text, matching icon"
      },
      name: "sd-semantic-fg-inverse",
      attributes: {},
      path: [
        "semantic",
        "fg",
        "inverse"
      ]
    },
    "inverse-secondary": {
      value: "rgba(163, 166, 172, 1)",
      type: "color",
      description: "token = lh-semantic-color-fg-inverse-secondary\n\ninverse, body text, subtitle, matching icons",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#a3a6ac",
        type: "color",
        description: "token = lh-semantic-color-fg-inverse-secondary\n\ninverse, body text, subtitle, matching icons"
      },
      name: "sd-semantic-fg-inverse-secondary",
      attributes: {},
      path: [
        "semantic",
        "fg",
        "inverse-secondary"
      ]
    },
    neutral: {
      value: "rgba(44, 45, 48, 1)",
      type: "color",
      description: "token = lh-semantic-color-fg-neutral\n\naction, neutral, icon, text",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#2c2d30",
        type: "color",
        description: "token = lh-semantic-color-fg-neutral\n\naction, neutral, icon, text"
      },
      name: "sd-semantic-fg-neutral",
      attributes: {},
      path: [
        "semantic",
        "fg",
        "neutral"
      ]
    },
    disabled: {
      value: "rgba(163, 166, 172, 0.5019607843137255)",
      type: "color",
      description: "token = lh-semantic-color-fg-disabled\n\ndisabled, action",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#a3a6ac80",
        type: "color",
        description: "token = lh-semantic-color-fg-disabled\n\ndisabled, action"
      },
      name: "sd-semantic-fg-disabled",
      attributes: {},
      path: [
        "semantic",
        "fg",
        "disabled"
      ]
    },
    "neutral-secondary": {
      value: "rgba(230, 231, 233, 1)",
      type: "color",
      description: "token = lh-semantic-color-fg-neutral-secondary\n\naction, neutral, inverse, text, icon",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#e6e7e9",
        type: "color",
        description: "token = lh-semantic-color-fg-neutral-secondary\n\naction, neutral, inverse, text, icon"
      },
      name: "sd-semantic-fg-neutral-secondary",
      attributes: {},
      path: [
        "semantic",
        "fg",
        "neutral-secondary"
      ]
    },
    danger: {
      value: "rgba(255, 59, 48, 1)",
      type: "color",
      description: "token = lh-semantic-color-fg-danger\n\ndestructive, danger, error, action, delete",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#ff3b30",
        type: "color",
        description: "token = lh-semantic-color-fg-danger\n\ndestructive, danger, error, action, delete"
      },
      name: "sd-semantic-fg-danger",
      attributes: {},
      path: [
        "semantic",
        "fg",
        "danger"
      ]
    },
    success: {
      value: "rgba(22, 163, 74, 1)",
      type: "color",
      description: "token = lh-semantic-color-fg-success\n\nsuccess, positive, action, approved",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#16a34a",
        type: "color",
        description: "token = lh-semantic-color-fg-success\n\nsuccess, positive, action, approved"
      },
      name: "sd-semantic-fg-success",
      attributes: {},
      path: [
        "semantic",
        "fg",
        "success"
      ]
    },
    warning: {
      value: "rgba(235, 172, 19, 1)",
      type: "color",
      description: "token = lh-semantic-color-fg-warning\n\nwarning, careful, action, caution",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#ebac13",
        type: "color",
        description: "token = lh-semantic-color-fg-warning\n\nwarning, careful, action, caution"
      },
      name: "sd-semantic-fg-warning",
      attributes: {},
      path: [
        "semantic",
        "fg",
        "warning"
      ]
    },
    white: {
      value: "rgba(255, 255, 255, 1)",
      type: "color",
      description: "token = lh-semantic-color-fg-white\n\nconstant, white, overlay, icon, text",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#ffffff",
        type: "color",
        description: "token = lh-semantic-color-fg-white\n\nconstant, white, overlay, icon, text"
      },
      name: "sd-semantic-fg-white",
      attributes: {},
      path: [
        "semantic",
        "fg",
        "white"
      ]
    },
    black: {
      value: "rgba(22, 23, 25, 1)",
      type: "color",
      description: "token = lh-semantic-color-fg-black\n\nconstant, black, overlay, icon, text",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#161719",
        type: "color",
        description: "token = lh-semantic-color-fg-black\n\nconstant, black, overlay, icon, text"
      },
      name: "sd-semantic-fg-black",
      attributes: {},
      path: [
        "semantic",
        "fg",
        "black"
      ]
    }
  }
};
const button = {
  large: {
    "icon-first": {
      height: {
        value: "48px",
        type: "dimension",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 48,
          type: "dimension"
        },
        name: "sd-button-large-icon-first-height",
        attributes: {},
        path: [
          "button",
          "large",
          "icon-first",
          "height"
        ]
      },
      paddingRight: {
        value: "20px",
        type: "dimension",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 20,
          type: "dimension"
        },
        name: "sd-button-large-icon-first-padding-right",
        attributes: {},
        path: [
          "button",
          "large",
          "icon-first",
          "paddingRight"
        ]
      },
      paddingLeft: {
        value: "12px",
        type: "dimension",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 12,
          type: "dimension"
        },
        name: "sd-button-large-icon-first-padding-left",
        attributes: {},
        path: [
          "button",
          "large",
          "icon-first",
          "paddingLeft"
        ]
      },
      borderRadius: {
        value: "999px",
        type: "borderRadius",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 999,
          type: "borderRadius"
        },
        name: "sd-button-large-icon-first-border-radius",
        attributes: {},
        path: [
          "button",
          "large",
          "icon-first",
          "borderRadius"
        ]
      },
      itemSpacing: {
        value: "8px",
        type: "dimension",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 8,
          type: "dimension"
        },
        name: "sd-button-large-icon-first-item-spacing",
        attributes: {},
        path: [
          "button",
          "large",
          "icon-first",
          "itemSpacing"
        ]
      }
    },
    "label-first": {
      height: {
        value: "48px",
        type: "dimension",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 48,
          type: "dimension"
        },
        name: "sd-button-large-label-first-height",
        attributes: {},
        path: [
          "button",
          "large",
          "label-first",
          "height"
        ]
      },
      paddingRight: {
        value: "12px",
        type: "dimension",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 12,
          type: "dimension"
        },
        name: "sd-button-large-label-first-padding-right",
        attributes: {},
        path: [
          "button",
          "large",
          "label-first",
          "paddingRight"
        ]
      },
      paddingLeft: {
        value: "20px",
        type: "dimension",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 20,
          type: "dimension"
        },
        name: "sd-button-large-label-first-padding-left",
        attributes: {},
        path: [
          "button",
          "large",
          "label-first",
          "paddingLeft"
        ]
      },
      borderRadius: {
        value: "999px",
        type: "borderRadius",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 999,
          type: "borderRadius"
        },
        name: "sd-button-large-label-first-border-radius",
        attributes: {},
        path: [
          "button",
          "large",
          "label-first",
          "borderRadius"
        ]
      },
      itemSpacing: {
        value: "8px",
        type: "dimension",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 8,
          type: "dimension"
        },
        name: "sd-button-large-label-first-item-spacing",
        attributes: {},
        path: [
          "button",
          "large",
          "label-first",
          "itemSpacing"
        ]
      }
    },
    label: {
      height: {
        value: "48px",
        type: "dimension",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 48,
          type: "dimension"
        },
        name: "sd-button-large-label-height",
        attributes: {},
        path: [
          "button",
          "large",
          "label",
          "height"
        ]
      },
      paddingRight: {
        value: "24px",
        type: "dimension",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 24,
          type: "dimension"
        },
        name: "sd-button-large-label-padding-right",
        attributes: {},
        path: [
          "button",
          "large",
          "label",
          "paddingRight"
        ]
      },
      paddingLeft: {
        value: "24px",
        type: "dimension",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 24,
          type: "dimension"
        },
        name: "sd-button-large-label-padding-left",
        attributes: {},
        path: [
          "button",
          "large",
          "label",
          "paddingLeft"
        ]
      },
      borderRadius: {
        value: "999px",
        type: "borderRadius",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 999,
          type: "borderRadius"
        },
        name: "sd-button-large-label-border-radius",
        attributes: {},
        path: [
          "button",
          "large",
          "label",
          "borderRadius"
        ]
      },
      itemSpacing: {
        value: "8px",
        type: "dimension",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 8,
          type: "dimension"
        },
        name: "sd-button-large-label-item-spacing",
        attributes: {},
        path: [
          "button",
          "large",
          "label",
          "itemSpacing"
        ]
      }
    },
    icon: {
      height: {
        value: "48px",
        type: "dimension",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 48,
          type: "dimension"
        },
        name: "sd-button-large-icon-height",
        attributes: {},
        path: [
          "button",
          "large",
          "icon",
          "height"
        ]
      },
      paddingRight: {
        value: "24px",
        type: "dimension",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 24,
          type: "dimension"
        },
        name: "sd-button-large-icon-padding-right",
        attributes: {},
        path: [
          "button",
          "large",
          "icon",
          "paddingRight"
        ]
      },
      paddingLeft: {
        value: "24px",
        type: "dimension",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 24,
          type: "dimension"
        },
        name: "sd-button-large-icon-padding-left",
        attributes: {},
        path: [
          "button",
          "large",
          "icon",
          "paddingLeft"
        ]
      },
      borderRadius: {
        value: "999px",
        type: "borderRadius",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 999,
          type: "borderRadius"
        },
        name: "sd-button-large-icon-border-radius",
        attributes: {},
        path: [
          "button",
          "large",
          "icon",
          "borderRadius"
        ]
      },
      width: {
        value: "48px",
        type: "dimension",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 48,
          type: "dimension"
        },
        name: "sd-button-large-icon-width",
        attributes: {},
        path: [
          "button",
          "large",
          "icon",
          "width"
        ]
      },
      itemSpacing: {
        value: "8px",
        type: "dimension",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 8,
          type: "dimension"
        },
        name: "sd-button-large-icon-item-spacing",
        attributes: {},
        path: [
          "button",
          "large",
          "icon",
          "itemSpacing"
        ]
      }
    }
  },
  medium: {
    "icon-first": {
      height: {
        value: "40px",
        type: "dimension",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 40,
          type: "dimension"
        },
        name: "sd-button-medium-icon-first-height",
        attributes: {},
        path: [
          "button",
          "medium",
          "icon-first",
          "height"
        ]
      },
      paddingRight: {
        value: "16px",
        type: "dimension",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 16,
          type: "dimension"
        },
        name: "sd-button-medium-icon-first-padding-right",
        attributes: {},
        path: [
          "button",
          "medium",
          "icon-first",
          "paddingRight"
        ]
      },
      paddingLeft: {
        value: "8px",
        type: "dimension",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 8,
          type: "dimension"
        },
        name: "sd-button-medium-icon-first-padding-left",
        attributes: {},
        path: [
          "button",
          "medium",
          "icon-first",
          "paddingLeft"
        ]
      },
      borderRadius: {
        value: "999px",
        type: "borderRadius",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 999,
          type: "borderRadius"
        },
        name: "sd-button-medium-icon-first-border-radius",
        attributes: {},
        path: [
          "button",
          "medium",
          "icon-first",
          "borderRadius"
        ]
      },
      itemSpacing: {
        value: "6px",
        type: "dimension",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 6,
          type: "dimension"
        },
        name: "sd-button-medium-icon-first-item-spacing",
        attributes: {},
        path: [
          "button",
          "medium",
          "icon-first",
          "itemSpacing"
        ]
      }
    },
    "label-first": {
      height: {
        value: "40px",
        type: "dimension",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 40,
          type: "dimension"
        },
        name: "sd-button-medium-label-first-height",
        attributes: {},
        path: [
          "button",
          "medium",
          "label-first",
          "height"
        ]
      },
      paddingRight: {
        value: "8px",
        type: "dimension",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 8,
          type: "dimension"
        },
        name: "sd-button-medium-label-first-padding-right",
        attributes: {},
        path: [
          "button",
          "medium",
          "label-first",
          "paddingRight"
        ]
      },
      paddingLeft: {
        value: "16px",
        type: "dimension",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 16,
          type: "dimension"
        },
        name: "sd-button-medium-label-first-padding-left",
        attributes: {},
        path: [
          "button",
          "medium",
          "label-first",
          "paddingLeft"
        ]
      },
      borderRadius: {
        value: "999px",
        type: "borderRadius",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 999,
          type: "borderRadius"
        },
        name: "sd-button-medium-label-first-border-radius",
        attributes: {},
        path: [
          "button",
          "medium",
          "label-first",
          "borderRadius"
        ]
      },
      itemSpacing: {
        value: "6px",
        type: "dimension",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 6,
          type: "dimension"
        },
        name: "sd-button-medium-label-first-item-spacing",
        attributes: {},
        path: [
          "button",
          "medium",
          "label-first",
          "itemSpacing"
        ]
      }
    },
    label: {
      height: {
        value: "40px",
        type: "dimension",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 40,
          type: "dimension"
        },
        name: "sd-button-medium-label-height",
        attributes: {},
        path: [
          "button",
          "medium",
          "label",
          "height"
        ]
      },
      paddingRight: {
        value: "20px",
        type: "dimension",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 20,
          type: "dimension"
        },
        name: "sd-button-medium-label-padding-right",
        attributes: {},
        path: [
          "button",
          "medium",
          "label",
          "paddingRight"
        ]
      },
      paddingLeft: {
        value: "20px",
        type: "dimension",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 20,
          type: "dimension"
        },
        name: "sd-button-medium-label-padding-left",
        attributes: {},
        path: [
          "button",
          "medium",
          "label",
          "paddingLeft"
        ]
      },
      borderRadius: {
        value: "999px",
        type: "borderRadius",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 999,
          type: "borderRadius"
        },
        name: "sd-button-medium-label-border-radius",
        attributes: {},
        path: [
          "button",
          "medium",
          "label",
          "borderRadius"
        ]
      },
      itemSpacing: {
        value: "6px",
        type: "dimension",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 6,
          type: "dimension"
        },
        name: "sd-button-medium-label-item-spacing",
        attributes: {},
        path: [
          "button",
          "medium",
          "label",
          "itemSpacing"
        ]
      }
    },
    icon: {
      height: {
        value: "40px",
        type: "dimension",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 40,
          type: "dimension"
        },
        name: "sd-button-medium-icon-height",
        attributes: {},
        path: [
          "button",
          "medium",
          "icon",
          "height"
        ]
      },
      paddingRight: {
        value: "20px",
        type: "dimension",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 20,
          type: "dimension"
        },
        name: "sd-button-medium-icon-padding-right",
        attributes: {},
        path: [
          "button",
          "medium",
          "icon",
          "paddingRight"
        ]
      },
      paddingLeft: {
        value: "20px",
        type: "dimension",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 20,
          type: "dimension"
        },
        name: "sd-button-medium-icon-padding-left",
        attributes: {},
        path: [
          "button",
          "medium",
          "icon",
          "paddingLeft"
        ]
      },
      borderRadius: {
        value: "999px",
        type: "borderRadius",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 999,
          type: "borderRadius"
        },
        name: "sd-button-medium-icon-border-radius",
        attributes: {},
        path: [
          "button",
          "medium",
          "icon",
          "borderRadius"
        ]
      },
      width: {
        value: "40px",
        type: "dimension",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 40,
          type: "dimension"
        },
        name: "sd-button-medium-icon-width",
        attributes: {},
        path: [
          "button",
          "medium",
          "icon",
          "width"
        ]
      },
      itemSpacing: {
        value: "6px",
        type: "dimension",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 6,
          type: "dimension"
        },
        name: "sd-button-medium-icon-item-spacing",
        attributes: {},
        path: [
          "button",
          "medium",
          "icon",
          "itemSpacing"
        ]
      }
    }
  },
  small: {
    "icon-first": {
      height: {
        value: "32px",
        type: "dimension",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 32,
          type: "dimension"
        },
        name: "sd-button-small-icon-first-height",
        attributes: {},
        path: [
          "button",
          "small",
          "icon-first",
          "height"
        ]
      },
      paddingRight: {
        value: "12px",
        type: "dimension",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 12,
          type: "dimension"
        },
        name: "sd-button-small-icon-first-padding-right",
        attributes: {},
        path: [
          "button",
          "small",
          "icon-first",
          "paddingRight"
        ]
      },
      paddingLeft: {
        value: "6px",
        type: "dimension",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 6,
          type: "dimension"
        },
        name: "sd-button-small-icon-first-padding-left",
        attributes: {},
        path: [
          "button",
          "small",
          "icon-first",
          "paddingLeft"
        ]
      },
      borderRadius: {
        value: "999px",
        type: "borderRadius",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 999,
          type: "borderRadius"
        },
        name: "sd-button-small-icon-first-border-radius",
        attributes: {},
        path: [
          "button",
          "small",
          "icon-first",
          "borderRadius"
        ]
      },
      itemSpacing: {
        value: "4px",
        type: "dimension",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 4,
          type: "dimension"
        },
        name: "sd-button-small-icon-first-item-spacing",
        attributes: {},
        path: [
          "button",
          "small",
          "icon-first",
          "itemSpacing"
        ]
      }
    },
    "label-first": {
      height: {
        value: "32px",
        type: "dimension",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 32,
          type: "dimension"
        },
        name: "sd-button-small-label-first-height",
        attributes: {},
        path: [
          "button",
          "small",
          "label-first",
          "height"
        ]
      },
      paddingRight: {
        value: "6px",
        type: "dimension",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 6,
          type: "dimension"
        },
        name: "sd-button-small-label-first-padding-right",
        attributes: {},
        path: [
          "button",
          "small",
          "label-first",
          "paddingRight"
        ]
      },
      paddingLeft: {
        value: "12px",
        type: "dimension",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 12,
          type: "dimension"
        },
        name: "sd-button-small-label-first-padding-left",
        attributes: {},
        path: [
          "button",
          "small",
          "label-first",
          "paddingLeft"
        ]
      },
      borderRadius: {
        value: "999px",
        type: "borderRadius",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 999,
          type: "borderRadius"
        },
        name: "sd-button-small-label-first-border-radius",
        attributes: {},
        path: [
          "button",
          "small",
          "label-first",
          "borderRadius"
        ]
      },
      itemSpacing: {
        value: "4px",
        type: "dimension",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 4,
          type: "dimension"
        },
        name: "sd-button-small-label-first-item-spacing",
        attributes: {},
        path: [
          "button",
          "small",
          "label-first",
          "itemSpacing"
        ]
      }
    },
    label: {
      height: {
        value: "32px",
        type: "dimension",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 32,
          type: "dimension"
        },
        name: "sd-button-small-label-height",
        attributes: {},
        path: [
          "button",
          "small",
          "label",
          "height"
        ]
      },
      paddingRight: {
        value: "16px",
        type: "dimension",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 16,
          type: "dimension"
        },
        name: "sd-button-small-label-padding-right",
        attributes: {},
        path: [
          "button",
          "small",
          "label",
          "paddingRight"
        ]
      },
      paddingLeft: {
        value: "16px",
        type: "dimension",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 16,
          type: "dimension"
        },
        name: "sd-button-small-label-padding-left",
        attributes: {},
        path: [
          "button",
          "small",
          "label",
          "paddingLeft"
        ]
      },
      borderRadius: {
        value: "999px",
        type: "borderRadius",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 999,
          type: "borderRadius"
        },
        name: "sd-button-small-label-border-radius",
        attributes: {},
        path: [
          "button",
          "small",
          "label",
          "borderRadius"
        ]
      },
      itemSpacing: {
        value: "4px",
        type: "dimension",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 4,
          type: "dimension"
        },
        name: "sd-button-small-label-item-spacing",
        attributes: {},
        path: [
          "button",
          "small",
          "label",
          "itemSpacing"
        ]
      }
    },
    icon: {
      height: {
        value: "32px",
        type: "dimension",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 32,
          type: "dimension"
        },
        name: "sd-button-small-icon-height",
        attributes: {},
        path: [
          "button",
          "small",
          "icon",
          "height"
        ]
      },
      paddingRight: {
        value: "16px",
        type: "dimension",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 16,
          type: "dimension"
        },
        name: "sd-button-small-icon-padding-right",
        attributes: {},
        path: [
          "button",
          "small",
          "icon",
          "paddingRight"
        ]
      },
      paddingLeft: {
        value: "16px",
        type: "dimension",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 16,
          type: "dimension"
        },
        name: "sd-button-small-icon-padding-left",
        attributes: {},
        path: [
          "button",
          "small",
          "icon",
          "paddingLeft"
        ]
      },
      borderRadius: {
        value: "999px",
        type: "borderRadius",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 999,
          type: "borderRadius"
        },
        name: "sd-button-small-icon-border-radius",
        attributes: {},
        path: [
          "button",
          "small",
          "icon",
          "borderRadius"
        ]
      },
      width: {
        value: "32px",
        type: "dimension",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 32,
          type: "dimension"
        },
        name: "sd-button-small-icon-width",
        attributes: {},
        path: [
          "button",
          "small",
          "icon",
          "width"
        ]
      },
      itemSpacing: {
        value: "4px",
        type: "dimension",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 4,
          type: "dimension"
        },
        name: "sd-button-small-icon-item-spacing",
        attributes: {},
        path: [
          "button",
          "small",
          "icon",
          "itemSpacing"
        ]
      }
    }
  },
  height: {
    sm: {
      value: "32px",
      type: "sizing",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 32,
        type: "sizing"
      },
      name: "sd-button-height-sm",
      attributes: {},
      path: [
        "button",
        "height",
        "sm"
      ]
    },
    md: {
      value: "40px",
      type: "sizing",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 40,
        type: "sizing"
      },
      name: "sd-button-height-md",
      attributes: {},
      path: [
        "button",
        "height",
        "md"
      ]
    },
    lg: {
      value: "48px",
      type: "sizing",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 48,
        type: "sizing"
      },
      name: "sd-button-height-lg",
      attributes: {},
      path: [
        "button",
        "height",
        "lg"
      ]
    }
  },
  space: {
    large: {
      min: {
        value: "12px",
        type: "spacing",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 12,
          type: "spacing"
        },
        name: "sd-button-space-large-min",
        attributes: {},
        path: [
          "button",
          "space",
          "large",
          "min"
        ]
      },
      max: {
        value: "20px",
        type: "spacing",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 20,
          type: "spacing"
        },
        name: "sd-button-space-large-max",
        attributes: {},
        path: [
          "button",
          "space",
          "large",
          "max"
        ]
      },
      "default": {
        value: "24px",
        type: "spacing",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 24,
          type: "spacing"
        },
        name: "sd-button-space-large-default",
        attributes: {},
        path: [
          "button",
          "space",
          "large",
          "default"
        ]
      },
      gap: {
        value: "8px",
        type: "spacing",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 8,
          type: "spacing"
        },
        name: "sd-button-space-large-gap",
        attributes: {},
        path: [
          "button",
          "space",
          "large",
          "gap"
        ]
      }
    },
    medium: {
      min: {
        value: "8px",
        type: "spacing",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 8,
          type: "spacing"
        },
        name: "sd-button-space-medium-min",
        attributes: {},
        path: [
          "button",
          "space",
          "medium",
          "min"
        ]
      },
      max: {
        value: "16px",
        type: "spacing",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 16,
          type: "spacing"
        },
        name: "sd-button-space-medium-max",
        attributes: {},
        path: [
          "button",
          "space",
          "medium",
          "max"
        ]
      },
      "default": {
        value: "20px",
        type: "spacing",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 20,
          type: "spacing"
        },
        name: "sd-button-space-medium-default",
        attributes: {},
        path: [
          "button",
          "space",
          "medium",
          "default"
        ]
      },
      gap: {
        value: "6px",
        type: "spacing",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 6,
          type: "spacing"
        },
        name: "sd-button-space-medium-gap",
        attributes: {},
        path: [
          "button",
          "space",
          "medium",
          "gap"
        ]
      }
    },
    small: {
      min: {
        value: "6px",
        type: "spacing",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 6,
          type: "spacing"
        },
        name: "sd-button-space-small-min",
        attributes: {},
        path: [
          "button",
          "space",
          "small",
          "min"
        ]
      },
      max: {
        value: "12px",
        type: "spacing",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 12,
          type: "spacing"
        },
        name: "sd-button-space-small-max",
        attributes: {},
        path: [
          "button",
          "space",
          "small",
          "max"
        ]
      },
      "default": {
        value: "16px",
        type: "spacing",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 16,
          type: "spacing"
        },
        name: "sd-button-space-small-default",
        attributes: {},
        path: [
          "button",
          "space",
          "small",
          "default"
        ]
      },
      gap: {
        value: "4px",
        type: "spacing",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 4,
          type: "spacing"
        },
        name: "sd-button-space-small-gap",
        attributes: {},
        path: [
          "button",
          "space",
          "small",
          "gap"
        ]
      }
    }
  },
  radius: {
    value: "999px",
    type: "borderRadius",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 999,
      type: "borderRadius"
    },
    name: "sd-button-radius",
    attributes: {},
    path: [
      "button",
      "radius"
    ]
  }
};
const card = {
  small: {
    verticalPadding: {
      value: "8px",
      type: "dimension",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 8,
        type: "dimension"
      },
      name: "sd-card-small-vertical-padding",
      attributes: {},
      path: [
        "card",
        "small",
        "verticalPadding"
      ]
    },
    horizontalPadding: {
      value: "8px",
      type: "dimension",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 8,
        type: "dimension"
      },
      name: "sd-card-small-horizontal-padding",
      attributes: {},
      path: [
        "card",
        "small",
        "horizontalPadding"
      ]
    },
    borderRadius: {
      value: "24px",
      type: "borderRadius",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 24,
        type: "borderRadius"
      },
      name: "sd-card-small-border-radius",
      attributes: {},
      path: [
        "card",
        "small",
        "borderRadius"
      ]
    },
    boxShadow: {
      "0": {
        color: {
          value: "rgba(14, 21, 38, 0.0784313725490196)",
          type: "color",
          filePath: "themes/videoleap-light.json",
          isSource: true,
          original: {
            value: "#0e152614",
            type: "color"
          },
          name: "sd-card-small-box-shadow-0-color",
          attributes: {},
          path: [
            "card",
            "small",
            "boxShadow",
            "0",
            "color"
          ]
        },
        type: {
          value: "dropShadow",
          type: "type",
          filePath: "themes/videoleap-light.json",
          isSource: true,
          original: {
            value: "dropShadow",
            type: "type"
          },
          name: "sd-card-small-box-shadow-0-type",
          attributes: {},
          path: [
            "card",
            "small",
            "boxShadow",
            "0",
            "type"
          ]
        },
        x: {
          value: "0px",
          type: "x",
          filePath: "themes/videoleap-light.json",
          isSource: true,
          original: {
            value: 0,
            type: "x"
          },
          name: "sd-card-small-box-shadow-0-x",
          attributes: {},
          path: [
            "card",
            "small",
            "boxShadow",
            "0",
            "x"
          ]
        },
        y: {
          value: "0px",
          type: "y",
          filePath: "themes/videoleap-light.json",
          isSource: true,
          original: {
            value: 0,
            type: "y"
          },
          name: "sd-card-small-box-shadow-0-y",
          attributes: {},
          path: [
            "card",
            "small",
            "boxShadow",
            "0",
            "y"
          ]
        },
        blur: {
          value: "1px",
          type: "blur",
          filePath: "themes/videoleap-light.json",
          isSource: true,
          original: {
            value: 1,
            type: "blur"
          },
          name: "sd-card-small-box-shadow-0-blur",
          attributes: {},
          path: [
            "card",
            "small",
            "boxShadow",
            "0",
            "blur"
          ]
        },
        spread: {
          value: "0px",
          type: "spread",
          filePath: "themes/videoleap-light.json",
          isSource: true,
          original: {
            value: 0,
            type: "spread"
          },
          name: "sd-card-small-box-shadow-0-spread",
          attributes: {},
          path: [
            "card",
            "small",
            "boxShadow",
            "0",
            "spread"
          ]
        }
      },
      "1": {
        color: {
          value: "rgba(14, 21, 38, 0.058823529411764705)",
          type: "color",
          filePath: "themes/videoleap-light.json",
          isSource: true,
          original: {
            value: "#0e15260f",
            type: "color"
          },
          name: "sd-card-small-box-shadow-1-color",
          attributes: {},
          path: [
            "card",
            "small",
            "boxShadow",
            "1",
            "color"
          ]
        },
        type: {
          value: "dropShadow",
          type: "type",
          filePath: "themes/videoleap-light.json",
          isSource: true,
          original: {
            value: "dropShadow",
            type: "type"
          },
          name: "sd-card-small-box-shadow-1-type",
          attributes: {},
          path: [
            "card",
            "small",
            "boxShadow",
            "1",
            "type"
          ]
        },
        x: {
          value: "0px",
          type: "x",
          filePath: "themes/videoleap-light.json",
          isSource: true,
          original: {
            value: 0,
            type: "x"
          },
          name: "sd-card-small-box-shadow-1-x",
          attributes: {},
          path: [
            "card",
            "small",
            "boxShadow",
            "1",
            "x"
          ]
        },
        y: {
          value: "2px",
          type: "y",
          filePath: "themes/videoleap-light.json",
          isSource: true,
          original: {
            value: 2,
            type: "y"
          },
          name: "sd-card-small-box-shadow-1-y",
          attributes: {},
          path: [
            "card",
            "small",
            "boxShadow",
            "1",
            "y"
          ]
        },
        blur: {
          value: "32px",
          type: "blur",
          filePath: "themes/videoleap-light.json",
          isSource: true,
          original: {
            value: 32,
            type: "blur"
          },
          name: "sd-card-small-box-shadow-1-blur",
          attributes: {},
          path: [
            "card",
            "small",
            "boxShadow",
            "1",
            "blur"
          ]
        },
        spread: {
          value: "0px",
          type: "spread",
          filePath: "themes/videoleap-light.json",
          isSource: true,
          original: {
            value: 0,
            type: "spread"
          },
          name: "sd-card-small-box-shadow-1-spread",
          attributes: {},
          path: [
            "card",
            "small",
            "boxShadow",
            "1",
            "spread"
          ]
        }
      }
    },
    fill: {
      value: "#ffffff",
      type: "fill",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#ffffff",
        type: "fill"
      },
      name: "sd-card-small-fill",
      attributes: {},
      path: [
        "card",
        "small",
        "fill"
      ]
    }
  },
  medium: {
    verticalPadding: {
      value: "12px",
      type: "dimension",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 12,
        type: "dimension"
      },
      name: "sd-card-medium-vertical-padding",
      attributes: {},
      path: [
        "card",
        "medium",
        "verticalPadding"
      ]
    },
    horizontalPadding: {
      value: "12px",
      type: "dimension",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 12,
        type: "dimension"
      },
      name: "sd-card-medium-horizontal-padding",
      attributes: {},
      path: [
        "card",
        "medium",
        "horizontalPadding"
      ]
    },
    borderRadius: {
      value: "32px",
      type: "borderRadius",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 32,
        type: "borderRadius"
      },
      name: "sd-card-medium-border-radius",
      attributes: {},
      path: [
        "card",
        "medium",
        "borderRadius"
      ]
    },
    boxShadow: {
      "0": {
        color: {
          value: "rgba(24, 39, 75, 0.1607843137254902)",
          type: "color",
          filePath: "themes/videoleap-light.json",
          isSource: true,
          original: {
            value: "#18274b29",
            type: "color"
          },
          name: "sd-card-medium-box-shadow-0-color",
          attributes: {},
          path: [
            "card",
            "medium",
            "boxShadow",
            "0",
            "color"
          ]
        },
        type: {
          value: "dropShadow",
          type: "type",
          filePath: "themes/videoleap-light.json",
          isSource: true,
          original: {
            value: "dropShadow",
            type: "type"
          },
          name: "sd-card-medium-box-shadow-0-type",
          attributes: {},
          path: [
            "card",
            "medium",
            "boxShadow",
            "0",
            "type"
          ]
        },
        x: {
          value: "0px",
          type: "x",
          filePath: "themes/videoleap-light.json",
          isSource: true,
          original: {
            value: 0,
            type: "x"
          },
          name: "sd-card-medium-box-shadow-0-x",
          attributes: {},
          path: [
            "card",
            "medium",
            "boxShadow",
            "0",
            "x"
          ]
        },
        y: {
          value: "18px",
          type: "y",
          filePath: "themes/videoleap-light.json",
          isSource: true,
          original: {
            value: 18,
            type: "y"
          },
          name: "sd-card-medium-box-shadow-0-y",
          attributes: {},
          path: [
            "card",
            "medium",
            "boxShadow",
            "0",
            "y"
          ]
        },
        blur: {
          value: "64px",
          type: "blur",
          filePath: "themes/videoleap-light.json",
          isSource: true,
          original: {
            value: 64,
            type: "blur"
          },
          name: "sd-card-medium-box-shadow-0-blur",
          attributes: {},
          path: [
            "card",
            "medium",
            "boxShadow",
            "0",
            "blur"
          ]
        },
        spread: {
          value: "-4px",
          type: "spread",
          filePath: "themes/videoleap-light.json",
          isSource: true,
          original: {
            value: -4,
            type: "spread"
          },
          name: "sd-card-medium-box-shadow-0-spread",
          attributes: {},
          path: [
            "card",
            "medium",
            "boxShadow",
            "0",
            "spread"
          ]
        }
      },
      "1": {
        color: {
          value: "rgba(24, 39, 75, 0.12156862745098039)",
          type: "color",
          filePath: "themes/videoleap-light.json",
          isSource: true,
          original: {
            value: "#18274b1f",
            type: "color"
          },
          name: "sd-card-medium-box-shadow-1-color",
          attributes: {},
          path: [
            "card",
            "medium",
            "boxShadow",
            "1",
            "color"
          ]
        },
        type: {
          value: "dropShadow",
          type: "type",
          filePath: "themes/videoleap-light.json",
          isSource: true,
          original: {
            value: "dropShadow",
            type: "type"
          },
          name: "sd-card-medium-box-shadow-1-type",
          attributes: {},
          path: [
            "card",
            "medium",
            "boxShadow",
            "1",
            "type"
          ]
        },
        x: {
          value: "0px",
          type: "x",
          filePath: "themes/videoleap-light.json",
          isSource: true,
          original: {
            value: 0,
            type: "x"
          },
          name: "sd-card-medium-box-shadow-1-x",
          attributes: {},
          path: [
            "card",
            "medium",
            "boxShadow",
            "1",
            "x"
          ]
        },
        y: {
          value: "6px",
          type: "y",
          filePath: "themes/videoleap-light.json",
          isSource: true,
          original: {
            value: 6,
            type: "y"
          },
          name: "sd-card-medium-box-shadow-1-y",
          attributes: {},
          path: [
            "card",
            "medium",
            "boxShadow",
            "1",
            "y"
          ]
        },
        blur: {
          value: "28px",
          type: "blur",
          filePath: "themes/videoleap-light.json",
          isSource: true,
          original: {
            value: 28,
            type: "blur"
          },
          name: "sd-card-medium-box-shadow-1-blur",
          attributes: {},
          path: [
            "card",
            "medium",
            "boxShadow",
            "1",
            "blur"
          ]
        },
        spread: {
          value: "-6px",
          type: "spread",
          filePath: "themes/videoleap-light.json",
          isSource: true,
          original: {
            value: -6,
            type: "spread"
          },
          name: "sd-card-medium-box-shadow-1-spread",
          attributes: {},
          path: [
            "card",
            "medium",
            "boxShadow",
            "1",
            "spread"
          ]
        }
      }
    },
    fill: {
      value: "#ffffff",
      type: "fill",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#ffffff",
        type: "fill"
      },
      name: "sd-card-medium-fill",
      attributes: {},
      path: [
        "card",
        "medium",
        "fill"
      ]
    },
    spacing: {
      value: "16px",
      type: "spacing",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 16,
        type: "spacing"
      },
      name: "sd-card-medium-spacing",
      attributes: {},
      path: [
        "card",
        "medium",
        "spacing"
      ]
    }
  },
  large: {
    spacing: {
      value: "16px",
      type: "spacing",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 16,
        type: "spacing"
      },
      name: "sd-card-large-spacing",
      attributes: {},
      path: [
        "card",
        "large",
        "spacing"
      ]
    },
    verticalPadding: {
      value: "16px",
      type: "dimension",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 16,
        type: "dimension"
      },
      name: "sd-card-large-vertical-padding",
      attributes: {},
      path: [
        "card",
        "large",
        "verticalPadding"
      ]
    },
    horizontalPadding: {
      value: "16px",
      type: "dimension",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 16,
        type: "dimension"
      },
      name: "sd-card-large-horizontal-padding",
      attributes: {},
      path: [
        "card",
        "large",
        "horizontalPadding"
      ]
    },
    borderRadius: {
      value: "40px",
      type: "borderRadius",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 40,
        type: "borderRadius"
      },
      name: "sd-card-large-border-radius",
      attributes: {},
      path: [
        "card",
        "large",
        "borderRadius"
      ]
    },
    boxShadow: {
      "0": {
        color: {
          value: "rgba(24, 39, 75, 0.1607843137254902)",
          type: "color",
          filePath: "themes/videoleap-light.json",
          isSource: true,
          original: {
            value: "#18274b29",
            type: "color"
          },
          name: "sd-card-large-box-shadow-0-color",
          attributes: {},
          path: [
            "card",
            "large",
            "boxShadow",
            "0",
            "color"
          ]
        },
        type: {
          value: "dropShadow",
          type: "type",
          filePath: "themes/videoleap-light.json",
          isSource: true,
          original: {
            value: "dropShadow",
            type: "type"
          },
          name: "sd-card-large-box-shadow-0-type",
          attributes: {},
          path: [
            "card",
            "large",
            "boxShadow",
            "0",
            "type"
          ]
        },
        x: {
          value: "0px",
          type: "x",
          filePath: "themes/videoleap-light.json",
          isSource: true,
          original: {
            value: 0,
            type: "x"
          },
          name: "sd-card-large-box-shadow-0-x",
          attributes: {},
          path: [
            "card",
            "large",
            "boxShadow",
            "0",
            "x"
          ]
        },
        y: {
          value: "18px",
          type: "y",
          filePath: "themes/videoleap-light.json",
          isSource: true,
          original: {
            value: 18,
            type: "y"
          },
          name: "sd-card-large-box-shadow-0-y",
          attributes: {},
          path: [
            "card",
            "large",
            "boxShadow",
            "0",
            "y"
          ]
        },
        blur: {
          value: "64px",
          type: "blur",
          filePath: "themes/videoleap-light.json",
          isSource: true,
          original: {
            value: 64,
            type: "blur"
          },
          name: "sd-card-large-box-shadow-0-blur",
          attributes: {},
          path: [
            "card",
            "large",
            "boxShadow",
            "0",
            "blur"
          ]
        },
        spread: {
          value: "-4px",
          type: "spread",
          filePath: "themes/videoleap-light.json",
          isSource: true,
          original: {
            value: -4,
            type: "spread"
          },
          name: "sd-card-large-box-shadow-0-spread",
          attributes: {},
          path: [
            "card",
            "large",
            "boxShadow",
            "0",
            "spread"
          ]
        }
      },
      "1": {
        color: {
          value: "rgba(24, 39, 75, 0.12156862745098039)",
          type: "color",
          filePath: "themes/videoleap-light.json",
          isSource: true,
          original: {
            value: "#18274b1f",
            type: "color"
          },
          name: "sd-card-large-box-shadow-1-color",
          attributes: {},
          path: [
            "card",
            "large",
            "boxShadow",
            "1",
            "color"
          ]
        },
        type: {
          value: "dropShadow",
          type: "type",
          filePath: "themes/videoleap-light.json",
          isSource: true,
          original: {
            value: "dropShadow",
            type: "type"
          },
          name: "sd-card-large-box-shadow-1-type",
          attributes: {},
          path: [
            "card",
            "large",
            "boxShadow",
            "1",
            "type"
          ]
        },
        x: {
          value: "0px",
          type: "x",
          filePath: "themes/videoleap-light.json",
          isSource: true,
          original: {
            value: 0,
            type: "x"
          },
          name: "sd-card-large-box-shadow-1-x",
          attributes: {},
          path: [
            "card",
            "large",
            "boxShadow",
            "1",
            "x"
          ]
        },
        y: {
          value: "6px",
          type: "y",
          filePath: "themes/videoleap-light.json",
          isSource: true,
          original: {
            value: 6,
            type: "y"
          },
          name: "sd-card-large-box-shadow-1-y",
          attributes: {},
          path: [
            "card",
            "large",
            "boxShadow",
            "1",
            "y"
          ]
        },
        blur: {
          value: "28px",
          type: "blur",
          filePath: "themes/videoleap-light.json",
          isSource: true,
          original: {
            value: 28,
            type: "blur"
          },
          name: "sd-card-large-box-shadow-1-blur",
          attributes: {},
          path: [
            "card",
            "large",
            "boxShadow",
            "1",
            "blur"
          ]
        },
        spread: {
          value: "-6px",
          type: "spread",
          filePath: "themes/videoleap-light.json",
          isSource: true,
          original: {
            value: -6,
            type: "spread"
          },
          name: "sd-card-large-box-shadow-1-spread",
          attributes: {},
          path: [
            "card",
            "large",
            "boxShadow",
            "1",
            "spread"
          ]
        }
      }
    },
    fill: {
      value: "#ffffff",
      type: "fill",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#ffffff",
        type: "fill"
      },
      name: "sd-card-large-fill",
      attributes: {},
      path: [
        "card",
        "large",
        "fill"
      ]
    }
  },
  radius: {
    xs: {
      value: "16px",
      type: "borderRadius",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 16,
        type: "borderRadius"
      },
      name: "sd-card-radius-xs",
      attributes: {},
      path: [
        "card",
        "radius",
        "xs"
      ]
    },
    sm: {
      value: "24px",
      type: "borderRadius",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 24,
        type: "borderRadius"
      },
      name: "sd-card-radius-sm",
      attributes: {},
      path: [
        "card",
        "radius",
        "sm"
      ]
    },
    md: {
      value: "32px",
      type: "borderRadius",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 32,
        type: "borderRadius"
      },
      name: "sd-card-radius-md",
      attributes: {},
      path: [
        "card",
        "radius",
        "md"
      ]
    },
    lg: {
      value: "40px",
      type: "borderRadius",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 40,
        type: "borderRadius"
      },
      name: "sd-card-radius-lg",
      attributes: {},
      path: [
        "card",
        "radius",
        "lg"
      ]
    }
  },
  padding: {
    sm: {
      value: "8px",
      type: "spacing",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 8,
        type: "spacing"
      },
      name: "sd-card-padding-sm",
      attributes: {},
      path: [
        "card",
        "padding",
        "sm"
      ]
    },
    md: {
      value: "12px",
      type: "spacing",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 12,
        type: "spacing"
      },
      name: "sd-card-padding-md",
      attributes: {},
      path: [
        "card",
        "padding",
        "md"
      ]
    },
    lg: {
      value: "16px",
      type: "spacing",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 16,
        type: "spacing"
      },
      name: "sd-card-padding-lg",
      attributes: {},
      path: [
        "card",
        "padding",
        "lg"
      ]
    },
    xl: {
      value: "20px",
      type: "spacing",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 20,
        type: "spacing"
      },
      name: "sd-card-padding-xl",
      attributes: {},
      path: [
        "card",
        "padding",
        "xl"
      ]
    }
  },
  gap: {
    sm: {
      value: "8px",
      type: "spacing",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 8,
        type: "spacing"
      },
      name: "sd-card-gap-sm",
      attributes: {},
      path: [
        "card",
        "gap",
        "sm"
      ]
    },
    md: {
      value: "16px",
      type: "spacing",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 16,
        type: "spacing"
      },
      name: "sd-card-gap-md",
      attributes: {},
      path: [
        "card",
        "gap",
        "md"
      ]
    },
    lg: {
      value: "24px",
      type: "spacing",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 24,
        type: "spacing"
      },
      name: "sd-card-gap-lg",
      attributes: {},
      path: [
        "card",
        "gap",
        "lg"
      ]
    },
    xl: {
      value: "32px",
      type: "spacing",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 32,
        type: "spacing"
      },
      name: "sd-card-gap-xl",
      attributes: {},
      path: [
        "card",
        "gap",
        "xl"
      ]
    }
  }
};
const sheet = {
  small: {
    borderRadius: {
      value: "16px",
      type: "borderRadius",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "16 16 0 0",
        type: "borderRadius"
      },
      name: "sd-sheet-small-border-radius",
      attributes: {},
      path: [
        "sheet",
        "small",
        "borderRadius"
      ]
    },
    fill: {
      value: "#ffffff",
      type: "fill",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#ffffff",
        type: "fill"
      },
      name: "sd-sheet-small-fill",
      attributes: {},
      path: [
        "sheet",
        "small",
        "fill"
      ]
    }
  },
  medium: {
    height: {
      value: "480px",
      type: "dimension",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 480,
        type: "dimension"
      },
      name: "sd-sheet-medium-height",
      attributes: {},
      path: [
        "sheet",
        "medium",
        "height"
      ]
    },
    borderRadius: {
      value: "24px",
      type: "borderRadius",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "24 24 0 0",
        type: "borderRadius"
      },
      name: "sd-sheet-medium-border-radius",
      attributes: {},
      path: [
        "sheet",
        "medium",
        "borderRadius"
      ]
    },
    fill: {
      value: "#ffffff",
      type: "fill",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#ffffff",
        type: "fill"
      },
      name: "sd-sheet-medium-fill",
      attributes: {},
      path: [
        "sheet",
        "medium",
        "fill"
      ]
    }
  },
  large: {
    height: {
      value: "480px",
      type: "dimension",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 480,
        type: "dimension"
      },
      name: "sd-sheet-large-height",
      attributes: {},
      path: [
        "sheet",
        "large",
        "height"
      ]
    },
    borderRadius: {
      value: "32px",
      type: "borderRadius",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "32 32 0 0",
        type: "borderRadius"
      },
      name: "sd-sheet-large-border-radius",
      attributes: {},
      path: [
        "sheet",
        "large",
        "borderRadius"
      ]
    },
    fill: {
      value: "#ffffff",
      type: "fill",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#ffffff",
        type: "fill"
      },
      name: "sd-sheet-large-fill",
      attributes: {},
      path: [
        "sheet",
        "large",
        "fill"
      ]
    }
  },
  radius: {
    sm: {
      value: "16px",
      type: "borderRadius",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "16 16 0 0",
        type: "borderRadius"
      },
      name: "sd-sheet-radius-sm",
      attributes: {},
      path: [
        "sheet",
        "radius",
        "sm"
      ]
    },
    md: {
      value: "24px",
      type: "borderRadius",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "24 24 0 0",
        type: "borderRadius"
      },
      name: "sd-sheet-radius-md",
      attributes: {},
      path: [
        "sheet",
        "radius",
        "md"
      ]
    },
    lg: {
      value: "32px",
      type: "borderRadius",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "32 32 0 0",
        type: "borderRadius"
      },
      name: "sd-sheet-radius-lg",
      attributes: {},
      path: [
        "sheet",
        "radius",
        "lg"
      ]
    }
  }
};
const comp = {
  button: {
    bg: {
      brand: {
        filled: {
          "default": {
            value: "rgba(244, 75, 73, 1)",
            type: "color",
            filePath: "themes/videoleap-light.json",
            isSource: true,
            original: {
              value: "#f44b49",
              type: "color"
            },
            name: "sd-comp-button-bg-brand-filled-default",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "brand",
              "filled",
              "default"
            ]
          },
          hover: {
            value: "rgba(179, 63, 60, 1)",
            type: "color",
            filePath: "themes/videoleap-light.json",
            isSource: true,
            original: {
              value: "#b33f3c",
              type: "color"
            },
            name: "sd-comp-button-bg-brand-filled-hover",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "brand",
              "filled",
              "hover"
            ]
          },
          pressed: {
            value: "rgba(147, 57, 53, 1)",
            type: "color",
            filePath: "themes/videoleap-light.json",
            isSource: true,
            original: {
              value: "#933935",
              type: "color"
            },
            name: "sd-comp-button-bg-brand-filled-pressed",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "brand",
              "filled",
              "pressed"
            ]
          },
          disabled: {
            value: "rgba(163, 166, 172, 0.25098039215686274)",
            type: "color",
            filePath: "themes/videoleap-light.json",
            isSource: true,
            original: {
              value: "#a3a6ac40",
              type: "color"
            },
            name: "sd-comp-button-bg-brand-filled-disabled",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "brand",
              "filled",
              "disabled"
            ]
          }
        },
        tinted: {
          "default": {
            value: "rgba(244, 75, 73, 0.1607843137254902)",
            type: "color",
            filePath: "themes/videoleap-light.json",
            isSource: true,
            original: {
              value: "#f44b4929",
              type: "color"
            },
            name: "sd-comp-button-bg-brand-tinted-default",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "brand",
              "tinted",
              "default"
            ]
          },
          hover: {
            value: "rgba(244, 75, 73, 0.34901960784313724)",
            type: "color",
            filePath: "themes/videoleap-light.json",
            isSource: true,
            original: {
              value: "#f44b4959",
              type: "color"
            },
            name: "sd-comp-button-bg-brand-tinted-hover",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "brand",
              "tinted",
              "hover"
            ]
          },
          pressed: {
            value: "rgba(244, 75, 73, 0.43137254901960786)",
            type: "color",
            filePath: "themes/videoleap-light.json",
            isSource: true,
            original: {
              value: "#f44b496e",
              type: "color"
            },
            name: "sd-comp-button-bg-brand-tinted-pressed",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "brand",
              "tinted",
              "pressed"
            ]
          },
          disabled: {
            value: "rgba(163, 166, 172, 0.10196078431372549)",
            type: "color",
            filePath: "themes/videoleap-light.json",
            isSource: true,
            original: {
              value: "#a3a6ac1a",
              type: "color"
            },
            name: "sd-comp-button-bg-brand-tinted-disabled",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "brand",
              "tinted",
              "disabled"
            ]
          }
        },
        plain: {
          "default": {
            value: "rgba(255, 255, 255, 0)",
            type: "color",
            filePath: "themes/videoleap-light.json",
            isSource: true,
            original: {
              value: "#ffffff00",
              type: "color"
            },
            name: "sd-comp-button-bg-brand-plain-default",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "brand",
              "plain",
              "default"
            ]
          },
          hover: {
            value: "rgba(255, 173, 161, 0.49019607843137253)",
            type: "color",
            filePath: "themes/videoleap-light.json",
            isSource: true,
            original: {
              value: "#ffada17d",
              type: "color"
            },
            name: "sd-comp-button-bg-brand-plain-hover",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "brand",
              "plain",
              "hover"
            ]
          },
          pressed: {
            value: "rgba(254, 144, 132, 0.6588235294117647)",
            type: "color",
            filePath: "themes/videoleap-light.json",
            isSource: true,
            original: {
              value: "#fe9084a8",
              type: "color"
            },
            name: "sd-comp-button-bg-brand-plain-pressed",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "brand",
              "plain",
              "pressed"
            ]
          },
          disabled: {
            value: "rgba(255, 255, 255, 0)",
            type: "color",
            filePath: "themes/videoleap-light.json",
            isSource: true,
            original: {
              value: "#ffffff00",
              type: "color"
            },
            name: "sd-comp-button-bg-brand-plain-disabled",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "brand",
              "plain",
              "disabled"
            ]
          }
        },
        elevated: {
          "default": {
            value: "rgba(255, 255, 255, 1)",
            type: "color",
            filePath: "themes/videoleap-light.json",
            isSource: true,
            original: {
              value: "#ffffff",
              type: "color"
            },
            name: "sd-comp-button-bg-brand-elevated-default",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "brand",
              "elevated",
              "default"
            ]
          },
          hover: {
            value: "rgba(224, 224, 224, 1)",
            type: "color",
            filePath: "themes/videoleap-light.json",
            isSource: true,
            original: {
              value: "#e0e0e0",
              type: "color"
            },
            name: "sd-comp-button-bg-brand-elevated-hover",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "brand",
              "elevated",
              "hover"
            ]
          },
          pressed: {
            value: "rgba(197, 198, 198, 1)",
            type: "color",
            filePath: "themes/videoleap-light.json",
            isSource: true,
            original: {
              value: "#c5c6c6",
              type: "color"
            },
            name: "sd-comp-button-bg-brand-elevated-pressed",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "brand",
              "elevated",
              "pressed"
            ]
          },
          disabled: {
            value: "rgba(128, 130, 136, 0.611764705882353)",
            type: "color",
            filePath: "themes/videoleap-light.json",
            isSource: true,
            original: {
              value: "#8082889c",
              type: "color"
            },
            name: "sd-comp-button-bg-brand-elevated-disabled",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "brand",
              "elevated",
              "disabled"
            ]
          }
        }
      },
      neutral: {
        filled: {
          "default": {
            value: "rgba(44, 45, 48, 1)",
            type: "color",
            filePath: "themes/videoleap-light.json",
            isSource: true,
            original: {
              value: "#2c2d30",
              type: "color"
            },
            name: "sd-comp-button-bg-neutral-filled-default",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "neutral",
              "filled",
              "default"
            ]
          },
          hover: {
            value: "rgba(95, 95, 98, 1)",
            type: "color",
            filePath: "themes/videoleap-light.json",
            isSource: true,
            original: {
              value: "#5f5f62",
              type: "color"
            },
            name: "sd-comp-button-bg-neutral-filled-hover",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "neutral",
              "filled",
              "hover"
            ]
          },
          pressed: {
            value: "rgba(122, 122, 125, 1)",
            type: "color",
            filePath: "themes/videoleap-light.json",
            isSource: true,
            original: {
              value: "#7a7a7d",
              type: "color"
            },
            name: "sd-comp-button-bg-neutral-filled-pressed",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "neutral",
              "filled",
              "pressed"
            ]
          }
        },
        tinted: {
          "default": {
            value: "rgba(44, 45, 48, 0.12156862745098039)",
            type: "color",
            filePath: "themes/videoleap-light.json",
            isSource: true,
            original: {
              value: "#2c2d301f",
              type: "color"
            },
            name: "sd-comp-button-bg-neutral-tinted-default",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "neutral",
              "tinted",
              "default"
            ]
          },
          hover: {
            value: "rgba(39, 40, 42, 0.30980392156862746)",
            type: "color",
            filePath: "themes/videoleap-light.json",
            isSource: true,
            original: {
              value: "#27282a4f",
              type: "color"
            },
            name: "sd-comp-button-bg-neutral-tinted-hover",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "neutral",
              "tinted",
              "hover"
            ]
          },
          pressed: {
            value: "rgba(37, 38, 40, 0.4)",
            type: "color",
            filePath: "themes/videoleap-light.json",
            isSource: true,
            original: {
              value: "#25262866",
              type: "color"
            },
            name: "sd-comp-button-bg-neutral-tinted-pressed",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "neutral",
              "tinted",
              "pressed"
            ]
          }
        },
        plain: {
          "default": {
            value: "rgba(255, 255, 255, 0)",
            type: "color",
            filePath: "themes/videoleap-light.json",
            isSource: true,
            original: {
              value: "#ffffff00",
              type: "color"
            },
            name: "sd-comp-button-bg-neutral-plain-default",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "neutral",
              "plain",
              "default"
            ]
          },
          hover: {
            value: "rgba(144, 145, 147, 0.49019607843137253)",
            type: "color",
            filePath: "themes/videoleap-light.json",
            isSource: true,
            original: {
              value: "#9091937d",
              type: "color"
            },
            name: "sd-comp-button-bg-neutral-plain-hover",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "neutral",
              "plain",
              "hover"
            ]
          },
          pressed: {
            value: "rgba(109, 110, 112, 0.6588235294117647)",
            type: "color",
            filePath: "themes/videoleap-light.json",
            isSource: true,
            original: {
              value: "#6d6e70a8",
              type: "color"
            },
            name: "sd-comp-button-bg-neutral-plain-pressed",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "neutral",
              "plain",
              "pressed"
            ]
          }
        },
        elevated: {
          "default": {
            value: "rgba(255, 255, 255, 1)",
            type: "color",
            filePath: "themes/videoleap-light.json",
            isSource: true,
            original: {
              value: "#ffffff",
              type: "color"
            },
            name: "sd-comp-button-bg-neutral-elevated-default",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "neutral",
              "elevated",
              "default"
            ]
          },
          hover: {
            value: "rgba(224, 224, 224, 1)",
            type: "color",
            filePath: "themes/videoleap-light.json",
            isSource: true,
            original: {
              value: "#e0e0e0",
              type: "color"
            },
            name: "sd-comp-button-bg-neutral-elevated-hover",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "neutral",
              "elevated",
              "hover"
            ]
          },
          pressed: {
            value: "rgba(197, 198, 198, 1)",
            type: "color",
            filePath: "themes/videoleap-light.json",
            isSource: true,
            original: {
              value: "#c5c6c6",
              type: "color"
            },
            name: "sd-comp-button-bg-neutral-elevated-pressed",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "neutral",
              "elevated",
              "pressed"
            ]
          }
        }
      },
      danger: {
        filled: {
          "default": {
            value: "rgba(255, 59, 48, 1)",
            type: "color",
            filePath: "themes/videoleap-light.json",
            isSource: true,
            original: {
              value: "#ff3b30",
              type: "color"
            },
            name: "sd-comp-button-bg-danger-filled-default",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "danger",
              "filled",
              "default"
            ]
          },
          hover: {
            value: "rgba(187, 55, 42, 1)",
            type: "color",
            filePath: "themes/videoleap-light.json",
            isSource: true,
            original: {
              value: "#bb372a",
              type: "color"
            },
            name: "sd-comp-button-bg-danger-filled-hover",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "danger",
              "filled",
              "hover"
            ]
          },
          pressed: {
            value: "rgba(154, 51, 39, 1)",
            type: "color",
            filePath: "themes/videoleap-light.json",
            isSource: true,
            original: {
              value: "#9a3327",
              type: "color"
            },
            name: "sd-comp-button-bg-danger-filled-pressed",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "danger",
              "filled",
              "pressed"
            ]
          }
        },
        tinted: {
          "default": {
            value: "rgba(255, 59, 48, 0.12156862745098039)",
            type: "color",
            filePath: "themes/videoleap-light.json",
            isSource: true,
            original: {
              value: "#ff3b301f",
              type: "color"
            },
            name: "sd-comp-button-bg-danger-tinted-default",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "danger",
              "tinted",
              "default"
            ]
          },
          hover: {
            value: "rgba(198, 56, 43, 0.30980392156862746)",
            type: "color",
            filePath: "themes/videoleap-light.json",
            isSource: true,
            original: {
              value: "#c6382b4f",
              type: "color"
            },
            name: "sd-comp-button-bg-danger-tinted-hover",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "danger",
              "tinted",
              "hover"
            ]
          },
          pressed: {
            value: "rgba(175, 54, 42, 0.4)",
            type: "color",
            filePath: "themes/videoleap-light.json",
            isSource: true,
            original: {
              value: "#af362a66",
              type: "color"
            },
            name: "sd-comp-button-bg-danger-tinted-pressed",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "danger",
              "tinted",
              "pressed"
            ]
          }
        },
        plain: {
          "default": {
            value: "rgba(255, 255, 255, 0)",
            type: "color",
            filePath: "themes/videoleap-light.json",
            isSource: true,
            original: {
              value: "#ffffff00",
              type: "color"
            },
            name: "sd-comp-button-bg-danger-plain-default",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "danger",
              "plain",
              "default"
            ]
          },
          hover: {
            value: "rgba(255, 170, 150, 0.49019607843137253)",
            type: "color",
            filePath: "themes/videoleap-light.json",
            isSource: true,
            original: {
              value: "#ffaa967d",
              type: "color"
            },
            name: "sd-comp-button-bg-danger-plain-hover",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "danger",
              "plain",
              "hover"
            ]
          },
          pressed: {
            value: "rgba(255, 140, 116, 0.6588235294117647)",
            type: "color",
            filePath: "themes/videoleap-light.json",
            isSource: true,
            original: {
              value: "#ff8c74a8",
              type: "color"
            },
            name: "sd-comp-button-bg-danger-plain-pressed",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "danger",
              "plain",
              "pressed"
            ]
          }
        },
        elevated: {
          "default": {
            value: "rgba(255, 255, 255, 1)",
            type: "color",
            filePath: "themes/videoleap-light.json",
            isSource: true,
            original: {
              value: "#ffffff",
              type: "color"
            },
            name: "sd-comp-button-bg-danger-elevated-default",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "danger",
              "elevated",
              "default"
            ]
          },
          hover: {
            value: "rgba(224, 224, 224, 1)",
            type: "color",
            filePath: "themes/videoleap-light.json",
            isSource: true,
            original: {
              value: "#e0e0e0",
              type: "color"
            },
            name: "sd-comp-button-bg-danger-elevated-hover",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "danger",
              "elevated",
              "hover"
            ]
          },
          pressed: {
            value: "rgba(197, 198, 198, 1)",
            type: "color",
            filePath: "themes/videoleap-light.json",
            isSource: true,
            original: {
              value: "#c5c6c6",
              type: "color"
            },
            name: "sd-comp-button-bg-danger-elevated-pressed",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "danger",
              "elevated",
              "pressed"
            ]
          }
        }
      },
      overlay: {
        filled: {
          "default": {
            value: "rgba(255, 255, 255, 1)",
            type: "color",
            filePath: "themes/videoleap-light.json",
            isSource: true,
            original: {
              value: "#ffffff",
              type: "color"
            },
            name: "sd-comp-button-bg-overlay-filled-default",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "overlay",
              "filled",
              "default"
            ]
          },
          hover: {
            value: "rgba(237, 237, 237, 1)",
            type: "color",
            filePath: "themes/videoleap-light.json",
            isSource: true,
            original: {
              value: "#ededed",
              type: "color"
            },
            name: "sd-comp-button-bg-overlay-filled-hover",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "overlay",
              "filled",
              "hover"
            ]
          },
          pressed: {
            value: "rgba(222, 222, 222, 1)",
            type: "color",
            filePath: "themes/videoleap-light.json",
            isSource: true,
            original: {
              value: "#dedede",
              type: "color"
            },
            name: "sd-comp-button-bg-overlay-filled-pressed",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "overlay",
              "filled",
              "pressed"
            ]
          }
        },
        tinted: {
          "default": {
            value: "rgba(255, 255, 255, 0.12156862745098039)",
            type: "color",
            filePath: "themes/videoleap-light.json",
            isSource: true,
            original: {
              value: "#ffffff1f",
              type: "color"
            },
            name: "sd-comp-button-bg-overlay-tinted-default",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "overlay",
              "tinted",
              "default"
            ]
          },
          hover: {
            value: "rgba(255, 255, 255, 0.30980392156862746)",
            type: "color",
            filePath: "themes/videoleap-light.json",
            isSource: true,
            original: {
              value: "#ffffff4f",
              type: "color"
            },
            name: "sd-comp-button-bg-overlay-tinted-hover",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "overlay",
              "tinted",
              "hover"
            ]
          },
          pressed: {
            value: "rgba(255, 255, 255, 0.4)",
            type: "color",
            filePath: "themes/videoleap-light.json",
            isSource: true,
            original: {
              value: "#fff6",
              type: "color"
            },
            name: "sd-comp-button-bg-overlay-tinted-pressed",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "overlay",
              "tinted",
              "pressed"
            ]
          }
        },
        plain: {
          "default": {
            value: "rgba(255, 255, 255, 0)",
            type: "color",
            filePath: "themes/videoleap-light.json",
            isSource: true,
            original: {
              value: "#ffffff00",
              type: "color"
            },
            name: "sd-comp-button-bg-overlay-plain-default",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "overlay",
              "plain",
              "default"
            ]
          },
          hover: {
            value: "rgba(255, 255, 255, 0.49019607843137253)",
            type: "color",
            filePath: "themes/videoleap-light.json",
            isSource: true,
            original: {
              value: "#ffffff7d",
              type: "color"
            },
            name: "sd-comp-button-bg-overlay-plain-hover",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "overlay",
              "plain",
              "hover"
            ]
          },
          pressed: {
            value: "rgba(255, 255, 255, 0.6588235294117647)",
            type: "color",
            filePath: "themes/videoleap-light.json",
            isSource: true,
            original: {
              value: "#ffffffa8",
              type: "color"
            },
            name: "sd-comp-button-bg-overlay-plain-pressed",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "overlay",
              "plain",
              "pressed"
            ]
          }
        },
        elevated: {
          "default": {
            value: "rgba(0, 0, 0, 0.30196078431372547)",
            type: "color",
            filePath: "themes/videoleap-light.json",
            isSource: true,
            original: {
              value: "#0000004d",
              type: "color"
            },
            name: "sd-comp-button-bg-overlay-elevated-default",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "overlay",
              "elevated",
              "default"
            ]
          },
          hover: {
            value: "rgba(0, 0, 0, 0.5215686274509804)",
            type: "color",
            filePath: "themes/videoleap-light.json",
            isSource: true,
            original: {
              value: "#00000085",
              type: "color"
            },
            name: "sd-comp-button-bg-overlay-elevated-hover",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "overlay",
              "elevated",
              "hover"
            ]
          },
          pressed: {
            value: "rgba(0, 0, 0, 0.6392156862745098)",
            type: "color",
            filePath: "themes/videoleap-light.json",
            isSource: true,
            original: {
              value: "#000000a3",
              type: "color"
            },
            name: "sd-comp-button-bg-overlay-elevated-pressed",
            attributes: {},
            path: [
              "comp",
              "button",
              "bg",
              "overlay",
              "elevated",
              "pressed"
            ]
          }
        }
      }
    },
    fg: {
      brand: {
        primary: {
          value: "rgba(255, 255, 255, 1)",
          type: "color",
          filePath: "themes/videoleap-light.json",
          isSource: true,
          original: {
            value: "#ffffff",
            type: "color"
          },
          name: "sd-comp-button-fg-brand-primary",
          attributes: {},
          path: [
            "comp",
            "button",
            "fg",
            "brand",
            "primary"
          ]
        },
        secondary: {
          value: "rgba(244, 75, 73, 1)",
          type: "color",
          filePath: "themes/videoleap-light.json",
          isSource: true,
          original: {
            value: "#f44b49",
            type: "color"
          },
          name: "sd-comp-button-fg-brand-secondary",
          attributes: {},
          path: [
            "comp",
            "button",
            "fg",
            "brand",
            "secondary"
          ]
        },
        disabled: {
          value: "rgba(163, 166, 172, 0.5019607843137255)",
          type: "color",
          filePath: "themes/videoleap-light.json",
          isSource: true,
          original: {
            value: "#a3a6ac80",
            type: "color"
          },
          name: "sd-comp-button-fg-brand-disabled",
          attributes: {},
          path: [
            "comp",
            "button",
            "fg",
            "brand",
            "disabled"
          ]
        }
      },
      neutral: {
        primary: {
          value: "rgba(230, 231, 233, 1)",
          type: "color",
          filePath: "themes/videoleap-light.json",
          isSource: true,
          original: {
            value: "#e6e7e9",
            type: "color"
          },
          name: "sd-comp-button-fg-neutral-primary",
          attributes: {},
          path: [
            "comp",
            "button",
            "fg",
            "neutral",
            "primary"
          ]
        },
        secondary: {
          value: "rgba(44, 45, 48, 1)",
          type: "color",
          filePath: "themes/videoleap-light.json",
          isSource: true,
          original: {
            value: "#2c2d30",
            type: "color"
          },
          name: "sd-comp-button-fg-neutral-secondary",
          attributes: {},
          path: [
            "comp",
            "button",
            "fg",
            "neutral",
            "secondary"
          ]
        }
      },
      danger: {
        primary: {
          value: "rgba(252, 252, 253, 1)",
          type: "color",
          filePath: "themes/videoleap-light.json",
          isSource: true,
          original: {
            value: "#fcfcfd",
            type: "color"
          },
          name: "sd-comp-button-fg-danger-primary",
          attributes: {},
          path: [
            "comp",
            "button",
            "fg",
            "danger",
            "primary"
          ]
        },
        secondary: {
          value: "rgba(255, 59, 48, 1)",
          type: "color",
          filePath: "themes/videoleap-light.json",
          isSource: true,
          original: {
            value: "#ff3b30",
            type: "color"
          },
          name: "sd-comp-button-fg-danger-secondary",
          attributes: {},
          path: [
            "comp",
            "button",
            "fg",
            "danger",
            "secondary"
          ]
        }
      },
      overlay: {
        primary: {
          value: "rgba(22, 23, 25, 1)",
          type: "color",
          filePath: "themes/videoleap-light.json",
          isSource: true,
          original: {
            value: "#161719",
            type: "color"
          },
          name: "sd-comp-button-fg-overlay-primary",
          attributes: {},
          path: [
            "comp",
            "button",
            "fg",
            "overlay",
            "primary"
          ]
        },
        secondary: {
          value: "rgba(255, 255, 255, 1)",
          type: "color",
          filePath: "themes/videoleap-light.json",
          isSource: true,
          original: {
            value: "#ffffff",
            type: "color"
          },
          name: "sd-comp-button-fg-overlay-secondary",
          attributes: {},
          path: [
            "comp",
            "button",
            "fg",
            "overlay",
            "secondary"
          ]
        }
      }
    }
  }
};
const gradient = {
  "primary↓": {
    value: "linear-gradient(180deg, #fcfcfd 0%, #ffffff00 100%)",
    type: "color",
    description: "token = lh-semantic-gradient-primary-down\n\nbg primary values, smooth, gradient, mask, transition",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: "linear-gradient(180deg, #fcfcfd 0%, #ffffff00 100%)",
      type: "color",
      description: "token = lh-semantic-gradient-primary-down\n\nbg primary values, smooth, gradient, mask, transition"
    },
    name: "sd-gradient-primary",
    attributes: {},
    path: [
      "gradient",
      "primary↓"
    ]
  },
  "primary↑": {
    value: "linear-gradient(0deg, #fcfcfd 0%, #ffffff00 100%)",
    type: "color",
    description: "token = lh-semantic-gradient-primary-up\n\nbg primary values, smooth, gradient, mask, transition",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: "linear-gradient(0deg, #fcfcfd 0%, #ffffff00 100%)",
      type: "color",
      description: "token = lh-semantic-gradient-primary-up\n\nbg primary values, smooth, gradient, mask, transition"
    },
    name: "sd-gradient-primary",
    attributes: {},
    path: [
      "gradient",
      "primary↑"
    ]
  },
  "secondary↓": {
    value: "linear-gradient(180deg, #ffffff 0%, #ffffff00 100%)",
    type: "color",
    description: "token = lh-semantic-gradient-secondary-down\n\nbg secondary values, smooth, gradient, mask, transition",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: "linear-gradient(180deg, #ffffff 0%, #ffffff00 100%)",
      type: "color",
      description: "token = lh-semantic-gradient-secondary-down\n\nbg secondary values, smooth, gradient, mask, transition"
    },
    name: "sd-gradient-secondary",
    attributes: {},
    path: [
      "gradient",
      "secondary↓"
    ]
  },
  "secondary↑": {
    value: "linear-gradient(0deg, #ffffff 0%, #ffffff00 100%)",
    type: "color",
    description: "token = lh-semantic-gradient-secondary-up\n\nbg secondary values, smooth, gradient, mask, transition",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: "linear-gradient(0deg, #ffffff 0%, #ffffff00 100%)",
      type: "color",
      description: "token = lh-semantic-gradient-secondary-up\n\nbg secondary values, smooth, gradient, mask, transition"
    },
    name: "sd-gradient-secondary",
    attributes: {},
    path: [
      "gradient",
      "secondary↑"
    ]
  },
  "inverse↓": {
    value: "linear-gradient(180deg, #161719 0%, #ffffff00 100%)",
    type: "color",
    description: "token = lh-semantic-gradient-inverse-down\n\nbg inverse values, smooth, gradient, mask, transition",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: "linear-gradient(180deg, #161719 0%, #ffffff00 100%)",
      type: "color",
      description: "token = lh-semantic-gradient-inverse-down\n\nbg inverse values, smooth, gradient, mask, transition"
    },
    name: "sd-gradient-inverse",
    attributes: {},
    path: [
      "gradient",
      "inverse↓"
    ]
  },
  "inverse↑": {
    value: "linear-gradient(0deg, #161719 0%, #ffffff00 100%)",
    type: "color",
    description: "token = lh-semantic-gradient-inverse-up\n\nbg inverse values, smooth, gradient, mask, transition",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: "linear-gradient(0deg, #161719 0%, #ffffff00 100%)",
      type: "color",
      description: "token = lh-semantic-gradient-inverse-up\n\nbg inverse values, smooth, gradient, mask, transition"
    },
    name: "sd-gradient-inverse",
    attributes: {},
    path: [
      "gradient",
      "inverse↑"
    ]
  },
  "brand↓": {
    value: "linear-gradient(180deg, #f44b49 0%, #ffffff00 100%)",
    type: "color",
    description: "token = lh-semantic-gradient-brand-down\n\nbg brand values, smooth, gradient, mask, transition",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: "linear-gradient(180deg, #f44b49 0%, #ffffff00 100%)",
      type: "color",
      description: "token = lh-semantic-gradient-brand-down\n\nbg brand values, smooth, gradient, mask, transition"
    },
    name: "sd-gradient-brand",
    attributes: {},
    path: [
      "gradient",
      "brand↓"
    ]
  },
  "brand↑": {
    value: "linear-gradient(0deg, #f44b49 0%, #ffffff00 100%)",
    type: "color",
    description: "token = lh-semantic-gradient-brand-up\n\nbg brand values, smooth, gradient, mask, transition",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: "linear-gradient(0deg, #f44b49 0%, #ffffff00 100%)",
      type: "color",
      description: "token = lh-semantic-gradient-brand-up\n\nbg brand values, smooth, gradient, mask, transition"
    },
    name: "sd-gradient-brand",
    attributes: {},
    path: [
      "gradient",
      "brand↑"
    ]
  },
  "black↓": {
    value: "linear-gradient(180deg, #000000 0%, #000000fc 11.79%, #000000f7 21.38%, #000000ed 29.12%, #000000e0 35.34%, #000000d1 40.37%, #000000bf 44.56%, #000000ab 48.24%, #00000096 51.76%, #00000080 55.44%, #00000069 59.63%, #00000054 64.66%, #0000003d 70.88%, #00000026 78.62%, #00000012 88.21%, #00000000 100%)",
    type: "color",
    description: "token = lh-semantic-gradient-black-down\n\nblack values, smooth, gradient, mask, transition, feed, overlay, content",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: "linear-gradient(180deg, #000000 0%, #000000fc 11.79%, #000000f7 21.38%, #000000ed 29.12%, #000000e0 35.34%, #000000d1 40.37%, #000000bf 44.56%, #000000ab 48.24%, #00000096 51.76%, #00000080 55.44%, #00000069 59.63%, #00000054 64.66%, #0000003d 70.88%, #00000026 78.62%, #00000012 88.21%, #00000000 100%)",
      type: "color",
      description: "token = lh-semantic-gradient-black-down\n\nblack values, smooth, gradient, mask, transition, feed, overlay, content"
    },
    name: "sd-gradient-black",
    attributes: {},
    path: [
      "gradient",
      "black↓"
    ]
  },
  "black↑": {
    value: "linear-gradient(0deg, #000000 0%, #000000fc 11.79%, #000000f7 21.38%, #000000ed 29.12%, #000000e0 35.34%, #000000d1 40.37%, #000000bf 44.56%, #000000ab 48.24%, #00000096 51.76%, #00000080 55.44%, #00000069 59.63%, #00000054 64.66%, #0000003d 70.88%, #00000026 78.62%, #00000012 88.21%, #00000000 100%)",
    type: "color",
    description: "token = lh-semantic-gradient-black-up\n\nblack values, smooth, gradient, mask, transition, feed, overlay, content",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: "linear-gradient(0deg, #000000 0%, #000000fc 11.79%, #000000f7 21.38%, #000000ed 29.12%, #000000e0 35.34%, #000000d1 40.37%, #000000bf 44.56%, #000000ab 48.24%, #00000096 51.76%, #00000080 55.44%, #00000069 59.63%, #00000054 64.66%, #0000003d 70.88%, #00000026 78.62%, #00000012 88.21%, #00000000 100%)",
      type: "color",
      description: "token = lh-semantic-gradient-black-up\n\nblack values, smooth, gradient, mask, transition, feed, overlay, content"
    },
    name: "sd-gradient-black",
    attributes: {},
    path: [
      "gradient",
      "black↑"
    ]
  }
};
const shadow = {
  "smooth-icon": {
    "0": {
      color: {
        value: "rgba(0, 0, 0, 0.0392156862745098)",
        type: "color",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: "#0000000a",
          type: "color"
        },
        name: "sd-shadow-smooth-icon-0-color",
        attributes: {},
        path: [
          "shadow",
          "smooth-icon",
          "0",
          "color"
        ]
      },
      type: {
        value: "dropShadow",
        type: "type",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: "dropShadow",
          type: "type"
        },
        name: "sd-shadow-smooth-icon-0-type",
        attributes: {},
        path: [
          "shadow",
          "smooth-icon",
          "0",
          "type"
        ]
      },
      x: {
        value: "0px",
        type: "x",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 0,
          type: "x"
        },
        name: "sd-shadow-smooth-icon-0-x",
        attributes: {},
        path: [
          "shadow",
          "smooth-icon",
          "0",
          "x"
        ]
      },
      y: {
        value: "0px",
        type: "y",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 0,
          type: "y"
        },
        name: "sd-shadow-smooth-icon-0-y",
        attributes: {},
        path: [
          "shadow",
          "smooth-icon",
          "0",
          "y"
        ]
      },
      blur: {
        value: "1px",
        type: "blur",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 1,
          type: "blur"
        },
        name: "sd-shadow-smooth-icon-0-blur",
        attributes: {},
        path: [
          "shadow",
          "smooth-icon",
          "0",
          "blur"
        ]
      },
      spread: {
        value: "0px",
        type: "spread",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 0,
          type: "spread"
        },
        name: "sd-shadow-smooth-icon-0-spread",
        attributes: {},
        path: [
          "shadow",
          "smooth-icon",
          "0",
          "spread"
        ]
      }
    },
    "1": {
      color: {
        value: "rgba(0, 0, 0, 0.23921568627450981)",
        type: "color",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: "#0000003d",
          type: "color"
        },
        name: "sd-shadow-smooth-icon-1-color",
        attributes: {},
        path: [
          "shadow",
          "smooth-icon",
          "1",
          "color"
        ]
      },
      type: {
        value: "dropShadow",
        type: "type",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: "dropShadow",
          type: "type"
        },
        name: "sd-shadow-smooth-icon-1-type",
        attributes: {},
        path: [
          "shadow",
          "smooth-icon",
          "1",
          "type"
        ]
      },
      x: {
        value: "0px",
        type: "x",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 0,
          type: "x"
        },
        name: "sd-shadow-smooth-icon-1-x",
        attributes: {},
        path: [
          "shadow",
          "smooth-icon",
          "1",
          "x"
        ]
      },
      y: {
        value: "0px",
        type: "y",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 0,
          type: "y"
        },
        name: "sd-shadow-smooth-icon-1-y",
        attributes: {},
        path: [
          "shadow",
          "smooth-icon",
          "1",
          "y"
        ]
      },
      blur: {
        value: "16px",
        type: "blur",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 16,
          type: "blur"
        },
        name: "sd-shadow-smooth-icon-1-blur",
        attributes: {},
        path: [
          "shadow",
          "smooth-icon",
          "1",
          "blur"
        ]
      },
      spread: {
        value: "0px",
        type: "spread",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 0,
          type: "spread"
        },
        name: "sd-shadow-smooth-icon-1-spread",
        attributes: {},
        path: [
          "shadow",
          "smooth-icon",
          "1",
          "spread"
        ]
      }
    }
  },
  "sharp-icon": {
    "0": {
      color: {
        value: "rgba(0, 0, 0, 0.47843137254901963)",
        type: "color",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: "#0000007a",
          type: "color"
        },
        name: "sd-shadow-sharp-icon-0-color",
        attributes: {},
        path: [
          "shadow",
          "sharp-icon",
          "0",
          "color"
        ]
      },
      type: {
        value: "dropShadow",
        type: "type",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: "dropShadow",
          type: "type"
        },
        name: "sd-shadow-sharp-icon-0-type",
        attributes: {},
        path: [
          "shadow",
          "sharp-icon",
          "0",
          "type"
        ]
      },
      x: {
        value: "0px",
        type: "x",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 0,
          type: "x"
        },
        name: "sd-shadow-sharp-icon-0-x",
        attributes: {},
        path: [
          "shadow",
          "sharp-icon",
          "0",
          "x"
        ]
      },
      y: {
        value: "0px",
        type: "y",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 0,
          type: "y"
        },
        name: "sd-shadow-sharp-icon-0-y",
        attributes: {},
        path: [
          "shadow",
          "sharp-icon",
          "0",
          "y"
        ]
      },
      blur: {
        value: "1px",
        type: "blur",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 1,
          type: "blur"
        },
        name: "sd-shadow-sharp-icon-0-blur",
        attributes: {},
        path: [
          "shadow",
          "sharp-icon",
          "0",
          "blur"
        ]
      },
      spread: {
        value: "0px",
        type: "spread",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 0,
          type: "spread"
        },
        name: "sd-shadow-sharp-icon-0-spread",
        attributes: {},
        path: [
          "shadow",
          "sharp-icon",
          "0",
          "spread"
        ]
      }
    },
    "1": {
      color: {
        value: "rgba(0, 0, 0, 0.1607843137254902)",
        type: "color",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: "#00000029",
          type: "color"
        },
        name: "sd-shadow-sharp-icon-1-color",
        attributes: {},
        path: [
          "shadow",
          "sharp-icon",
          "1",
          "color"
        ]
      },
      type: {
        value: "dropShadow",
        type: "type",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: "dropShadow",
          type: "type"
        },
        name: "sd-shadow-sharp-icon-1-type",
        attributes: {},
        path: [
          "shadow",
          "sharp-icon",
          "1",
          "type"
        ]
      },
      x: {
        value: "0px",
        type: "x",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 0,
          type: "x"
        },
        name: "sd-shadow-sharp-icon-1-x",
        attributes: {},
        path: [
          "shadow",
          "sharp-icon",
          "1",
          "x"
        ]
      },
      y: {
        value: "0px",
        type: "y",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 0,
          type: "y"
        },
        name: "sd-shadow-sharp-icon-1-y",
        attributes: {},
        path: [
          "shadow",
          "sharp-icon",
          "1",
          "y"
        ]
      },
      blur: {
        value: "2px",
        type: "blur",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 2,
          type: "blur"
        },
        name: "sd-shadow-sharp-icon-1-blur",
        attributes: {},
        path: [
          "shadow",
          "sharp-icon",
          "1",
          "blur"
        ]
      },
      spread: {
        value: "0px",
        type: "spread",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 0,
          type: "spread"
        },
        name: "sd-shadow-sharp-icon-1-spread",
        attributes: {},
        path: [
          "shadow",
          "sharp-icon",
          "1",
          "spread"
        ]
      }
    }
  },
  seperation: {
    "0": {
      color: {
        value: "rgba(14, 21, 38, 0.0784313725490196)",
        type: "color",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: "#0e152614",
          type: "color"
        },
        name: "sd-shadow-seperation-0-color",
        attributes: {},
        path: [
          "shadow",
          "seperation",
          "0",
          "color"
        ]
      },
      type: {
        value: "dropShadow",
        type: "type",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: "dropShadow",
          type: "type"
        },
        name: "sd-shadow-seperation-0-type",
        attributes: {},
        path: [
          "shadow",
          "seperation",
          "0",
          "type"
        ]
      },
      x: {
        value: "0px",
        type: "x",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 0,
          type: "x"
        },
        name: "sd-shadow-seperation-0-x",
        attributes: {},
        path: [
          "shadow",
          "seperation",
          "0",
          "x"
        ]
      },
      y: {
        value: "0px",
        type: "y",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 0,
          type: "y"
        },
        name: "sd-shadow-seperation-0-y",
        attributes: {},
        path: [
          "shadow",
          "seperation",
          "0",
          "y"
        ]
      },
      blur: {
        value: "1px",
        type: "blur",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 1,
          type: "blur"
        },
        name: "sd-shadow-seperation-0-blur",
        attributes: {},
        path: [
          "shadow",
          "seperation",
          "0",
          "blur"
        ]
      },
      spread: {
        value: "0px",
        type: "spread",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 0,
          type: "spread"
        },
        name: "sd-shadow-seperation-0-spread",
        attributes: {},
        path: [
          "shadow",
          "seperation",
          "0",
          "spread"
        ]
      }
    },
    "1": {
      color: {
        value: "rgba(14, 21, 38, 0.058823529411764705)",
        type: "color",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: "#0e15260f",
          type: "color"
        },
        name: "sd-shadow-seperation-1-color",
        attributes: {},
        path: [
          "shadow",
          "seperation",
          "1",
          "color"
        ]
      },
      type: {
        value: "dropShadow",
        type: "type",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: "dropShadow",
          type: "type"
        },
        name: "sd-shadow-seperation-1-type",
        attributes: {},
        path: [
          "shadow",
          "seperation",
          "1",
          "type"
        ]
      },
      x: {
        value: "0px",
        type: "x",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 0,
          type: "x"
        },
        name: "sd-shadow-seperation-1-x",
        attributes: {},
        path: [
          "shadow",
          "seperation",
          "1",
          "x"
        ]
      },
      y: {
        value: "2px",
        type: "y",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 2,
          type: "y"
        },
        name: "sd-shadow-seperation-1-y",
        attributes: {},
        path: [
          "shadow",
          "seperation",
          "1",
          "y"
        ]
      },
      blur: {
        value: "32px",
        type: "blur",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 32,
          type: "blur"
        },
        name: "sd-shadow-seperation-1-blur",
        attributes: {},
        path: [
          "shadow",
          "seperation",
          "1",
          "blur"
        ]
      },
      spread: {
        value: "0px",
        type: "spread",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 0,
          type: "spread"
        },
        name: "sd-shadow-seperation-1-spread",
        attributes: {},
        path: [
          "shadow",
          "seperation",
          "1",
          "spread"
        ]
      }
    }
  },
  "elevation-1": {
    "0": {
      color: {
        value: "rgba(24, 39, 75, 0.0784313725490196)",
        type: "color",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: "#18274b14",
          type: "color"
        },
        name: "sd-shadow-elevation-1-0-color",
        attributes: {},
        path: [
          "shadow",
          "elevation-1",
          "0",
          "color"
        ]
      },
      type: {
        value: "dropShadow",
        type: "type",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: "dropShadow",
          type: "type"
        },
        name: "sd-shadow-elevation-1-0-type",
        attributes: {},
        path: [
          "shadow",
          "elevation-1",
          "0",
          "type"
        ]
      },
      x: {
        value: "0px",
        type: "x",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 0,
          type: "x"
        },
        name: "sd-shadow-elevation-1-0-x",
        attributes: {},
        path: [
          "shadow",
          "elevation-1",
          "0",
          "x"
        ]
      },
      y: {
        value: "4px",
        type: "y",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 4,
          type: "y"
        },
        name: "sd-shadow-elevation-1-0-y",
        attributes: {},
        path: [
          "shadow",
          "elevation-1",
          "0",
          "y"
        ]
      },
      blur: {
        value: "12px",
        type: "blur",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 12,
          type: "blur"
        },
        name: "sd-shadow-elevation-1-0-blur",
        attributes: {},
        path: [
          "shadow",
          "elevation-1",
          "0",
          "blur"
        ]
      },
      spread: {
        value: "-2px",
        type: "spread",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: -2,
          type: "spread"
        },
        name: "sd-shadow-elevation-1-0-spread",
        attributes: {},
        path: [
          "shadow",
          "elevation-1",
          "0",
          "spread"
        ]
      }
    },
    "1": {
      color: {
        value: "rgba(24, 39, 75, 0.0196078431372549)",
        type: "color",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: "#18274b05",
          type: "color"
        },
        name: "sd-shadow-elevation-1-1-color",
        attributes: {},
        path: [
          "shadow",
          "elevation-1",
          "1",
          "color"
        ]
      },
      type: {
        value: "dropShadow",
        type: "type",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: "dropShadow",
          type: "type"
        },
        name: "sd-shadow-elevation-1-1-type",
        attributes: {},
        path: [
          "shadow",
          "elevation-1",
          "1",
          "type"
        ]
      },
      x: {
        value: "0px",
        type: "x",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 0,
          type: "x"
        },
        name: "sd-shadow-elevation-1-1-x",
        attributes: {},
        path: [
          "shadow",
          "elevation-1",
          "1",
          "x"
        ]
      },
      y: {
        value: "0px",
        type: "y",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 0,
          type: "y"
        },
        name: "sd-shadow-elevation-1-1-y",
        attributes: {},
        path: [
          "shadow",
          "elevation-1",
          "1",
          "y"
        ]
      },
      blur: {
        value: "4px",
        type: "blur",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 4,
          type: "blur"
        },
        name: "sd-shadow-elevation-1-1-blur",
        attributes: {},
        path: [
          "shadow",
          "elevation-1",
          "1",
          "blur"
        ]
      },
      spread: {
        value: "0px",
        type: "spread",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 0,
          type: "spread"
        },
        name: "sd-shadow-elevation-1-1-spread",
        attributes: {},
        path: [
          "shadow",
          "elevation-1",
          "1",
          "spread"
        ]
      }
    }
  },
  "elevation-2": {
    "0": {
      color: {
        value: "rgba(24, 39, 75, 0.0784313725490196)",
        type: "color",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: "#18274b14",
          type: "color"
        },
        name: "sd-shadow-elevation-2-0-color",
        attributes: {},
        path: [
          "shadow",
          "elevation-2",
          "0",
          "color"
        ]
      },
      type: {
        value: "dropShadow",
        type: "type",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: "dropShadow",
          type: "type"
        },
        name: "sd-shadow-elevation-2-0-type",
        attributes: {},
        path: [
          "shadow",
          "elevation-2",
          "0",
          "type"
        ]
      },
      x: {
        value: "0px",
        type: "x",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 0,
          type: "x"
        },
        name: "sd-shadow-elevation-2-0-x",
        attributes: {},
        path: [
          "shadow",
          "elevation-2",
          "0",
          "x"
        ]
      },
      y: {
        value: "8px",
        type: "y",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 8,
          type: "y"
        },
        name: "sd-shadow-elevation-2-0-y",
        attributes: {},
        path: [
          "shadow",
          "elevation-2",
          "0",
          "y"
        ]
      },
      blur: {
        value: "24px",
        type: "blur",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 24,
          type: "blur"
        },
        name: "sd-shadow-elevation-2-0-blur",
        attributes: {},
        path: [
          "shadow",
          "elevation-2",
          "0",
          "blur"
        ]
      },
      spread: {
        value: "-4px",
        type: "spread",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: -4,
          type: "spread"
        },
        name: "sd-shadow-elevation-2-0-spread",
        attributes: {},
        path: [
          "shadow",
          "elevation-2",
          "0",
          "spread"
        ]
      }
    },
    "1": {
      color: {
        value: "rgba(24, 39, 75, 0.12156862745098039)",
        type: "color",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: "#18274b1f",
          type: "color"
        },
        name: "sd-shadow-elevation-2-1-color",
        attributes: {},
        path: [
          "shadow",
          "elevation-2",
          "1",
          "color"
        ]
      },
      type: {
        value: "dropShadow",
        type: "type",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: "dropShadow",
          type: "type"
        },
        name: "sd-shadow-elevation-2-1-type",
        attributes: {},
        path: [
          "shadow",
          "elevation-2",
          "1",
          "type"
        ]
      },
      x: {
        value: "0px",
        type: "x",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 0,
          type: "x"
        },
        name: "sd-shadow-elevation-2-1-x",
        attributes: {},
        path: [
          "shadow",
          "elevation-2",
          "1",
          "x"
        ]
      },
      y: {
        value: "2px",
        type: "y",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 2,
          type: "y"
        },
        name: "sd-shadow-elevation-2-1-y",
        attributes: {},
        path: [
          "shadow",
          "elevation-2",
          "1",
          "y"
        ]
      },
      blur: {
        value: "12px",
        type: "blur",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 12,
          type: "blur"
        },
        name: "sd-shadow-elevation-2-1-blur",
        attributes: {},
        path: [
          "shadow",
          "elevation-2",
          "1",
          "blur"
        ]
      },
      spread: {
        value: "-2px",
        type: "spread",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: -2,
          type: "spread"
        },
        name: "sd-shadow-elevation-2-1-spread",
        attributes: {},
        path: [
          "shadow",
          "elevation-2",
          "1",
          "spread"
        ]
      }
    }
  },
  "elevation-3": {
    "0": {
      color: {
        value: "rgba(24, 39, 75, 0.12156862745098039)",
        type: "color",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: "#18274b1f",
          type: "color"
        },
        name: "sd-shadow-elevation-3-0-color",
        attributes: {},
        path: [
          "shadow",
          "elevation-3",
          "0",
          "color"
        ]
      },
      type: {
        value: "dropShadow",
        type: "type",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: "dropShadow",
          type: "type"
        },
        name: "sd-shadow-elevation-3-0-type",
        attributes: {},
        path: [
          "shadow",
          "elevation-3",
          "0",
          "type"
        ]
      },
      x: {
        value: "0px",
        type: "x",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 0,
          type: "x"
        },
        name: "sd-shadow-elevation-3-0-x",
        attributes: {},
        path: [
          "shadow",
          "elevation-3",
          "0",
          "x"
        ]
      },
      y: {
        value: "12px",
        type: "y",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 12,
          type: "y"
        },
        name: "sd-shadow-elevation-3-0-y",
        attributes: {},
        path: [
          "shadow",
          "elevation-3",
          "0",
          "y"
        ]
      },
      blur: {
        value: "42px",
        type: "blur",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 42,
          type: "blur"
        },
        name: "sd-shadow-elevation-3-0-blur",
        attributes: {},
        path: [
          "shadow",
          "elevation-3",
          "0",
          "blur"
        ]
      },
      spread: {
        value: "-4px",
        type: "spread",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: -4,
          type: "spread"
        },
        name: "sd-shadow-elevation-3-0-spread",
        attributes: {},
        path: [
          "shadow",
          "elevation-3",
          "0",
          "spread"
        ]
      }
    },
    "1": {
      color: {
        value: "rgba(24, 39, 75, 0.12156862745098039)",
        type: "color",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: "#18274b1f",
          type: "color"
        },
        name: "sd-shadow-elevation-3-1-color",
        attributes: {},
        path: [
          "shadow",
          "elevation-3",
          "1",
          "color"
        ]
      },
      type: {
        value: "dropShadow",
        type: "type",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: "dropShadow",
          type: "type"
        },
        name: "sd-shadow-elevation-3-1-type",
        attributes: {},
        path: [
          "shadow",
          "elevation-3",
          "1",
          "type"
        ]
      },
      x: {
        value: "0px",
        type: "x",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 0,
          type: "x"
        },
        name: "sd-shadow-elevation-3-1-x",
        attributes: {},
        path: [
          "shadow",
          "elevation-3",
          "1",
          "x"
        ]
      },
      y: {
        value: "4px",
        type: "y",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 4,
          type: "y"
        },
        name: "sd-shadow-elevation-3-1-y",
        attributes: {},
        path: [
          "shadow",
          "elevation-3",
          "1",
          "y"
        ]
      },
      blur: {
        value: "16px",
        type: "blur",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 16,
          type: "blur"
        },
        name: "sd-shadow-elevation-3-1-blur",
        attributes: {},
        path: [
          "shadow",
          "elevation-3",
          "1",
          "blur"
        ]
      },
      spread: {
        value: "-6px",
        type: "spread",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: -6,
          type: "spread"
        },
        name: "sd-shadow-elevation-3-1-spread",
        attributes: {},
        path: [
          "shadow",
          "elevation-3",
          "1",
          "spread"
        ]
      }
    }
  },
  "elevation-4": {
    "0": {
      color: {
        value: "rgba(24, 39, 75, 0.1607843137254902)",
        type: "color",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: "#18274b29",
          type: "color"
        },
        name: "sd-shadow-elevation-4-0-color",
        attributes: {},
        path: [
          "shadow",
          "elevation-4",
          "0",
          "color"
        ]
      },
      type: {
        value: "dropShadow",
        type: "type",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: "dropShadow",
          type: "type"
        },
        name: "sd-shadow-elevation-4-0-type",
        attributes: {},
        path: [
          "shadow",
          "elevation-4",
          "0",
          "type"
        ]
      },
      x: {
        value: "0px",
        type: "x",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 0,
          type: "x"
        },
        name: "sd-shadow-elevation-4-0-x",
        attributes: {},
        path: [
          "shadow",
          "elevation-4",
          "0",
          "x"
        ]
      },
      y: {
        value: "18px",
        type: "y",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 18,
          type: "y"
        },
        name: "sd-shadow-elevation-4-0-y",
        attributes: {},
        path: [
          "shadow",
          "elevation-4",
          "0",
          "y"
        ]
      },
      blur: {
        value: "64px",
        type: "blur",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 64,
          type: "blur"
        },
        name: "sd-shadow-elevation-4-0-blur",
        attributes: {},
        path: [
          "shadow",
          "elevation-4",
          "0",
          "blur"
        ]
      },
      spread: {
        value: "-4px",
        type: "spread",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: -4,
          type: "spread"
        },
        name: "sd-shadow-elevation-4-0-spread",
        attributes: {},
        path: [
          "shadow",
          "elevation-4",
          "0",
          "spread"
        ]
      }
    },
    "1": {
      color: {
        value: "rgba(24, 39, 75, 0.12156862745098039)",
        type: "color",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: "#18274b1f",
          type: "color"
        },
        name: "sd-shadow-elevation-4-1-color",
        attributes: {},
        path: [
          "shadow",
          "elevation-4",
          "1",
          "color"
        ]
      },
      type: {
        value: "dropShadow",
        type: "type",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: "dropShadow",
          type: "type"
        },
        name: "sd-shadow-elevation-4-1-type",
        attributes: {},
        path: [
          "shadow",
          "elevation-4",
          "1",
          "type"
        ]
      },
      x: {
        value: "0px",
        type: "x",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 0,
          type: "x"
        },
        name: "sd-shadow-elevation-4-1-x",
        attributes: {},
        path: [
          "shadow",
          "elevation-4",
          "1",
          "x"
        ]
      },
      y: {
        value: "6px",
        type: "y",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 6,
          type: "y"
        },
        name: "sd-shadow-elevation-4-1-y",
        attributes: {},
        path: [
          "shadow",
          "elevation-4",
          "1",
          "y"
        ]
      },
      blur: {
        value: "28px",
        type: "blur",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 28,
          type: "blur"
        },
        name: "sd-shadow-elevation-4-1-blur",
        attributes: {},
        path: [
          "shadow",
          "elevation-4",
          "1",
          "blur"
        ]
      },
      spread: {
        value: "-6px",
        type: "spread",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: -6,
          type: "spread"
        },
        name: "sd-shadow-elevation-4-1-spread",
        attributes: {},
        path: [
          "shadow",
          "elevation-4",
          "1",
          "spread"
        ]
      }
    }
  }
};
const typography$1 = {
  display: {
    lg: {
      fontFamily: {
        value: "Brown LL",
        type: "fontFamilies",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: "Brown LL",
          type: "fontFamilies"
        },
        name: "sd-typography-display-lg-font-family",
        attributes: {},
        path: [
          "typography",
          "display",
          "lg",
          "fontFamily"
        ]
      },
      fontWeight: {
        value: "Medium",
        type: "fontWeights",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: "Medium",
          type: "fontWeights"
        },
        name: "sd-typography-display-lg-font-weight",
        attributes: {},
        path: [
          "typography",
          "display",
          "lg",
          "fontWeight"
        ]
      },
      lineHeight: {
        value: "72px",
        type: "lineHeight",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 72,
          type: "lineHeight"
        },
        name: "sd-typography-display-lg-line-height",
        attributes: {},
        path: [
          "typography",
          "display",
          "lg",
          "lineHeight"
        ]
      },
      fontSize: {
        value: "64px",
        type: "fontSizes",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 64,
          type: "fontSizes"
        },
        name: "sd-typography-display-lg-font-size",
        attributes: {},
        path: [
          "typography",
          "display",
          "lg",
          "fontSize"
        ]
      },
      letterSpacing: {
        value: "0px",
        type: "letterSpacing",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 0,
          type: "letterSpacing"
        },
        name: "sd-typography-display-lg-letter-spacing",
        attributes: {},
        path: [
          "typography",
          "display",
          "lg",
          "letterSpacing"
        ]
      },
      textDecoration: {
        value: "none",
        type: "textDecoration",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: "none",
          type: "textDecoration"
        },
        name: "sd-typography-display-lg-text-decoration",
        attributes: {},
        path: [
          "typography",
          "display",
          "lg",
          "textDecoration"
        ]
      }
    },
    md: {
      fontFamily: {
        value: "Brown LL",
        type: "fontFamilies",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: "Brown LL",
          type: "fontFamilies"
        },
        name: "sd-typography-display-md-font-family",
        attributes: {},
        path: [
          "typography",
          "display",
          "md",
          "fontFamily"
        ]
      },
      fontWeight: {
        value: "Bold",
        type: "fontWeights",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: "Bold",
          type: "fontWeights"
        },
        name: "sd-typography-display-md-font-weight",
        attributes: {},
        path: [
          "typography",
          "display",
          "md",
          "fontWeight"
        ]
      },
      lineHeight: {
        value: "64px",
        type: "lineHeight",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 64,
          type: "lineHeight"
        },
        name: "sd-typography-display-md-line-height",
        attributes: {},
        path: [
          "typography",
          "display",
          "md",
          "lineHeight"
        ]
      },
      fontSize: {
        value: "56px",
        type: "fontSizes",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 56,
          type: "fontSizes"
        },
        name: "sd-typography-display-md-font-size",
        attributes: {},
        path: [
          "typography",
          "display",
          "md",
          "fontSize"
        ]
      },
      letterSpacing: {
        value: "0px",
        type: "letterSpacing",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 0,
          type: "letterSpacing"
        },
        name: "sd-typography-display-md-letter-spacing",
        attributes: {},
        path: [
          "typography",
          "display",
          "md",
          "letterSpacing"
        ]
      },
      textDecoration: {
        value: "none",
        type: "textDecoration",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: "none",
          type: "textDecoration"
        },
        name: "sd-typography-display-md-text-decoration",
        attributes: {},
        path: [
          "typography",
          "display",
          "md",
          "textDecoration"
        ]
      }
    },
    sm: {
      fontFamily: {
        value: "Brown LL",
        type: "fontFamilies",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: "Brown LL",
          type: "fontFamilies"
        },
        name: "sd-typography-display-sm-font-family",
        attributes: {},
        path: [
          "typography",
          "display",
          "sm",
          "fontFamily"
        ]
      },
      fontWeight: {
        value: "Medium",
        type: "fontWeights",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: "Medium",
          type: "fontWeights"
        },
        name: "sd-typography-display-sm-font-weight",
        attributes: {},
        path: [
          "typography",
          "display",
          "sm",
          "fontWeight"
        ]
      },
      lineHeight: {
        value: "48px",
        type: "lineHeight",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 48,
          type: "lineHeight"
        },
        name: "sd-typography-display-sm-line-height",
        attributes: {},
        path: [
          "typography",
          "display",
          "sm",
          "lineHeight"
        ]
      },
      fontSize: {
        value: "40px",
        type: "fontSizes",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 40,
          type: "fontSizes"
        },
        name: "sd-typography-display-sm-font-size",
        attributes: {},
        path: [
          "typography",
          "display",
          "sm",
          "fontSize"
        ]
      },
      letterSpacing: {
        value: "0px",
        type: "letterSpacing",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 0,
          type: "letterSpacing"
        },
        name: "sd-typography-display-sm-letter-spacing",
        attributes: {},
        path: [
          "typography",
          "display",
          "sm",
          "letterSpacing"
        ]
      },
      textDecoration: {
        value: "none",
        type: "textDecoration",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: "none",
          type: "textDecoration"
        },
        name: "sd-typography-display-sm-text-decoration",
        attributes: {},
        path: [
          "typography",
          "display",
          "sm",
          "textDecoration"
        ]
      }
    }
  },
  headline: {
    xl: {
      fontFamily: {
        value: "Brown LL",
        type: "fontFamilies",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: "Brown LL",
          type: "fontFamilies"
        },
        name: "sd-typography-headline-xl-font-family",
        attributes: {},
        path: [
          "typography",
          "headline",
          "xl",
          "fontFamily"
        ]
      },
      fontWeight: {
        value: "Bold",
        type: "fontWeights",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: "Bold",
          type: "fontWeights"
        },
        name: "sd-typography-headline-xl-font-weight",
        attributes: {},
        path: [
          "typography",
          "headline",
          "xl",
          "fontWeight"
        ]
      },
      lineHeight: {
        value: "40px",
        type: "lineHeight",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 40,
          type: "lineHeight"
        },
        name: "sd-typography-headline-xl-line-height",
        attributes: {},
        path: [
          "typography",
          "headline",
          "xl",
          "lineHeight"
        ]
      },
      fontSize: {
        value: "32px",
        type: "fontSizes",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 32,
          type: "fontSizes"
        },
        name: "sd-typography-headline-xl-font-size",
        attributes: {},
        path: [
          "typography",
          "headline",
          "xl",
          "fontSize"
        ]
      },
      letterSpacing: {
        value: "-1px",
        type: "letterSpacing",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: -1,
          type: "letterSpacing"
        },
        name: "sd-typography-headline-xl-letter-spacing",
        attributes: {},
        path: [
          "typography",
          "headline",
          "xl",
          "letterSpacing"
        ]
      },
      textDecoration: {
        value: "none",
        type: "textDecoration",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: "none",
          type: "textDecoration"
        },
        name: "sd-typography-headline-xl-text-decoration",
        attributes: {},
        path: [
          "typography",
          "headline",
          "xl",
          "textDecoration"
        ]
      }
    },
    lg: {
      fontFamily: {
        value: "Brown LL",
        type: "fontFamilies",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: "Brown LL",
          type: "fontFamilies"
        },
        name: "sd-typography-headline-lg-font-family",
        attributes: {},
        path: [
          "typography",
          "headline",
          "lg",
          "fontFamily"
        ]
      },
      fontWeight: {
        value: "Bold",
        type: "fontWeights",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: "Bold",
          type: "fontWeights"
        },
        name: "sd-typography-headline-lg-font-weight",
        attributes: {},
        path: [
          "typography",
          "headline",
          "lg",
          "fontWeight"
        ]
      },
      lineHeight: {
        value: "32px",
        type: "lineHeight",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 32,
          type: "lineHeight"
        },
        name: "sd-typography-headline-lg-line-height",
        attributes: {},
        path: [
          "typography",
          "headline",
          "lg",
          "lineHeight"
        ]
      },
      fontSize: {
        value: "24px",
        type: "fontSizes",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 24,
          type: "fontSizes"
        },
        name: "sd-typography-headline-lg-font-size",
        attributes: {},
        path: [
          "typography",
          "headline",
          "lg",
          "fontSize"
        ]
      },
      letterSpacing: {
        value: "-0.75px",
        type: "letterSpacing",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: -0.75,
          type: "letterSpacing"
        },
        name: "sd-typography-headline-lg-letter-spacing",
        attributes: {},
        path: [
          "typography",
          "headline",
          "lg",
          "letterSpacing"
        ]
      },
      textDecoration: {
        value: "none",
        type: "textDecoration",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: "none",
          type: "textDecoration"
        },
        name: "sd-typography-headline-lg-text-decoration",
        attributes: {},
        path: [
          "typography",
          "headline",
          "lg",
          "textDecoration"
        ]
      }
    },
    md: {
      fontFamily: {
        value: "Brown LL",
        type: "fontFamilies",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: "Brown LL",
          type: "fontFamilies"
        },
        name: "sd-typography-headline-md-font-family",
        attributes: {},
        path: [
          "typography",
          "headline",
          "md",
          "fontFamily"
        ]
      },
      fontWeight: {
        value: "Bold",
        type: "fontWeights",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: "Bold",
          type: "fontWeights"
        },
        name: "sd-typography-headline-md-font-weight",
        attributes: {},
        path: [
          "typography",
          "headline",
          "md",
          "fontWeight"
        ]
      },
      lineHeight: {
        value: "26px",
        type: "lineHeight",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 26,
          type: "lineHeight"
        },
        name: "sd-typography-headline-md-line-height",
        attributes: {},
        path: [
          "typography",
          "headline",
          "md",
          "lineHeight"
        ]
      },
      fontSize: {
        value: "20px",
        type: "fontSizes",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 20,
          type: "fontSizes"
        },
        name: "sd-typography-headline-md-font-size",
        attributes: {},
        path: [
          "typography",
          "headline",
          "md",
          "fontSize"
        ]
      },
      letterSpacing: {
        value: "-0.25px",
        type: "letterSpacing",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: -0.25,
          type: "letterSpacing"
        },
        name: "sd-typography-headline-md-letter-spacing",
        attributes: {},
        path: [
          "typography",
          "headline",
          "md",
          "letterSpacing"
        ]
      },
      textDecoration: {
        value: "none",
        type: "textDecoration",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: "none",
          type: "textDecoration"
        },
        name: "sd-typography-headline-md-text-decoration",
        attributes: {},
        path: [
          "typography",
          "headline",
          "md",
          "textDecoration"
        ]
      }
    },
    sm: {
      fontFamily: {
        value: "Brown LL",
        type: "fontFamilies",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: "Brown LL",
          type: "fontFamilies"
        },
        name: "sd-typography-headline-sm-font-family",
        attributes: {},
        path: [
          "typography",
          "headline",
          "sm",
          "fontFamily"
        ]
      },
      fontWeight: {
        value: "Bold",
        type: "fontWeights",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: "Bold",
          type: "fontWeights"
        },
        name: "sd-typography-headline-sm-font-weight",
        attributes: {},
        path: [
          "typography",
          "headline",
          "sm",
          "fontWeight"
        ]
      },
      lineHeight: {
        value: "24px",
        type: "lineHeight",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 24,
          type: "lineHeight"
        },
        name: "sd-typography-headline-sm-line-height",
        attributes: {},
        path: [
          "typography",
          "headline",
          "sm",
          "lineHeight"
        ]
      },
      fontSize: {
        value: "18px",
        type: "fontSizes",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 18,
          type: "fontSizes"
        },
        name: "sd-typography-headline-sm-font-size",
        attributes: {},
        path: [
          "typography",
          "headline",
          "sm",
          "fontSize"
        ]
      },
      letterSpacing: {
        value: "-0.5px",
        type: "letterSpacing",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: -0.5,
          type: "letterSpacing"
        },
        name: "sd-typography-headline-sm-letter-spacing",
        attributes: {},
        path: [
          "typography",
          "headline",
          "sm",
          "letterSpacing"
        ]
      },
      textDecoration: {
        value: "none",
        type: "textDecoration",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: "none",
          type: "textDecoration"
        },
        name: "sd-typography-headline-sm-text-decoration",
        attributes: {},
        path: [
          "typography",
          "headline",
          "sm",
          "textDecoration"
        ]
      }
    },
    xs: {
      fontFamily: {
        value: "Brown LL",
        type: "fontFamilies",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: "Brown LL",
          type: "fontFamilies"
        },
        name: "sd-typography-headline-xs-font-family",
        attributes: {},
        path: [
          "typography",
          "headline",
          "xs",
          "fontFamily"
        ]
      },
      fontWeight: {
        value: "Bold",
        type: "fontWeights",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: "Bold",
          type: "fontWeights"
        },
        name: "sd-typography-headline-xs-font-weight",
        attributes: {},
        path: [
          "typography",
          "headline",
          "xs",
          "fontWeight"
        ]
      },
      lineHeight: {
        value: "20px",
        type: "lineHeight",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 20,
          type: "lineHeight"
        },
        name: "sd-typography-headline-xs-line-height",
        attributes: {},
        path: [
          "typography",
          "headline",
          "xs",
          "lineHeight"
        ]
      },
      fontSize: {
        value: "16px",
        type: "fontSizes",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 16,
          type: "fontSizes"
        },
        name: "sd-typography-headline-xs-font-size",
        attributes: {},
        path: [
          "typography",
          "headline",
          "xs",
          "fontSize"
        ]
      },
      letterSpacing: {
        value: "-0.5px",
        type: "letterSpacing",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: -0.5,
          type: "letterSpacing"
        },
        name: "sd-typography-headline-xs-letter-spacing",
        attributes: {},
        path: [
          "typography",
          "headline",
          "xs",
          "letterSpacing"
        ]
      },
      textDecoration: {
        value: "none",
        type: "textDecoration",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: "none",
          type: "textDecoration"
        },
        name: "sd-typography-headline-xs-text-decoration",
        attributes: {},
        path: [
          "typography",
          "headline",
          "xs",
          "textDecoration"
        ]
      }
    },
    xxs: {
      fontFamily: {
        value: "Brown LL",
        type: "fontFamilies",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: "Brown LL",
          type: "fontFamilies"
        },
        name: "sd-typography-headline-xxs-font-family",
        attributes: {},
        path: [
          "typography",
          "headline",
          "xxs",
          "fontFamily"
        ]
      },
      fontWeight: {
        value: "Bold",
        type: "fontWeights",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: "Bold",
          type: "fontWeights"
        },
        name: "sd-typography-headline-xxs-font-weight",
        attributes: {},
        path: [
          "typography",
          "headline",
          "xxs",
          "fontWeight"
        ]
      },
      lineHeight: {
        value: "18px",
        type: "lineHeight",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 18,
          type: "lineHeight"
        },
        name: "sd-typography-headline-xxs-line-height",
        attributes: {},
        path: [
          "typography",
          "headline",
          "xxs",
          "lineHeight"
        ]
      },
      fontSize: {
        value: "14px",
        type: "fontSizes",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 14,
          type: "fontSizes"
        },
        name: "sd-typography-headline-xxs-font-size",
        attributes: {},
        path: [
          "typography",
          "headline",
          "xxs",
          "fontSize"
        ]
      },
      letterSpacing: {
        value: "-0.25px",
        type: "letterSpacing",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: -0.25,
          type: "letterSpacing"
        },
        name: "sd-typography-headline-xxs-letter-spacing",
        attributes: {},
        path: [
          "typography",
          "headline",
          "xxs",
          "letterSpacing"
        ]
      },
      textDecoration: {
        value: "none",
        type: "textDecoration",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: "none",
          type: "textDecoration"
        },
        name: "sd-typography-headline-xxs-text-decoration",
        attributes: {},
        path: [
          "typography",
          "headline",
          "xxs",
          "textDecoration"
        ]
      }
    }
  },
  body: {
    xl: {
      fontFamily: {
        value: "Brown LL",
        type: "fontFamilies",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: "Brown LL",
          type: "fontFamilies"
        },
        name: "sd-typography-body-xl-font-family",
        attributes: {},
        path: [
          "typography",
          "body",
          "xl",
          "fontFamily"
        ]
      },
      fontWeight: {
        value: "Regular",
        type: "fontWeights",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: "Regular",
          type: "fontWeights"
        },
        name: "sd-typography-body-xl-font-weight",
        attributes: {},
        path: [
          "typography",
          "body",
          "xl",
          "fontWeight"
        ]
      },
      lineHeight: {
        value: "24px",
        type: "lineHeight",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 24,
          type: "lineHeight"
        },
        name: "sd-typography-body-xl-line-height",
        attributes: {},
        path: [
          "typography",
          "body",
          "xl",
          "lineHeight"
        ]
      },
      fontSize: {
        value: "18px",
        type: "fontSizes",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 18,
          type: "fontSizes"
        },
        name: "sd-typography-body-xl-font-size",
        attributes: {},
        path: [
          "typography",
          "body",
          "xl",
          "fontSize"
        ]
      },
      letterSpacing: {
        value: "-0.5px",
        type: "letterSpacing",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: -0.5,
          type: "letterSpacing"
        },
        name: "sd-typography-body-xl-letter-spacing",
        attributes: {},
        path: [
          "typography",
          "body",
          "xl",
          "letterSpacing"
        ]
      },
      textDecoration: {
        value: "none",
        type: "textDecoration",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: "none",
          type: "textDecoration"
        },
        name: "sd-typography-body-xl-text-decoration",
        attributes: {},
        path: [
          "typography",
          "body",
          "xl",
          "textDecoration"
        ]
      }
    },
    lg: {
      fontFamily: {
        value: "Brown LL",
        type: "fontFamilies",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: "Brown LL",
          type: "fontFamilies"
        },
        name: "sd-typography-body-lg-font-family",
        attributes: {},
        path: [
          "typography",
          "body",
          "lg",
          "fontFamily"
        ]
      },
      fontWeight: {
        value: "Regular",
        type: "fontWeights",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: "Regular",
          type: "fontWeights"
        },
        name: "sd-typography-body-lg-font-weight",
        attributes: {},
        path: [
          "typography",
          "body",
          "lg",
          "fontWeight"
        ]
      },
      lineHeight: {
        value: "20px",
        type: "lineHeight",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 20,
          type: "lineHeight"
        },
        name: "sd-typography-body-lg-line-height",
        attributes: {},
        path: [
          "typography",
          "body",
          "lg",
          "lineHeight"
        ]
      },
      fontSize: {
        value: "16px",
        type: "fontSizes",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 16,
          type: "fontSizes"
        },
        name: "sd-typography-body-lg-font-size",
        attributes: {},
        path: [
          "typography",
          "body",
          "lg",
          "fontSize"
        ]
      },
      letterSpacing: {
        value: "-0.5px",
        type: "letterSpacing",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: -0.5,
          type: "letterSpacing"
        },
        name: "sd-typography-body-lg-letter-spacing",
        attributes: {},
        path: [
          "typography",
          "body",
          "lg",
          "letterSpacing"
        ]
      },
      textDecoration: {
        value: "none",
        type: "textDecoration",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: "none",
          type: "textDecoration"
        },
        name: "sd-typography-body-lg-text-decoration",
        attributes: {},
        path: [
          "typography",
          "body",
          "lg",
          "textDecoration"
        ]
      }
    },
    md: {
      fontFamily: {
        value: "Brown LL",
        type: "fontFamilies",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: "Brown LL",
          type: "fontFamilies"
        },
        name: "sd-typography-body-md-font-family",
        attributes: {},
        path: [
          "typography",
          "body",
          "md",
          "fontFamily"
        ]
      },
      fontWeight: {
        value: "Regular",
        type: "fontWeights",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: "Regular",
          type: "fontWeights"
        },
        name: "sd-typography-body-md-font-weight",
        attributes: {},
        path: [
          "typography",
          "body",
          "md",
          "fontWeight"
        ]
      },
      lineHeight: {
        value: "18px",
        type: "lineHeight",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 18,
          type: "lineHeight"
        },
        name: "sd-typography-body-md-line-height",
        attributes: {},
        path: [
          "typography",
          "body",
          "md",
          "lineHeight"
        ]
      },
      fontSize: {
        value: "14px",
        type: "fontSizes",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 14,
          type: "fontSizes"
        },
        name: "sd-typography-body-md-font-size",
        attributes: {},
        path: [
          "typography",
          "body",
          "md",
          "fontSize"
        ]
      },
      letterSpacing: {
        value: "-0.25px",
        type: "letterSpacing",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: -0.25,
          type: "letterSpacing"
        },
        name: "sd-typography-body-md-letter-spacing",
        attributes: {},
        path: [
          "typography",
          "body",
          "md",
          "letterSpacing"
        ]
      },
      textDecoration: {
        value: "none",
        type: "textDecoration",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: "none",
          type: "textDecoration"
        },
        name: "sd-typography-body-md-text-decoration",
        attributes: {},
        path: [
          "typography",
          "body",
          "md",
          "textDecoration"
        ]
      }
    },
    sm: {
      fontFamily: {
        value: "Brown LL",
        type: "fontFamilies",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: "Brown LL",
          type: "fontFamilies"
        },
        name: "sd-typography-body-sm-font-family",
        attributes: {},
        path: [
          "typography",
          "body",
          "sm",
          "fontFamily"
        ]
      },
      fontWeight: {
        value: "Regular",
        type: "fontWeights",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: "Regular",
          type: "fontWeights"
        },
        name: "sd-typography-body-sm-font-weight",
        attributes: {},
        path: [
          "typography",
          "body",
          "sm",
          "fontWeight"
        ]
      },
      lineHeight: {
        value: "16px",
        type: "lineHeight",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 16,
          type: "lineHeight"
        },
        name: "sd-typography-body-sm-line-height",
        attributes: {},
        path: [
          "typography",
          "body",
          "sm",
          "lineHeight"
        ]
      },
      fontSize: {
        value: "12px",
        type: "fontSizes",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 12,
          type: "fontSizes"
        },
        name: "sd-typography-body-sm-font-size",
        attributes: {},
        path: [
          "typography",
          "body",
          "sm",
          "fontSize"
        ]
      },
      letterSpacing: {
        value: "-0.25px",
        type: "letterSpacing",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: -0.25,
          type: "letterSpacing"
        },
        name: "sd-typography-body-sm-letter-spacing",
        attributes: {},
        path: [
          "typography",
          "body",
          "sm",
          "letterSpacing"
        ]
      },
      textDecoration: {
        value: "none",
        type: "textDecoration",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: "none",
          type: "textDecoration"
        },
        name: "sd-typography-body-sm-text-decoration",
        attributes: {},
        path: [
          "typography",
          "body",
          "sm",
          "textDecoration"
        ]
      }
    }
  },
  label: {
    lg: {
      fontFamily: {
        value: "Brown LL",
        type: "fontFamilies",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: "Brown LL",
          type: "fontFamilies"
        },
        name: "sd-typography-label-lg-font-family",
        attributes: {},
        path: [
          "typography",
          "label",
          "lg",
          "fontFamily"
        ]
      },
      fontWeight: {
        value: "Medium",
        type: "fontWeights",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: "Medium",
          type: "fontWeights"
        },
        name: "sd-typography-label-lg-font-weight",
        attributes: {},
        path: [
          "typography",
          "label",
          "lg",
          "fontWeight"
        ]
      },
      lineHeight: {
        value: "20px",
        type: "lineHeight",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 20,
          type: "lineHeight"
        },
        name: "sd-typography-label-lg-line-height",
        attributes: {},
        path: [
          "typography",
          "label",
          "lg",
          "lineHeight"
        ]
      },
      fontSize: {
        value: "16px",
        type: "fontSizes",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 16,
          type: "fontSizes"
        },
        name: "sd-typography-label-lg-font-size",
        attributes: {},
        path: [
          "typography",
          "label",
          "lg",
          "fontSize"
        ]
      },
      letterSpacing: {
        value: "-0.5px",
        type: "letterSpacing",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: -0.5,
          type: "letterSpacing"
        },
        name: "sd-typography-label-lg-letter-spacing",
        attributes: {},
        path: [
          "typography",
          "label",
          "lg",
          "letterSpacing"
        ]
      },
      textDecoration: {
        value: "none",
        type: "textDecoration",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: "none",
          type: "textDecoration"
        },
        name: "sd-typography-label-lg-text-decoration",
        attributes: {},
        path: [
          "typography",
          "label",
          "lg",
          "textDecoration"
        ]
      }
    },
    md: {
      fontFamily: {
        value: "Brown LL",
        type: "fontFamilies",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: "Brown LL",
          type: "fontFamilies"
        },
        name: "sd-typography-label-md-font-family",
        attributes: {},
        path: [
          "typography",
          "label",
          "md",
          "fontFamily"
        ]
      },
      fontWeight: {
        value: "Medium",
        type: "fontWeights",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: "Medium",
          type: "fontWeights"
        },
        name: "sd-typography-label-md-font-weight",
        attributes: {},
        path: [
          "typography",
          "label",
          "md",
          "fontWeight"
        ]
      },
      lineHeight: {
        value: "18px",
        type: "lineHeight",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 18,
          type: "lineHeight"
        },
        name: "sd-typography-label-md-line-height",
        attributes: {},
        path: [
          "typography",
          "label",
          "md",
          "lineHeight"
        ]
      },
      fontSize: {
        value: "14px",
        type: "fontSizes",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 14,
          type: "fontSizes"
        },
        name: "sd-typography-label-md-font-size",
        attributes: {},
        path: [
          "typography",
          "label",
          "md",
          "fontSize"
        ]
      },
      letterSpacing: {
        value: "-0.5px",
        type: "letterSpacing",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: -0.5,
          type: "letterSpacing"
        },
        name: "sd-typography-label-md-letter-spacing",
        attributes: {},
        path: [
          "typography",
          "label",
          "md",
          "letterSpacing"
        ]
      },
      textDecoration: {
        value: "none",
        type: "textDecoration",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: "none",
          type: "textDecoration"
        },
        name: "sd-typography-label-md-text-decoration",
        attributes: {},
        path: [
          "typography",
          "label",
          "md",
          "textDecoration"
        ]
      }
    },
    sm: {
      fontFamily: {
        value: "Brown LL",
        type: "fontFamilies",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: "Brown LL",
          type: "fontFamilies"
        },
        name: "sd-typography-label-sm-font-family",
        attributes: {},
        path: [
          "typography",
          "label",
          "sm",
          "fontFamily"
        ]
      },
      fontWeight: {
        value: "Bold",
        type: "fontWeights",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: "Bold",
          type: "fontWeights"
        },
        name: "sd-typography-label-sm-font-weight",
        attributes: {},
        path: [
          "typography",
          "label",
          "sm",
          "fontWeight"
        ]
      },
      lineHeight: {
        value: "16px",
        type: "lineHeight",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 16,
          type: "lineHeight"
        },
        name: "sd-typography-label-sm-line-height",
        attributes: {},
        path: [
          "typography",
          "label",
          "sm",
          "lineHeight"
        ]
      },
      fontSize: {
        value: "12px",
        type: "fontSizes",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 12,
          type: "fontSizes"
        },
        name: "sd-typography-label-sm-font-size",
        attributes: {},
        path: [
          "typography",
          "label",
          "sm",
          "fontSize"
        ]
      },
      letterSpacing: {
        value: "0px",
        type: "letterSpacing",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 0,
          type: "letterSpacing"
        },
        name: "sd-typography-label-sm-letter-spacing",
        attributes: {},
        path: [
          "typography",
          "label",
          "sm",
          "letterSpacing"
        ]
      },
      textDecoration: {
        value: "none",
        type: "textDecoration",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: "none",
          type: "textDecoration"
        },
        name: "sd-typography-label-sm-text-decoration",
        attributes: {},
        path: [
          "typography",
          "label",
          "sm",
          "textDecoration"
        ]
      }
    },
    xs: {
      fontFamily: {
        value: "Brown LL",
        type: "fontFamilies",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: "Brown LL",
          type: "fontFamilies"
        },
        name: "sd-typography-label-xs-font-family",
        attributes: {},
        path: [
          "typography",
          "label",
          "xs",
          "fontFamily"
        ]
      },
      fontWeight: {
        value: "Bold",
        type: "fontWeights",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: "Bold",
          type: "fontWeights"
        },
        name: "sd-typography-label-xs-font-weight",
        attributes: {},
        path: [
          "typography",
          "label",
          "xs",
          "fontWeight"
        ]
      },
      lineHeight: {
        value: "14px",
        type: "lineHeight",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 14,
          type: "lineHeight"
        },
        name: "sd-typography-label-xs-line-height",
        attributes: {},
        path: [
          "typography",
          "label",
          "xs",
          "lineHeight"
        ]
      },
      fontSize: {
        value: "10px",
        type: "fontSizes",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: 10,
          type: "fontSizes"
        },
        name: "sd-typography-label-xs-font-size",
        attributes: {},
        path: [
          "typography",
          "label",
          "xs",
          "fontSize"
        ]
      },
      letterSpacing: {
        value: "-0.25px",
        type: "letterSpacing",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: -0.25,
          type: "letterSpacing"
        },
        name: "sd-typography-label-xs-letter-spacing",
        attributes: {},
        path: [
          "typography",
          "label",
          "xs",
          "letterSpacing"
        ]
      },
      textDecoration: {
        value: "none",
        type: "textDecoration",
        filePath: "themes/videoleap-light.json",
        isSource: true,
        original: {
          value: "none",
          type: "textDecoration"
        },
        name: "sd-typography-label-xs-text-decoration",
        attributes: {},
        path: [
          "typography",
          "label",
          "xs",
          "textDecoration"
        ]
      }
    }
  }
};
const border = {
  "default": {
    value: {
      color: "#2c2d301f",
      width: 1
    },
    type: "border",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: {
        color: "#2c2d301f",
        width: 1
      },
      type: "border"
    },
    name: "sd-border-default",
    attributes: {},
    path: [
      "border",
      "default"
    ]
  },
  focused: {
    value: {
      color: "#2c2d30",
      width: 1
    },
    type: "border",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: {
        color: "#2c2d30",
        width: 1
      },
      type: "border"
    },
    name: "sd-border-focused",
    attributes: {},
    path: [
      "border",
      "focused"
    ]
  },
  selected: {
    value: {
      color: "#f44b49",
      width: 2
    },
    type: "border",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: {
        color: "#f44b49",
        width: 2
      },
      type: "border"
    },
    name: "sd-border-selected",
    attributes: {},
    path: [
      "border",
      "selected"
    ]
  },
  danger: {
    value: {
      color: "#ff3b30",
      width: 1
    },
    type: "border",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: {
        color: "#ff3b30",
        width: 1
      },
      type: "border"
    },
    name: "sd-border-danger",
    attributes: {},
    path: [
      "border",
      "danger"
    ]
  },
  warning: {
    value: {
      color: "#ebac13",
      width: 1
    },
    type: "border",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: {
        color: "#ebac13",
        width: 1
      },
      type: "border"
    },
    name: "sd-border-warning",
    attributes: {},
    path: [
      "border",
      "warning"
    ]
  },
  success: {
    value: {
      color: "#16a34a",
      width: 1
    },
    type: "border",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: {
        color: "#16a34a",
        width: 1
      },
      type: "border"
    },
    name: "sd-border-success",
    attributes: {},
    path: [
      "border",
      "success"
    ]
  },
  overlay: {
    value: {
      color: "#ffffff1f",
      width: 1
    },
    type: "border",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: {
        color: "#ffffff1f",
        width: 1
      },
      type: "border"
    },
    name: "sd-border-overlay",
    attributes: {},
    path: [
      "border",
      "overlay"
    ]
  }
};
const opacity = {
  "0": {
    value: 0,
    type: "opacity",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 0,
      type: "opacity"
    },
    name: "sd-opacity-0",
    attributes: {},
    path: [
      "opacity",
      "0"
    ]
  },
  "20": {
    value: 0.02,
    type: "opacity",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 0.02,
      type: "opacity"
    },
    name: "sd-opacity-20",
    attributes: {},
    path: [
      "opacity",
      "20"
    ]
  },
  "40": {
    value: 0.04,
    type: "opacity",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 0.04,
      type: "opacity"
    },
    name: "sd-opacity-40",
    attributes: {},
    path: [
      "opacity",
      "40"
    ]
  },
  "60": {
    value: 0.06,
    type: "opacity",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 0.06,
      type: "opacity"
    },
    name: "sd-opacity-60",
    attributes: {},
    path: [
      "opacity",
      "60"
    ]
  },
  "80": {
    value: 0.08,
    type: "opacity",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 0.08,
      type: "opacity"
    },
    name: "sd-opacity-80",
    attributes: {},
    path: [
      "opacity",
      "80"
    ]
  },
  "100": {
    value: 0.1,
    type: "opacity",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 0.1,
      type: "opacity"
    },
    name: "sd-opacity-100",
    attributes: {},
    path: [
      "opacity",
      "100"
    ]
  },
  "120": {
    value: 0.12,
    type: "opacity",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 0.12,
      type: "opacity"
    },
    name: "sd-opacity-120",
    attributes: {},
    path: [
      "opacity",
      "120"
    ]
  },
  "160": {
    value: 0.16,
    type: "opacity",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 0.16,
      type: "opacity"
    },
    name: "sd-opacity-160",
    attributes: {},
    path: [
      "opacity",
      "160"
    ]
  },
  "200": {
    value: 0.2,
    type: "opacity",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 0.2,
      type: "opacity"
    },
    name: "sd-opacity-200",
    attributes: {},
    path: [
      "opacity",
      "200"
    ]
  },
  "250": {
    value: 0.25,
    type: "opacity",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 0.25,
      type: "opacity"
    },
    name: "sd-opacity-250",
    attributes: {},
    path: [
      "opacity",
      "250"
    ]
  },
  "300": {
    value: 0.3,
    type: "opacity",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 0.3,
      type: "opacity"
    },
    name: "sd-opacity-300",
    attributes: {},
    path: [
      "opacity",
      "300"
    ]
  },
  "350": {
    value: 0.35,
    type: "opacity",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 0.35,
      type: "opacity"
    },
    name: "sd-opacity-350",
    attributes: {},
    path: [
      "opacity",
      "350"
    ]
  },
  "400": {
    value: 0.4,
    type: "opacity",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 0.4,
      type: "opacity"
    },
    name: "sd-opacity-400",
    attributes: {},
    path: [
      "opacity",
      "400"
    ]
  },
  "500": {
    value: 0.5,
    type: "opacity",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 0.5,
      type: "opacity"
    },
    name: "sd-opacity-500",
    attributes: {},
    path: [
      "opacity",
      "500"
    ]
  },
  "600": {
    value: 0.6,
    type: "opacity",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 0.6,
      type: "opacity"
    },
    name: "sd-opacity-600",
    attributes: {},
    path: [
      "opacity",
      "600"
    ]
  },
  "700": {
    value: 0.7,
    type: "opacity",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 0.7,
      type: "opacity"
    },
    name: "sd-opacity-700",
    attributes: {},
    path: [
      "opacity",
      "700"
    ]
  },
  "800": {
    value: 0.8,
    type: "opacity",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 0.8,
      type: "opacity"
    },
    name: "sd-opacity-800",
    attributes: {},
    path: [
      "opacity",
      "800"
    ]
  },
  "900": {
    value: 0.9,
    type: "opacity",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 0.9,
      type: "opacity"
    },
    name: "sd-opacity-900",
    attributes: {},
    path: [
      "opacity",
      "900"
    ]
  },
  "1000": {
    value: 1,
    type: "opacity",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 1,
      type: "opacity"
    },
    name: "sd-opacity-1000",
    attributes: {},
    path: [
      "opacity",
      "1000"
    ]
  },
  none: {
    value: 0,
    type: "opacity",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 0,
      type: "opacity"
    },
    name: "sd-opacity-none",
    attributes: {},
    path: [
      "opacity",
      "none"
    ]
  },
  low: {
    value: 0.2,
    type: "opacity",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 0.2,
      type: "opacity"
    },
    name: "sd-opacity-low",
    attributes: {},
    path: [
      "opacity",
      "low"
    ]
  },
  mid: {
    value: 0.5,
    type: "opacity",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 0.5,
      type: "opacity"
    },
    name: "sd-opacity-mid",
    attributes: {},
    path: [
      "opacity",
      "mid"
    ]
  },
  high: {
    value: 0.8,
    type: "opacity",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 0.8,
      type: "opacity"
    },
    name: "sd-opacity-high",
    attributes: {},
    path: [
      "opacity",
      "high"
    ]
  }
};
const space = {
  "0": {
    value: "0px",
    type: "spacing",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 0,
      type: "spacing"
    },
    name: "sd-space-0",
    attributes: {},
    path: [
      "space",
      "0"
    ]
  },
  "25": {
    value: "2px",
    type: "spacing",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 2,
      type: "spacing"
    },
    name: "sd-space-25",
    attributes: {},
    path: [
      "space",
      "25"
    ]
  },
  "50": {
    value: "4px",
    type: "spacing",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 4,
      type: "spacing"
    },
    name: "sd-space-50",
    attributes: {},
    path: [
      "space",
      "50"
    ]
  },
  "75": {
    value: "6px",
    type: "spacing",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 6,
      type: "spacing"
    },
    name: "sd-space-75",
    attributes: {},
    path: [
      "space",
      "75"
    ]
  },
  "100": {
    value: "8px",
    type: "spacing",
    description: "Base size\n",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 8,
      type: "spacing",
      description: "Base size\n"
    },
    name: "sd-space-100",
    attributes: {},
    path: [
      "space",
      "100"
    ]
  },
  "125": {
    value: "10px",
    type: "spacing",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 10,
      type: "spacing"
    },
    name: "sd-space-125",
    attributes: {},
    path: [
      "space",
      "125"
    ]
  },
  "150": {
    value: "12px",
    type: "spacing",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 12,
      type: "spacing"
    },
    name: "sd-space-150",
    attributes: {},
    path: [
      "space",
      "150"
    ]
  },
  "175": {
    value: "14px",
    type: "spacing",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 14,
      type: "spacing"
    },
    name: "sd-space-175",
    attributes: {},
    path: [
      "space",
      "175"
    ]
  },
  "200": {
    value: "16px",
    type: "spacing",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 16,
      type: "spacing"
    },
    name: "sd-space-200",
    attributes: {},
    path: [
      "space",
      "200"
    ]
  },
  "250": {
    value: "20px",
    type: "spacing",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 20,
      type: "spacing"
    },
    name: "sd-space-250",
    attributes: {},
    path: [
      "space",
      "250"
    ]
  },
  "300": {
    value: "24px",
    type: "spacing",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 24,
      type: "spacing"
    },
    name: "sd-space-300",
    attributes: {},
    path: [
      "space",
      "300"
    ]
  },
  "350": {
    value: "28px",
    type: "spacing",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 28,
      type: "spacing"
    },
    name: "sd-space-350",
    attributes: {},
    path: [
      "space",
      "350"
    ]
  },
  "400": {
    value: "32px",
    type: "spacing",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 32,
      type: "spacing"
    },
    name: "sd-space-400",
    attributes: {},
    path: [
      "space",
      "400"
    ]
  },
  "450": {
    value: "36px",
    type: "spacing",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 36,
      type: "spacing"
    },
    name: "sd-space-450",
    attributes: {},
    path: [
      "space",
      "450"
    ]
  },
  "500": {
    value: "40px",
    type: "spacing",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 40,
      type: "spacing"
    },
    name: "sd-space-500",
    attributes: {},
    path: [
      "space",
      "500"
    ]
  },
  "550": {
    value: "44px",
    type: "spacing",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 44,
      type: "spacing"
    },
    name: "sd-space-550",
    attributes: {},
    path: [
      "space",
      "550"
    ]
  },
  "600": {
    value: "48px",
    type: "spacing",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 48,
      type: "spacing"
    },
    name: "sd-space-600",
    attributes: {},
    path: [
      "space",
      "600"
    ]
  },
  "700": {
    value: "56px",
    type: "spacing",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 56,
      type: "spacing"
    },
    name: "sd-space-700",
    attributes: {},
    path: [
      "space",
      "700"
    ]
  },
  "800": {
    value: "64px",
    type: "spacing",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 64,
      type: "spacing"
    },
    name: "sd-space-800",
    attributes: {},
    path: [
      "space",
      "800"
    ]
  },
  "900": {
    value: "72px",
    type: "spacing",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 72,
      type: "spacing"
    },
    name: "sd-space-900",
    attributes: {},
    path: [
      "space",
      "900"
    ]
  },
  "1000": {
    value: "80px",
    type: "spacing",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 80,
      type: "spacing"
    },
    name: "sd-space-1000",
    attributes: {},
    path: [
      "space",
      "1000"
    ]
  },
  "1100": {
    value: "88px",
    type: "spacing",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 88,
      type: "spacing"
    },
    name: "sd-space-1100",
    attributes: {},
    path: [
      "space",
      "1100"
    ]
  },
  "1200": {
    value: "96px",
    type: "spacing",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 96,
      type: "spacing"
    },
    name: "sd-space-1200",
    attributes: {},
    path: [
      "space",
      "1200"
    ]
  },
  "1400": {
    value: "112px",
    type: "spacing",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 112,
      type: "spacing"
    },
    name: "sd-space-1400",
    attributes: {},
    path: [
      "space",
      "1400"
    ]
  },
  "1600": {
    value: "128px",
    type: "spacing",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 128,
      type: "spacing"
    },
    name: "sd-space-1600",
    attributes: {},
    path: [
      "space",
      "1600"
    ]
  },
  "1800": {
    value: "144px",
    type: "spacing",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 144,
      type: "spacing"
    },
    name: "sd-space-1800",
    attributes: {},
    path: [
      "space",
      "1800"
    ]
  },
  margins: {
    xxs: {
      value: "4px",
      type: "spacing",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 4,
        type: "spacing"
      },
      name: "sd-space-margins-xxs",
      attributes: {},
      path: [
        "space",
        "margins",
        "xxs"
      ]
    },
    xs: {
      value: "8px",
      type: "spacing",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 8,
        type: "spacing"
      },
      name: "sd-space-margins-xs",
      attributes: {},
      path: [
        "space",
        "margins",
        "xs"
      ]
    },
    sm: {
      value: "12px",
      type: "spacing",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 12,
        type: "spacing"
      },
      name: "sd-space-margins-sm",
      attributes: {},
      path: [
        "space",
        "margins",
        "sm"
      ]
    },
    md: {
      value: "16px",
      type: "spacing",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 16,
        type: "spacing"
      },
      name: "sd-space-margins-md",
      attributes: {},
      path: [
        "space",
        "margins",
        "md"
      ]
    },
    lg: {
      value: "20px",
      type: "spacing",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 20,
        type: "spacing"
      },
      name: "sd-space-margins-lg",
      attributes: {},
      path: [
        "space",
        "margins",
        "lg"
      ]
    },
    xl: {
      value: "24px",
      type: "spacing",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 24,
        type: "spacing"
      },
      name: "sd-space-margins-xl",
      attributes: {},
      path: [
        "space",
        "margins",
        "xl"
      ]
    },
    xxl: {
      value: "32px",
      type: "spacing",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 32,
        type: "spacing"
      },
      name: "sd-space-margins-xxl",
      attributes: {},
      path: [
        "space",
        "margins",
        "xxl"
      ]
    }
  },
  padding: {
    xs: {
      value: "8px",
      type: "spacing",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 8,
        type: "spacing"
      },
      name: "sd-space-padding-xs",
      attributes: {},
      path: [
        "space",
        "padding",
        "xs"
      ]
    },
    sm: {
      value: "12px",
      type: "spacing",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 12,
        type: "spacing"
      },
      name: "sd-space-padding-sm",
      attributes: {},
      path: [
        "space",
        "padding",
        "sm"
      ]
    },
    md: {
      value: "16px",
      type: "spacing",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 16,
        type: "spacing"
      },
      name: "sd-space-padding-md",
      attributes: {},
      path: [
        "space",
        "padding",
        "md"
      ]
    },
    lg: {
      value: "20px",
      type: "spacing",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 20,
        type: "spacing"
      },
      name: "sd-space-padding-lg",
      attributes: {},
      path: [
        "space",
        "padding",
        "lg"
      ]
    },
    xl: {
      value: "24px",
      type: "spacing",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 24,
        type: "spacing"
      },
      name: "sd-space-padding-xl",
      attributes: {},
      path: [
        "space",
        "padding",
        "xl"
      ]
    },
    xxl: {
      value: "32px",
      type: "spacing",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 32,
        type: "spacing"
      },
      name: "sd-space-padding-xxl",
      attributes: {},
      path: [
        "space",
        "padding",
        "xxl"
      ]
    }
  },
  gap: {
    xs: {
      value: "4px",
      type: "spacing",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 4,
        type: "spacing"
      },
      name: "sd-space-gap-xs",
      attributes: {},
      path: [
        "space",
        "gap",
        "xs"
      ]
    },
    sm: {
      value: "8px",
      type: "spacing",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 8,
        type: "spacing"
      },
      name: "sd-space-gap-sm",
      attributes: {},
      path: [
        "space",
        "gap",
        "sm"
      ]
    },
    md: {
      value: "12px",
      type: "spacing",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 12,
        type: "spacing"
      },
      name: "sd-space-gap-md",
      attributes: {},
      path: [
        "space",
        "gap",
        "md"
      ]
    },
    lg: {
      value: "16px",
      type: "spacing",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 16,
        type: "spacing"
      },
      name: "sd-space-gap-lg",
      attributes: {},
      path: [
        "space",
        "gap",
        "lg"
      ]
    },
    xl: {
      value: "20px",
      type: "spacing",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 20,
        type: "spacing"
      },
      name: "sd-space-gap-xl",
      attributes: {},
      path: [
        "space",
        "gap",
        "xl"
      ]
    },
    xxl: {
      value: "28px",
      type: "spacing",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 28,
        type: "spacing"
      },
      name: "sd-space-gap-xxl",
      attributes: {},
      path: [
        "space",
        "gap",
        "xxl"
      ]
    },
    xxxl: {
      value: "36px",
      type: "spacing",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 36,
        type: "spacing"
      },
      name: "sd-space-gap-xxxl",
      attributes: {},
      path: [
        "space",
        "gap",
        "xxxl"
      ]
    }
  }
};
const old = {
  "large-title": {
    fontFamily: {
      value: "Brown LL",
      type: "fontFamilies",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "Brown LL",
        type: "fontFamilies"
      },
      name: "sd-old-large-title-font-family",
      attributes: {},
      path: [
        "old",
        "large-title",
        "fontFamily"
      ]
    },
    fontWeight: {
      value: "Medium",
      type: "fontWeights",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "Medium",
        type: "fontWeights"
      },
      name: "sd-old-large-title-font-weight",
      attributes: {},
      path: [
        "old",
        "large-title",
        "fontWeight"
      ]
    },
    lineHeight: {
      value: "48px",
      type: "lineHeight",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 48,
        type: "lineHeight"
      },
      name: "sd-old-large-title-line-height",
      attributes: {},
      path: [
        "old",
        "large-title",
        "lineHeight"
      ]
    },
    fontSize: {
      value: "40px",
      type: "fontSizes",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 40,
        type: "fontSizes"
      },
      name: "sd-old-large-title-font-size",
      attributes: {},
      path: [
        "old",
        "large-title",
        "fontSize"
      ]
    },
    letterSpacing: {
      value: "0px",
      type: "letterSpacing",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 0,
        type: "letterSpacing"
      },
      name: "sd-old-large-title-letter-spacing",
      attributes: {},
      path: [
        "old",
        "large-title",
        "letterSpacing"
      ]
    },
    textDecoration: {
      value: "none",
      type: "textDecoration",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "none",
        type: "textDecoration"
      },
      name: "sd-old-large-title-text-decoration",
      attributes: {},
      path: [
        "old",
        "large-title",
        "textDecoration"
      ]
    }
  },
  "title-1": {
    fontFamily: {
      value: "Brown LL",
      type: "fontFamilies",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "Brown LL",
        type: "fontFamilies"
      },
      name: "sd-old-title-1-font-family",
      attributes: {},
      path: [
        "old",
        "title-1",
        "fontFamily"
      ]
    },
    fontWeight: {
      value: "Bold",
      type: "fontWeights",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "Bold",
        type: "fontWeights"
      },
      name: "sd-old-title-1-font-weight",
      attributes: {},
      path: [
        "old",
        "title-1",
        "fontWeight"
      ]
    },
    lineHeight: {
      value: "40px",
      type: "lineHeight",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 40,
        type: "lineHeight"
      },
      name: "sd-old-title-1-line-height",
      attributes: {},
      path: [
        "old",
        "title-1",
        "lineHeight"
      ]
    },
    fontSize: {
      value: "32px",
      type: "fontSizes",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 32,
        type: "fontSizes"
      },
      name: "sd-old-title-1-font-size",
      attributes: {},
      path: [
        "old",
        "title-1",
        "fontSize"
      ]
    },
    letterSpacing: {
      value: "-1px",
      type: "letterSpacing",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: -1,
        type: "letterSpacing"
      },
      name: "sd-old-title-1-letter-spacing",
      attributes: {},
      path: [
        "old",
        "title-1",
        "letterSpacing"
      ]
    },
    textDecoration: {
      value: "none",
      type: "textDecoration",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "none",
        type: "textDecoration"
      },
      name: "sd-old-title-1-text-decoration",
      attributes: {},
      path: [
        "old",
        "title-1",
        "textDecoration"
      ]
    }
  },
  "title-2": {
    fontFamily: {
      value: "Brown LL",
      type: "fontFamilies",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "Brown LL",
        type: "fontFamilies"
      },
      name: "sd-old-title-2-font-family",
      attributes: {},
      path: [
        "old",
        "title-2",
        "fontFamily"
      ]
    },
    fontWeight: {
      value: "Bold",
      type: "fontWeights",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "Bold",
        type: "fontWeights"
      },
      name: "sd-old-title-2-font-weight",
      attributes: {},
      path: [
        "old",
        "title-2",
        "fontWeight"
      ]
    },
    lineHeight: {
      value: "32px",
      type: "lineHeight",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 32,
        type: "lineHeight"
      },
      name: "sd-old-title-2-line-height",
      attributes: {},
      path: [
        "old",
        "title-2",
        "lineHeight"
      ]
    },
    fontSize: {
      value: "24px",
      type: "fontSizes",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 24,
        type: "fontSizes"
      },
      name: "sd-old-title-2-font-size",
      attributes: {},
      path: [
        "old",
        "title-2",
        "fontSize"
      ]
    },
    letterSpacing: {
      value: "-0.75px",
      type: "letterSpacing",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: -0.75,
        type: "letterSpacing"
      },
      name: "sd-old-title-2-letter-spacing",
      attributes: {},
      path: [
        "old",
        "title-2",
        "letterSpacing"
      ]
    },
    textDecoration: {
      value: "none",
      type: "textDecoration",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "none",
        type: "textDecoration"
      },
      name: "sd-old-title-2-text-decoration",
      attributes: {},
      path: [
        "old",
        "title-2",
        "textDecoration"
      ]
    }
  },
  "title-3": {
    fontFamily: {
      value: "Brown LL",
      type: "fontFamilies",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "Brown LL",
        type: "fontFamilies"
      },
      name: "sd-old-title-3-font-family",
      attributes: {},
      path: [
        "old",
        "title-3",
        "fontFamily"
      ]
    },
    fontWeight: {
      value: "Bold",
      type: "fontWeights",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "Bold",
        type: "fontWeights"
      },
      name: "sd-old-title-3-font-weight",
      attributes: {},
      path: [
        "old",
        "title-3",
        "fontWeight"
      ]
    },
    lineHeight: {
      value: "26px",
      type: "lineHeight",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 26,
        type: "lineHeight"
      },
      name: "sd-old-title-3-line-height",
      attributes: {},
      path: [
        "old",
        "title-3",
        "lineHeight"
      ]
    },
    fontSize: {
      value: "20px",
      type: "fontSizes",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 20,
        type: "fontSizes"
      },
      name: "sd-old-title-3-font-size",
      attributes: {},
      path: [
        "old",
        "title-3",
        "fontSize"
      ]
    },
    letterSpacing: {
      value: "-0.25px",
      type: "letterSpacing",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: -0.25,
        type: "letterSpacing"
      },
      name: "sd-old-title-3-letter-spacing",
      attributes: {},
      path: [
        "old",
        "title-3",
        "letterSpacing"
      ]
    },
    textDecoration: {
      value: "none",
      type: "textDecoration",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "none",
        type: "textDecoration"
      },
      name: "sd-old-title-3-text-decoration",
      attributes: {},
      path: [
        "old",
        "title-3",
        "textDecoration"
      ]
    }
  },
  "body-1e": {
    fontFamily: {
      value: "Brown LL",
      type: "fontFamilies",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "Brown LL",
        type: "fontFamilies"
      },
      name: "sd-old-body-1e-font-family",
      attributes: {},
      path: [
        "old",
        "body-1e",
        "fontFamily"
      ]
    },
    fontWeight: {
      value: "Bold",
      type: "fontWeights",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "Bold",
        type: "fontWeights"
      },
      name: "sd-old-body-1e-font-weight",
      attributes: {},
      path: [
        "old",
        "body-1e",
        "fontWeight"
      ]
    },
    lineHeight: {
      value: "24px",
      type: "lineHeight",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 24,
        type: "lineHeight"
      },
      name: "sd-old-body-1e-line-height",
      attributes: {},
      path: [
        "old",
        "body-1e",
        "lineHeight"
      ]
    },
    fontSize: {
      value: "18px",
      type: "fontSizes",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 18,
        type: "fontSizes"
      },
      name: "sd-old-body-1e-font-size",
      attributes: {},
      path: [
        "old",
        "body-1e",
        "fontSize"
      ]
    },
    letterSpacing: {
      value: "-0.5px",
      type: "letterSpacing",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: -0.5,
        type: "letterSpacing"
      },
      name: "sd-old-body-1e-letter-spacing",
      attributes: {},
      path: [
        "old",
        "body-1e",
        "letterSpacing"
      ]
    },
    textDecoration: {
      value: "none",
      type: "textDecoration",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "none",
        type: "textDecoration"
      },
      name: "sd-old-body-1e-text-decoration",
      attributes: {},
      path: [
        "old",
        "body-1e",
        "textDecoration"
      ]
    }
  },
  "body-2e": {
    fontFamily: {
      value: "Brown LL",
      type: "fontFamilies",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "Brown LL",
        type: "fontFamilies"
      },
      name: "sd-old-body-2e-font-family",
      attributes: {},
      path: [
        "old",
        "body-2e",
        "fontFamily"
      ]
    },
    fontWeight: {
      value: "Bold",
      type: "fontWeights",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "Bold",
        type: "fontWeights"
      },
      name: "sd-old-body-2e-font-weight",
      attributes: {},
      path: [
        "old",
        "body-2e",
        "fontWeight"
      ]
    },
    lineHeight: {
      value: "20px",
      type: "lineHeight",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 20,
        type: "lineHeight"
      },
      name: "sd-old-body-2e-line-height",
      attributes: {},
      path: [
        "old",
        "body-2e",
        "lineHeight"
      ]
    },
    fontSize: {
      value: "16px",
      type: "fontSizes",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 16,
        type: "fontSizes"
      },
      name: "sd-old-body-2e-font-size",
      attributes: {},
      path: [
        "old",
        "body-2e",
        "fontSize"
      ]
    },
    letterSpacing: {
      value: "-0.5px",
      type: "letterSpacing",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: -0.5,
        type: "letterSpacing"
      },
      name: "sd-old-body-2e-letter-spacing",
      attributes: {},
      path: [
        "old",
        "body-2e",
        "letterSpacing"
      ]
    },
    textDecoration: {
      value: "none",
      type: "textDecoration",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "none",
        type: "textDecoration"
      },
      name: "sd-old-body-2e-text-decoration",
      attributes: {},
      path: [
        "old",
        "body-2e",
        "textDecoration"
      ]
    }
  },
  "body-3e": {
    fontFamily: {
      value: "Brown LL",
      type: "fontFamilies",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "Brown LL",
        type: "fontFamilies"
      },
      name: "sd-old-body-3e-font-family",
      attributes: {},
      path: [
        "old",
        "body-3e",
        "fontFamily"
      ]
    },
    fontWeight: {
      value: "Bold",
      type: "fontWeights",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "Bold",
        type: "fontWeights"
      },
      name: "sd-old-body-3e-font-weight",
      attributes: {},
      path: [
        "old",
        "body-3e",
        "fontWeight"
      ]
    },
    lineHeight: {
      value: "18px",
      type: "lineHeight",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 18,
        type: "lineHeight"
      },
      name: "sd-old-body-3e-line-height",
      attributes: {},
      path: [
        "old",
        "body-3e",
        "lineHeight"
      ]
    },
    fontSize: {
      value: "14px",
      type: "fontSizes",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 14,
        type: "fontSizes"
      },
      name: "sd-old-body-3e-font-size",
      attributes: {},
      path: [
        "old",
        "body-3e",
        "fontSize"
      ]
    },
    letterSpacing: {
      value: "-0.25px",
      type: "letterSpacing",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: -0.25,
        type: "letterSpacing"
      },
      name: "sd-old-body-3e-letter-spacing",
      attributes: {},
      path: [
        "old",
        "body-3e",
        "letterSpacing"
      ]
    },
    textDecoration: {
      value: "none",
      type: "textDecoration",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "none",
        type: "textDecoration"
      },
      name: "sd-old-body-3e-text-decoration",
      attributes: {},
      path: [
        "old",
        "body-3e",
        "textDecoration"
      ]
    }
  },
  "body-1": {
    fontFamily: {
      value: "Brown LL",
      type: "fontFamilies",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "Brown LL",
        type: "fontFamilies"
      },
      name: "sd-old-body-1-font-family",
      attributes: {},
      path: [
        "old",
        "body-1",
        "fontFamily"
      ]
    },
    fontWeight: {
      value: "Regular",
      type: "fontWeights",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "Regular",
        type: "fontWeights"
      },
      name: "sd-old-body-1-font-weight",
      attributes: {},
      path: [
        "old",
        "body-1",
        "fontWeight"
      ]
    },
    lineHeight: {
      value: "24px",
      type: "lineHeight",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 24,
        type: "lineHeight"
      },
      name: "sd-old-body-1-line-height",
      attributes: {},
      path: [
        "old",
        "body-1",
        "lineHeight"
      ]
    },
    fontSize: {
      value: "18px",
      type: "fontSizes",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 18,
        type: "fontSizes"
      },
      name: "sd-old-body-1-font-size",
      attributes: {},
      path: [
        "old",
        "body-1",
        "fontSize"
      ]
    },
    letterSpacing: {
      value: "-0.5px",
      type: "letterSpacing",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: -0.5,
        type: "letterSpacing"
      },
      name: "sd-old-body-1-letter-spacing",
      attributes: {},
      path: [
        "old",
        "body-1",
        "letterSpacing"
      ]
    },
    textDecoration: {
      value: "none",
      type: "textDecoration",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "none",
        type: "textDecoration"
      },
      name: "sd-old-body-1-text-decoration",
      attributes: {},
      path: [
        "old",
        "body-1",
        "textDecoration"
      ]
    }
  },
  "body-2": {
    fontFamily: {
      value: "Brown LL",
      type: "fontFamilies",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "Brown LL",
        type: "fontFamilies"
      },
      name: "sd-old-body-2-font-family",
      attributes: {},
      path: [
        "old",
        "body-2",
        "fontFamily"
      ]
    },
    fontWeight: {
      value: "Regular",
      type: "fontWeights",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "Regular",
        type: "fontWeights"
      },
      name: "sd-old-body-2-font-weight",
      attributes: {},
      path: [
        "old",
        "body-2",
        "fontWeight"
      ]
    },
    lineHeight: {
      value: "20px",
      type: "lineHeight",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 20,
        type: "lineHeight"
      },
      name: "sd-old-body-2-line-height",
      attributes: {},
      path: [
        "old",
        "body-2",
        "lineHeight"
      ]
    },
    fontSize: {
      value: "16px",
      type: "fontSizes",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 16,
        type: "fontSizes"
      },
      name: "sd-old-body-2-font-size",
      attributes: {},
      path: [
        "old",
        "body-2",
        "fontSize"
      ]
    },
    letterSpacing: {
      value: "-0.5px",
      type: "letterSpacing",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: -0.5,
        type: "letterSpacing"
      },
      name: "sd-old-body-2-letter-spacing",
      attributes: {},
      path: [
        "old",
        "body-2",
        "letterSpacing"
      ]
    },
    textDecoration: {
      value: "none",
      type: "textDecoration",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "none",
        type: "textDecoration"
      },
      name: "sd-old-body-2-text-decoration",
      attributes: {},
      path: [
        "old",
        "body-2",
        "textDecoration"
      ]
    }
  },
  "body-3": {
    fontFamily: {
      value: "Brown LL",
      type: "fontFamilies",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "Brown LL",
        type: "fontFamilies"
      },
      name: "sd-old-body-3-font-family",
      attributes: {},
      path: [
        "old",
        "body-3",
        "fontFamily"
      ]
    },
    fontWeight: {
      value: "Regular",
      type: "fontWeights",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "Regular",
        type: "fontWeights"
      },
      name: "sd-old-body-3-font-weight",
      attributes: {},
      path: [
        "old",
        "body-3",
        "fontWeight"
      ]
    },
    lineHeight: {
      value: "18px",
      type: "lineHeight",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 18,
        type: "lineHeight"
      },
      name: "sd-old-body-3-line-height",
      attributes: {},
      path: [
        "old",
        "body-3",
        "lineHeight"
      ]
    },
    fontSize: {
      value: "14px",
      type: "fontSizes",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 14,
        type: "fontSizes"
      },
      name: "sd-old-body-3-font-size",
      attributes: {},
      path: [
        "old",
        "body-3",
        "fontSize"
      ]
    },
    letterSpacing: {
      value: "-0.25px",
      type: "letterSpacing",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: -0.25,
        type: "letterSpacing"
      },
      name: "sd-old-body-3-letter-spacing",
      attributes: {},
      path: [
        "old",
        "body-3",
        "letterSpacing"
      ]
    },
    textDecoration: {
      value: "none",
      type: "textDecoration",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "none",
        type: "textDecoration"
      },
      name: "sd-old-body-3-text-decoration",
      attributes: {},
      path: [
        "old",
        "body-3",
        "textDecoration"
      ]
    }
  },
  footnote: {
    fontFamily: {
      value: "Brown LL",
      type: "fontFamilies",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "Brown LL",
        type: "fontFamilies"
      },
      name: "sd-old-footnote-font-family",
      attributes: {},
      path: [
        "old",
        "footnote",
        "fontFamily"
      ]
    },
    fontWeight: {
      value: "Regular",
      type: "fontWeights",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "Regular",
        type: "fontWeights"
      },
      name: "sd-old-footnote-font-weight",
      attributes: {},
      path: [
        "old",
        "footnote",
        "fontWeight"
      ]
    },
    lineHeight: {
      value: "16px",
      type: "lineHeight",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 16,
        type: "lineHeight"
      },
      name: "sd-old-footnote-line-height",
      attributes: {},
      path: [
        "old",
        "footnote",
        "lineHeight"
      ]
    },
    fontSize: {
      value: "12px",
      type: "fontSizes",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 12,
        type: "fontSizes"
      },
      name: "sd-old-footnote-font-size",
      attributes: {},
      path: [
        "old",
        "footnote",
        "fontSize"
      ]
    },
    letterSpacing: {
      value: "-0.25px",
      type: "letterSpacing",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: -0.25,
        type: "letterSpacing"
      },
      name: "sd-old-footnote-letter-spacing",
      attributes: {},
      path: [
        "old",
        "footnote",
        "letterSpacing"
      ]
    },
    textDecoration: {
      value: "none",
      type: "textDecoration",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "none",
        type: "textDecoration"
      },
      name: "sd-old-footnote-text-decoration",
      attributes: {},
      path: [
        "old",
        "footnote",
        "textDecoration"
      ]
    }
  },
  "button-1": {
    fontFamily: {
      value: "Brown LL",
      type: "fontFamilies",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "Brown LL",
        type: "fontFamilies"
      },
      name: "sd-old-button-1-font-family",
      attributes: {},
      path: [
        "old",
        "button-1",
        "fontFamily"
      ]
    },
    fontWeight: {
      value: "Medium",
      type: "fontWeights",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "Medium",
        type: "fontWeights"
      },
      name: "sd-old-button-1-font-weight",
      attributes: {},
      path: [
        "old",
        "button-1",
        "fontWeight"
      ]
    },
    lineHeight: {
      value: "20px",
      type: "lineHeight",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 20,
        type: "lineHeight"
      },
      name: "sd-old-button-1-line-height",
      attributes: {},
      path: [
        "old",
        "button-1",
        "lineHeight"
      ]
    },
    fontSize: {
      value: "16px",
      type: "fontSizes",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 16,
        type: "fontSizes"
      },
      name: "sd-old-button-1-font-size",
      attributes: {},
      path: [
        "old",
        "button-1",
        "fontSize"
      ]
    },
    letterSpacing: {
      value: "-0.5px",
      type: "letterSpacing",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: -0.5,
        type: "letterSpacing"
      },
      name: "sd-old-button-1-letter-spacing",
      attributes: {},
      path: [
        "old",
        "button-1",
        "letterSpacing"
      ]
    },
    textDecoration: {
      value: "none",
      type: "textDecoration",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "none",
        type: "textDecoration"
      },
      name: "sd-old-button-1-text-decoration",
      attributes: {},
      path: [
        "old",
        "button-1",
        "textDecoration"
      ]
    }
  },
  "button-2": {
    fontFamily: {
      value: "Brown LL",
      type: "fontFamilies",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "Brown LL",
        type: "fontFamilies"
      },
      name: "sd-old-button-2-font-family",
      attributes: {},
      path: [
        "old",
        "button-2",
        "fontFamily"
      ]
    },
    fontWeight: {
      value: "Medium",
      type: "fontWeights",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "Medium",
        type: "fontWeights"
      },
      name: "sd-old-button-2-font-weight",
      attributes: {},
      path: [
        "old",
        "button-2",
        "fontWeight"
      ]
    },
    lineHeight: {
      value: "18px",
      type: "lineHeight",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 18,
        type: "lineHeight"
      },
      name: "sd-old-button-2-line-height",
      attributes: {},
      path: [
        "old",
        "button-2",
        "lineHeight"
      ]
    },
    fontSize: {
      value: "14px",
      type: "fontSizes",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 14,
        type: "fontSizes"
      },
      name: "sd-old-button-2-font-size",
      attributes: {},
      path: [
        "old",
        "button-2",
        "fontSize"
      ]
    },
    letterSpacing: {
      value: "-0.5px",
      type: "letterSpacing",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: -0.5,
        type: "letterSpacing"
      },
      name: "sd-old-button-2-letter-spacing",
      attributes: {},
      path: [
        "old",
        "button-2",
        "letterSpacing"
      ]
    },
    textDecoration: {
      value: "none",
      type: "textDecoration",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "none",
        type: "textDecoration"
      },
      name: "sd-old-button-2-text-decoration",
      attributes: {},
      path: [
        "old",
        "button-2",
        "textDecoration"
      ]
    }
  },
  "footnote-e": {
    fontFamily: {
      value: "Brown LL",
      type: "fontFamilies",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "Brown LL",
        type: "fontFamilies"
      },
      name: "sd-old-footnote-e-font-family",
      attributes: {},
      path: [
        "old",
        "footnote-e",
        "fontFamily"
      ]
    },
    fontWeight: {
      value: "Bold",
      type: "fontWeights",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "Bold",
        type: "fontWeights"
      },
      name: "sd-old-footnote-e-font-weight",
      attributes: {},
      path: [
        "old",
        "footnote-e",
        "fontWeight"
      ]
    },
    lineHeight: {
      value: "16px",
      type: "lineHeight",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 16,
        type: "lineHeight"
      },
      name: "sd-old-footnote-e-line-height",
      attributes: {},
      path: [
        "old",
        "footnote-e",
        "lineHeight"
      ]
    },
    fontSize: {
      value: "12px",
      type: "fontSizes",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 12,
        type: "fontSizes"
      },
      name: "sd-old-footnote-e-font-size",
      attributes: {},
      path: [
        "old",
        "footnote-e",
        "fontSize"
      ]
    },
    letterSpacing: {
      value: "0px",
      type: "letterSpacing",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 0,
        type: "letterSpacing"
      },
      name: "sd-old-footnote-e-letter-spacing",
      attributes: {},
      path: [
        "old",
        "footnote-e",
        "letterSpacing"
      ]
    },
    textDecoration: {
      value: "none",
      type: "textDecoration",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "none",
        type: "textDecoration"
      },
      name: "sd-old-footnote-e-text-decoration",
      attributes: {},
      path: [
        "old",
        "footnote-e",
        "textDecoration"
      ]
    }
  },
  "caption-3": {
    fontFamily: {
      value: "Brown LL",
      type: "fontFamilies",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "Brown LL",
        type: "fontFamilies"
      },
      name: "sd-old-caption-3-font-family",
      attributes: {},
      path: [
        "old",
        "caption-3",
        "fontFamily"
      ]
    },
    fontWeight: {
      value: "Bold",
      type: "fontWeights",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "Bold",
        type: "fontWeights"
      },
      name: "sd-old-caption-3-font-weight",
      attributes: {},
      path: [
        "old",
        "caption-3",
        "fontWeight"
      ]
    },
    lineHeight: {
      value: "14px",
      type: "lineHeight",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 14,
        type: "lineHeight"
      },
      name: "sd-old-caption-3-line-height",
      attributes: {},
      path: [
        "old",
        "caption-3",
        "lineHeight"
      ]
    },
    fontSize: {
      value: "10px",
      type: "fontSizes",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 10,
        type: "fontSizes"
      },
      name: "sd-old-caption-3-font-size",
      attributes: {},
      path: [
        "old",
        "caption-3",
        "fontSize"
      ]
    },
    letterSpacing: {
      value: "-0.25px",
      type: "letterSpacing",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: -0.25,
        type: "letterSpacing"
      },
      name: "sd-old-caption-3-letter-spacing",
      attributes: {},
      path: [
        "old",
        "caption-3",
        "letterSpacing"
      ]
    },
    textDecoration: {
      value: "none",
      type: "textDecoration",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "none",
        type: "textDecoration"
      },
      name: "sd-old-caption-3-text-decoration",
      attributes: {},
      path: [
        "old",
        "caption-3",
        "textDecoration"
      ]
    }
  }
};
const radius = {
  "100": {
    value: "4px",
    type: "borderRadius",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 4,
      type: "borderRadius"
    },
    name: "sd-radius-100",
    attributes: {},
    path: [
      "radius",
      "100"
    ]
  },
  "200": {
    value: "8px",
    type: "borderRadius",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 8,
      type: "borderRadius"
    },
    name: "sd-radius-200",
    attributes: {},
    path: [
      "radius",
      "200"
    ]
  },
  "300": {
    value: "12px",
    type: "borderRadius",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 12,
      type: "borderRadius"
    },
    name: "sd-radius-300",
    attributes: {},
    path: [
      "radius",
      "300"
    ]
  },
  "400": {
    value: "16px",
    type: "borderRadius",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 16,
      type: "borderRadius"
    },
    name: "sd-radius-400",
    attributes: {},
    path: [
      "radius",
      "400"
    ]
  },
  "500": {
    value: "20px",
    type: "borderRadius",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 20,
      type: "borderRadius"
    },
    name: "sd-radius-500",
    attributes: {},
    path: [
      "radius",
      "500"
    ]
  },
  "600": {
    value: "24px",
    type: "borderRadius",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 24,
      type: "borderRadius"
    },
    name: "sd-radius-600",
    attributes: {},
    path: [
      "radius",
      "600"
    ]
  },
  "700": {
    value: "28px",
    type: "borderRadius",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 28,
      type: "borderRadius"
    },
    name: "sd-radius-700",
    attributes: {},
    path: [
      "radius",
      "700"
    ]
  },
  "800": {
    value: "32px",
    type: "borderRadius",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 32,
      type: "borderRadius"
    },
    name: "sd-radius-800",
    attributes: {},
    path: [
      "radius",
      "800"
    ]
  },
  "900": {
    value: "36px",
    type: "borderRadius",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 36,
      type: "borderRadius"
    },
    name: "sd-radius-900",
    attributes: {},
    path: [
      "radius",
      "900"
    ]
  },
  "1000": {
    value: "40px",
    type: "borderRadius",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 40,
      type: "borderRadius"
    },
    name: "sd-radius-1000",
    attributes: {},
    path: [
      "radius",
      "1000"
    ]
  },
  full: {
    value: "999px",
    type: "borderRadius",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 999,
      type: "borderRadius"
    },
    name: "sd-radius-full",
    attributes: {},
    path: [
      "radius",
      "full"
    ]
  }
};
const stroke = {
  "0": {
    value: "0px",
    type: "borderWidth",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 0,
      type: "borderWidth"
    },
    name: "sd-stroke-0",
    attributes: {},
    path: [
      "stroke",
      "0"
    ]
  },
  "100": {
    value: "1px",
    type: "borderWidth",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 1,
      type: "borderWidth"
    },
    name: "sd-stroke-100",
    attributes: {},
    path: [
      "stroke",
      "100"
    ]
  },
  "200": {
    value: "2px",
    type: "borderWidth",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 2,
      type: "borderWidth"
    },
    name: "sd-stroke-200",
    attributes: {},
    path: [
      "stroke",
      "200"
    ]
  },
  "300": {
    value: "3px",
    type: "borderWidth",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 3,
      type: "borderWidth"
    },
    name: "sd-stroke-300",
    attributes: {},
    path: [
      "stroke",
      "300"
    ]
  }
};
const font = {
  family: {
    main: {
      value: "Brown LL",
      type: "fontFamilies",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "Brown LL",
        type: "fontFamilies"
      },
      name: "sd-font-family-main",
      attributes: {},
      path: [
        "font",
        "family",
        "main"
      ]
    }
  },
  "line-heights": {
    "50": {
      value: "14px",
      type: "lineHeights",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 14,
        type: "lineHeights"
      },
      name: "sd-font-line-heights-50",
      attributes: {},
      path: [
        "font",
        "line-heights",
        "50"
      ]
    },
    "75": {
      value: "16px",
      type: "lineHeights",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 16,
        type: "lineHeights"
      },
      name: "sd-font-line-heights-75",
      attributes: {},
      path: [
        "font",
        "line-heights",
        "75"
      ]
    },
    "100": {
      value: "18px",
      type: "lineHeights",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 18,
        type: "lineHeights"
      },
      name: "sd-font-line-heights-100",
      attributes: {},
      path: [
        "font",
        "line-heights",
        "100"
      ]
    },
    "200": {
      value: "20px",
      type: "lineHeights",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 20,
        type: "lineHeights"
      },
      name: "sd-font-line-heights-200",
      attributes: {},
      path: [
        "font",
        "line-heights",
        "200"
      ]
    },
    "300": {
      value: "24px",
      type: "lineHeights",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 24,
        type: "lineHeights"
      },
      name: "sd-font-line-heights-300",
      attributes: {},
      path: [
        "font",
        "line-heights",
        "300"
      ]
    },
    "400": {
      value: "26px",
      type: "lineHeights",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 26,
        type: "lineHeights"
      },
      name: "sd-font-line-heights-400",
      attributes: {},
      path: [
        "font",
        "line-heights",
        "400"
      ]
    },
    "500": {
      value: "32px",
      type: "lineHeights",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 32,
        type: "lineHeights"
      },
      name: "sd-font-line-heights-500",
      attributes: {},
      path: [
        "font",
        "line-heights",
        "500"
      ]
    },
    "600": {
      value: "36px",
      type: "lineHeights",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 36,
        type: "lineHeights"
      },
      name: "sd-font-line-heights-600",
      attributes: {},
      path: [
        "font",
        "line-heights",
        "600"
      ]
    },
    "700": {
      value: "40px",
      type: "lineHeights",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 40,
        type: "lineHeights"
      },
      name: "sd-font-line-heights-700",
      attributes: {},
      path: [
        "font",
        "line-heights",
        "700"
      ]
    },
    "800": {
      value: "48px",
      type: "lineHeights",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 48,
        type: "lineHeights"
      },
      name: "sd-font-line-heights-800",
      attributes: {},
      path: [
        "font",
        "line-heights",
        "800"
      ]
    },
    "900": {
      value: "64px",
      type: "lineHeights",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 64,
        type: "lineHeights"
      },
      name: "sd-font-line-heights-900",
      attributes: {},
      path: [
        "font",
        "line-heights",
        "900"
      ]
    },
    "1000": {
      value: "72px",
      type: "lineHeights",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 72,
        type: "lineHeights"
      },
      name: "sd-font-line-heights-1000",
      attributes: {},
      path: [
        "font",
        "line-heights",
        "1000"
      ]
    }
  },
  weights: {
    regular: {
      value: "Regular",
      type: "fontWeights",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "Regular",
        type: "fontWeights"
      },
      name: "sd-font-weights-regular",
      attributes: {},
      path: [
        "font",
        "weights",
        "regular"
      ]
    },
    medium: {
      value: "Medium",
      type: "fontWeights",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "Medium",
        type: "fontWeights"
      },
      name: "sd-font-weights-medium",
      attributes: {},
      path: [
        "font",
        "weights",
        "medium"
      ]
    },
    bold: {
      value: "Bold",
      type: "fontWeights",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "Bold",
        type: "fontWeights"
      },
      name: "sd-font-weights-bold",
      attributes: {},
      path: [
        "font",
        "weights",
        "bold"
      ]
    }
  },
  size: {
    "50": {
      value: "10px",
      type: "fontSizes",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 10,
        type: "fontSizes"
      },
      name: "sd-font-size-50",
      attributes: {},
      path: [
        "font",
        "size",
        "50"
      ]
    },
    "75": {
      value: "12px",
      type: "fontSizes",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 12,
        type: "fontSizes"
      },
      name: "sd-font-size-75",
      attributes: {},
      path: [
        "font",
        "size",
        "75"
      ]
    },
    "100": {
      value: "14px",
      type: "fontSizes",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 14,
        type: "fontSizes"
      },
      name: "sd-font-size-100",
      attributes: {},
      path: [
        "font",
        "size",
        "100"
      ]
    },
    "200": {
      value: "16px",
      type: "fontSizes",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 16,
        type: "fontSizes"
      },
      name: "sd-font-size-200",
      attributes: {},
      path: [
        "font",
        "size",
        "200"
      ]
    },
    "300": {
      value: "18px",
      type: "fontSizes",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 18,
        type: "fontSizes"
      },
      name: "sd-font-size-300",
      attributes: {},
      path: [
        "font",
        "size",
        "300"
      ]
    },
    "400": {
      value: "20px",
      type: "fontSizes",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 20,
        type: "fontSizes"
      },
      name: "sd-font-size-400",
      attributes: {},
      path: [
        "font",
        "size",
        "400"
      ]
    },
    "500": {
      value: "24px",
      type: "fontSizes",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 24,
        type: "fontSizes"
      },
      name: "sd-font-size-500",
      attributes: {},
      path: [
        "font",
        "size",
        "500"
      ]
    },
    "600": {
      value: "28px",
      type: "fontSizes",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 28,
        type: "fontSizes"
      },
      name: "sd-font-size-600",
      attributes: {},
      path: [
        "font",
        "size",
        "600"
      ]
    },
    "700": {
      value: "32px",
      type: "fontSizes",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 32,
        type: "fontSizes"
      },
      name: "sd-font-size-700",
      attributes: {},
      path: [
        "font",
        "size",
        "700"
      ]
    },
    "800": {
      value: "40px",
      type: "fontSizes",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 40,
        type: "fontSizes"
      },
      name: "sd-font-size-800",
      attributes: {},
      path: [
        "font",
        "size",
        "800"
      ]
    },
    "900": {
      value: "56px",
      type: "fontSizes",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 56,
        type: "fontSizes"
      },
      name: "sd-font-size-900",
      attributes: {},
      path: [
        "font",
        "size",
        "900"
      ]
    },
    "1000": {
      value: "64px",
      type: "fontSizes",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 64,
        type: "fontSizes"
      },
      name: "sd-font-size-1000",
      attributes: {},
      path: [
        "font",
        "size",
        "1000"
      ]
    }
  },
  tracking: {
    xs: {
      value: "-1px",
      type: "letterSpacing",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: -1,
        type: "letterSpacing"
      },
      name: "sd-font-tracking-xs",
      attributes: {},
      path: [
        "font",
        "tracking",
        "xs"
      ]
    },
    sm: {
      value: "-0.75px",
      type: "letterSpacing",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: -0.75,
        type: "letterSpacing"
      },
      name: "sd-font-tracking-sm",
      attributes: {},
      path: [
        "font",
        "tracking",
        "sm"
      ]
    },
    md: {
      value: "-0.5px",
      type: "letterSpacing",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: -0.5,
        type: "letterSpacing"
      },
      name: "sd-font-tracking-md",
      attributes: {},
      path: [
        "font",
        "tracking",
        "md"
      ]
    },
    lg: {
      value: "-0.25px",
      type: "letterSpacing",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: -0.25,
        type: "letterSpacing"
      },
      name: "sd-font-tracking-lg",
      attributes: {},
      path: [
        "font",
        "tracking",
        "lg"
      ]
    },
    xl: {
      value: "0px",
      type: "letterSpacing",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: 0,
        type: "letterSpacing"
      },
      name: "sd-font-tracking-xl",
      attributes: {},
      path: [
        "font",
        "tracking",
        "xl"
      ]
    }
  },
  "text-decoration": {
    none: {
      value: "none",
      type: "textDecoration",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "none",
        type: "textDecoration"
      },
      name: "sd-font-text-decoration-none",
      attributes: {},
      path: [
        "font",
        "text-decoration",
        "none"
      ]
    }
  },
  "paragraph-indent": {
    "0": {
      value: "0px",
      type: "dimension",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "0px",
        type: "dimension"
      },
      name: "sd-font-paragraph-indent-0",
      attributes: {},
      path: [
        "font",
        "paragraph-indent",
        "0"
      ]
    }
  }
};
const reference = {
  black: {
    value: "rgba(0, 0, 0, 1)",
    type: "color",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: "#000000",
      type: "color"
    },
    name: "sd-reference-black",
    attributes: {},
    path: [
      "reference",
      "black"
    ]
  },
  white: {
    value: "rgba(255, 255, 255, 1)",
    type: "color",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: "#ffffff",
      type: "color"
    },
    name: "sd-reference-white",
    attributes: {},
    path: [
      "reference",
      "white"
    ]
  },
  gray: {
    "100": {
      value: "rgba(243, 244, 246, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#f3f4f6",
        type: "color"
      },
      name: "sd-reference-gray-100",
      attributes: {},
      path: [
        "reference",
        "gray",
        "100"
      ]
    },
    "200": {
      value: "rgba(230, 231, 233, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#e6e7e9",
        type: "color"
      },
      name: "sd-reference-gray-200",
      attributes: {},
      path: [
        "reference",
        "gray",
        "200"
      ]
    },
    "300": {
      value: "rgba(208, 209, 211, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#d0d1d3",
        type: "color"
      },
      name: "sd-reference-gray-300",
      attributes: {},
      path: [
        "reference",
        "gray",
        "300"
      ]
    },
    "400": {
      value: "rgba(163, 166, 172, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#a3a6ac",
        type: "color"
      },
      name: "sd-reference-gray-400",
      attributes: {},
      path: [
        "reference",
        "gray",
        "400"
      ]
    },
    "500": {
      value: "rgba(122, 124, 129, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#7a7c81",
        type: "color"
      },
      name: "sd-reference-gray-500",
      attributes: {},
      path: [
        "reference",
        "gray",
        "500"
      ]
    },
    "600": {
      value: "rgba(83, 85, 90, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#53555a",
        type: "color"
      },
      name: "sd-reference-gray-600",
      attributes: {},
      path: [
        "reference",
        "gray",
        "600"
      ]
    },
    "700": {
      value: "rgba(44, 45, 48, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#2c2d30",
        type: "color"
      },
      name: "sd-reference-gray-700",
      attributes: {},
      path: [
        "reference",
        "gray",
        "700"
      ]
    },
    "800": {
      value: "rgba(34, 35, 37, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#222325",
        type: "color"
      },
      name: "sd-reference-gray-800",
      attributes: {},
      path: [
        "reference",
        "gray",
        "800"
      ]
    },
    "900": {
      value: "rgba(22, 23, 25, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#161719",
        type: "color"
      },
      name: "sd-reference-gray-900",
      attributes: {},
      path: [
        "reference",
        "gray",
        "900"
      ]
    },
    "050": {
      value: "rgba(252, 252, 253, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#fcfcfd",
        type: "color"
      },
      name: "sd-reference-gray-050",
      attributes: {},
      path: [
        "reference",
        "gray",
        "050"
      ]
    }
  },
  blue: {
    "10": {
      value: "rgba(222, 239, 253, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#deeffd",
        type: "color"
      },
      name: "sd-reference-blue-10",
      attributes: {},
      path: [
        "reference",
        "blue",
        "10"
      ]
    },
    "20": {
      value: "rgba(170, 215, 249, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#aad7f9",
        type: "color"
      },
      name: "sd-reference-blue-20",
      attributes: {},
      path: [
        "reference",
        "blue",
        "20"
      ]
    },
    "30": {
      value: "rgba(72, 169, 242, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#48a9f2",
        type: "color"
      },
      name: "sd-reference-blue-30",
      attributes: {},
      path: [
        "reference",
        "blue",
        "30"
      ]
    },
    "40": {
      value: "rgba(43, 155, 240, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#2b9bf0",
        type: "color"
      },
      name: "sd-reference-blue-40",
      attributes: {},
      path: [
        "reference",
        "blue",
        "40"
      ]
    },
    "50": {
      value: "rgba(39, 141, 218, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#278dda",
        type: "color"
      },
      name: "sd-reference-blue-50",
      attributes: {},
      path: [
        "reference",
        "blue",
        "50"
      ]
    },
    "60": {
      value: "rgba(25, 91, 141, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#195b8d",
        type: "color"
      },
      name: "sd-reference-blue-60",
      attributes: {},
      path: [
        "reference",
        "blue",
        "60"
      ]
    },
    "70": {
      value: "rgba(16, 59, 92, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#103b5c",
        type: "color"
      },
      name: "sd-reference-blue-70",
      attributes: {},
      path: [
        "reference",
        "blue",
        "70"
      ]
    }
  },
  Indigo: {
    "10": {
      value: "rgba(227, 230, 253, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#e3e6fd",
        type: "color"
      },
      name: "sd-reference-indigo-10",
      attributes: {},
      path: [
        "reference",
        "Indigo",
        "10"
      ]
    },
    "20": {
      value: "rgba(199, 205, 252, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#c7cdfc",
        type: "color"
      },
      name: "sd-reference-indigo-20",
      attributes: {},
      path: [
        "reference",
        "Indigo",
        "20"
      ]
    },
    "30": {
      value: "rgba(139, 151, 248, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#8b97f8",
        type: "color"
      },
      name: "sd-reference-indigo-30",
      attributes: {},
      path: [
        "reference",
        "Indigo",
        "30"
      ]
    },
    "40": {
      value: "rgba(116, 130, 247, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#7482f7",
        type: "color"
      },
      name: "sd-reference-indigo-40",
      attributes: {},
      path: [
        "reference",
        "Indigo",
        "40"
      ]
    },
    "50": {
      value: "rgba(105, 118, 224, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#6976e0",
        type: "color"
      },
      name: "sd-reference-indigo-50",
      attributes: {},
      path: [
        "reference",
        "Indigo",
        "50"
      ]
    },
    "60": {
      value: "rgba(70, 78, 148, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#464e94",
        type: "color"
      },
      name: "sd-reference-indigo-60",
      attributes: {},
      path: [
        "reference",
        "Indigo",
        "60"
      ]
    },
    "70": {
      value: "rgba(46, 52, 99, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#2e3463",
        type: "color"
      },
      name: "sd-reference-indigo-70",
      attributes: {},
      path: [
        "reference",
        "Indigo",
        "70"
      ]
    }
  },
  purple: {
    "10": {
      value: "rgba(241, 236, 255, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#f1ecff",
        type: "color"
      },
      name: "sd-reference-purple-10",
      attributes: {},
      path: [
        "reference",
        "purple",
        "10"
      ]
    },
    "20": {
      value: "rgba(199, 178, 255, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#c7b2ff",
        type: "color"
      },
      name: "sd-reference-purple-20",
      attributes: {},
      path: [
        "reference",
        "purple",
        "20"
      ]
    },
    "30": {
      value: "rgba(173, 142, 255, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#ad8eff",
        type: "color"
      },
      name: "sd-reference-purple-30",
      attributes: {},
      path: [
        "reference",
        "purple",
        "30"
      ]
    },
    "40": {
      value: "rgba(165, 130, 255, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#a582ff",
        type: "color"
      },
      name: "sd-reference-purple-40",
      attributes: {},
      path: [
        "reference",
        "purple",
        "40"
      ]
    },
    "50": {
      value: "rgba(152, 112, 255, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#9870ff",
        type: "color"
      },
      name: "sd-reference-purple-50",
      attributes: {},
      path: [
        "reference",
        "purple",
        "50"
      ]
    },
    "60": {
      value: "rgba(99, 78, 153, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#634e99",
        type: "color"
      },
      name: "sd-reference-purple-60",
      attributes: {},
      path: [
        "reference",
        "purple",
        "60"
      ]
    },
    "70": {
      value: "rgba(66, 52, 102, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#423466",
        type: "color"
      },
      name: "sd-reference-purple-70",
      attributes: {},
      path: [
        "reference",
        "purple",
        "70"
      ]
    }
  },
  pink: {
    "10": {
      value: "rgba(255, 227, 240, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#ffe3f0",
        type: "color"
      },
      name: "sd-reference-pink-10",
      attributes: {},
      path: [
        "reference",
        "pink",
        "10"
      ]
    },
    "20": {
      value: "rgba(255, 201, 226, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#ffc9e2",
        type: "color"
      },
      name: "sd-reference-pink-20",
      attributes: {},
      path: [
        "reference",
        "pink",
        "20"
      ]
    },
    "30": {
      value: "rgba(255, 139, 192, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#ff8bc0",
        type: "color"
      },
      name: "sd-reference-pink-30",
      attributes: {},
      path: [
        "reference",
        "pink",
        "30"
      ]
    },
    "40": {
      value: "rgba(255, 114, 178, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#ff72b2",
        type: "color"
      },
      name: "sd-reference-pink-40",
      attributes: {},
      path: [
        "reference",
        "pink",
        "40"
      ]
    },
    "50": {
      value: "rgba(227, 102, 159, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#e3669f",
        type: "color"
      },
      name: "sd-reference-pink-50",
      attributes: {},
      path: [
        "reference",
        "pink",
        "50"
      ]
    },
    "60": {
      value: "rgba(153, 68, 107, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#99446b",
        type: "color"
      },
      name: "sd-reference-pink-60",
      attributes: {},
      path: [
        "reference",
        "pink",
        "60"
      ]
    },
    "70": {
      value: "rgba(102, 46, 71, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#662e47",
        type: "color"
      },
      name: "sd-reference-pink-70",
      attributes: {},
      path: [
        "reference",
        "pink",
        "70"
      ]
    }
  },
  red: {
    "10": {
      value: "rgba(255, 238, 237, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#ffeeed",
        type: "color"
      },
      name: "sd-reference-red-10",
      attributes: {},
      path: [
        "reference",
        "red",
        "10"
      ]
    },
    "20": {
      value: "rgba(255, 185, 184, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#ffb9b8",
        type: "color"
      },
      name: "sd-reference-red-20",
      attributes: {},
      path: [
        "reference",
        "red",
        "20"
      ]
    },
    "30": {
      value: "rgba(255, 102, 101, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#ff6665",
        type: "color"
      },
      name: "sd-reference-red-30",
      attributes: {},
      path: [
        "reference",
        "red",
        "30"
      ]
    },
    "40": {
      value: "rgba(255, 80, 78, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#ff504e",
        type: "color"
      },
      name: "sd-reference-red-40",
      attributes: {},
      path: [
        "reference",
        "red",
        "40"
      ]
    },
    "50": {
      value: "rgba(244, 75, 73, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#f44b49",
        type: "color"
      },
      name: "sd-reference-red-50",
      attributes: {},
      path: [
        "reference",
        "red",
        "50"
      ]
    },
    "60": {
      value: "rgba(153, 48, 46, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#99302e",
        type: "color"
      },
      name: "sd-reference-red-60",
      attributes: {},
      path: [
        "reference",
        "red",
        "60"
      ]
    },
    "70": {
      value: "rgba(97, 31, 30, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#611f1e",
        type: "color"
      },
      name: "sd-reference-red-70",
      attributes: {},
      path: [
        "reference",
        "red",
        "70"
      ]
    }
  },
  orange: {
    "10": {
      value: "rgba(255, 220, 196, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#ffdcc4",
        type: "color"
      },
      name: "sd-reference-orange-10",
      attributes: {},
      path: [
        "reference",
        "orange",
        "10"
      ]
    },
    "20": {
      value: "rgba(255, 188, 142, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#ffbc8e",
        type: "color"
      },
      name: "sd-reference-orange-20",
      attributes: {},
      path: [
        "reference",
        "orange",
        "20"
      ]
    },
    "30": {
      value: "rgba(255, 162, 97, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#ffa261",
        type: "color"
      },
      name: "sd-reference-orange-30",
      attributes: {},
      path: [
        "reference",
        "orange",
        "30"
      ]
    },
    "40": {
      value: "rgba(255, 144, 66, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#ff9042",
        type: "color"
      },
      name: "sd-reference-orange-40",
      attributes: {},
      path: [
        "reference",
        "orange",
        "40"
      ]
    },
    "50": {
      value: "rgba(232, 131, 60, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#e8833c",
        type: "color"
      },
      name: "sd-reference-orange-50",
      attributes: {},
      path: [
        "reference",
        "orange",
        "50"
      ]
    },
    "60": {
      value: "rgba(158, 89, 41, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#9e5929",
        type: "color"
      },
      name: "sd-reference-orange-60",
      attributes: {},
      path: [
        "reference",
        "orange",
        "60"
      ]
    },
    "70": {
      value: "rgba(102, 58, 26, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#663a1a",
        type: "color"
      },
      name: "sd-reference-orange-70",
      attributes: {},
      path: [
        "reference",
        "orange",
        "70"
      ]
    }
  },
  yellow: {
    "10": {
      value: "rgba(254, 245, 193, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#fef5c1",
        type: "color"
      },
      name: "sd-reference-yellow-10",
      attributes: {},
      path: [
        "reference",
        "yellow",
        "10"
      ]
    },
    "20": {
      value: "rgba(254, 231, 137, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#fee789",
        type: "color"
      },
      name: "sd-reference-yellow-20",
      attributes: {},
      path: [
        "reference",
        "yellow",
        "20"
      ]
    },
    "30": {
      value: "rgba(250, 213, 79, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#fad54f",
        type: "color"
      },
      name: "sd-reference-yellow-30",
      attributes: {},
      path: [
        "reference",
        "yellow",
        "30"
      ]
    },
    "40": {
      value: "rgba(247, 194, 36, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#f7c224",
        type: "color"
      },
      name: "sd-reference-yellow-40",
      attributes: {},
      path: [
        "reference",
        "yellow",
        "40"
      ]
    },
    "50": {
      value: "rgba(235, 172, 19, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#ebac13",
        type: "color"
      },
      name: "sd-reference-yellow-50",
      attributes: {},
      path: [
        "reference",
        "yellow",
        "50"
      ]
    },
    "60": {
      value: "rgba(203, 133, 9, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#cb8509",
        type: "color"
      },
      name: "sd-reference-yellow-60",
      attributes: {},
      path: [
        "reference",
        "yellow",
        "60"
      ]
    },
    "70": {
      value: "rgba(145, 80, 10, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#91500a",
        type: "color"
      },
      name: "sd-reference-yellow-70",
      attributes: {},
      path: [
        "reference",
        "yellow",
        "70"
      ]
    }
  },
  volt: {
    "10": {
      value: "rgba(241, 255, 212, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#f1ffd4",
        type: "color"
      },
      name: "sd-reference-volt-10",
      attributes: {},
      path: [
        "reference",
        "volt",
        "10"
      ]
    },
    "20": {
      value: "rgba(227, 255, 169, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#e3ffa9",
        type: "color"
      },
      name: "sd-reference-volt-20",
      attributes: {},
      path: [
        "reference",
        "volt",
        "20"
      ]
    },
    "30": {
      value: "rgba(214, 255, 127, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#d6ff7f",
        type: "color"
      },
      name: "sd-reference-volt-30",
      attributes: {},
      path: [
        "reference",
        "volt",
        "30"
      ]
    },
    "40": {
      value: "rgba(186, 255, 41, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#baff29",
        type: "color"
      },
      name: "sd-reference-volt-40",
      attributes: {},
      path: [
        "reference",
        "volt",
        "40"
      ]
    },
    "50": {
      value: "rgba(171, 235, 38, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#abeb26",
        type: "color"
      },
      name: "sd-reference-volt-50",
      attributes: {},
      path: [
        "reference",
        "volt",
        "50"
      ]
    },
    "60": {
      value: "rgba(112, 153, 25, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#709919",
        type: "color"
      },
      name: "sd-reference-volt-60",
      attributes: {},
      path: [
        "reference",
        "volt",
        "60"
      ]
    },
    "70": {
      value: "rgba(74, 102, 16, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#4a6610",
        type: "color"
      },
      name: "sd-reference-volt-70",
      attributes: {},
      path: [
        "reference",
        "volt",
        "70"
      ]
    }
  },
  green: {
    "10": {
      value: "rgba(221, 246, 230, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#ddf6e6",
        type: "color"
      },
      name: "sd-reference-green-10",
      attributes: {},
      path: [
        "reference",
        "green",
        "10"
      ]
    },
    "20": {
      value: "rgba(171, 233, 193, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#abe9c1",
        type: "color"
      },
      name: "sd-reference-green-20",
      attributes: {},
      path: [
        "reference",
        "green",
        "20"
      ]
    },
    "30": {
      value: "rgba(74, 222, 128, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#4ade80",
        type: "color"
      },
      name: "sd-reference-green-30",
      attributes: {},
      path: [
        "reference",
        "green",
        "30"
      ]
    },
    "40": {
      value: "rgba(34, 197, 94, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#22c55e",
        type: "color"
      },
      name: "sd-reference-green-40",
      attributes: {},
      path: [
        "reference",
        "green",
        "40"
      ]
    },
    "50": {
      value: "rgba(22, 163, 74, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#16a34a",
        type: "color"
      },
      name: "sd-reference-green-50",
      attributes: {},
      path: [
        "reference",
        "green",
        "50"
      ]
    },
    "60": {
      value: "rgba(21, 128, 61, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#15803d",
        type: "color"
      },
      name: "sd-reference-green-60",
      attributes: {},
      path: [
        "reference",
        "green",
        "60"
      ]
    },
    "70": {
      value: "rgba(22, 101, 52, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#166534",
        type: "color"
      },
      name: "sd-reference-green-70",
      attributes: {},
      path: [
        "reference",
        "green",
        "70"
      ]
    }
  },
  mint: {
    "10": {
      value: "rgba(220, 247, 242, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#dcf7f2",
        type: "color"
      },
      name: "sd-reference-mint-10",
      attributes: {},
      path: [
        "reference",
        "mint",
        "10"
      ]
    },
    "20": {
      value: "rgba(119, 224, 199, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#77e0c7",
        type: "color"
      },
      name: "sd-reference-mint-20",
      attributes: {},
      path: [
        "reference",
        "mint",
        "20"
      ]
    },
    "30": {
      value: "rgba(59, 210, 165, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#3bd2a5",
        type: "color"
      },
      name: "sd-reference-mint-30",
      attributes: {},
      path: [
        "reference",
        "mint",
        "30"
      ]
    },
    "40": {
      value: "rgba(41, 200, 147, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#29c893",
        type: "color"
      },
      name: "sd-reference-mint-40",
      attributes: {},
      path: [
        "reference",
        "mint",
        "40"
      ]
    },
    "50": {
      value: "rgba(41, 200, 147, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#29c893",
        type: "color"
      },
      name: "sd-reference-mint-50",
      attributes: {},
      path: [
        "reference",
        "mint",
        "50"
      ]
    },
    "60": {
      value: "rgba(16, 119, 88, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#107758",
        type: "color"
      },
      name: "sd-reference-mint-60",
      attributes: {},
      path: [
        "reference",
        "mint",
        "60"
      ]
    },
    "70": {
      value: "rgba(11, 78, 65, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#0b4e41",
        type: "color"
      },
      name: "sd-reference-mint-70",
      attributes: {},
      path: [
        "reference",
        "mint",
        "70"
      ]
    }
  },
  teal: {
    "10": {
      value: "rgba(233, 249, 253, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#e9f9fd",
        type: "color"
      },
      name: "sd-reference-teal-10",
      attributes: {},
      path: [
        "reference",
        "teal",
        "10"
      ]
    },
    "20": {
      value: "rgba(166, 232, 246, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#a6e8f6",
        type: "color"
      },
      name: "sd-reference-teal-20",
      attributes: {},
      path: [
        "reference",
        "teal",
        "20"
      ]
    },
    "30": {
      value: "rgba(82, 210, 238, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#52d2ee",
        type: "color"
      },
      name: "sd-reference-teal-30",
      attributes: {},
      path: [
        "reference",
        "teal",
        "30"
      ]
    },
    "40": {
      value: "rgba(39, 199, 234, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#27c7ea",
        type: "color"
      },
      name: "sd-reference-teal-40",
      attributes: {},
      path: [
        "reference",
        "teal",
        "40"
      ]
    },
    "50": {
      value: "rgba(30, 193, 228, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#1ec1e4",
        type: "color"
      },
      name: "sd-reference-teal-50",
      attributes: {},
      path: [
        "reference",
        "teal",
        "50"
      ]
    },
    "60": {
      value: "rgba(31, 140, 187, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#1f8cbb",
        type: "color"
      },
      name: "sd-reference-teal-60",
      attributes: {},
      path: [
        "reference",
        "teal",
        "60"
      ]
    },
    "70": {
      value: "rgba(46, 74, 99, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#2e4a63",
        type: "color"
      },
      name: "sd-reference-teal-70",
      attributes: {},
      path: [
        "reference",
        "teal",
        "70"
      ]
    }
  },
  danger: {
    "10": {
      value: "rgba(255, 210, 207, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#ffd2cf",
        type: "color"
      },
      name: "sd-reference-danger-10",
      attributes: {},
      path: [
        "reference",
        "danger",
        "10"
      ]
    },
    "20": {
      value: "rgba(255, 116, 107, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#ff746b",
        type: "color"
      },
      name: "sd-reference-danger-20",
      attributes: {},
      path: [
        "reference",
        "danger",
        "20"
      ]
    },
    "30": {
      value: "rgba(255, 75, 65, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#ff4b41",
        type: "color"
      },
      name: "sd-reference-danger-30",
      attributes: {},
      path: [
        "reference",
        "danger",
        "30"
      ]
    },
    "40": {
      value: "rgba(255, 69, 58, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#ff453a",
        type: "color"
      },
      name: "sd-reference-danger-40",
      attributes: {},
      path: [
        "reference",
        "danger",
        "40"
      ]
    },
    "50": {
      value: "rgba(255, 59, 48, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#ff3b30",
        type: "color"
      },
      name: "sd-reference-danger-50",
      attributes: {},
      path: [
        "reference",
        "danger",
        "50"
      ]
    },
    "60": {
      value: "rgba(152, 27, 20, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#981b14",
        type: "color"
      },
      name: "sd-reference-danger-60",
      attributes: {},
      path: [
        "reference",
        "danger",
        "60"
      ]
    },
    "70": {
      value: "rgba(81, 20, 15, 1)",
      type: "color",
      filePath: "themes/videoleap-light.json",
      isSource: true,
      original: {
        value: "#51140f",
        type: "color"
      },
      name: "sd-reference-danger-70",
      attributes: {},
      path: [
        "reference",
        "danger",
        "70"
      ]
    }
  }
};
const size = {
  "0": {
    value: "0px",
    type: "sizing",
    description: "size",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 0,
      type: "sizing",
      description: "size"
    },
    name: "sd-size-0",
    attributes: {},
    path: [
      "size",
      "0"
    ]
  },
  "25": {
    value: "2px",
    type: "sizing",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 2,
      type: "sizing"
    },
    name: "sd-size-25",
    attributes: {},
    path: [
      "size",
      "25"
    ]
  },
  "50": {
    value: "4px",
    type: "sizing",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 4,
      type: "sizing"
    },
    name: "sd-size-50",
    attributes: {},
    path: [
      "size",
      "50"
    ]
  },
  "75": {
    value: "6px",
    type: "sizing",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 6,
      type: "sizing"
    },
    name: "sd-size-75",
    attributes: {},
    path: [
      "size",
      "75"
    ]
  },
  "100": {
    value: "8px",
    type: "sizing",
    description: "Base size\n",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 8,
      type: "sizing",
      description: "Base size\n"
    },
    name: "sd-size-100",
    attributes: {},
    path: [
      "size",
      "100"
    ]
  },
  "125": {
    value: "10px",
    type: "sizing",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 10,
      type: "sizing"
    },
    name: "sd-size-125",
    attributes: {},
    path: [
      "size",
      "125"
    ]
  },
  "150": {
    value: "12px",
    type: "sizing",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 12,
      type: "sizing"
    },
    name: "sd-size-150",
    attributes: {},
    path: [
      "size",
      "150"
    ]
  },
  "175": {
    value: "14px",
    type: "sizing",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 14,
      type: "sizing"
    },
    name: "sd-size-175",
    attributes: {},
    path: [
      "size",
      "175"
    ]
  },
  "200": {
    value: "16px",
    type: "sizing",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 16,
      type: "sizing"
    },
    name: "sd-size-200",
    attributes: {},
    path: [
      "size",
      "200"
    ]
  },
  "250": {
    value: "20px",
    type: "sizing",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 20,
      type: "sizing"
    },
    name: "sd-size-250",
    attributes: {},
    path: [
      "size",
      "250"
    ]
  },
  "300": {
    value: "24px",
    type: "sizing",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 24,
      type: "sizing"
    },
    name: "sd-size-300",
    attributes: {},
    path: [
      "size",
      "300"
    ]
  },
  "350": {
    value: "28px",
    type: "sizing",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 28,
      type: "sizing"
    },
    name: "sd-size-350",
    attributes: {},
    path: [
      "size",
      "350"
    ]
  },
  "400": {
    value: "32px",
    type: "sizing",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 32,
      type: "sizing"
    },
    name: "sd-size-400",
    attributes: {},
    path: [
      "size",
      "400"
    ]
  },
  "450": {
    value: "36px",
    type: "sizing",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 36,
      type: "sizing"
    },
    name: "sd-size-450",
    attributes: {},
    path: [
      "size",
      "450"
    ]
  },
  "500": {
    value: "40px",
    type: "sizing",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 40,
      type: "sizing"
    },
    name: "sd-size-500",
    attributes: {},
    path: [
      "size",
      "500"
    ]
  },
  "550": {
    value: "44px",
    type: "sizing",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 44,
      type: "sizing"
    },
    name: "sd-size-550",
    attributes: {},
    path: [
      "size",
      "550"
    ]
  },
  "600": {
    value: "48px",
    type: "sizing",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 48,
      type: "sizing"
    },
    name: "sd-size-600",
    attributes: {},
    path: [
      "size",
      "600"
    ]
  },
  "650": {
    value: "52px",
    type: "sizing",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 52,
      type: "sizing"
    },
    name: "sd-size-650",
    attributes: {},
    path: [
      "size",
      "650"
    ]
  },
  "700": {
    value: "56px",
    type: "sizing",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 56,
      type: "sizing"
    },
    name: "sd-size-700",
    attributes: {},
    path: [
      "size",
      "700"
    ]
  },
  "750": {
    value: "60px",
    type: "sizing",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 60,
      type: "sizing"
    },
    name: "sd-size-750",
    attributes: {},
    path: [
      "size",
      "750"
    ]
  },
  "800": {
    value: "64px",
    type: "sizing",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 64,
      type: "sizing"
    },
    name: "sd-size-800",
    attributes: {},
    path: [
      "size",
      "800"
    ]
  },
  "900": {
    value: "72px",
    type: "sizing",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 72,
      type: "sizing"
    },
    name: "sd-size-900",
    attributes: {},
    path: [
      "size",
      "900"
    ]
  },
  "1000": {
    value: "80px",
    type: "sizing",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 80,
      type: "sizing"
    },
    name: "sd-size-1000",
    attributes: {},
    path: [
      "size",
      "1000"
    ]
  },
  "1100": {
    value: "88px",
    type: "sizing",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 88,
      type: "sizing"
    },
    name: "sd-size-1100",
    attributes: {},
    path: [
      "size",
      "1100"
    ]
  },
  "1200": {
    value: "96px",
    type: "sizing",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 96,
      type: "sizing"
    },
    name: "sd-size-1200",
    attributes: {},
    path: [
      "size",
      "1200"
    ]
  },
  "1300": {
    value: "104px",
    type: "sizing",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 104,
      type: "sizing"
    },
    name: "sd-size-1300",
    attributes: {},
    path: [
      "size",
      "1300"
    ]
  },
  "1400": {
    value: "112px",
    type: "sizing",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 112,
      type: "sizing"
    },
    name: "sd-size-1400",
    attributes: {},
    path: [
      "size",
      "1400"
    ]
  },
  "1500": {
    value: "120px",
    type: "sizing",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 120,
      type: "sizing"
    },
    name: "sd-size-1500",
    attributes: {},
    path: [
      "size",
      "1500"
    ]
  },
  "1750": {
    value: "140px",
    type: "sizing",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 140,
      type: "sizing"
    },
    name: "sd-size-1750",
    attributes: {},
    path: [
      "size",
      "1750"
    ]
  },
  "2000": {
    value: "160px",
    type: "sizing",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 160,
      type: "sizing"
    },
    name: "sd-size-2000",
    attributes: {},
    path: [
      "size",
      "2000"
    ]
  },
  "2200": {
    value: "176px",
    type: "sizing",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 176,
      type: "sizing"
    },
    name: "sd-size-2200",
    attributes: {},
    path: [
      "size",
      "2200"
    ]
  },
  "2500": {
    value: "200px",
    type: "sizing",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 200,
      type: "sizing"
    },
    name: "sd-size-2500",
    attributes: {},
    path: [
      "size",
      "2500"
    ]
  },
  "3000": {
    value: "240px",
    type: "sizing",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 240,
      type: "sizing"
    },
    name: "sd-size-3000",
    attributes: {},
    path: [
      "size",
      "3000"
    ]
  },
  "3500": {
    value: "280px",
    type: "sizing",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 280,
      type: "sizing"
    },
    name: "sd-size-3500",
    attributes: {},
    path: [
      "size",
      "3500"
    ]
  },
  "4000": {
    value: "320px",
    type: "sizing",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 320,
      type: "sizing"
    },
    name: "sd-size-4000",
    attributes: {},
    path: [
      "size",
      "4000"
    ]
  },
  "5000": {
    value: "400px",
    type: "sizing",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 400,
      type: "sizing"
    },
    name: "sd-size-5000",
    attributes: {},
    path: [
      "size",
      "5000"
    ]
  },
  "6000": {
    value: "480px",
    type: "sizing",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 480,
      type: "sizing"
    },
    name: "sd-size-6000",
    attributes: {},
    path: [
      "size",
      "6000"
    ]
  },
  "7000": {
    value: "560px",
    type: "sizing",
    filePath: "themes/videoleap-light.json",
    isSource: true,
    original: {
      value: 560,
      type: "sizing"
    },
    name: "sd-size-7000",
    attributes: {},
    path: [
      "size",
      "7000"
    ]
  }
};
const videoleapLight = {
  semantic,
  button,
  card,
  sheet,
  comp,
  gradient,
  shadow,
  typography: typography$1,
  border,
  opacity,
  space,
  old,
  radius,
  stroke,
  font,
  reference,
  size
};
const themeFilesMap = {
  popularpayLight,
  videoleapDark,
  videoleapLight
};
class ThemeTokens {
  constructor() {
    __publicField(this, "theme");
    __publicField(this, "tokens");
    __publicField(this, "setTheme", (theme) => {
      this.theme = theme;
      this.tokens = theme && themeFilesMap[this.theme];
    });
    __publicField(this, "getTokensInitialized", () => {
      return !!this.tokens;
    });
    __publicField(this, "getTokens", () => {
      return this.tokens;
    });
  }
}
const ThemeTokens$1 = new ThemeTokens();
const cssVariablesTagId = "design-system-variables";
const keysToSkip = /* @__PURE__ */ new Set([
  "description",
  "type",
  "filePath",
  "isSource",
  "name",
  "attributes",
  "path",
  "0",
  "1",
  "2",
  "3"
]);
const convertTokensToCssVariables = (tokens, prefix = "") => {
  return Object.entries(tokens).reduce((css, [key, value]) => {
    if (keysToSkip.has(key))
      return css;
    const isEndValue = key === "value" || key === "original-value";
    const cssKey = isEndValue ? prefix : `${prefix}${prefix ? "-" : "--lt-"}${key}`;
    if (cssKey.endsWith("original"))
      return css;
    if (typeof value === "object") {
      return css + convertTokensToCssVariables(value, cssKey);
    } else {
      return `${css}${cssKey}: ${value};
`;
    }
  }, "");
};
const injectDesignSystemVariables = (tokens) => {
  const doesElementExist = (id) => document.getElementById(id) !== null;
  if (doesElementExist(cssVariablesTagId))
    return;
  const cssVariables = convertTokensToCssVariables(tokens);
  const cssClass = `:root {
${cssVariables}}`;
  const styleElement = document.createElement("style");
  styleElement.id = cssVariablesTagId;
  styleElement.textContent = cssClass;
  document.head.appendChild(styleElement);
};
const designSystemToken = (tokenPath) => {
  const tokens = ThemeTokens$1.getTokens();
  return tokens && lodashExports.get(tokens, `${tokenPath}.value`) || "";
};
const designSystemComposition = (compositionPath) => {
  const tokens = ThemeTokens$1.getTokens();
  if (!tokens)
    return {};
  const composition = lodashExports.get(tokens, compositionPath);
  return Object.keys(composition).reduce((acc, curr) => {
    acc[curr] = composition[curr].value;
    return acc;
  }, {});
};
function Body(props) {
  const { children: children2, size: size2, dangerouslyInnerHTML, ...rest } = props;
  const compositionProperties = designSystemComposition(`typography.body.${size2}`);
  let dangerouslySetInnerHTML;
  if (dangerouslyInnerHTML) {
    dangerouslySetInnerHTML = {
      __html: dangerouslyInnerHTML
    };
  }
  return /* @__PURE__ */ jsx(
    Typography,
    {
      color: designSystemToken("semantic.fg.black"),
      ...compositionProperties,
      dangerouslySetInnerHTML,
      ...rest,
      children: children2
    }
  );
}
function Display(props) {
  const { children: children2, size: size2, ...rest } = props;
  const compositionProperties = designSystemComposition(`typography.display.${size2}`);
  return /* @__PURE__ */ jsx(Typography, { color: designSystemToken("semantic.fg.black"), ...compositionProperties, ...rest, children: children2 });
}
function Headline(props) {
  const { children: children2, size: size2, ...rest } = props;
  const compositionProperties = designSystemComposition(`typography.headline.${size2}`);
  return /* @__PURE__ */ jsx(Typography, { color: designSystemToken("semantic.fg.black"), ...compositionProperties, ...rest, children: children2 });
}
const index = {};
function FiltersRadioChecked(props) {
  const { color = "#161719", width = 24, height = 24 } = props;
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width,
      height,
      viewBox: "0 0 24 24",
      fill: "none",
      children: [
        /* @__PURE__ */ jsx("circle", { cx: "12", cy: "12", r: "11", stroke: color, strokeWidth: "2" }),
        /* @__PURE__ */ jsx("circle", { cx: "12", cy: "12", r: "6", fill: color })
      ]
    }
  );
}
function FiltersCheckboxChecked(props) {
  const { color = "#161719", width = 24, height = 24 } = props;
  return /* @__PURE__ */ jsx(
    "svg",
    {
      width,
      height,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5.33316 2.02236C7.30655 0.703788 9.62663 0 12 0C15.1826 0 18.2348 1.26428 20.4853 3.51472C22.7357 5.76515 24 8.8174 24 12C24 14.3734 23.2962 16.6935 21.9776 18.6668C20.6591 20.6402 18.7849 22.1783 16.5922 23.0866C14.3995 23.9948 11.9867 24.2324 9.65892 23.7694C7.33115 23.3064 5.19295 22.1635 3.51472 20.4853C1.83649 18.8071 0.693605 16.6689 0.230582 14.3411C-0.232441 12.0133 0.00519943 9.60051 0.913451 7.4078C1.8217 5.21509 3.35977 3.34094 5.33316 2.02236ZM11.848 16.53L16.848 8.53C16.9886 8.3051 17.034 8.03357 16.9744 7.77514C16.9148 7.51672 16.7549 7.29257 16.53 7.152C16.3051 7.01144 16.0336 6.96597 15.7751 7.02561C15.5167 7.08525 15.2926 7.2451 15.152 7.47L10.818 14.404L8.707 12.293C8.5184 12.1108 8.2658 12.01 8.0036 12.0123C7.74141 12.0146 7.49059 12.1198 7.30518 12.3052C7.11978 12.4906 7.01461 12.7414 7.01233 13.0036C7.01005 13.2658 7.11084 13.5184 7.293 13.707L10.293 16.707C10.3857 16.8 10.4959 16.8738 10.6173 16.924C10.7386 16.9743 10.8687 17.0001 11 17C11.0377 17 11.0755 16.998 11.113 16.994C11.2625 16.9769 11.4062 16.9263 11.5335 16.8459C11.6607 16.7656 11.7682 16.6576 11.848 16.53Z",
          fill: color
        }
      )
    }
  );
}
function FiltersCheckboxUnChecked(props) {
  const { width = 24, height = 24 } = props;
  return /* @__PURE__ */ jsx(
    "svg",
    {
      width,
      height,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsx("circle", { cx: "12", cy: "12", r: "11.5", stroke: "#2C2D30", strokeOpacity: "0.12" })
    }
  );
}
function ClearIcon(props) {
  const { width = 20, height = 20 } = props;
  return /* @__PURE__ */ jsx(
    "svg",
    {
      width,
      height,
      viewBox: "0 0 28 28",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsx(
        "path",
        {
          d: "M7.70711 6.79289C7.31658 6.40237 6.68342 6.40237 6.29289 6.79289C5.90237 7.18342 5.90237 7.81658 6.29289 8.20711L12.5858 14.5L6.29289 20.7929C5.90237 21.1834 5.90237 21.8166 6.29289 22.2071C6.68342 22.5976 7.31658 22.5976 7.70711 22.2071L14 15.9142L20.2929 22.2071C20.6834 22.5976 21.3166 22.5976 21.7071 22.2071C22.0976 21.8166 22.0976 21.1834 21.7071 20.7929L15.4142 14.5L21.7071 8.20711C22.0976 7.81658 22.0976 7.18342 21.7071 6.79289C21.3166 6.40237 20.6834 6.40237 20.2929 6.79289L14 13.0858L7.70711 6.79289Z",
          fill: "black"
        }
      )
    }
  );
}
function AvatarPlaceholder(props) {
  const { width = 96, height = 96 } = props;
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width,
      height,
      viewBox: "0 0 96 96",
      fill: "none",
      children: [
        /* @__PURE__ */ jsx("rect", { width, height, fill: "url(#pattern0)" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M48 28C41.3726 28 36 33.3726 36 40C36 46.6274 41.3726 52 48 52C54.6274 52 60 46.6274 60 40C60 33.3726 54.6274 28 48 28ZM28 40C28 28.9543 36.9543 20 48 20C59.0457 20 68 28.9543 68 40C68 51.0457 59.0457 60 48 60C36.9543 60 28 51.0457 28 40ZM29.8244 74.9058C25.6074 76.7783 24 79.1432 24 82C24 82.8946 24.159 83.4008 24.3891 83.7679C24.6193 84.1351 25.1686 84.757 26.6488 85.4267C29.8125 86.858 36.0644 88 48 88C59.9356 88 66.1875 86.858 69.3512 85.4267C70.8314 84.757 71.3807 84.1351 71.6109 83.7679C71.841 83.4008 72 82.8946 72 82C72 79.1432 70.3926 76.7783 66.1756 74.9058C61.8457 72.9831 55.4886 72 48 72C40.5114 72 34.1543 72.9831 29.8244 74.9058ZM26.5777 67.5942C32.3817 65.0169 40.0247 64 48 64C55.9753 64 63.6183 65.0169 69.4223 67.5942C75.3394 70.2217 80 74.8568 80 82C80 83.8668 79.659 85.9913 78.3891 88.0171C77.1193 90.0426 75.1686 91.5755 72.6488 92.7155C67.8125 94.9034 60.0644 96 48 96C35.9356 96 28.1875 94.9034 23.3512 92.7155C20.8314 91.5755 18.8807 90.0426 17.6109 88.0171C16.341 85.9913 16 83.8668 16 82C16 74.8568 20.6607 70.2217 26.5777 67.5942Z",
            fill: "#A3A6AC",
            fillOpacity: "0.5"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M24 82C24 79.1432 25.6074 76.7783 29.8244 74.9058C34.1543 72.9831 40.5114 72 48 72C55.4886 72 61.8457 72.9831 66.1756 74.9058C70.3926 76.7783 72 79.1432 72 82C72 82.8946 71.841 83.4008 71.6109 83.7679C71.3807 84.1351 70.8314 84.757 69.3512 85.4267C66.1875 86.858 59.9356 88 48 88C36.0644 88 29.8125 86.858 26.6488 85.4267C25.1686 84.757 24.6193 84.1351 24.3891 83.7679C24.159 83.4008 24 82.8946 24 82Z",
            fill: "#A3A6AC",
            fillOpacity: "0.5"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M36 40C36 33.3726 41.3726 28 48 28C54.6274 28 60 33.3726 60 40C60 46.6274 54.6274 52 48 52C41.3726 52 36 46.6274 36 40Z",
            fill: "#A3A6AC",
            fillOpacity: "0.5"
          }
        )
      ]
    }
  );
}
function TabsScrollArrow(props) {
  const { color = "#2C2D30", width = 28, height = 28 } = props;
  return /* @__PURE__ */ jsx(
    "svg",
    {
      width,
      height,
      viewBox: "0 0 28 28",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.29289 4.29289C9.68342 3.90237 10.3166 3.90237 10.7071 4.29289L19.7071 13.2929C20.0976 13.6834 20.0976 14.3166 19.7071 14.7071L10.7071 23.7071C10.3166 24.0976 9.68342 24.0976 9.29289 23.7071C8.90237 23.3166 8.90237 22.6834 9.29289 22.2929L17.5858 14L9.29289 5.70711C8.90237 5.31658 8.90237 4.68342 9.29289 4.29289Z",
          fill: "#2C2D30"
        }
      )
    }
  );
}
function Label(props) {
  const { children: children2, size: size2, sx, underline, ...rest } = props;
  const compositionProperties = designSystemComposition(`typography.label.${size2}`);
  const textDecoration = underline ? "underline" : "none";
  return /* @__PURE__ */ jsx(
    Typography,
    {
      color: designSystemToken("semantic.fg.black"),
      ...compositionProperties,
      sx: { textDecoration, ...sx },
      ...rest,
      children: children2
    }
  );
}
const sizeMap = {
  "3xl": "1200",
  "2xl": "1000",
  xl: "800",
  lg: "600",
  md: "500",
  sm: "400",
  xs: "300",
  "2xs": "250",
  "3xs": "200"
};
const InitialsSizeComponent = (initials) => ({
  "3xl": () => /* @__PURE__ */ jsx(Display, { size: "sm", children: initials }),
  "2xl": () => /* @__PURE__ */ jsx(Headline, { size: "xl", children: initials }),
  xl: () => /* @__PURE__ */ jsx(Headline, { size: "lg", children: initials }),
  lg: () => /* @__PURE__ */ jsx(Headline, { size: "lg", children: initials }),
  md: () => /* @__PURE__ */ jsx(Body, { size: "xl", children: initials }),
  sm: () => /* @__PURE__ */ jsx(Body, { size: "lg", children: initials }),
  xs: () => /* @__PURE__ */ jsx(Body, { size: "md", children: initials }),
  "2xs": () => /* @__PURE__ */ jsx(Body, { size: "sm", children: initials }),
  "3xs": () => /* @__PURE__ */ jsx(Label, { size: "xs", children: initials })
});
const StyledAvatar = styled(Avatar$1)(({ background, type }) => ({
  background: background || (type === "placeholder" ? designSystemToken("semantic.bg.neutral-secondary") : designSystemToken("semantic.bg.brand")),
  zIndex: 1,
  ".MuiTypography-root": {
    color: designSystemToken("semantic.fg.white")
  },
  height: "100%",
  width: "100%"
}));
const StyledDiv$2 = styled("div")(({ size: size2 }) => ({
  position: "relative",
  borderRadius: "50%",
  width: designSystemToken(`size.${sizeMap[size2]}`),
  height: designSystemToken(`size.${sizeMap[size2]}`)
}));
const StyledBackground = styled("div")(({ type }) => ({
  position: "absolute",
  top: 0,
  left: 0,
  height: "100%",
  width: "100%",
  backgroundColor: type === "placeholder" ? "white" : "transparent",
  zIndex: 0,
  borderRadius: "50%"
}));
function Avatar(props) {
  const { type, initials, size: size2, src, className, background, ...rest } = props;
  const InitialsComponent = type === "initials" && initials ? InitialsSizeComponent(initials)[size2] : () => null;
  const PlaceholderComponent = type === "placeholder" ? () => /* @__PURE__ */ jsx(AvatarPlaceholder, {}) : () => null;
  return /* @__PURE__ */ jsxs(StyledDiv$2, { size: size2, className, children: [
    /* @__PURE__ */ jsx(StyledBackground, { type }),
    /* @__PURE__ */ jsxs(
      StyledAvatar,
      {
        src: type === "picture" ? src : "",
        type,
        size: size2,
        background,
        ...rest,
        children: [
          /* @__PURE__ */ jsx(InitialsComponent, {}),
          /* @__PURE__ */ jsx(PlaceholderComponent, {})
        ]
      }
    )
  ] });
}
const SEVERITY_TO_ICON_COLOR = {
  success: designSystemToken("semantic.fg.success"),
  warning: designSystemToken("semantic.fg.warning"),
  error: designSystemToken("semantic.bg.danger"),
  info: designSystemToken("semantic.bg.neutral")
};
const StyledAlert = styled(Alert)(
  ({ theme, mode = "dark", severity = "info" }) => {
    const backgroundColor = mode === "light" ? designSystemToken("semantic.bg.secondary") : designSystemToken("semantic.bg.neutral");
    const color = mode === "light" ? designSystemToken("semantic.fg.secondary") : designSystemToken("semantic.fg.inverse");
    return {
      position: "absolute",
      top: 40,
      left: "50%",
      transform: "translateX(-50%)",
      backgroundColor,
      color,
      zIndex: theme.zIndex.snackbar,
      borderRadius: 16,
      boxShadow: "0 2px 12px -2px rgba(24, 39, 75, 0.12), 0 8px 24px -4px rgba(24, 39, 75, 0.08)",
      ".MuiAlert-icon": {
        color: SEVERITY_TO_ICON_COLOR[severity],
        paddingTop: 6
      },
      ".MuiAlert-message": {
        wordWrap: "break-word"
      },
      maxWidth: "544px",
      [theme.breakpoints.down("mobile")]: {
        maxWidth: "calc(100vw - 32px)",
        boxSizing: "border-box"
      }
    };
  }
);
const StyledAlertTitle = styled(AlertTitle)`
  text-align: start;
  color: ${() => designSystemToken("semantic.bg.neutral")};
`;
function Banner(props) {
  const {
    isOpen,
    title,
    onActionClick,
    children: children2,
    severity,
    mode = "dark",
    testID = "banner",
    autoHide = true,
    ...rest
  } = props;
  useEffect(() => {
    if (!isOpen)
      return;
    setTimeout(() => {
      autoHide && onActionClick();
    }, 6e3);
  }, [isOpen]);
  const testIDProps = {
    "data-testid": testID
  };
  const headlineColor = mode === "light" ? designSystemToken("semantic.fg.primary") : designSystemToken("semantic.fg.inverse");
  return isOpen ? /* @__PURE__ */ jsxs(StyledAlert, { ...rest, ...testIDProps, mode, severity, onClose: onActionClick, children: [
    /* @__PURE__ */ jsx(StyledAlertTitle, { children: /* @__PURE__ */ jsx(Headline, { size: "xs", color: headlineColor, children: title }) }),
    children2
  ] }) : null;
}
const colorsMap = () => ({
  brand: {
    filled: {
      backgroundColor: designSystemToken("semantic.bg.brand"),
      color: designSystemToken("semantic.fg.white"),
      "&:disabled": {
        backgroundColor: designSystemToken("semantic.bg.disabled"),
        color: designSystemToken("semantic.fg.disabled")
      }
    },
    tinted: {
      backgroundColor: designSystemToken("semantic.bg.brand-secondary"),
      color: designSystemToken("semantic.fg.brand"),
      "&:disabled": {
        backgroundColor: designSystemToken("semantic.bg.disabled-secondary"),
        color: designSystemToken("semantic.fg.disabled")
      }
    },
    plain: {
      backgroundColor: designSystemToken("semantic.bg.transparent"),
      color: designSystemToken("semantic.fg.brand"),
      "&:disabled": {
        color: designSystemToken("semantic.fg.disabled")
      }
    },
    elevated: {
      backgroundColor: designSystemToken("semantic.bg.secondary"),
      color: designSystemToken("semantic.fg.brand"),
      boxShadow: "0px 0px 4px rgba(24, 39, 75, 0.02), 0px 4px 12px -2px rgba(24, 39, 75, 0.08)",
      "&:disabled": {
        backgroundColor: designSystemToken("semantic.bg.disabled-secondary"),
        color: designSystemToken("semantic.fg.disabled")
      }
    }
  },
  neutral: {
    filled: {
      backgroundColor: designSystemToken("semantic.bg.neutral"),
      color: designSystemToken("semantic.fg.neutral-secondary"),
      "&:disabled": {
        backgroundColor: designSystemToken("semantic.bg.disabled"),
        color: designSystemToken("semantic.fg.disabled")
      }
    },
    tinted: {
      backgroundColor: designSystemToken("semantic.bg.neutral-secondary"),
      color: designSystemToken("semantic.fg.neutral"),
      "&:disabled": {
        backgroundColor: designSystemToken("semantic.bg.disabled-secondary"),
        color: designSystemToken("semantic.fg.disabled")
      }
    },
    plain: {
      backgroundColor: designSystemToken("semantic.bg.transparent"),
      color: designSystemToken("semantic.fg.neutral"),
      "&:disabled": {
        color: designSystemToken("semantic.fg.disabled")
      }
    },
    elevated: {
      backgroundColor: designSystemToken("semantic.bg.secondary"),
      color: designSystemToken("semantic.fg.neutral"),
      boxShadow: "0px 0px 4px rgba(24, 39, 75, 0.02), 0px 4px 12px -2px rgba(24, 39, 75, 0.08)",
      "&:disabled": {
        backgroundColor: designSystemToken("semantic.bg.disabled-secondary"),
        color: designSystemToken("semantic.fg.disabled")
      }
    }
  },
  danger: {
    filled: {
      backgroundColor: designSystemToken("semantic.bg.danger"),
      color: designSystemToken("semantic.fg.white"),
      "&:disabled": {
        backgroundColor: designSystemToken("semantic.bg.disabled"),
        color: designSystemToken("semantic.fg.disabled")
      }
    },
    tinted: {
      backgroundColor: designSystemToken("semantic.bg.danger-secondary"),
      color: designSystemToken("semantic.fg.danger"),
      "&:disabled": {
        backgroundColor: designSystemToken("semantic.bg.disabled-secondary"),
        color: designSystemToken("semantic.fg.disabled")
      }
    },
    plain: {
      backgroundColor: designSystemToken("semantic.bg.transparent"),
      color: designSystemToken("semantic.fg.danger"),
      "&:disabled": {
        color: designSystemToken("semantic.fg.disabled")
      }
    },
    elevated: {
      backgroundColor: designSystemToken("semantic.bg.secondary"),
      color: designSystemToken("semantic.fg.danger"),
      boxShadow: "0px 0px 4px rgba(24, 39, 75, 0.02), 0px 4px 12px -2px rgba(24, 39, 75, 0.08)",
      "&:disabled": {
        backgroundColor: designSystemToken("semantic.bg.disabled-secondary"),
        color: designSystemToken("semantic.fg.disabled")
      }
    }
  },
  overlay: {
    filled: {
      backgroundColor: designSystemToken("semantic.bg.white"),
      color: designSystemToken("semantic.fg.primary"),
      "&:disabled": {
        backgroundColor: designSystemToken("semantic.bg.disabled"),
        color: designSystemToken("semantic.fg.disabled")
      }
    },
    tinted: {
      backgroundColor: designSystemToken("semantic.bg.black-secondary"),
      color: designSystemToken("semantic.fg.white"),
      "&:disabled": {
        backgroundColor: designSystemToken("semantic.bg.disabled-secondary"),
        color: designSystemToken("semantic.fg.disabled")
      }
    },
    plain: {
      backgroundColor: designSystemToken("semantic.bg.transparent"),
      color: designSystemToken("semantic.fg.white"),
      textShadow: "0px 0px 16px rgba(0, 0, 0, 0.24), 0px 0px 1px rgba(0, 0, 0, 0.04)",
      "&:disabled": {
        color: designSystemToken("semantic.fg.disabled"),
        textShadow: "none"
      }
    },
    elevated: {
      backgroundColor: designSystemToken("semantic.bg.white-secondary"),
      color: designSystemToken("semantic.fg.white"),
      textShadow: "0px 0px 16px rgba(0, 0, 0, 0.24), 0px 0px 1px rgba(0, 0, 0, 0.04)",
      "&:disabled": {
        backgroundColor: designSystemToken("semantic.bg.disabled-secondary"),
        color: designSystemToken("semantic.fg.disabled"),
        textShadow: "none"
      }
    }
  }
});
const sizesMap = (hasChildren, icon, iconPosition) => {
  let iconString;
  if (icon) {
    if (hasChildren) {
      if (iconPosition === "start") {
        iconString = "icon-first";
      } else {
        iconString = "label-first";
      }
    } else {
      iconString = "icon";
    }
  } else {
    iconString = "label";
  }
  return {
    large: {
      ...designSystemComposition("typography.label.lg"),
      ...designSystemComposition(`button.large.${iconString}`)
    },
    medium: {
      ...designSystemComposition("typography.label.md"),
      ...designSystemComposition(`button.medium.${iconString}`)
    },
    small: {
      ...designSystemComposition("typography.label.sm"),
      ...designSystemComposition(`button.small.${iconString}`)
    }
  };
};
const getColors = (appearance, mode) => colorsMap()[appearance][mode];
const getSize = (size2, hasChildren, icon, iconPosition) => sizesMap(hasChildren, icon, iconPosition)[size2];
const circleLoader = "_circleLoader_1rjeb_93";
const load8 = "_load8_1rjeb_1";
const styles$2 = {
  circleLoader,
  load8
};
function CircleLoader({ size: size2 }) {
  return /* @__PURE__ */ jsx("div", { className: styles$2.circleLoader, "data-size": size2 });
}
const shouldNotForwardProps$1 = [
  "appearance",
  "mode",
  "size",
  "iconPosition",
  "icon",
  "hasChildren",
  "isLoading"
];
const StyledButton$1 = styled(Button$1, {
  shouldForwardProp: (prop) => !shouldNotForwardProps$1.includes(prop)
})(({ appearance, mode, size: size2, icon, iconPosition, hasChildren }) => {
  const colorProperties = getColors(appearance, mode);
  const sizeProperties = getSize(size2, hasChildren, icon, iconPosition);
  return {
    ...colorProperties,
    ...sizeProperties,
    textTransform: "none",
    borderRadius: 24,
    minWidth: "auto",
    "&:hover": {
      backgroundColor: colorProperties.backgroundColor,
      opacity: 0.8
    },
    "&:active": {
      backgroundColor: colorProperties.backgroundColor,
      opacity: 0.5
    },
    ".MuiTouchRipple-root": {
      display: "none"
    }
  };
});
const StyledContent$1 = styled("div")`
  display: flex;
  justify-content: center;
  align-items: center;
  column-gap: 6px;
  height: 100%;
  opacity: ${(props) => props.isLoading ? 0 : void 0};
  white-space: nowrap;
`;
const StyledLoading = styled("span")`
  position: absolute;
`;
function Button(props) {
  const { children: children2, icon, iconPosition = "start", testID, ...rest } = props;
  if (!children2 && !icon)
    return null;
  const testIDProps = {
    "data-testid": testID || void 0
  };
  return /* @__PURE__ */ jsxs(
    StyledButton$1,
    {
      ...rest,
      ...testIDProps,
      iconPosition,
      icon,
      hasChildren: !!children2,
      "data-appearance": rest.appearance,
      "data-mode": rest.mode,
      "data-size": rest.size,
      children: [
        rest.isLoading ? /* @__PURE__ */ jsx(StyledLoading, { children: /* @__PURE__ */ jsx(CircleLoader, { size: rest.size }) }) : null,
        /* @__PURE__ */ jsxs(StyledContent$1, { isLoading: rest.isLoading, children: [
          iconPosition === "start" && icon,
          children2,
          iconPosition === "end" && icon
        ] })
      ]
    }
  );
}
const StyledFormControlLabel$1 = styled(FormControlLabel)`
  color: #404040;
  align-items: flex-start;

  .MuiCheckbox-root {
    margin-right: 5px;
    padding: 0 10px;
  }

  ${(props) => props.theme.breakpoints.down("mobile")} {
    margin-left: 0;
    width: 100%;
    display: flex;
  }
`;
const StyledFormHelperText = styled(FormHelperText)`
  margin-top: 0;
  height: 40px;
  color: ${() => designSystemToken("semantic.bg.danger")};
  margin-left: 36px;

  ${(props) => props.theme.breakpoints.down("mobile")} {
    margin-left: 49px;
  }
`;
function Checkbox(props) {
  const {
    label,
    checked,
    onChange,
    error,
    customCheckedIcon,
    customUncheckedIcon,
    testID = "checkbox",
    radio = false,
    ...rest
  } = props;
  const handleClick = (event) => {
    onChange(event.target.checked);
  };
  const testIDProps = {
    "data-testid": testID
  };
  return /* @__PURE__ */ jsxs(FormControl, { ...testIDProps, children: [
    /* @__PURE__ */ jsx(
      StyledFormControlLabel$1,
      {
        control: /* @__PURE__ */ jsx(
          Checkbox$1,
          {
            ...rest,
            disableRipple: true,
            icon: customUncheckedIcon || /* @__PURE__ */ jsx(FiltersCheckboxUnChecked, {}),
            checkedIcon: radio ? /* @__PURE__ */ jsx(FiltersRadioChecked, {}) : customCheckedIcon || /* @__PURE__ */ jsx(FiltersCheckboxChecked, {}),
            onChange: handleClick,
            sx: {
              "& .MuiSvgIcon-root": {
                fontSize: 25
              },
              "&.Mui-checked": {
                color: "#000000"
              }
            }
          }
        ),
        label,
        checked
      }
    ),
    /* @__PURE__ */ jsx(StyledFormHelperText, { children: error })
  ] });
}
const StyledIcon$1 = styled("svg")`
  &.icon-small {
    width: 16px;
    height: 16px;
  }
  &.icon-medium {
    width: 24px;
    height: 24px;
  }
  &.icon-large {
    width: 32px;
    height: 32px;
  }
  fill: ${(props) => props.color ? props.color : designSystemToken(`semantic.fg.${props.appearance}`)};
`;
function Icon(props) {
  const { size: size2, appearance, name, color, className, style } = props;
  return /* @__PURE__ */ jsx(
    StyledIcon$1,
    {
      className: `icon-${size2} ${className || ""}`,
      style,
      appearance,
      name,
      size: size2,
      color: color ? color : "",
      children: /* @__PURE__ */ jsx("use", { type: "image/svg+xml", href: `/icon.svg#${name}` })
    }
  );
}
const StyledInputStatic = styled(TextField)`
  .MuiInputBase-input {
    padding: 0px;
  }

  width: 100%;
  .MuiInputBase-root {
    border: solid 1px ${() => designSystemToken("semantic.bg.neutral-secondary")};
    border-radius: 8px;
    height: 46px;
    padding-top: 8px;
    padding-bottom: 8px;
    margin-bottom: 10px;

    &.Mui-error {
      border-color: ${() => designSystemToken("semantic.bg.danger")};
      .MuiInput-input {
        border-color: ${() => designSystemToken("semantic.bg.danger")};
      }
    }
    &.Mui-focused {
      border: solid 1px ${() => designSystemToken("semantic.bg.neutral")};
    }
    &.Mui-disabled {
      background-color: ${() => designSystemToken("semantic.bg.disabled-secondary")};
      .MuiInput-input {
        color: ${() => designSystemToken("semantic.fg.disabled")};
      }
    }
    .MuiInput-input {
      ${() => designSystemComposition("typography.body.lg")};
      color: ${() => designSystemToken("semantic.fg.primary")};
      color: ${() => designSystemToken("semantic.fg.primary")};
      height: unset;
      font-style: normal;
      font-weight: 400;
      line-height: 19px;
      letter-spacing: -0.2px;
      border-radius: 5px;

      &.placeholder {
        color: ${() => designSystemToken("semantic.fg.inverse-secondary")};
        opacity: 1;
      }
      &.Mui-disabled {
        color: ${() => designSystemToken("semantic.fg.disabled")};
      }
    }
  }
  .MuiFormHelperText-root {
    position: absolute;
    top: 100%;
    margin-top: 0px;
    color: ${() => designSystemToken("semantic.fg.secondary")};
    ${() => designSystemComposition("typography.body.sm")};
    padding: 0px 16px;

    &.Mui-error {
      color: ${() => designSystemToken("semantic.bg.danger")};
    }
    &.Mui-disabled {
      color: ${() => designSystemToken("semantic.fg.disabled")};
    }
    a {
      color: ${() => designSystemToken("semantic.fg.brand")};
    }
  }
`;
const StyledInput = styled(StyledInputStatic)(
  ({
    starticon,
    clearicon,
    endicon
  }) => ({
    ".MuiInputBase-root": {
      paddingLeft: starticon ? "12px" : "16px",
      paddingRight: clearicon || endicon ? "12px" : "16px"
    }
  })
);
const StyledInputLabel$1 = styled(InputLabel)`
  margin-bottom: 8px;
  .MuiTypography-root {
    color: ${() => designSystemToken("semantic.fg.primary")};
  }
  &.Mui-disabled {
    .MuiTypography-root {
      color: ${() => designSystemToken("semantic.fg.disabled")};
    }
  }
`;
const StyledButton = styled("button")`
  background-color: transparent;
  border: none;
  cursor: pointer;
  outline: none;
  padding: 0px;
  margin: 0px;
  display: flex;
`;
const StyledStartAdornment = styled(InputAdornment)(({ icon }) => ({
  marginRight: icon ? "16px" : "0px"
}));
const StyledEndAdornment = styled(InputAdornment)(({ val }) => ({
  visibility: val ? "visible" : "hidden"
}));
function InnerInput(props) {
  const {
    label,
    labelSize = "md",
    labelStyle,
    errorText,
    supportingText,
    onInputChange,
    onInputBlur,
    testID,
    className,
    disabled,
    startIcon,
    endIcon,
    clearIcon = true,
    focused,
    value,
    setBlurred,
    ...rest
  } = props;
  const testIDProps = {
    "data-testid": testID || void 0
  };
  const [val, setValue] = useState(value ? value : "");
  const [mouseDown, setMouseDown] = useState(false);
  const handleClear = () => {
    setValue("");
    if (onInputChange) {
      onInputChange("");
    }
    if (setBlurred) {
      setBlurred(false);
    }
  };
  const onChange = (event) => {
    const text = event.target.value;
    setValue(text);
    if (onInputChange) {
      onInputChange(text);
    }
  };
  const getHelperText = () => {
    if (errorText && !mouseDown)
      return errorText;
    if (supportingText)
      return supportingText;
    return null;
  };
  const onBlur = () => {
    if (onInputBlur) {
      onInputBlur();
    }
  };
  const getEndAdornment = () => {
    if (endIcon) {
      return /* @__PURE__ */ jsx(StyledEndAdornment, { val: 1, position: "end", children: endIcon });
    } else if (clearIcon) {
      return /* @__PURE__ */ jsx(
        StyledEndAdornment,
        {
          position: "end",
          onClick: handleClear,
          onMouseDown: () => setMouseDown(true),
          onMouseUp: () => setMouseDown(false),
          val: val ? 1 : 0,
          children: /* @__PURE__ */ jsx(StyledButton, { type: "reset", children: /* @__PURE__ */ jsx(ClearIcon, {}) })
        }
      );
    }
    return null;
  };
  return /* @__PURE__ */ jsxs("div", { className, children: [
    /* @__PURE__ */ jsx(
      StyledInputLabel$1,
      {
        disableAnimation: true,
        disabled,
        sx: {
          ...designSystemComposition(`typography.label.${labelSize}`),
          ...labelStyle
        },
        children: /* @__PURE__ */ jsx(Body, { size: labelSize, children: label })
      }
    ),
    /* @__PURE__ */ jsx(
      StyledInput,
      {
        starticon: startIcon ? 1 : 0,
        endicon: endIcon ? 1 : 0,
        clearicon: clearIcon ? 1 : 0,
        helperText: getHelperText() ? getHelperText() : null,
        error: !!errorText && !mouseDown,
        value: val,
        onChange,
        InputProps: {
          disableUnderline: true,
          onChange,
          onBlur,
          startAdornment: /* @__PURE__ */ jsx(StyledStartAdornment, { icon: startIcon ? 1 : 0, position: "start", children: startIcon }),
          endAdornment: getEndAdornment()
        },
        variant: "standard",
        disabled,
        focused,
        ...rest,
        ...testIDProps
      }
    )
  ] });
}
function ValidatedInput(props) {
  const { validatorOptions, ...rest } = props;
  const [localValue, setLocalValue] = useState("");
  const [error, setError] = useState("");
  const [inputBlurredAtLeastOnce, setInputBlurredAtLeastOnce] = useState(false);
  const { type, onValidation, validators, isValid, onChangeText, overrideError } = validatorOptions;
  const validate = useCallback(
    (text) => {
      const invalidObject = validators.find(({ validator }) => !validator(text));
      if (invalidObject) {
        setError(invalidObject.errorMessage);
        onValidation == null ? void 0 : onValidation(false);
      } else if (!invalidObject) {
        setError("");
        onValidation == null ? void 0 : onValidation(true);
      }
    },
    [validatorOptions.validators]
  );
  useEffect(() => {
    setError(overrideError);
  }, [overrideError]);
  useEffect(() => {
    if (typeof isValid === "boolean" && inputBlurredAtLeastOnce) {
      validate(localValue);
    }
  }, [isValid, inputBlurredAtLeastOnce]);
  const onChangeTextProxy = (text) => {
    setLocalValue(text);
    onChangeText(text);
    validate(text);
  };
  const onBlurProxy = () => {
    setInputBlurredAtLeastOnce(true);
    validate(localValue);
  };
  const errorText = inputBlurredAtLeastOnce && error || inputBlurredAtLeastOnce && isValid === false || overrideError ? error : "";
  return /* @__PURE__ */ jsx(
    InnerInput,
    {
      type,
      onInputBlur: onBlurProxy,
      errorText,
      setBlurred: setInputBlurredAtLeastOnce,
      ...rest,
      onInputChange: onChangeTextProxy
    }
  );
}
function Input(props) {
  const { validatorOptions, ...rest } = props;
  if (validatorOptions) {
    return /* @__PURE__ */ jsx(ValidatedInput, { ...props, validatorOptions });
  }
  return /* @__PURE__ */ jsx(InnerInput, { ...rest });
}
function Modal(props) {
  const {
    testID = "modal",
    children: children2,
    size: _size,
    width,
    icon,
    header,
    textAlignment = "center",
    footerAlignment = "center",
    primaryButtonText,
    primaryButtonProps,
    handlePrimaryButtonClick,
    secondaryButtonText,
    secondaryButtonProps,
    handleSecondaryButtonClick,
    handleClose,
    showCloseButton,
    hideScrollbars = true,
    fullScreen,
    className,
    contentClassName,
    ...rest
  } = props;
  const isSizeSet = !!_size;
  const size2 = isSizeSet ? _size : "large";
  const footerButtonProps = {
    size: "large",
    appearance: "neutral",
    mode: "filled",
    sx: modalActionButtonSx[size2]
  };
  return /* @__PURE__ */ jsx(StyledMuiModal, { ...rest, onClose: handleClose, "data-testid": testID, className, children: /* @__PURE__ */ jsxs(
    StyledModalContent,
    {
      sx: modalContentSx({ width, isSizeSet })[width ? "custom" : size2],
      hideScrollbars,
      fullScreen,
      className: contentClassName,
      children: [
        showCloseButton && /* @__PURE__ */ jsx(
          StyledModalCloseButton,
          {
            onClick: handleClose,
            mode: "plain",
            size: "medium",
            appearance: "neutral",
            icon: /* @__PURE__ */ jsx(Icon, { name: "Actions-Close-Small", size: "medium", appearance: "neutral" }),
            sx: modalCloseButtonSx[size2]
          }
        ),
        icon && /* @__PURE__ */ jsx(StyledModalIconContainer, { children: icon }),
        header && /* @__PURE__ */ jsx(StyledModalHeaderDiv, { alignment: textAlignment, children: /* @__PURE__ */ jsx(Headline, { size: "md", children: header }) }),
        /* @__PURE__ */ jsx(StyledModalBody, { component: "div", size: "md", alignment: textAlignment, children: children2 }),
        (secondaryButtonText || primaryButtonText) && /* @__PURE__ */ jsxs(StyledModalFooterDiv, { sx: modalFooterSx[size2], alignment: footerAlignment, children: [
          /* @__PURE__ */ jsx(
            Button,
            {
              onClick: handleSecondaryButtonClick,
              ...footerButtonProps,
              mode: "tinted",
              testID: `${testID}__primary-button`,
              ...secondaryButtonProps,
              children: secondaryButtonText
            }
          ),
          /* @__PURE__ */ jsx(
            Button,
            {
              onClick: handlePrimaryButtonClick,
              ...footerButtonProps,
              ...primaryButtonProps,
              children: primaryButtonText
            }
          )
        ] })
      ]
    }
  ) });
}
const flexAligned = (alignment) => ({
  display: "flex",
  justifyContent: alignment,
  alignItems: "center",
  alignSelf: "stretch"
});
const StyledMuiModal = styled(Modal$1)(() => ({
  "& .MuiBackdrop-root": {
    backgroundColor: designSystemToken("semantic.bg.alpha-secondary")
  }
}));
const StyledModalContent = styled("div", { name: "modal-content" })(({ hideScrollbars = false, fullScreen }) => ({
  display: "flex",
  width: fullScreen ? "100vw !important" : "",
  height: fullScreen ? "100vh !important" : "",
  maxWidth: fullScreen ? "" : "95vw",
  maxHeight: fullScreen ? "" : "95vh",
  overflow: "auto",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: 16,
  borderRadius: fullScreen ? 0 : 32,
  backgroundColor: designSystemToken("semantic.bg.secondary"),
  boxShadow: "0px 6px 28px -6px rgba(24, 39, 75, 0.12), 0px 18px 64px -4px rgba(24, 39, 75, 0.16)",
  boxSizing: "border-box",
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  outline: "none",
  ...hideScrollbars ? {
    scrollbarWidth: "none",
    // Hide the scrollbar for firefox
    "&::-webkit-scrollbar": {
      display: "none"
      // Hide the scrollbar for WebKit browsers (Chrome, Safari, Edge, etc.)
    },
    "&-ms-overflow-style:": {
      display: "none"
      // Hide the scrollbar for IE
    }
  } : {}
}));
const StyledModalCloseButton = styled(Button)(() => ({
  position: "absolute",
  top: "32px",
  right: "32px",
  padding: 0,
  margin: 0,
  width: "32px",
  height: "32px",
  borderRadius: "50%",
  border: `1px solid ${designSystemToken("semantic.bg.neutral-inverse")}`
}));
const StyledModalHeaderDiv = styled("div")(({ alignment }) => ({
  ...flexAligned(alignment),
  height: "26px"
}));
const StyledModalIconContainer = styled("div")(() => ({
  width: "32px",
  height: "32px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
}));
const StyledModalBody = styled(Body)(
  ({ alignment = "center" }) => ({
    ...flexAligned(alignment),
    textAlign: alignment,
    flexDirection: "column",
    width: "100%",
    color: designSystemToken("semantic.fg.secondary"),
    "> *": {
      color: designSystemToken("semantic.fg.primary")
    }
  })
);
const StyledModalFooterDiv = styled("div")(({ alignment }) => ({
  ...flexAligned(alignment),
  gap: "8px"
}));
const modalContentSx = ({ width, isSizeSet }) => ({
  small: { p: 3, pt: 4, width: 320 },
  large: { p: 5, pt: 6, width: isSizeSet ? 600 : "fit-content" },
  custom: { p: 5, pt: 6, width }
});
const modalFooterSx = {
  small: { flexDirection: "column", pt: 1 },
  large: { flexDirection: "row", pt: 2 }
};
const modalActionButtonSx = {
  small: { width: 1 },
  large: { width: "unset" }
};
const modalCloseButtonSx = {
  small: { top: 16, right: 16 },
  large: { top: 32, right: 32 }
};
function r(e) {
  var t, f, n = "";
  if ("string" == typeof e || "number" == typeof e)
    n += e;
  else if ("object" == typeof e)
    if (Array.isArray(e))
      for (t = 0; t < e.length; t++)
        e[t] && (f = r(e[t])) && (n && (n += " "), n += f);
    else
      for (t in e)
        e[t] && (n && (n += " "), n += t);
  return n;
}
function clsx() {
  for (var e, t, f = 0, n = ""; f < arguments.length; )
    (e = arguments[f++]) && (t = r(e)) && (n && (n += " "), n += t);
  return n;
}
const progressBarContainer = "_progressBarContainer_m8i0q_93";
const barContainer = "_barContainer_m8i0q_98";
const sm = "_sm_m8i0q_105";
const md = "_md_m8i0q_108";
const lg = "_lg_m8i0q_111";
const fillerBackground = "_fillerBackground_m8i0q_115";
const filler = "_filler_m8i0q_115";
const styles$1 = {
  progressBarContainer,
  barContainer,
  sm,
  md,
  lg,
  fillerBackground,
  filler
};
function ProgressBar(props) {
  const {
    className,
    testID = "progress-bar",
    value,
    size: size2 = "sm",
    fillColor,
    backgroundColor,
    useRelativeGradientPercentage = false
  } = props;
  const [valueProxy, setValueProxy] = useState(0);
  useEffect(
    function animateInitialValue() {
      const normalizedValue = value <= 1 ? value * 100 : value;
      const timeout = setTimeout(() => setValueProxy(Math.min(100, normalizedValue)));
      return () => clearTimeout(timeout);
    },
    [value]
  );
  const fillerRelativePercentage = useRelativeGradientPercentage && valueProxy > 0 ? Math.min(100 / valueProxy * 100, 100) : 0;
  const fillColorStyle = useMemo(() => {
    const style = {};
    if (useRelativeGradientPercentage) {
      style.width = `${fillerRelativePercentage}%`;
    }
    if (fillColor) {
      style.background = fillColor;
    }
    return style;
  }, [fillColor, fillerRelativePercentage, useRelativeGradientPercentage]);
  const barContainerStyle = useMemo(() => {
    if (!backgroundColor) {
      return {};
    }
    return {
      background: backgroundColor
    };
  }, [backgroundColor]);
  return /* @__PURE__ */ jsx("div", { "data-testid": testID, className: clsx(className, styles$1.progressBarContainer), children: /* @__PURE__ */ jsx("div", { className: clsx(styles$1.barContainer, styles$1[size2]), style: barContainerStyle, children: /* @__PURE__ */ jsx(
    "div",
    {
      "data-testid": "progress-bar-filler",
      className: styles$1.filler,
      style: { width: `${valueProxy}%` },
      children: /* @__PURE__ */ jsx("div", { className: styles$1.fillerBackground, style: fillColorStyle })
    }
  ) }) });
}
const ICON_NAMES_MAP = {
  instagram: "Social-Instagram",
  facebook: "Social-Facebook",
  tiktok: "Social-TikTok",
  // eslint-disable-next-line camelcase
  tiktok_v2: "Social-TikTok",
  youtube: "Social-YouTube",
  twitter: "Social-Twitter",
  pinterest: "Social-Pinterest"
};
function SocialNetworkIcon(props) {
  const { network, appearance, size: size2, color } = props;
  return /* @__PURE__ */ jsx(Icon, { size: size2, appearance, color, name: ICON_NAMES_MAP[network] });
}
const StyledFormControlLabel = styled(FormControlLabel)`
  margin: 0;

  .MuiFormControlLabel-label {
    margin-left: 6px;
    font-size: 14px;
    line-height: 18px;
    font-weight: 500;
    color: ${designSystemToken("semantic.fg.neutral")};
  }
`;
const StyledSwitch = styled((props) => /* @__PURE__ */ jsx(Switch, { focusVisibleClassName: ".Mui-focusVisible", disableRipple: true, ...props }))(({ theme, ...props }) => {
  return {
    width: 28,
    height: 18,
    padding: 0,
    "& .MuiSwitch-switchBase": {
      padding: 0,
      margin: 2,
      transitionDuration: "300ms",
      "&.Mui-checked": {
        transform: "translateX(10px)",
        color: "#fff",
        "& + .MuiSwitch-track": {
          backgroundColor: props.checkedTrackColor || designSystemToken("semantic.bg.brand"),
          opacity: 1,
          border: 0
        },
        "& .MuiSwitch-thumb": {
          backgroundColor: props.checkedThumbColor || void 0,
          opacity: 1
        },
        "&.Mui-disabled + .MuiSwitch-track": {
          opacity: 0.5
        }
      },
      "&.Mui-focusVisible .MuiSwitch-thumb": {
        color: "#33cf4d",
        border: "6px solid #fff"
      },
      "&.Mui-disabled .MuiSwitch-thumb": {
        color: theme.palette.mode === "light" ? theme.palette.grey[100] : theme.palette.grey[600]
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: theme.palette.mode === "light" ? 0.7 : 0.3
      }
    },
    "& .MuiSwitch-thumb": {
      boxSizing: "border-box",
      width: 14,
      height: 14,
      backgroundColor: props.uncheckedThumbColor || void 0
    },
    "& .MuiSwitch-track": {
      borderRadius: 26 / 2,
      backgroundColor: props.uncheckedTrackColor || designSystemToken("semantic.fg.tertiary"),
      opacity: 1,
      transition: theme.transitions.create(["background-color"], {
        duration: 400
      })
    }
  };
});
function SwitchButton(props) {
  const { label, onChange, checked, disabled, ...rest } = props;
  return /* @__PURE__ */ jsx(
    StyledFormControlLabel,
    {
      checked,
      disabled,
      control: /* @__PURE__ */ jsx(StyledSwitch, { ...rest, onChange }),
      label
    }
  );
}
const StyledDiv$1 = styled("div")(({ direction }) => ({
  transform: direction === "left" ? "scaleX(-1)" : "none",
  display: "flex",
  alignItems: "center",
  padding: 6
}));
const ScrollButtonComponent = ({ ownerState, tabsRef }) => {
  const { disabled, direction } = ownerState;
  useEffect(() => {
    if (!tabsRef.current) {
      return;
    }
    tabsRef.current.style.setProperty(
      direction === "left" ? "--left-opacity" : "--right-opacity",
      disabled ? "0" : "1"
    );
  }, [disabled, direction, tabsRef]);
  return /* @__PURE__ */ jsx(StyledDiv$1, { direction, children: /* @__PURE__ */ jsx(TabsScrollArrow, {}) });
};
const TabComponent = (props) => {
  const { size: size2, label, children: children2, innerRef, testID, startAdornment, endAdornment, ...rest } = props;
  return /* @__PURE__ */ jsxs("button", { "data-testid": testID, role: "button", ...rest, ref: innerRef, children: [
    children2,
    startAdornment,
    /* @__PURE__ */ jsx(Label, { size: size2 === "large" ? "lg" : "md", children: label }),
    endAdornment
  ] });
};
const shouldNotForwardProps = [
  "size",
  "appearance",
  "tabsData",
  "showBorderBottom",
  "sidesColor",
  "big",
  "slotProps"
];
const getBackgroundColor = (appearance) => {
  const colors = {
    overlay: designSystemToken("semantic.fg.white"),
    neutral: designSystemToken("semantic.fg.primary"),
    brand: designSystemToken("semantic.fg.brand"),
    default: designSystemToken("semantic.fg.primary")
  };
  return colors[appearance] || colors.default;
};
const StyledTabs = styled(Tabs$1, {
  shouldForwardProp: (prop) => !shouldNotForwardProps.includes(prop)
})(({ theme, appearance, sidesColor, big }) => ({
  "--left-opacity": "0",
  "--right-opacity": "0",
  backgroundColor: designSystemToken("semantic.bg.transparent"),
  position: "relative",
  minHeight: 0,
  ".MuiTabs-scroller": {
    ".MuiTabs-flexContainer": {
      height: "100%"
    },
    ".MuiTabs-indicator": {
      backgroundColor: "transparent",
      display: "flex",
      justifyContent: "center",
      span: {
        width: "100%",
        height: 2,
        borderRadius: 4,
        background: getBackgroundColor(appearance),
        boxShadow: appearance === "overlay" ? "0px 0px 1px rgba(0, 0, 0, 0.04), 0px 0px 16px rgba(0, 0, 0, 0.24)" : "none"
      }
    },
    ".MuiTab-root": {
      textTransform: "none",
      minHeight: 0,
      paddingBlock: big ? "24px" : "16px",
      "&:focus": {
        outline: "none"
      },
      "&.Mui-selected": {
        ".MuiTypography-root": {
          color: appearance === "overlay" ? designSystemToken("semantic.fg.white") : designSystemToken("semantic.fg.primary")
        }
      },
      ".MuiTypography-root": {
        color: appearance === "overlay" ? designSystemToken("semantic.fg.white") : designSystemToken("semantic.fg.secondary"),
        textShadow: appearance === "overlay" ? "0px 0px 1px rgba(0, 0, 0, 0.04), 0px 0px 16px rgba(0, 0, 0, 0.24)" : "none"
      }
    }
  },
  "&:after, &:before": {
    content: '""',
    height: "100%",
    width: 104,
    position: "absolute",
    zIndex: 1,
    pointerEvents: "none",
    transition: "opacity .2s ease-in-out",
    [theme.breakpoints.down("mobile")]: {
      display: "none"
    }
  },
  "&:before": {
    left: 0,
    background: `linear-gradient(90deg,${sidesColor || designSystemToken("semantic.bg.secondary")} 0,#fff0 90%,#fff0)`,
    opacity: "var(--left-opacity)"
  },
  "&:after": {
    right: 0,
    background: `linear-gradient(270deg,${sidesColor || designSystemToken("semantic.bg.secondary")} 0,#fff0 90%,#fff0)`,
    opacity: "var(--right-opacity)"
  },
  ".MuiTabScrollButton-root": {
    position: "absolute",
    right: 0,
    height: "100%",
    zIndex: 2,
    ".MuiTouchRipple-root": {
      display: "none"
    },
    "&:first-of-type": {
      left: 0
    },
    [theme.breakpoints.down("mobile")]: {
      display: "none"
    }
  }
}));
const StyledBorder = styled("div")(() => ({
  position: "absolute",
  width: "100%",
  height: 1,
  bottom: 0,
  background: designSystemToken("semantic.bg.neutral-secondary")
}));
const StyledContainer = styled("div")(() => ({
  position: "relative",
  ".MuiTabs-root": {
    minHeight: 40
  }
}));
function Tabs(props) {
  const {
    onChange,
    value,
    className,
    testID,
    tabsData,
    size: size2,
    showBorderBottom = false,
    ...rest
  } = props;
  const onTabChange = (event, newValue) => {
    onChange == null ? void 0 : onChange(event, newValue);
  };
  const tabsRef = useRef(null);
  return /* @__PURE__ */ jsxs(StyledContainer, { "data-testid": testID, className, children: [
    /* @__PURE__ */ jsx(
      StyledTabs,
      {
        ref: tabsRef,
        ...rest,
        size: size2,
        tabsData,
        value,
        scrollButtons: "auto",
        variant: "scrollable",
        onChange: onTabChange,
        TabIndicatorProps: { children: /* @__PURE__ */ jsx("span", {}) },
        slots: {
          EndScrollButtonIcon: (props2) => /* @__PURE__ */ jsx(ScrollButtonComponent, { ...props2, tabsRef }),
          StartScrollButtonIcon: (props2) => /* @__PURE__ */ jsx(ScrollButtonComponent, { ...props2, tabsRef })
        },
        children: tabsData.map(({ value: value2, label, startAdornment, endAdornment }, index2) => /* @__PURE__ */ jsx(
          Tab,
          {
            value: value2,
            disableTouchRipple: true,
            component: require$$0.forwardRef((props2, ref) => /* @__PURE__ */ jsx(
              TabComponent,
              {
                ...props2,
                testID: `tab-${value2}`,
                label,
                size: size2,
                innerRef: ref,
                startAdornment,
                endAdornment
              }
            ))
          },
          `${value2}-${index2 + 1}`
        ))
      }
    ),
    showBorderBottom && /* @__PURE__ */ jsx(StyledBorder, {})
  ] });
}
const StyledContent = styled("div")`
  display: flex;

  * {
    cursor: ${(props) => props.onClick ? "pointer" : "inherit"};
  }
`;
const StyledDiv = styled("div")`
  background-color: ${(props) => props.backgroundColor};
  border: 1px solid ${() => designSystemToken("semantic.bg.neutral-secondary")};
  border-radius: 8px;
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  justify-content: space-around;
  padding: 4px 8px;
`;
const StyledLabel = styled("label")`
  color: ${(props) => props.color};
  font-size: ${(props) => `${props.size || 12}px`};
`;
const StyledIcon = styled("label")`
  display: flex;
  align-items: center;
  padding-left: 2px;
  padding-right: 2px;
`;
function Tag(props) {
  const { testID = "ds-tag", onClick, text, textColor, backgroundColor, textSize, icon } = props;
  return /* @__PURE__ */ jsx(StyledContent, { "data-testid": testID, onClick, children: /* @__PURE__ */ jsxs(StyledDiv, { backgroundColor, children: [
    icon ? /* @__PURE__ */ jsx(StyledIcon, { children: icon }) : null,
    /* @__PURE__ */ jsx(StyledLabel, { color: textColor, size: textSize, children: text })
  ] }) });
}
const StyledTextarea = styled(TextareaAutosize)`
  width: 100%;
  box-sizing: border-box;
  outline: none;
  border: solid 1px ${() => designSystemToken("semantic.bg.neutral-secondary")};
  border-radius: 8px;
  ${() => designSystemComposition("typography.body.lg")};
  color: ${() => designSystemToken("semantic.fg.primary")};
  padding: 18px 16px;
  resize: none;

  &:disabled{
    background-color: ${() => designSystemToken("semantic.bg.disabled-secondary")};
    &::placeholder {
      color: ${() => designSystemToken("semantic.fg.disabled")};
      opacity: 1;
    })
  }
  
  &:focus {
    outline: none;
    border: solid 1px ${() => designSystemToken("semantic.bg.neutral")};
  }
  
  &::placeholder {
    color: ${() => designSystemToken("semantic.fg.inverse-secondary")};
    opacity: 1;
  })`;
const StyledInputLabel = styled(InputLabel)`
  margin-bottom: 8px;
  .MuiTypography-root {
    color: ${() => designSystemToken("semantic.fg.primary")};
    ${() => designSystemComposition("typography.label.md")};
  }
  &.Mui-disabled {
    .MuiTypography-root {
      color: ${() => designSystemToken("semantic.fg.disabled")};
    }
  }
`;
const StyledHelperText = styled(FormHelperText)`
  top: 100%;
  color: ${() => designSystemToken("semantic.fg.primary")};
  margin-top: 0px;

  .MuiTypography-root {
    color: ${() => designSystemToken("semantic.fg.secondary")};
    ${() => designSystemComposition("typography.body.sm")};
    padding: 0px 16px;
  }
  &.Mui-error {
    .MuiTypography-root {
      color: ${() => designSystemToken("semantic.bg.danger")};
      ${() => designSystemComposition("typography.body.sm")};
      padding: 0px 16px;
    }
  }
  &.Mui-disabled {
    .MuiTypography-root {
      color: ${() => designSystemToken("semantic.fg.disabled")};
    }
  }
  a {
    color: ${() => designSystemToken("semantic.fg.brand")};
  }
`;
function Textarea(props) {
  const { label, supportingText, testID, className, disabled, ...rest } = props;
  const testIDProps = {
    "data-testid": testID || void 0
  };
  return /* @__PURE__ */ jsxs("div", { className, children: [
    /* @__PURE__ */ jsx(StyledInputLabel, { disableAnimation: true, disabled, children: /* @__PURE__ */ jsx(Body, { size: "md", children: label }) }),
    /* @__PURE__ */ jsx(StyledTextarea, { disabled, ...rest, ...testIDProps }),
    /* @__PURE__ */ jsx(StyledHelperText, { disabled, children: /* @__PURE__ */ jsx(Body, { size: "md", children: supportingText }) })
  ] });
}
const StyledTooltip = styled(({ className, type, ...props }) => /* @__PURE__ */ jsx(Tooltip$1, { ...props, classes: { popper: className } }))(({ theme, type }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    fontFamily: "Brown LL",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "18px",
    letterSpacing: "-0.2px",
    backgroundColor: type === "dark" ? designSystemToken("semantic.bg.inverse") : designSystemToken("semantic.bg.secondary"),
    color: type === "dark" ? designSystemToken("semantic.fg.inverse") : designSystemToken("semantic.fg.primary"),
    boxShadow: `0px 2px 12px -2px rgba(24, 39, 75, 0.12), 0px 8px 24px -4px rgba(24, 39, 75, 0.08)`,
    padding: "10px 12px",
    borderRadius: "8px"
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: type === "dark" ? designSystemToken("semantic.bg.inverse") : designSystemToken("semantic.bg.secondary"),
    "&:before": {
      boxShadow: `0px 2px 12px -2px rgba(24, 39, 75, 0.12), 0px 8px 24px -4px rgba(24, 39, 75, 0.08)`
    }
  }
}));
function Tooltip(props) {
  const { children: children2, ...rest } = props;
  return /* @__PURE__ */ jsx(StyledTooltip, { ...rest, children: children2 });
}
const wizardLayoutContainer = "_wizardLayoutContainer_z545v_93";
const desktopContent = "_desktopContent_z545v_111";
const primaryContent = "_primaryContent_z545v_131";
const primaryContentInner = "_primaryContentInner_z545v_140";
const typography = "_typography_z545v_164";
const children = "_children_z545v_171";
const topNav = "_topNav_z545v_179";
const topNavButtonContainer = "_topNavButtonContainer_z545v_195";
const topNavButton = "_topNavButton_z545v_195";
const progressBar = "_progressBar_z545v_212";
const footer = "_footer_z545v_226";
const cta = "_cta_z545v_242";
const hideOnMobile = "_hideOnMobile_z545v_247";
const wizardBanner = "_wizardBanner_z545v_252";
const styles = {
  wizardLayoutContainer,
  desktopContent,
  primaryContent,
  primaryContentInner,
  typography,
  children,
  topNav,
  topNavButtonContainer,
  topNavButton,
  progressBar,
  footer,
  cta,
  hideOnMobile,
  wizardBanner
};
function WizardLayout(props) {
  const {
    banner,
    progress,
    heading,
    subheading,
    renderContent,
    renderFooter,
    renderDesktopVisual,
    desktopVisualBackgroundColor,
    onBack,
    onNext,
    onSkip,
    onCloseBanner,
    defaultFooterButtonProps,
    isNextDisabled,
    renderTopHeader,
    skipLabel,
    isUploading = false,
    progressBarColor
  } = props;
  const wizardFooterButton = !(defaultFooterButtonProps == null ? void 0 : defaultFooterButtonProps.hideNextButton) && /* @__PURE__ */ jsx(
    Button,
    {
      disabled: isNextDisabled || isUploading,
      className: styles.cta,
      onClick: onNext,
      appearance: "neutral",
      size: "large",
      mode: "filled",
      isLoading: isUploading,
      icon: (defaultFooterButtonProps == null ? void 0 : defaultFooterButtonProps.iconName) && /* @__PURE__ */ jsx(Icon, { name: defaultFooterButtonProps.iconName, size: "medium", appearance: "inverse" }),
      children: (defaultFooterButtonProps == null ? void 0 : defaultFooterButtonProps.label) ?? "Next"
    }
  );
  return /* @__PURE__ */ jsxs("div", { className: styles.wizardLayoutContainer, children: [
    /* @__PURE__ */ jsx(
      "div",
      {
        className: styles.desktopContent,
        style: { backgroundColor: desktopVisualBackgroundColor },
        children: renderDesktopVisual == null ? void 0 : renderDesktopVisual()
      }
    ),
    /* @__PURE__ */ jsxs("div", { className: styles.primaryContent, children: [
      banner && /* @__PURE__ */ jsx(
        Banner,
        {
          className: styles.wizardBanner,
          mode: "light",
          ...banner,
          onActionClick: onCloseBanner ?? banner.onActionClick
        }
      ),
      /* @__PURE__ */ jsx(
        WizardTopNav,
        {
          onBack,
          onSkip,
          progress,
          skipLabel,
          progressBarColor
        }
      ),
      /* @__PURE__ */ jsxs("div", { className: styles.primaryContentInner, children: [
        renderTopHeader && renderTopHeader(),
        (heading || subheading) && /* @__PURE__ */ jsxs("div", { className: clsx(styles.typography), children: [
          heading && /* @__PURE__ */ jsx(Headline, { size: "xl", children: heading }),
          subheading && /* @__PURE__ */ jsx(Body, { size: "lg", children: subheading })
        ] }),
        /* @__PURE__ */ jsx("div", { className: clsx(styles.children), children: renderContent() })
      ] }),
      /* @__PURE__ */ jsx("div", { className: styles.footer, children: renderFooter ? renderFooter() : /* @__PURE__ */ jsx(Fragment, { children: wizardFooterButton }) })
    ] })
  ] });
}
function WizardTopNav(props) {
  const { onBack, onSkip, progress, skipLabel, progressBarColor } = props;
  const fillColor = progressBarColor ?? `linear-gradient(
              90deg, ${designSystemToken("reference.purple.50")} 0%,
                ${designSystemToken("semantic.fg.brand")} 97%)`;
  return /* @__PURE__ */ jsxs("div", { className: styles.topNav, children: [
    /* @__PURE__ */ jsx("div", { className: styles.topNavButtonContainer, children: onBack && /* @__PURE__ */ jsx(
      Button,
      {
        onClick: onBack,
        appearance: "overlay",
        size: "medium",
        mode: "plain",
        className: styles.topNavButton,
        icon: /* @__PURE__ */ jsx(Icon, { name: "Actions-Arrow-Back-Large-Primary", size: "medium", appearance: "primary" })
      }
    ) }),
    progress !== null && /* @__PURE__ */ jsx(
      ProgressBar,
      {
        className: styles.progressBar,
        value: progress,
        size: "md",
        fillColor
      }
    ),
    /* @__PURE__ */ jsx("div", { className: clsx(styles.topNavButtonContainer, styles.hideOnMobile), children: onSkip && /* @__PURE__ */ jsx(
      Button,
      {
        onClick: onSkip,
        className: styles.topNavButton,
        appearance: "neutral",
        size: "medium",
        mode: "plain",
        children: skipLabel ?? "Skip"
      }
    ) })
  ] });
}
const mediaBreakPoints = {
  mobileUpperBound: 768,
  smallDesktopUpperBound: 1400
};
const themesMap = {
  popularpayLight: (designSystemToken2) => ({
    typography: {
      fontFamily: designSystemToken2("font.family.main"),
      h1: {
        fontSize: "64px",
        fontWeight: 500,
        lineHeight: "72px",
        letterSpacing: 0
      },
      h2: {
        fontSize: "56px",
        fontWeight: 500,
        lineHeight: "64px",
        letterSpacing: 0
      },
      h3: {
        fontSize: "48px",
        fontWeight: 500,
        lineHeight: "56px",
        letterSpacing: 0
      },
      h4: {
        fontSize: "32px",
        fontWeight: 500,
        lineHeight: "40px",
        letterSpacing: "-1px"
      },
      h5: {
        fontSize: "24px",
        fontWeight: 500,
        lineHeight: "32px",
        letterSpacing: "-0.75px"
      },
      h6: {
        fontSize: "20px",
        fontWeight: 500,
        lineHeight: "26px",
        letterSpacing: "-0.25px"
      },
      subtitle1: {
        fontSize: "16px",
        fontWeight: 400,
        lineHeight: "20px",
        letterSpacing: "-0.25px"
      },
      subtitle2: {
        fontSize: "14px",
        fontWeight: 500,
        lineHeight: "18px",
        letterSpacing: "-0.25px"
      },
      body1: {
        fontSize: "16px",
        fontWeight: 400,
        lineHeight: "20px",
        letterSpacing: "-0.05px"
      },
      body2: {
        fontSize: "14px",
        fontWeight: 400,
        lineHeight: "18px",
        letterSpacing: "-0.25px"
      },
      caption: {
        fontSize: "12px",
        fontWeight: 500,
        lineHeight: "16px",
        letterSpacing: 0
      },
      overline: {
        fontSize: "12px",
        fontWeight: 500,
        lineHeight: "16px",
        letterSpacing: 0
      }
    },
    palette: {
      mode: "light",
      primary: {
        main: designSystemToken2("semantic.bg.neutral")
      },
      secondary: {
        main: designSystemToken2("semantic.bg.brand"),
        contrastText: "rgba(255,255,255,0.87)",
        dark: designSystemToken2("semantic.bg.brand-secondary"),
        light: designSystemToken2("reference.green.mint.10")
      },
      background: {
        default: designSystemToken2("semantic.bg.primary")
      },
      text: {
        primary: designSystemToken2("semantic.bg.inverse"),
        secondary: "rgba(22,23,25,0.6)",
        disabled: "rgba(22,23,25,0.38)",
        hint: designSystemToken2("semantic.bg.inverse")
      },
      info: {
        main: designSystemToken2("reference.purple.50")
      },
      warning: {
        main: designSystemToken2("semantic.bg.warning")
      },
      error: {
        main: designSystemToken2("semantic.bg.danger")
      },
      success: {
        main: designSystemToken2("semantic.fg.brand")
      },
      divider: designSystemToken2("semantic.bg.neutral-secondary")
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            borderRadius: 9999999
          }
        }
      }
    }
  }),
  videoleapDark: () => ({}),
  videoleapLight: () => ({})
};
const muiTheme = ({ theme }) => createTheme({
  typography: {
    fontFamily: designSystemToken("font.family.main")
  },
  breakpoints: {
    values: {
      mobile: mediaBreakPoints.mobileUpperBound,
      smallDesktop: mediaBreakPoints.smallDesktopUpperBound
    }
  },
  ...themesMap[theme](designSystemToken)
});
function DesignSystemThemeProvider({ children: children2, theme }) {
  const [tokensInitialized, setTokensInitialized] = useState(ThemeTokens$1.getTokensInitialized());
  useEffect(() => {
    theme && ThemeTokens$1.setTheme(theme);
    setTokensInitialized(ThemeTokens$1.getTokensInitialized());
  }, [theme]);
  if (!tokensInitialized) {
    return null;
  }
  return /* @__PURE__ */ jsx(ThemeProvider, { theme: muiTheme({ theme }), children: /* @__PURE__ */ jsx(StyledEngineProvider, { injectFirst: true, children: children2 }) });
}
try {
  require("./style.css");
} catch (e) {
}
export {
  Avatar,
  Banner,
  Body,
  Button,
  Checkbox,
  DesignSystemThemeProvider,
  Display,
  Headline,
  Icon,
  index as Icons,
  Input,
  Label,
  Modal,
  ProgressBar,
  SocialNetworkIcon,
  SwitchButton,
  Tabs,
  Tag,
  Textarea,
  Tooltip,
  WizardLayout,
  cssVariablesTagId,
  designSystemComposition,
  designSystemToken,
  injectDesignSystemVariables,
  mediaBreakPoints as mediaBreakpoints,
  muiTheme as muiConfig
};
